[
  {
    "codigo": "01012100",
    "descricao": "-- Reprodutores de raça pura"
  },
  {
    "codigo": "01012900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "01013000",
    "descricao": "- Asininos"
  },
  {
    "codigo": "01019000",
    "descricao": "- Outros"
  },
  {
    "codigo": "01022110",
    "descricao": "Prenhes ou com cria ao pé"
  },
  {
    "codigo": "01022190",
    "descricao": "Outros"
  },
  {
    "codigo": "01022911",
    "descricao": "Prenhes ou com cria ao pé"
  },
  {
    "codigo": "01022919",
    "descricao": "Outros"
  },
  {
    "codigo": "01022990",
    "descricao": "Outros"
  },
  {
    "codigo": "01023110",
    "descricao": "Prenhes ou com cria ao pé"
  },
  {
    "codigo": "01023190",
    "descricao": "Outros"
  },
  {
    "codigo": "01023911",
    "descricao": "Prenhes ou com cria ao pé"
  },
  {
    "codigo": "01023919",
    "descricao": "Outros"
  },
  {
    "codigo": "01023990",
    "descricao": "Outros"
  },
  {
    "codigo": "01029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "01031000",
    "descricao": "- Reprodutores de raça pura"
  },
  {
    "codigo": "01039100",
    "descricao": "-- De peso inferior a 50 kg"
  },
  {
    "codigo": "01039200",
    "descricao": "-- De peso igual ou superior a 50 kg"
  },
  {
    "codigo": "01041011",
    "descricao": "Prenhes ou com cria ao pé"
  },
  {
    "codigo": "01041019",
    "descricao": "Outros"
  },
  {
    "codigo": "01041090",
    "descricao": "Outros"
  },
  {
    "codigo": "01042010",
    "descricao": "Reprodutores de raça pura"
  },
  {
    "codigo": "01042090",
    "descricao": "Outros"
  },
  {
    "codigo": "01051110",
    "descricao": "De linhas puras ou híbridas, para reprodução"
  },
  {
    "codigo": "01051190",
    "descricao": "Outros"
  },
  {
    "codigo": "01051200",
    "descricao": "-- Peruas e perus"
  },
  {
    "codigo": "01051300",
    "descricao": "-- Patos"
  },
  {
    "codigo": "01051400",
    "descricao": "-- Gansos"
  },
  {
    "codigo": "01051500",
    "descricao": "-- Galinhas-d'angola (pintadas)"
  },
  {
    "codigo": "01059400",
    "descricao": "-- Aves da espécie <i>Gallus domesticus</i>"
  },
  {
    "codigo": "01059900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "01061100",
    "descricao": "-- Primatas"
  },
  {
    "codigo": "01061200",
    "descricao": "-- Baleias, golfinhos e botos (mamíferos da ordem Cetacea); peixes-boi (manatins) e dugongos (mamíferos da ordem Sirenia); otárias e focas, leões-marinhos e morsas (mamíferos da subordem Pinnipedia)"
  },
  {
    "codigo": "01061300",
    "descricao": "-- Camelos e outros camelídeos (<i>Camelidae</i>)"
  },
  {
    "codigo": "01061400",
    "descricao": "-- Coelhos e lebres"
  },
  {
    "codigo": "01061900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "01062000",
    "descricao": "- Répteis (incluindo as serpentes e as tartarugas marinhas)"
  },
  {
    "codigo": "01063100",
    "descricao": "-- Aves de rapina"
  },
  {
    "codigo": "01063200",
    "descricao": "-- Psitaciformes (incluindo os papagaios, os periquitos, as araras e as catatuas)"
  },
  {
    "codigo": "01063310",
    "descricao": "Avestruzes (<i>Struthio camelus</i>), para reprodução"
  },
  {
    "codigo": "01063390",
    "descricao": "Outros"
  },
  {
    "codigo": "01063900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "01064100",
    "descricao": "-- Abelhas"
  },
  {
    "codigo": "01064900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "01069000",
    "descricao": "- Outros"
  },
  {
    "codigo": "02011000",
    "descricao": "- Carcaças e meias-carcaças"
  },
  {
    "codigo": "02012010",
    "descricao": "Quartos dianteiros"
  },
  {
    "codigo": "02012020",
    "descricao": "Quartos traseiros"
  },
  {
    "codigo": "02012090",
    "descricao": "Outras"
  },
  {
    "codigo": "02013000",
    "descricao": "- Desossadas"
  },
  {
    "codigo": "02021000",
    "descricao": "- Carcaças e meias-carcaças"
  },
  {
    "codigo": "02022010",
    "descricao": "Quartos dianteiros"
  },
  {
    "codigo": "02022020",
    "descricao": "Quartos traseiros"
  },
  {
    "codigo": "02022090",
    "descricao": "Outras"
  },
  {
    "codigo": "02023000",
    "descricao": "- Desossadas"
  },
  {
    "codigo": "02031100",
    "descricao": "-- Carcaças e meias-carcaças"
  },
  {
    "codigo": "02031200",
    "descricao": "-- Pernas, pás e respectivos pedaços, não desossados"
  },
  {
    "codigo": "02031900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "02032100",
    "descricao": "-- Carcaças e meias-carcaças"
  },
  {
    "codigo": "02032200",
    "descricao": "-- Pernas, pás e respectivos pedaços, não desossados"
  },
  {
    "codigo": "02032900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "02041000",
    "descricao": "- Carcaças e meias-carcaças de cordeiro, frescas ou refrigeradas"
  },
  {
    "codigo": "02042100",
    "descricao": "-- Carcaças e meias-carcaças"
  },
  {
    "codigo": "02042200",
    "descricao": "-- Outras peças não desossadas"
  },
  {
    "codigo": "02042300",
    "descricao": "-- Desossadas"
  },
  {
    "codigo": "02043000",
    "descricao": "- Carcaças e meias-carcaças de cordeiro, congeladas"
  },
  {
    "codigo": "02044100",
    "descricao": "-- Carcaças e meias-carcaças"
  },
  {
    "codigo": "02044200",
    "descricao": "-- Outras peças não desossadas"
  },
  {
    "codigo": "02044300",
    "descricao": "-- Desossadas"
  },
  {
    "codigo": "02045000",
    "descricao": "- Carnes de animais da espécie caprina"
  },
  {
    "codigo": "02050000",
    "descricao": "Carnes de animais das espécies cavalar, asinina e muar, frescas, refrigeradas ou congeladas."
  },
  {
    "codigo": "02061000",
    "descricao": "- Da espécie bovina, frescas ou refrigeradas"
  },
  {
    "codigo": "02062100",
    "descricao": "-- Línguas"
  },
  {
    "codigo": "02062200",
    "descricao": "-- Fígados"
  },
  {
    "codigo": "02062910",
    "descricao": "Rabos"
  },
  {
    "codigo": "02062990",
    "descricao": "Outros"
  },
  {
    "codigo": "02063000",
    "descricao": "- Da espécie suína, frescas ou refrigeradas"
  },
  {
    "codigo": "02064100",
    "descricao": "-- Fígados"
  },
  {
    "codigo": "02064900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "02068000",
    "descricao": "- Outras, frescas ou refrigeradas"
  },
  {
    "codigo": "02069000",
    "descricao": "- Outras, congeladas"
  },
  {
    "codigo": "02071100",
    "descricao": "-- Não cortadas em pedaços, frescas ou refrigeradas"
  },
  {
    "codigo": "02071210",
    "descricao": "Com miudezas"
  },
  {
    "codigo": "02071220",
    "descricao": "Sem miudezas"
  },
  {
    "codigo": "02071300",
    "descricao": "-- Pedaços e miudezas, frescos ou refrigerados"
  },
  {
    "codigo": "02071411",
    "descricao": "Peitos"
  },
  {
    "codigo": "02071412",
    "descricao": "Coxas com sobrecoxas"
  },
  {
    "codigo": "02071413",
    "descricao": "Asas"
  },
  {
    "codigo": "02071419",
    "descricao": "Outros"
  },
  {
    "codigo": "02071421",
    "descricao": "Peitos, coxas e sobrecoxas, formando uma só peça"
  },
  {
    "codigo": "02071422",
    "descricao": "Peitos"
  },
  {
    "codigo": "02071423",
    "descricao": "Coxas com sobrecoxas"
  },
  {
    "codigo": "02071424",
    "descricao": "Carne mecanicamente separada"
  },
  {
    "codigo": "02071429",
    "descricao": "Outros"
  },
  {
    "codigo": "02071431",
    "descricao": "Fígados"
  },
  {
    "codigo": "02071432",
    "descricao": "Moelas"
  },
  {
    "codigo": "02071433",
    "descricao": "Corações"
  },
  {
    "codigo": "02071434",
    "descricao": "Pés e patas"
  },
  {
    "codigo": "02071439",
    "descricao": "Outras"
  },
  {
    "codigo": "02072400",
    "descricao": "-- Não cortadas em pedaços, frescas ou refrigeradas"
  },
  {
    "codigo": "02072500",
    "descricao": "-- Não cortadas em pedaços, congeladas"
  },
  {
    "codigo": "02072600",
    "descricao": "-- Pedaços e miudezas, frescos ou refrigerados"
  },
  {
    "codigo": "02072700",
    "descricao": "-- Pedaços e miudezas, congelados"
  },
  {
    "codigo": "02074100",
    "descricao": "-- Não cortadas em pedaços, frescas ou refrigeradas"
  },
  {
    "codigo": "02074200",
    "descricao": "-- Não cortadas em pedaços, congeladas"
  },
  {
    "codigo": "02074300",
    "descricao": "-- Fígados gordos (<i>foies gras</i>), frescos ou refrigerados"
  },
  {
    "codigo": "02074400",
    "descricao": "-- Outras, frescas ou refrigeradas"
  },
  {
    "codigo": "02074500",
    "descricao": "-- Outras, congeladas"
  },
  {
    "codigo": "02075100",
    "descricao": "-- Não cortadas em pedaços, frescas ou refrigeradas"
  },
  {
    "codigo": "02075200",
    "descricao": "-- Não cortadas em pedaços, congeladas"
  },
  {
    "codigo": "02075300",
    "descricao": "-- Fígados gordos (<i>foies gras</i>), frescos ou refrigerados"
  },
  {
    "codigo": "02075400",
    "descricao": "-- Outras, frescas ou refrigeradas"
  },
  {
    "codigo": "02075500",
    "descricao": "-- Outras, congeladas"
  },
  {
    "codigo": "02076000",
    "descricao": "- De galinhas-d'angola (pintadas)"
  },
  {
    "codigo": "02081000",
    "descricao": "- De coelhos ou lebres"
  },
  {
    "codigo": "02083000",
    "descricao": "- De primatas"
  },
  {
    "codigo": "02084000",
    "descricao": "- De baleias, golfinhos e botos (mamíferos da ordem Cetacea); de peixes-boi (manatins) e dugongos (mamíferos da ordem Sirenia); de otárias e focas, leões-marinhos e morsas (mamíferos da subordem Pinnipedia)"
  },
  {
    "codigo": "02085000",
    "descricao": "- De répteis (incluindo as serpentes e as tartarugas marinhas)"
  },
  {
    "codigo": "02086000",
    "descricao": "- De camelos e outros camelídeos (<i>Camelidae</i>)"
  },
  {
    "codigo": "02089000",
    "descricao": "- Outras"
  },
  {
    "codigo": "02091011",
    "descricao": "Fresco, refrigerado ou congelado"
  },
  {
    "codigo": "02091019",
    "descricao": "Outros"
  },
  {
    "codigo": "02091021",
    "descricao": "Fresca, refrigerada ou congelada"
  },
  {
    "codigo": "02091029",
    "descricao": "Outras"
  },
  {
    "codigo": "02099000",
    "descricao": "- Outros"
  },
  {
    "codigo": "02101100",
    "descricao": "-- Pernas, pás e respectivos pedaços, não desossados"
  },
  {
    "codigo": "02101200",
    "descricao": "-- Toucinhos entremeados (Barrigas (entremeadas)*) e seus pedaços"
  },
  {
    "codigo": "02101900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "02102000",
    "descricao": "- Carnes da espécie bovina"
  },
  {
    "codigo": "02109100",
    "descricao": "-- De primatas"
  },
  {
    "codigo": "02109200",
    "descricao": "-- De baleias, golfinhos e botos (mamíferos da ordem Cetacea); de peixes-boi (manatins) e dugongos (mamíferos da ordem Sirenia); de otárias e focas, leões-marinhos e morsas (mamíferos da subordem Pinnipedia)"
  },
  {
    "codigo": "02109300",
    "descricao": "-- De répteis (incluindo as serpentes e as tartarugas marinhas)"
  },
  {
    "codigo": "02109911",
    "descricao": "De galos e de galinhas"
  },
  {
    "codigo": "02109919",
    "descricao": "Outras"
  },
  {
    "codigo": "02109920",
    "descricao": "Carnes da espécie ovina"
  },
  {
    "codigo": "02109930",
    "descricao": "Carnes da espécie cavalar"
  },
  {
    "codigo": "02109940",
    "descricao": "Miudezas comestíveis"
  },
  {
    "codigo": "02109990",
    "descricao": "Outras"
  },
  {
    "codigo": "03011110",
    "descricao": "Aruanã (<i>Osteoglossum bicirrhosum</i>)"
  },
  {
    "codigo": "03011190",
    "descricao": "Outros"
  },
  {
    "codigo": "03011900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03019110",
    "descricao": "Para reprodução"
  },
  {
    "codigo": "03019190",
    "descricao": "Outras"
  },
  {
    "codigo": "03019210",
    "descricao": "Para reprodução"
  },
  {
    "codigo": "03019290",
    "descricao": "Outras"
  },
  {
    "codigo": "03019310",
    "descricao": "Para reprodução"
  },
  {
    "codigo": "03019390",
    "descricao": "Outras"
  },
  {
    "codigo": "03019410",
    "descricao": "Para reprodução"
  },
  {
    "codigo": "03019490",
    "descricao": "Outras"
  },
  {
    "codigo": "03019510",
    "descricao": "Para reprodução"
  },
  {
    "codigo": "03019590",
    "descricao": "Outros"
  },
  {
    "codigo": "03019911",
    "descricao": "Tilápias (<i>Tilapia</i> spp.<i>, Oreochromis</i> spp.<i>, Sarotherodon</i> spp.<i>, Danakilia</i> spp.; seus híbridos)"
  },
  {
    "codigo": "03019912",
    "descricao": "Esturjões (<i>Acipenser baerii, Acipenser gueldenstaedtii, Acipenser persicus, Acipenser stellatus</i>)"
  },
  {
    "codigo": "03019919",
    "descricao": "Outros"
  },
  {
    "codigo": "03019991",
    "descricao": "Tilápias (<i>Tilapia</i> spp.<i>, Oreochromis</i> spp.<i>, Sarotherodon</i> spp.<i>, Danakilia</i> spp.; seus híbridos)"
  },
  {
    "codigo": "03019992",
    "descricao": "Esturjões (<i>Acipenser baerii, Acipenser gueldenstaedtii, Acipenser persicus, Acipenser stellatus</i>)"
  },
  {
    "codigo": "03019999",
    "descricao": "Outros"
  },
  {
    "codigo": "03021100",
    "descricao": "-- Trutas (<i>Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache</i> e <i>Oncorhynchus chrysogaster</i>)"
  },
  {
    "codigo": "03021300",
    "descricao": "-- Salmões-do-pacífico (<i>Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou</i> e <i>Oncorhynchus rhodurus</i>)"
  },
  {
    "codigo": "03021400",
    "descricao": "-- Salmão-do-atlântico (<i>Salmo salar</i>) e salmão-do-danúbio (<i>Hucho hucho</i>)"
  },
  {
    "codigo": "03021900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03022100",
    "descricao": "-- Linguados-gigantes (Alabotes*) (<i>Reinhardtius hippoglossoides, Hippoglossus hippoglossus, Hippoglossus stenolepis</i>)"
  },
  {
    "codigo": "03022200",
    "descricao": "-- Solha (<i>Pleuronectes platessa</i>)"
  },
  {
    "codigo": "03022300",
    "descricao": "-- Linguados (<i>Solea</i> spp.)"
  },
  {
    "codigo": "03022400",
    "descricao": "-- Pregado (<i>Psetta maxima</i>)"
  },
  {
    "codigo": "03022900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03023100",
    "descricao": "-- Albacora-branca (atum) (<i>Thunnus alalunga</i>)"
  },
  {
    "codigo": "03023200",
    "descricao": "-- Albacora-laje (atum) (<i>Thunnus albacares</i>)"
  },
  {
    "codigo": "03023300",
    "descricao": "-- Bonito-listrado (Gaiado*) (<i>Katsuwonus pelamis</i>)"
  },
  {
    "codigo": "03023400",
    "descricao": "-- Albacora-bandolim (atum) (<i>Thunnus obesus</i>)"
  },
  {
    "codigo": "03023500",
    "descricao": "-- Atuns-azuis (atuns) (<i>Thunnus thynnus, Thunnus orientalis</i>)"
  },
  {
    "codigo": "03023600",
    "descricao": "-- Atum-azul do sul (atum) (<i>Thunnus maccoyii</i>)"
  },
  {
    "codigo": "03023900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03024100",
    "descricao": "-- Arenques (<i>Clupea harengus, Clupea pallasii</i>)"
  },
  {
    "codigo": "03024210",
    "descricao": "Anchoita (<i>Engraulis anchoita</i>)"
  },
  {
    "codigo": "03024290",
    "descricao": "Outros"
  },
  {
    "codigo": "03024300",
    "descricao": "-- Sardinhas (<i>Sardina pilchardus, Sardinops</i> spp., <i>Sardinella</i> spp.) (Sardinha (<i>Sardina pilchardus</i>) e sardinelas (<i>Sardinops</i> spp., <i>Sardinella</i> spp.)*), anchoveta (espadilha*) (<i>Sprattus sprattus</i>)"
  },
  {
    "codigo": "03024400",
    "descricao": "-- Cavalinhas (Sardas e cavalas*) (<i>Scomber scombrus, Scomber australasicus, Scomber japonicus</i>)"
  },
  {
    "codigo": "03024500",
    "descricao": "-- Carapaus (<i>Trachurus</i> spp.)"
  },
  {
    "codigo": "03024600",
    "descricao": "-- Bijupirá (Cobia*) (<i>Rachycentron canadum</i>)"
  },
  {
    "codigo": "03024700",
    "descricao": "-- Espadarte (<i>Xiphias gladius</i>)"
  },
  {
    "codigo": "03024910",
    "descricao": "Espadins, marlins, veleiros (<i>Istiophoridae</i>)"
  },
  {
    "codigo": "03024990",
    "descricao": "Outros"
  },
  {
    "codigo": "03025100",
    "descricao": "-- Bacalhau-do-atlântico (<i>Gadus morhua</i>), bacalhau-da-groelândia (<i>Gadus ogac</i>) e bacalhau-do-pacífico (<i>Gadus macrocephalus</i>)"
  },
  {
    "codigo": "03025200",
    "descricao": "-- Hadoque (Arinca*) (<i>Melanogrammus aeglefinus</i>)"
  },
  {
    "codigo": "03025300",
    "descricao": "-- Saithe (Escamudo*) (<i>Pollachius virens</i>)"
  },
  {
    "codigo": "03025400",
    "descricao": "-- Merluzas (Pescadas*) e abróteas (<i>Merluccius</i> spp.<i>, Urophycis</i> spp.)"
  },
  {
    "codigo": "03025500",
    "descricao": "-- Polaca-do-alasca (Escamudo-do-alasca*) (<i>Theragra chalcogramma</i>)"
  },
  {
    "codigo": "03025600",
    "descricao": "-- Verdinhos (<i>Micromesistius poutassou, Micromesistius australis</i>)"
  },
  {
    "codigo": "03025900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03027100",
    "descricao": "-- Tilápias (<i>Oreochromis</i> spp.)"
  },
  {
    "codigo": "03027210",
    "descricao": "Bagre americano (<i>Ictalurus punctatus</i>)"
  },
  {
    "codigo": "03027290",
    "descricao": "Outros"
  },
  {
    "codigo": "03027300",
    "descricao": "-- Carpas (<i>Cyprinus</i> spp.<i>, Carassius</i> spp.<i>, Ctenopharyngodon idellus, Hypophthalmichthys</i> spp.<i>, Cirrhinus</i> spp.<i>, Mylopharyngodon piceus, Catla catla, Labeo</i> spp.<i>, Osteochilus hasselti, Leptobarbus hoeveni, Megalobrama</i> spp.)"
  },
  {
    "codigo": "03027400",
    "descricao": "-- Enguias (<i>Anguilla</i> spp.)"
  },
  {
    "codigo": "03027900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03028100",
    "descricao": "-- Cação e outros tubarões"
  },
  {
    "codigo": "03028200",
    "descricao": "-- Raias (<i>Rajidae</i>)"
  },
  {
    "codigo": "03028310",
    "descricao": "Merluza negra (<i>Dissostichus eleginoides</i>)"
  },
  {
    "codigo": "03028320",
    "descricao": "Merluza antártica (<i>Dissostichus mawsoni</i>)"
  },
  {
    "codigo": "03028400",
    "descricao": "-- Robalos (<i>Dicentrarchus</i> spp.)"
  },
  {
    "codigo": "03028500",
    "descricao": "-- Esparídeos (<i>Sparidae</i>)"
  },
  {
    "codigo": "03028910",
    "descricao": "Pargo (<i>Lutjanus purpureus</i>)"
  },
  {
    "codigo": "03028921",
    "descricao": "Cherne-poveiro (<i>Polyprion americanus</i>)"
  },
  {
    "codigo": "03028922",
    "descricao": "Garoupas (<i>Acanthistius</i> spp.)"
  },
  {
    "codigo": "03028923",
    "descricao": "Esturjão (<i>Acipenser baerii</i>)"
  },
  {
    "codigo": "03028924",
    "descricao": "Peixes-rei (<i>Atherina</i> spp.)"
  },
  {
    "codigo": "03028931",
    "descricao": "Curimatãs (<i>Prochilodus</i> spp.)"
  },
  {
    "codigo": "03028932",
    "descricao": "Tilápias (<i>Tilapia</i> spp.<i>, Sarotherodon</i> spp.<i>, Danakilia</i> spp.; seus híbridos)"
  },
  {
    "codigo": "03028933",
    "descricao": "Surubins (<i>Pseudoplatystoma</i> spp.)"
  },
  {
    "codigo": "03028934",
    "descricao": "Traíra (<i>Hoplias malabaricus & H. cf. lacerdae</i>)"
  },
  {
    "codigo": "03028935",
    "descricao": "Piaus (<i>Leporinus</i> spp.)"
  },
  {
    "codigo": "03028936",
    "descricao": "Tainhas (<i>Mugil</i> spp.)"
  },
  {
    "codigo": "03028937",
    "descricao": "Pirarucu (<i>Arapaima gigas</i>)"
  },
  {
    "codigo": "03028938",
    "descricao": "Pescadas (<i>Cynoscion</i> spp.)"
  },
  {
    "codigo": "03028941",
    "descricao": "Piramutaba (<i>Brachyplatystoma vaillantii</i>)"
  },
  {
    "codigo": "03028942",
    "descricao": "Dourada (<i>Brachyplatystoma flavicans</i>)"
  },
  {
    "codigo": "03028943",
    "descricao": "Pacu (<i>Piaractus mesopotamicus</i>)"
  },
  {
    "codigo": "03028944",
    "descricao": "Tambaqui (<i>Colossoma macropomum</i>)"
  },
  {
    "codigo": "03028945",
    "descricao": "Tambacu (híbrido de tambaqui e pacu)"
  },
  {
    "codigo": "03028990",
    "descricao": "Outros"
  },
  {
    "codigo": "03029110",
    "descricao": "Ovas de tainhas (<i>Mugil</i> spp.)"
  },
  {
    "codigo": "03029190",
    "descricao": "Outros"
  },
  {
    "codigo": "03029200",
    "descricao": "-- Barbatanas de tubarão"
  },
  {
    "codigo": "03029900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03031100",
    "descricao": "-- Salmão-do-pacífico (salmão-vermelho) (<i>Oncorhynchus nerka</i>)"
  },
  {
    "codigo": "03031200",
    "descricao": "-- Outros salmões-do-pacífico (<i>Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou</i> e <i>Oncorhynchus rhodurus</i>)"
  },
  {
    "codigo": "03031300",
    "descricao": "-- Salmão-do-atlântico (<i>Salmo salar</i>) e salmão-do-danúbio (<i>Hucho hucho</i>)"
  },
  {
    "codigo": "03031400",
    "descricao": "-- Trutas (<i>Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache</i> e <i>Oncorhynchus chrysogaster</i>)"
  },
  {
    "codigo": "03031900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03032300",
    "descricao": "-- Tilápias (<i>Oreochromis</i> spp.)"
  },
  {
    "codigo": "03032410",
    "descricao": "Bagre americano (<i>Ictalurus punctatus</i>)"
  },
  {
    "codigo": "03032490",
    "descricao": "Outros"
  },
  {
    "codigo": "03032500",
    "descricao": "-- Carpas (<i>Cyprinus</i> spp.<i>, Carassius</i> spp.<i>, Ctenopharyngodon idellus, Hypophthalmichthys</i> spp.<i>, Cirrhinus</i> spp.<i>, Mylopharyngodon piceus, Catla catla, Labeo</i> spp.<i>, Osteochilus hasselti, Leptobarbus hoeveni, Megalobrama</i> spp.)"
  },
  {
    "codigo": "03032600",
    "descricao": "-- Enguias (<i>Anguilla</i> spp.)"
  },
  {
    "codigo": "03032900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03033100",
    "descricao": "-- Linguados-gigantes (Alabotes*) (<i>Reinhardtius hippoglossoides, Hippoglossus hippoglossus, Hippoglossus stenolepis</i>)"
  },
  {
    "codigo": "03033200",
    "descricao": "-- Solha (<i>Pleuronectes platessa</i>)"
  },
  {
    "codigo": "03033300",
    "descricao": "-- Linguados (<i>Solea</i> spp.)"
  },
  {
    "codigo": "03033400",
    "descricao": "-- Pregado (<i>Psetta maxima</i>)"
  },
  {
    "codigo": "03033900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03034100",
    "descricao": "-- Albacora-branca (atum) (<i>Thunnus alalunga</i>)"
  },
  {
    "codigo": "03034200",
    "descricao": "-- Albacora-laje (atum) (<i>Thunnus albacares</i>)"
  },
  {
    "codigo": "03034300",
    "descricao": "-- Bonito-listrado (Gaiado*) (<i>Katsuwonus pelamis</i>)"
  },
  {
    "codigo": "03034400",
    "descricao": "-- Albacora-bandolim (atum) (<i>Thunnus obesus</i>)"
  },
  {
    "codigo": "03034500",
    "descricao": "-- Atuns-azuis (atuns) (<i>Thunnus thynnus, Thunnus orientalis</i>)"
  },
  {
    "codigo": "03034600",
    "descricao": "-- Atum-azul do sul (atum) (<i>Thunnus maccoyii</i>)"
  },
  {
    "codigo": "03034900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03035100",
    "descricao": "-- Arenques (<i>Clupea harengus, Clupea pallasii</i>)"
  },
  {
    "codigo": "03035300",
    "descricao": "-- Sardinhas (<i>Sardina pilchardus, Sardinops</i> spp.<i>, Sardinella</i> spp.) (Sardinha (<i>Sardina pilchardus</i>) e sardinelas (<i>Sardinops</i> spp.,<i> </i><i>Sardinella</i> spp.)*), anchoveta (espadilha*) (<i>Sprattus sprattus</i>)"
  },
  {
    "codigo": "03035400",
    "descricao": "-- Cavalinhas (Sardas e cavalas*) (<i>Scomber scombrus, Scomber australasicus, Scomber japonicus</i>)"
  },
  {
    "codigo": "03035500",
    "descricao": "-- Carapaus (<i>Trachurus</i> spp.)"
  },
  {
    "codigo": "03035600",
    "descricao": "-- Bijupirá (Cobia*) (<i>Rachycentron canadum</i>)"
  },
  {
    "codigo": "03035700",
    "descricao": "-- Espadarte (<i>Xiphias gladius</i>)"
  },
  {
    "codigo": "03035910",
    "descricao": "Espadins, marlins, veleiros (<i>Istiophoridae</i>)"
  },
  {
    "codigo": "03035920",
    "descricao": "Anchoita (<i>Engraulis anchoita</i>)"
  },
  {
    "codigo": "03035990",
    "descricao": "Outros"
  },
  {
    "codigo": "03036300",
    "descricao": "-- Bacalhau-do-atlântico (<i>Gadus morhua</i>), bacalhau-da-groelândia (<i>Gadus ogac</i>) e bacalhau-do-pacífico (<i>Gadus macrocephalus</i>)"
  },
  {
    "codigo": "03036400",
    "descricao": "-- Hadoque (Arinca*) (<i>Melanogrammus aeglefinus</i>)"
  },
  {
    "codigo": "03036500",
    "descricao": "-- Saithe (Escamudo*) (<i>Pollachius virens</i>)"
  },
  {
    "codigo": "03036600",
    "descricao": "-- Merluzas (Pescadas*) e abróteas (<i>Merluccius</i> spp., <i>Urophycis</i> spp.)"
  },
  {
    "codigo": "03036700",
    "descricao": "-- Polaca-do-alasca (Escamudo-do-alasca*) (<i>Theragra chalcogramma</i>)"
  },
  {
    "codigo": "03036800",
    "descricao": "-- Verdinhos (<i>Micromesistius poutassou, Micromesistius australis</i>)"
  },
  {
    "codigo": "03036910",
    "descricao": "Merluza rosada (<i>Macruronus magellanicus</i>)"
  },
  {
    "codigo": "03036990",
    "descricao": "Outros"
  },
  {
    "codigo": "03038111",
    "descricao": "Inteiro"
  },
  {
    "codigo": "03038112",
    "descricao": "Eviscerado, sem cabeça e sem barbatanas"
  },
  {
    "codigo": "03038113",
    "descricao": "Em pedaços, com pele"
  },
  {
    "codigo": "03038114",
    "descricao": "Em pedaços, sem pele"
  },
  {
    "codigo": "03038119",
    "descricao": "Outros"
  },
  {
    "codigo": "03038190",
    "descricao": "Outros"
  },
  {
    "codigo": "03038200",
    "descricao": "-- Raias (<i>Rajidae</i>)"
  },
  {
    "codigo": "03038311",
    "descricao": "Evisceradas, sem cabeça e sem cauda"
  },
  {
    "codigo": "03038319",
    "descricao": "Outras"
  },
  {
    "codigo": "03038321",
    "descricao": "Evisceradas, sem cabeça e sem cauda"
  },
  {
    "codigo": "03038329",
    "descricao": "Outras"
  },
  {
    "codigo": "03038400",
    "descricao": "-- Robalos (<i>Dicentrarchus</i> spp.)"
  },
  {
    "codigo": "03038910",
    "descricao": "Corvina (<i>Micropogonias furnieri</i>)"
  },
  {
    "codigo": "03038920",
    "descricao": "Pescadas (<i>Cynoscion</i> spp.)"
  },
  {
    "codigo": "03038932",
    "descricao": "Pargo (<i>Lutjanus purpureus</i>)"
  },
  {
    "codigo": "03038933",
    "descricao": "Peixe-sapo (<i>Lophius gastrophysus</i>)"
  },
  {
    "codigo": "03038941",
    "descricao": "Cherne-poveiro (<i>Polyprion americanus</i>)"
  },
  {
    "codigo": "03038942",
    "descricao": "Garoupas (<i>Acanthistius</i> spp.)"
  },
  {
    "codigo": "03038943",
    "descricao": "Tainhas (<i>Mugil</i> spp.)"
  },
  {
    "codigo": "03038944",
    "descricao": "Esturjões (<i>Acipenser baerii, Acipenser gueldenstaedtii, Acipenser persicus, Acipenser stellatus</i>)"
  },
  {
    "codigo": "03038945",
    "descricao": "Peixes-rei (<i>Atherina</i> spp.)"
  },
  {
    "codigo": "03038946",
    "descricao": "Nototenias (<i>Patagonotothen</i> spp.)"
  },
  {
    "codigo": "03038951",
    "descricao": "Curimatãs (<i>Prochilodus</i> spp.)"
  },
  {
    "codigo": "03038952",
    "descricao": "Tilápias (<i>Tilapia</i> spp.<i>, Sarotherodon</i> spp.<i>, Danakilia</i> spp.; seus híbridos)"
  },
  {
    "codigo": "03038953",
    "descricao": "Surubins (<i>Pseudoplatystoma</i> spp.)"
  },
  {
    "codigo": "03038954",
    "descricao": "Traíra (<i>Hoplias malabaricus & H. cf. lacerdae</i>)"
  },
  {
    "codigo": "03038955",
    "descricao": "Piaus (<i>Leporinus</i> spp.)"
  },
  {
    "codigo": "03038956",
    "descricao": "Pirarucu (<i>Arapaima gigas</i>)"
  },
  {
    "codigo": "03038961",
    "descricao": "Piramutaba (<i>Brachyplatystoma vaillantii</i>)"
  },
  {
    "codigo": "03038962",
    "descricao": "Dourada (<i>Brachyplatystoma flavicans</i>)"
  },
  {
    "codigo": "03038963",
    "descricao": "Pacu (<i>Piaractus mesopotamicus</i>)"
  },
  {
    "codigo": "03038964",
    "descricao": "Tambaqui (<i>Colossoma macropomum</i>)"
  },
  {
    "codigo": "03038965",
    "descricao": "Tambacu (híbrido de tambaqui e pacu)"
  },
  {
    "codigo": "03038990",
    "descricao": "Outros"
  },
  {
    "codigo": "03039110",
    "descricao": "Ovas de tainhas (<i>Mugil</i> spp.)"
  },
  {
    "codigo": "03039190",
    "descricao": "Outros"
  },
  {
    "codigo": "03039200",
    "descricao": "-- Barbatanas de tubarão"
  },
  {
    "codigo": "03039910",
    "descricao": "Cabeças de Merluza negra (<i>Dissostichus eleginoides</i>)"
  },
  {
    "codigo": "03039920",
    "descricao": "Cabeças de Merluza antártica (<i>Dissostichus mawsoni</i>)"
  },
  {
    "codigo": "03039990",
    "descricao": "Outros"
  },
  {
    "codigo": "03043100",
    "descricao": "-- Tilápias (<i>Oreochromis</i> spp.)"
  },
  {
    "codigo": "03043210",
    "descricao": "Bagre americano (<i>Ictalurus punctatus</i>)"
  },
  {
    "codigo": "03043290",
    "descricao": "Outros"
  },
  {
    "codigo": "03043300",
    "descricao": "-- Perca-do-nilo (<i>Lates niloticus</i>)"
  },
  {
    "codigo": "03043900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03044100",
    "descricao": "-- Salmões-do-pacífico (<i>Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou</i> e <i>Oncorhynchus rhodurus</i>), salmão-do-atlântico (<i>Salmo salar</i>) e salmão-do-danúbio (<i>Hucho hucho</i>)"
  },
  {
    "codigo": "03044200",
    "descricao": "-- Trutas (<i>Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache</i> e <i>Oncorhynchus chrysogaster</i>)"
  },
  {
    "codigo": "03044300",
    "descricao": "-- Peixes chatos (<i>Pleuronectidae, Bothidae, Cynoglossidae, Soleidae, Scophthalmidae</i> e <i>Citharidae</i>)"
  },
  {
    "codigo": "03044400",
    "descricao": "-- Peixes das famílias <i>Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae</i> e <i>Muraenolepididae</i>"
  },
  {
    "codigo": "03044500",
    "descricao": "-- Espadarte (<i>Xiphias gladius</i>)"
  },
  {
    "codigo": "03044600",
    "descricao": "-- Merluza negra e merluza antártica (Marlongas*) (<i>Dissostichus</i> spp.)"
  },
  {
    "codigo": "03044700",
    "descricao": "-- Cação e outros tubarões"
  },
  {
    "codigo": "03044800",
    "descricao": "-- Raias (<i>Rajidae</i>)"
  },
  {
    "codigo": "03044910",
    "descricao": "Cherne-poveiro (<i>Polyprion americanus</i>)"
  },
  {
    "codigo": "03044920",
    "descricao": "Garoupas (<i>Acanthistius</i> spp.)"
  },
  {
    "codigo": "03044990",
    "descricao": "Outros"
  },
  {
    "codigo": "03045100",
    "descricao": "-- Tilápias (<i>Oreochromis</i> spp.), bagres (peixes-gato*) (<i>Pangasius</i> spp., <i>Silurus</i> spp., <i>Clarias</i> spp., <i>Ictalurus</i> spp.), carpas (<i>Cyprinus</i> spp., <i>Carassius</i> spp., <i>Ctenopharyngodon idellus</i>, <i>Hypophthalmichthys</i> spp., <i>Cirrhinus</i> spp., <i>Mylopharyngodon piceus</i>, <i>Catla catla</i>, <i>Labeo</i> spp., <i>Osteochilus hasselti</i>, <i>Leptobarbus hoeveni</i>, <i>Megalobrama</i> spp.), enguias (<i>Anguilla</i> spp.), perca-do-nilo (<i>Lates niloticus</i>) e peixes cabeça-de-serpente (<i>Channa</i> spp.)"
  },
  {
    "codigo": "03045200",
    "descricao": "-- Salmonídeos"
  },
  {
    "codigo": "03045300",
    "descricao": "-- Peixes das famílias <i>Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae</i> e <i>Muraenolepididae</i>"
  },
  {
    "codigo": "03045400",
    "descricao": "-- Espadarte (<i>Xiphias gladius</i>)"
  },
  {
    "codigo": "03045500",
    "descricao": "-- Merluza negra e merluza antártica (Marlongas*) (<i>Dissostichus</i> spp.)"
  },
  {
    "codigo": "03045600",
    "descricao": "-- Cação e outros tubarões"
  },
  {
    "codigo": "03045700",
    "descricao": "-- Raias (<i>Rajidae</i>)"
  },
  {
    "codigo": "03045900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03046100",
    "descricao": "-- Tilápias (<i>Oreochromis</i> spp.)"
  },
  {
    "codigo": "03046210",
    "descricao": "Bagre americano (<i>Ictalurus punctatus</i>)"
  },
  {
    "codigo": "03046290",
    "descricao": "Outros"
  },
  {
    "codigo": "03046300",
    "descricao": "-- Perca-do-nilo (<i>Lates niloticus</i>)"
  },
  {
    "codigo": "03046900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03047100",
    "descricao": "-- Bacalhau-do-atlântico (<i>Gadus morhua</i>), bacalhau-da-groelândia (<i>Gadus ogac</i>) e bacalhau-do-pacífico (<i>Gadus macrocephalus</i>)"
  },
  {
    "codigo": "03047200",
    "descricao": "-- Hadoque (Arinca*) (<i>Melanogrammus aeglefinus</i>)"
  },
  {
    "codigo": "03047300",
    "descricao": "-- Saithe (Escamudo*) (<i>Pollachius virens</i>)"
  },
  {
    "codigo": "03047400",
    "descricao": "-- Merluzas (Pescadas*) e abróteas (<i>Merluccius</i> spp.<i>, Urophycis</i> spp.)"
  },
  {
    "codigo": "03047500",
    "descricao": "-- Polaca-do-alasca (Escamudo-do-alasca*) (<i>Theragra chalcogramma</i>)"
  },
  {
    "codigo": "03047900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03048100",
    "descricao": "-- Salmões-do-pacífico (<i>Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou</i> e <i>Oncorhynchus rhodurus</i>), salmão-do-atlântico (<i>Salmo salar</i>) e salmão-do-danúbio (<i>Hucho hucho</i>)"
  },
  {
    "codigo": "03048200",
    "descricao": "-- Trutas (<i>Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache</i> e <i>Oncorhynchus chrysogaster</i>)"
  },
  {
    "codigo": "03048300",
    "descricao": "-- Peixes chatos (<i>Pleuronectidae, Bothidae, Cynoglossidae, Soleidae, Scophthalmidae</i> e <i>Citharidae</i>)"
  },
  {
    "codigo": "03048400",
    "descricao": "-- Espadarte (<i>Xiphias gladius</i>)"
  },
  {
    "codigo": "03048510",
    "descricao": "Merluza negra (<i>Dissostichus eleginoides</i>)"
  },
  {
    "codigo": "03048520",
    "descricao": "Merluza antártica (<i>Dissostichus mawsoni</i>)"
  },
  {
    "codigo": "03048600",
    "descricao": "-- Arenques (<i>Clupea harengus, Clupea pallasii</i>)"
  },
  {
    "codigo": "03048700",
    "descricao": "-- Atuns (do gênero <i>Thunnus</i>), bonito-listrado (gaiado*) (<i>Katsuwonus pelamis</i>)"
  },
  {
    "codigo": "03048810",
    "descricao": "Tubarão-azul (<i>Prionace glauca</i>)"
  },
  {
    "codigo": "03048890",
    "descricao": "Outros"
  },
  {
    "codigo": "03048910",
    "descricao": "Pargo (<i>Lutjanus purpureus</i>)"
  },
  {
    "codigo": "03048920",
    "descricao": "Cherne-poveiro (<i>Polyprion americanus</i>)"
  },
  {
    "codigo": "03048930",
    "descricao": "Garoupas (<i>Acanthistius</i> spp.)"
  },
  {
    "codigo": "03048990",
    "descricao": "Outros"
  },
  {
    "codigo": "03049100",
    "descricao": "-- Espadarte (<i>Xiphias gladius</i>)"
  },
  {
    "codigo": "03049211",
    "descricao": "Bochechas (<i>cheeks</i>)"
  },
  {
    "codigo": "03049212",
    "descricao": "Colares (<i>collars</i>)"
  },
  {
    "codigo": "03049219",
    "descricao": "Outros"
  },
  {
    "codigo": "03049221",
    "descricao": "Bochechas (<i>cheeks</i>)"
  },
  {
    "codigo": "03049222",
    "descricao": "Colares (<i>collars</i>)"
  },
  {
    "codigo": "03049229",
    "descricao": "Outros"
  },
  {
    "codigo": "03049300",
    "descricao": "-- Tilápias (<i>Oreochromis</i> spp.), bagres (peixes-gato*) (<i>Pangasius</i> spp.<i>, Silurus</i> spp.<i>, Clarias</i> spp.<i>, Ictalurus</i> spp.), carpas (<i>Cyprinus</i> spp.<i>, Carassius</i> spp.<i>, Ctenopharyngodon idellus, Hypophthalmichthys</i> spp.<i>, Cirrhinus</i> spp.<i>, Mylopharyngodon piceus, Catla catla, Labeo</i> spp.<i>, Osteochilus hasselti, Leptobarbus hoeveni, Megalobrama</i> spp.), enguias (<i>Anguilla</i> spp.), perca-do-nilo (<i>Lates niloticus</i>) e peixes cabeça-de-serpente (<i>Channa</i> spp.)"
  },
  {
    "codigo": "03049400",
    "descricao": "-- Polaca-do-alasca (Escamudo-do-alasca*) (<i>Theragra chalcogramma</i>)"
  },
  {
    "codigo": "03049500",
    "descricao": "-- Peixes das famílias <i>Bregmacerotidae, Euclichthyidae, Gadidae, Macrouridae, Melanonidae, Merlucciidae, Moridae</i> e <i>Muraenolepididae</i>, exceto a polaca-do-alasca (escamudo-do-alasca*) (<i>Theragra chalcogramma</i>)"
  },
  {
    "codigo": "03049600",
    "descricao": "-- Cação e outros tubarões"
  },
  {
    "codigo": "03049700",
    "descricao": "-- Raias (<i>Rajidae</i>)"
  },
  {
    "codigo": "03049900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03052010",
    "descricao": "Ovas de tainhas (<i>Mugil</i> spp.)"
  },
  {
    "codigo": "03052090",
    "descricao": "Outros"
  },
  {
    "codigo": "03053100",
    "descricao": "-- Tilápias (<i>Oreochromis</i> spp.), bagres (peixes-gato*) (<i>Pangasius</i> spp.<i>, Silurus</i> spp.<i>, Clarias</i> spp.<i>, Ictalurus</i> spp.), carpas (<i>Cyprinus</i> spp.<i>, Carassius</i> spp.<i>, Ctenopharyngodon idellus, Hypophthalmichthys</i> spp.<i>, Cirrhinus</i> spp.<i>, Mylopharyngodon piceus, Catla catla, Labeo</i> spp.<i>, Osteochilus hasselti, Leptobarbus hoeveni, Megalobrama</i> spp.), enguias (<i>Anguilla</i> spp.), perca-do-nilo (<i>Lates niloticus</i>) e peixes cabeça-de-serpente (<i>Channa</i> spp.)"
  },
  {
    "codigo": "03053210",
    "descricao": "Bacalhau-do-atlântico (<i>Gadus morhua</i>), bacalhau-da-groelândia (<i>Gadus ogac</i>) e bacalhau-do-pacífico (<i>Gadus macrocephalus</i>)"
  },
  {
    "codigo": "03053220",
    "descricao": "Saithe (<i>Pollachius virens</i>)"
  },
  {
    "codigo": "03053230",
    "descricao": "Ling (<i>Molva molva</i>) e zarbo (<i>Brosme brosme</i>)"
  },
  {
    "codigo": "03053290",
    "descricao": "Outros"
  },
  {
    "codigo": "03053900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03054100",
    "descricao": "-- Salmões-do-pacífico (<i>Oncorhynchus nerka, Oncorhynchus gorbuscha, Oncorhynchus keta, Oncorhynchus tschawytscha, Oncorhynchus kisutch, Oncorhynchus masou</i> e <i>Oncorhynchus rhodurus</i>), salmão-do-atlântico (<i>Salmo salar</i>) e salmão-do-danúbio (<i>Hucho hucho</i>)"
  },
  {
    "codigo": "03054200",
    "descricao": "-- Arenques (<i>Clupea harengus, Clupea pallasii</i>)"
  },
  {
    "codigo": "03054300",
    "descricao": "-- Trutas (<i>Salmo trutta, Oncorhynchus mykiss, Oncorhynchus clarki, Oncorhynchus aguabonita, Oncorhynchus gilae, Oncorhynchus apache</i> e <i>Oncorhynchus chrysogaster</i>)"
  },
  {
    "codigo": "03054400",
    "descricao": "-- Tilápias (<i>Oreochromis</i> spp.), bagres (peixes-gato*) (<i>Pangasius</i> spp.<i>, Silurus</i> spp.<i>, Clarias</i> spp.<i>, Ictalurus</i> spp.), carpas (<i>Cyprinus</i> spp.<i>, Carassius</i> spp.<i>, Ctenopharyngodon idellus, Hypophthalmichthys</i> spp.<i>, Cirrhinus</i> spp.<i>, Mylopharyngodon piceus, Catla catla, Labeo</i> spp.<i>, Osteochilus hasselti, Leptobarbus hoeveni, Megalobrama</i> spp.), enguias (<i>Anguilla</i> spp.), perca-do-nilo (<i>Lates niloticus</i>) e peixes cabeça-de-serpente (<i>Channa</i> spp.)"
  },
  {
    "codigo": "03054910",
    "descricao": "Bacalhau-do-atlântico (<i>Gadus morhua</i>), bacalhau-da-groelândia (<i>Gadus ogac</i>) e bacalhau-do-pacífico (<i>Gadus macrocephalus</i>)"
  },
  {
    "codigo": "03054920",
    "descricao": "Saithe (<i>Pollachius virens</i>), ling (<i>Molva molva</i>) e zarbo (<i>Brosme brosme</i>)"
  },
  {
    "codigo": "03054990",
    "descricao": "Outros"
  },
  {
    "codigo": "03055100",
    "descricao": "-- Bacalhau-do-atlântico (<i>Gadus morhua</i>), bacalhau-da-groelândia (<i>Gadus ogac</i>) e bacalhau-do-pacífico (<i>Gadus macrocephalus</i>)"
  },
  {
    "codigo": "03055200",
    "descricao": "-- Tilápias (<i>Oreochromis</i> spp.), bagres (peixes-gato*) (<i>Pangasius</i> spp.<i>, Silurus</i> spp.<i>, Clarias</i> spp.<i>, Ictalurus</i> spp.), carpas (<i>Cyprinus</i> spp.<i>, Carassius</i> spp.<i>, Ctenopharyngodon idellus, Hypophthalmichthys</i> spp.<i>, Cirrhinus</i> spp.<i>, Mylopharyngodon piceus, Catla catla, Labeo</i> spp.<i>, Osteochilus hasselti, Leptobarbus hoeveni, Megalobrama</i> spp.), enguias (<i>Anguilla</i> spp.), perca-do-nilo (<i>Lates niloticus</i>) e peixes cabeça-de-serpente (<i>Channa</i> spp.)"
  },
  {
    "codigo": "03055310",
    "descricao": "Bacalhau polar (<i>Boreogadus saida</i>), saithe (<i>Pollachius virens</i>), ling (<i>Molva molva</i>), ling azul (<i>Molva dypterygia</i>), zarbo (<i>Brosme brosme</i>), abrotea-do-alto (<i>Urophycis blennoides</i>) e hadoque (<i>Melanogrammus aeglefinus</i>)"
  },
  {
    "codigo": "03055390",
    "descricao": "Outros"
  },
  {
    "codigo": "03055400",
    "descricao": "-- Arenques (<i>Clupea harengus, Clupea pallasii</i>), anchovas (biqueirões*) (<i>Engraulis</i> spp.), sardinhas (<i>Sardina pilchardus, Sardinops</i> spp.<i>, Sardinella</i> spp.) (sardinha (<i>Sardina pilchardus</i>) e sardinelas (<i>Sardinops</i> spp., <i>Sardinella</i> spp.)*), anchoveta (espadilha*) (<i>Sprattus sprattus</i>), cavalinhas (sardas e cavalas*) (<i>Scomber scombrus, Scomber australasicus, Scomber japonicus</i>), cavalas-do-índico (<i>Rastrelliger</i> spp.), serras (<i>Scomberomorus</i> spp.), carapaus (<i>Trachurus</i> spp.), xaréus (<i>Caranx</i> spp.), bijupirá (cobia*) (<i>Rachycentron canadum</i>), pampos-prateado (<i>Pampus</i> spp.), agulhão-do-japão (<i>Cololabis saira</i>), charros (<i>Decapterus</i> spp.), capelim (<i>Mallotus villosus</i>), espadarte (<i>Xiphias gladius</i>), merma-oriental (<i>Euthynnus affinis</i>), bonitos (<i>Sarda</i> spp.), espadins, marlins, veleiros (<i>Istiophoridae</i>)"
  },
  {
    "codigo": "03055900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03056100",
    "descricao": "-- Arenques (<i>Clupea harengus, Clupea pallasii</i>)"
  },
  {
    "codigo": "03056200",
    "descricao": "-- Bacalhau-do-atlântico (<i>Gadus morhua</i>), bacalhau-da-groelândia (<i>Gadus ogac</i>) e bacalhau-do-pacífico (<i>Gadus macrocephalus</i>)"
  },
  {
    "codigo": "03056300",
    "descricao": "-- Anchovas (Biqueirões*) (<i>Engraulis</i> spp.)"
  },
  {
    "codigo": "03056400",
    "descricao": "-- Tilápias (<i>Oreochromis</i> spp.), bagres (peixes-gato*) (<i>Pangasius</i> spp.<i>, Silurus</i> spp.<i>, Clarias</i> spp.<i>, Ictalurus</i> spp.), carpas (<i>Cyprinus</i> spp.<i>, Carassius</i> spp.<i>, Ctenopharyngodon idellus, Hypophthalmichthys</i> spp.<i>, Cirrhinus</i> spp.<i>, Mylopharyngodon piceus, Catla catla, Labeo</i> spp.<i>, Osteochilus hasselti, Leptobarbus hoeveni, Megalobrama</i> spp.), enguias (<i>Anguilla</i> spp.), perca-do-nilo (<i>Lates niloticus</i>) e peixes cabeça-de-serpente (<i>Channa</i> spp.)"
  },
  {
    "codigo": "03056910",
    "descricao": "Saithe (<i>Pollachius virens</i>), ling (<i>Molva molva</i>) e zarbo (<i>Brosme brosme</i>)"
  },
  {
    "codigo": "03056990",
    "descricao": "Outros"
  },
  {
    "codigo": "03057100",
    "descricao": "-- Barbatanas de tubarão"
  },
  {
    "codigo": "03057200",
    "descricao": "-- Cabeças, caudas e bexigas-natatórias, de peixes"
  },
  {
    "codigo": "03057900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03061110",
    "descricao": "Inteiras"
  },
  {
    "codigo": "03061190",
    "descricao": "Outras"
  },
  {
    "codigo": "03061200",
    "descricao": "-- Lavagantes (<i>Homarus</i> spp.)"
  },
  {
    "codigo": "03061400",
    "descricao": "-- Caranguejos"
  },
  {
    "codigo": "03061500",
    "descricao": "-- Lagosta norueguesa (Lagostim*) (<i>Nephrops norvegicus</i>)"
  },
  {
    "codigo": "03061610",
    "descricao": "Inteiros"
  },
  {
    "codigo": "03061690",
    "descricao": "Outros"
  },
  {
    "codigo": "03061710",
    "descricao": "Inteiros"
  },
  {
    "codigo": "03061790",
    "descricao": "Outros"
  },
  {
    "codigo": "03061910",
    "descricao": "Krill (<i>Euphausia superba</i>)"
  },
  {
    "codigo": "03061990",
    "descricao": "Outros"
  },
  {
    "codigo": "03063100",
    "descricao": "-- Lagostas (<i>Palinurus</i> spp., <i>Panulirus</i> spp., <i>Jasus</i> spp.)"
  },
  {
    "codigo": "03063200",
    "descricao": "-- Lavagantes (<i>Homarus</i> spp.)"
  },
  {
    "codigo": "03063300",
    "descricao": "-- Caranguejos"
  },
  {
    "codigo": "03063400",
    "descricao": "-- Lagosta norueguesa (Lagostim*) (<i>Nephrops norvegicus</i>)"
  },
  {
    "codigo": "03063500",
    "descricao": "-- Camarões de água fria (<i>Pandalus</i> spp., <i>Crangon crangon</i>)"
  },
  {
    "codigo": "03063600",
    "descricao": "-- Outros camarões"
  },
  {
    "codigo": "03063910",
    "descricao": "Lagosta de água doce (<i>Cherax quadricarinatus</i>)"
  },
  {
    "codigo": "03063990",
    "descricao": "Outros"
  },
  {
    "codigo": "03069100",
    "descricao": "-- Lagostas (<i>Palinurus</i> spp., <i>Panulirus</i> spp., <i>Jasus</i> spp.)"
  },
  {
    "codigo": "03069200",
    "descricao": "-- Lavagantes (<i>Homarus</i> spp.)"
  },
  {
    "codigo": "03069300",
    "descricao": "-- Caranguejos"
  },
  {
    "codigo": "03069400",
    "descricao": "-- Lagosta norueguesa (Lagostim*) (<i>Nephrops norvegicus</i>)"
  },
  {
    "codigo": "03069500",
    "descricao": "-- Camarões"
  },
  {
    "codigo": "03069910",
    "descricao": "Lagosta de água doce (<i>Cherax quadricarinatus</i>)"
  },
  {
    "codigo": "03069990",
    "descricao": "Outros"
  },
  {
    "codigo": "03071100",
    "descricao": "-- Vivas, frescas ou refrigeradas"
  },
  {
    "codigo": "03071200",
    "descricao": "-- Congeladas"
  },
  {
    "codigo": "03071900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "03072100",
    "descricao": "-- Vivos, frescos ou refrigerados"
  },
  {
    "codigo": "03072200",
    "descricao": "-- Congelados"
  },
  {
    "codigo": "03072900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03073100",
    "descricao": "-- Vivos, frescos ou refrigerados"
  },
  {
    "codigo": "03073200",
    "descricao": "-- Congelados"
  },
  {
    "codigo": "03073900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03074200",
    "descricao": "-- Vivas, frescas ou refrigeradas"
  },
  {
    "codigo": "03074310",
    "descricao": "Lulas"
  },
  {
    "codigo": "03074320",
    "descricao": "Sépias"
  },
  {
    "codigo": "03074900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "03075100",
    "descricao": "-- Vivos, frescos ou refrigerados"
  },
  {
    "codigo": "03075200",
    "descricao": "-- Congelados"
  },
  {
    "codigo": "03075900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03076000",
    "descricao": "- Caracóis, exceto os do mar"
  },
  {
    "codigo": "03077100",
    "descricao": "-- Vivos, frescos ou refrigerados"
  },
  {
    "codigo": "03077200",
    "descricao": "-- Congelados"
  },
  {
    "codigo": "03077900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03078100",
    "descricao": "-- Abalones (Orelhas-do-mar*) (<i>Haliotis</i> spp.) vivos, frescos ou refrigerados"
  },
  {
    "codigo": "03078200",
    "descricao": "-- Estrombos (<i>Strombus</i> spp.) vivos, frescos ou refrigerados"
  },
  {
    "codigo": "03078300",
    "descricao": "-- Abalones (Orelhas-do-mar*) (<i>Haliotis</i> spp.) congelados"
  },
  {
    "codigo": "03078400",
    "descricao": "-- Estrombos (<i>Strombus</i> spp.) congelados"
  },
  {
    "codigo": "03078700",
    "descricao": "-- Outros abalones (orelhas-do-mar*) (<i>Haliotis</i> spp.)"
  },
  {
    "codigo": "03078800",
    "descricao": "-- Outros estrombos (<i>Strombus</i> spp.)"
  },
  {
    "codigo": "03079100",
    "descricao": "-- Vivos, frescos ou refrigerados"
  },
  {
    "codigo": "03079200",
    "descricao": "-- Congelados"
  },
  {
    "codigo": "03079900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03081100",
    "descricao": "-- Vivos, frescos ou refrigerados"
  },
  {
    "codigo": "03081200",
    "descricao": "-- Congelados"
  },
  {
    "codigo": "03081900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03082100",
    "descricao": "-- Vivos, frescos ou refrigerados"
  },
  {
    "codigo": "03082200",
    "descricao": "-- Congelados"
  },
  {
    "codigo": "03082900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "03083000",
    "descricao": "- Medusas (águas-vivas) (<i>Rhopilema</i> spp.)"
  },
  {
    "codigo": "03089000",
    "descricao": "- Outros"
  },
  {
    "codigo": "03091000",
    "descricao": "- De peixe"
  },
  {
    "codigo": "03099000",
    "descricao": "- Outros"
  },
  {
    "codigo": "04011010",
    "descricao": "Leite UHT (<i>Ultra High Temperature</i>)"
  },
  {
    "codigo": "04011090",
    "descricao": "Outros"
  },
  {
    "codigo": "04012010",
    "descricao": "Leite UHT (<i>Ultra High Temperature</i>)"
  },
  {
    "codigo": "04012090",
    "descricao": "Outros"
  },
  {
    "codigo": "04014010",
    "descricao": "Leite"
  },
  {
    "codigo": "04014021",
    "descricao": "UHT (<i>Ultra High Temperature</i>)"
  },
  {
    "codigo": "04014029",
    "descricao": "Outros"
  },
  {
    "codigo": "04015010",
    "descricao": "Leite"
  },
  {
    "codigo": "04015021",
    "descricao": "UHT (<i>Ultra High Temperature</i>)"
  },
  {
    "codigo": "04015029",
    "descricao": "Outros"
  },
  {
    "codigo": "04021010",
    "descricao": "Com um teor de arsênio, chumbo ou cobre, considerados isoladamente, inferior a 5 ppm"
  },
  {
    "codigo": "04021090",
    "descricao": "Outros"
  },
  {
    "codigo": "04022110",
    "descricao": "Leite integral"
  },
  {
    "codigo": "04022120",
    "descricao": "Leite parcialmente desnatado"
  },
  {
    "codigo": "04022130",
    "descricao": "Creme de leite (nata)"
  },
  {
    "codigo": "04022910",
    "descricao": "Leite integral"
  },
  {
    "codigo": "04022920",
    "descricao": "Leite parcialmente desnatado"
  },
  {
    "codigo": "04022930",
    "descricao": "Creme de leite (nata)"
  },
  {
    "codigo": "04029100",
    "descricao": "-- Sem adição de açúcar ou de outros edulcorantes"
  },
  {
    "codigo": "04029900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "04032000",
    "descricao": "- Iogurte"
  },
  {
    "codigo": "04039000",
    "descricao": "- Outros"
  },
  {
    "codigo": "04041000",
    "descricao": "- Soro de leite, modificado ou não, mesmo concentrado ou adicionado de açúcar ou de outros edulcorantes"
  },
  {
    "codigo": "04049000",
    "descricao": "- Outros"
  },
  {
    "codigo": "04051000",
    "descricao": "- Manteiga"
  },
  {
    "codigo": "04052000",
    "descricao": "- Pasta de espalhar (barrar) de produtos provenientes do leite"
  },
  {
    "codigo": "04059010",
    "descricao": "Óleo butírico de manteiga (<i>butter oil</i>)"
  },
  {
    "codigo": "04059090",
    "descricao": "Outras"
  },
  {
    "codigo": "04061010",
    "descricao": "Mozarela"
  },
  {
    "codigo": "04061090",
    "descricao": "Outros"
  },
  {
    "codigo": "04062000",
    "descricao": "- Queijos ralados ou em pó, de qualquer tipo"
  },
  {
    "codigo": "04063000",
    "descricao": "- Queijos fundidos, exceto ralados ou em pó"
  },
  {
    "codigo": "04064000",
    "descricao": "- Queijos de pasta mofada (azul) e outros queijos que apresentem veios obtidos utilizando <i>Penicillium roqueforti</i>"
  },
  {
    "codigo": "04069010",
    "descricao": "Com um teor de umidade inferior a 36,0 %, em peso (massa dura)"
  },
  {
    "codigo": "04069020",
    "descricao": "Com um teor de umidade igual ou superior a 36,0 % e inferior a 46,0 %, em peso (massa semidura)"
  },
  {
    "codigo": "04069030",
    "descricao": "Com um teor de umidade igual ou superior a 46,0 % e inferior a 55,0 %, em peso (massa macia)"
  },
  {
    "codigo": "04069090",
    "descricao": "Outros"
  },
  {
    "codigo": "04071100",
    "descricao": "-- De aves da espécie <i>Gallus domesticus</i>"
  },
  {
    "codigo": "04071900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "04072100",
    "descricao": "-- De aves da espécie <i>Gallus domesticus</i>"
  },
  {
    "codigo": "04072900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "04079000",
    "descricao": "- Outros"
  },
  {
    "codigo": "04081100",
    "descricao": "-- Secas"
  },
  {
    "codigo": "04081900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "04089100",
    "descricao": "-- Secos"
  },
  {
    "codigo": "04089900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "04090000",
    "descricao": "Mel natural."
  },
  {
    "codigo": "04101000",
    "descricao": "- Insetos"
  },
  {
    "codigo": "04109000",
    "descricao": "- Outros"
  },
  {
    "codigo": "05010000",
    "descricao": "Cabelo em bruto, mesmo lavado ou desengordurado; desperdícios de cabelo."
  },
  {
    "codigo": "05021011",
    "descricao": "Lavadas, alvejadas ou desengorduradas, mesmo tintas"
  },
  {
    "codigo": "05021019",
    "descricao": "Outras"
  },
  {
    "codigo": "05021090",
    "descricao": "Outros"
  },
  {
    "codigo": "05029010",
    "descricao": "Pelos"
  },
  {
    "codigo": "05029020",
    "descricao": "Desperdícios"
  },
  {
    "codigo": "05040011",
    "descricao": "De bovinos"
  },
  {
    "codigo": "05040012",
    "descricao": "De ovinos"
  },
  {
    "codigo": "05040013",
    "descricao": "De suínos"
  },
  {
    "codigo": "05040019",
    "descricao": "Outras"
  },
  {
    "codigo": "05040090",
    "descricao": "Outros"
  },
  {
    "codigo": "05051000",
    "descricao": "- Penas do tipo utilizado para enchimento ou estofamento; penugem"
  },
  {
    "codigo": "05059000",
    "descricao": "- Outros"
  },
  {
    "codigo": "05061000",
    "descricao": "- Osseína e ossos acidulados"
  },
  {
    "codigo": "05069000",
    "descricao": "- Outros"
  },
  {
    "codigo": "05071000",
    "descricao": "- Marfim; pó e desperdícios de marfim"
  },
  {
    "codigo": "05079000",
    "descricao": "- Outros"
  },
  {
    "codigo": "05080000",
    "descricao": "Coral e matérias semelhantes, em bruto ou simplesmente preparados, mas não trabalhados de outro modo; conchas e carapaças de moluscos, crustáceos ou de equinodermes e ossos de sépias (chocos*) (chocos e chopos*), em bruto ou simplesmente preparados, mas não cortados em forma determinada, seus pós e desperdícios."
  },
  {
    "codigo": "05100010",
    "descricao": "Pâncreas de bovino"
  },
  {
    "codigo": "05100090",
    "descricao": "Outros"
  },
  {
    "codigo": "05111000",
    "descricao": "- Sêmen de bovino"
  },
  {
    "codigo": "05119110",
    "descricao": "Ovas de peixe fecundadas, para reprodução"
  },
  {
    "codigo": "05119190",
    "descricao": "Outros"
  },
  {
    "codigo": "05119910",
    "descricao": "Embriões de animais"
  },
  {
    "codigo": "05119920",
    "descricao": "Sêmen animal"
  },
  {
    "codigo": "05119930",
    "descricao": "Ovos de bicho-da-seda"
  },
  {
    "codigo": "05119991",
    "descricao": "Crinas e seus desperdícios, mesmo em mantas, mesmo com suporte"
  },
  {
    "codigo": "05119999",
    "descricao": "Outros"
  },
  {
    "codigo": "06011000",
    "descricao": "- Bulbos, tubérculos, raízes tuberosas, cormos, coroas e rizomas, em repouso vegetativo"
  },
  {
    "codigo": "06012000",
    "descricao": "- Bulbos, tubérculos, raízes tuberosas, cormos, coroas e rizomas, em vegetação ou em flor; mudas, plantas e raízes de chicória"
  },
  {
    "codigo": "06021000",
    "descricao": "- Estacas não enraizadas e enxertos"
  },
  {
    "codigo": "06022000",
    "descricao": "- Árvores, arbustos e silvados, de fruta, enxertados ou não"
  },
  {
    "codigo": "06023000",
    "descricao": "- Rododendros e azaleias, enxertados ou não"
  },
  {
    "codigo": "06024000",
    "descricao": "- Roseiras, enxertadas ou não"
  },
  {
    "codigo": "06029010",
    "descricao": "Micélios de cogumelos"
  },
  {
    "codigo": "06029021",
    "descricao": "De orquídea"
  },
  {
    "codigo": "06029029",
    "descricao": "Outras"
  },
  {
    "codigo": "06029081",
    "descricao": "De cana-de-açúcar"
  },
  {
    "codigo": "06029082",
    "descricao": "De videira"
  },
  {
    "codigo": "06029083",
    "descricao": "De café"
  },
  {
    "codigo": "06029089",
    "descricao": "Outras"
  },
  {
    "codigo": "06029090",
    "descricao": "Outras"
  },
  {
    "codigo": "06031100",
    "descricao": "-- Rosas"
  },
  {
    "codigo": "06031200",
    "descricao": "-- Cravos"
  },
  {
    "codigo": "06031300",
    "descricao": "-- Orquídeas"
  },
  {
    "codigo": "06031400",
    "descricao": "-- Crisântemos"
  },
  {
    "codigo": "06031500",
    "descricao": "-- Lírios (<i>Lilium</i> spp.)"
  },
  {
    "codigo": "06031900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "06039000",
    "descricao": "- Outros"
  },
  {
    "codigo": "06042000",
    "descricao": "- Frescos"
  },
  {
    "codigo": "06049000",
    "descricao": "- Outros"
  },
  {
    "codigo": "07011000",
    "descricao": "- Batata-semente"
  },
  {
    "codigo": "07019000",
    "descricao": "- Outras"
  },
  {
    "codigo": "07020000",
    "descricao": "Tomates, frescos ou refrigerados."
  },
  {
    "codigo": "07031011",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07031019",
    "descricao": "Outras"
  },
  {
    "codigo": "07031021",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07031029",
    "descricao": "Outras"
  },
  {
    "codigo": "07032010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07032090",
    "descricao": "Outros"
  },
  {
    "codigo": "07039010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07039090",
    "descricao": "Outros"
  },
  {
    "codigo": "07041000",
    "descricao": "- Couve-flor e brócolis"
  },
  {
    "codigo": "07042000",
    "descricao": "- Couve-de-bruxelas"
  },
  {
    "codigo": "07049000",
    "descricao": "- Outros"
  },
  {
    "codigo": "07051100",
    "descricao": "-- Repolhuda"
  },
  {
    "codigo": "07051900",
    "descricao": "-- Outra"
  },
  {
    "codigo": "07052100",
    "descricao": "-- Endívia (<i>Cichorium intybus</i> var. <i>foliosum</i>)"
  },
  {
    "codigo": "07052900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "07061000",
    "descricao": "- Cenouras e nabos"
  },
  {
    "codigo": "07069000",
    "descricao": "- Outros"
  },
  {
    "codigo": "07070000",
    "descricao": "Pepinos e pepininhos (<i>cornichons</i>), frescos ou refrigerados."
  },
  {
    "codigo": "07081000",
    "descricao": "- Ervilhas (<i>Pisum sativum</i>)"
  },
  {
    "codigo": "07082000",
    "descricao": "- Feijões (<i>Vigna</i> spp., <i>Phaseolus</i> spp.)"
  },
  {
    "codigo": "07089000",
    "descricao": "- Outros legumes de vagem"
  },
  {
    "codigo": "07092000",
    "descricao": "- Aspargos"
  },
  {
    "codigo": "07093000",
    "descricao": "- Berinjelas"
  },
  {
    "codigo": "07094000",
    "descricao": "- Aipo, exceto aipo-rábano"
  },
  {
    "codigo": "07095100",
    "descricao": "-- Cogumelos do gênero <i>Agaricus</i>"
  },
  {
    "codigo": "07095200",
    "descricao": "-- Cogumelos do gênero <i>Boletus</i>"
  },
  {
    "codigo": "07095300",
    "descricao": "-- Cogumelos do gênero <i>Cantharellus</i>"
  },
  {
    "codigo": "07095400",
    "descricao": "-- Shitake (<i>Lentinus edodes</i>)"
  },
  {
    "codigo": "07095500",
    "descricao": "-- Matsutake (<i>Tricholoma matsutake</i>, <i>Tricholoma magnivelare</i>, <i>Tricholoma anatolicum</i>, <i>Tricholoma dulciolens</i>, <i>Tricholoma caligatum</i>)"
  },
  {
    "codigo": "07095600",
    "descricao": "-- Trufas (<i>Tuber</i> spp.)"
  },
  {
    "codigo": "07095900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "07096000",
    "descricao": "- Pimentões (pimentos) e pimentas do gênero <i>Capsicum</i> ou do gênero <i>Pimenta</i>"
  },
  {
    "codigo": "07097000",
    "descricao": "- Espinafres, espinafres-da-nova-zelândia e espinafres gigantes"
  },
  {
    "codigo": "07099100",
    "descricao": "-- Alcachofras"
  },
  {
    "codigo": "07099200",
    "descricao": "-- Azeitonas"
  },
  {
    "codigo": "07099300",
    "descricao": "-- Abóboras, abobrinhas (curgetes*) e cabaças (<i>Cucurbita</i> spp.)"
  },
  {
    "codigo": "07099911",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07099919",
    "descricao": "Outros"
  },
  {
    "codigo": "07099990",
    "descricao": "Outros"
  },
  {
    "codigo": "07101000",
    "descricao": "- Batatas"
  },
  {
    "codigo": "07102100",
    "descricao": "-- Ervilhas (<i>Pisum sativum</i>)"
  },
  {
    "codigo": "07102200",
    "descricao": "-- Feijões (<i>Vigna</i> spp., <i>Phaseolus</i> spp.)"
  },
  {
    "codigo": "07102900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "07103000",
    "descricao": "- Espinafres, espinafres-da-nova-zelândia e espinafres gigantes"
  },
  {
    "codigo": "07104000",
    "descricao": "- Milho doce"
  },
  {
    "codigo": "07108000",
    "descricao": "- Outros produtos hortícolas"
  },
  {
    "codigo": "07109000",
    "descricao": "- Misturas de produtos hortícolas"
  },
  {
    "codigo": "07112010",
    "descricao": "Com água salgada"
  },
  {
    "codigo": "07112020",
    "descricao": "Com água sulfurada ou adicionada de outras substâncias"
  },
  {
    "codigo": "07112090",
    "descricao": "Outras"
  },
  {
    "codigo": "07114000",
    "descricao": "- Pepinos e pepininhos (<i>cornichons</i>)"
  },
  {
    "codigo": "07115100",
    "descricao": "-- Cogumelos do gênero <i>Agaricus</i>"
  },
  {
    "codigo": "07115900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "07119000",
    "descricao": "- Outros produtos hortícolas; misturas de produtos hortícolas"
  },
  {
    "codigo": "07122000",
    "descricao": "- Cebolas"
  },
  {
    "codigo": "07123100",
    "descricao": "-- Cogumelos do gênero <i>Agaricus</i>"
  },
  {
    "codigo": "07123200",
    "descricao": "-- Orelhas-de-judas (<i>Auricularia</i> spp.)"
  },
  {
    "codigo": "07123300",
    "descricao": "-- Tremelas (<i>Tremella</i> spp.)"
  },
  {
    "codigo": "07123400",
    "descricao": "-- Shitake (<i>Lentinus edodes</i>)"
  },
  {
    "codigo": "07123900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "07129020",
    "descricao": "Alho"
  },
  {
    "codigo": "07129090",
    "descricao": "Outros"
  },
  {
    "codigo": "07131010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07131090",
    "descricao": "Outras"
  },
  {
    "codigo": "07132010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07132090",
    "descricao": "Outros"
  },
  {
    "codigo": "07133110",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07133190",
    "descricao": "Outros"
  },
  {
    "codigo": "07133210",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07133290",
    "descricao": "Outros"
  },
  {
    "codigo": "07133311",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07133319",
    "descricao": "Outros"
  },
  {
    "codigo": "07133321",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07133329",
    "descricao": "Outros"
  },
  {
    "codigo": "07133391",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07133399",
    "descricao": "Outros"
  },
  {
    "codigo": "07133410",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07133490",
    "descricao": "Outros"
  },
  {
    "codigo": "07133510",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07133590",
    "descricao": "Outros"
  },
  {
    "codigo": "07133910",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07133990",
    "descricao": "Outros"
  },
  {
    "codigo": "07134010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07134090",
    "descricao": "Outras"
  },
  {
    "codigo": "07135010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07135090",
    "descricao": "Outras"
  },
  {
    "codigo": "07136010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07136090",
    "descricao": "Outros"
  },
  {
    "codigo": "07139010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "07139090",
    "descricao": "Outros"
  },
  {
    "codigo": "07141000",
    "descricao": "- Raízes de mandioca"
  },
  {
    "codigo": "07142000",
    "descricao": "- Batatas-doces"
  },
  {
    "codigo": "07143000",
    "descricao": "- Inhames (<i>Dioscorea</i> spp.)"
  },
  {
    "codigo": "07144000",
    "descricao": "- Taros (inhames-brancos) (<i>Colocasia</i> spp.)"
  },
  {
    "codigo": "07145000",
    "descricao": "- Mangaritos (Orelhas-de-elefante*) (<i>Xanthosoma</i> spp.)"
  },
  {
    "codigo": "07149000",
    "descricao": "- Outros"
  },
  {
    "codigo": "08011100",
    "descricao": "-- Dessecados"
  },
  {
    "codigo": "08011200",
    "descricao": "-- Na casca interna (endocarpo)"
  },
  {
    "codigo": "08011900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "08012100",
    "descricao": "-- Com casca"
  },
  {
    "codigo": "08012200",
    "descricao": "-- Sem casca"
  },
  {
    "codigo": "08013100",
    "descricao": "-- Com casca"
  },
  {
    "codigo": "08013200",
    "descricao": "-- Sem casca"
  },
  {
    "codigo": "08021100",
    "descricao": "-- Com casca"
  },
  {
    "codigo": "08021200",
    "descricao": "-- Sem casca"
  },
  {
    "codigo": "08022100",
    "descricao": "-- Com casca"
  },
  {
    "codigo": "08022200",
    "descricao": "-- Sem casca"
  },
  {
    "codigo": "08023100",
    "descricao": "-- Com casca"
  },
  {
    "codigo": "08023200",
    "descricao": "-- Sem casca"
  },
  {
    "codigo": "08024100",
    "descricao": "-- Com casca"
  },
  {
    "codigo": "08024200",
    "descricao": "-- Sem casca"
  },
  {
    "codigo": "08025100",
    "descricao": "-- Com casca"
  },
  {
    "codigo": "08025200",
    "descricao": "-- Sem casca"
  },
  {
    "codigo": "08026100",
    "descricao": "-- Com casca"
  },
  {
    "codigo": "08026200",
    "descricao": "-- Sem casca"
  },
  {
    "codigo": "08027000",
    "descricao": "- Nozes-de-cola (<i>Cola</i> spp.)"
  },
  {
    "codigo": "08028000",
    "descricao": "- Nozes-de-areca (nozes de bétele)"
  },
  {
    "codigo": "08029100",
    "descricao": "-- Pinhões, com casca"
  },
  {
    "codigo": "08029200",
    "descricao": "-- Pinhões, sem casca"
  },
  {
    "codigo": "08029900",
    "descricao": "-- Outra"
  },
  {
    "codigo": "08031000",
    "descricao": "- Bananas-da-terra (Bananas-pão*) (Plátanos*)"
  },
  {
    "codigo": "08039000",
    "descricao": "- Outras"
  },
  {
    "codigo": "08041010",
    "descricao": "Frescas"
  },
  {
    "codigo": "08041020",
    "descricao": "Secas"
  },
  {
    "codigo": "08042010",
    "descricao": "Frescos"
  },
  {
    "codigo": "08042020",
    "descricao": "Secos"
  },
  {
    "codigo": "08043000",
    "descricao": "- Abacaxis (ananases)"
  },
  {
    "codigo": "08044000",
    "descricao": "- Abacates"
  },
  {
    "codigo": "08045010",
    "descricao": "Goiabas"
  },
  {
    "codigo": "08045020",
    "descricao": "Mangas"
  },
  {
    "codigo": "08045030",
    "descricao": "Mangostões"
  },
  {
    "codigo": "08051000",
    "descricao": "- Laranjas"
  },
  {
    "codigo": "08052100",
    "descricao": "-- Mandarinas (incluindo as tangerinas e as <i>satsumas</i>)"
  },
  {
    "codigo": "08052200",
    "descricao": "-- Clementinas"
  },
  {
    "codigo": "08052900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "08054000",
    "descricao": "- Toranjas e pomelos"
  },
  {
    "codigo": "08055000",
    "descricao": "- Limões (<i>Citrus limon, Citrus limonum</i>) e limas (<i>Citrus aurantifolia, Citrus latifolia</i>)"
  },
  {
    "codigo": "08059000",
    "descricao": "- Outros"
  },
  {
    "codigo": "08061000",
    "descricao": "- Frescas"
  },
  {
    "codigo": "08062000",
    "descricao": "- Secas (passas)"
  },
  {
    "codigo": "08071100",
    "descricao": "-- Melancias"
  },
  {
    "codigo": "08071900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "08072000",
    "descricao": "- Mamões (papaias)"
  },
  {
    "codigo": "08081000",
    "descricao": "- Maçãs"
  },
  {
    "codigo": "08083000",
    "descricao": "- Peras"
  },
  {
    "codigo": "08084000",
    "descricao": "- Marmelos"
  },
  {
    "codigo": "08091000",
    "descricao": "- Damascos"
  },
  {
    "codigo": "08092100",
    "descricao": "-- Ginjas (<i>Prunus cerasus</i>)"
  },
  {
    "codigo": "08092900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "08093010",
    "descricao": "Pêssegos, excluindo as nectarinas"
  },
  {
    "codigo": "08093020",
    "descricao": "Nectarinas"
  },
  {
    "codigo": "08094000",
    "descricao": "- Ameixas e abrunhos"
  },
  {
    "codigo": "08101000",
    "descricao": "- Morangos"
  },
  {
    "codigo": "08102000",
    "descricao": "- Framboesas, amoras, incluindo as silvestres, e amoras-framboesas"
  },
  {
    "codigo": "08103000",
    "descricao": "- Groselhas, incluindo o cassis"
  },
  {
    "codigo": "08104000",
    "descricao": "- Airelas, mirtilos e outra fruta do gênero <i>Vaccinium</i>"
  },
  {
    "codigo": "08105000",
    "descricao": "- Kiwis (quivis)"
  },
  {
    "codigo": "08106000",
    "descricao": "- Duriões (duriangos)"
  },
  {
    "codigo": "08107000",
    "descricao": "- Caquis (dióspiros)"
  },
  {
    "codigo": "08109011",
    "descricao": "Carambolas (<i>Averrhoa carambola</i>)"
  },
  {
    "codigo": "08109012",
    "descricao": "Anonas e outras frutas do gênero Annona"
  },
  {
    "codigo": "08109013",
    "descricao": "Jacas (<i>Artocarpus heterophyllus</i>)"
  },
  {
    "codigo": "08109014",
    "descricao": "Lechias (<i>Litchi chinensis</i>)"
  },
  {
    "codigo": "08109015",
    "descricao": "Maracujás (<i>Passiflora edulis</i>)"
  },
  {
    "codigo": "08109016",
    "descricao": "Pitaias (<i>Hylocereus</i> spp., <i>Selenicereus undatus</i>)"
  },
  {
    "codigo": "08109017",
    "descricao": "Tamarindos (<i>Tamarindus indica</i>)"
  },
  {
    "codigo": "08109090",
    "descricao": "Outra"
  },
  {
    "codigo": "08111000",
    "descricao": "- Morangos"
  },
  {
    "codigo": "08112000",
    "descricao": "- Framboesas, amoras, incluindo as silvestres, amoras-framboesas e groselhas"
  },
  {
    "codigo": "08119000",
    "descricao": "- Outra"
  },
  {
    "codigo": "08121000",
    "descricao": "- Cerejas"
  },
  {
    "codigo": "08129000",
    "descricao": "- Outra"
  },
  {
    "codigo": "08131000",
    "descricao": "- Damascos"
  },
  {
    "codigo": "08132010",
    "descricao": "Com caroço"
  },
  {
    "codigo": "08132020",
    "descricao": "Sem caroço"
  },
  {
    "codigo": "08133000",
    "descricao": "- Maçãs"
  },
  {
    "codigo": "08134010",
    "descricao": "Peras"
  },
  {
    "codigo": "08134090",
    "descricao": "Outra"
  },
  {
    "codigo": "08135000",
    "descricao": "- Misturas de fruta seca ou de fruta de casca rija, do presente Capítulo"
  },
  {
    "codigo": "08140000",
    "descricao": "Cascas de citros (citrinos), de melões ou de melancias, frescas, secas, congeladas ou apresentadas em água salgada, sulfurada ou adicionada de outras substâncias destinadas a assegurar transitoriamente a sua conservação."
  },
  {
    "codigo": "09011110",
    "descricao": "Em grão"
  },
  {
    "codigo": "09011190",
    "descricao": "Outros"
  },
  {
    "codigo": "09011200",
    "descricao": "-- Descafeinado"
  },
  {
    "codigo": "09012100",
    "descricao": "-- Não descafeinado"
  },
  {
    "codigo": "09012200",
    "descricao": "-- Descafeinado"
  },
  {
    "codigo": "09019000",
    "descricao": "- Outros"
  },
  {
    "codigo": "09021000",
    "descricao": "- Chá verde (não fermentado) em embalagens imediatas de conteúdo não superior a 3 kg"
  },
  {
    "codigo": "09022000",
    "descricao": "- Chá verde (não fermentado) apresentado de qualquer outra forma"
  },
  {
    "codigo": "09023000",
    "descricao": "- Chá preto (fermentado) e chá parcialmente fermentado, em embalagens imediatas de conteúdo não superior a 3 kg"
  },
  {
    "codigo": "09024000",
    "descricao": "- Chá preto (fermentado) e chá parcialmente fermentado, apresentados de qualquer outra forma"
  },
  {
    "codigo": "09030010",
    "descricao": "Simplesmente cancheado"
  },
  {
    "codigo": "09030090",
    "descricao": "Outros"
  },
  {
    "codigo": "09041100",
    "descricao": "-- Não triturada nem em pó"
  },
  {
    "codigo": "09041200",
    "descricao": "-- Triturada ou em pó"
  },
  {
    "codigo": "09042100",
    "descricao": "-- Secos, não triturados nem em pó"
  },
  {
    "codigo": "09042200",
    "descricao": "-- Triturados ou em pó"
  },
  {
    "codigo": "09051000",
    "descricao": "- Não triturada nem em pó"
  },
  {
    "codigo": "09052000",
    "descricao": "- Triturada ou em pó"
  },
  {
    "codigo": "09061100",
    "descricao": "-- Canela (<i>Cinnamomum zeylanicum blume</i>)"
  },
  {
    "codigo": "09061900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "09062000",
    "descricao": "- Trituradas ou em pó"
  },
  {
    "codigo": "09071000",
    "descricao": "- Não triturado nem em pó"
  },
  {
    "codigo": "09072000",
    "descricao": "- Triturado ou em pó"
  },
  {
    "codigo": "09081100",
    "descricao": "-- Não triturada nem em pó"
  },
  {
    "codigo": "09081200",
    "descricao": "-- Triturada ou em pó"
  },
  {
    "codigo": "09082100",
    "descricao": "-- Não triturado nem em pó"
  },
  {
    "codigo": "09082200",
    "descricao": "-- Triturado ou em pó"
  },
  {
    "codigo": "09083100",
    "descricao": "-- Não triturados nem em pó"
  },
  {
    "codigo": "09083200",
    "descricao": "-- Triturados ou em pó"
  },
  {
    "codigo": "09092100",
    "descricao": "-- Não trituradas nem em pó"
  },
  {
    "codigo": "09092200",
    "descricao": "-- Trituradas ou em pó"
  },
  {
    "codigo": "09093100",
    "descricao": "-- Não trituradas nem em pó"
  },
  {
    "codigo": "09093200",
    "descricao": "-- Trituradas ou em pó"
  },
  {
    "codigo": "09096110",
    "descricao": "De anis (erva-doce)"
  },
  {
    "codigo": "09096120",
    "descricao": "De badiana (anis-estrelado)"
  },
  {
    "codigo": "09096190",
    "descricao": "Outras"
  },
  {
    "codigo": "09096210",
    "descricao": "De anis (erva-doce)"
  },
  {
    "codigo": "09096220",
    "descricao": "De badiana (anis-estrelado)"
  },
  {
    "codigo": "09096290",
    "descricao": "Outras"
  },
  {
    "codigo": "09101100",
    "descricao": "-- Não triturado nem em pó"
  },
  {
    "codigo": "09101200",
    "descricao": "-- Triturado ou em pó"
  },
  {
    "codigo": "09102000",
    "descricao": "- Açafrão"
  },
  {
    "codigo": "09103000",
    "descricao": "- Cúrcuma"
  },
  {
    "codigo": "09109100",
    "descricao": "-- Misturas mencionadas na Nota 1 b) do presente Capítulo"
  },
  {
    "codigo": "09109900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "10011100",
    "descricao": "-- Para semeadura (sementeira)"
  },
  {
    "codigo": "10011900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "10019100",
    "descricao": "-- Para semeadura (sementeira)"
  },
  {
    "codigo": "10019900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "10021000",
    "descricao": "- Para semeadura (sementeira)"
  },
  {
    "codigo": "10029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "10031000",
    "descricao": "- Para semeadura (sementeira)"
  },
  {
    "codigo": "10039010",
    "descricao": "Cervejeira"
  },
  {
    "codigo": "10039080",
    "descricao": "Outras, em grão"
  },
  {
    "codigo": "10039090",
    "descricao": "Outras"
  },
  {
    "codigo": "10041000",
    "descricao": "- Para semeadura (sementeira)"
  },
  {
    "codigo": "10049000",
    "descricao": "- Outras"
  },
  {
    "codigo": "10051000",
    "descricao": "- Para semeadura (sementeira)"
  },
  {
    "codigo": "10059010",
    "descricao": "Em grão"
  },
  {
    "codigo": "10059090",
    "descricao": "Outros"
  },
  {
    "codigo": "10061010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "10061091",
    "descricao": "Parboilizado"
  },
  {
    "codigo": "10061092",
    "descricao": "Não parboilizado"
  },
  {
    "codigo": "10062010",
    "descricao": "Parboilizado"
  },
  {
    "codigo": "10062020",
    "descricao": "Não parboilizado"
  },
  {
    "codigo": "10063011",
    "descricao": "Polido ou brunido"
  },
  {
    "codigo": "10063019",
    "descricao": "Outros"
  },
  {
    "codigo": "10063021",
    "descricao": "Polido ou brunido"
  },
  {
    "codigo": "10063029",
    "descricao": "Outros"
  },
  {
    "codigo": "10064000",
    "descricao": "- Arroz quebrado (Trinca de arroz*)"
  },
  {
    "codigo": "10071000",
    "descricao": "- Para semeadura (sementeira)"
  },
  {
    "codigo": "10079000",
    "descricao": "- Outros"
  },
  {
    "codigo": "10081010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "10081090",
    "descricao": "Outros"
  },
  {
    "codigo": "10082110",
    "descricao": "Milheto (<i>Pennisetum glaucum</i>)"
  },
  {
    "codigo": "10082190",
    "descricao": "Outros"
  },
  {
    "codigo": "10082910",
    "descricao": "Milheto (<i>Pennisetum glaucum</i>)"
  },
  {
    "codigo": "10082990",
    "descricao": "Outros"
  },
  {
    "codigo": "10083010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "10083090",
    "descricao": "Outros"
  },
  {
    "codigo": "10084010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "10084090",
    "descricao": "Outros"
  },
  {
    "codigo": "10085010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "10085090",
    "descricao": "Outros"
  },
  {
    "codigo": "10086010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "10086090",
    "descricao": "Outros"
  },
  {
    "codigo": "10089010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "10089090",
    "descricao": "Outros"
  },
  {
    "codigo": "11010010",
    "descricao": "De trigo"
  },
  {
    "codigo": "11010020",
    "descricao": "De mistura de trigo com centeio (<i>méteil</i>)"
  },
  {
    "codigo": "11022000",
    "descricao": "- Farinha de milho"
  },
  {
    "codigo": "11029000",
    "descricao": "- Outras"
  },
  {
    "codigo": "11031100",
    "descricao": "-- De trigo"
  },
  {
    "codigo": "11031300",
    "descricao": "-- De milho"
  },
  {
    "codigo": "11031900",
    "descricao": "-- De outros cereais"
  },
  {
    "codigo": "11032000",
    "descricao": "- <i>Pellets</i>"
  },
  {
    "codigo": "11041200",
    "descricao": "-- De aveia"
  },
  {
    "codigo": "11041900",
    "descricao": "-- De outros cereais"
  },
  {
    "codigo": "11042200",
    "descricao": "-- De aveia"
  },
  {
    "codigo": "11042300",
    "descricao": "-- De milho"
  },
  {
    "codigo": "11042900",
    "descricao": "-- De outros cereais"
  },
  {
    "codigo": "11043000",
    "descricao": "- Germes de cereais, inteiros, esmagados, em flocos ou moídos"
  },
  {
    "codigo": "11051000",
    "descricao": "- Farinha, sêmola e pó"
  },
  {
    "codigo": "11052000",
    "descricao": "- Flocos, grânulos e <i>pellets</i>"
  },
  {
    "codigo": "11061000",
    "descricao": "- Dos legumes de vagem, secos, da posição 07.13"
  },
  {
    "codigo": "11062000",
    "descricao": "- De sagu ou das raízes ou tubérculos, da posição 07.14"
  },
  {
    "codigo": "11063000",
    "descricao": "- Dos produtos do Capítulo 8"
  },
  {
    "codigo": "11071010",
    "descricao": "Inteiro ou partido"
  },
  {
    "codigo": "11071020",
    "descricao": "Moído ou em farinha"
  },
  {
    "codigo": "11072010",
    "descricao": "Inteiro ou partido"
  },
  {
    "codigo": "11072020",
    "descricao": "Moído ou em farinha"
  },
  {
    "codigo": "11081100",
    "descricao": "-- Amido de trigo"
  },
  {
    "codigo": "11081200",
    "descricao": "-- Amido de milho"
  },
  {
    "codigo": "11081300",
    "descricao": "-- Fécula de batata"
  },
  {
    "codigo": "11081400",
    "descricao": "-- Fécula de mandioca"
  },
  {
    "codigo": "11081900",
    "descricao": "-- Outros amidos e féculas"
  },
  {
    "codigo": "11082000",
    "descricao": "- Inulina"
  },
  {
    "codigo": "11090000",
    "descricao": "Glúten de trigo, mesmo seco."
  },
  {
    "codigo": "12011000",
    "descricao": "- Para semeadura (sementeira)"
  },
  {
    "codigo": "12019000",
    "descricao": "- Outras"
  },
  {
    "codigo": "12023000",
    "descricao": "- Para semeadura (sementeira)"
  },
  {
    "codigo": "12024100",
    "descricao": "-- Com casca"
  },
  {
    "codigo": "12024200",
    "descricao": "-- Descascados, mesmo triturados"
  },
  {
    "codigo": "12030000",
    "descricao": "Copra."
  },
  {
    "codigo": "12040010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "12040090",
    "descricao": "Outras"
  },
  {
    "codigo": "12051010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "12051090",
    "descricao": "Outras"
  },
  {
    "codigo": "12059010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "12059090",
    "descricao": "Outras"
  },
  {
    "codigo": "12060010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "12060090",
    "descricao": "Outras"
  },
  {
    "codigo": "12071010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "12071090",
    "descricao": "Outras"
  },
  {
    "codigo": "12072100",
    "descricao": "-- Para semeadura (sementeira)"
  },
  {
    "codigo": "12072900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "12073010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "12073090",
    "descricao": "Outras"
  },
  {
    "codigo": "12074010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "12074090",
    "descricao": "Outras"
  },
  {
    "codigo": "12075010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "12075090",
    "descricao": "Outras"
  },
  {
    "codigo": "12076010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "12076090",
    "descricao": "Outras"
  },
  {
    "codigo": "12077010",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "12077090",
    "descricao": "Outras"
  },
  {
    "codigo": "12079110",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "12079190",
    "descricao": "Outras"
  },
  {
    "codigo": "12079910",
    "descricao": "Para semeadura (sementeira)"
  },
  {
    "codigo": "12079990",
    "descricao": "Outros"
  },
  {
    "codigo": "12081000",
    "descricao": "- De soja"
  },
  {
    "codigo": "12089000",
    "descricao": "- Outras"
  },
  {
    "codigo": "12091000",
    "descricao": "- Sementes de beterraba sacarina"
  },
  {
    "codigo": "12092100",
    "descricao": "-- Sementes de alfafa (luzerna)"
  },
  {
    "codigo": "12092200",
    "descricao": "-- Sementes de trevo (<i>Trifolium</i> spp.)"
  },
  {
    "codigo": "12092300",
    "descricao": "-- Sementes de festuca"
  },
  {
    "codigo": "12092400",
    "descricao": "-- Sementes de pasto dos prados de Kentucky (<i>Poa pratensis</i> L.)"
  },
  {
    "codigo": "12092500",
    "descricao": "-- Sementes de azevém (<i>Lolium multiflorum Lam., Lolium perenne</i> L.)"
  },
  {
    "codigo": "12092900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "12093000",
    "descricao": "- Sementes de plantas herbáceas cultivadas especialmente pelas suas flores"
  },
  {
    "codigo": "12099100",
    "descricao": "-- Sementes de produtos hortícolas"
  },
  {
    "codigo": "12099900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "12101000",
    "descricao": "- Cones de lúpulo, não triturados nem moídos nem em <i>pellets</i>"
  },
  {
    "codigo": "12102010",
    "descricao": "Cones de lúpulo"
  },
  {
    "codigo": "12102020",
    "descricao": "Lupulina"
  },
  {
    "codigo": "12112000",
    "descricao": "- Raízes de ginseng"
  },
  {
    "codigo": "12113000",
    "descricao": "- Coca (folha de)"
  },
  {
    "codigo": "12114000",
    "descricao": "- Palha de dormideira (papoula)"
  },
  {
    "codigo": "12115000",
    "descricao": "- Éfedra"
  },
  {
    "codigo": "12116000",
    "descricao": "- Casca de cerejeira africana (<i>Prunus africana</i>)"
  },
  {
    "codigo": "12119010",
    "descricao": "Orégano (<i>Origanum vulgare</i>)"
  },
  {
    "codigo": "12119090",
    "descricao": "Outros"
  },
  {
    "codigo": "12122100",
    "descricao": "-- Próprias para alimentação humana"
  },
  {
    "codigo": "12122900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "12129100",
    "descricao": "-- Beterraba sacarina"
  },
  {
    "codigo": "12129200",
    "descricao": "-- Alfarroba"
  },
  {
    "codigo": "12129300",
    "descricao": "-- Cana-de-açúcar"
  },
  {
    "codigo": "12129400",
    "descricao": "-- Raízes de chicória"
  },
  {
    "codigo": "12129910",
    "descricao": "Estévia (<i>Ka'a He'ẽ</i>) (<i>Stevia rebaudiana</i>)"
  },
  {
    "codigo": "12129990",
    "descricao": "Outros"
  },
  {
    "codigo": "12130000",
    "descricao": "Palhas e cascas de cereais, em bruto, mesmo picadas, moídas, prensadas ou em <i>pellets</i>."
  },
  {
    "codigo": "12141000",
    "descricao": "- Farinha e <i>pellets</i>, de alfafa (luzerna)"
  },
  {
    "codigo": "12149000",
    "descricao": "- Outros"
  },
  {
    "codigo": "13012000",
    "descricao": "- Goma-arábica"
  },
  {
    "codigo": "13019010",
    "descricao": "Goma-laca"
  },
  {
    "codigo": "13019090",
    "descricao": "Outros"
  },
  {
    "codigo": "13021110",
    "descricao": "Concentrados de palha de papoula"
  },
  {
    "codigo": "13021190",
    "descricao": "Outros"
  },
  {
    "codigo": "13021200",
    "descricao": "-- De alcaçuz (regoliz)"
  },
  {
    "codigo": "13021300",
    "descricao": "-- De lúpulo"
  },
  {
    "codigo": "13021400",
    "descricao": "-- De éfedra"
  },
  {
    "codigo": "13021910",
    "descricao": "De mamão (<i>Carica papaya</i>), seco"
  },
  {
    "codigo": "13021920",
    "descricao": "De semente de toranja; de semente de pomelo"
  },
  {
    "codigo": "13021930",
    "descricao": "De <i>Ginkgo biloba</i>, seco"
  },
  {
    "codigo": "13021940",
    "descricao": "Valepotriatos"
  },
  {
    "codigo": "13021950",
    "descricao": "De ginseng"
  },
  {
    "codigo": "13021960",
    "descricao": "Silimarina"
  },
  {
    "codigo": "13021991",
    "descricao": "De píretro ou de raízes de plantas que contenham rotenona"
  },
  {
    "codigo": "13021999",
    "descricao": "Outros"
  },
  {
    "codigo": "13022010",
    "descricao": "Matérias pécticas (pectinas)"
  },
  {
    "codigo": "13022090",
    "descricao": "Outros"
  },
  {
    "codigo": "13023100",
    "descricao": "-- Ágar-ágar"
  },
  {
    "codigo": "13023211",
    "descricao": "Farinha de endosperma"
  },
  {
    "codigo": "13023219",
    "descricao": "Outros"
  },
  {
    "codigo": "13023220",
    "descricao": "De sementes de guar"
  },
  {
    "codigo": "13023910",
    "descricao": "Carragenina (musgo-de-irlanda)"
  },
  {
    "codigo": "13023990",
    "descricao": "Outros"
  },
  {
    "codigo": "14011000",
    "descricao": "- Bambus"
  },
  {
    "codigo": "14012000",
    "descricao": "- Rotins"
  },
  {
    "codigo": "14019000",
    "descricao": "- Outras"
  },
  {
    "codigo": "14042010",
    "descricao": "Em bruto"
  },
  {
    "codigo": "14042090",
    "descricao": "Outros"
  },
  {
    "codigo": "14049010",
    "descricao": "Matérias vegetais das espécies principalmente utilizadas na fabricação de vassouras, escovas, pincéis e artigos semelhantes (por exemplo, sorgo, piaçaba, raiz de grama (relva), tampico), mesmo em torcidas ou em feixes"
  },
  {
    "codigo": "14049090",
    "descricao": "Outros"
  },
  {
    "codigo": "15011000",
    "descricao": "- Banha"
  },
  {
    "codigo": "15012000",
    "descricao": "- Outras gorduras de porco"
  },
  {
    "codigo": "15019000",
    "descricao": "- Outras"
  },
  {
    "codigo": "15021011",
    "descricao": "Em bruto"
  },
  {
    "codigo": "15021012",
    "descricao": "Fundido (incluindo o <i>premier jus</i>)"
  },
  {
    "codigo": "15021019",
    "descricao": "Outros"
  },
  {
    "codigo": "15021090",
    "descricao": "Outros"
  },
  {
    "codigo": "15029000",
    "descricao": "- Outras"
  },
  {
    "codigo": "15030000",
    "descricao": "Estearina solar, óleo de banha de porco, oleoestearina, oleomargarina e óleo de sebo, não emulsionados nem misturados, nem preparados de outro modo."
  },
  {
    "codigo": "15041011",
    "descricao": "Óleo em bruto"
  },
  {
    "codigo": "15041019",
    "descricao": "Outros"
  },
  {
    "codigo": "15041090",
    "descricao": "Outros"
  },
  {
    "codigo": "15042000",
    "descricao": "- Gorduras e óleos de peixes e respectivas frações, exceto óleos de fígados"
  },
  {
    "codigo": "15043000",
    "descricao": "- Gorduras e óleos de mamíferos marinhos e respectivas frações"
  },
  {
    "codigo": "15050010",
    "descricao": "Lanolina"
  },
  {
    "codigo": "15050090",
    "descricao": "Outras"
  },
  {
    "codigo": "15060000",
    "descricao": "Outras gorduras e óleos animais, e respectivas frações, mesmo refinados, mas não quimicamente modificados."
  },
  {
    "codigo": "15071000",
    "descricao": "- Óleo em bruto, mesmo degomado"
  },
  {
    "codigo": "15079011",
    "descricao": "Em recipientes com capacidade inferior ou igual a 5 l"
  },
  {
    "codigo": "15079019",
    "descricao": "Outros"
  },
  {
    "codigo": "15079090",
    "descricao": "Outros"
  },
  {
    "codigo": "15081000",
    "descricao": "- Óleo em bruto"
  },
  {
    "codigo": "15089000",
    "descricao": "- Outros"
  },
  {
    "codigo": "15092000",
    "descricao": "- Azeite de oliva (oliveira) extra virgem"
  },
  {
    "codigo": "15093000",
    "descricao": "- Azeite de oliva (oliveira) virgem"
  },
  {
    "codigo": "15094000",
    "descricao": "- Outros azeites de oliva (oliveira) virgens"
  },
  {
    "codigo": "15099010",
    "descricao": "Refinado"
  },
  {
    "codigo": "15099090",
    "descricao": "Outros"
  },
  {
    "codigo": "15101000",
    "descricao": "- Óleo de bagaço de azeitona em bruto"
  },
  {
    "codigo": "15109000",
    "descricao": "- Outros"
  },
  {
    "codigo": "15111000",
    "descricao": "- Óleo em bruto"
  },
  {
    "codigo": "15119000",
    "descricao": "- Outros"
  },
  {
    "codigo": "15121110",
    "descricao": "De girassol"
  },
  {
    "codigo": "15121120",
    "descricao": "De cártamo"
  },
  {
    "codigo": "15121911",
    "descricao": "Refinado, em recipientes com capacidade inferior ou igual a 5 l"
  },
  {
    "codigo": "15121919",
    "descricao": "Outros"
  },
  {
    "codigo": "15121920",
    "descricao": "De cártamo"
  },
  {
    "codigo": "15122100",
    "descricao": "-- Óleo em bruto, mesmo desprovido de gossipol"
  },
  {
    "codigo": "15122910",
    "descricao": "Refinado"
  },
  {
    "codigo": "15122990",
    "descricao": "Outros"
  },
  {
    "codigo": "15131100",
    "descricao": "-- Óleo em bruto"
  },
  {
    "codigo": "15131900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "15132111",
    "descricao": "De coco <i>mbocaya</i> (<i>Acrocomia</i><i> </i><i>totai</i>)"
  },
  {
    "codigo": "15132119",
    "descricao": "Outros"
  },
  {
    "codigo": "15132120",
    "descricao": "De babaçu"
  },
  {
    "codigo": "15132911",
    "descricao": "De coco <i>mbocaya</i> (<i>Acrocomia</i><i> </i><i>totai</i>)"
  },
  {
    "codigo": "15132919",
    "descricao": "Outros"
  },
  {
    "codigo": "15132920",
    "descricao": "De babaçu"
  },
  {
    "codigo": "15141100",
    "descricao": "-- Óleos em bruto"
  },
  {
    "codigo": "15141910",
    "descricao": "Refinados"
  },
  {
    "codigo": "15141990",
    "descricao": "Outros"
  },
  {
    "codigo": "15149100",
    "descricao": "-- Óleos em bruto"
  },
  {
    "codigo": "15149910",
    "descricao": "Refinados"
  },
  {
    "codigo": "15149990",
    "descricao": "Outros"
  },
  {
    "codigo": "15151100",
    "descricao": "-- Óleo em bruto"
  },
  {
    "codigo": "15151900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "15152100",
    "descricao": "-- Óleo em bruto"
  },
  {
    "codigo": "15152910",
    "descricao": "Refinado, em recipientes com capacidade inferior ou igual a 5 l"
  },
  {
    "codigo": "15152990",
    "descricao": "Outros"
  },
  {
    "codigo": "15153000",
    "descricao": "- Óleo de rícino (mamona) e respectivas frações"
  },
  {
    "codigo": "15155000",
    "descricao": "- Óleo de gergelim (sésamo) e respectivas frações"
  },
  {
    "codigo": "15156000",
    "descricao": "- Gorduras e óleos de origem microbiana e respectivas frações"
  },
  {
    "codigo": "15159010",
    "descricao": "Óleo de jojoba e respectivas frações"
  },
  {
    "codigo": "15159021",
    "descricao": "Em bruto"
  },
  {
    "codigo": "15159022",
    "descricao": "Refinado"
  },
  {
    "codigo": "15159090",
    "descricao": "Outros"
  },
  {
    "codigo": "15161000",
    "descricao": "- Gorduras e óleos animais e respectivas frações"
  },
  {
    "codigo": "15162000",
    "descricao": "- Gorduras e óleos vegetais e respectivas frações"
  },
  {
    "codigo": "15163000",
    "descricao": "- Gorduras e óleos de origem microbiana e respectivas frações"
  },
  {
    "codigo": "15171000",
    "descricao": "- Margarina, exceto a margarina líquida"
  },
  {
    "codigo": "15179010",
    "descricao": "Misturas de óleos refinados, em recipientes com capacidade inferior ou igual a 5 l"
  },
  {
    "codigo": "15179090",
    "descricao": "Outras"
  },
  {
    "codigo": "15180010",
    "descricao": "Óleo vegetal epoxidado"
  },
  {
    "codigo": "15180090",
    "descricao": "Outros"
  },
  {
    "codigo": "15200010",
    "descricao": "Glicerol em bruto"
  },
  {
    "codigo": "15200020",
    "descricao": "Águas e lixívias, glicéricas"
  },
  {
    "codigo": "15211000",
    "descricao": "- Ceras vegetais"
  },
  {
    "codigo": "15219011",
    "descricao": "Em bruto"
  },
  {
    "codigo": "15219019",
    "descricao": "Outras"
  },
  {
    "codigo": "15219090",
    "descricao": "Outros"
  },
  {
    "codigo": "15220000",
    "descricao": "<i>Dégras</i>; resíduos provenientes do tratamento das substâncias gordas ou das ceras animais ou vegetais."
  },
  {
    "codigo": "16010000",
    "descricao": "Enchidos e produtos semelhantes, de carne, miudezas, sangue ou de insetos; preparações alimentícias à base desses produtos."
  },
  {
    "codigo": "16021000",
    "descricao": "- Preparações homogeneizadas"
  },
  {
    "codigo": "16022000",
    "descricao": "- De fígados de quaisquer animais"
  },
  {
    "codigo": "16023100",
    "descricao": "-- De peruas e de perus"
  },
  {
    "codigo": "16023210",
    "descricao": "Com conteúdo de carne ou de miudezas igual ou superior a 57 %, em peso, não cozidas"
  },
  {
    "codigo": "16023220",
    "descricao": "Com conteúdo de carne ou de miudezas igual ou superior a 57 %, em peso, cozidas"
  },
  {
    "codigo": "16023230",
    "descricao": "Com conteúdo de carne ou de miudezas igual ou superior a 25 % e inferior a 57 %, em peso"
  },
  {
    "codigo": "16023290",
    "descricao": "Outras"
  },
  {
    "codigo": "16023900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "16024100",
    "descricao": "-- Pernas e respectivos pedaços"
  },
  {
    "codigo": "16024200",
    "descricao": "-- Pás e respectivos pedaços"
  },
  {
    "codigo": "16024900",
    "descricao": "-- Outras, incluindo as misturas"
  },
  {
    "codigo": "16025000",
    "descricao": "- Da espécie bovina"
  },
  {
    "codigo": "16029000",
    "descricao": "- Outras, incluindo as preparações de sangue de quaisquer animais"
  },
  {
    "codigo": "16030000",
    "descricao": "Extratos e sucos de carne, peixes ou crustáceos, moluscos ou de outros invertebrados aquáticos."
  },
  {
    "codigo": "16041100",
    "descricao": "-- Salmões"
  },
  {
    "codigo": "16041200",
    "descricao": "-- Arenques"
  },
  {
    "codigo": "16041310",
    "descricao": "Sardinhas"
  },
  {
    "codigo": "16041390",
    "descricao": "Outros"
  },
  {
    "codigo": "16041410",
    "descricao": "Atuns"
  },
  {
    "codigo": "16041420",
    "descricao": "Bonito-listrado"
  },
  {
    "codigo": "16041430",
    "descricao": "Bonito-cachorro"
  },
  {
    "codigo": "16041500",
    "descricao": "-- Cavalinhas (Sardas e cavalas*)"
  },
  {
    "codigo": "16041600",
    "descricao": "-- Anchovas (Biqueirões*)"
  },
  {
    "codigo": "16041700",
    "descricao": "-- Enguias"
  },
  {
    "codigo": "16041800",
    "descricao": "-- Barbatanas de tubarão"
  },
  {
    "codigo": "16041900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "16042010",
    "descricao": "De atuns"
  },
  {
    "codigo": "16042020",
    "descricao": "De bonito-listrado"
  },
  {
    "codigo": "16042030",
    "descricao": "De sardinhas ou de anchoveta"
  },
  {
    "codigo": "16042090",
    "descricao": "Outras"
  },
  {
    "codigo": "16043100",
    "descricao": "-- Caviar"
  },
  {
    "codigo": "16043200",
    "descricao": "-- Sucedâneos do caviar"
  },
  {
    "codigo": "16051000",
    "descricao": "- Caranguejos"
  },
  {
    "codigo": "16052100",
    "descricao": "-- Não acondicionados em recipientes hermeticamente fechados"
  },
  {
    "codigo": "16052900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "16053000",
    "descricao": "- Lavagantes"
  },
  {
    "codigo": "16054000",
    "descricao": "- Outros crustáceos"
  },
  {
    "codigo": "16055100",
    "descricao": "-- Ostras"
  },
  {
    "codigo": "16055200",
    "descricao": "-- Vieiras, incluindo a americana"
  },
  {
    "codigo": "16055300",
    "descricao": "-- Mexilhões"
  },
  {
    "codigo": "16055400",
    "descricao": "-- Sépias e lulas (Chocos e lulas*) (Chocos, chopos, potas e lulas*)"
  },
  {
    "codigo": "16055500",
    "descricao": "-- Polvos"
  },
  {
    "codigo": "16055600",
    "descricao": "-- Amêijoas, berbigões e arcas"
  },
  {
    "codigo": "16055700",
    "descricao": "-- Abalones (Orelhas-do-mar*)"
  },
  {
    "codigo": "16055800",
    "descricao": "-- Caracóis, exceto os do mar"
  },
  {
    "codigo": "16055900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "16056100",
    "descricao": "-- Pepinos-do-mar"
  },
  {
    "codigo": "16056200",
    "descricao": "-- Ouriços-do-mar"
  },
  {
    "codigo": "16056300",
    "descricao": "-- Medusas (águas-vivas)"
  },
  {
    "codigo": "16056900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "17011200",
    "descricao": "-- De beterraba"
  },
  {
    "codigo": "17011300",
    "descricao": "-- Açúcar de cana mencionado na Nota de subposição 2 do presente Capítulo"
  },
  {
    "codigo": "17011400",
    "descricao": "-- Outros açúcares de cana"
  },
  {
    "codigo": "17019100",
    "descricao": "-- Adicionados de aromatizantes ou de corantes"
  },
  {
    "codigo": "17019900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "17021100",
    "descricao": "-- Que contenham, em peso, 99 % ou mais de lactose, expresso em lactose anidra, calculado sobre a matéria seca"
  },
  {
    "codigo": "17021900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "17022000",
    "descricao": "- Açúcar e xarope, de bordo (ácer)"
  },
  {
    "codigo": "17023011",
    "descricao": "Quimicamente pura"
  },
  {
    "codigo": "17023019",
    "descricao": "Outra"
  },
  {
    "codigo": "17023020",
    "descricao": "Xarope de glicose"
  },
  {
    "codigo": "17024010",
    "descricao": "Glicose"
  },
  {
    "codigo": "17024020",
    "descricao": "Xarope de glicose"
  },
  {
    "codigo": "17025000",
    "descricao": "- Frutose (levulose) quimicamente pura"
  },
  {
    "codigo": "17026010",
    "descricao": "Frutose (levulose)"
  },
  {
    "codigo": "17026020",
    "descricao": "Xarope de frutose (levulose)"
  },
  {
    "codigo": "17029000",
    "descricao": "- Outros, incluindo o açúcar invertido e os outros açúcares e xaropes de açúcares, que contenham, em peso, no estado seco, 50 % de frutose (levulose)"
  },
  {
    "codigo": "17031000",
    "descricao": "- Melaços de cana"
  },
  {
    "codigo": "17039000",
    "descricao": "- Outros"
  },
  {
    "codigo": "17041000",
    "descricao": "- Gomas de mascar (pastilhas elásticas), mesmo revestidas de açúcar"
  },
  {
    "codigo": "17049010",
    "descricao": "Chocolate branco"
  },
  {
    "codigo": "17049020",
    "descricao": "Caramelos, confeitos, dropes, pastilhas, e produtos semelhantes"
  },
  {
    "codigo": "17049090",
    "descricao": "Outros"
  },
  {
    "codigo": "18010000",
    "descricao": "Cacau inteiro ou partido, em bruto ou torrado."
  },
  {
    "codigo": "18020000",
    "descricao": "Cascas, películas e outros desperdícios de cacau."
  },
  {
    "codigo": "18031000",
    "descricao": "- Não desengordurada"
  },
  {
    "codigo": "18032000",
    "descricao": "- Total ou parcialmente desengordurada"
  },
  {
    "codigo": "18040000",
    "descricao": "Manteiga, gordura e óleo, de cacau."
  },
  {
    "codigo": "18050000",
    "descricao": "Cacau em pó, sem adição de açúcar ou de outros edulcorantes."
  },
  {
    "codigo": "18061000",
    "descricao": "- Cacau em pó, com adição de açúcar ou de outros edulcorantes"
  },
  {
    "codigo": "18062000",
    "descricao": "- Outras preparações em blocos ou em barras, de peso superior a 2 kg, ou no estado líquido, em pasta, em pó, grânulos ou formas semelhantes, em recipientes ou embalagens imediatas de conteúdo superior a 2 kg"
  },
  {
    "codigo": "18063110",
    "descricao": "Chocolate"
  },
  {
    "codigo": "18063120",
    "descricao": "Outras preparações"
  },
  {
    "codigo": "18063210",
    "descricao": "Chocolate"
  },
  {
    "codigo": "18063220",
    "descricao": "Outras preparações"
  },
  {
    "codigo": "18069000",
    "descricao": "- Outros"
  },
  {
    "codigo": "19011010",
    "descricao": "Leite modificado"
  },
  {
    "codigo": "19011020",
    "descricao": "Farinha láctea"
  },
  {
    "codigo": "19011030",
    "descricao": "À base de farinha, grumos, sêmola ou amido"
  },
  {
    "codigo": "19011090",
    "descricao": "Outras"
  },
  {
    "codigo": "19012010",
    "descricao": "Massa para a preparação de pão, sem adição de grãos ou sementes integrais, congelada"
  },
  {
    "codigo": "19012020",
    "descricao": "Massa para a preparação de pão, com adição de grãos ou sementes integrais, congelada"
  },
  {
    "codigo": "19012090",
    "descricao": "Outras"
  },
  {
    "codigo": "19019010",
    "descricao": "Extrato de malte"
  },
  {
    "codigo": "19019020",
    "descricao": "Doce de leite"
  },
  {
    "codigo": "19019090",
    "descricao": "Outros"
  },
  {
    "codigo": "19021100",
    "descricao": "-- Que contenham ovos"
  },
  {
    "codigo": "19021900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "19022000",
    "descricao": "- Massas alimentícias recheadas (mesmo cozidas ou preparadas de outro modo)"
  },
  {
    "codigo": "19023000",
    "descricao": "- Outras massas alimentícias"
  },
  {
    "codigo": "19024000",
    "descricao": "- Cuscuz"
  },
  {
    "codigo": "19030000",
    "descricao": "Tapioca e seus sucedâneos preparados a partir de féculas, em flocos, grumos, grãos, pérolas ou formas semelhantes."
  },
  {
    "codigo": "19041000",
    "descricao": "- Produtos à base de cereais, obtidos por expansão ou por torrefação"
  },
  {
    "codigo": "19042000",
    "descricao": "- Preparações alimentícias obtidas a partir de flocos de cereais não torrados ou de misturas de flocos de cereais não torrados com flocos de cereais torrados ou expandidos"
  },
  {
    "codigo": "19043000",
    "descricao": "- Trigo <i>bulgur</i>"
  },
  {
    "codigo": "19049000",
    "descricao": "- Outros"
  },
  {
    "codigo": "19051000",
    "descricao": "- Pão crocante denominado <i>knäckebrot</i>"
  },
  {
    "codigo": "19052010",
    "descricao": "Panetone"
  },
  {
    "codigo": "19052090",
    "descricao": "Outros"
  },
  {
    "codigo": "19053100",
    "descricao": "-- Bolachas e biscoitos, adicionados de edulcorantes"
  },
  {
    "codigo": "19053200",
    "descricao": "-- <i>Waffles</i> e <i>wafers</i>"
  },
  {
    "codigo": "19054000",
    "descricao": "- Torradas (tostas), pão torrado e produtos semelhantes torrados"
  },
  {
    "codigo": "19059010",
    "descricao": "Pão de forma"
  },
  {
    "codigo": "19059020",
    "descricao": "Bolachas e biscoitos"
  },
  {
    "codigo": "19059090",
    "descricao": "Outros"
  },
  {
    "codigo": "20011000",
    "descricao": "- Pepinos e pepininhos (<i>cornichons</i>)"
  },
  {
    "codigo": "20019000",
    "descricao": "- Outros"
  },
  {
    "codigo": "20021000",
    "descricao": "- Tomates inteiros ou em pedaços"
  },
  {
    "codigo": "20029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "20031000",
    "descricao": "- Cogumelos do gênero <i>Agaricus</i>"
  },
  {
    "codigo": "20039000",
    "descricao": "- Outros"
  },
  {
    "codigo": "20041000",
    "descricao": "- Batatas"
  },
  {
    "codigo": "20049000",
    "descricao": "- Outros produtos hortícolas e misturas de produtos hortícolas"
  },
  {
    "codigo": "20051000",
    "descricao": "- Produtos hortícolas homogeneizados"
  },
  {
    "codigo": "20052000",
    "descricao": "- Batatas"
  },
  {
    "codigo": "20054000",
    "descricao": "- Ervilhas (<i>Pisum sativum</i>)"
  },
  {
    "codigo": "20055100",
    "descricao": "-- Feijões em grãos"
  },
  {
    "codigo": "20055900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "20056000",
    "descricao": "- Aspargos"
  },
  {
    "codigo": "20057000",
    "descricao": "- Azeitonas"
  },
  {
    "codigo": "20058000",
    "descricao": "- Milho doce (<i>Zea mays</i> var. <i>saccharata</i>)"
  },
  {
    "codigo": "20059100",
    "descricao": "-- Brotos (rebentos) de bambu"
  },
  {
    "codigo": "20059900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "20060000",
    "descricao": "Produtos hortícolas, fruta, cascas de fruta e outras partes de plantas, conservados com açúcar (passados por calda, glaçados ou cristalizados)."
  },
  {
    "codigo": "20071000",
    "descricao": "- Preparações homogeneizadas"
  },
  {
    "codigo": "20079100",
    "descricao": "-- De citros (citrinos)"
  },
  {
    "codigo": "20079910",
    "descricao": "Geleias e <i>marmelades</i>"
  },
  {
    "codigo": "20079921",
    "descricao": "De açaí (<i>Euterpe oleracea</i>)"
  },
  {
    "codigo": "20079922",
    "descricao": "De acerola (<i>Malpighia</i> spp.)"
  },
  {
    "codigo": "20079923",
    "descricao": "De banana (<i>Musa</i> spp.)"
  },
  {
    "codigo": "20079924",
    "descricao": "De goiaba (<i>Psidium guajava</i>)"
  },
  {
    "codigo": "20079925",
    "descricao": "De manga (<i>Mangifera indica</i>)"
  },
  {
    "codigo": "20079926",
    "descricao": "De cupuaçu (<i>Theobroma grandiflorum</i>)"
  },
  {
    "codigo": "20079927",
    "descricao": "De mamão (papaia) (<i>Carica papaya L.</i>)"
  },
  {
    "codigo": "20079929",
    "descricao": "Outros"
  },
  {
    "codigo": "20079990",
    "descricao": "Outros"
  },
  {
    "codigo": "20081100",
    "descricao": "-- Amendoins"
  },
  {
    "codigo": "20081900",
    "descricao": "-- Outros, incluindo as misturas"
  },
  {
    "codigo": "20082010",
    "descricao": "Em água edulcorada, incluindo os xaropes"
  },
  {
    "codigo": "20082090",
    "descricao": "Outros"
  },
  {
    "codigo": "20083000",
    "descricao": "- Citros (citrinos)"
  },
  {
    "codigo": "20084010",
    "descricao": "Em água edulcorada, incluindo os xaropes"
  },
  {
    "codigo": "20084090",
    "descricao": "Outras"
  },
  {
    "codigo": "20085000",
    "descricao": "- Damascos"
  },
  {
    "codigo": "20086010",
    "descricao": "Em água edulcorada, incluindo os xaropes"
  },
  {
    "codigo": "20086090",
    "descricao": "Outras"
  },
  {
    "codigo": "20087010",
    "descricao": "Em água edulcorada, incluindo os xaropes"
  },
  {
    "codigo": "20087020",
    "descricao": "Polpa com valor Brix igual ou superior a 20"
  },
  {
    "codigo": "20087090",
    "descricao": "Outros"
  },
  {
    "codigo": "20088000",
    "descricao": "- Morangos"
  },
  {
    "codigo": "20089100",
    "descricao": "-- Palmitos"
  },
  {
    "codigo": "20089300",
    "descricao": "-- Arandos vermelhos (<i>cranberries</i>) (<i>Vaccinium macrocarpon</i>, <i>Vaccinium oxycoccos</i>); airela vermelha (<i>Vaccinium vitis-idaea</i>)"
  },
  {
    "codigo": "20089710",
    "descricao": "Em água edulcorada, incluindo os xaropes"
  },
  {
    "codigo": "20089790",
    "descricao": "Outras"
  },
  {
    "codigo": "20089900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "20091100",
    "descricao": "-- Congelado"
  },
  {
    "codigo": "20091200",
    "descricao": "-- Não congelado, com valor Brix não superior a 20"
  },
  {
    "codigo": "20091900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "20092100",
    "descricao": "-- Com valor Brix não superior a 20"
  },
  {
    "codigo": "20092900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "20093100",
    "descricao": "-- Com valor Brix não superior a 20"
  },
  {
    "codigo": "20093900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "20094100",
    "descricao": "-- Com valor Brix não superior a 20"
  },
  {
    "codigo": "20094900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "20095000",
    "descricao": "- Suco (sumo) de tomate"
  },
  {
    "codigo": "20096100",
    "descricao": "-- Com valor Brix não superior a 30"
  },
  {
    "codigo": "20096900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "20097100",
    "descricao": "-- Com valor Brix não superior a 20"
  },
  {
    "codigo": "20097900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "20098100",
    "descricao": "-- Suco (sumo) de arando vermelho (<i>cranberry</i>) (<i>Vaccinium macrocarpon</i>, <i>Vaccinium oxycoccos</i>); suco (sumo) de airela vermelha (<i>Vaccinium vitis-idaea</i>)"
  },
  {
    "codigo": "20098911",
    "descricao": "De pêssego, com valor Brix igual ou superior a 60"
  },
  {
    "codigo": "20098912",
    "descricao": "De acerola (<i>Malpighia</i> spp.)"
  },
  {
    "codigo": "20098913",
    "descricao": "De maracujá (<i>Passiflora edulis</i>)"
  },
  {
    "codigo": "20098919",
    "descricao": "Outros"
  },
  {
    "codigo": "20098921",
    "descricao": "Com valor Brix não superior a 7,4"
  },
  {
    "codigo": "20098922",
    "descricao": "Com valor Brix superior a 7,4"
  },
  {
    "codigo": "20098990",
    "descricao": "Outros"
  },
  {
    "codigo": "20099000",
    "descricao": "- Misturas de sucos (sumos)"
  },
  {
    "codigo": "21011110",
    "descricao": "Café solúvel, mesmo descafeinado"
  },
  {
    "codigo": "21011190",
    "descricao": "Outros"
  },
  {
    "codigo": "21011200",
    "descricao": "-- Preparações à base de extratos, essências ou concentrados ou à base de café"
  },
  {
    "codigo": "21012010",
    "descricao": "De chá"
  },
  {
    "codigo": "21012020",
    "descricao": "De mate"
  },
  {
    "codigo": "21013000",
    "descricao": "- Chicória torrada e outros sucedâneos torrados do café e respectivos extratos, essências e concentrados"
  },
  {
    "codigo": "21021010",
    "descricao": "<i>Saccharomyces boulardii</i>"
  },
  {
    "codigo": "21021090",
    "descricao": "Outras"
  },
  {
    "codigo": "21022000",
    "descricao": "- Leveduras mortas; outros microrganismos monocelulares mortos"
  },
  {
    "codigo": "21023000",
    "descricao": "- Pós para levedar, preparados"
  },
  {
    "codigo": "21031010",
    "descricao": "Em embalagens imediatas de conteúdo inferior ou igual a 1 kg"
  },
  {
    "codigo": "21031090",
    "descricao": "Outros"
  },
  {
    "codigo": "21032010",
    "descricao": "Em embalagens imediatas de conteúdo inferior ou igual a 1 kg"
  },
  {
    "codigo": "21032090",
    "descricao": "Outros"
  },
  {
    "codigo": "21033010",
    "descricao": "Farinha de mostarda"
  },
  {
    "codigo": "21033021",
    "descricao": "Em embalagens imediatas de conteúdo inferior ou igual a 1 kg"
  },
  {
    "codigo": "21033029",
    "descricao": "Outras"
  },
  {
    "codigo": "21039011",
    "descricao": "Em embalagens imediatas de conteúdo inferior ou igual a 1 kg"
  },
  {
    "codigo": "21039019",
    "descricao": "Outra"
  },
  {
    "codigo": "21039021",
    "descricao": "Em embalagens imediatas de conteúdo inferior ou igual a 1 kg"
  },
  {
    "codigo": "21039029",
    "descricao": "Outros"
  },
  {
    "codigo": "21039091",
    "descricao": "Em embalagens imediatas de conteúdo inferior ou igual a 1 kg"
  },
  {
    "codigo": "21039099",
    "descricao": "Outros"
  },
  {
    "codigo": "21041011",
    "descricao": "Em embalagens imediatas de conteúdo inferior ou igual a 1 kg"
  },
  {
    "codigo": "21041019",
    "descricao": "Outras"
  },
  {
    "codigo": "21041021",
    "descricao": "Em embalagens imediatas de conteúdo inferior ou igual a 1 kg"
  },
  {
    "codigo": "21041029",
    "descricao": "Outros"
  },
  {
    "codigo": "21042000",
    "descricao": "- Preparações alimentícias compostas homogeneizadas"
  },
  {
    "codigo": "21050010",
    "descricao": "Em embalagens imediatas de conteúdo inferior ou igual a 2 kg"
  },
  {
    "codigo": "21050090",
    "descricao": "Outros"
  },
  {
    "codigo": "21061000",
    "descricao": "- Concentrados de proteínas e substâncias proteicas texturizadas"
  },
  {
    "codigo": "21069010",
    "descricao": "Preparações do tipo utilizado para elaboração de bebidas"
  },
  {
    "codigo": "21069021",
    "descricao": "Para a fabricação de pudins, em embalagens imediatas de conteúdo inferior ou igual a 1 kg"
  },
  {
    "codigo": "21069029",
    "descricao": "Outros"
  },
  {
    "codigo": "21069030",
    "descricao": "Suplementos alimentares"
  },
  {
    "codigo": "21069040",
    "descricao": "Misturas à base de ascorbato de sódio e glucose próprias para embutidos"
  },
  {
    "codigo": "21069050",
    "descricao": "Gomas de mascar, sem açúcar"
  },
  {
    "codigo": "21069060",
    "descricao": "Caramelos, confeitos, pastilhas e produtos semelhantes, sem açúcar"
  },
  {
    "codigo": "21069090",
    "descricao": "Outras"
  },
  {
    "codigo": "22011000",
    "descricao": "- Águas minerais e águas gaseificadas"
  },
  {
    "codigo": "22019000",
    "descricao": "- Outros"
  },
  {
    "codigo": "22021000",
    "descricao": "- Águas, incluindo as águas minerais e as águas gaseificadas, adicionadas de açúcar ou de outros edulcorantes ou aromatizadas"
  },
  {
    "codigo": "22029100",
    "descricao": "-- Cerveja sem álcool"
  },
  {
    "codigo": "22029900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "22030000",
    "descricao": "Cervejas de malte."
  },
  {
    "codigo": "22041010",
    "descricao": "Tipo champanha (<i>champagne</i>)"
  },
  {
    "codigo": "22041090",
    "descricao": "Outros"
  },
  {
    "codigo": "22042100",
    "descricao": "-- Em recipientes de capacidade não superior a 2 l"
  },
  {
    "codigo": "22042211",
    "descricao": "Em recipientes de capacidade não superior a 5 l"
  },
  {
    "codigo": "22042219",
    "descricao": "Outros"
  },
  {
    "codigo": "22042220",
    "descricao": "Mostos"
  },
  {
    "codigo": "22042910",
    "descricao": "Vinhos"
  },
  {
    "codigo": "22042920",
    "descricao": "Mostos"
  },
  {
    "codigo": "22043000",
    "descricao": "- Outros mostos de uvas"
  },
  {
    "codigo": "22051000",
    "descricao": "- Em recipientes de capacidade não superior a 2 l"
  },
  {
    "codigo": "22059000",
    "descricao": "- Outros"
  },
  {
    "codigo": "22060010",
    "descricao": "Sidra"
  },
  {
    "codigo": "22060090",
    "descricao": "Outras"
  },
  {
    "codigo": "22071010",
    "descricao": "Com um teor de água inferior ou igual a 1 % vol."
  },
  {
    "codigo": "22071090",
    "descricao": "Outros"
  },
  {
    "codigo": "22072011",
    "descricao": "Com um teor de água inferior ou igual a 1 % vol."
  },
  {
    "codigo": "22072019",
    "descricao": "Outros"
  },
  {
    "codigo": "22072020",
    "descricao": "Aguardente"
  },
  {
    "codigo": "22082000",
    "descricao": "- Aguardentes de vinho ou de bagaço, de uvas"
  },
  {
    "codigo": "22083010",
    "descricao": "Com um teor alcoólico, em volume, superior a 50 % vol., em recipientes de capacidade igual ou superior a 50 l"
  },
  {
    "codigo": "22083020",
    "descricao": "Em embalagens de capacidade inferior ou igual a 2 l"
  },
  {
    "codigo": "22083090",
    "descricao": "Outros"
  },
  {
    "codigo": "22084000",
    "descricao": "- Rum e outras aguardentes provenientes da destilação, após fermentação, de produtos da cana-de-açúcar"
  },
  {
    "codigo": "22085000",
    "descricao": "- Gim e genebra"
  },
  {
    "codigo": "22086000",
    "descricao": "- Vodca"
  },
  {
    "codigo": "22087000",
    "descricao": "- Licores"
  },
  {
    "codigo": "22089000",
    "descricao": "- Outros"
  },
  {
    "codigo": "22090000",
    "descricao": "Vinagres e seus sucedâneos obtidos a partir do ácido acético, para uso alimentar."
  },
  {
    "codigo": "23011010",
    "descricao": "De carne"
  },
  {
    "codigo": "23011090",
    "descricao": "Outros"
  },
  {
    "codigo": "23012010",
    "descricao": "De peixes"
  },
  {
    "codigo": "23012090",
    "descricao": "Outros"
  },
  {
    "codigo": "23021000",
    "descricao": "- De milho"
  },
  {
    "codigo": "23023010",
    "descricao": "Farelo"
  },
  {
    "codigo": "23023090",
    "descricao": "Outros"
  },
  {
    "codigo": "23024000",
    "descricao": "- De outros cereais"
  },
  {
    "codigo": "23025000",
    "descricao": "- De leguminosas"
  },
  {
    "codigo": "23031000",
    "descricao": "- Resíduos da fabricação do amido e resíduos semelhantes"
  },
  {
    "codigo": "23032000",
    "descricao": "- Polpas de beterraba, bagaços de cana-de-açúcar e outros desperdícios da indústria do açúcar"
  },
  {
    "codigo": "23033000",
    "descricao": "- Borras e desperdícios da indústria da cerveja e das destilarias"
  },
  {
    "codigo": "23040010",
    "descricao": "Farinhas e <i>pellets</i>"
  },
  {
    "codigo": "23040090",
    "descricao": "Outros"
  },
  {
    "codigo": "23050000",
    "descricao": "Tortas (bagaços) e outros resíduos sólidos, mesmo triturados ou em <i>pellets</i>, da extração do óleo de amendoim."
  },
  {
    "codigo": "23061000",
    "descricao": "- De sementes de algodão"
  },
  {
    "codigo": "23062000",
    "descricao": "- De linhaça (sementes de linho)"
  },
  {
    "codigo": "23063010",
    "descricao": "Tortas (bagaços), farinhas e <i>pellets</i>"
  },
  {
    "codigo": "23063090",
    "descricao": "Outros"
  },
  {
    "codigo": "23064100",
    "descricao": "-- Com baixo teor de ácido erúcico"
  },
  {
    "codigo": "23064900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "23065000",
    "descricao": "- De coco ou de copra"
  },
  {
    "codigo": "23066000",
    "descricao": "- De nozes ou de amêndoas de palma (palmiste) (coconote)"
  },
  {
    "codigo": "23069010",
    "descricao": "De germe de milho"
  },
  {
    "codigo": "23069090",
    "descricao": "Outros"
  },
  {
    "codigo": "23070000",
    "descricao": "Borras de vinho; tártaro em bruto."
  },
  {
    "codigo": "23080000",
    "descricao": "Matérias vegetais e desperdícios vegetais, resíduos e subprodutos vegetais, mesmo em <i>pellets</i>, do tipo utilizado na alimentação de animais, não especificados nem compreendidos noutras posições."
  },
  {
    "codigo": "23091000",
    "descricao": "- Alimentos para cães ou gatos, acondicionados para venda a retalho"
  },
  {
    "codigo": "23099010",
    "descricao": "Preparações destinadas a fornecer ao animal a totalidade dos elementos nutritivos necessários para uma alimentação diária racional e equilibrada (alimentos compostos completos)"
  },
  {
    "codigo": "23099020",
    "descricao": "Preparações à base de sal iodado, farinha de ossos, farinha de concha, cobre e cobalto"
  },
  {
    "codigo": "23099030",
    "descricao": "Bolachas e biscoitos"
  },
  {
    "codigo": "23099040",
    "descricao": "Preparações que contenham diclazuril"
  },
  {
    "codigo": "23099050",
    "descricao": "Preparações com um teor de cloridrato de ractopamina igual ou superior a 2 %, em peso, com suporte de farelo de soja"
  },
  {
    "codigo": "23099060",
    "descricao": "Preparações que contenham xilanase e betagluconase, com suporte de farinha de trigo"
  },
  {
    "codigo": "23099070",
    "descricao": "Preparações com um teor de vitamina B<sub>12</sub> igual ou superior a 0,1 %, mas não superior a 1 %, em peso, com suporte à base de carbonato de cálcio"
  },
  {
    "codigo": "23099090",
    "descricao": "Outras"
  },
  {
    "codigo": "24011010",
    "descricao": "Em folhas, sem secar nem fermentar"
  },
  {
    "codigo": "24011020",
    "descricao": "Em folhas secas ou fermentadas tipo capeiro"
  },
  {
    "codigo": "24011030",
    "descricao": "Em folhas secas em secador de ar quente (<i>flue cured</i>), do tipo Virgínia"
  },
  {
    "codigo": "24011040",
    "descricao": "Em folhas secas, com um conteúdo de óleos voláteis superior a 0,2 %, em peso, do tipo turco"
  },
  {
    "codigo": "24011090",
    "descricao": "Outros"
  },
  {
    "codigo": "24012010",
    "descricao": "Em folhas, sem secar nem fermentar"
  },
  {
    "codigo": "24012020",
    "descricao": "Em folhas secas ou fermentadas tipo capeiro"
  },
  {
    "codigo": "24012030",
    "descricao": "Em folhas secas em secador de ar quente (<i>flue cured</i>), do tipo Virgínia"
  },
  {
    "codigo": "24012040",
    "descricao": "Em folhas secas (<i>light air cured</i>), do tipo Burley"
  },
  {
    "codigo": "24012090",
    "descricao": "Outros"
  },
  {
    "codigo": "24013000",
    "descricao": "- Desperdícios de tabaco"
  },
  {
    "codigo": "24021000",
    "descricao": "- Charutos e cigarrilhas, que contenham tabaco"
  },
  {
    "codigo": "24022000",
    "descricao": "- Cigarros que contenham tabaco"
  },
  {
    "codigo": "24029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "24031100",
    "descricao": "-- Tabaco para narguilé (cachimbo de água) mencionado na Nota de subposição 1 do presente Capítulo"
  },
  {
    "codigo": "24031900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "24039100",
    "descricao": "-- Tabaco \"homogeneizado\" ou \"reconstituído\""
  },
  {
    "codigo": "24039910",
    "descricao": "Extratos e molhos"
  },
  {
    "codigo": "24039990",
    "descricao": "Outros"
  },
  {
    "codigo": "24041100",
    "descricao": "-- Que contenham tabaco ou tabaco reconstituído"
  },
  {
    "codigo": "24041200",
    "descricao": "-- Outros, que contenham nicotina"
  },
  {
    "codigo": "24041900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "24049100",
    "descricao": "-- Para aplicação oral"
  },
  {
    "codigo": "24049200",
    "descricao": "-- Para aplicação percutânea"
  },
  {
    "codigo": "24049900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "25010011",
    "descricao": "Sal marinho"
  },
  {
    "codigo": "25010019",
    "descricao": "Outros"
  },
  {
    "codigo": "25010020",
    "descricao": "Sal de mesa"
  },
  {
    "codigo": "25010090",
    "descricao": "Outros"
  },
  {
    "codigo": "25020000",
    "descricao": "Piritas de ferro não ustuladas."
  },
  {
    "codigo": "25030010",
    "descricao": "A granel"
  },
  {
    "codigo": "25030090",
    "descricao": "Outros"
  },
  {
    "codigo": "25041000",
    "descricao": "- Em pó ou em escamas"
  },
  {
    "codigo": "25049000",
    "descricao": "- Outra"
  },
  {
    "codigo": "25051000",
    "descricao": "- Areias siliciosas e areias quartzosas"
  },
  {
    "codigo": "25059000",
    "descricao": "- Outras areias"
  },
  {
    "codigo": "25061000",
    "descricao": "- Quartzo"
  },
  {
    "codigo": "25062000",
    "descricao": "- Quartzitos"
  },
  {
    "codigo": "25070010",
    "descricao": "Caulim (caulino)"
  },
  {
    "codigo": "25070090",
    "descricao": "Outros"
  },
  {
    "codigo": "25081000",
    "descricao": "- Bentonita"
  },
  {
    "codigo": "25083000",
    "descricao": "- Argilas refratárias"
  },
  {
    "codigo": "25084010",
    "descricao": "Plásticas, com um teor de Fe<sub>2</sub>O<sub>3</sub>, em peso, inferior a 1,5 % e com perda por calcinação, em peso, superior a 12 %"
  },
  {
    "codigo": "25084090",
    "descricao": "Outras"
  },
  {
    "codigo": "25085000",
    "descricao": "- Andaluzita, cianita e silimanita"
  },
  {
    "codigo": "25086000",
    "descricao": "- Mulita"
  },
  {
    "codigo": "25087000",
    "descricao": "- Barro cozido em pó (terra de <i>chamotte</i>) e terra de dinas"
  },
  {
    "codigo": "25090000",
    "descricao": "Cré."
  },
  {
    "codigo": "25101010",
    "descricao": "Fosfatos de cálcio naturais"
  },
  {
    "codigo": "25101090",
    "descricao": "Outros"
  },
  {
    "codigo": "25102010",
    "descricao": "Fosfatos de cálcio naturais"
  },
  {
    "codigo": "25102090",
    "descricao": "Outros"
  },
  {
    "codigo": "25111000",
    "descricao": "- Sulfato de bário natural (baritina)"
  },
  {
    "codigo": "25112000",
    "descricao": "- Carbonato de bário natural (witherita)"
  },
  {
    "codigo": "25120000",
    "descricao": "Farinhas siliciosas fósseis (por exemplo, <i>kieselguhr</i>, tripolita, diatomita) e outras terras siliciosas análogas de densidade aparente não superior a 1, mesmo calcinadas."
  },
  {
    "codigo": "25131000",
    "descricao": "- Pedra-pomes"
  },
  {
    "codigo": "25132000",
    "descricao": "- Esmeril, corindo natural, granada natural e outros abrasivos naturais"
  },
  {
    "codigo": "25140000",
    "descricao": "Ardósia, mesmo desbastada ou simplesmente cortada à serra ou por outro meio, em blocos ou placas de forma quadrada ou retangular."
  },
  {
    "codigo": "25151100",
    "descricao": "-- Em bruto ou desbastados"
  },
  {
    "codigo": "25151210",
    "descricao": "Mármores"
  },
  {
    "codigo": "25151220",
    "descricao": "Travertinos"
  },
  {
    "codigo": "25152000",
    "descricao": "- Granitos belgas e outras pedras calcárias de cantaria ou de construção; alabastro"
  },
  {
    "codigo": "25161100",
    "descricao": "-- Em bruto ou desbastado"
  },
  {
    "codigo": "25161200",
    "descricao": "-- Simplesmente cortado à serra ou por outro meio, em blocos ou placas de forma quadrada ou retangular"
  },
  {
    "codigo": "25162000",
    "descricao": "- Arenito (grés)"
  },
  {
    "codigo": "25169000",
    "descricao": "- Outras pedras de cantaria ou de construção"
  },
  {
    "codigo": "25171000",
    "descricao": "- Calhaus, cascalho, pedras britadas, do tipo normalmente utilizado em concreto (betão) ou para empedramento de estradas, de vias férreas ou outros balastros, seixos rolados e sílex, mesmo tratados termicamente"
  },
  {
    "codigo": "25172000",
    "descricao": "- Macadame de escórias de altos-fornos, de outras escórias ou de resíduos industriais semelhantes, mesmo que contenham matérias incluídas na subposição 2517.10"
  },
  {
    "codigo": "25173000",
    "descricao": "- Tarmacadame"
  },
  {
    "codigo": "25174100",
    "descricao": "-- De mármore"
  },
  {
    "codigo": "25174900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "25181000",
    "descricao": "- Dolomita não calcinada nem sinterizada, denominada \"crua\""
  },
  {
    "codigo": "25182000",
    "descricao": "- Dolomita calcinada ou sinterizada"
  },
  {
    "codigo": "25191000",
    "descricao": "- Carbonato de magnésio natural (magnesita)"
  },
  {
    "codigo": "25199010",
    "descricao": "Magnésia eletrofundida"
  },
  {
    "codigo": "25199090",
    "descricao": "Outros"
  },
  {
    "codigo": "25201011",
    "descricao": "Em pedaços irregulares (pedras)"
  },
  {
    "codigo": "25201019",
    "descricao": "Outros"
  },
  {
    "codigo": "25201020",
    "descricao": "Anidrita"
  },
  {
    "codigo": "25202010",
    "descricao": "Moído, apto para uso odontológico"
  },
  {
    "codigo": "25202090",
    "descricao": "Outros"
  },
  {
    "codigo": "25210000",
    "descricao": "Castinas; pedras calcárias utilizadas na fabricação de cal ou de cimento."
  },
  {
    "codigo": "25221000",
    "descricao": "- Cal viva"
  },
  {
    "codigo": "25222000",
    "descricao": "- Cal apagada"
  },
  {
    "codigo": "25223000",
    "descricao": "- Cal hidráulica"
  },
  {
    "codigo": "25231000",
    "descricao": "- Cimentos não pulverizados, denominados <i>clinkers</i>"
  },
  {
    "codigo": "25232100",
    "descricao": "-- Cimentos brancos, mesmo corados artificialmente"
  },
  {
    "codigo": "25232910",
    "descricao": "Cimento comum"
  },
  {
    "codigo": "25232990",
    "descricao": "Outros"
  },
  {
    "codigo": "25233000",
    "descricao": "- Cimentos aluminosos"
  },
  {
    "codigo": "25239000",
    "descricao": "- Outros cimentos hidráulicos"
  },
  {
    "codigo": "25241000",
    "descricao": "- Crocidolita"
  },
  {
    "codigo": "25249000",
    "descricao": "- Outros"
  },
  {
    "codigo": "25251000",
    "descricao": "- Mica em bruto ou clivada em folhas ou lamelas irregulares (<i>splittings</i>)"
  },
  {
    "codigo": "25252000",
    "descricao": "- Mica em pó"
  },
  {
    "codigo": "25253000",
    "descricao": "- Desperdícios de mica"
  },
  {
    "codigo": "25261000",
    "descricao": "- Não triturados nem em pó"
  },
  {
    "codigo": "25262000",
    "descricao": "- Triturados ou em pó"
  },
  {
    "codigo": "25280000",
    "descricao": "Boratos naturais e seus concentrados (calcinados ou não), exceto boratos extraídos de salmouras naturais; ácido bórico natural com um teor máximo de 85 % de H<sub>3</sub>BO<sub>3</sub>, em produto seco."
  },
  {
    "codigo": "25291000",
    "descricao": "- Feldspato"
  },
  {
    "codigo": "25292100",
    "descricao": "-- Que contenha, em peso, 97 % ou menos de fluoreto de cálcio"
  },
  {
    "codigo": "25292200",
    "descricao": "-- Que contenha, em peso, mais de 97 % de fluoreto de cálcio"
  },
  {
    "codigo": "25293000",
    "descricao": "- Leucita; nefelina e nefelina-sienito"
  },
  {
    "codigo": "25301010",
    "descricao": "Perlita"
  },
  {
    "codigo": "25301090",
    "descricao": "Outras"
  },
  {
    "codigo": "25302000",
    "descricao": "- Kieserita, epsomita (sulfatos de magnésio naturais)"
  },
  {
    "codigo": "25309010",
    "descricao": "Espodumênio"
  },
  {
    "codigo": "25309020",
    "descricao": "Areia de zircônio micronizada, própria para a preparação de esmaltes cerâmicos"
  },
  {
    "codigo": "25309030",
    "descricao": "Minerais de metais das terras raras"
  },
  {
    "codigo": "25309040",
    "descricao": "Terras corantes"
  },
  {
    "codigo": "25309090",
    "descricao": "Outras"
  },
  {
    "codigo": "26011100",
    "descricao": "-- Não aglomerados"
  },
  {
    "codigo": "26011210",
    "descricao": "Aglomerados por processo de peletização, de diâmetro igual ou superior a 8 mm, mas não superior a 18 mm"
  },
  {
    "codigo": "26011220",
    "descricao": "Em briquetes de volume igual ou superior a 4 cm³, mas não superior a 60 cm³"
  },
  {
    "codigo": "26011290",
    "descricao": "Outros"
  },
  {
    "codigo": "26012000",
    "descricao": "- Piritas de ferro ustuladas (cinzas de piritas)"
  },
  {
    "codigo": "26020010",
    "descricao": "Aglomerados"
  },
  {
    "codigo": "26020090",
    "descricao": "Outros"
  },
  {
    "codigo": "26030010",
    "descricao": "Sulfetos"
  },
  {
    "codigo": "26030090",
    "descricao": "Outros"
  },
  {
    "codigo": "26040000",
    "descricao": "Minérios de níquel e seus concentrados."
  },
  {
    "codigo": "26050000",
    "descricao": "Minérios de cobalto e seus concentrados."
  },
  {
    "codigo": "26060011",
    "descricao": "Não calcinada"
  },
  {
    "codigo": "26060012",
    "descricao": "Calcinada"
  },
  {
    "codigo": "26060090",
    "descricao": "Outros"
  },
  {
    "codigo": "26070000",
    "descricao": "Minérios de chumbo e seus concentrados."
  },
  {
    "codigo": "26080010",
    "descricao": "Sulfetos"
  },
  {
    "codigo": "26080090",
    "descricao": "Outros"
  },
  {
    "codigo": "26090000",
    "descricao": "Minérios de estanho e seus concentrados."
  },
  {
    "codigo": "26100010",
    "descricao": "Cromita"
  },
  {
    "codigo": "26100090",
    "descricao": "Outros"
  },
  {
    "codigo": "26110000",
    "descricao": "Minérios de tungstênio (volfrâmio) e seus concentrados."
  },
  {
    "codigo": "26121000",
    "descricao": "- Minérios de urânio e seus concentrados"
  },
  {
    "codigo": "26122000",
    "descricao": "- Minérios de tório e seus concentrados"
  },
  {
    "codigo": "26131010",
    "descricao": "Molibdenita"
  },
  {
    "codigo": "26131090",
    "descricao": "Outros"
  },
  {
    "codigo": "26139010",
    "descricao": "Molibdenita"
  },
  {
    "codigo": "26139090",
    "descricao": "Outros"
  },
  {
    "codigo": "26140010",
    "descricao": "Ilmenita"
  },
  {
    "codigo": "26140090",
    "descricao": "Outros"
  },
  {
    "codigo": "26151010",
    "descricao": "Badeleíta"
  },
  {
    "codigo": "26151020",
    "descricao": "Zirconita"
  },
  {
    "codigo": "26151090",
    "descricao": "Outros"
  },
  {
    "codigo": "26159000",
    "descricao": "- Outros"
  },
  {
    "codigo": "26161000",
    "descricao": "- Minérios de prata e seus concentrados"
  },
  {
    "codigo": "26169000",
    "descricao": "- Outros"
  },
  {
    "codigo": "26171000",
    "descricao": "- Minérios de antimônio e seus concentrados"
  },
  {
    "codigo": "26179000",
    "descricao": "- Outros"
  },
  {
    "codigo": "26180000",
    "descricao": "Escória de altos-fornos granulada (areia de escória) proveniente da fabricação de ferro fundido, ferro ou aço."
  },
  {
    "codigo": "26190000",
    "descricao": "Escórias (exceto escória de altos-fornos granulada) e outros desperdícios da fabricação de ferro fundido, ferro ou aço."
  },
  {
    "codigo": "26201100",
    "descricao": "-- Mates de galvanização"
  },
  {
    "codigo": "26201900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "26202100",
    "descricao": "-- Lamas (borras) de gasolina que contenham chumbo e lamas (borras) de compostos antidetonantes que contenham chumbo"
  },
  {
    "codigo": "26202900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "26203000",
    "descricao": "- Que contenham principalmente cobre"
  },
  {
    "codigo": "26204000",
    "descricao": "- Que contenham principalmente alumínio"
  },
  {
    "codigo": "26206000",
    "descricao": "- Que contenham arsênio, mercúrio, tálio ou suas misturas, do tipo utilizado para extração de arsênio ou destes metais ou para fabricação dos seus compostos químicos"
  },
  {
    "codigo": "26209100",
    "descricao": "-- Que contenham antimônio, berílio, cádmio, cromo ou suas misturas"
  },
  {
    "codigo": "26209910",
    "descricao": "Que contenham principalmente titânio"
  },
  {
    "codigo": "26209990",
    "descricao": "Outros"
  },
  {
    "codigo": "26211000",
    "descricao": "- Cinzas e resíduos provenientes da incineração de resíduos municipais"
  },
  {
    "codigo": "26219010",
    "descricao": "Cinzas de origem vegetal"
  },
  {
    "codigo": "26219090",
    "descricao": "Outras"
  },
  {
    "codigo": "27011100",
    "descricao": "-- Antracita"
  },
  {
    "codigo": "27011200",
    "descricao": "-- Hulha betuminosa"
  },
  {
    "codigo": "27011900",
    "descricao": "-- Outras hulhas"
  },
  {
    "codigo": "27012000",
    "descricao": "- Briquetes, bolas em aglomerados e combustíveis sólidos semelhantes, obtidos a partir da hulha"
  },
  {
    "codigo": "27021000",
    "descricao": "- Linhitas, mesmo em pó, mas não aglomeradas"
  },
  {
    "codigo": "27022000",
    "descricao": "- Linhitas aglomeradas"
  },
  {
    "codigo": "27030000",
    "descricao": "Turfa (incluindo a turfa para cama de animais), mesmo aglomerada."
  },
  {
    "codigo": "27040011",
    "descricao": "Com granulometria igual ou superior a 80 mm"
  },
  {
    "codigo": "27040012",
    "descricao": "Com granulometria inferior a 80 mm"
  },
  {
    "codigo": "27040090",
    "descricao": "Outros"
  },
  {
    "codigo": "27050000",
    "descricao": "Gás de hulha, gás de água, gás pobre (gás de ar) e gases semelhantes, exceto gases de petróleo e outros hidrocarbonetos gasosos."
  },
  {
    "codigo": "27060000",
    "descricao": "Alcatrões de hulha, de linhita ou de turfa e outros alcatrões minerais, mesmo desidratados ou parcialmente destilados, incluindo os alcatrões reconstituídos."
  },
  {
    "codigo": "27071000",
    "descricao": "- Benzol (benzeno)"
  },
  {
    "codigo": "27072000",
    "descricao": "- Toluol (tolueno)"
  },
  {
    "codigo": "27073000",
    "descricao": "- Xilol (xilenos)"
  },
  {
    "codigo": "27074000",
    "descricao": "- Naftaleno"
  },
  {
    "codigo": "27075010",
    "descricao": "Misturas que contenham trimetilbenzenos e etiltoluenos, como componentes majoritários"
  },
  {
    "codigo": "27075090",
    "descricao": "Outras"
  },
  {
    "codigo": "27079100",
    "descricao": "-- Óleos de creosoto"
  },
  {
    "codigo": "27079910",
    "descricao": "Cresóis"
  },
  {
    "codigo": "27079990",
    "descricao": "Outros"
  },
  {
    "codigo": "27081000",
    "descricao": "- Breu"
  },
  {
    "codigo": "27082000",
    "descricao": "- Coque de breu"
  },
  {
    "codigo": "27090010",
    "descricao": "De petróleo"
  },
  {
    "codigo": "27090090",
    "descricao": "Outros"
  },
  {
    "codigo": "27101210",
    "descricao": "Hexano comercial"
  },
  {
    "codigo": "27101221",
    "descricao": "Di-isobutileno"
  },
  {
    "codigo": "27101229",
    "descricao": "Outras"
  },
  {
    "codigo": "27101230",
    "descricao": "Aguarrás mineral (<i>white spirit</i>)"
  },
  {
    "codigo": "27101241",
    "descricao": "Para petroquímica"
  },
  {
    "codigo": "27101249",
    "descricao": "Outras"
  },
  {
    "codigo": "27101251",
    "descricao": "De aviação"
  },
  {
    "codigo": "27101259",
    "descricao": "Outras"
  },
  {
    "codigo": "27101260",
    "descricao": "Mistura de hidrocarbonetos acíclicos e cíclicos, saturados, derivados de frações de petróleo, que contenha, em peso, menos de 2 %, de hidrocarbonetos aromáticos, cuja curva de destilação, segundo o método ISO 3405 (equivalente ao método ASTM D 86), apresenta um ponto inicial mínimo de 70 °C e uma fração de destilado igual ou superior a 90 %, em volume, a 210 °C"
  },
  {
    "codigo": "27101290",
    "descricao": "Outros"
  },
  {
    "codigo": "27101911",
    "descricao": "De aviação"
  },
  {
    "codigo": "27101919",
    "descricao": "Outros"
  },
  {
    "codigo": "27101921",
    "descricao": "\"Gasóleo\" (óleo diesel)"
  },
  {
    "codigo": "27101922",
    "descricao": "<i>Fuel-oil</i>"
  },
  {
    "codigo": "27101929",
    "descricao": "Outros"
  },
  {
    "codigo": "27101931",
    "descricao": "Sem aditivos"
  },
  {
    "codigo": "27101932",
    "descricao": "Com aditivos"
  },
  {
    "codigo": "27101991",
    "descricao": "Óleos minerais brancos (óleos de vaselina ou de parafina)"
  },
  {
    "codigo": "27101992",
    "descricao": "Líquidos para transmissões hidráulicas"
  },
  {
    "codigo": "27101993",
    "descricao": "Óleos para isolamento elétrico"
  },
  {
    "codigo": "27101994",
    "descricao": "Mistura de hidrocarbonetos acíclicos e cíclicos, saturados, derivados de frações de petróleo, que contenha, em peso, menos de 2 %, de hidrocarbonetos aromáticos, que destila, segundo o método ISO 3405 (equivalente ao método ASTM D 86), uma fração inferior a 90 %, em volume, a 210 °C com um ponto final máximo de 360 °C"
  },
  {
    "codigo": "27101999",
    "descricao": "Outros"
  },
  {
    "codigo": "27102000",
    "descricao": "- Óleos de petróleo ou de minerais betuminosos (exceto óleos brutos) e preparações não especificadas nem compreendidas noutras posições, que contenham, como constituintes básicos, 70 % ou mais, em peso, de óleos de petróleo ou de minerais betuminosos, que contenham biodiesel, exceto os resíduos de óleos"
  },
  {
    "codigo": "27109110",
    "descricao": "Que contenham bifenilas policloradas (PCB) numa concentração igual ou superior a 50 mg/kg"
  },
  {
    "codigo": "27109120",
    "descricao": "Outros, que contenham terfenilas policloradas (PCT) ou bifenilas polibromadas (PBB), mesmo que também contenham bifenilas policloradas (PCB) numa concentração inferior a 50 mg/kg"
  },
  {
    "codigo": "27109190",
    "descricao": "Outros"
  },
  {
    "codigo": "27109900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "27111100",
    "descricao": "-- Gás natural"
  },
  {
    "codigo": "27111210",
    "descricao": "Bruto"
  },
  {
    "codigo": "27111290",
    "descricao": "Outros"
  },
  {
    "codigo": "27111300",
    "descricao": "-- Butanos"
  },
  {
    "codigo": "27111400",
    "descricao": "-- Etileno, propileno, butileno e butadieno"
  },
  {
    "codigo": "27111910",
    "descricao": "Gás liquefeito de petróleo (GLP)"
  },
  {
    "codigo": "27111990",
    "descricao": "Outros"
  },
  {
    "codigo": "27112100",
    "descricao": "-- Gás natural"
  },
  {
    "codigo": "27112910",
    "descricao": "Butanos"
  },
  {
    "codigo": "27112990",
    "descricao": "Outros"
  },
  {
    "codigo": "27121000",
    "descricao": "- Vaselina"
  },
  {
    "codigo": "27122000",
    "descricao": "- Parafina que contenha, em peso, menos de 0,75 % de óleo"
  },
  {
    "codigo": "27129000",
    "descricao": "- Outros"
  },
  {
    "codigo": "27131100",
    "descricao": "-- Não calcinado"
  },
  {
    "codigo": "27131200",
    "descricao": "-- Calcinado"
  },
  {
    "codigo": "27132000",
    "descricao": "- Betume de petróleo"
  },
  {
    "codigo": "27139000",
    "descricao": "- Outros resíduos dos óleos de petróleo ou de minerais betuminosos"
  },
  {
    "codigo": "27141000",
    "descricao": "- Xistos e areias betuminosos"
  },
  {
    "codigo": "27149000",
    "descricao": "- Outros"
  },
  {
    "codigo": "27150000",
    "descricao": "Misturas betuminosas à base de asfalto ou de betume naturais, de betume de petróleo, de alcatrão mineral ou de breu de alcatrão mineral (por exemplo, mástiques betuminosas e <i>cut-backs</i>)."
  },
  {
    "codigo": "27160000",
    "descricao": "Energia elétrica."
  },
  {
    "codigo": "28011000",
    "descricao": "- Cloro"
  },
  {
    "codigo": "28012010",
    "descricao": "Sublimado"
  },
  {
    "codigo": "28012090",
    "descricao": "Outros"
  },
  {
    "codigo": "28013000",
    "descricao": "- Flúor; bromo"
  },
  {
    "codigo": "28020000",
    "descricao": "Enxofre sublimado ou precipitado; enxofre coloidal."
  },
  {
    "codigo": "28030011",
    "descricao": "Negro de acetileno"
  },
  {
    "codigo": "28030019",
    "descricao": "Outros"
  },
  {
    "codigo": "28030090",
    "descricao": "Outros"
  },
  {
    "codigo": "28041000",
    "descricao": "- Hidrogênio"
  },
  {
    "codigo": "28042100",
    "descricao": "-- Argônio (árgon)"
  },
  {
    "codigo": "28042910",
    "descricao": "Hélio líquido"
  },
  {
    "codigo": "28042990",
    "descricao": "Outros"
  },
  {
    "codigo": "28043000",
    "descricao": "- Nitrogênio (azoto)"
  },
  {
    "codigo": "28044000",
    "descricao": "- Oxigênio"
  },
  {
    "codigo": "28045000",
    "descricao": "- Boro; telúrio"
  },
  {
    "codigo": "28046100",
    "descricao": "-- Que contenha, em peso, pelo menos 99,99 % de silício"
  },
  {
    "codigo": "28046900",
    "descricao": "-- Outro"
  },
  {
    "codigo": "28047010",
    "descricao": "Branco"
  },
  {
    "codigo": "28047020",
    "descricao": "Vermelho ou amorfo"
  },
  {
    "codigo": "28047030",
    "descricao": "Negro"
  },
  {
    "codigo": "28048000",
    "descricao": "- Arsênio"
  },
  {
    "codigo": "28049000",
    "descricao": "- Selênio"
  },
  {
    "codigo": "28051100",
    "descricao": "-- Sódio"
  },
  {
    "codigo": "28051200",
    "descricao": "-- Cálcio"
  },
  {
    "codigo": "28051910",
    "descricao": "Estrôncio"
  },
  {
    "codigo": "28051920",
    "descricao": "Bário"
  },
  {
    "codigo": "28051990",
    "descricao": "Outros"
  },
  {
    "codigo": "28053010",
    "descricao": "Liga de cério, com um teor de ferro inferior ou igual a 5 %, em peso (<i>Mischmetal</i>)"
  },
  {
    "codigo": "28053090",
    "descricao": "Outros"
  },
  {
    "codigo": "28054000",
    "descricao": "- Mercúrio"
  },
  {
    "codigo": "28061010",
    "descricao": "Em estado gasoso ou liquefeito"
  },
  {
    "codigo": "28061020",
    "descricao": "Em solução aquosa"
  },
  {
    "codigo": "28062000",
    "descricao": "- Ácido clorossulfúrico"
  },
  {
    "codigo": "28070010",
    "descricao": "Ácido sulfúrico"
  },
  {
    "codigo": "28070020",
    "descricao": "Ácido sulfúrico fumante (óleum)"
  },
  {
    "codigo": "28080010",
    "descricao": "Ácido nítrico"
  },
  {
    "codigo": "28080020",
    "descricao": "Ácidos sulfonítricos"
  },
  {
    "codigo": "28091000",
    "descricao": "- Pentóxido de difósforo"
  },
  {
    "codigo": "28092011",
    "descricao": "Com um teor de ferro inferior a 750 ppm"
  },
  {
    "codigo": "28092019",
    "descricao": "Outros"
  },
  {
    "codigo": "28092020",
    "descricao": "Ácidos metafosfóricos"
  },
  {
    "codigo": "28092030",
    "descricao": "Ácido pirofosfórico"
  },
  {
    "codigo": "28092090",
    "descricao": "Outros"
  },
  {
    "codigo": "28100010",
    "descricao": "Ácido ortobórico"
  },
  {
    "codigo": "28100090",
    "descricao": "Outros"
  },
  {
    "codigo": "28111100",
    "descricao": "-- Fluoreto de hidrogênio (ácido fluorídrico)"
  },
  {
    "codigo": "28111200",
    "descricao": "-- Cianeto de hidrogênio (ácido cianídrico ou ácido hidrociânico)"
  },
  {
    "codigo": "28111910",
    "descricao": "Ácido aminossulfônico (ácido sulfâmico)"
  },
  {
    "codigo": "28111920",
    "descricao": "Ácido fosfônico (ácido fosforoso)"
  },
  {
    "codigo": "28111930",
    "descricao": "Ácido perclórico"
  },
  {
    "codigo": "28111940",
    "descricao": "Fluorácidos e outros compostos de flúor"
  },
  {
    "codigo": "28111990",
    "descricao": "Outros"
  },
  {
    "codigo": "28112100",
    "descricao": "-- Dióxido de carbono"
  },
  {
    "codigo": "28112210",
    "descricao": "Obtido por precipitação química"
  },
  {
    "codigo": "28112220",
    "descricao": "Tipo aerogel"
  },
  {
    "codigo": "28112230",
    "descricao": "Gel de sílica"
  },
  {
    "codigo": "28112290",
    "descricao": "Outros"
  },
  {
    "codigo": "28112910",
    "descricao": "Dióxido de enxofre"
  },
  {
    "codigo": "28112990",
    "descricao": "Outros"
  },
  {
    "codigo": "28121100",
    "descricao": "-- Dicloreto de carbonila (fosgênio)"
  },
  {
    "codigo": "28121200",
    "descricao": "-- Oxicloreto de fósforo"
  },
  {
    "codigo": "28121300",
    "descricao": "-- Tricloreto de fósforo"
  },
  {
    "codigo": "28121400",
    "descricao": "-- Pentacloreto de fósforo"
  },
  {
    "codigo": "28121500",
    "descricao": "-- Monocloreto de enxofre"
  },
  {
    "codigo": "28121600",
    "descricao": "-- Dicloreto de enxofre"
  },
  {
    "codigo": "28121700",
    "descricao": "-- Cloreto de tionila"
  },
  {
    "codigo": "28121911",
    "descricao": "Tricloreto de arsênio"
  },
  {
    "codigo": "28121919",
    "descricao": "Outros"
  },
  {
    "codigo": "28121920",
    "descricao": "Oxicloretos"
  },
  {
    "codigo": "28129000",
    "descricao": "- Outros"
  },
  {
    "codigo": "28131000",
    "descricao": "- Dissulfeto de carbono"
  },
  {
    "codigo": "28139010",
    "descricao": "Pentassulfeto de difósforo"
  },
  {
    "codigo": "28139090",
    "descricao": "Outros"
  },
  {
    "codigo": "28141000",
    "descricao": "- Amoníaco anidro"
  },
  {
    "codigo": "28142000",
    "descricao": "- Amoníaco em solução aquosa (amônia)"
  },
  {
    "codigo": "28151100",
    "descricao": "-- Sólido"
  },
  {
    "codigo": "28151200",
    "descricao": "-- Em solução aquosa (lixívia de soda cáustica)"
  },
  {
    "codigo": "28152000",
    "descricao": "- Hidróxido de potássio (potassa cáustica)"
  },
  {
    "codigo": "28153000",
    "descricao": "- Peróxidos de sódio ou de potássio"
  },
  {
    "codigo": "28161010",
    "descricao": "Hidróxido"
  },
  {
    "codigo": "28161020",
    "descricao": "Peróxido"
  },
  {
    "codigo": "28164010",
    "descricao": "Hidróxido de bário"
  },
  {
    "codigo": "28164090",
    "descricao": "Outros"
  },
  {
    "codigo": "28170010",
    "descricao": "Óxido de zinco (branco de zinco)"
  },
  {
    "codigo": "28170020",
    "descricao": "Peróxido de zinco"
  },
  {
    "codigo": "28181010",
    "descricao": "Branco, que passe através de uma peneira com abertura de malha de 63 micrômetros (mícrons) em proporção superior a 90 %, em peso"
  },
  {
    "codigo": "28181090",
    "descricao": "Outros"
  },
  {
    "codigo": "28182010",
    "descricao": "Alumina calcinada"
  },
  {
    "codigo": "28182090",
    "descricao": "Outros"
  },
  {
    "codigo": "28183000",
    "descricao": "- Hidróxido de alumínio"
  },
  {
    "codigo": "28191000",
    "descricao": "- Trióxido de cromo"
  },
  {
    "codigo": "28199010",
    "descricao": "Óxidos"
  },
  {
    "codigo": "28199020",
    "descricao": "Hidróxidos"
  },
  {
    "codigo": "28201010",
    "descricao": "Com um teor de MnO<sub>2</sub> igual ou superior a 91 %, em peso (manganês eletrolítico)"
  },
  {
    "codigo": "28201090",
    "descricao": "Outros"
  },
  {
    "codigo": "28209010",
    "descricao": "Óxido manganoso"
  },
  {
    "codigo": "28209020",
    "descricao": "Trióxido de dimanganês (sesquióxido de manganês)"
  },
  {
    "codigo": "28209030",
    "descricao": "Tetraóxido de trimanganês (óxido salino de manganês)"
  },
  {
    "codigo": "28209040",
    "descricao": "Heptaóxido de dimanganês (anidrido permangânico)"
  },
  {
    "codigo": "28211011",
    "descricao": "Com um teor de Fe<sub>2</sub>O<sub>3</sub> igual ou superior a 85 %, em peso"
  },
  {
    "codigo": "28211019",
    "descricao": "Outros"
  },
  {
    "codigo": "28211020",
    "descricao": "Óxido ferroso-férrico (óxido magnético de ferro), com um teor de Fe<sub>3</sub>O<sub>4</sub> igual ou superior a 93 %, em peso"
  },
  {
    "codigo": "28211030",
    "descricao": "Hidróxidos de ferro"
  },
  {
    "codigo": "28211090",
    "descricao": "Outros"
  },
  {
    "codigo": "28212000",
    "descricao": "- Terras corantes"
  },
  {
    "codigo": "28220010",
    "descricao": "Tetraóxido de tricobalto (óxido salino de cobalto)"
  },
  {
    "codigo": "28220090",
    "descricao": "Outros"
  },
  {
    "codigo": "28230010",
    "descricao": "Tipo anátase"
  },
  {
    "codigo": "28230090",
    "descricao": "Outros"
  },
  {
    "codigo": "28241000",
    "descricao": "- Monóxido de chumbo (litargírio, massicote)"
  },
  {
    "codigo": "28249010",
    "descricao": "Mínio (zarcão) e mínio-laranja (<i>mine-orange</i>)"
  },
  {
    "codigo": "28249090",
    "descricao": "Outros"
  },
  {
    "codigo": "28251010",
    "descricao": "Hidrazina e seus sais inorgânicos"
  },
  {
    "codigo": "28251020",
    "descricao": "Hidroxilamina e seus sais inorgânicos"
  },
  {
    "codigo": "28252010",
    "descricao": "Óxido"
  },
  {
    "codigo": "28252020",
    "descricao": "Hidróxido"
  },
  {
    "codigo": "28253010",
    "descricao": "Pentóxido de divanádio"
  },
  {
    "codigo": "28253090",
    "descricao": "Outros"
  },
  {
    "codigo": "28254010",
    "descricao": "Óxido niqueloso"
  },
  {
    "codigo": "28254090",
    "descricao": "Outros"
  },
  {
    "codigo": "28255010",
    "descricao": "Óxido cúprico, com um teor de CuO igual ou superior a 98 %, em peso"
  },
  {
    "codigo": "28255090",
    "descricao": "Outros"
  },
  {
    "codigo": "28256010",
    "descricao": "Óxidos de germânio"
  },
  {
    "codigo": "28256020",
    "descricao": "Dióxido de zircônio"
  },
  {
    "codigo": "28257010",
    "descricao": "Trióxido de molibdênio"
  },
  {
    "codigo": "28257090",
    "descricao": "Outros"
  },
  {
    "codigo": "28258010",
    "descricao": "Trióxido de antimônio"
  },
  {
    "codigo": "28258090",
    "descricao": "Outros"
  },
  {
    "codigo": "28259010",
    "descricao": "Óxido de cádmio"
  },
  {
    "codigo": "28259020",
    "descricao": "Trióxido de tungstênio (volfrâmio)"
  },
  {
    "codigo": "28259090",
    "descricao": "Outros"
  },
  {
    "codigo": "28261200",
    "descricao": "-- De alumínio"
  },
  {
    "codigo": "28261910",
    "descricao": "Trifluoreto de cromo"
  },
  {
    "codigo": "28261920",
    "descricao": "Fluoreto ácido de amônio"
  },
  {
    "codigo": "28261990",
    "descricao": "Outros"
  },
  {
    "codigo": "28263000",
    "descricao": "- Hexafluoraluminato de sódio (criolita sintética)"
  },
  {
    "codigo": "28269010",
    "descricao": "Fluoroaluminato de potássio"
  },
  {
    "codigo": "28269020",
    "descricao": "Fluorossilicatos de sódio ou de potássio"
  },
  {
    "codigo": "28269090",
    "descricao": "Outros"
  },
  {
    "codigo": "28271000",
    "descricao": "- Cloreto de amônio"
  },
  {
    "codigo": "28272010",
    "descricao": "Com um teor de CaCl<sub>2</sub> igual ou superior a 98 %, em peso, em base seca"
  },
  {
    "codigo": "28272090",
    "descricao": "Outros"
  },
  {
    "codigo": "28273110",
    "descricao": "Com um teor de MgCl<sub>2</sub> inferior a 98 %, em peso, e de cálcio (Ca) inferior ou igual a 0,5 %, em peso"
  },
  {
    "codigo": "28273190",
    "descricao": "Outros"
  },
  {
    "codigo": "28273200",
    "descricao": "-- De alumínio"
  },
  {
    "codigo": "28273500",
    "descricao": "-- De níquel"
  },
  {
    "codigo": "28273910",
    "descricao": "De cobre I (cloreto cuproso ou monocloreto de cobre)"
  },
  {
    "codigo": "28273920",
    "descricao": "De titânio"
  },
  {
    "codigo": "28273931",
    "descricao": "Anidro, com um teor de ZnCl<sub>2</sub> igual ou superior a 98 %, em peso"
  },
  {
    "codigo": "28273939",
    "descricao": "Outros"
  },
  {
    "codigo": "28273940",
    "descricao": "De zircônio"
  },
  {
    "codigo": "28273950",
    "descricao": "De antimônio"
  },
  {
    "codigo": "28273960",
    "descricao": "De lítio"
  },
  {
    "codigo": "28273970",
    "descricao": "De bismuto"
  },
  {
    "codigo": "28273991",
    "descricao": "De cádmio"
  },
  {
    "codigo": "28273992",
    "descricao": "De césio"
  },
  {
    "codigo": "28273993",
    "descricao": "De cromo"
  },
  {
    "codigo": "28273994",
    "descricao": "De estrôncio"
  },
  {
    "codigo": "28273995",
    "descricao": "De manganês"
  },
  {
    "codigo": "28273996",
    "descricao": "De ferro"
  },
  {
    "codigo": "28273997",
    "descricao": "De cobalto"
  },
  {
    "codigo": "28273999",
    "descricao": "Outros"
  },
  {
    "codigo": "28274110",
    "descricao": "Oxicloretos"
  },
  {
    "codigo": "28274120",
    "descricao": "Hidroxicloretos"
  },
  {
    "codigo": "28274911",
    "descricao": "De bismuto"
  },
  {
    "codigo": "28274912",
    "descricao": "De zircônio"
  },
  {
    "codigo": "28274919",
    "descricao": "Outros"
  },
  {
    "codigo": "28274921",
    "descricao": "De alumínio"
  },
  {
    "codigo": "28274929",
    "descricao": "Outros"
  },
  {
    "codigo": "28275100",
    "descricao": "-- Brometos de sódio ou de potássio"
  },
  {
    "codigo": "28275900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "28276011",
    "descricao": "De sódio"
  },
  {
    "codigo": "28276012",
    "descricao": "De potássio"
  },
  {
    "codigo": "28276019",
    "descricao": "Outros"
  },
  {
    "codigo": "28276021",
    "descricao": "De potássio"
  },
  {
    "codigo": "28276029",
    "descricao": "Outros"
  },
  {
    "codigo": "28281000",
    "descricao": "- Hipoclorito de cálcio comercial e outros hipocloritos de cálcio"
  },
  {
    "codigo": "28289011",
    "descricao": "De sódio"
  },
  {
    "codigo": "28289019",
    "descricao": "Outros"
  },
  {
    "codigo": "28289020",
    "descricao": "Clorito de sódio"
  },
  {
    "codigo": "28289090",
    "descricao": "Outros"
  },
  {
    "codigo": "28291100",
    "descricao": "-- De sódio"
  },
  {
    "codigo": "28291910",
    "descricao": "De cálcio"
  },
  {
    "codigo": "28291920",
    "descricao": "De potássio"
  },
  {
    "codigo": "28291990",
    "descricao": "Outros"
  },
  {
    "codigo": "28299011",
    "descricao": "De sódio"
  },
  {
    "codigo": "28299012",
    "descricao": "De potássio"
  },
  {
    "codigo": "28299019",
    "descricao": "Outros"
  },
  {
    "codigo": "28299021",
    "descricao": "De sódio"
  },
  {
    "codigo": "28299022",
    "descricao": "De potássio"
  },
  {
    "codigo": "28299029",
    "descricao": "Outros"
  },
  {
    "codigo": "28299031",
    "descricao": "De potássio"
  },
  {
    "codigo": "28299032",
    "descricao": "De cálcio"
  },
  {
    "codigo": "28299039",
    "descricao": "Outros"
  },
  {
    "codigo": "28299040",
    "descricao": "Periodatos"
  },
  {
    "codigo": "28299050",
    "descricao": "Percloratos"
  },
  {
    "codigo": "28301010",
    "descricao": "De dissódio"
  },
  {
    "codigo": "28301020",
    "descricao": "De monossódio (hidrogenossulfeto de sódio)"
  },
  {
    "codigo": "28309011",
    "descricao": "De molibdênio IV (dissulfeto de molibdênio)"
  },
  {
    "codigo": "28309012",
    "descricao": "De bário"
  },
  {
    "codigo": "28309013",
    "descricao": "De potássio"
  },
  {
    "codigo": "28309014",
    "descricao": "De chumbo"
  },
  {
    "codigo": "28309015",
    "descricao": "De estrôncio"
  },
  {
    "codigo": "28309016",
    "descricao": "De zinco"
  },
  {
    "codigo": "28309019",
    "descricao": "Outros"
  },
  {
    "codigo": "28309020",
    "descricao": "Polissulfetos"
  },
  {
    "codigo": "28311011",
    "descricao": "Estabilizados"
  },
  {
    "codigo": "28311019",
    "descricao": "Outros"
  },
  {
    "codigo": "28311021",
    "descricao": "Estabilizados com formaldeído"
  },
  {
    "codigo": "28311029",
    "descricao": "Outros"
  },
  {
    "codigo": "28319010",
    "descricao": "Ditionito de zinco"
  },
  {
    "codigo": "28319090",
    "descricao": "Outros"
  },
  {
    "codigo": "28321010",
    "descricao": "De dissódio"
  },
  {
    "codigo": "28321090",
    "descricao": "Outros"
  },
  {
    "codigo": "28322000",
    "descricao": "- Outros sulfitos"
  },
  {
    "codigo": "28323010",
    "descricao": "De amônio"
  },
  {
    "codigo": "28323020",
    "descricao": "De sódio"
  },
  {
    "codigo": "28323090",
    "descricao": "Outros"
  },
  {
    "codigo": "28331110",
    "descricao": "Anidro"
  },
  {
    "codigo": "28331190",
    "descricao": "Outros"
  },
  {
    "codigo": "28331900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "28332100",
    "descricao": "-- De magnésio"
  },
  {
    "codigo": "28332200",
    "descricao": "-- De alumínio"
  },
  {
    "codigo": "28332400",
    "descricao": "-- De níquel"
  },
  {
    "codigo": "28332510",
    "descricao": "Cuproso"
  },
  {
    "codigo": "28332520",
    "descricao": "Cúprico"
  },
  {
    "codigo": "28332710",
    "descricao": "Com um teor de BaSO<sub>4</sub> igual ou superior a 97,5 %, em peso"
  },
  {
    "codigo": "28332790",
    "descricao": "Outros"
  },
  {
    "codigo": "28332910",
    "descricao": "De antimônio"
  },
  {
    "codigo": "28332920",
    "descricao": "De lítio"
  },
  {
    "codigo": "28332930",
    "descricao": "De estrôncio"
  },
  {
    "codigo": "28332940",
    "descricao": "Sulfato ferroso"
  },
  {
    "codigo": "28332950",
    "descricao": "Neutro de chumbo"
  },
  {
    "codigo": "28332960",
    "descricao": "De cromo"
  },
  {
    "codigo": "28332970",
    "descricao": "De zinco"
  },
  {
    "codigo": "28332990",
    "descricao": "Outros"
  },
  {
    "codigo": "28333000",
    "descricao": "- Alumes"
  },
  {
    "codigo": "28334010",
    "descricao": "De sódio"
  },
  {
    "codigo": "28334020",
    "descricao": "De amônio"
  },
  {
    "codigo": "28334090",
    "descricao": "Outros"
  },
  {
    "codigo": "28341010",
    "descricao": "De sódio"
  },
  {
    "codigo": "28341090",
    "descricao": "Outros"
  },
  {
    "codigo": "28342110",
    "descricao": "Com um teor de KNO<sub>3</sub> inferior ou igual a 98 %, em peso"
  },
  {
    "codigo": "28342190",
    "descricao": "Outros"
  },
  {
    "codigo": "28342910",
    "descricao": "De cálcio, com um teor de nitrogênio (azoto) inferior ou igual a 16 %, em peso"
  },
  {
    "codigo": "28342930",
    "descricao": "De alumínio"
  },
  {
    "codigo": "28342940",
    "descricao": "De lítio"
  },
  {
    "codigo": "28342990",
    "descricao": "Outros"
  },
  {
    "codigo": "28351011",
    "descricao": "De sódio"
  },
  {
    "codigo": "28351019",
    "descricao": "Outros"
  },
  {
    "codigo": "28351021",
    "descricao": "Dibásico de chumbo"
  },
  {
    "codigo": "28351029",
    "descricao": "Outros"
  },
  {
    "codigo": "28352200",
    "descricao": "-- Mono ou dissódico"
  },
  {
    "codigo": "28352400",
    "descricao": "-- De potássio"
  },
  {
    "codigo": "28352500",
    "descricao": "-- Hidrogeno-ortofosfato de cálcio (fosfato dicálcico)"
  },
  {
    "codigo": "28352600",
    "descricao": "-- Outros fosfatos de cálcio"
  },
  {
    "codigo": "28352910",
    "descricao": "De ferro"
  },
  {
    "codigo": "28352920",
    "descricao": "De cobalto"
  },
  {
    "codigo": "28352930",
    "descricao": "De cobre"
  },
  {
    "codigo": "28352940",
    "descricao": "De cromo"
  },
  {
    "codigo": "28352950",
    "descricao": "De estrôncio"
  },
  {
    "codigo": "28352960",
    "descricao": "De manganês"
  },
  {
    "codigo": "28352970",
    "descricao": "De triamônio"
  },
  {
    "codigo": "28352980",
    "descricao": "De trissódio"
  },
  {
    "codigo": "28352990",
    "descricao": "Outros"
  },
  {
    "codigo": "28353110",
    "descricao": "Grau alimentício, de acordo com o estabelecido pela <i>Food and Agriculture Organization</i> - Organização Mundial da Saúde (FAO - OMS) ou pelo <i>Food Chemical Codex</i> (FCC)"
  },
  {
    "codigo": "28353190",
    "descricao": "Outros"
  },
  {
    "codigo": "28353910",
    "descricao": "Metafosfatos de sódio"
  },
  {
    "codigo": "28353920",
    "descricao": "Pirofosfatos de sódio"
  },
  {
    "codigo": "28353930",
    "descricao": "Pirofosfato de zinco"
  },
  {
    "codigo": "28353990",
    "descricao": "Outros"
  },
  {
    "codigo": "28362010",
    "descricao": "Anidro"
  },
  {
    "codigo": "28362090",
    "descricao": "Outros"
  },
  {
    "codigo": "28363000",
    "descricao": "- Hidrogenocarbonato (bicarbonato) de sódio"
  },
  {
    "codigo": "28364000",
    "descricao": "- Carbonatos de potássio"
  },
  {
    "codigo": "28365000",
    "descricao": "- Carbonato de cálcio"
  },
  {
    "codigo": "28366010",
    "descricao": "Com um teor de BaCO<sub>3</sub> igual ou superior a 98 %, em peso"
  },
  {
    "codigo": "28366090",
    "descricao": "Outros"
  },
  {
    "codigo": "28369100",
    "descricao": "-- Carbonatos de lítio"
  },
  {
    "codigo": "28369200",
    "descricao": "-- Carbonato de estrôncio"
  },
  {
    "codigo": "28369911",
    "descricao": "De magnésio, de densidade aparente inferior a 200 kg/m<sup>3</sup>"
  },
  {
    "codigo": "28369912",
    "descricao": "De zircônio"
  },
  {
    "codigo": "28369913",
    "descricao": "De amônio comercial e outros carbonatos de amônio"
  },
  {
    "codigo": "28369919",
    "descricao": "Outros"
  },
  {
    "codigo": "28369920",
    "descricao": "Peroxocarbonatos (percarbonatos)"
  },
  {
    "codigo": "28371100",
    "descricao": "-- De sódio"
  },
  {
    "codigo": "28371911",
    "descricao": "De potássio"
  },
  {
    "codigo": "28371912",
    "descricao": "De zinco"
  },
  {
    "codigo": "28371914",
    "descricao": "De cobre I (cianeto cuproso)"
  },
  {
    "codigo": "28371915",
    "descricao": "De cobre II (cianeto cúprico)"
  },
  {
    "codigo": "28371919",
    "descricao": "Outros"
  },
  {
    "codigo": "28371920",
    "descricao": "Oxicianetos"
  },
  {
    "codigo": "28372011",
    "descricao": "De sódio"
  },
  {
    "codigo": "28372012",
    "descricao": "De ferro II (ferrocianeto ferroso)"
  },
  {
    "codigo": "28372019",
    "descricao": "Outros"
  },
  {
    "codigo": "28372021",
    "descricao": "De potássio"
  },
  {
    "codigo": "28372022",
    "descricao": "De ferro II (ferricianeto ferroso)"
  },
  {
    "codigo": "28372023",
    "descricao": "De ferro III (ferricianeto férrico)"
  },
  {
    "codigo": "28372029",
    "descricao": "Outros"
  },
  {
    "codigo": "28372090",
    "descricao": "Outros"
  },
  {
    "codigo": "28391100",
    "descricao": "-- Metassilicatos"
  },
  {
    "codigo": "28391900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "28399010",
    "descricao": "De magnésio"
  },
  {
    "codigo": "28399020",
    "descricao": "De alumínio"
  },
  {
    "codigo": "28399030",
    "descricao": "De zircônio"
  },
  {
    "codigo": "28399040",
    "descricao": "De chumbo"
  },
  {
    "codigo": "28399050",
    "descricao": "De potássio"
  },
  {
    "codigo": "28399090",
    "descricao": "Outros"
  },
  {
    "codigo": "28401100",
    "descricao": "-- Anidro"
  },
  {
    "codigo": "28401900",
    "descricao": "-- Outro"
  },
  {
    "codigo": "28402000",
    "descricao": "- Outros boratos"
  },
  {
    "codigo": "28403000",
    "descricao": "- Peroxoboratos (perboratos)"
  },
  {
    "codigo": "28413000",
    "descricao": "- Dicromato de sódio"
  },
  {
    "codigo": "28415011",
    "descricao": "Cromato de amônio; dicromato de amônio"
  },
  {
    "codigo": "28415012",
    "descricao": "Cromato de potássio"
  },
  {
    "codigo": "28415013",
    "descricao": "Cromato de sódio"
  },
  {
    "codigo": "28415014",
    "descricao": "Dicromato de potássio"
  },
  {
    "codigo": "28415015",
    "descricao": "Cromato de zinco"
  },
  {
    "codigo": "28415016",
    "descricao": "Cromato de chumbo"
  },
  {
    "codigo": "28415019",
    "descricao": "Outros"
  },
  {
    "codigo": "28415020",
    "descricao": "Peroxocromatos"
  },
  {
    "codigo": "28416100",
    "descricao": "-- Permanganato de potássio"
  },
  {
    "codigo": "28416910",
    "descricao": "Manganitos"
  },
  {
    "codigo": "28416920",
    "descricao": "Manganatos"
  },
  {
    "codigo": "28416930",
    "descricao": "Permanganatos"
  },
  {
    "codigo": "28417010",
    "descricao": "De amônio"
  },
  {
    "codigo": "28417020",
    "descricao": "De sódio"
  },
  {
    "codigo": "28417090",
    "descricao": "Outros"
  },
  {
    "codigo": "28418010",
    "descricao": "De amônio"
  },
  {
    "codigo": "28418020",
    "descricao": "De chumbo"
  },
  {
    "codigo": "28418090",
    "descricao": "Outros"
  },
  {
    "codigo": "28419011",
    "descricao": "De chumbo"
  },
  {
    "codigo": "28419012",
    "descricao": "De bário ou de bismuto"
  },
  {
    "codigo": "28419013",
    "descricao": "De cálcio ou de estrôncio"
  },
  {
    "codigo": "28419014",
    "descricao": "De magnésio"
  },
  {
    "codigo": "28419015",
    "descricao": "De lantânio ou de neodímio"
  },
  {
    "codigo": "28419019",
    "descricao": "Outros"
  },
  {
    "codigo": "28419021",
    "descricao": "Ferrito de bário"
  },
  {
    "codigo": "28419022",
    "descricao": "Ferrito de estrôncio"
  },
  {
    "codigo": "28419029",
    "descricao": "Outros"
  },
  {
    "codigo": "28419030",
    "descricao": "Vanadatos"
  },
  {
    "codigo": "28419041",
    "descricao": "De bário"
  },
  {
    "codigo": "28419042",
    "descricao": "De bismuto"
  },
  {
    "codigo": "28419043",
    "descricao": "De cálcio"
  },
  {
    "codigo": "28419049",
    "descricao": "Outros"
  },
  {
    "codigo": "28419050",
    "descricao": "Plumbatos"
  },
  {
    "codigo": "28419060",
    "descricao": "Antimoniatos"
  },
  {
    "codigo": "28419070",
    "descricao": "Zincatos"
  },
  {
    "codigo": "28419081",
    "descricao": "De sódio"
  },
  {
    "codigo": "28419082",
    "descricao": "De magnésio"
  },
  {
    "codigo": "28419083",
    "descricao": "De bismuto"
  },
  {
    "codigo": "28419089",
    "descricao": "Outros"
  },
  {
    "codigo": "28419090",
    "descricao": "Outros"
  },
  {
    "codigo": "28421010",
    "descricao": "Zeólitas do tipo utilizado como trocadores de íons para o tratamento de águas"
  },
  {
    "codigo": "28421090",
    "descricao": "Outros"
  },
  {
    "codigo": "28429000",
    "descricao": "- Outros"
  },
  {
    "codigo": "28431000",
    "descricao": "- Metais preciosos no estado coloidal"
  },
  {
    "codigo": "28432100",
    "descricao": "-- Nitrato de prata"
  },
  {
    "codigo": "28432910",
    "descricao": "Vitelinato de prata"
  },
  {
    "codigo": "28432990",
    "descricao": "Outros"
  },
  {
    "codigo": "28433010",
    "descricao": "Sulfeto de ouro em dispersão de gelatina"
  },
  {
    "codigo": "28433090",
    "descricao": "Outros"
  },
  {
    "codigo": "28439011",
    "descricao": "Apresentados como medicamentos"
  },
  {
    "codigo": "28439019",
    "descricao": "Outros"
  },
  {
    "codigo": "28439020",
    "descricao": "Tricloreto de rutênio em solução aquosa com uma concentração igual ou superior a 17 %, mas inferior ou igual a 27 %, em peso"
  },
  {
    "codigo": "28439030",
    "descricao": "Ácido hexacloroirídico em solução aquosa com uma concentração igual ou superior a 17 %, mas inferior ou igual a 27 %, em peso"
  },
  {
    "codigo": "28439040",
    "descricao": "Tricloreto de rutênio, em pó"
  },
  {
    "codigo": "28439090",
    "descricao": "Outros"
  },
  {
    "codigo": "28441000",
    "descricao": "- Urânio natural e seus compostos; ligas, dispersões (incluindo os <i>cermets</i>), produtos cerâmicos e misturas que contenham urânio natural ou compostos de urânio natural"
  },
  {
    "codigo": "28442000",
    "descricao": "- Urânio enriquecido em U 235 e seus compostos; plutônio e seus compostos; ligas, dispersões (incluindo os <i>cermets</i>), produtos cerâmicos e misturas que contenham urânio enriquecido em U 235, plutônio ou compostos destes produtos"
  },
  {
    "codigo": "28443000",
    "descricao": "- Urânio empobrecido em U 235 e seus compostos; tório e seus compostos; ligas, dispersões (incluindo os <i>cermets</i>), produtos cerâmicos e misturas que contenham urânio empobrecido em U 235, tório ou compostos destes produtos"
  },
  {
    "codigo": "28444100",
    "descricao": "-- Trítio e seus compostos; ligas, dispersões (incluindo os <i>cermets</i>), produtos cerâmicos e misturas que contenham trítio ou seus compostos"
  },
  {
    "codigo": "28444200",
    "descricao": "-- Actínio-225, actínio-227, califórnio-253, cúrio-240, cúrio-241, cúrio-242, cúrio-243, cúrio-244, einstêinio-253, einstêinio-254, gadolínio-148, polônio-208, polônio-209, polônio-210, rádio-223, urânio-230 ou urânio-232, e seus compostos; ligas, dispersões (incluindo os <i>cermets</i>), produtos cerâmicos e misturas que contenham estes elementos ou compostos"
  },
  {
    "codigo": "28444310",
    "descricao": "Molibdênio-99 absorvido em alumina, apto para a obtenção de tecnécio-99 (reativo de diagnóstico para medicina nuclear)"
  },
  {
    "codigo": "28444320",
    "descricao": "Cobalto-60"
  },
  {
    "codigo": "28444330",
    "descricao": "Iodo-131"
  },
  {
    "codigo": "28444390",
    "descricao": "Outros"
  },
  {
    "codigo": "28444400",
    "descricao": "-- Resíduos radioativos"
  },
  {
    "codigo": "28445000",
    "descricao": "- Elementos combustíveis (cartuchos) usados (irradiados) de reatores nucleares"
  },
  {
    "codigo": "28451000",
    "descricao": "- Água pesada (óxido de deutério)"
  },
  {
    "codigo": "28452000",
    "descricao": "- Boro enriquecido em boro-10 e seus compostos"
  },
  {
    "codigo": "28453000",
    "descricao": "- Lítio enriquecido em lítio-6 e seus compostos"
  },
  {
    "codigo": "28454000",
    "descricao": "- Hélio-3"
  },
  {
    "codigo": "28459000",
    "descricao": "- Outros"
  },
  {
    "codigo": "28461010",
    "descricao": "Óxido cérico"
  },
  {
    "codigo": "28461090",
    "descricao": "Outros"
  },
  {
    "codigo": "28469010",
    "descricao": "Óxido de praseodímio"
  },
  {
    "codigo": "28469020",
    "descricao": "Cloretos dos demais metais das terras raras"
  },
  {
    "codigo": "28469030",
    "descricao": "Gadopentetato de dimeglumina"
  },
  {
    "codigo": "28469090",
    "descricao": "Outros"
  },
  {
    "codigo": "28470000",
    "descricao": "Peróxido de hidrogênio (água oxigenada), mesmo solidificado com ureia."
  },
  {
    "codigo": "28491000",
    "descricao": "- De cálcio"
  },
  {
    "codigo": "28492000",
    "descricao": "- De silício"
  },
  {
    "codigo": "28499010",
    "descricao": "De boro"
  },
  {
    "codigo": "28499020",
    "descricao": "De tântalo"
  },
  {
    "codigo": "28499030",
    "descricao": "De tungstênio (volfrâmio)"
  },
  {
    "codigo": "28499090",
    "descricao": "Outros"
  },
  {
    "codigo": "28500010",
    "descricao": "Nitreto de boro"
  },
  {
    "codigo": "28500020",
    "descricao": "Silicieto de cálcio"
  },
  {
    "codigo": "28500090",
    "descricao": "Outros"
  },
  {
    "codigo": "28521011",
    "descricao": "Óxidos"
  },
  {
    "codigo": "28521012",
    "descricao": "Cloreto de mercúrio I (cloreto mercuroso)"
  },
  {
    "codigo": "28521013",
    "descricao": "Cloreto de mercúrio II (cloreto mercúrico), para uso fotográfico, acondicionado para venda a retalho, pronto para utilização"
  },
  {
    "codigo": "28521014",
    "descricao": "Cloreto de mercúrio II (cloreto mercúrico), apresentado de outro modo"
  },
  {
    "codigo": "28521019",
    "descricao": "Outros"
  },
  {
    "codigo": "28521021",
    "descricao": "Acetato de mercúrio"
  },
  {
    "codigo": "28521022",
    "descricao": "Timerosal"
  },
  {
    "codigo": "28521023",
    "descricao": "Estearato de mercúrio"
  },
  {
    "codigo": "28521024",
    "descricao": "Lactato de mercúrio"
  },
  {
    "codigo": "28521025",
    "descricao": "Salicilato de mercúrio"
  },
  {
    "codigo": "28521029",
    "descricao": "Outros"
  },
  {
    "codigo": "28529000",
    "descricao": "- Outros"
  },
  {
    "codigo": "28531000",
    "descricao": "- Cloreto de cianogênio (clorociano)"
  },
  {
    "codigo": "28539011",
    "descricao": "De alumínio"
  },
  {
    "codigo": "28539012",
    "descricao": "De magnésio"
  },
  {
    "codigo": "28539013",
    "descricao": "De cobre (fosfetos de cobre), que contenham mais de 15 %, em peso, de fósforo"
  },
  {
    "codigo": "28539019",
    "descricao": "Outros"
  },
  {
    "codigo": "28539020",
    "descricao": "Cianamida e seus derivados metálicos"
  },
  {
    "codigo": "28539030",
    "descricao": "Sulfocloretos de fósforo"
  },
  {
    "codigo": "28539090",
    "descricao": "Outros"
  },
  {
    "codigo": "29011000",
    "descricao": "- Saturados"
  },
  {
    "codigo": "29012100",
    "descricao": "-- Etileno"
  },
  {
    "codigo": "29012200",
    "descricao": "-- Propeno (propileno)"
  },
  {
    "codigo": "29012300",
    "descricao": "-- Buteno (butileno) e seus isômeros"
  },
  {
    "codigo": "29012410",
    "descricao": "Buta-1,3-dieno"
  },
  {
    "codigo": "29012420",
    "descricao": "Isopreno"
  },
  {
    "codigo": "29012900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "29021100",
    "descricao": "-- Cicloexano"
  },
  {
    "codigo": "29021910",
    "descricao": "Limoneno"
  },
  {
    "codigo": "29021990",
    "descricao": "Outros"
  },
  {
    "codigo": "29022000",
    "descricao": "- Benzeno"
  },
  {
    "codigo": "29023000",
    "descricao": "- Tolueno"
  },
  {
    "codigo": "29024100",
    "descricao": "-- <i>o</i>-Xileno"
  },
  {
    "codigo": "29024200",
    "descricao": "-- <i>m</i>-Xileno"
  },
  {
    "codigo": "29024300",
    "descricao": "-- <i>p</i>-Xileno"
  },
  {
    "codigo": "29024400",
    "descricao": "-- Mistura de isômeros do xileno"
  },
  {
    "codigo": "29025000",
    "descricao": "- Estireno"
  },
  {
    "codigo": "29026000",
    "descricao": "- Etilbenzeno"
  },
  {
    "codigo": "29027000",
    "descricao": "- Cumeno"
  },
  {
    "codigo": "29029010",
    "descricao": "Difenila (1,1'-bifenila)"
  },
  {
    "codigo": "29029020",
    "descricao": "Naftaleno"
  },
  {
    "codigo": "29029030",
    "descricao": "Antraceno"
  },
  {
    "codigo": "29029040",
    "descricao": "alfa-Metilestireno"
  },
  {
    "codigo": "29029090",
    "descricao": "Outros"
  },
  {
    "codigo": "29031110",
    "descricao": "Clorometano (cloreto de metila)"
  },
  {
    "codigo": "29031120",
    "descricao": "Cloroetano (cloreto de etila)"
  },
  {
    "codigo": "29031200",
    "descricao": "-- Diclorometano (cloreto de metileno)"
  },
  {
    "codigo": "29031300",
    "descricao": "-- Clorofórmio (triclorometano)"
  },
  {
    "codigo": "29031400",
    "descricao": "-- Tetracloreto de carbono"
  },
  {
    "codigo": "29031500",
    "descricao": "-- Dicloreto de etileno (ISO) (1,2-dicloroetano)"
  },
  {
    "codigo": "29031910",
    "descricao": "1,1,1-Tricloroetano (metilclorofórmio)"
  },
  {
    "codigo": "29031920",
    "descricao": "1,1,2-Tricloroetano"
  },
  {
    "codigo": "29031990",
    "descricao": "Outros"
  },
  {
    "codigo": "29032100",
    "descricao": "-- Cloreto de vinila (cloroetileno)"
  },
  {
    "codigo": "29032200",
    "descricao": "-- Tricloroetileno"
  },
  {
    "codigo": "29032300",
    "descricao": "-- Tetracloroetileno (percloroetileno)"
  },
  {
    "codigo": "29032910",
    "descricao": "Hexaclorobutadieno"
  },
  {
    "codigo": "29032990",
    "descricao": "Outros"
  },
  {
    "codigo": "29034100",
    "descricao": "-- Trifluorometano (HFC-23)"
  },
  {
    "codigo": "29034200",
    "descricao": "-- Difluorometano (HFC-32)"
  },
  {
    "codigo": "29034300",
    "descricao": "-- Fluorometano (HFC-41), 1,2-difluoroetano (HFC-152) e 1,1-difluoroetano (HFC-152a)"
  },
  {
    "codigo": "29034400",
    "descricao": "-- Pentafluoroetano (HFC-125), 1,1,1-trifluoroetano (HFC-143a) e 1,1,2-trifluoroetano (HFC-143)"
  },
  {
    "codigo": "29034510",
    "descricao": "1,1,1,2-Tetrafluoroetano (HFC-134a)"
  },
  {
    "codigo": "29034520",
    "descricao": "1,1,2,2-Tetrafluoroetano (HFC-134)"
  },
  {
    "codigo": "29034600",
    "descricao": "-- 1,1,1,2,3,3,3-Heptafluoropropano (HFC-227ea), 1,1,1,2,2,3-hexafluoropropano (HFC-236cb), 1,1,1,2,3,3-hexafluoropropano (HFC-236ea) e 1,1,1,3,3,3-hexafluoropropano (HFC-236fa)"
  },
  {
    "codigo": "29034700",
    "descricao": "-- 1,1,1,3,3-Pentafluoropropano (HFC-245fa) e 1,1,2,2,3-pentafluoropropano (HFC-245ca)"
  },
  {
    "codigo": "29034800",
    "descricao": "-- 1,1,1,3,3-Pentafluorobutano (HFC-365mfc) e 1,1,1,2,2,3,4,5,5,5-decafluoropentano (HFC-43-10mee)"
  },
  {
    "codigo": "29034900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "29035100",
    "descricao": "-- 2,3,3,3-Tetrafluoropropeno (HFO-1234yf), 1,3,3,3-tetrafluoropropeno (HFO-1234ze) e (Z)-1,1,1,4,4,4-hexafluoro-2-buteno (HFO-1336mzz)"
  },
  {
    "codigo": "29035910",
    "descricao": "1,1,3,3,3-Pentafluoro-2-(trifluorometil)prop-1-eno"
  },
  {
    "codigo": "29035990",
    "descricao": "Outros"
  },
  {
    "codigo": "29036100",
    "descricao": "-- Brometo de metila (bromometano)"
  },
  {
    "codigo": "29036200",
    "descricao": "-- Dibrometo de etileno (ISO) (1,2-dibromoetano)"
  },
  {
    "codigo": "29036910",
    "descricao": "Iodoetano"
  },
  {
    "codigo": "29036920",
    "descricao": "Iodofórmio"
  },
  {
    "codigo": "29036990",
    "descricao": "Outros"
  },
  {
    "codigo": "29037100",
    "descricao": "-- Clorodifluorometano (HCFC-22)"
  },
  {
    "codigo": "29037200",
    "descricao": "-- Diclorotrifluoroetanos (HCFC-123)"
  },
  {
    "codigo": "29037300",
    "descricao": "-- Diclorofluoroetanos (HCFC-141, 141b)"
  },
  {
    "codigo": "29037400",
    "descricao": "-- Clorodifluoroetanos (HCFC-142, 142b)"
  },
  {
    "codigo": "29037500",
    "descricao": "-- Dicloropentafluoropropanos (HCFC-225, 225ca, 225cb)"
  },
  {
    "codigo": "29037600",
    "descricao": "-- Bromoclorodifluorometano (halon-1211), bromotrifluorometano (halon-1301) e dibromotetrafluoroetanos (halon-2402)"
  },
  {
    "codigo": "29037711",
    "descricao": "Triclorofluorometano"
  },
  {
    "codigo": "29037712",
    "descricao": "Diclorodifluorometano"
  },
  {
    "codigo": "29037713",
    "descricao": "Clorotrifluorometano"
  },
  {
    "codigo": "29037721",
    "descricao": "Triclorotrifluoroetanos"
  },
  {
    "codigo": "29037722",
    "descricao": "Diclorotetrafluoroetanos e cloropentafluoroetano"
  },
  {
    "codigo": "29037723",
    "descricao": "Pentaclorofluoroetano"
  },
  {
    "codigo": "29037724",
    "descricao": "Tetraclorodifluoroetanos"
  },
  {
    "codigo": "29037731",
    "descricao": "Heptaclorofluoropropanos"
  },
  {
    "codigo": "29037732",
    "descricao": "Hexaclorodifluoropropanos"
  },
  {
    "codigo": "29037733",
    "descricao": "Pentaclorotrifluoropropanos"
  },
  {
    "codigo": "29037734",
    "descricao": "Tetraclorotetrafluoropropanos"
  },
  {
    "codigo": "29037735",
    "descricao": "Tricloropentafluoropropanos"
  },
  {
    "codigo": "29037736",
    "descricao": "Dicloroexafluoropropanos"
  },
  {
    "codigo": "29037737",
    "descricao": "Cloroeptafluoropropanos"
  },
  {
    "codigo": "29037790",
    "descricao": "Outros"
  },
  {
    "codigo": "29037800",
    "descricao": "-- Outros derivados peralogenados"
  },
  {
    "codigo": "29037911",
    "descricao": "Clorofluoroetanos"
  },
  {
    "codigo": "29037912",
    "descricao": "Clorotetrafluoroetanos"
  },
  {
    "codigo": "29037919",
    "descricao": "Outros"
  },
  {
    "codigo": "29037920",
    "descricao": "Derivados do metano, etano ou propano, halogenados unicamente com flúor e bromo"
  },
  {
    "codigo": "29037931",
    "descricao": "Halotano"
  },
  {
    "codigo": "29037939",
    "descricao": "Outros"
  },
  {
    "codigo": "29037990",
    "descricao": "Outros"
  },
  {
    "codigo": "29038110",
    "descricao": "Lindano (gama-hexaclorocicloexano)"
  },
  {
    "codigo": "29038120",
    "descricao": "alfa-Hexaclorocicloexano"
  },
  {
    "codigo": "29038130",
    "descricao": "beta-Hexaclorocicloexano"
  },
  {
    "codigo": "29038190",
    "descricao": "Outros"
  },
  {
    "codigo": "29038210",
    "descricao": "Aldrin"
  },
  {
    "codigo": "29038220",
    "descricao": "Clordano"
  },
  {
    "codigo": "29038230",
    "descricao": "Heptacloro"
  },
  {
    "codigo": "29038300",
    "descricao": "-- Mirex (ISO)"
  },
  {
    "codigo": "29038910",
    "descricao": "Hexabromociclododecanos (HBCD)"
  },
  {
    "codigo": "29038990",
    "descricao": "Outros"
  },
  {
    "codigo": "29039110",
    "descricao": "Clorobenzeno"
  },
  {
    "codigo": "29039120",
    "descricao": "<i>o</i>-Diclorobenzeno"
  },
  {
    "codigo": "29039130",
    "descricao": "<i>p</i>-Diclorobenzeno"
  },
  {
    "codigo": "29039210",
    "descricao": "Hexaclorobenzeno"
  },
  {
    "codigo": "29039220",
    "descricao": "DDT"
  },
  {
    "codigo": "29039300",
    "descricao": "-- Pentaclorobenzeno (ISO)"
  },
  {
    "codigo": "29039400",
    "descricao": "-- Hexabromobifenilas"
  },
  {
    "codigo": "29039911",
    "descricao": "Cloreto de benzila"
  },
  {
    "codigo": "29039912",
    "descricao": "<i>p</i>-Clorotolueno"
  },
  {
    "codigo": "29039913",
    "descricao": "Cloreto de neofila"
  },
  {
    "codigo": "29039914",
    "descricao": "Triclorobenzenos"
  },
  {
    "codigo": "29039915",
    "descricao": "Cloronaftalenos"
  },
  {
    "codigo": "29039916",
    "descricao": "Cloreto de benzilideno"
  },
  {
    "codigo": "29039917",
    "descricao": "Cloretos de xilila"
  },
  {
    "codigo": "29039918",
    "descricao": "Bifenilas policloradas (PCB); terfenilas policloradas (PCT)"
  },
  {
    "codigo": "29039919",
    "descricao": "Outros"
  },
  {
    "codigo": "29039921",
    "descricao": "Bromobenzeno"
  },
  {
    "codigo": "29039922",
    "descricao": "Brometos de xilila"
  },
  {
    "codigo": "29039923",
    "descricao": "Bromodifenilmetano"
  },
  {
    "codigo": "29039924",
    "descricao": "Bifenilas polibromadas (PBB)"
  },
  {
    "codigo": "29039929",
    "descricao": "Outros"
  },
  {
    "codigo": "29039931",
    "descricao": "4-Cloro-alfa,alfa,alfa-trifluortolueno"
  },
  {
    "codigo": "29039939",
    "descricao": "Outros"
  },
  {
    "codigo": "29039990",
    "descricao": "Outros"
  },
  {
    "codigo": "29041011",
    "descricao": "Ácido metanossulfônico"
  },
  {
    "codigo": "29041012",
    "descricao": "Metanossulfonato de chumbo"
  },
  {
    "codigo": "29041013",
    "descricao": "Metanossulfonato de estanho"
  },
  {
    "codigo": "29041019",
    "descricao": "Outros"
  },
  {
    "codigo": "29041020",
    "descricao": "Ácido dodecilbenzenossulfônico e seus sais"
  },
  {
    "codigo": "29041030",
    "descricao": "Ácidos toluenossulfônicos; ácidos xilenossulfônicos; sais destes ácidos"
  },
  {
    "codigo": "29041040",
    "descricao": "Ácido etanossulfônico; ácido etilenossulfônico"
  },
  {
    "codigo": "29041051",
    "descricao": "Naftalenossulfonatos de sódio"
  },
  {
    "codigo": "29041052",
    "descricao": "Ácido beta-naftalenossulfônico"
  },
  {
    "codigo": "29041053",
    "descricao": "Ácidos alquil- e dialquilnaftalenossulfônicos; sais destes ácidos"
  },
  {
    "codigo": "29041059",
    "descricao": "Outros"
  },
  {
    "codigo": "29041060",
    "descricao": "Ácido benzenossulfônico e seus sais"
  },
  {
    "codigo": "29041090",
    "descricao": "Outros"
  },
  {
    "codigo": "29042010",
    "descricao": "Mononitrotoluenos (MNT)"
  },
  {
    "codigo": "29042020",
    "descricao": "Nitropropanos"
  },
  {
    "codigo": "29042030",
    "descricao": "Dinitrotoluenos"
  },
  {
    "codigo": "29042041",
    "descricao": "2,4,6-Trinitrotolueno (TNT)"
  },
  {
    "codigo": "29042049",
    "descricao": "Outros"
  },
  {
    "codigo": "29042051",
    "descricao": "Nitrobenzeno"
  },
  {
    "codigo": "29042052",
    "descricao": "1,3,5-Trinitrobenzeno"
  },
  {
    "codigo": "29042059",
    "descricao": "Outros"
  },
  {
    "codigo": "29042060",
    "descricao": "Derivados nitrados do xileno"
  },
  {
    "codigo": "29042070",
    "descricao": "Mononitroetano; nitrometanos"
  },
  {
    "codigo": "29042090",
    "descricao": "Outros"
  },
  {
    "codigo": "29043100",
    "descricao": "-- Ácido perfluoroctano sulfônico"
  },
  {
    "codigo": "29043200",
    "descricao": "-- Perfluoroctanossulfonato de amônio"
  },
  {
    "codigo": "29043300",
    "descricao": "-- Perfluoroctanossulfonato de lítio"
  },
  {
    "codigo": "29043400",
    "descricao": "-- Perfluoroctanossulfonato de potássio"
  },
  {
    "codigo": "29043500",
    "descricao": "-- Outros sais do ácido perfluoroctano sulfônico"
  },
  {
    "codigo": "29043600",
    "descricao": "-- Fluoreto de perfluoroctanossulfonila"
  },
  {
    "codigo": "29049100",
    "descricao": "-- Tricloronitrometano (cloropicrina)"
  },
  {
    "codigo": "29049911",
    "descricao": "1-Cloro-4-nitrobenzeno"
  },
  {
    "codigo": "29049912",
    "descricao": "1-Cloro-2,4-dinitrobenzeno"
  },
  {
    "codigo": "29049913",
    "descricao": "2-Cloro-1,3-dinitrobenzeno"
  },
  {
    "codigo": "29049914",
    "descricao": "4-Cloro-alfa,alfa,alfa-trifluor-3,5-dinitrotolueno"
  },
  {
    "codigo": "29049915",
    "descricao": "<i>o</i>-Nitroclorobenzeno; <i>m</i>-nitroclorobenzeno"
  },
  {
    "codigo": "29049916",
    "descricao": "1,2-Dicloro-4-nitrobenzeno"
  },
  {
    "codigo": "29049919",
    "descricao": "Outros"
  },
  {
    "codigo": "29049921",
    "descricao": "Ácidos dinitroestilbenodissulfônicos"
  },
  {
    "codigo": "29049929",
    "descricao": "Outros"
  },
  {
    "codigo": "29049930",
    "descricao": "Cloreto de <i>p</i>-toluenossulfonila (cloreto de tosila)"
  },
  {
    "codigo": "29049940",
    "descricao": "Cloreto de <i>o</i>-toluenossulfonila"
  },
  {
    "codigo": "29049990",
    "descricao": "Outros"
  },
  {
    "codigo": "29051100",
    "descricao": "-- Metanol (álcool metílico)"
  },
  {
    "codigo": "29051210",
    "descricao": "Álcool propílico"
  },
  {
    "codigo": "29051220",
    "descricao": "Álcool isopropílico"
  },
  {
    "codigo": "29051300",
    "descricao": "-- Butan-1-ol (álcool <i>n</i>-butílico)"
  },
  {
    "codigo": "29051410",
    "descricao": "Álcool isobutílico (2-metil-1-propanol)"
  },
  {
    "codigo": "29051420",
    "descricao": "Álcool <i>sec</i>-butílico (2-butanol)"
  },
  {
    "codigo": "29051430",
    "descricao": "Álcool <i>ter</i>-butílico (2-metil-2-propanol)"
  },
  {
    "codigo": "29051600",
    "descricao": "-- Octanol (álcool octílico) e seus isômeros"
  },
  {
    "codigo": "29051710",
    "descricao": "Álcool láurico"
  },
  {
    "codigo": "29051720",
    "descricao": "Álcool cetílico"
  },
  {
    "codigo": "29051730",
    "descricao": "Álcool esteárico"
  },
  {
    "codigo": "29051911",
    "descricao": "<i>n</i>-Decanol"
  },
  {
    "codigo": "29051912",
    "descricao": "Isodecanol"
  },
  {
    "codigo": "29051919",
    "descricao": "Outros"
  },
  {
    "codigo": "29051921",
    "descricao": "Etilato de magnésio"
  },
  {
    "codigo": "29051922",
    "descricao": "Metilato de sódio"
  },
  {
    "codigo": "29051923",
    "descricao": "Etilato de sódio"
  },
  {
    "codigo": "29051929",
    "descricao": "Outros"
  },
  {
    "codigo": "29051991",
    "descricao": "4-Metilpentan-2-ol"
  },
  {
    "codigo": "29051992",
    "descricao": "Isononanol"
  },
  {
    "codigo": "29051993",
    "descricao": "Isotridecanol"
  },
  {
    "codigo": "29051994",
    "descricao": "Tetra-hidrolinalol (3,7-dimetiloctan-3-ol)"
  },
  {
    "codigo": "29051995",
    "descricao": "3,3-Dimetilbutan-2-ol (álcool pinacolílico)"
  },
  {
    "codigo": "29051996",
    "descricao": "Pentanol (álcool amílico) e seus isômeros"
  },
  {
    "codigo": "29051999",
    "descricao": "Outros"
  },
  {
    "codigo": "29052210",
    "descricao": "Linalol"
  },
  {
    "codigo": "29052220",
    "descricao": "Geraniol"
  },
  {
    "codigo": "29052230",
    "descricao": "Di-hidromircenol (2,6-dimetil-7-octen-2-ol)"
  },
  {
    "codigo": "29052290",
    "descricao": "Outros"
  },
  {
    "codigo": "29052910",
    "descricao": "Álcool alílico"
  },
  {
    "codigo": "29052990",
    "descricao": "Outros"
  },
  {
    "codigo": "29053100",
    "descricao": "-- Etilenoglicol (etanodiol)"
  },
  {
    "codigo": "29053200",
    "descricao": "-- Propilenoglicol (propano-1,2-diol)"
  },
  {
    "codigo": "29053910",
    "descricao": "2-Metil-2,4-pentanodiol (hexilenoglicol)"
  },
  {
    "codigo": "29053920",
    "descricao": "Trimetilenoglicol (1,3-propanodiol)"
  },
  {
    "codigo": "29053930",
    "descricao": "1,3-Butilenoglicol (1,3-butanodiol)"
  },
  {
    "codigo": "29053990",
    "descricao": "Outros"
  },
  {
    "codigo": "29054100",
    "descricao": "-- 2-Etil-2-(hidroximetil)propano-1,3-diol (trimetilolpropano)"
  },
  {
    "codigo": "29054200",
    "descricao": "-- Pentaeritritol (pentaeritrita)"
  },
  {
    "codigo": "29054300",
    "descricao": "-- Manitol"
  },
  {
    "codigo": "29054400",
    "descricao": "-- D-glucitol (sorbitol)"
  },
  {
    "codigo": "29054500",
    "descricao": "-- Glicerol"
  },
  {
    "codigo": "29054900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "29055100",
    "descricao": "-- Etclorvinol (DCI)"
  },
  {
    "codigo": "29055910",
    "descricao": "Hidrato de cloral"
  },
  {
    "codigo": "29055990",
    "descricao": "Outros"
  },
  {
    "codigo": "29061100",
    "descricao": "-- Mentol"
  },
  {
    "codigo": "29061200",
    "descricao": "-- Cicloexanol, metilcicloexanóis e dimetilcicloexanóis"
  },
  {
    "codigo": "29061300",
    "descricao": "-- Esteróis e inositóis"
  },
  {
    "codigo": "29061910",
    "descricao": "Derivados do mentol"
  },
  {
    "codigo": "29061920",
    "descricao": "Borneol; isoborneol"
  },
  {
    "codigo": "29061930",
    "descricao": "Terpina e seu hidrato"
  },
  {
    "codigo": "29061940",
    "descricao": "Álcool fenchílico (1,3,3-trimetil-2-norbornanol)"
  },
  {
    "codigo": "29061950",
    "descricao": "Terpineóis"
  },
  {
    "codigo": "29061990",
    "descricao": "Outros"
  },
  {
    "codigo": "29062100",
    "descricao": "-- Álcool benzílico"
  },
  {
    "codigo": "29062910",
    "descricao": "2-Feniletanol"
  },
  {
    "codigo": "29062920",
    "descricao": "Dicofol"
  },
  {
    "codigo": "29062990",
    "descricao": "Outros"
  },
  {
    "codigo": "29071100",
    "descricao": "-- Fenol (hidroxibenzeno) e seus sais"
  },
  {
    "codigo": "29071200",
    "descricao": "-- Cresóis e seus sais"
  },
  {
    "codigo": "29071300",
    "descricao": "-- Octilfenol, nonilfenol, e seus isômeros; sais destes produtos"
  },
  {
    "codigo": "29071510",
    "descricao": "beta-Naftol e seus sais"
  },
  {
    "codigo": "29071590",
    "descricao": "Outros"
  },
  {
    "codigo": "29071910",
    "descricao": "2,6-Di-<i>ter</i>-butil-<i>p</i>-cresol e seus sais"
  },
  {
    "codigo": "29071920",
    "descricao": "<i>o</i>-Fenilfenol e seus sais"
  },
  {
    "codigo": "29071930",
    "descricao": "<i>p</i>-<i>ter</i>-Butilfenol e seus sais"
  },
  {
    "codigo": "29071940",
    "descricao": "Xilenóis e seus sais"
  },
  {
    "codigo": "29071990",
    "descricao": "Outros"
  },
  {
    "codigo": "29072100",
    "descricao": "-- Resorcinol e seus sais"
  },
  {
    "codigo": "29072200",
    "descricao": "-- Hidroquinona e seus sais"
  },
  {
    "codigo": "29072300",
    "descricao": "-- 4,4'-Isopropilidenodifenol (bisfenol A, difenilolpropano) e seus sais"
  },
  {
    "codigo": "29072900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "29081100",
    "descricao": "-- Pentaclorofenol (ISO)"
  },
  {
    "codigo": "29081911",
    "descricao": "4-Cloro-<i>m</i>-cresol e seus sais"
  },
  {
    "codigo": "29081912",
    "descricao": "Diclorofenóis e seus sais"
  },
  {
    "codigo": "29081913",
    "descricao": "<i>p</i>-Clorofenol"
  },
  {
    "codigo": "29081914",
    "descricao": "Triclorofenóis e seus sais"
  },
  {
    "codigo": "29081915",
    "descricao": "Tetraclorofenóis e seus sais"
  },
  {
    "codigo": "29081916",
    "descricao": "Pentaclorofenato de sódio"
  },
  {
    "codigo": "29081919",
    "descricao": "Outros"
  },
  {
    "codigo": "29081921",
    "descricao": "2,4,6-Tribromofenol"
  },
  {
    "codigo": "29081929",
    "descricao": "Outros"
  },
  {
    "codigo": "29081990",
    "descricao": "Outros"
  },
  {
    "codigo": "29089100",
    "descricao": "-- Dinoseb (ISO) e seus sais"
  },
  {
    "codigo": "29089200",
    "descricao": "-- 4,6-Dinitro-<i>o</i>-cresol (DNOC (ISO)) e seus sais"
  },
  {
    "codigo": "29089912",
    "descricao": "<i>p</i>-Nitrofenol e seus sais"
  },
  {
    "codigo": "29089913",
    "descricao": "Ácido pícrico"
  },
  {
    "codigo": "29089919",
    "descricao": "Outros"
  },
  {
    "codigo": "29089921",
    "descricao": "Disofenol"
  },
  {
    "codigo": "29089929",
    "descricao": "Outros"
  },
  {
    "codigo": "29089930",
    "descricao": "Derivados sulfonados do fenol, seus sais e seus ésteres"
  },
  {
    "codigo": "29089990",
    "descricao": "Outros"
  },
  {
    "codigo": "29091100",
    "descricao": "-- Éter dietílico (óxido de dietila)"
  },
  {
    "codigo": "29091910",
    "descricao": "Éter metil-<i>ter</i>-butílico (MTBE)"
  },
  {
    "codigo": "29091920",
    "descricao": "Sevoflurano"
  },
  {
    "codigo": "29091990",
    "descricao": "Outros"
  },
  {
    "codigo": "29092000",
    "descricao": "- Éteres ciclânicos, ciclênicos, cicloterpênicos e seus derivados halogenados, sulfonados, nitrados ou nitrosados"
  },
  {
    "codigo": "29093011",
    "descricao": "Anetol"
  },
  {
    "codigo": "29093012",
    "descricao": "Éter difenílico (éter fenílico)"
  },
  {
    "codigo": "29093013",
    "descricao": "Éter dibenzílico (éter benzílico)"
  },
  {
    "codigo": "29093014",
    "descricao": "Éter feniletil-isoamílico"
  },
  {
    "codigo": "29093019",
    "descricao": "Outros"
  },
  {
    "codigo": "29093021",
    "descricao": "Oxifluorfeno"
  },
  {
    "codigo": "29093022",
    "descricao": "Pentacloroanisol"
  },
  {
    "codigo": "29093023",
    "descricao": "Éteres tetra- ou pentabromodifenílicos"
  },
  {
    "codigo": "29093024",
    "descricao": "Éteres hexa-, hepta- ou octabromodifenílicos"
  },
  {
    "codigo": "29093025",
    "descricao": "Éter decabromodifenílico"
  },
  {
    "codigo": "29093029",
    "descricao": "Outros"
  },
  {
    "codigo": "29094100",
    "descricao": "-- 2,2'-Oxidietanol (dietilenoglicol)"
  },
  {
    "codigo": "29094310",
    "descricao": "Do etilenoglicol"
  },
  {
    "codigo": "29094320",
    "descricao": "Do dietilenoglicol"
  },
  {
    "codigo": "29094411",
    "descricao": "Éter etílico"
  },
  {
    "codigo": "29094412",
    "descricao": "Éter isobutílico"
  },
  {
    "codigo": "29094413",
    "descricao": "Éter hexílico"
  },
  {
    "codigo": "29094419",
    "descricao": "Outros"
  },
  {
    "codigo": "29094421",
    "descricao": "Éter etílico"
  },
  {
    "codigo": "29094429",
    "descricao": "Outros"
  },
  {
    "codigo": "29094910",
    "descricao": "Guaifenesina"
  },
  {
    "codigo": "29094921",
    "descricao": "Trietilenoglicol"
  },
  {
    "codigo": "29094922",
    "descricao": "Tetraetilenoglicol"
  },
  {
    "codigo": "29094923",
    "descricao": "Pentaetilenoglicol e seus éteres"
  },
  {
    "codigo": "29094924",
    "descricao": "Éter fenílico do etilenoglicol"
  },
  {
    "codigo": "29094929",
    "descricao": "Outros"
  },
  {
    "codigo": "29094931",
    "descricao": "Dipropilenoglicol"
  },
  {
    "codigo": "29094932",
    "descricao": "Éteres do mono-, di- e tripropilenoglicol"
  },
  {
    "codigo": "29094939",
    "descricao": "Outros"
  },
  {
    "codigo": "29094941",
    "descricao": "Éter etílico do butilenoglicol"
  },
  {
    "codigo": "29094949",
    "descricao": "Outros"
  },
  {
    "codigo": "29094950",
    "descricao": "Álcoois fenoxibenzílicos"
  },
  {
    "codigo": "29094990",
    "descricao": "Outros"
  },
  {
    "codigo": "29095011",
    "descricao": "Triclosan"
  },
  {
    "codigo": "29095012",
    "descricao": "Eugenol"
  },
  {
    "codigo": "29095013",
    "descricao": "Isoeugenol"
  },
  {
    "codigo": "29095019",
    "descricao": "Outros"
  },
  {
    "codigo": "29095090",
    "descricao": "Outros"
  },
  {
    "codigo": "29096011",
    "descricao": "De di-isopropilbenzeno"
  },
  {
    "codigo": "29096012",
    "descricao": "De <i>ter</i>-butila"
  },
  {
    "codigo": "29096013",
    "descricao": "De <i>p</i>-mentano"
  },
  {
    "codigo": "29096019",
    "descricao": "Outros"
  },
  {
    "codigo": "29096090",
    "descricao": "Outros"
  },
  {
    "codigo": "29101000",
    "descricao": "- Oxirano (óxido de etileno)"
  },
  {
    "codigo": "29102000",
    "descricao": "- Metiloxirano (óxido de propileno)"
  },
  {
    "codigo": "29103000",
    "descricao": "- 1-Cloro-2,3-epoxipropano (epicloridrina)"
  },
  {
    "codigo": "29104000",
    "descricao": "- Dieldrin (ISO, DCI)"
  },
  {
    "codigo": "29105000",
    "descricao": "- Endrin (ISO)"
  },
  {
    "codigo": "29109010",
    "descricao": "Óxido de estireno"
  },
  {
    "codigo": "29109090",
    "descricao": "Outros"
  },
  {
    "codigo": "29110010",
    "descricao": "Dimetilacetal do 2-nitrobenzaldeído"
  },
  {
    "codigo": "29110090",
    "descricao": "Outros"
  },
  {
    "codigo": "29121100",
    "descricao": "-- Metanal (formaldeído)"
  },
  {
    "codigo": "29121200",
    "descricao": "-- Etanal (acetaldeído)"
  },
  {
    "codigo": "29121911",
    "descricao": "Glioxal"
  },
  {
    "codigo": "29121912",
    "descricao": "Glutaraldeído"
  },
  {
    "codigo": "29121919",
    "descricao": "Outros"
  },
  {
    "codigo": "29121921",
    "descricao": "Citral"
  },
  {
    "codigo": "29121922",
    "descricao": "Citronelal (3,7-dimetil-6-octenal)"
  },
  {
    "codigo": "29121923",
    "descricao": "Bergamal (3,7-dimetil-2-metileno-6-octenal)"
  },
  {
    "codigo": "29121929",
    "descricao": "Outros"
  },
  {
    "codigo": "29121991",
    "descricao": "Heptanal"
  },
  {
    "codigo": "29121999",
    "descricao": "Outros"
  },
  {
    "codigo": "29122100",
    "descricao": "-- Benzaldeído (aldeído benzoico)"
  },
  {
    "codigo": "29122910",
    "descricao": "Aldeído alfa-amilcinâmico"
  },
  {
    "codigo": "29122920",
    "descricao": "Aldeído alfa-hexilcinâmico"
  },
  {
    "codigo": "29122990",
    "descricao": "Outros"
  },
  {
    "codigo": "29124100",
    "descricao": "-- Vanilina (aldeído metilprotocatéquico)"
  },
  {
    "codigo": "29124200",
    "descricao": "-- Etilvanilina (aldeído etilprotocatéquico)"
  },
  {
    "codigo": "29124910",
    "descricao": "3-Fenoxibenzaldeído"
  },
  {
    "codigo": "29124920",
    "descricao": "3-Hidroxibenzaldeído"
  },
  {
    "codigo": "29124930",
    "descricao": "3,4,5-Trimetoxibenzaldeído"
  },
  {
    "codigo": "29124941",
    "descricao": "4-(4-Hidroxi-4-metilpentil)-3-cicloexeno-1-carboxialdeído"
  },
  {
    "codigo": "29124949",
    "descricao": "Outros"
  },
  {
    "codigo": "29124990",
    "descricao": "Outros"
  },
  {
    "codigo": "29125000",
    "descricao": "- Polímeros cíclicos dos aldeídos"
  },
  {
    "codigo": "29126000",
    "descricao": "- Paraformaldeído"
  },
  {
    "codigo": "29130010",
    "descricao": "Tricloroacetaldeído"
  },
  {
    "codigo": "29130090",
    "descricao": "Outros"
  },
  {
    "codigo": "29141100",
    "descricao": "-- Acetona"
  },
  {
    "codigo": "29141200",
    "descricao": "-- Butanona (metiletilcetona)"
  },
  {
    "codigo": "29141300",
    "descricao": "-- 4-Metilpentan-2-ona (metilisobutilcetona)"
  },
  {
    "codigo": "29141910",
    "descricao": "Forona"
  },
  {
    "codigo": "29141921",
    "descricao": "Acetilacetona"
  },
  {
    "codigo": "29141922",
    "descricao": "Acetonilacetona"
  },
  {
    "codigo": "29141923",
    "descricao": "Diacetila"
  },
  {
    "codigo": "29141929",
    "descricao": "Outras"
  },
  {
    "codigo": "29141930",
    "descricao": "Metilexilcetona"
  },
  {
    "codigo": "29141940",
    "descricao": "Pseudoiononas"
  },
  {
    "codigo": "29141950",
    "descricao": "Metilisopropilcetona"
  },
  {
    "codigo": "29141990",
    "descricao": "Outras"
  },
  {
    "codigo": "29142210",
    "descricao": "Cicloexanona"
  },
  {
    "codigo": "29142220",
    "descricao": "Metilcicloexanonas"
  },
  {
    "codigo": "29142310",
    "descricao": "Iononas"
  },
  {
    "codigo": "29142320",
    "descricao": "Metiliononas"
  },
  {
    "codigo": "29142910",
    "descricao": "Carvona"
  },
  {
    "codigo": "29142920",
    "descricao": "<i>l</i>-Mentona"
  },
  {
    "codigo": "29142990",
    "descricao": "Outras"
  },
  {
    "codigo": "29143100",
    "descricao": "-- Fenilacetona (fenilpropan-2-ona)"
  },
  {
    "codigo": "29143910",
    "descricao": "Acetofenona"
  },
  {
    "codigo": "29143990",
    "descricao": "Outras"
  },
  {
    "codigo": "29144010",
    "descricao": "4-Hidroxi-4-metilpentan-2-ona (diacetona álcool)"
  },
  {
    "codigo": "29144091",
    "descricao": "Benzoína"
  },
  {
    "codigo": "29144099",
    "descricao": "Outras"
  },
  {
    "codigo": "29145010",
    "descricao": "Nabumetona"
  },
  {
    "codigo": "29145020",
    "descricao": "1,8-Di-hidroxi-3-metil-9-antrona e sua forma enólica (crisarobina ou <i>chrysarobin</i>)"
  },
  {
    "codigo": "29145090",
    "descricao": "Outras"
  },
  {
    "codigo": "29146100",
    "descricao": "-- Antraquinona"
  },
  {
    "codigo": "29146200",
    "descricao": "-- Coenzima Q10 (ubidecarenona (DCI))"
  },
  {
    "codigo": "29146910",
    "descricao": "Lapachol"
  },
  {
    "codigo": "29146920",
    "descricao": "Menadiona"
  },
  {
    "codigo": "29146990",
    "descricao": "Outras"
  },
  {
    "codigo": "29147100",
    "descricao": "-- Clordecona (ISO)"
  },
  {
    "codigo": "29147911",
    "descricao": "1-Cloro-5-hexanona"
  },
  {
    "codigo": "29147919",
    "descricao": "Outros"
  },
  {
    "codigo": "29147921",
    "descricao": "Bissulfito sódico de menadiona"
  },
  {
    "codigo": "29147922",
    "descricao": "Ácido 2-hidroxi-4-metoxibenzofenona-5-sulfônico (sulisobenzona)"
  },
  {
    "codigo": "29147929",
    "descricao": "Outros"
  },
  {
    "codigo": "29147990",
    "descricao": "Outros"
  },
  {
    "codigo": "29151100",
    "descricao": "-- Ácido fórmico"
  },
  {
    "codigo": "29151210",
    "descricao": "De sódio"
  },
  {
    "codigo": "29151290",
    "descricao": "Outros"
  },
  {
    "codigo": "29151310",
    "descricao": "De geranila"
  },
  {
    "codigo": "29151390",
    "descricao": "Outros"
  },
  {
    "codigo": "29152100",
    "descricao": "-- Ácido acético"
  },
  {
    "codigo": "29152400",
    "descricao": "-- Anidrido acético"
  },
  {
    "codigo": "29152910",
    "descricao": "Acetato de sódio"
  },
  {
    "codigo": "29152920",
    "descricao": "Acetatos de cobalto"
  },
  {
    "codigo": "29152990",
    "descricao": "Outros"
  },
  {
    "codigo": "29153100",
    "descricao": "-- Acetato de etila"
  },
  {
    "codigo": "29153200",
    "descricao": "-- Acetato de vinila"
  },
  {
    "codigo": "29153300",
    "descricao": "-- Acetato de <i>n</i>-butila"
  },
  {
    "codigo": "29153600",
    "descricao": "-- Acetato de dinoseb (ISO)"
  },
  {
    "codigo": "29153910",
    "descricao": "Acetato de linalila"
  },
  {
    "codigo": "29153921",
    "descricao": "Triacetina"
  },
  {
    "codigo": "29153929",
    "descricao": "Outros"
  },
  {
    "codigo": "29153931",
    "descricao": "De <i>n</i>-propila"
  },
  {
    "codigo": "29153932",
    "descricao": "Acetato de 2-etoxietila"
  },
  {
    "codigo": "29153939",
    "descricao": "Outros"
  },
  {
    "codigo": "29153941",
    "descricao": "De decila"
  },
  {
    "codigo": "29153942",
    "descricao": "De hexenila"
  },
  {
    "codigo": "29153951",
    "descricao": "De benzestrol"
  },
  {
    "codigo": "29153952",
    "descricao": "De dienoestrol"
  },
  {
    "codigo": "29153953",
    "descricao": "De hexestrol"
  },
  {
    "codigo": "29153954",
    "descricao": "De mestilbol"
  },
  {
    "codigo": "29153955",
    "descricao": "De estilbestrol"
  },
  {
    "codigo": "29153961",
    "descricao": "De tricloro-alfa-feniletila"
  },
  {
    "codigo": "29153962",
    "descricao": "De triclorometilfenilcarbinila"
  },
  {
    "codigo": "29153963",
    "descricao": "Diacetato de etilenoglicol (diacetato de etileno)"
  },
  {
    "codigo": "29153991",
    "descricao": "De 2-<i>ter</i>-butilcicloexila"
  },
  {
    "codigo": "29153992",
    "descricao": "De bornila"
  },
  {
    "codigo": "29153993",
    "descricao": "De dimetilbenzilcarbinila"
  },
  {
    "codigo": "29153994",
    "descricao": "Bis(<i>p</i>-acetoxifenil)cicloexilidenometano (ciclofenil)"
  },
  {
    "codigo": "29153999",
    "descricao": "Outros"
  },
  {
    "codigo": "29154010",
    "descricao": "Ácido monocloroacético"
  },
  {
    "codigo": "29154020",
    "descricao": "Monocloroacetato de sódio"
  },
  {
    "codigo": "29154090",
    "descricao": "Outros"
  },
  {
    "codigo": "29155010",
    "descricao": "Ácido propiônico"
  },
  {
    "codigo": "29155020",
    "descricao": "Sais"
  },
  {
    "codigo": "29155030",
    "descricao": "Ésteres"
  },
  {
    "codigo": "29156011",
    "descricao": "Ácidos butanoicos e seus sais"
  },
  {
    "codigo": "29156012",
    "descricao": "Butanoato de etila"
  },
  {
    "codigo": "29156019",
    "descricao": "Outros"
  },
  {
    "codigo": "29156021",
    "descricao": "Ácido piválico"
  },
  {
    "codigo": "29156029",
    "descricao": "Outros"
  },
  {
    "codigo": "29157011",
    "descricao": "Ácido palmítico"
  },
  {
    "codigo": "29157019",
    "descricao": "Outros"
  },
  {
    "codigo": "29157020",
    "descricao": "Ácido esteárico"
  },
  {
    "codigo": "29157031",
    "descricao": "De zinco"
  },
  {
    "codigo": "29157039",
    "descricao": "Outros"
  },
  {
    "codigo": "29157040",
    "descricao": "Ésteres do ácido esteárico"
  },
  {
    "codigo": "29159010",
    "descricao": "Cloreto de cloroacetila"
  },
  {
    "codigo": "29159021",
    "descricao": "Ácido 2-etilexanoico (ácido 2-etilexoico)"
  },
  {
    "codigo": "29159022",
    "descricao": "2-Etilexanoato de estanho II"
  },
  {
    "codigo": "29159023",
    "descricao": "Di(2-etilexanoato) de trietilenoglicol"
  },
  {
    "codigo": "29159024",
    "descricao": "Cloreto de 2-etilexanoíla"
  },
  {
    "codigo": "29159029",
    "descricao": "Outros"
  },
  {
    "codigo": "29159031",
    "descricao": "Ácido mirístico"
  },
  {
    "codigo": "29159032",
    "descricao": "Ácido caprílico"
  },
  {
    "codigo": "29159033",
    "descricao": "Miristato de isopropila"
  },
  {
    "codigo": "29159039",
    "descricao": "Outros"
  },
  {
    "codigo": "29159041",
    "descricao": "Ácido láurico"
  },
  {
    "codigo": "29159043",
    "descricao": "Laurato de pentaclorobifenila"
  },
  {
    "codigo": "29159049",
    "descricao": "Outros"
  },
  {
    "codigo": "29159050",
    "descricao": "Peróxidos de ácidos"
  },
  {
    "codigo": "29159060",
    "descricao": "Peroxiácidos"
  },
  {
    "codigo": "29159070",
    "descricao": "Ácidos perfluoroctanoicos e seus sais"
  },
  {
    "codigo": "29159090",
    "descricao": "Outros"
  },
  {
    "codigo": "29161110",
    "descricao": "Ácido acrílico"
  },
  {
    "codigo": "29161120",
    "descricao": "Sais"
  },
  {
    "codigo": "29161210",
    "descricao": "De metila"
  },
  {
    "codigo": "29161220",
    "descricao": "De etila"
  },
  {
    "codigo": "29161230",
    "descricao": "De butila"
  },
  {
    "codigo": "29161240",
    "descricao": "De 2-etilexila"
  },
  {
    "codigo": "29161290",
    "descricao": "Outros"
  },
  {
    "codigo": "29161310",
    "descricao": "Ácido metacrílico"
  },
  {
    "codigo": "29161320",
    "descricao": "Sais"
  },
  {
    "codigo": "29161410",
    "descricao": "De metila"
  },
  {
    "codigo": "29161420",
    "descricao": "De etila"
  },
  {
    "codigo": "29161430",
    "descricao": "De <i>n</i>-butila"
  },
  {
    "codigo": "29161490",
    "descricao": "Outros"
  },
  {
    "codigo": "29161511",
    "descricao": "Oleato de manitol"
  },
  {
    "codigo": "29161519",
    "descricao": "Outros"
  },
  {
    "codigo": "29161520",
    "descricao": "Ácido linoleico; ácido linolênico; seus sais e seus ésteres"
  },
  {
    "codigo": "29161600",
    "descricao": "-- Binapacril (ISO)"
  },
  {
    "codigo": "29161911",
    "descricao": "Sorbato de potássio"
  },
  {
    "codigo": "29161919",
    "descricao": "Outros"
  },
  {
    "codigo": "29161921",
    "descricao": "Ácido undecilênico"
  },
  {
    "codigo": "29161922",
    "descricao": "Undecilenato de metila"
  },
  {
    "codigo": "29161923",
    "descricao": "Undecilenato de zinco"
  },
  {
    "codigo": "29161929",
    "descricao": "Outros"
  },
  {
    "codigo": "29161990",
    "descricao": "Outros"
  },
  {
    "codigo": "29162011",
    "descricao": "Ácido 3-(2,2-dibromovinil)-2,2-dimetilciclopropanocarboxílico"
  },
  {
    "codigo": "29162012",
    "descricao": "Cloreto do ácido 3-(2,2-diclorovinil)-2,2-dimetilciclopropanocarboxílico (DVO)"
  },
  {
    "codigo": "29162013",
    "descricao": "Aletrinas"
  },
  {
    "codigo": "29162014",
    "descricao": "Permetrina"
  },
  {
    "codigo": "29162015",
    "descricao": "Bifentrina"
  },
  {
    "codigo": "29162019",
    "descricao": "Outros"
  },
  {
    "codigo": "29162090",
    "descricao": "Outros"
  },
  {
    "codigo": "29163110",
    "descricao": "Ácido benzoico"
  },
  {
    "codigo": "29163121",
    "descricao": "De sódio"
  },
  {
    "codigo": "29163122",
    "descricao": "De amônio"
  },
  {
    "codigo": "29163129",
    "descricao": "Outros"
  },
  {
    "codigo": "29163131",
    "descricao": "De metila"
  },
  {
    "codigo": "29163132",
    "descricao": "De benzila"
  },
  {
    "codigo": "29163139",
    "descricao": "Outros"
  },
  {
    "codigo": "29163210",
    "descricao": "Peróxido de benzoíla"
  },
  {
    "codigo": "29163220",
    "descricao": "Cloreto de benzoíla"
  },
  {
    "codigo": "29163400",
    "descricao": "-- Ácido fenilacético e seus sais"
  },
  {
    "codigo": "29163910",
    "descricao": "Cloreto de 4-cloro-alfa-(1-metiletil)benzenoacetila"
  },
  {
    "codigo": "29163920",
    "descricao": "Ibuprofeno"
  },
  {
    "codigo": "29163930",
    "descricao": "Ácido 4-cloro-3-nitrobenzoico"
  },
  {
    "codigo": "29163940",
    "descricao": "Perbenzoato de <i>ter</i>-butila"
  },
  {
    "codigo": "29163990",
    "descricao": "Outros"
  },
  {
    "codigo": "29171110",
    "descricao": "Ácido oxálico e seus sais"
  },
  {
    "codigo": "29171120",
    "descricao": "Ésteres"
  },
  {
    "codigo": "29171210",
    "descricao": "Ácido adípico"
  },
  {
    "codigo": "29171220",
    "descricao": "Sais e ésteres"
  },
  {
    "codigo": "29171310",
    "descricao": "Ácido azelaico, seus sais e seus ésteres"
  },
  {
    "codigo": "29171321",
    "descricao": "Ácido sebácico"
  },
  {
    "codigo": "29171322",
    "descricao": "Sebacato de dibutila"
  },
  {
    "codigo": "29171323",
    "descricao": "Sebacato de dioctila"
  },
  {
    "codigo": "29171329",
    "descricao": "Outros"
  },
  {
    "codigo": "29171400",
    "descricao": "-- Anidrido maleico"
  },
  {
    "codigo": "29171910",
    "descricao": "Dioctilsulfossuccinato de sódio"
  },
  {
    "codigo": "29171921",
    "descricao": "Ácido maleico"
  },
  {
    "codigo": "29171922",
    "descricao": "Sais e ésteres"
  },
  {
    "codigo": "29171930",
    "descricao": "Ácido fumárico, seus sais e seus ésteres"
  },
  {
    "codigo": "29171990",
    "descricao": "Outros"
  },
  {
    "codigo": "29172000",
    "descricao": "- Ácidos policarboxílicos ciclânicos, ciclênicos ou cicloterpênicos, seus anidridos, halogenetos, peróxidos, peroxiácidos e seus derivados"
  },
  {
    "codigo": "29173200",
    "descricao": "-- Ortoftalatos de dioctila"
  },
  {
    "codigo": "29173300",
    "descricao": "-- Ortoftalatos de dinonila ou de didecila"
  },
  {
    "codigo": "29173400",
    "descricao": "-- Outros ésteres do ácido ortoftálico"
  },
  {
    "codigo": "29173500",
    "descricao": "-- Anidrido ftálico"
  },
  {
    "codigo": "29173600",
    "descricao": "-- Ácido tereftálico e seus sais"
  },
  {
    "codigo": "29173700",
    "descricao": "-- Tereftalato de dimetila"
  },
  {
    "codigo": "29173911",
    "descricao": "Ésteres"
  },
  {
    "codigo": "29173919",
    "descricao": "Outros"
  },
  {
    "codigo": "29173920",
    "descricao": "Ácido ortoftálico e seus sais"
  },
  {
    "codigo": "29173931",
    "descricao": "De dioctila"
  },
  {
    "codigo": "29173939",
    "descricao": "Outros"
  },
  {
    "codigo": "29173940",
    "descricao": "Sais e ésteres do ácido trimelítico (sais e ésteres do ácido 1,2,4-benzenotricarboxílico)"
  },
  {
    "codigo": "29173950",
    "descricao": "Anidrido trimelítico (ácido 1,3-dioxo-5-isobenzofuranocarboxílico)"
  },
  {
    "codigo": "29173990",
    "descricao": "Outros"
  },
  {
    "codigo": "29181100",
    "descricao": "-- Ácido láctico, seus sais e seus ésteres"
  },
  {
    "codigo": "29181200",
    "descricao": "-- Ácido tartárico"
  },
  {
    "codigo": "29181310",
    "descricao": "Sais"
  },
  {
    "codigo": "29181320",
    "descricao": "Ésteres"
  },
  {
    "codigo": "29181400",
    "descricao": "-- Ácido cítrico"
  },
  {
    "codigo": "29181500",
    "descricao": "-- Sais e ésteres do ácido cítrico"
  },
  {
    "codigo": "29181610",
    "descricao": "Gluconato de cálcio"
  },
  {
    "codigo": "29181690",
    "descricao": "Outros"
  },
  {
    "codigo": "29181700",
    "descricao": "-- Ácido 2,2-difenil-2-hidroxiacético (ácido benzílico)"
  },
  {
    "codigo": "29181800",
    "descricao": "-- Clorobenzilato (ISO)"
  },
  {
    "codigo": "29181910",
    "descricao": "Bromopropilato"
  },
  {
    "codigo": "29181921",
    "descricao": "Ursodiol (ácido ursodeoxicólico)"
  },
  {
    "codigo": "29181922",
    "descricao": "Ácido quenodeoxicólico"
  },
  {
    "codigo": "29181929",
    "descricao": "Outros"
  },
  {
    "codigo": "29181930",
    "descricao": "Ácido 12-hidroxiesteárico"
  },
  {
    "codigo": "29181942",
    "descricao": "Sais"
  },
  {
    "codigo": "29181943",
    "descricao": "Ésteres"
  },
  {
    "codigo": "29181990",
    "descricao": "Outros"
  },
  {
    "codigo": "29182110",
    "descricao": "Ácido salicílico"
  },
  {
    "codigo": "29182120",
    "descricao": "Sais"
  },
  {
    "codigo": "29182211",
    "descricao": "Ácido <i>o</i>-acetilsalicílico"
  },
  {
    "codigo": "29182212",
    "descricao": "<i>o</i>-Acetilsalicilato de alumínio"
  },
  {
    "codigo": "29182219",
    "descricao": "Outros"
  },
  {
    "codigo": "29182220",
    "descricao": "Ésteres"
  },
  {
    "codigo": "29182300",
    "descricao": "-- Outros ésteres do ácido salicílico e seus sais"
  },
  {
    "codigo": "29182910",
    "descricao": "Ácidos hidroxinaftoicos"
  },
  {
    "codigo": "29182921",
    "descricao": "Ácido <i>p</i>-hidroxibenzoico"
  },
  {
    "codigo": "29182922",
    "descricao": "Metilparabeno"
  },
  {
    "codigo": "29182923",
    "descricao": "Propilparabeno"
  },
  {
    "codigo": "29182929",
    "descricao": "Outros"
  },
  {
    "codigo": "29182930",
    "descricao": "Ácido gálico, seus sais e seus ésteres"
  },
  {
    "codigo": "29182940",
    "descricao": "Tetrakis(3-(3,5-di-<i>ter</i>-butil-4-hidroxifenil)propionato) de pentaeritritila"
  },
  {
    "codigo": "29182950",
    "descricao": "3-(3,5-Di-<i>ter</i>-butil-4-hidroxifenil)propionato de octadecila"
  },
  {
    "codigo": "29182990",
    "descricao": "Outros"
  },
  {
    "codigo": "29183010",
    "descricao": "Cetoprofeno"
  },
  {
    "codigo": "29183020",
    "descricao": "Butirilacetato de metila"
  },
  {
    "codigo": "29183031",
    "descricao": "Ácido deidrocólico"
  },
  {
    "codigo": "29183032",
    "descricao": "Deidrocolato de sódio"
  },
  {
    "codigo": "29183033",
    "descricao": "Deidrocolato de magnésio"
  },
  {
    "codigo": "29183039",
    "descricao": "Outros"
  },
  {
    "codigo": "29183040",
    "descricao": "Acetilacetato de 2-nitrometilbenzilideno"
  },
  {
    "codigo": "29183090",
    "descricao": "Outros"
  },
  {
    "codigo": "29189100",
    "descricao": "-- 2,4,5-T (ISO) (ácido 2,4,5-triclorofenoxiacético), seus sais e seus ésteres"
  },
  {
    "codigo": "29189911",
    "descricao": "Ácido fenoxiacético, seus sais e seus ésteres"
  },
  {
    "codigo": "29189912",
    "descricao": "Ácido 2,4-diclorofenoxiacético (2,4-D), seus sais e seus ésteres"
  },
  {
    "codigo": "29189919",
    "descricao": "Outros"
  },
  {
    "codigo": "29189921",
    "descricao": "Ácidos diclorofenoxibutanoicos, seus sais e seus ésteres"
  },
  {
    "codigo": "29189929",
    "descricao": "Outros"
  },
  {
    "codigo": "29189930",
    "descricao": "Acifluorfen sódico"
  },
  {
    "codigo": "29189940",
    "descricao": "Naproxeno"
  },
  {
    "codigo": "29189950",
    "descricao": "Ácido 3-(2-cloro-alfa, alfa, alfa-trifluor-<i>p</i>-toliloxi)benzoico"
  },
  {
    "codigo": "29189960",
    "descricao": "Diclofop-metila"
  },
  {
    "codigo": "29189991",
    "descricao": "Fenofibrato"
  },
  {
    "codigo": "29189992",
    "descricao": "Ácidos metilclorofenoxiacéticos, seus sais e seus ésteres"
  },
  {
    "codigo": "29189993",
    "descricao": "5-(2-Cloro-4-trifluorometilfenoxi)-2-nitrobenzoato de 1'-(carboetoxi)etila (lactofen)"
  },
  {
    "codigo": "29189994",
    "descricao": "Ácido 4-(4-hidroxifenoxi)-3,5-di-iodofenilacético"
  },
  {
    "codigo": "29189999",
    "descricao": "Outros"
  },
  {
    "codigo": "29191000",
    "descricao": "- Fosfato de tris(2,3-dibromopropila)"
  },
  {
    "codigo": "29199010",
    "descricao": "De tributila"
  },
  {
    "codigo": "29199020",
    "descricao": "De tricresila"
  },
  {
    "codigo": "29199030",
    "descricao": "De trifenila"
  },
  {
    "codigo": "29199040",
    "descricao": "Diclorvós (DDVP)"
  },
  {
    "codigo": "29199050",
    "descricao": "Lactofosfato de cálcio"
  },
  {
    "codigo": "29199060",
    "descricao": "Clorfenvinfós"
  },
  {
    "codigo": "29199090",
    "descricao": "Outros"
  },
  {
    "codigo": "29201110",
    "descricao": "Paration (etil paration)"
  },
  {
    "codigo": "29201120",
    "descricao": "Paration-metila (metil paration)"
  },
  {
    "codigo": "29201910",
    "descricao": "Fenitrotion"
  },
  {
    "codigo": "29201920",
    "descricao": "Cloreto de fosforotioato de dimetila"
  },
  {
    "codigo": "29201990",
    "descricao": "Outros"
  },
  {
    "codigo": "29202100",
    "descricao": "-- Fosfito de dimetila"
  },
  {
    "codigo": "29202200",
    "descricao": "-- Fosfito de dietila"
  },
  {
    "codigo": "29202300",
    "descricao": "-- Fosfito de trimetila"
  },
  {
    "codigo": "29202400",
    "descricao": "-- Fosfito de trietila"
  },
  {
    "codigo": "29202910",
    "descricao": "Fosfito de alquila de C<sub>3</sub> a C<sub>13</sub> ou de alquil-arila"
  },
  {
    "codigo": "29202920",
    "descricao": "Fosfito de difenila"
  },
  {
    "codigo": "29202930",
    "descricao": "Outros fosfitos, de arila"
  },
  {
    "codigo": "29202940",
    "descricao": "Fosetil Al"
  },
  {
    "codigo": "29202950",
    "descricao": "Fosfito de tris(2,4-di-<i>ter</i>-butilfenila)"
  },
  {
    "codigo": "29202990",
    "descricao": "Outros"
  },
  {
    "codigo": "29203000",
    "descricao": "- Endossulfan (ISO)"
  },
  {
    "codigo": "29209022",
    "descricao": "Propargite"
  },
  {
    "codigo": "29209029",
    "descricao": "Outros"
  },
  {
    "codigo": "29209031",
    "descricao": "De propatila"
  },
  {
    "codigo": "29209032",
    "descricao": "Nitroglicerina"
  },
  {
    "codigo": "29209033",
    "descricao": "Tetranitrato de pentaeritritol (PETN, nitropenta, pentrita)"
  },
  {
    "codigo": "29209039",
    "descricao": "Outros"
  },
  {
    "codigo": "29209041",
    "descricao": "De alquila de C<sub>6</sub> a C<sub>22</sub>"
  },
  {
    "codigo": "29209042",
    "descricao": "De monoalquildietilenoglicol ou de monoalquiltrietilenoglicol"
  },
  {
    "codigo": "29209049",
    "descricao": "Outros"
  },
  {
    "codigo": "29209051",
    "descricao": "De etila"
  },
  {
    "codigo": "29209059",
    "descricao": "Outros"
  },
  {
    "codigo": "29209090",
    "descricao": "Outros"
  },
  {
    "codigo": "29211111",
    "descricao": "Monometilamina"
  },
  {
    "codigo": "29211112",
    "descricao": "Sais"
  },
  {
    "codigo": "29211121",
    "descricao": "Dimetilamina"
  },
  {
    "codigo": "29211122",
    "descricao": "2,4-Diclorofenoxiacetato de dimetilamina"
  },
  {
    "codigo": "29211123",
    "descricao": "Metilclorofenoxiacetato de dimetilamina"
  },
  {
    "codigo": "29211129",
    "descricao": "Outros"
  },
  {
    "codigo": "29211131",
    "descricao": "Trimetilamina"
  },
  {
    "codigo": "29211132",
    "descricao": "Cloridrato de trimetilamina"
  },
  {
    "codigo": "29211139",
    "descricao": "Outros"
  },
  {
    "codigo": "29211200",
    "descricao": "-- Cloridrato de 2-cloroetil(N,N-dimetilamina)"
  },
  {
    "codigo": "29211300",
    "descricao": "-- Cloridrato de 2-cloroetil(N,N-dietilamina)"
  },
  {
    "codigo": "29211400",
    "descricao": "-- Cloridrato de 2-cloroetil(N,N-di-isopropilamina)"
  },
  {
    "codigo": "29211911",
    "descricao": "Monoetilamina e seus sais"
  },
  {
    "codigo": "29211912",
    "descricao": "Trietilamina"
  },
  {
    "codigo": "29211913",
    "descricao": "Bis(2-cloroetil)etilamina"
  },
  {
    "codigo": "29211914",
    "descricao": "Triclormetina (DCI) (tris(2-cloroetil)amina)"
  },
  {
    "codigo": "29211915",
    "descricao": "Dietilamina e seus sais, exceto etansilato (<i>ethamsylate</i>)"
  },
  {
    "codigo": "29211919",
    "descricao": "Outros"
  },
  {
    "codigo": "29211921",
    "descricao": "Mono-<i>n</i>-propilamina e seus sais"
  },
  {
    "codigo": "29211922",
    "descricao": "Di-<i>n</i>-propilamina e seus sais"
  },
  {
    "codigo": "29211923",
    "descricao": "Monoisopropilamina e seus sais"
  },
  {
    "codigo": "29211924",
    "descricao": "Di-isopropilamina e seus sais"
  },
  {
    "codigo": "29211929",
    "descricao": "Outros"
  },
  {
    "codigo": "29211931",
    "descricao": "Di-isobutilamina e seus sais"
  },
  {
    "codigo": "29211939",
    "descricao": "Outros"
  },
  {
    "codigo": "29211941",
    "descricao": "Metildialquilaminas"
  },
  {
    "codigo": "29211949",
    "descricao": "Outras"
  },
  {
    "codigo": "29211991",
    "descricao": "Clormetina (DCI) (bis(2-cloroetil)metilamina)"
  },
  {
    "codigo": "29211992",
    "descricao": "N,N-Dialquil-2-cloroetilamina, com grupos alquila de C<sub>1</sub> a C<sub>3</sub>, e seus sais protonados"
  },
  {
    "codigo": "29211993",
    "descricao": "Mucato de isometepteno"
  },
  {
    "codigo": "29211994",
    "descricao": "N,N-Dimetilcetilamina"
  },
  {
    "codigo": "29211999",
    "descricao": "Outros"
  },
  {
    "codigo": "29212100",
    "descricao": "-- Etilenodiamina e seus sais"
  },
  {
    "codigo": "29212200",
    "descricao": "-- Hexametilenodiamina e seus sais"
  },
  {
    "codigo": "29212910",
    "descricao": "Dietilenotriamina e seus sais"
  },
  {
    "codigo": "29212920",
    "descricao": "Trietilenotetramina e seus sais"
  },
  {
    "codigo": "29212990",
    "descricao": "Outros"
  },
  {
    "codigo": "29213011",
    "descricao": "Monocicloexilamina e seus sais"
  },
  {
    "codigo": "29213012",
    "descricao": "Dicicloexilamina"
  },
  {
    "codigo": "29213019",
    "descricao": "Outros"
  },
  {
    "codigo": "29213020",
    "descricao": "Propilexedrina"
  },
  {
    "codigo": "29213090",
    "descricao": "Outros"
  },
  {
    "codigo": "29214100",
    "descricao": "-- Anilina e seus sais"
  },
  {
    "codigo": "29214211",
    "descricao": "Ácido sulfanílico e seus sais"
  },
  {
    "codigo": "29214219",
    "descricao": "Outros"
  },
  {
    "codigo": "29214221",
    "descricao": "3,4-Dicloroanilina e seus sais"
  },
  {
    "codigo": "29214229",
    "descricao": "Outros"
  },
  {
    "codigo": "29214231",
    "descricao": "4-Nitroanilina"
  },
  {
    "codigo": "29214239",
    "descricao": "Outros"
  },
  {
    "codigo": "29214241",
    "descricao": "5-Cloro-2-nitroanilina"
  },
  {
    "codigo": "29214249",
    "descricao": "Outros"
  },
  {
    "codigo": "29214290",
    "descricao": "Outros"
  },
  {
    "codigo": "29214311",
    "descricao": "<i>o</i>-Toluidina"
  },
  {
    "codigo": "29214319",
    "descricao": "Outros"
  },
  {
    "codigo": "29214321",
    "descricao": "3-Nitro-4-toluidina e seus sais"
  },
  {
    "codigo": "29214322",
    "descricao": "Trifluralina"
  },
  {
    "codigo": "29214323",
    "descricao": "4-Cloro-2-toluidina"
  },
  {
    "codigo": "29214329",
    "descricao": "Outros"
  },
  {
    "codigo": "29214410",
    "descricao": "Difenilamina e seus sais"
  },
  {
    "codigo": "29214421",
    "descricao": "<i>n</i>-Octildifenilamina"
  },
  {
    "codigo": "29214422",
    "descricao": "<i>n</i>-Nonildifenilamina"
  },
  {
    "codigo": "29214429",
    "descricao": "Outros"
  },
  {
    "codigo": "29214500",
    "descricao": "-- 1-Naftilamina (alfa-naftilamina), 2-naftilamina (beta-naftilamina), e seus derivados; sais destes produtos"
  },
  {
    "codigo": "29214610",
    "descricao": "Anfetamina e seus sais"
  },
  {
    "codigo": "29214620",
    "descricao": "Benzofetamina e seus sais"
  },
  {
    "codigo": "29214630",
    "descricao": "Dexanfetamina e seus sais"
  },
  {
    "codigo": "29214640",
    "descricao": "Etilanfetamina e seus sais"
  },
  {
    "codigo": "29214650",
    "descricao": "Fencanfamina e seus sais"
  },
  {
    "codigo": "29214660",
    "descricao": "Fentermina e seus sais"
  },
  {
    "codigo": "29214670",
    "descricao": "Lefetamina e seus sais"
  },
  {
    "codigo": "29214680",
    "descricao": "Levanfetamina e seus sais"
  },
  {
    "codigo": "29214690",
    "descricao": "Mefenorex e seus sais"
  },
  {
    "codigo": "29214910",
    "descricao": "Cloridrato de fenfluramina"
  },
  {
    "codigo": "29214921",
    "descricao": "2,4-Xilidina e seus sais"
  },
  {
    "codigo": "29214922",
    "descricao": "Pendimetalina"
  },
  {
    "codigo": "29214929",
    "descricao": "Outros"
  },
  {
    "codigo": "29214931",
    "descricao": "Sulfato de tranilcipromina"
  },
  {
    "codigo": "29214939",
    "descricao": "Outros"
  },
  {
    "codigo": "29214990",
    "descricao": "Outros"
  },
  {
    "codigo": "29215111",
    "descricao": "<i>m</i>-Fenilenodiamina e seus sais"
  },
  {
    "codigo": "29215112",
    "descricao": "Diaminotoluenos (toluilenodiaminas)"
  },
  {
    "codigo": "29215119",
    "descricao": "Outros"
  },
  {
    "codigo": "29215120",
    "descricao": "Derivados sulfonados das fenilenodiaminas e de seus derivados; sais destes produtos"
  },
  {
    "codigo": "29215131",
    "descricao": "N,N'-Di-<i>sec</i>-butil-<i>p</i>-fenilenodiamina"
  },
  {
    "codigo": "29215132",
    "descricao": "N-Isopropil-N'-fenil-<i>p</i>-fenilenodiamina"
  },
  {
    "codigo": "29215133",
    "descricao": "N-(1,3-Dimetilbutil)-N'-fenil-<i>p</i>-fenilenodiamina"
  },
  {
    "codigo": "29215134",
    "descricao": "N-(1,4-Dimetilpentil)-N'-fenil-<i>p</i>-fenilenodiamina"
  },
  {
    "codigo": "29215135",
    "descricao": "N-Fenil-<i>p</i>-fenilenodiamina (4-aminodifenilamina) e seus sais"
  },
  {
    "codigo": "29215139",
    "descricao": "Outros"
  },
  {
    "codigo": "29215190",
    "descricao": "Outros"
  },
  {
    "codigo": "29215911",
    "descricao": "3,3'-Diclorobenzidina"
  },
  {
    "codigo": "29215919",
    "descricao": "Outros"
  },
  {
    "codigo": "29215921",
    "descricao": "4,4'-Diaminodifenilmetano"
  },
  {
    "codigo": "29215929",
    "descricao": "Outros"
  },
  {
    "codigo": "29215931",
    "descricao": "4,4'-Diaminodifenilamina e seus sais"
  },
  {
    "codigo": "29215932",
    "descricao": "Ácido 4,4'-diaminodifenilamino-2-sulfônico e seus sais"
  },
  {
    "codigo": "29215939",
    "descricao": "Outros"
  },
  {
    "codigo": "29215990",
    "descricao": "Outros"
  },
  {
    "codigo": "29221100",
    "descricao": "-- Monoetanolamina e seus sais"
  },
  {
    "codigo": "29221200",
    "descricao": "-- Dietanolamina e seus sais"
  },
  {
    "codigo": "29221400",
    "descricao": "-- Dextropropoxifeno (DCI) e seus sais"
  },
  {
    "codigo": "29221500",
    "descricao": "-- Trietanolamina"
  },
  {
    "codigo": "29221600",
    "descricao": "-- Perfluoroctanossulfonato de dietanolamônio"
  },
  {
    "codigo": "29221700",
    "descricao": "-- Metildietanolamina e etildietanolamina"
  },
  {
    "codigo": "29221800",
    "descricao": "-- 2-(N,N-di-isopropilamino)etanol"
  },
  {
    "codigo": "29221911",
    "descricao": "Monoisopropanolamina"
  },
  {
    "codigo": "29221912",
    "descricao": "2,4-Diclorofenoxiacetato de triisopropanolamina"
  },
  {
    "codigo": "29221913",
    "descricao": "2,4-Diclorofenoxiacetato de dimetilpropanolamina"
  },
  {
    "codigo": "29221919",
    "descricao": "Outros"
  },
  {
    "codigo": "29221921",
    "descricao": "Citrato"
  },
  {
    "codigo": "29221929",
    "descricao": "Outros"
  },
  {
    "codigo": "29221931",
    "descricao": "Cloridrato"
  },
  {
    "codigo": "29221939",
    "descricao": "Outros"
  },
  {
    "codigo": "29221941",
    "descricao": "Cloridrato"
  },
  {
    "codigo": "29221949",
    "descricao": "Outros"
  },
  {
    "codigo": "29221951",
    "descricao": "N,N-Dimetil-2-aminoetanol e seus sais protonados"
  },
  {
    "codigo": "29221952",
    "descricao": "N,N-Dietil-2-aminoetanol e seus sais protonados"
  },
  {
    "codigo": "29221959",
    "descricao": "Outros"
  },
  {
    "codigo": "29221971",
    "descricao": "Cloridrato"
  },
  {
    "codigo": "29221979",
    "descricao": "Outros"
  },
  {
    "codigo": "29221981",
    "descricao": "Tartarato"
  },
  {
    "codigo": "29221989",
    "descricao": "Outros"
  },
  {
    "codigo": "29221991",
    "descricao": "1-<i>p</i>-Nitrofenil-2-amino-1,3-propanodiol"
  },
  {
    "codigo": "29221992",
    "descricao": "Fumarato de benciclano"
  },
  {
    "codigo": "29221993",
    "descricao": "Clembuterol (<i>clenbuterol</i>) e seu cloridrato"
  },
  {
    "codigo": "29221994",
    "descricao": "Mirtecaína"
  },
  {
    "codigo": "29221995",
    "descricao": "Tamoxifen e seu citrato"
  },
  {
    "codigo": "29221996",
    "descricao": "Propranolol e seus sais"
  },
  {
    "codigo": "29221999",
    "descricao": "Outros"
  },
  {
    "codigo": "29222100",
    "descricao": "-- Ácidos aminohidroxinaftalenossulfônicos e seus sais"
  },
  {
    "codigo": "29222911",
    "descricao": "<i>p</i>-Aminofenol"
  },
  {
    "codigo": "29222919",
    "descricao": "Outros"
  },
  {
    "codigo": "29222920",
    "descricao": "Nitroanisidinas e seus sais"
  },
  {
    "codigo": "29222990",
    "descricao": "Outros"
  },
  {
    "codigo": "29223111",
    "descricao": "Anfepramona"
  },
  {
    "codigo": "29223112",
    "descricao": "Sais"
  },
  {
    "codigo": "29223120",
    "descricao": "Metadona e seus sais"
  },
  {
    "codigo": "29223130",
    "descricao": "Normetadona e seus sais"
  },
  {
    "codigo": "29223910",
    "descricao": "Aminoantraquinonas e seus sais"
  },
  {
    "codigo": "29223921",
    "descricao": "Cloridrato"
  },
  {
    "codigo": "29223929",
    "descricao": "Outros"
  },
  {
    "codigo": "29223990",
    "descricao": "Outros"
  },
  {
    "codigo": "29224110",
    "descricao": "Lisina"
  },
  {
    "codigo": "29224190",
    "descricao": "Outros"
  },
  {
    "codigo": "29224210",
    "descricao": "Ácido glutâmico"
  },
  {
    "codigo": "29224220",
    "descricao": "Sais"
  },
  {
    "codigo": "29224300",
    "descricao": "-- Ácido antranílico e seus sais"
  },
  {
    "codigo": "29224410",
    "descricao": "Tilidina"
  },
  {
    "codigo": "29224420",
    "descricao": "Sais"
  },
  {
    "codigo": "29224910",
    "descricao": "Glicina e seus sais"
  },
  {
    "codigo": "29224920",
    "descricao": "Ácido etilenodiaminotetracético (EDTA) e seus sais"
  },
  {
    "codigo": "29224931",
    "descricao": "Ácido iminodiacético"
  },
  {
    "codigo": "29224932",
    "descricao": "Sais"
  },
  {
    "codigo": "29224940",
    "descricao": "Ácido dietilenotriaminopentacético e seus sais"
  },
  {
    "codigo": "29224951",
    "descricao": "alfa-Fenilglicina"
  },
  {
    "codigo": "29224952",
    "descricao": "Cloridrato de cloreto de D(-)alfa-aminobenzenoacetila"
  },
  {
    "codigo": "29224959",
    "descricao": "Outros"
  },
  {
    "codigo": "29224961",
    "descricao": "Diclofenaco de sódio"
  },
  {
    "codigo": "29224962",
    "descricao": "Diclofenaco de potássio"
  },
  {
    "codigo": "29224963",
    "descricao": "Diclofenaco de dietilamônio"
  },
  {
    "codigo": "29224964",
    "descricao": "Diclofenaco"
  },
  {
    "codigo": "29224969",
    "descricao": "Outros"
  },
  {
    "codigo": "29224990",
    "descricao": "Outros"
  },
  {
    "codigo": "29225011",
    "descricao": "Cloridrato"
  },
  {
    "codigo": "29225019",
    "descricao": "Outros"
  },
  {
    "codigo": "29225031",
    "descricao": "Levodopa"
  },
  {
    "codigo": "29225032",
    "descricao": "Metildopa"
  },
  {
    "codigo": "29225039",
    "descricao": "Outros"
  },
  {
    "codigo": "29225091",
    "descricao": "N-(1-(Metoxicarbonil)propen-2-il)-alfa-amino-<i>p</i>-hidroxifenilacetato de sódio (NAPOH)"
  },
  {
    "codigo": "29225099",
    "descricao": "Outros"
  },
  {
    "codigo": "29231000",
    "descricao": "- Colina e seus sais"
  },
  {
    "codigo": "29232000",
    "descricao": "- Lecitinas e outros fosfoaminolipídios"
  },
  {
    "codigo": "29233000",
    "descricao": "- Perfluoroctanossulfonato de tetraetilamônio"
  },
  {
    "codigo": "29234000",
    "descricao": "- Perfluoroctanossulfonato de didecildimetilamônio"
  },
  {
    "codigo": "29239010",
    "descricao": "Betaína e seus sais"
  },
  {
    "codigo": "29239020",
    "descricao": "Derivados da colina"
  },
  {
    "codigo": "29239030",
    "descricao": "Cloreto de 3-cloro-2-hidroxipropiltrimetilamônio"
  },
  {
    "codigo": "29239040",
    "descricao": "Halogenetos de alquil-trimetilamônio, com grupo alquila de C<sub>6</sub> a C<sub>22</sub>"
  },
  {
    "codigo": "29239050",
    "descricao": "Halogenetos de dialquil-dimetilamônio ou de alquil-benzil-dimetilamônio, com grupo alquila de C<sub>6</sub> a C<sub>22</sub>"
  },
  {
    "codigo": "29239060",
    "descricao": "Halogenetos de pentametil-alquil-propilenodiamônio, com grupo alquila de C<sub>6</sub> a C<sub>22</sub>"
  },
  {
    "codigo": "29239090",
    "descricao": "Outros"
  },
  {
    "codigo": "29241100",
    "descricao": "-- Meprobamato (DCI)"
  },
  {
    "codigo": "29241210",
    "descricao": "Fluoracetamida"
  },
  {
    "codigo": "29241220",
    "descricao": "Fosfamidona"
  },
  {
    "codigo": "29241230",
    "descricao": "Monocrotofós"
  },
  {
    "codigo": "29241911",
    "descricao": "2-Cloro-N-metilacetoacetamida"
  },
  {
    "codigo": "29241919",
    "descricao": "Outros"
  },
  {
    "codigo": "29241921",
    "descricao": "N-Metilformamida"
  },
  {
    "codigo": "29241922",
    "descricao": "N,N-Dimetilformamida"
  },
  {
    "codigo": "29241929",
    "descricao": "Outras"
  },
  {
    "codigo": "29241931",
    "descricao": "Acrilamida"
  },
  {
    "codigo": "29241932",
    "descricao": "Metacrilamidas"
  },
  {
    "codigo": "29241939",
    "descricao": "Outros"
  },
  {
    "codigo": "29241942",
    "descricao": "Dicrotofós"
  },
  {
    "codigo": "29241949",
    "descricao": "Outros"
  },
  {
    "codigo": "29241991",
    "descricao": "N,N'-Dimetilureia"
  },
  {
    "codigo": "29241992",
    "descricao": "Carisoprodol"
  },
  {
    "codigo": "29241993",
    "descricao": "N,N'-(Diestearoil)etilenodiamina (N,N'-etilen-bis-estearamida)"
  },
  {
    "codigo": "29241994",
    "descricao": "Dietanolamidas de ácidos graxos (gordos) de C<sub>12</sub> a C<sub>18</sub>"
  },
  {
    "codigo": "29241999",
    "descricao": "Outros"
  },
  {
    "codigo": "29242111",
    "descricao": "Hexanitrocarbanilidas"
  },
  {
    "codigo": "29242119",
    "descricao": "Outros"
  },
  {
    "codigo": "29242120",
    "descricao": "Diuron"
  },
  {
    "codigo": "29242190",
    "descricao": "Outros"
  },
  {
    "codigo": "29242300",
    "descricao": "-- Ácido 2-acetamidobenzoico (ácido N-acetilantranílico) e seus sais"
  },
  {
    "codigo": "29242400",
    "descricao": "-- Etinamato (DCI)"
  },
  {
    "codigo": "29242500",
    "descricao": "-- Alaclor (ISO)"
  },
  {
    "codigo": "29242911",
    "descricao": "Acetanilida"
  },
  {
    "codigo": "29242912",
    "descricao": "4-Aminoacetanilida"
  },
  {
    "codigo": "29242913",
    "descricao": "Acetaminofen (paracetamol)"
  },
  {
    "codigo": "29242914",
    "descricao": "Lidocaína e seu cloridrato"
  },
  {
    "codigo": "29242915",
    "descricao": "2,5-Dimetoxiacetanilida"
  },
  {
    "codigo": "29242919",
    "descricao": "Outros"
  },
  {
    "codigo": "29242920",
    "descricao": "Anilidas dos ácidos hidroxinaftoicos e seus derivados; sais destes produtos"
  },
  {
    "codigo": "29242931",
    "descricao": "Carbaril"
  },
  {
    "codigo": "29242932",
    "descricao": "Propoxur"
  },
  {
    "codigo": "29242939",
    "descricao": "Outros"
  },
  {
    "codigo": "29242941",
    "descricao": "Teclozam"
  },
  {
    "codigo": "29242943",
    "descricao": "Atenolol; metolaclor"
  },
  {
    "codigo": "29242944",
    "descricao": "Ácido ioxáglico"
  },
  {
    "codigo": "29242945",
    "descricao": "Iodamida"
  },
  {
    "codigo": "29242946",
    "descricao": "Cloreto do ácido <i>p</i>-acetamidobenzenossulfônico"
  },
  {
    "codigo": "29242947",
    "descricao": "Ácido ioxitalâmico"
  },
  {
    "codigo": "29242949",
    "descricao": "Outros"
  },
  {
    "codigo": "29242951",
    "descricao": "Bromoprida"
  },
  {
    "codigo": "29242952",
    "descricao": "Metoclopramida e seu cloridrato"
  },
  {
    "codigo": "29242959",
    "descricao": "Outros"
  },
  {
    "codigo": "29242961",
    "descricao": "Propanil"
  },
  {
    "codigo": "29242962",
    "descricao": "Flutamida"
  },
  {
    "codigo": "29242963",
    "descricao": "Prilocaína e seu cloridrato"
  },
  {
    "codigo": "29242964",
    "descricao": "Iobitridol"
  },
  {
    "codigo": "29242969",
    "descricao": "Outros"
  },
  {
    "codigo": "29242991",
    "descricao": "Aspartame"
  },
  {
    "codigo": "29242992",
    "descricao": "Diflubenzurom"
  },
  {
    "codigo": "29242993",
    "descricao": "Metalaxil"
  },
  {
    "codigo": "29242994",
    "descricao": "Triflumurom"
  },
  {
    "codigo": "29242995",
    "descricao": "Buclosamida"
  },
  {
    "codigo": "29242996",
    "descricao": "Benzoato de denatônio"
  },
  {
    "codigo": "29242999",
    "descricao": "Outros"
  },
  {
    "codigo": "29251100",
    "descricao": "-- Sacarina e seus sais"
  },
  {
    "codigo": "29251200",
    "descricao": "-- Glutetimida (DCI)"
  },
  {
    "codigo": "29251910",
    "descricao": "Talidomida"
  },
  {
    "codigo": "29251990",
    "descricao": "Outros"
  },
  {
    "codigo": "29252100",
    "descricao": "-- Clordimeforme (ISO)"
  },
  {
    "codigo": "29252911",
    "descricao": "Aspartato de L-arginina"
  },
  {
    "codigo": "29252919",
    "descricao": "Outros"
  },
  {
    "codigo": "29252921",
    "descricao": "Guanidina"
  },
  {
    "codigo": "29252922",
    "descricao": "N,N'-Difenilguanidina"
  },
  {
    "codigo": "29252923",
    "descricao": "Clorexidina e seus sais"
  },
  {
    "codigo": "29252929",
    "descricao": "Outros"
  },
  {
    "codigo": "29252930",
    "descricao": "Amitraz"
  },
  {
    "codigo": "29252940",
    "descricao": "Isetionato de pentamidina"
  },
  {
    "codigo": "29252950",
    "descricao": "N-(3,7-Dimetil-7-hidroxioctilideno)antranilato de metila"
  },
  {
    "codigo": "29252990",
    "descricao": "Outros"
  },
  {
    "codigo": "29261000",
    "descricao": "- Acrilonitrila"
  },
  {
    "codigo": "29262000",
    "descricao": "- 1-Cianoguanidina (diciandiamida)"
  },
  {
    "codigo": "29263011",
    "descricao": "Fenproporex"
  },
  {
    "codigo": "29263012",
    "descricao": "Sais"
  },
  {
    "codigo": "29263020",
    "descricao": "Intermediário da metadona"
  },
  {
    "codigo": "29264000",
    "descricao": "- alfa-Fenilacetoacetonitrila"
  },
  {
    "codigo": "29269011",
    "descricao": "Verapamil"
  },
  {
    "codigo": "29269012",
    "descricao": "Cloridrato"
  },
  {
    "codigo": "29269019",
    "descricao": "Outros"
  },
  {
    "codigo": "29269021",
    "descricao": "Álcool alfa-ciano-3-fenoxibenzílico"
  },
  {
    "codigo": "29269022",
    "descricao": "Ciflutrina"
  },
  {
    "codigo": "29269023",
    "descricao": "Cipermetrina"
  },
  {
    "codigo": "29269024",
    "descricao": "Deltametrina"
  },
  {
    "codigo": "29269025",
    "descricao": "Fenvalerato"
  },
  {
    "codigo": "29269026",
    "descricao": "Cialotrina (<i>cyhalothrin</i>)"
  },
  {
    "codigo": "29269029",
    "descricao": "Outros"
  },
  {
    "codigo": "29269030",
    "descricao": "Sais de intermediário da metadona"
  },
  {
    "codigo": "29269091",
    "descricao": "Adiponitrila (1,4-dicianobutano)"
  },
  {
    "codigo": "29269092",
    "descricao": "Cianidrina de acetona (acetona cianidrina)"
  },
  {
    "codigo": "29269093",
    "descricao": "Closantel"
  },
  {
    "codigo": "29269095",
    "descricao": "Clorotalonil"
  },
  {
    "codigo": "29269096",
    "descricao": "Cianoacrilatos de etila"
  },
  {
    "codigo": "29269099",
    "descricao": "Outros"
  },
  {
    "codigo": "29270010",
    "descricao": "Compostos diazoicos"
  },
  {
    "codigo": "29270021",
    "descricao": "Azodicarbonamida"
  },
  {
    "codigo": "29270029",
    "descricao": "Outros"
  },
  {
    "codigo": "29270030",
    "descricao": "Compostos azóxicos"
  },
  {
    "codigo": "29280011",
    "descricao": "Metiletilacetoxima"
  },
  {
    "codigo": "29280019",
    "descricao": "Outros"
  },
  {
    "codigo": "29280020",
    "descricao": "Carbidopa"
  },
  {
    "codigo": "29280030",
    "descricao": "2-Hidrazinoetanol"
  },
  {
    "codigo": "29280041",
    "descricao": "Fenilidrazina"
  },
  {
    "codigo": "29280042",
    "descricao": "Derivados"
  },
  {
    "codigo": "29280090",
    "descricao": "Outros"
  },
  {
    "codigo": "29291010",
    "descricao": "Di-isocianato de difenilmetano"
  },
  {
    "codigo": "29291021",
    "descricao": "Mistura de isômeros"
  },
  {
    "codigo": "29291029",
    "descricao": "Outros"
  },
  {
    "codigo": "29291030",
    "descricao": "Isocianato de 3,4-diclorofenila"
  },
  {
    "codigo": "29291090",
    "descricao": "Outros"
  },
  {
    "codigo": "29299011",
    "descricao": "De sódio"
  },
  {
    "codigo": "29299012",
    "descricao": "De cálcio"
  },
  {
    "codigo": "29299019",
    "descricao": "Outros"
  },
  {
    "codigo": "29299031",
    "descricao": "Dicloreto de N,N-dimetilfosforoamídico"
  },
  {
    "codigo": "29299039",
    "descricao": "Outros"
  },
  {
    "codigo": "29299040",
    "descricao": "N,N-Dialquilfosforoamidatos de dialquila, com grupos alquila de C<sub>1</sub> a C<sub>3</sub>"
  },
  {
    "codigo": "29299050",
    "descricao": "Fosfonamidofluoridatos de N-(1-(dialquila (de até C<sub>10</sub>, incluindo cicloalquila)amino))alquilideno (H ou de até C<sub>10</sub>, incluindo cicloalquila) e sais alquilados ou protonados destes produtos"
  },
  {
    "codigo": "29299060",
    "descricao": "Fosforamidofluoridatos de O-alquila (H ou de até C<sub>10</sub>, incluindo cicloalquila) N-(1-(dialquila (de até C<sub>10</sub>, incluindo  cicloalquila)amino))alquilideno (H ou de até C<sub>10</sub>, incluindo cicloalquila) e sais alquilados ou protonados destes produtos"
  },
  {
    "codigo": "29299090",
    "descricao": "Outros"
  },
  {
    "codigo": "29301000",
    "descricao": "- 2-(N,N-Dimetilamino)etanotiol"
  },
  {
    "codigo": "29302011",
    "descricao": "EPTC"
  },
  {
    "codigo": "29302012",
    "descricao": "Cartap"
  },
  {
    "codigo": "29302013",
    "descricao": "Tiobencarb (dietiltiocarbamato de S-4-clorobenzila)"
  },
  {
    "codigo": "29302019",
    "descricao": "Outros"
  },
  {
    "codigo": "29302021",
    "descricao": "Ziram; dimetilditiocarbamato de sódio"
  },
  {
    "codigo": "29302022",
    "descricao": "Dietilditiocarbamato de zinco"
  },
  {
    "codigo": "29302023",
    "descricao": "Dibutilditiocarbamato de zinco"
  },
  {
    "codigo": "29302024",
    "descricao": "Metam sódio"
  },
  {
    "codigo": "29302029",
    "descricao": "Outros"
  },
  {
    "codigo": "29303011",
    "descricao": "De tetrametiltiourama"
  },
  {
    "codigo": "29303012",
    "descricao": "Sulfiram"
  },
  {
    "codigo": "29303019",
    "descricao": "Outros"
  },
  {
    "codigo": "29303021",
    "descricao": "Thiram"
  },
  {
    "codigo": "29303022",
    "descricao": "Dissulfiram"
  },
  {
    "codigo": "29303029",
    "descricao": "Outros"
  },
  {
    "codigo": "29303090",
    "descricao": "Outros"
  },
  {
    "codigo": "29304010",
    "descricao": "DL-Metionina, com um teor de cinzas sulfatadas superior a 0,1 %, em peso"
  },
  {
    "codigo": "29304090",
    "descricao": "Outra"
  },
  {
    "codigo": "29306000",
    "descricao": "- 2-(N,N-Dietilamino)etanotiol"
  },
  {
    "codigo": "29307000",
    "descricao": "- Sulfeto de bis(2-hidroxietila) (tiodiglicol (DCI))"
  },
  {
    "codigo": "29308010",
    "descricao": "Aldicarb"
  },
  {
    "codigo": "29308020",
    "descricao": "Captafol"
  },
  {
    "codigo": "29308030",
    "descricao": "Metamidofós"
  },
  {
    "codigo": "29309011",
    "descricao": "Ácido tioglicólico e seus sais"
  },
  {
    "codigo": "29309012",
    "descricao": "Cisteína"
  },
  {
    "codigo": "29309013",
    "descricao": "N,N-Dialquil-2-aminoetanotiol, com grupos alquila de C<sub>1</sub> a C<sub>3</sub>, e seus sais protonados"
  },
  {
    "codigo": "29309019",
    "descricao": "Outros"
  },
  {
    "codigo": "29309021",
    "descricao": "Tioureia"
  },
  {
    "codigo": "29309022",
    "descricao": "Tiofanato-Metila"
  },
  {
    "codigo": "29309023",
    "descricao": "4-Metil-3-tiosemicarbazida"
  },
  {
    "codigo": "29309029",
    "descricao": "Outros"
  },
  {
    "codigo": "29309031",
    "descricao": "2-(Etiltio)etanol, com uma concentração igual ou superior a 98 %, em peso"
  },
  {
    "codigo": "29309032",
    "descricao": "3-(Metiltio)propanal"
  },
  {
    "codigo": "29309033",
    "descricao": "Clorotioformiato de S-etila"
  },
  {
    "codigo": "29309034",
    "descricao": "Ácido 2-hidroxi-4-(metiltio)butanoico e seu sal cálcico"
  },
  {
    "codigo": "29309035",
    "descricao": "Metomil"
  },
  {
    "codigo": "29309036",
    "descricao": "Carbocisteína"
  },
  {
    "codigo": "29309037",
    "descricao": "4-Sulfatoetilsulfonil-2,5-dimetoxianilina; 4-sulfatoetilsulfonil-2-metoxi-5-metilanilina; 4-sulfatoetilsulfonil-2-metoxianilina"
  },
  {
    "codigo": "29309039",
    "descricao": "Outros"
  },
  {
    "codigo": "29309041",
    "descricao": "Fosforotioato de O,O-dietila e de S-[2-(dietilamino)etila] e seus sais alquilados ou protonados"
  },
  {
    "codigo": "29309042",
    "descricao": "Fosforotioato de O,O-dimetila e de S-[2-(1-metilcarbamoiletiltio)-etila)] (vamidotion)"
  },
  {
    "codigo": "29309043",
    "descricao": "Fosforotioato de O-(4-bromo-2-clorofenila) O-etila e de S-propila (profenofós)"
  },
  {
    "codigo": "29309049",
    "descricao": "Outros"
  },
  {
    "codigo": "29309051",
    "descricao": "Forato (ISO); terbufós (ISO)"
  },
  {
    "codigo": "29309052",
    "descricao": "Dissulfoton"
  },
  {
    "codigo": "29309053",
    "descricao": "Etion"
  },
  {
    "codigo": "29309054",
    "descricao": "Dimetoato"
  },
  {
    "codigo": "29309057",
    "descricao": "Fosforoditioato de O,O-dimetila e de S-[2-(etiltio)etila] (tiometon)"
  },
  {
    "codigo": "29309059",
    "descricao": "Outros"
  },
  {
    "codigo": "29309061",
    "descricao": "Acefato"
  },
  {
    "codigo": "29309069",
    "descricao": "Outros"
  },
  {
    "codigo": "29309071",
    "descricao": "Tiaprida"
  },
  {
    "codigo": "29309072",
    "descricao": "Bicalutamida"
  },
  {
    "codigo": "29309079",
    "descricao": "Outras"
  },
  {
    "codigo": "29309081",
    "descricao": "Sulfeto de 2-cloroetila e de clorometila"
  },
  {
    "codigo": "29309082",
    "descricao": "Sulfeto de bis(2-cloroetila)"
  },
  {
    "codigo": "29309083",
    "descricao": "Bis(2-cloroetiltio)metano"
  },
  {
    "codigo": "29309084",
    "descricao": "1,2-Bis(2-cloroetiltio)etano"
  },
  {
    "codigo": "29309085",
    "descricao": "1,3-Bis(2-cloroetiltio)-<i>n</i>-propano"
  },
  {
    "codigo": "29309086",
    "descricao": "1,4-Bis(2-cloroetiltio)-<i>n</i>-butano"
  },
  {
    "codigo": "29309087",
    "descricao": "1,5-Bis(2-cloroetiltio)-<i>n</i>-pentano"
  },
  {
    "codigo": "29309088",
    "descricao": "Óxido de bis(2-cloroetiltiometila)"
  },
  {
    "codigo": "29309089",
    "descricao": "Óxido de bis(2-cloroetiltioetila)"
  },
  {
    "codigo": "29309091",
    "descricao": "Captan"
  },
  {
    "codigo": "29309093",
    "descricao": "Metileno-bis-tiocianato"
  },
  {
    "codigo": "29309094",
    "descricao": "Dimetiltiofosforamida"
  },
  {
    "codigo": "29309095",
    "descricao": "Etilditiofosfonato de O-etila e de S-fenila (fonofós)"
  },
  {
    "codigo": "29309096",
    "descricao": "Hidrogênio alquil(de C<sub>1</sub> a C<sub>3</sub>)fosfonotioatos de [S-2-(dialquil(de C<sub>1</sub> a C<sub>3</sub>)amino)etila], seus ésteres de O-alquila (de até C<sub>10</sub>, incluindo os cicloalquila); sais alquilados ou protonados destes produtos"
  },
  {
    "codigo": "29309097",
    "descricao": "Outros compostos que contenham um átomo de fósforo ligado a um grupo alquila (de C<sub>1</sub> a C<sub>3</sub>) mas sem outros átomos de carbono"
  },
  {
    "codigo": "29309098",
    "descricao": "Ditiocarbonatos (xantatos e xantogenatos)"
  },
  {
    "codigo": "29309099",
    "descricao": "Outros"
  },
  {
    "codigo": "29311000",
    "descricao": "- Tetrametila de chumbo e tetraetila de chumbo"
  },
  {
    "codigo": "29312000",
    "descricao": "- Compostos de tributilestanho"
  },
  {
    "codigo": "29314100",
    "descricao": "-- Metilfosfonato de dimetila"
  },
  {
    "codigo": "29314200",
    "descricao": "-- Propilfosfonato de dimetila"
  },
  {
    "codigo": "29314300",
    "descricao": "-- Etilfosfonato de dietila"
  },
  {
    "codigo": "29314400",
    "descricao": "-- Ácido metilfosfônico"
  },
  {
    "codigo": "29314500",
    "descricao": "-- Sal do ácido metilfosfônico e de (aminoiminometil)ureia (1:1)"
  },
  {
    "codigo": "29314600",
    "descricao": "-- 2,4,6-Trióxido de 2,4,6-tripropil-1,3,5,2,4,6-trioxatrifosfinano"
  },
  {
    "codigo": "29314700",
    "descricao": "-- Metilfosfonato de (5-etil-2-metil-2-óxido-1,3,2-dioxafosfinan-5-il)metil metila"
  },
  {
    "codigo": "29314800",
    "descricao": "-- 3,9-Dióxido de 3,9-dimetil-2,4,8,10-tetraoxa-3,9-difosfaspiro[5.5]undecano"
  },
  {
    "codigo": "29314911",
    "descricao": "Ácido fosfonometiliminodiacético; ácido aminotrimetilenofosfônico"
  },
  {
    "codigo": "29314912",
    "descricao": "Difenilfosfonato(4,4'-bis((dimetoxifosfinil)metil)difenila)"
  },
  {
    "codigo": "29314913",
    "descricao": "Etidronato dissódico"
  },
  {
    "codigo": "29314914",
    "descricao": "Glifosato e seu sal de monoisopropilamina"
  },
  {
    "codigo": "29314915",
    "descricao": "Glufosinato de amônio"
  },
  {
    "codigo": "29314916",
    "descricao": "Hidrogenofosfonato de bis(2-etilexilo)"
  },
  {
    "codigo": "29314920",
    "descricao": "Hidrogênio alquil(de C<sub>1</sub> a C<sub>3</sub>)fosfonitos de [O-2-(dialquil(de C<sub>1</sub> a C<sub>3</sub>)amino)etila], seus ésteres de O-alquila (de até C<sub>10</sub>, incluindo os cicloalquila); sais alquilados ou protonados destes produtos"
  },
  {
    "codigo": "29314931",
    "descricao": "Metilfosfinato de butila"
  },
  {
    "codigo": "29314932",
    "descricao": "Metilfosfonato de bis(1-metilpentila)"
  },
  {
    "codigo": "29314939",
    "descricao": "Outros"
  },
  {
    "codigo": "29314940",
    "descricao": "N,N-Dialquil(de C<sub>1</sub> a C<sub>3</sub>)fosforoamidocianidatos de O-alquila (de até C<sub>10</sub>, incluindo os cicloalquila)"
  },
  {
    "codigo": "29314990",
    "descricao": "Outros"
  },
  {
    "codigo": "29315100",
    "descricao": "-- Dicloreto metilfosfônico"
  },
  {
    "codigo": "29315200",
    "descricao": "-- Dicloreto propilfosfônico"
  },
  {
    "codigo": "29315300",
    "descricao": "-- Metilfosfonotionato de O-(3-cloropropil) O-[4-nitro-3-(trifluorometil)fenila]"
  },
  {
    "codigo": "29315400",
    "descricao": "-- Triclorfom (ISO)"
  },
  {
    "codigo": "29315911",
    "descricao": "Ácido clodrônico e seu sal dissódico"
  },
  {
    "codigo": "29315912",
    "descricao": "Etefon"
  },
  {
    "codigo": "29315913",
    "descricao": "Fotemustina"
  },
  {
    "codigo": "29315991",
    "descricao": "Alquil(de C<sub>1</sub> a C<sub>3</sub>)fosfonofluoridatos de O-alquila (de até C<sub>10</sub>, incluindo os cicloalquila)"
  },
  {
    "codigo": "29315992",
    "descricao": "Metilfosfonocloridato de O-isopropila"
  },
  {
    "codigo": "29315993",
    "descricao": "Metilfosfonocloridato de O-pinacolila"
  },
  {
    "codigo": "29315994",
    "descricao": "Difluoreto de alquilfosfonila, com grupo alquila de C<sub>1</sub> a C<sub>3</sub>"
  },
  {
    "codigo": "29315995",
    "descricao": "Fosfonamidofluoridatos de P-alquila (de até C<sub>10</sub>, incluindo cicloalquila) N-(1-(dialquila (de até C<sub>10</sub>, incluindo cicloalquila)amino))alquilideno (H ou de até C<sub>10</sub>, incluindo cicloalquila) e sais alquilados ou protonados destes produtos"
  },
  {
    "codigo": "29315996",
    "descricao": "(Bis(dietilamina)metileno)fosfonamidofluoridato de metila"
  },
  {
    "codigo": "29315998",
    "descricao": "Outros compostos que contenham um átomo de fósforo ligado a um grupo alquila (de C<sub>1</sub> a C<sub>3</sub>) mas sem outros átomos de carbono"
  },
  {
    "codigo": "29315999",
    "descricao": "Outros"
  },
  {
    "codigo": "29319021",
    "descricao": "Bis(trimetilsilil)ureia"
  },
  {
    "codigo": "29319029",
    "descricao": "Outros"
  },
  {
    "codigo": "29319041",
    "descricao": "Acetato de trifenilestanho"
  },
  {
    "codigo": "29319042",
    "descricao": "Tetraoctilestanho"
  },
  {
    "codigo": "29319043",
    "descricao": "Ciexatin"
  },
  {
    "codigo": "29319044",
    "descricao": "Hidróxido de trifenilestanho"
  },
  {
    "codigo": "29319045",
    "descricao": "Óxido de fembutatina"
  },
  {
    "codigo": "29319046",
    "descricao": "Sais de dimetil-estanho, de dibutil-estanho e de dioctil-estanho, dos ácidos carboxílicos ou tioglicólicos e de seus ésteres"
  },
  {
    "codigo": "29319049",
    "descricao": "Outros"
  },
  {
    "codigo": "29319051",
    "descricao": "Ácido metilarsínico e seus sais"
  },
  {
    "codigo": "29319052",
    "descricao": "2-Clorovinil-dicloroarsina"
  },
  {
    "codigo": "29319053",
    "descricao": "Bis(2-clorovinil)cloroarsina"
  },
  {
    "codigo": "29319054",
    "descricao": "Tris(2-clorovinil)arsina"
  },
  {
    "codigo": "29319059",
    "descricao": "Outros"
  },
  {
    "codigo": "29319061",
    "descricao": "Tricloreto de etilalumínio (sesquicloreto de etilalumínio)"
  },
  {
    "codigo": "29319062",
    "descricao": "Cloreto de dietilalumínio"
  },
  {
    "codigo": "29319069",
    "descricao": "Outros"
  },
  {
    "codigo": "29319090",
    "descricao": "Outros"
  },
  {
    "codigo": "29321100",
    "descricao": "-- Tetra-hidrofurano"
  },
  {
    "codigo": "29321200",
    "descricao": "-- 2-Furaldeído (furfural)"
  },
  {
    "codigo": "29321310",
    "descricao": "Álcool furfurílico"
  },
  {
    "codigo": "29321320",
    "descricao": "Álcool tetra-hidrofurfurílico"
  },
  {
    "codigo": "29321400",
    "descricao": "-- Sucralose"
  },
  {
    "codigo": "29321910",
    "descricao": "Ranitidina e seus sais"
  },
  {
    "codigo": "29321920",
    "descricao": "Nafronil"
  },
  {
    "codigo": "29321930",
    "descricao": "Nitrovin"
  },
  {
    "codigo": "29321940",
    "descricao": "Bioresmetrina"
  },
  {
    "codigo": "29321950",
    "descricao": "Diacetato de 5-nitrofurfurilideno (NFDA)"
  },
  {
    "codigo": "29321990",
    "descricao": "Outros"
  },
  {
    "codigo": "29322000",
    "descricao": "- Lactonas"
  },
  {
    "codigo": "29329100",
    "descricao": "-- Isosafrol"
  },
  {
    "codigo": "29329200",
    "descricao": "-- 1-(1,3-Benzodioxol-5-il)propan-2-ona"
  },
  {
    "codigo": "29329300",
    "descricao": "-- Piperonal"
  },
  {
    "codigo": "29329400",
    "descricao": "-- Safrol"
  },
  {
    "codigo": "29329500",
    "descricao": "-- Tetra-hidrocanabinóis (todos os isômeros)"
  },
  {
    "codigo": "29329600",
    "descricao": "-- Carbofurano (ISO)"
  },
  {
    "codigo": "29329911",
    "descricao": "Eucaliptol"
  },
  {
    "codigo": "29329912",
    "descricao": "Quercetina"
  },
  {
    "codigo": "29329913",
    "descricao": "Dinitrato de isossorbida"
  },
  {
    "codigo": "29329991",
    "descricao": "Cloridrato de amiodarona"
  },
  {
    "codigo": "29329992",
    "descricao": "1,3,4,6,7,8-Hexaidro-4,6,6,7,8,8-hexametilciclopenta-gama-2-benzopirano"
  },
  {
    "codigo": "29329993",
    "descricao": "Dibenzilideno-sorbitol"
  },
  {
    "codigo": "29329994",
    "descricao": "Carbosulfan ((dibutilaminotio)metilcarbamato de 2,3-di-hidro-2,2-dimetilbenzofuran-7-ila)"
  },
  {
    "codigo": "29329999",
    "descricao": "Outros"
  },
  {
    "codigo": "29331111",
    "descricao": "Dipirona"
  },
  {
    "codigo": "29331112",
    "descricao": "Magnopirol (dipirona magnésica)"
  },
  {
    "codigo": "29331119",
    "descricao": "Outros"
  },
  {
    "codigo": "29331120",
    "descricao": "Metileno-bis(4-metilamino-1-fenil-2,3-dimetil)pirazolona"
  },
  {
    "codigo": "29331190",
    "descricao": "Outros"
  },
  {
    "codigo": "29331911",
    "descricao": "Fenilbutazona cálcica"
  },
  {
    "codigo": "29331919",
    "descricao": "Outros"
  },
  {
    "codigo": "29331990",
    "descricao": "Outros"
  },
  {
    "codigo": "29332110",
    "descricao": "Iprodiona"
  },
  {
    "codigo": "29332121",
    "descricao": "Fenitoína e seu sal sódico"
  },
  {
    "codigo": "29332129",
    "descricao": "Outros"
  },
  {
    "codigo": "29332190",
    "descricao": "Outros"
  },
  {
    "codigo": "29332911",
    "descricao": "2-Metil-5-nitroimidazol"
  },
  {
    "codigo": "29332912",
    "descricao": "Metronidazol e seus sais"
  },
  {
    "codigo": "29332913",
    "descricao": "Tinidazol"
  },
  {
    "codigo": "29332919",
    "descricao": "Outros"
  },
  {
    "codigo": "29332921",
    "descricao": "Econazol e seu nitrato"
  },
  {
    "codigo": "29332922",
    "descricao": "Nitrato de miconazol"
  },
  {
    "codigo": "29332923",
    "descricao": "Cloridrato de clonidina"
  },
  {
    "codigo": "29332924",
    "descricao": "Nitrato de isoconazol"
  },
  {
    "codigo": "29332925",
    "descricao": "Clotrimazol"
  },
  {
    "codigo": "29332929",
    "descricao": "Outros"
  },
  {
    "codigo": "29332930",
    "descricao": "Cimetidina e seus sais"
  },
  {
    "codigo": "29332940",
    "descricao": "4-Metil-5-hidroximetilimidazol e seus sais"
  },
  {
    "codigo": "29332991",
    "descricao": "Imidazol"
  },
  {
    "codigo": "29332992",
    "descricao": "Histidina e seus sais"
  },
  {
    "codigo": "29332993",
    "descricao": "Ondansetron e seus sais"
  },
  {
    "codigo": "29332994",
    "descricao": "1-Hidroxietil-2-undecanoilimidazolina"
  },
  {
    "codigo": "29332995",
    "descricao": "1-Hidroxietil-2-(8-heptadecenoil)imidazolina"
  },
  {
    "codigo": "29332999",
    "descricao": "Outros"
  },
  {
    "codigo": "29333110",
    "descricao": "Piridina"
  },
  {
    "codigo": "29333120",
    "descricao": "Sais"
  },
  {
    "codigo": "29333200",
    "descricao": "-- Piperidina e seus sais"
  },
  {
    "codigo": "29333311",
    "descricao": "Alfentanila"
  },
  {
    "codigo": "29333312",
    "descricao": "Anileridina"
  },
  {
    "codigo": "29333319",
    "descricao": "Outros"
  },
  {
    "codigo": "29333321",
    "descricao": "Bezitramida"
  },
  {
    "codigo": "29333322",
    "descricao": "Bromazepam"
  },
  {
    "codigo": "29333329",
    "descricao": "Outros"
  },
  {
    "codigo": "29333331",
    "descricao": "Carfentanila"
  },
  {
    "codigo": "29333332",
    "descricao": "Cetobemidona"
  },
  {
    "codigo": "29333339",
    "descricao": "Outros"
  },
  {
    "codigo": "29333341",
    "descricao": "Difenoxilato"
  },
  {
    "codigo": "29333342",
    "descricao": "Cloridrato de difenoxilato"
  },
  {
    "codigo": "29333349",
    "descricao": "Outros"
  },
  {
    "codigo": "29333351",
    "descricao": "Difenoxina"
  },
  {
    "codigo": "29333352",
    "descricao": "Dipipanona"
  },
  {
    "codigo": "29333359",
    "descricao": "Outros"
  },
  {
    "codigo": "29333361",
    "descricao": "Fenciclidina"
  },
  {
    "codigo": "29333362",
    "descricao": "Fenoperidina"
  },
  {
    "codigo": "29333363",
    "descricao": "Fentanila"
  },
  {
    "codigo": "29333369",
    "descricao": "Outros"
  },
  {
    "codigo": "29333371",
    "descricao": "Metilfenidato"
  },
  {
    "codigo": "29333372",
    "descricao": "Pentazocina"
  },
  {
    "codigo": "29333379",
    "descricao": "Outros"
  },
  {
    "codigo": "29333381",
    "descricao": "Petidina"
  },
  {
    "codigo": "29333382",
    "descricao": "Intermediário A da petidina"
  },
  {
    "codigo": "29333383",
    "descricao": "Pipradrol"
  },
  {
    "codigo": "29333384",
    "descricao": "Cloridrato de petidina"
  },
  {
    "codigo": "29333389",
    "descricao": "Outros"
  },
  {
    "codigo": "29333391",
    "descricao": "Piritramida"
  },
  {
    "codigo": "29333392",
    "descricao": "Propiram"
  },
  {
    "codigo": "29333393",
    "descricao": "Trimeperidina"
  },
  {
    "codigo": "29333394",
    "descricao": "Remifentanila"
  },
  {
    "codigo": "29333399",
    "descricao": "Outros"
  },
  {
    "codigo": "29333400",
    "descricao": "-- Outras fentanilas e seus derivados"
  },
  {
    "codigo": "29333500",
    "descricao": "-- Quinuclidin-3-ol"
  },
  {
    "codigo": "29333600",
    "descricao": "-- 4-Anilino-N-fenetilpiperidina (ANPP)"
  },
  {
    "codigo": "29333700",
    "descricao": "-- N-Fenetil-4-piperidona (NPP)"
  },
  {
    "codigo": "29333912",
    "descricao": "Droperidol"
  },
  {
    "codigo": "29333913",
    "descricao": "Ácido niflúmico"
  },
  {
    "codigo": "29333914",
    "descricao": "Haloxifop (ácido (RS)-2-(4-(3-cloro-5-trifluorometil-2-piridiloxi)fenoxi)propiônico)"
  },
  {
    "codigo": "29333915",
    "descricao": "Haloperidol"
  },
  {
    "codigo": "29333919",
    "descricao": "Outros"
  },
  {
    "codigo": "29333921",
    "descricao": "Picloram"
  },
  {
    "codigo": "29333922",
    "descricao": "Clorpirifós"
  },
  {
    "codigo": "29333923",
    "descricao": "Malato ácido de cleboprida (malato de cleboprida)"
  },
  {
    "codigo": "29333924",
    "descricao": "Cloridrato de loperamida"
  },
  {
    "codigo": "29333925",
    "descricao": "Ácido 2-(2-metil-3-cloroanilino)nicotínico e seu sal de lisina"
  },
  {
    "codigo": "29333929",
    "descricao": "Outros"
  },
  {
    "codigo": "29333931",
    "descricao": "Terfenadina"
  },
  {
    "codigo": "29333932",
    "descricao": "Biperideno e seus sais"
  },
  {
    "codigo": "29333933",
    "descricao": "Ácido isonicotínico"
  },
  {
    "codigo": "29333934",
    "descricao": "5-Etil-2,3-dicarboxipiridina (5-EPDC)"
  },
  {
    "codigo": "29333935",
    "descricao": "Imazetapir (ácido (RS)-5-etil-2-(4-isopropil-4-metil-5-oxo-2-imidazolin-2-il)nicotínico)"
  },
  {
    "codigo": "29333936",
    "descricao": "Dibrometo de 1-[N,N-dialquila (de até C<sub>10</sub>) -N-(n-hidroxialquil (de até C<sub>10</sub>))amônio]-n-[N-(3-dimetilcarbamoxi-alfa-picolinil)-N,N-dialquil (de até C<sub>10</sub>) amônio]decano (n=1-8)"
  },
  {
    "codigo": "29333937",
    "descricao": "Benzilato de 3-quinuclidinila"
  },
  {
    "codigo": "29333939",
    "descricao": "Outros"
  },
  {
    "codigo": "29333941",
    "descricao": "Dibrometo de 1-[N,N-dialquila (de até C<sub>10</sub>) -N-(n-(ciano, acetoxi)alquil (de até C<sub>10</sub>))amônio]-n-[N-(3-dimetilcarbamoxi-alfa-picolinil)-N,N-dialquil (de até C<sub>10</sub>) amônio]decano (n=1-8)"
  },
  {
    "codigo": "29333942",
    "descricao": "Dibrometo de 1,n-bis[N-(3-dimetilcarbamoxi-alfa-picolil)-N,N-dialquila (de até C<sub>10</sub>) amônio]-alcano-(2,(n-1)-diona) (n=2-12)"
  },
  {
    "codigo": "29333943",
    "descricao": "Nifedipina"
  },
  {
    "codigo": "29333944",
    "descricao": "Nitrendipina"
  },
  {
    "codigo": "29333945",
    "descricao": "Maleato de pirilamina"
  },
  {
    "codigo": "29333946",
    "descricao": "Omeprazol"
  },
  {
    "codigo": "29333948",
    "descricao": "Nimodipina"
  },
  {
    "codigo": "29333949",
    "descricao": "Outros"
  },
  {
    "codigo": "29333981",
    "descricao": "Cloridrato de benzetimida"
  },
  {
    "codigo": "29333982",
    "descricao": "Cloridrato de mepivacaína"
  },
  {
    "codigo": "29333983",
    "descricao": "Cloridrato de bupivacaína"
  },
  {
    "codigo": "29333984",
    "descricao": "Dicloreto de paraquate"
  },
  {
    "codigo": "29333989",
    "descricao": "Outros"
  },
  {
    "codigo": "29333991",
    "descricao": "Cloridrato de fenazopiridina"
  },
  {
    "codigo": "29333992",
    "descricao": "Isoniazida"
  },
  {
    "codigo": "29333993",
    "descricao": "3-Cianopiridina"
  },
  {
    "codigo": "29333994",
    "descricao": "4,4'-Bipiridina"
  },
  {
    "codigo": "29333999",
    "descricao": "Outros"
  },
  {
    "codigo": "29334110",
    "descricao": "Levorfanol"
  },
  {
    "codigo": "29334120",
    "descricao": "Sais"
  },
  {
    "codigo": "29334911",
    "descricao": "Ácido 2,3-quinolinodicarboxílico"
  },
  {
    "codigo": "29334912",
    "descricao": "Rosoxacina"
  },
  {
    "codigo": "29334913",
    "descricao": "Imazaquin"
  },
  {
    "codigo": "29334919",
    "descricao": "Outros"
  },
  {
    "codigo": "29334920",
    "descricao": "Oxaminiquina"
  },
  {
    "codigo": "29334930",
    "descricao": "Broxiquinolina"
  },
  {
    "codigo": "29334940",
    "descricao": "Ésteres do levorfanol"
  },
  {
    "codigo": "29334990",
    "descricao": "Outros"
  },
  {
    "codigo": "29335200",
    "descricao": "-- Malonilureia (ácido barbitúrico) e seus sais"
  },
  {
    "codigo": "29335311",
    "descricao": "Alobarbital e seus sais"
  },
  {
    "codigo": "29335312",
    "descricao": "Amobarbital e seus sais"
  },
  {
    "codigo": "29335321",
    "descricao": "Barbital e seus sais"
  },
  {
    "codigo": "29335322",
    "descricao": "Butalbital e seus sais"
  },
  {
    "codigo": "29335323",
    "descricao": "Butobarbital e seus sais"
  },
  {
    "codigo": "29335330",
    "descricao": "Ciclobarbital e seus sais"
  },
  {
    "codigo": "29335340",
    "descricao": "Fenobarbital e seus sais"
  },
  {
    "codigo": "29335350",
    "descricao": "Metilfenobarbital e seus sais"
  },
  {
    "codigo": "29335360",
    "descricao": "Pentobarbital e seus sais"
  },
  {
    "codigo": "29335371",
    "descricao": "Secbutabarbital e seus sais"
  },
  {
    "codigo": "29335372",
    "descricao": "Secobarbital e seus sais"
  },
  {
    "codigo": "29335380",
    "descricao": "Venilbital e seus sais"
  },
  {
    "codigo": "29335400",
    "descricao": "-- Outros derivados de malonilureia (ácido barbitúrico); sais destes produtos"
  },
  {
    "codigo": "29335510",
    "descricao": "Loprazolam e seus sais"
  },
  {
    "codigo": "29335520",
    "descricao": "Mecloqualona e seus sais"
  },
  {
    "codigo": "29335530",
    "descricao": "Metaqualona e seus sais"
  },
  {
    "codigo": "29335540",
    "descricao": "Zipeprol e seus sais"
  },
  {
    "codigo": "29335911",
    "descricao": "Oxatomida"
  },
  {
    "codigo": "29335912",
    "descricao": "Praziquantel"
  },
  {
    "codigo": "29335913",
    "descricao": "Norfloxacina e seu nicotinato"
  },
  {
    "codigo": "29335914",
    "descricao": "Flunarizina e seu dicloridrato"
  },
  {
    "codigo": "29335915",
    "descricao": "Enrofloxacina; sais de piperazina"
  },
  {
    "codigo": "29335916",
    "descricao": "Cloridrato de buspirona"
  },
  {
    "codigo": "29335919",
    "descricao": "Outros"
  },
  {
    "codigo": "29335921",
    "descricao": "Bromacil"
  },
  {
    "codigo": "29335922",
    "descricao": "Terbacil"
  },
  {
    "codigo": "29335923",
    "descricao": "Fluorouracil"
  },
  {
    "codigo": "29335929",
    "descricao": "Outros"
  },
  {
    "codigo": "29335931",
    "descricao": "Propiltiouracil"
  },
  {
    "codigo": "29335932",
    "descricao": "Diazinon"
  },
  {
    "codigo": "29335933",
    "descricao": "Pirazofós"
  },
  {
    "codigo": "29335934",
    "descricao": "Azatioprina"
  },
  {
    "codigo": "29335935",
    "descricao": "6-Mercaptopurina"
  },
  {
    "codigo": "29335939",
    "descricao": "Outros"
  },
  {
    "codigo": "29335941",
    "descricao": "Trimetoprima"
  },
  {
    "codigo": "29335942",
    "descricao": "Aciclovir"
  },
  {
    "codigo": "29335943",
    "descricao": "Tosilatos de dipiridamol"
  },
  {
    "codigo": "29335944",
    "descricao": "Nicarbazina"
  },
  {
    "codigo": "29335945",
    "descricao": "Bissulfito de menadiona dimetilpirimidinol"
  },
  {
    "codigo": "29335949",
    "descricao": "Outros"
  },
  {
    "codigo": "29335991",
    "descricao": "Minoxidil"
  },
  {
    "codigo": "29335992",
    "descricao": "2-Aminopirimidina"
  },
  {
    "codigo": "29335999",
    "descricao": "Outros"
  },
  {
    "codigo": "29336100",
    "descricao": "-- Melamina"
  },
  {
    "codigo": "29336911",
    "descricao": "2,4,6-Triclorotriazina (cloreto cianúrico)"
  },
  {
    "codigo": "29336912",
    "descricao": "Mercaptodiclorotriazina"
  },
  {
    "codigo": "29336913",
    "descricao": "Atrazina"
  },
  {
    "codigo": "29336914",
    "descricao": "Simazina"
  },
  {
    "codigo": "29336915",
    "descricao": "Cianazina"
  },
  {
    "codigo": "29336916",
    "descricao": "Anilazina"
  },
  {
    "codigo": "29336919",
    "descricao": "Outros"
  },
  {
    "codigo": "29336921",
    "descricao": "N,N,N-Triidroxietilexaidrotriazina"
  },
  {
    "codigo": "29336922",
    "descricao": "Hexazinona"
  },
  {
    "codigo": "29336923",
    "descricao": "Metribuzim"
  },
  {
    "codigo": "29336929",
    "descricao": "Outros"
  },
  {
    "codigo": "29336991",
    "descricao": "Ametrina"
  },
  {
    "codigo": "29336992",
    "descricao": "Metenamina e seus sais"
  },
  {
    "codigo": "29336999",
    "descricao": "Outros"
  },
  {
    "codigo": "29337100",
    "descricao": "-- 6-Hexanolactama (épsilon-caprolactama)"
  },
  {
    "codigo": "29337210",
    "descricao": "Clobazam"
  },
  {
    "codigo": "29337220",
    "descricao": "Metiprilona"
  },
  {
    "codigo": "29337910",
    "descricao": "Piracetam"
  },
  {
    "codigo": "29337990",
    "descricao": "Outras"
  },
  {
    "codigo": "29339111",
    "descricao": "Alprazolam"
  },
  {
    "codigo": "29339112",
    "descricao": "Camazepam"
  },
  {
    "codigo": "29339113",
    "descricao": "Clonazepam"
  },
  {
    "codigo": "29339114",
    "descricao": "Clorazepato"
  },
  {
    "codigo": "29339115",
    "descricao": "Clordiazepóxido"
  },
  {
    "codigo": "29339119",
    "descricao": "Outros"
  },
  {
    "codigo": "29339121",
    "descricao": "Delorazepam"
  },
  {
    "codigo": "29339122",
    "descricao": "Diazepam"
  },
  {
    "codigo": "29339123",
    "descricao": "Estazolam"
  },
  {
    "codigo": "29339129",
    "descricao": "Outros"
  },
  {
    "codigo": "29339131",
    "descricao": "Fludiazepam"
  },
  {
    "codigo": "29339132",
    "descricao": "Flunitrazepam"
  },
  {
    "codigo": "29339133",
    "descricao": "Flurazepam"
  },
  {
    "codigo": "29339134",
    "descricao": "Halazepam"
  },
  {
    "codigo": "29339139",
    "descricao": "Outros"
  },
  {
    "codigo": "29339141",
    "descricao": "Loflazepato de etila"
  },
  {
    "codigo": "29339142",
    "descricao": "Lorazepam"
  },
  {
    "codigo": "29339143",
    "descricao": "Lormetazepam"
  },
  {
    "codigo": "29339149",
    "descricao": "Outros"
  },
  {
    "codigo": "29339151",
    "descricao": "Mazindol"
  },
  {
    "codigo": "29339152",
    "descricao": "Medazepam"
  },
  {
    "codigo": "29339153",
    "descricao": "Midazolam e seus sais"
  },
  {
    "codigo": "29339159",
    "descricao": "Outros"
  },
  {
    "codigo": "29339161",
    "descricao": "Nimetazepam"
  },
  {
    "codigo": "29339162",
    "descricao": "Nitrazepam"
  },
  {
    "codigo": "29339163",
    "descricao": "Nordazepam"
  },
  {
    "codigo": "29339164",
    "descricao": "Oxazepam"
  },
  {
    "codigo": "29339169",
    "descricao": "Outros"
  },
  {
    "codigo": "29339171",
    "descricao": "Pinazepam"
  },
  {
    "codigo": "29339172",
    "descricao": "Pirovalerona"
  },
  {
    "codigo": "29339173",
    "descricao": "Prazepam"
  },
  {
    "codigo": "29339179",
    "descricao": "Outros"
  },
  {
    "codigo": "29339181",
    "descricao": "Temazepam"
  },
  {
    "codigo": "29339182",
    "descricao": "Tetrazepam"
  },
  {
    "codigo": "29339183",
    "descricao": "Triazolam"
  },
  {
    "codigo": "29339189",
    "descricao": "Outros"
  },
  {
    "codigo": "29339200",
    "descricao": "-- Azinfós metil (ISO)"
  },
  {
    "codigo": "29339911",
    "descricao": "Pirazinamida"
  },
  {
    "codigo": "29339912",
    "descricao": "Cloridrato de amilorida"
  },
  {
    "codigo": "29339913",
    "descricao": "Pindolol"
  },
  {
    "codigo": "29339919",
    "descricao": "Outros"
  },
  {
    "codigo": "29339920",
    "descricao": "Cuja estrutura contém um ciclo diazepina (hidrogenado ou não)"
  },
  {
    "codigo": "29339931",
    "descricao": "Dibenzoazepina (iminoestilbeno)"
  },
  {
    "codigo": "29339932",
    "descricao": "Carbamazepina"
  },
  {
    "codigo": "29339933",
    "descricao": "Cloridrato de clomipramina"
  },
  {
    "codigo": "29339934",
    "descricao": "Molinate (hexaidroazepin-1-carbotioato de S-etila)"
  },
  {
    "codigo": "29339935",
    "descricao": "Hexametilenoimina"
  },
  {
    "codigo": "29339939",
    "descricao": "Outros"
  },
  {
    "codigo": "29339941",
    "descricao": "Clemastina e seus derivados; sais destes produtos"
  },
  {
    "codigo": "29339942",
    "descricao": "Amisulprida"
  },
  {
    "codigo": "29339943",
    "descricao": "Sultoprida"
  },
  {
    "codigo": "29339944",
    "descricao": "Alizaprida"
  },
  {
    "codigo": "29339945",
    "descricao": "Buflomedil e seus derivados; sais destes produtos"
  },
  {
    "codigo": "29339946",
    "descricao": "Maleato de enalapril"
  },
  {
    "codigo": "29339947",
    "descricao": "Ketorolac trometamina"
  },
  {
    "codigo": "29339949",
    "descricao": "Outros"
  },
  {
    "codigo": "29339951",
    "descricao": "Benomil"
  },
  {
    "codigo": "29339952",
    "descricao": "Oxifendazol"
  },
  {
    "codigo": "29339953",
    "descricao": "Albendazol e seu sulfóxido"
  },
  {
    "codigo": "29339954",
    "descricao": "Mebendazol"
  },
  {
    "codigo": "29339955",
    "descricao": "Flubendazol"
  },
  {
    "codigo": "29339956",
    "descricao": "Fembendazol"
  },
  {
    "codigo": "29339959",
    "descricao": "Outros"
  },
  {
    "codigo": "29339961",
    "descricao": "Triadimenol"
  },
  {
    "codigo": "29339962",
    "descricao": "Triadimefon"
  },
  {
    "codigo": "29339963",
    "descricao": "Triazofós (fosforotioato de O,O-dietila O-(1-fenil-1H-1,2,4-triazol-3-ila))"
  },
  {
    "codigo": "29339969",
    "descricao": "Outros"
  },
  {
    "codigo": "29339991",
    "descricao": "Azinfós etílico"
  },
  {
    "codigo": "29339992",
    "descricao": "Ácido nalidíxico"
  },
  {
    "codigo": "29339993",
    "descricao": "Clofazimina"
  },
  {
    "codigo": "29339995",
    "descricao": "Metilssulfato de amezínio"
  },
  {
    "codigo": "29339996",
    "descricao": "Hidrazida maleica e seus sais"
  },
  {
    "codigo": "29339999",
    "descricao": "Outros"
  },
  {
    "codigo": "29341010",
    "descricao": "Fentiazac"
  },
  {
    "codigo": "29341020",
    "descricao": "Cloridrato de tiazolidina"
  },
  {
    "codigo": "29341030",
    "descricao": "Tiabendazol"
  },
  {
    "codigo": "29341090",
    "descricao": "Outros"
  },
  {
    "codigo": "29342010",
    "descricao": "2-Mercaptobenzotiazol e seus sais"
  },
  {
    "codigo": "29342020",
    "descricao": "2,2'-Ditio-bis(benzotiazol) (dissulfeto de benzotiazila)"
  },
  {
    "codigo": "29342031",
    "descricao": "2-(Terbutilaminotio)benzotiazol (N-terbutil-benzotiazol-sulfenamida)"
  },
  {
    "codigo": "29342032",
    "descricao": "2-(Cicloexilaminotio)benzotiazol (N-cicloexil-benzotiazol-sulfenamida)"
  },
  {
    "codigo": "29342033",
    "descricao": "2-(Dicicloexilaminotio)benzotiazol (N,N-dicicloexil-benzotiazol-sulfenamida)"
  },
  {
    "codigo": "29342034",
    "descricao": "2-(4-Morfoliniltio)benzotiazol (N-oxidietileno-benzotiazol-sulfenamida)"
  },
  {
    "codigo": "29342039",
    "descricao": "Outras"
  },
  {
    "codigo": "29342040",
    "descricao": "2-(Tiocianometiltio)benzotiazol (TCMTB)"
  },
  {
    "codigo": "29342090",
    "descricao": "Outros"
  },
  {
    "codigo": "29343010",
    "descricao": "Maleato de metotrimeprazina (maleato de levomepromazina)"
  },
  {
    "codigo": "29343020",
    "descricao": "Enantato de flufenazina"
  },
  {
    "codigo": "29343030",
    "descricao": "Prometazina"
  },
  {
    "codigo": "29343090",
    "descricao": "Outros"
  },
  {
    "codigo": "29349111",
    "descricao": "Aminorex e seus sais"
  },
  {
    "codigo": "29349112",
    "descricao": "Brotizolam e seus sais"
  },
  {
    "codigo": "29349121",
    "descricao": "Clotiazepam"
  },
  {
    "codigo": "29349122",
    "descricao": "Cloxazolam"
  },
  {
    "codigo": "29349123",
    "descricao": "Dextromoramida"
  },
  {
    "codigo": "29349129",
    "descricao": "Outros"
  },
  {
    "codigo": "29349131",
    "descricao": "Fendimetrazina e seus sais"
  },
  {
    "codigo": "29349132",
    "descricao": "Fenmetrazina e seus sais"
  },
  {
    "codigo": "29349133",
    "descricao": "Haloxazolam e seus sais"
  },
  {
    "codigo": "29349141",
    "descricao": "Ketazolam"
  },
  {
    "codigo": "29349142",
    "descricao": "Mesocarbo"
  },
  {
    "codigo": "29349149",
    "descricao": "Outros"
  },
  {
    "codigo": "29349150",
    "descricao": "Oxazolam e seus sais"
  },
  {
    "codigo": "29349160",
    "descricao": "Pemolina e seus sais"
  },
  {
    "codigo": "29349170",
    "descricao": "Sufentanila e seus sais"
  },
  {
    "codigo": "29349200",
    "descricao": "-- Outras fentanilas e seus derivados"
  },
  {
    "codigo": "29349911",
    "descricao": "Morfolina e seus sais"
  },
  {
    "codigo": "29349912",
    "descricao": "Pirenoxina sódica (catalino sódico)"
  },
  {
    "codigo": "29349913",
    "descricao": "Nimorazol"
  },
  {
    "codigo": "29349914",
    "descricao": "Anidrido isatoico (2H-3,1-benzoxazina-2,4-(1H)-diona)"
  },
  {
    "codigo": "29349915",
    "descricao": "4,4'-Ditiodimorfolina"
  },
  {
    "codigo": "29349919",
    "descricao": "Outros"
  },
  {
    "codigo": "29349922",
    "descricao": "Zidovudina (AZT)"
  },
  {
    "codigo": "29349923",
    "descricao": "Timidina"
  },
  {
    "codigo": "29349924",
    "descricao": "Furazolidona"
  },
  {
    "codigo": "29349925",
    "descricao": "Citarabina"
  },
  {
    "codigo": "29349926",
    "descricao": "Oxadiazona"
  },
  {
    "codigo": "29349927",
    "descricao": "Estavudina"
  },
  {
    "codigo": "29349929",
    "descricao": "Outros"
  },
  {
    "codigo": "29349931",
    "descricao": "Cetoconazol"
  },
  {
    "codigo": "29349932",
    "descricao": "Cloridrato de prazosina"
  },
  {
    "codigo": "29349933",
    "descricao": "Talniflumato"
  },
  {
    "codigo": "29349934",
    "descricao": "Ácidos nucleicos e seus sais"
  },
  {
    "codigo": "29349935",
    "descricao": "Propiconazol"
  },
  {
    "codigo": "29349939",
    "descricao": "Outros"
  },
  {
    "codigo": "29349941",
    "descricao": "Tiofeno"
  },
  {
    "codigo": "29349942",
    "descricao": "Ácido 6-aminopenicilânico"
  },
  {
    "codigo": "29349943",
    "descricao": "Ácido 7-aminocefalosporânico"
  },
  {
    "codigo": "29349944",
    "descricao": "Ácido 7-aminodesacetoxicefalosporânico"
  },
  {
    "codigo": "29349945",
    "descricao": "Clormezanona"
  },
  {
    "codigo": "29349946",
    "descricao": "9-(N-Metil-4-piperidinilideno)tioxanteno"
  },
  {
    "codigo": "29349949",
    "descricao": "Outros"
  },
  {
    "codigo": "29349951",
    "descricao": "Tebutiuron"
  },
  {
    "codigo": "29349952",
    "descricao": "Tetramisol"
  },
  {
    "codigo": "29349953",
    "descricao": "Levamisol e seus sais"
  },
  {
    "codigo": "29349954",
    "descricao": "Tioconazol"
  },
  {
    "codigo": "29349959",
    "descricao": "Outros"
  },
  {
    "codigo": "29349961",
    "descricao": "Cloridrato de tizanidina"
  },
  {
    "codigo": "29349969",
    "descricao": "Outros"
  },
  {
    "codigo": "29349991",
    "descricao": "Timolol"
  },
  {
    "codigo": "29349992",
    "descricao": "Maleato ácido de timolol"
  },
  {
    "codigo": "29349993",
    "descricao": "Lamivudina"
  },
  {
    "codigo": "29349999",
    "descricao": "Outros"
  },
  {
    "codigo": "29351000",
    "descricao": "- N-Metilperfluoroctano sulfonamida"
  },
  {
    "codigo": "29352000",
    "descricao": "- N-Etilperfluoroctano sulfonamida"
  },
  {
    "codigo": "29353000",
    "descricao": "- N-Etil-N-(2-hidroxietil)perfluoroctano sulfonamida"
  },
  {
    "codigo": "29354000",
    "descricao": "- N-(2-Hidroxietil)-N-metilperfluoroctano sulfonamida"
  },
  {
    "codigo": "29355000",
    "descricao": "- Outras perfluoroctanossulfonamidas"
  },
  {
    "codigo": "29359011",
    "descricao": "Sulfadiazina e seu sal sódico"
  },
  {
    "codigo": "29359012",
    "descricao": "Clortalidona"
  },
  {
    "codigo": "29359013",
    "descricao": "Sulpirida"
  },
  {
    "codigo": "29359014",
    "descricao": "Veraliprida"
  },
  {
    "codigo": "29359015",
    "descricao": "Sulfametazina (4,6-dimetil-2-sulfanilamidopirimidina) e seu sal sódico"
  },
  {
    "codigo": "29359019",
    "descricao": "Outras"
  },
  {
    "codigo": "29359021",
    "descricao": "Furosemida"
  },
  {
    "codigo": "29359022",
    "descricao": "Ftalilsulfatiazol"
  },
  {
    "codigo": "29359023",
    "descricao": "Piroxicam"
  },
  {
    "codigo": "29359024",
    "descricao": "Tenoxicam"
  },
  {
    "codigo": "29359025",
    "descricao": "Sulfametoxazol"
  },
  {
    "codigo": "29359029",
    "descricao": "Outras"
  },
  {
    "codigo": "29359091",
    "descricao": "Cloramina-B e cloramina-T"
  },
  {
    "codigo": "29359092",
    "descricao": "Gliburida"
  },
  {
    "codigo": "29359093",
    "descricao": "Toluenossulfonamidas"
  },
  {
    "codigo": "29359094",
    "descricao": "Nimesulida"
  },
  {
    "codigo": "29359095",
    "descricao": "Bumetanida"
  },
  {
    "codigo": "29359096",
    "descricao": "Sulfaguanidina"
  },
  {
    "codigo": "29359099",
    "descricao": "Outras"
  },
  {
    "codigo": "29362111",
    "descricao": "Vitamina A<sub>1</sub> álcool (retinol)"
  },
  {
    "codigo": "29362112",
    "descricao": "Acetato"
  },
  {
    "codigo": "29362113",
    "descricao": "Palmitato"
  },
  {
    "codigo": "29362119",
    "descricao": "Outros"
  },
  {
    "codigo": "29362190",
    "descricao": "Outros"
  },
  {
    "codigo": "29362210",
    "descricao": "Cloridrato de vitamina B<sub>1</sub> (cloridrato de tiamina)"
  },
  {
    "codigo": "29362220",
    "descricao": "Mononitrato de vitamina B<sub>1 </sub>(mononitrato de tiamina)"
  },
  {
    "codigo": "29362290",
    "descricao": "Outros"
  },
  {
    "codigo": "29362310",
    "descricao": "Vitamina B<sub>2 </sub>(riboflavina)"
  },
  {
    "codigo": "29362320",
    "descricao": "5'-Fosfato sódico de vitamina B<sub>2</sub> (5'-fosfato sódico de riboflavina)"
  },
  {
    "codigo": "29362390",
    "descricao": "Outros"
  },
  {
    "codigo": "29362410",
    "descricao": "D-Pantotenato de cálcio"
  },
  {
    "codigo": "29362490",
    "descricao": "Outros"
  },
  {
    "codigo": "29362510",
    "descricao": "Vitamina B<sub>6</sub>"
  },
  {
    "codigo": "29362520",
    "descricao": "Cloridrato de piridoxina"
  },
  {
    "codigo": "29362590",
    "descricao": "Outros"
  },
  {
    "codigo": "29362610",
    "descricao": "Vitamina B<sub>12</sub> (cianocobalamina)"
  },
  {
    "codigo": "29362620",
    "descricao": "Cobamamida"
  },
  {
    "codigo": "29362630",
    "descricao": "Hidroxocobalamina e seus sais"
  },
  {
    "codigo": "29362690",
    "descricao": "Outros"
  },
  {
    "codigo": "29362710",
    "descricao": "Vitamina C (ácido L- ou DL-ascórbico)"
  },
  {
    "codigo": "29362720",
    "descricao": "Ascorbato de sódio"
  },
  {
    "codigo": "29362790",
    "descricao": "Outros"
  },
  {
    "codigo": "29362811",
    "descricao": "D- ou DL-alfa-Tocoferol"
  },
  {
    "codigo": "29362812",
    "descricao": "Acetato de D- ou DL-alfa-tocoferol"
  },
  {
    "codigo": "29362819",
    "descricao": "Outros"
  },
  {
    "codigo": "29362890",
    "descricao": "Outros"
  },
  {
    "codigo": "29362911",
    "descricao": "Vitamina B<sub>9</sub> (ácido fólico) e seus sais"
  },
  {
    "codigo": "29362919",
    "descricao": "Outros"
  },
  {
    "codigo": "29362921",
    "descricao": "Vitamina D<sub>3</sub> (colecalciferol)"
  },
  {
    "codigo": "29362929",
    "descricao": "Outros"
  },
  {
    "codigo": "29362931",
    "descricao": "Vitamina H (biotina)"
  },
  {
    "codigo": "29362939",
    "descricao": "Outros"
  },
  {
    "codigo": "29362940",
    "descricao": "Vitaminas K e seus derivados"
  },
  {
    "codigo": "29362951",
    "descricao": "Ácido nicotínico"
  },
  {
    "codigo": "29362952",
    "descricao": "Nicotinamida"
  },
  {
    "codigo": "29362953",
    "descricao": "Nicotinato de sódio"
  },
  {
    "codigo": "29362959",
    "descricao": "Outros"
  },
  {
    "codigo": "29362990",
    "descricao": "Outros"
  },
  {
    "codigo": "29369000",
    "descricao": "- Outras, incluindo os concentrados naturais"
  },
  {
    "codigo": "29371100",
    "descricao": "-- Somatotropina, seus derivados e análogos estruturais"
  },
  {
    "codigo": "29371200",
    "descricao": "-- Insulina e seus sais"
  },
  {
    "codigo": "29371910",
    "descricao": "ACTH (corticotropina)"
  },
  {
    "codigo": "29371920",
    "descricao": "HCG (gonadotropina coriônica)"
  },
  {
    "codigo": "29371930",
    "descricao": "PMSG (gonadotropina sérica)"
  },
  {
    "codigo": "29371940",
    "descricao": "Menotropinas"
  },
  {
    "codigo": "29371950",
    "descricao": "Oxitocina"
  },
  {
    "codigo": "29371990",
    "descricao": "Outros"
  },
  {
    "codigo": "29372110",
    "descricao": "Cortisona"
  },
  {
    "codigo": "29372120",
    "descricao": "Hidrocortisona"
  },
  {
    "codigo": "29372130",
    "descricao": "Prednisona (deidrocortisona)"
  },
  {
    "codigo": "29372140",
    "descricao": "Prednisolona (deidroidrocortisona)"
  },
  {
    "codigo": "29372210",
    "descricao": "Dexametasona e seus acetatos"
  },
  {
    "codigo": "29372221",
    "descricao": "Acetonida da triancinolona"
  },
  {
    "codigo": "29372229",
    "descricao": "Outros"
  },
  {
    "codigo": "29372231",
    "descricao": "Valerato de diflucortolona"
  },
  {
    "codigo": "29372239",
    "descricao": "Outros"
  },
  {
    "codigo": "29372290",
    "descricao": "Outros"
  },
  {
    "codigo": "29372310",
    "descricao": "Medroxiprogesterona e seus derivados"
  },
  {
    "codigo": "29372321",
    "descricao": "L-Norgestrel (levonorgestrel)"
  },
  {
    "codigo": "29372322",
    "descricao": "DL-Norgestrel"
  },
  {
    "codigo": "29372329",
    "descricao": "Outros"
  },
  {
    "codigo": "29372331",
    "descricao": "Estriol e seu succinato"
  },
  {
    "codigo": "29372339",
    "descricao": "Outros"
  },
  {
    "codigo": "29372341",
    "descricao": "Hemissuccinato de estradiol"
  },
  {
    "codigo": "29372342",
    "descricao": "Fempropionato de estradiol (17-(3-fenilpropionato) de estradiol)"
  },
  {
    "codigo": "29372349",
    "descricao": "Outros"
  },
  {
    "codigo": "29372351",
    "descricao": "Alilestrenol"
  },
  {
    "codigo": "29372359",
    "descricao": "Outros"
  },
  {
    "codigo": "29372360",
    "descricao": "Desogestrel"
  },
  {
    "codigo": "29372370",
    "descricao": "Linestrenol"
  },
  {
    "codigo": "29372391",
    "descricao": "Acetato de etinodiol"
  },
  {
    "codigo": "29372392",
    "descricao": "Gestodeno"
  },
  {
    "codigo": "29372399",
    "descricao": "Outros"
  },
  {
    "codigo": "29372910",
    "descricao": "Metilprednisolona e seus derivados"
  },
  {
    "codigo": "29372920",
    "descricao": "21-Succinato sódico de hidrocortisona"
  },
  {
    "codigo": "29372931",
    "descricao": "Acetato de ciproterona"
  },
  {
    "codigo": "29372939",
    "descricao": "Outros"
  },
  {
    "codigo": "29372940",
    "descricao": "Mesterolona e seus derivados"
  },
  {
    "codigo": "29372950",
    "descricao": "Espironolactona"
  },
  {
    "codigo": "29372960",
    "descricao": "Deflazacorte"
  },
  {
    "codigo": "29372990",
    "descricao": "Outros"
  },
  {
    "codigo": "29375000",
    "descricao": "- Prostaglandinas, tromboxanas e leucotrienos, seus derivados e análogos estruturais"
  },
  {
    "codigo": "29379010",
    "descricao": "Tiratricol (triac) e seu sal sódico"
  },
  {
    "codigo": "29379030",
    "descricao": "Levotiroxina sódica"
  },
  {
    "codigo": "29379040",
    "descricao": "Liotironina sódica"
  },
  {
    "codigo": "29379090",
    "descricao": "Outros"
  },
  {
    "codigo": "29381000",
    "descricao": "- Rutosídio (rutina) e seus derivados"
  },
  {
    "codigo": "29389010",
    "descricao": "Deslanosídio"
  },
  {
    "codigo": "29389020",
    "descricao": "Esteviosídio"
  },
  {
    "codigo": "29389090",
    "descricao": "Outros"
  },
  {
    "codigo": "29391110",
    "descricao": "Concentrados de palha de dormideira ou papoula"
  },
  {
    "codigo": "29391121",
    "descricao": "Buprenorfina e seus sais"
  },
  {
    "codigo": "29391122",
    "descricao": "Codeína e seus sais"
  },
  {
    "codigo": "29391123",
    "descricao": "Di-hidrocodeína e seus sais"
  },
  {
    "codigo": "29391131",
    "descricao": "Etilmorfina e seus sais"
  },
  {
    "codigo": "29391132",
    "descricao": "Etorfina e seus sais"
  },
  {
    "codigo": "29391140",
    "descricao": "Folcodina e seus sais"
  },
  {
    "codigo": "29391151",
    "descricao": "Heroína e seus sais"
  },
  {
    "codigo": "29391152",
    "descricao": "Hidrocodona e seus sais"
  },
  {
    "codigo": "29391153",
    "descricao": "Hidromorfona e seus sais"
  },
  {
    "codigo": "29391161",
    "descricao": "Morfina"
  },
  {
    "codigo": "29391162",
    "descricao": "Cloridrato e sulfato de morfina"
  },
  {
    "codigo": "29391169",
    "descricao": "Outros"
  },
  {
    "codigo": "29391170",
    "descricao": "Nicomorfina e seus sais"
  },
  {
    "codigo": "29391181",
    "descricao": "Oxicodona e seus sais"
  },
  {
    "codigo": "29391182",
    "descricao": "Oximorfona e seus sais"
  },
  {
    "codigo": "29391191",
    "descricao": "Tebacona e seus sais"
  },
  {
    "codigo": "29391192",
    "descricao": "Tebaína e seus sais"
  },
  {
    "codigo": "29391900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "29392000",
    "descricao": "- Alcaloides da quina e seus derivados; sais destes produtos"
  },
  {
    "codigo": "29393010",
    "descricao": "Cafeína"
  },
  {
    "codigo": "29393020",
    "descricao": "Sais"
  },
  {
    "codigo": "29394100",
    "descricao": "-- Efedrina e seus sais"
  },
  {
    "codigo": "29394200",
    "descricao": "-- Pseudoefedrina (DCI) e seus sais"
  },
  {
    "codigo": "29394300",
    "descricao": "-- Catina (DCI) e seus sais"
  },
  {
    "codigo": "29394400",
    "descricao": "-- Norefedrina e seus sais"
  },
  {
    "codigo": "29394510",
    "descricao": "Levometanfetamina e seus sais"
  },
  {
    "codigo": "29394520",
    "descricao": "Metanfetamina e seus sais"
  },
  {
    "codigo": "29394530",
    "descricao": "Racemato de metanfetamina e seus sais"
  },
  {
    "codigo": "29394900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "29395100",
    "descricao": "-- Fenetilina (DCI) e seus sais"
  },
  {
    "codigo": "29395910",
    "descricao": "Teofilina"
  },
  {
    "codigo": "29395920",
    "descricao": "Aminofilina"
  },
  {
    "codigo": "29395990",
    "descricao": "Outros"
  },
  {
    "codigo": "29396100",
    "descricao": "-- Ergometrina (DCI) e seus sais"
  },
  {
    "codigo": "29396200",
    "descricao": "-- Ergotamina (DCI) e seus sais"
  },
  {
    "codigo": "29396300",
    "descricao": "-- Ácido lisérgico e seus sais"
  },
  {
    "codigo": "29396911",
    "descricao": "Maleato de metilergometrina"
  },
  {
    "codigo": "29396919",
    "descricao": "Outros"
  },
  {
    "codigo": "29396921",
    "descricao": "Mesilato de di-hidroergotamina"
  },
  {
    "codigo": "29396929",
    "descricao": "Outros"
  },
  {
    "codigo": "29396931",
    "descricao": "Mesilato de di-hidroergocornina"
  },
  {
    "codigo": "29396939",
    "descricao": "Outros"
  },
  {
    "codigo": "29396941",
    "descricao": "Mesilato de alfa-di-hidroergocriptina"
  },
  {
    "codigo": "29396942",
    "descricao": "Mesilato de beta-di-hidroergocriptina"
  },
  {
    "codigo": "29396949",
    "descricao": "Outros"
  },
  {
    "codigo": "29396951",
    "descricao": "Ergocristina"
  },
  {
    "codigo": "29396952",
    "descricao": "Metanossulfonato de di-hidroergocristina"
  },
  {
    "codigo": "29396959",
    "descricao": "Outros"
  },
  {
    "codigo": "29396990",
    "descricao": "Outros"
  },
  {
    "codigo": "29397210",
    "descricao": "Cocaína e seus sais"
  },
  {
    "codigo": "29397220",
    "descricao": "Ecgonina e seus sais"
  },
  {
    "codigo": "29397290",
    "descricao": "Outros"
  },
  {
    "codigo": "29397911",
    "descricao": "Brometo de N-butilescopolamônio"
  },
  {
    "codigo": "29397919",
    "descricao": "Outros"
  },
  {
    "codigo": "29397920",
    "descricao": "Teobromina e seus derivados; sais destes produtos"
  },
  {
    "codigo": "29397931",
    "descricao": "Pilocarpina, seu nitrato e seu cloridrato"
  },
  {
    "codigo": "29397939",
    "descricao": "Outros"
  },
  {
    "codigo": "29397940",
    "descricao": "Tiocolquicósido"
  },
  {
    "codigo": "29397990",
    "descricao": "Outros"
  },
  {
    "codigo": "29398010",
    "descricao": "Saxitoxina"
  },
  {
    "codigo": "29398090",
    "descricao": "Outros"
  },
  {
    "codigo": "29400011",
    "descricao": "Galactose"
  },
  {
    "codigo": "29400012",
    "descricao": "Arabinose"
  },
  {
    "codigo": "29400013",
    "descricao": "Ramnose"
  },
  {
    "codigo": "29400019",
    "descricao": "Outros"
  },
  {
    "codigo": "29400021",
    "descricao": "Ácido lactobiônico"
  },
  {
    "codigo": "29400022",
    "descricao": "Lactobionato de cálcio"
  },
  {
    "codigo": "29400023",
    "descricao": "Bromolactobionato de cálcio"
  },
  {
    "codigo": "29400029",
    "descricao": "Outros"
  },
  {
    "codigo": "29400092",
    "descricao": "Frutose-1,6-difosfato de cálcio ou de sódio"
  },
  {
    "codigo": "29400093",
    "descricao": "Maltitol"
  },
  {
    "codigo": "29400094",
    "descricao": "Lactogluconato de cálcio"
  },
  {
    "codigo": "29400099",
    "descricao": "Outros"
  },
  {
    "codigo": "29411010",
    "descricao": "Ampicilina e seus sais"
  },
  {
    "codigo": "29411020",
    "descricao": "Amoxicilina e seus sais"
  },
  {
    "codigo": "29411031",
    "descricao": "Penicilina V potássica"
  },
  {
    "codigo": "29411039",
    "descricao": "Outros"
  },
  {
    "codigo": "29411041",
    "descricao": "Penicilina G potássica"
  },
  {
    "codigo": "29411042",
    "descricao": "Penicilina G benzatínica"
  },
  {
    "codigo": "29411043",
    "descricao": "Penicilina G procaínica"
  },
  {
    "codigo": "29411049",
    "descricao": "Outros"
  },
  {
    "codigo": "29411090",
    "descricao": "Outros"
  },
  {
    "codigo": "29412010",
    "descricao": "Sulfatos"
  },
  {
    "codigo": "29412090",
    "descricao": "Outros"
  },
  {
    "codigo": "29413010",
    "descricao": "Cloridrato de tetraciclina"
  },
  {
    "codigo": "29413020",
    "descricao": "Oxitetraciclina"
  },
  {
    "codigo": "29413031",
    "descricao": "Minociclina"
  },
  {
    "codigo": "29413032",
    "descricao": "Sais"
  },
  {
    "codigo": "29413090",
    "descricao": "Outros"
  },
  {
    "codigo": "29414011",
    "descricao": "Cloranfenicol, seu palmitato, seu succinato e seu hemissuccinato"
  },
  {
    "codigo": "29414019",
    "descricao": "Outros"
  },
  {
    "codigo": "29414020",
    "descricao": "Tianfenicol e seus ésteres"
  },
  {
    "codigo": "29414090",
    "descricao": "Outros"
  },
  {
    "codigo": "29415010",
    "descricao": "Claritromicina"
  },
  {
    "codigo": "29415020",
    "descricao": "Eritromicina e seus sais"
  },
  {
    "codigo": "29415090",
    "descricao": "Outros"
  },
  {
    "codigo": "29419011",
    "descricao": "Rifamicina S"
  },
  {
    "codigo": "29419012",
    "descricao": "Rifampicina (rifamicina AMP)"
  },
  {
    "codigo": "29419013",
    "descricao": "Rifamicina SV sódica"
  },
  {
    "codigo": "29419019",
    "descricao": "Outros"
  },
  {
    "codigo": "29419021",
    "descricao": "Cloridrato de lincomicina"
  },
  {
    "codigo": "29419022",
    "descricao": "Fosfato de clindamicina"
  },
  {
    "codigo": "29419029",
    "descricao": "Outros"
  },
  {
    "codigo": "29419031",
    "descricao": "Ceftriaxona e seus sais"
  },
  {
    "codigo": "29419032",
    "descricao": "Cefoperazona e seus sais, cefazolina sódica"
  },
  {
    "codigo": "29419033",
    "descricao": "Cefaclor e cefalexina monoidratados, cefalotina sódica"
  },
  {
    "codigo": "29419034",
    "descricao": "Cefadroxil e seus sais"
  },
  {
    "codigo": "29419035",
    "descricao": "Cefotaxima sódica"
  },
  {
    "codigo": "29419036",
    "descricao": "Cefoxitina e seus sais"
  },
  {
    "codigo": "29419037",
    "descricao": "Cefalosporina C"
  },
  {
    "codigo": "29419039",
    "descricao": "Outros"
  },
  {
    "codigo": "29419041",
    "descricao": "Sulfato de neomicina"
  },
  {
    "codigo": "29419042",
    "descricao": "Embonato de gentamicina (pamoato de gentamicina)"
  },
  {
    "codigo": "29419043",
    "descricao": "Sulfato de gentamicina"
  },
  {
    "codigo": "29419049",
    "descricao": "Outros"
  },
  {
    "codigo": "29419051",
    "descricao": "Embonato de espiramicina (pamoato de espiramicina)"
  },
  {
    "codigo": "29419059",
    "descricao": "Outros"
  },
  {
    "codigo": "29419061",
    "descricao": "Nistatina e seus sais"
  },
  {
    "codigo": "29419062",
    "descricao": "Anfotericina B e seus sais"
  },
  {
    "codigo": "29419069",
    "descricao": "Outros"
  },
  {
    "codigo": "29419071",
    "descricao": "Monensina sódica"
  },
  {
    "codigo": "29419072",
    "descricao": "Narasina"
  },
  {
    "codigo": "29419073",
    "descricao": "Avilamicinas"
  },
  {
    "codigo": "29419079",
    "descricao": "Outros"
  },
  {
    "codigo": "29419081",
    "descricao": "Polimixinas e seus sais, exceto sulfato de colistina"
  },
  {
    "codigo": "29419082",
    "descricao": "Sulfato de colistina"
  },
  {
    "codigo": "29419083",
    "descricao": "Virginiamicinas e seus sais"
  },
  {
    "codigo": "29419089",
    "descricao": "Outros"
  },
  {
    "codigo": "29419091",
    "descricao": "Griseofulvina e seus sais"
  },
  {
    "codigo": "29419092",
    "descricao": "Fumarato de tiamulina"
  },
  {
    "codigo": "29419099",
    "descricao": "Outros"
  },
  {
    "codigo": "29420000",
    "descricao": "Outros compostos orgânicos."
  },
  {
    "codigo": "30012010",
    "descricao": "De fígado"
  },
  {
    "codigo": "30012090",
    "descricao": "Outros"
  },
  {
    "codigo": "30019010",
    "descricao": "Heparina e seus sais"
  },
  {
    "codigo": "30019020",
    "descricao": "Pedaços de pericárdio de origem bovina ou suína"
  },
  {
    "codigo": "30019031",
    "descricao": "Fígados"
  },
  {
    "codigo": "30019039",
    "descricao": "Outros"
  },
  {
    "codigo": "30019090",
    "descricao": "Outros"
  },
  {
    "codigo": "30021211",
    "descricao": "Antiofídicos e outros antivenenosos"
  },
  {
    "codigo": "30021212",
    "descricao": "Antitetânico"
  },
  {
    "codigo": "30021213",
    "descricao": "Anticatarral"
  },
  {
    "codigo": "30021214",
    "descricao": "Antipiogênico"
  },
  {
    "codigo": "30021215",
    "descricao": "Antidiftérico"
  },
  {
    "codigo": "30021216",
    "descricao": "Polivalentes"
  },
  {
    "codigo": "30021219",
    "descricao": "Outros"
  },
  {
    "codigo": "30021221",
    "descricao": "Imunoglobulina anti-Rh"
  },
  {
    "codigo": "30021222",
    "descricao": "Outras imunoglobulinas séricas"
  },
  {
    "codigo": "30021223",
    "descricao": "Concentrado de fator VIII"
  },
  {
    "codigo": "30021224",
    "descricao": "Soroalbumina, sob a forma de gel, para preparação de reagentes de diagnóstico"
  },
  {
    "codigo": "30021229",
    "descricao": "Outros"
  },
  {
    "codigo": "30021231",
    "descricao": "Soroalbumina, exceto a humana"
  },
  {
    "codigo": "30021232",
    "descricao": "Plasmina (fibrinolisina)"
  },
  {
    "codigo": "30021233",
    "descricao": "Uroquinase"
  },
  {
    "codigo": "30021234",
    "descricao": "Imunoglobulina e cloridrato de histamina, associados"
  },
  {
    "codigo": "30021235",
    "descricao": "Imunoglobulina G, liofilizada ou em solução"
  },
  {
    "codigo": "30021236",
    "descricao": "Soroalbumina humana"
  },
  {
    "codigo": "30021239",
    "descricao": "Outros"
  },
  {
    "codigo": "30021300",
    "descricao": "-- Produtos imunológicos, não misturados, não apresentados em doses nem acondicionados para venda a retalho"
  },
  {
    "codigo": "30021400",
    "descricao": "-- Produtos imunológicos, misturados, não apresentados em doses nem acondicionados para venda a retalho"
  },
  {
    "codigo": "30021510",
    "descricao": "betainterferona; alfapeginterferona 2a"
  },
  {
    "codigo": "30021520",
    "descricao": "Basiliximab (DCI); bevacizumab (DCI); daclizumab (DCI); etanercept (DCI); gemtuzumab ozogamicin (DCI); oprelvekin (DCI); rituximab (DCI); trastuzumab (DCI)"
  },
  {
    "codigo": "30021590",
    "descricao": "Outros"
  },
  {
    "codigo": "30024111",
    "descricao": "Contra a gripe"
  },
  {
    "codigo": "30024112",
    "descricao": "Contra a poliomielite"
  },
  {
    "codigo": "30024113",
    "descricao": "Contra a hepatite B"
  },
  {
    "codigo": "30024114",
    "descricao": "Contra o sarampo"
  },
  {
    "codigo": "30024115",
    "descricao": "Contra a meningite"
  },
  {
    "codigo": "30024116",
    "descricao": "Contra a rubéola, sarampo e caxumba (tríplice)"
  },
  {
    "codigo": "30024117",
    "descricao": "Outras tríplices"
  },
  {
    "codigo": "30024118",
    "descricao": "Anticatarral e antipiogênico"
  },
  {
    "codigo": "30024119",
    "descricao": "Outras"
  },
  {
    "codigo": "30024121",
    "descricao": "Contra a gripe"
  },
  {
    "codigo": "30024122",
    "descricao": "Contra a poliomielite"
  },
  {
    "codigo": "30024123",
    "descricao": "Contra a hepatite B"
  },
  {
    "codigo": "30024124",
    "descricao": "Contra o sarampo"
  },
  {
    "codigo": "30024125",
    "descricao": "Contra a meningite"
  },
  {
    "codigo": "30024126",
    "descricao": "Contra a rubéola, sarampo e caxumba (tríplice)"
  },
  {
    "codigo": "30024127",
    "descricao": "Outras tríplices"
  },
  {
    "codigo": "30024128",
    "descricao": "Anticatarral e antipiogênico"
  },
  {
    "codigo": "30024129",
    "descricao": "Outras"
  },
  {
    "codigo": "30024210",
    "descricao": "Contra a raiva"
  },
  {
    "codigo": "30024220",
    "descricao": "Contra a coccidiose"
  },
  {
    "codigo": "30024230",
    "descricao": "Contra a querato-conjuntivite"
  },
  {
    "codigo": "30024240",
    "descricao": "Contra a cinomose"
  },
  {
    "codigo": "30024250",
    "descricao": "Contra a leptospirose"
  },
  {
    "codigo": "30024260",
    "descricao": "Contra a febre aftosa"
  },
  {
    "codigo": "30024270",
    "descricao": "Contra as seguintes enfermidades: de <i>Newcastle</i>, a vírus vivo ou vírus inativo; de Gumboro, a vírus vivo ou vírus inativo; bronquite, a vírus vivo ou vírus inativo; difteroviruela, a vírus vivo; síndrome de queda de postura (EDS); salmonelose aviária, elaborada com cepa 9R; cólera de aves, inativadas"
  },
  {
    "codigo": "30024280",
    "descricao": "Vacinas combinadas contra as enfermidades citadas no item 3002.42.70"
  },
  {
    "codigo": "30024290",
    "descricao": "Outras"
  },
  {
    "codigo": "30024910",
    "descricao": "Antitoxinas de origem microbiana"
  },
  {
    "codigo": "30024920",
    "descricao": "Tuberculinas"
  },
  {
    "codigo": "30024991",
    "descricao": "Para a saúde animal"
  },
  {
    "codigo": "30024992",
    "descricao": "Para a saúde humana"
  },
  {
    "codigo": "30024994",
    "descricao": "Ricina"
  },
  {
    "codigo": "30024999",
    "descricao": "Outros"
  },
  {
    "codigo": "30025100",
    "descricao": "-- Produtos de terapia celular"
  },
  {
    "codigo": "30025900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "30029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "30031011",
    "descricao": "Ampicilina ou seus sais"
  },
  {
    "codigo": "30031012",
    "descricao": "Amoxicilina ou seus sais"
  },
  {
    "codigo": "30031013",
    "descricao": "Penicilina G benzatínica"
  },
  {
    "codigo": "30031014",
    "descricao": "Penicilina G potássica"
  },
  {
    "codigo": "30031015",
    "descricao": "Penicilina G procaínica"
  },
  {
    "codigo": "30031019",
    "descricao": "Outros"
  },
  {
    "codigo": "30031020",
    "descricao": "Que contenham estreptomicinas ou seus derivados"
  },
  {
    "codigo": "30032011",
    "descricao": "Cloranfenicol, seu palmitato, seu succinato ou seu hemissuccinato"
  },
  {
    "codigo": "30032019",
    "descricao": "Outros"
  },
  {
    "codigo": "30032021",
    "descricao": "Eritromicina ou seus sais"
  },
  {
    "codigo": "30032029",
    "descricao": "Outros"
  },
  {
    "codigo": "30032031",
    "descricao": "Rifamicina SV sódica"
  },
  {
    "codigo": "30032032",
    "descricao": "Rifampicina"
  },
  {
    "codigo": "30032039",
    "descricao": "Outros"
  },
  {
    "codigo": "30032041",
    "descricao": "Cloridrato de lincomicina"
  },
  {
    "codigo": "30032049",
    "descricao": "Outros"
  },
  {
    "codigo": "30032051",
    "descricao": "Cefalotina sódica"
  },
  {
    "codigo": "30032052",
    "descricao": "Cefaclor ou cefalexina monoidratados"
  },
  {
    "codigo": "30032059",
    "descricao": "Outros"
  },
  {
    "codigo": "30032061",
    "descricao": "Sulfato de gentamicina"
  },
  {
    "codigo": "30032062",
    "descricao": "Daunorubicina"
  },
  {
    "codigo": "30032063",
    "descricao": "Idarubicina; pirarubicina"
  },
  {
    "codigo": "30032069",
    "descricao": "Outros"
  },
  {
    "codigo": "30032071",
    "descricao": "Vancomicina"
  },
  {
    "codigo": "30032072",
    "descricao": "Actinomicinas"
  },
  {
    "codigo": "30032073",
    "descricao": "Ciclosporina A"
  },
  {
    "codigo": "30032079",
    "descricao": "Outros"
  },
  {
    "codigo": "30032091",
    "descricao": "Mitomicina"
  },
  {
    "codigo": "30032092",
    "descricao": "Fumarato de tiamulina"
  },
  {
    "codigo": "30032093",
    "descricao": "Bleomicinas ou seus sais"
  },
  {
    "codigo": "30032094",
    "descricao": "Imipenem"
  },
  {
    "codigo": "30032095",
    "descricao": "Anfotericina B em lipossomas"
  },
  {
    "codigo": "30032099",
    "descricao": "Outros"
  },
  {
    "codigo": "30033100",
    "descricao": "-- Que contenham insulina"
  },
  {
    "codigo": "30033911",
    "descricao": "Somatotropina"
  },
  {
    "codigo": "30033912",
    "descricao": "Gonadotropina coriônica (hCG)"
  },
  {
    "codigo": "30033913",
    "descricao": "Menotropinas"
  },
  {
    "codigo": "30033914",
    "descricao": "Corticotropina (ACTH)"
  },
  {
    "codigo": "30033915",
    "descricao": "Gonadotropina sérica (PMSG)"
  },
  {
    "codigo": "30033916",
    "descricao": "Somatostatina ou seus sais"
  },
  {
    "codigo": "30033917",
    "descricao": "Buserelina ou seu acetato"
  },
  {
    "codigo": "30033918",
    "descricao": "Triptorelina ou seus sais"
  },
  {
    "codigo": "30033919",
    "descricao": "Leuprolida ou seu acetato"
  },
  {
    "codigo": "30033921",
    "descricao": "LH-RH (gonadorelina)"
  },
  {
    "codigo": "30033922",
    "descricao": "Oxitocina"
  },
  {
    "codigo": "30033923",
    "descricao": "Sais de insulina"
  },
  {
    "codigo": "30033924",
    "descricao": "Timosinas"
  },
  {
    "codigo": "30033925",
    "descricao": "Octreotida"
  },
  {
    "codigo": "30033926",
    "descricao": "Goserelina ou seu acetato"
  },
  {
    "codigo": "30033927",
    "descricao": "Nafarelina ou seu acetato"
  },
  {
    "codigo": "30033929",
    "descricao": "Outros"
  },
  {
    "codigo": "30033931",
    "descricao": "Hemissuccinato de estradiol"
  },
  {
    "codigo": "30033932",
    "descricao": "Fempropionato de estradiol"
  },
  {
    "codigo": "30033933",
    "descricao": "Estriol ou seu succinato"
  },
  {
    "codigo": "30033934",
    "descricao": "Alilestrenol"
  },
  {
    "codigo": "30033935",
    "descricao": "Linestrenol"
  },
  {
    "codigo": "30033936",
    "descricao": "Acetato de megestrol; formestano; fulvestranto"
  },
  {
    "codigo": "30033937",
    "descricao": "Desogestrel"
  },
  {
    "codigo": "30033939",
    "descricao": "Outros"
  },
  {
    "codigo": "30033981",
    "descricao": "Levotiroxina sódica"
  },
  {
    "codigo": "30033982",
    "descricao": "Liotironina sódica"
  },
  {
    "codigo": "30033991",
    "descricao": "Sal sódico ou éster metílico do ácido 9,11,15-triidroxi-16-(3-clorofenoxi)prosta-5,13-dien-1-oico (derivado da prostaglandina F<sub>2</sub>-alfa)"
  },
  {
    "codigo": "30033992",
    "descricao": "Tiratricol (triac) ou seu sal sódico"
  },
  {
    "codigo": "30033994",
    "descricao": "Espironolactona"
  },
  {
    "codigo": "30033995",
    "descricao": "Exemestano"
  },
  {
    "codigo": "30033999",
    "descricao": "Outros"
  },
  {
    "codigo": "30034100",
    "descricao": "-- Que contenham efedrina ou seus sais"
  },
  {
    "codigo": "30034200",
    "descricao": "-- Que contenham pseudoefedrina (DCI) ou seus sais"
  },
  {
    "codigo": "30034300",
    "descricao": "-- Que contenham norefedrina ou seus sais"
  },
  {
    "codigo": "30034910",
    "descricao": "Vimblastina; vincristina; derivados destes produtos; topotecan ou seu cloridrato"
  },
  {
    "codigo": "30034920",
    "descricao": "Pilocarpina, seu nitrato ou seu cloridrato"
  },
  {
    "codigo": "30034930",
    "descricao": "Metanossulfonato de di-hidroergocristina"
  },
  {
    "codigo": "30034940",
    "descricao": "Codeína ou seus sais"
  },
  {
    "codigo": "30034950",
    "descricao": "Granisetron; tropisetrona ou seu cloridrato"
  },
  {
    "codigo": "30034990",
    "descricao": "Outros"
  },
  {
    "codigo": "30036000",
    "descricao": "- Outros, que contenham princípios ativos antimaláricos (antipalúdicos) descritos na Nota de subposições 2 do presente Capítulo"
  },
  {
    "codigo": "30039011",
    "descricao": "Folinato de cálcio (leucovorina)"
  },
  {
    "codigo": "30039012",
    "descricao": "Nicotinamida"
  },
  {
    "codigo": "30039013",
    "descricao": "Hidroxocobalamina ou seus sais; cianocobalamina"
  },
  {
    "codigo": "30039014",
    "descricao": "Vitamina A<sub>1</sub> (retinol) ou seus derivados, exceto o ácido retinoico (tretinoína)"
  },
  {
    "codigo": "30039015",
    "descricao": "D-Pantotenato de cálcio; vitamina D<sub>3</sub> (colecalciferol)"
  },
  {
    "codigo": "30039016",
    "descricao": "Ésteres das vitaminas A e D<sub>3</sub>, em concentração igual ou superior a 1.500.000 UI/g de vitamina A e igual ou superior a 50.000 UI/g de vitamina D<sub>3</sub>"
  },
  {
    "codigo": "30039017",
    "descricao": "Ácido retinoico (tretinoína)"
  },
  {
    "codigo": "30039019",
    "descricao": "Outros"
  },
  {
    "codigo": "30039021",
    "descricao": "Estreptoquinase"
  },
  {
    "codigo": "30039022",
    "descricao": "L-Asparaginase"
  },
  {
    "codigo": "30039023",
    "descricao": "Deoxirribonuclease"
  },
  {
    "codigo": "30039024",
    "descricao": "Idursulfase"
  },
  {
    "codigo": "30039025",
    "descricao": "alfa-Agalsidase; alfavelaglicerase"
  },
  {
    "codigo": "30039029",
    "descricao": "Outros"
  },
  {
    "codigo": "30039031",
    "descricao": "Permetrina; nitrato de propatila; benzoato de benzila; dioctilsulfossuccinato de sódio"
  },
  {
    "codigo": "30039032",
    "descricao": "Ácido cólico; ácido deoxicólico; sal magnésico do ácido deidrocólico"
  },
  {
    "codigo": "30039033",
    "descricao": "Ácido glucônico, seus sais ou seus ésteres"
  },
  {
    "codigo": "30039034",
    "descricao": "Ácido <i>o</i>-acetilsalicílico; <i>o</i>-acetilsalicilato de alumínio; salicilato de metila; diclorvós"
  },
  {
    "codigo": "30039035",
    "descricao": "Lactofosfato de cálcio"
  },
  {
    "codigo": "30039036",
    "descricao": "Ácido láctico, seus sais ou seus ésteres; ácido 4-(4-hidroxifenoxi)-3,5-di-iodofenilacético"
  },
  {
    "codigo": "30039037",
    "descricao": "Ácido fumárico, seus sais ou seus ésteres"
  },
  {
    "codigo": "30039038",
    "descricao": "Etretinato; fosfestrol ou seus sais de di ou tetrassódio"
  },
  {
    "codigo": "30039039",
    "descricao": "Outros"
  },
  {
    "codigo": "30039041",
    "descricao": "Sulfato de tranilcipromina; dietilpropiona"
  },
  {
    "codigo": "30039042",
    "descricao": "Cloridrato de ketamina"
  },
  {
    "codigo": "30039043",
    "descricao": "Clembuterol ou seu cloridrato"
  },
  {
    "codigo": "30039044",
    "descricao": "Tamoxifen ou seu citrato"
  },
  {
    "codigo": "30039045",
    "descricao": "Levodopa; alfa-metildopa"
  },
  {
    "codigo": "30039046",
    "descricao": "Cloridrato de fenilefrina; mirtecaína; propranolol ou seus sais"
  },
  {
    "codigo": "30039047",
    "descricao": "Diclofenaco de sódio; diclofenaco de potássio; diclofenaco de dietilamônio"
  },
  {
    "codigo": "30039048",
    "descricao": "Clorambucil; clormetina (DCI) ou seu cloridrato; melfalano; toremifene ou seu citrato"
  },
  {
    "codigo": "30039049",
    "descricao": "Outros"
  },
  {
    "codigo": "30039051",
    "descricao": "Metoclopramida ou seu cloridrato; closantel"
  },
  {
    "codigo": "30039052",
    "descricao": "Atenolol; prilocaína ou seu cloridrato; talidomida"
  },
  {
    "codigo": "30039053",
    "descricao": "Lidocaína ou seu cloridrato; flutamida"
  },
  {
    "codigo": "30039054",
    "descricao": "Femproporex"
  },
  {
    "codigo": "30039055",
    "descricao": "Paracetamol; bromoprida"
  },
  {
    "codigo": "30039056",
    "descricao": "Amitraz; cipermetrina"
  },
  {
    "codigo": "30039057",
    "descricao": "Clorexidina ou seus sais; isetionato de pentamidina"
  },
  {
    "codigo": "30039058",
    "descricao": "Aminoglutetimida; carmustina; deferoxamina (desferrioxamina B) ou seus sais, derivados destes produtos; lomustina"
  },
  {
    "codigo": "30039059",
    "descricao": "Outros"
  },
  {
    "codigo": "30039061",
    "descricao": "Quercetina"
  },
  {
    "codigo": "30039062",
    "descricao": "Tiaprida"
  },
  {
    "codigo": "30039063",
    "descricao": "Etidronato dissódico"
  },
  {
    "codigo": "30039064",
    "descricao": "Cloridrato de amiodarona"
  },
  {
    "codigo": "30039065",
    "descricao": "Nitrovin; moxidectina"
  },
  {
    "codigo": "30039066",
    "descricao": "Ácido clodrônico ou seu sal dissódico; estreptozocina; fotemustina"
  },
  {
    "codigo": "30039067",
    "descricao": "Carbocisteína; sulfiram"
  },
  {
    "codigo": "30039069",
    "descricao": "Outros"
  },
  {
    "codigo": "30039071",
    "descricao": "Terfenadina; talniflumato; malato ácido de cleboprida; econazol ou seu nitrato; nitrato de isoconazol; flubendazol; cloridrato de mepivacaína; trimetoprima; cloridrato de bupivacaína"
  },
  {
    "codigo": "30039072",
    "descricao": "Cloridrato de loperamida; fembendazol; ketorolac trometamina; nifedipina; nimodipina; nitrendipina"
  },
  {
    "codigo": "30039073",
    "descricao": "Albendazol ou seu sulfóxido; mebendazol; 6-mercaptopurina; metilsulfato de amezínio; oxifendazol; praziquantel"
  },
  {
    "codigo": "30039074",
    "descricao": "Alprazolam; bromazepam; clordiazepóxido; cloridrato de petidina; diazepam; droperidol; mazindol; triazolam"
  },
  {
    "codigo": "30039075",
    "descricao": "Benzetimida ou seu cloridrato; fenitoína ou seu sal sódico; isoniazida; pirazinamida"
  },
  {
    "codigo": "30039076",
    "descricao": "Ácido 2-(2-metil-3-cloroanilina)nicotínico ou seu sal de lisina; metronidazol ou seus sais; azatioprina; nitrato de miconazol"
  },
  {
    "codigo": "30039077",
    "descricao": "Enrofloxacina; maleato de enalapril; maleato de pirilamina; nicarbazina; norfloxacina; sais de piperazina"
  },
  {
    "codigo": "30039078",
    "descricao": "Altretamina; bortezomib; cloridrato de erlotinibe; dacarbazina; disoproxilfumarato de tenofovir; enfuvirtida; fluspirileno; letrozol; lopinavir; mesilato de imatinib; nelfinavir ou seu mesilato; nevirapine; pemetrexed; saquinavir; sulfato de abacavir; sulfato de atazanavir; sulfato de indinavir; temozolomida; tioguanina; tiopental sódico; tosilato de niraparibe; trietilenotiofosforamida; trimetrexato; uracil e tegafur; verteporfin"
  },
  {
    "codigo": "30039079",
    "descricao": "Outros"
  },
  {
    "codigo": "30039081",
    "descricao": "Levamisol ou seus sais; tetramisol"
  },
  {
    "codigo": "30039082",
    "descricao": "Sulfadiazina ou seu sal sódico; sulfametoxazol"
  },
  {
    "codigo": "30039083",
    "descricao": "Cloxazolam; ketazolam; piroxicam; tenoxicam"
  },
  {
    "codigo": "30039084",
    "descricao": "Ftalilsulfatiazol; inosina"
  },
  {
    "codigo": "30039085",
    "descricao": "Enantato de flufenazina; prometazina; gliburida; rutosídio; deslanosídio"
  },
  {
    "codigo": "30039086",
    "descricao": "Clortalidona; furosemida"
  },
  {
    "codigo": "30039087",
    "descricao": "Cloridrato de tizanidina; cetoconazol; furazolidona"
  },
  {
    "codigo": "30039088",
    "descricao": "Amprenavir; aprepitanto; delavirdina ou seu mesilato; efavirenz; emtricitabina; etopósido; everolimus; fosamprenavir cálcico; fosfato de fludarabina; gencitabina ou seu cloridrato; mesilato de dabrafenibe; raltitrexida; ritonavir; sirolimus; tacrolimus; temsirolimus; tenipósido; tipranavir"
  },
  {
    "codigo": "30039089",
    "descricao": "Outros"
  },
  {
    "codigo": "30039091",
    "descricao": "Extrato de pólen"
  },
  {
    "codigo": "30039092",
    "descricao": "Crisarobina; disofenol"
  },
  {
    "codigo": "30039093",
    "descricao": "Diclofenaco resinato"
  },
  {
    "codigo": "30039094",
    "descricao": "Silimarina"
  },
  {
    "codigo": "30039095",
    "descricao": "Bussulfano; dexormaplatina; dietilestilbestrol ou seu dipropionato; enloplatina; iproplatina; lobaplatina; miboplatina; miltefosina; mitotano; ormaplatina; procarbazina ou seu cloridrato; propofol; sebriplatina; zeniplatina"
  },
  {
    "codigo": "30039096",
    "descricao": "Complexo de ferro dextrana"
  },
  {
    "codigo": "30039097",
    "descricao": "Sevoflurano"
  },
  {
    "codigo": "30039099",
    "descricao": "Outros"
  },
  {
    "codigo": "30041011",
    "descricao": "Ampicilina ou seus sais"
  },
  {
    "codigo": "30041012",
    "descricao": "Amoxicilina ou seus sais"
  },
  {
    "codigo": "30041013",
    "descricao": "Penicilina G benzatínica"
  },
  {
    "codigo": "30041014",
    "descricao": "Penicilina G potássica"
  },
  {
    "codigo": "30041015",
    "descricao": "Penicilina G procaínica"
  },
  {
    "codigo": "30041019",
    "descricao": "Outros"
  },
  {
    "codigo": "30041020",
    "descricao": "Que contenham estreptomicinas ou seus derivados"
  },
  {
    "codigo": "30042011",
    "descricao": "Cloranfenicol, seu palmitato, seu succinato ou seu hemissuccinato"
  },
  {
    "codigo": "30042019",
    "descricao": "Outros"
  },
  {
    "codigo": "30042021",
    "descricao": "Eritromicina ou seus sais"
  },
  {
    "codigo": "30042029",
    "descricao": "Outros"
  },
  {
    "codigo": "30042031",
    "descricao": "Rifamicina SV sódica"
  },
  {
    "codigo": "30042032",
    "descricao": "Rifampicina"
  },
  {
    "codigo": "30042039",
    "descricao": "Outros"
  },
  {
    "codigo": "30042041",
    "descricao": "Cloridrato de lincomicina"
  },
  {
    "codigo": "30042049",
    "descricao": "Outros"
  },
  {
    "codigo": "30042051",
    "descricao": "Cefalotina sódica"
  },
  {
    "codigo": "30042052",
    "descricao": "Cefaclor ou cefalexina monoidratados"
  },
  {
    "codigo": "30042059",
    "descricao": "Outros"
  },
  {
    "codigo": "30042061",
    "descricao": "Sulfato de gentamicina"
  },
  {
    "codigo": "30042062",
    "descricao": "Daunorubicina"
  },
  {
    "codigo": "30042063",
    "descricao": "Idarubicina; pirarubicina"
  },
  {
    "codigo": "30042069",
    "descricao": "Outros"
  },
  {
    "codigo": "30042071",
    "descricao": "Vancomicina"
  },
  {
    "codigo": "30042072",
    "descricao": "Actinomicinas"
  },
  {
    "codigo": "30042073",
    "descricao": "Ciclosporina A"
  },
  {
    "codigo": "30042079",
    "descricao": "Outros"
  },
  {
    "codigo": "30042091",
    "descricao": "Mitomicina"
  },
  {
    "codigo": "30042092",
    "descricao": "Fumarato de tiamulina"
  },
  {
    "codigo": "30042093",
    "descricao": "Bleomicinas ou seus sais"
  },
  {
    "codigo": "30042094",
    "descricao": "Imipenem"
  },
  {
    "codigo": "30042095",
    "descricao": "Anfotericina B em lipossomas"
  },
  {
    "codigo": "30042099",
    "descricao": "Outros"
  },
  {
    "codigo": "30043100",
    "descricao": "-- Que contenham insulina"
  },
  {
    "codigo": "30043210",
    "descricao": "Hormônios corticosteroides"
  },
  {
    "codigo": "30043220",
    "descricao": "Espironolactona"
  },
  {
    "codigo": "30043290",
    "descricao": "Outros"
  },
  {
    "codigo": "30043911",
    "descricao": "Somatotropina"
  },
  {
    "codigo": "30043912",
    "descricao": "Gonadotropina coriônica (hCG)"
  },
  {
    "codigo": "30043913",
    "descricao": "Menotropinas"
  },
  {
    "codigo": "30043914",
    "descricao": "Corticotropina (ACTH)"
  },
  {
    "codigo": "30043915",
    "descricao": "Gonadotropina sérica (PMSG)"
  },
  {
    "codigo": "30043916",
    "descricao": "Somatostatina ou seus sais"
  },
  {
    "codigo": "30043917",
    "descricao": "Buserelina ou seu acetato"
  },
  {
    "codigo": "30043918",
    "descricao": "Triptorelina ou seus sais"
  },
  {
    "codigo": "30043919",
    "descricao": "Leuprolida ou seu acetato"
  },
  {
    "codigo": "30043921",
    "descricao": "LH-RH (gonadorelina)"
  },
  {
    "codigo": "30043922",
    "descricao": "Oxitocina"
  },
  {
    "codigo": "30043923",
    "descricao": "Sais de insulina"
  },
  {
    "codigo": "30043924",
    "descricao": "Timosinas"
  },
  {
    "codigo": "30043925",
    "descricao": "Calcitonina"
  },
  {
    "codigo": "30043926",
    "descricao": "Octreotida"
  },
  {
    "codigo": "30043927",
    "descricao": "Goserelina ou seu acetato"
  },
  {
    "codigo": "30043928",
    "descricao": "Nafarelina ou seu acetato"
  },
  {
    "codigo": "30043929",
    "descricao": "Outros"
  },
  {
    "codigo": "30043931",
    "descricao": "Hemissuccinato de estradiol"
  },
  {
    "codigo": "30043932",
    "descricao": "Fempropionato de estradiol"
  },
  {
    "codigo": "30043933",
    "descricao": "Estriol ou seu succinato"
  },
  {
    "codigo": "30043934",
    "descricao": "Alilestrenol"
  },
  {
    "codigo": "30043935",
    "descricao": "Linestrenol"
  },
  {
    "codigo": "30043936",
    "descricao": "Acetato de megestrol; formestano; fulvestranto"
  },
  {
    "codigo": "30043937",
    "descricao": "Desogestrel"
  },
  {
    "codigo": "30043939",
    "descricao": "Outros"
  },
  {
    "codigo": "30043981",
    "descricao": "Levotiroxina sódica"
  },
  {
    "codigo": "30043982",
    "descricao": "Liotironina sódica"
  },
  {
    "codigo": "30043991",
    "descricao": "Sal sódico ou éster metílico do ácido 9,11,15-triidroxi-16-(3-clorofenoxi)prosta-5,13-dien-1-oico (derivado da prostaglandina F<sub>2</sub>-alfa)"
  },
  {
    "codigo": "30043992",
    "descricao": "Tiratricol (triac) ou seu sal sódico"
  },
  {
    "codigo": "30043994",
    "descricao": "Exemestano"
  },
  {
    "codigo": "30043999",
    "descricao": "Outros"
  },
  {
    "codigo": "30044100",
    "descricao": "-- Que contenham efedrina ou seus sais"
  },
  {
    "codigo": "30044200",
    "descricao": "-- Que contenham pseudoefedrina (DCI) ou seus sais"
  },
  {
    "codigo": "30044300",
    "descricao": "-- Que contenham norefedrina ou seus sais"
  },
  {
    "codigo": "30044910",
    "descricao": "Vimblastina; vincristina; derivados destes produtos; topotecan ou seu cloridrato"
  },
  {
    "codigo": "30044920",
    "descricao": "Pilocarpina, seu nitrato ou seu cloridrato"
  },
  {
    "codigo": "30044930",
    "descricao": "Metanossulfonato de di-hidroergocristina"
  },
  {
    "codigo": "30044940",
    "descricao": "Codeína ou seus sais"
  },
  {
    "codigo": "30044950",
    "descricao": "Granisetron; tropisetrona ou seu cloridrato"
  },
  {
    "codigo": "30044990",
    "descricao": "Outros"
  },
  {
    "codigo": "30045010",
    "descricao": "Folinato de cálcio (leucovorina)"
  },
  {
    "codigo": "30045020",
    "descricao": "Nicotinamida"
  },
  {
    "codigo": "30045030",
    "descricao": "Hidroxocobalamina ou seus sais; cianocobalamina"
  },
  {
    "codigo": "30045040",
    "descricao": "Vitamina A<sub>1</sub> (retinol) ou seus derivados, exceto o ácido retinoico (tretinoína)"
  },
  {
    "codigo": "30045050",
    "descricao": "D-Pantotenato de cálcio; vitamina D<sub>3</sub> (colecalciferol)"
  },
  {
    "codigo": "30045060",
    "descricao": "Ácido retinoico (tretinoína)"
  },
  {
    "codigo": "30045090",
    "descricao": "Outros"
  },
  {
    "codigo": "30046000",
    "descricao": "- Outros, que contenham princípios ativos antimaláricos (antipalúdicos) descritos na Nota de subposições 2 do presente Capítulo"
  },
  {
    "codigo": "30049011",
    "descricao": "Estreptoquinase"
  },
  {
    "codigo": "30049012",
    "descricao": "L-Asparaginase"
  },
  {
    "codigo": "30049013",
    "descricao": "Deoxirribonuclease"
  },
  {
    "codigo": "30049014",
    "descricao": "Idursulfase"
  },
  {
    "codigo": "30049015",
    "descricao": "alfa-Agalsidase; alfavelaglicerase"
  },
  {
    "codigo": "30049019",
    "descricao": "Outros"
  },
  {
    "codigo": "30049021",
    "descricao": "Permetrina; nitrato de propatila; benzoato de benzila; dioctilsulfossuccinato de sódio"
  },
  {
    "codigo": "30049022",
    "descricao": "Ácido cólico; ácido deoxicólico; sal magnésico do ácido deidrocólico"
  },
  {
    "codigo": "30049023",
    "descricao": "Ácido glucônico, seus sais ou seus ésteres"
  },
  {
    "codigo": "30049024",
    "descricao": "Ácido <i>o</i>-acetilsalicílico; <i>o</i>-acetilsalicilato de alumínio; salicilato de metila; diclorvós"
  },
  {
    "codigo": "30049025",
    "descricao": "Lactofosfato de cálcio"
  },
  {
    "codigo": "30049026",
    "descricao": "Ácido láctico, seus sais ou seus ésteres; ácido 4-(4-hidroxifenoxi)-3,5-di-iodofenilacético; ácido fumárico, seus sais ou seus ésteres"
  },
  {
    "codigo": "30049027",
    "descricao": "Nitroglicerina, destinada a ser administrada por via percutânea"
  },
  {
    "codigo": "30049028",
    "descricao": "Etretinato; fosfestrol ou seus sais de di ou tetrassódio"
  },
  {
    "codigo": "30049029",
    "descricao": "Outros"
  },
  {
    "codigo": "30049031",
    "descricao": "Sulfato de tranilcipromina; dietilpropiona"
  },
  {
    "codigo": "30049032",
    "descricao": "Cloridrato de ketamina"
  },
  {
    "codigo": "30049033",
    "descricao": "Clembuterol ou seu cloridrato"
  },
  {
    "codigo": "30049034",
    "descricao": "Tamoxifen ou seu citrato"
  },
  {
    "codigo": "30049035",
    "descricao": "Levodopa; alfa-metildopa"
  },
  {
    "codigo": "30049036",
    "descricao": "Cloridrato de fenilefrina; mirtecaína; propranolol ou seus sais"
  },
  {
    "codigo": "30049037",
    "descricao": "Diclofenaco de sódio; diclofenaco de potássio; diclofenaco de dietilamônio"
  },
  {
    "codigo": "30049038",
    "descricao": "Clorambucil; clormetina (DCI) ou seu cloridrato; melfalano; toremifene ou seu citrato"
  },
  {
    "codigo": "30049039",
    "descricao": "Outros"
  },
  {
    "codigo": "30049041",
    "descricao": "Metoclopramida ou seu cloridrato; closantel"
  },
  {
    "codigo": "30049042",
    "descricao": "Atenolol; prilocaína ou seu cloridrato; talidomida"
  },
  {
    "codigo": "30049043",
    "descricao": "Lidocaína ou seu cloridrato; flutamida"
  },
  {
    "codigo": "30049044",
    "descricao": "Femproporex"
  },
  {
    "codigo": "30049045",
    "descricao": "Paracetamol; bromoprida"
  },
  {
    "codigo": "30049046",
    "descricao": "Amitraz; cipermetrina"
  },
  {
    "codigo": "30049047",
    "descricao": "Clorexidina ou seus sais; isetionato de pentamidina"
  },
  {
    "codigo": "30049048",
    "descricao": "Aminoglutetimida; carmustina; deferoxamina (desferrioxamina B) ou seus sais, derivados destes produtos; lomustina"
  },
  {
    "codigo": "30049049",
    "descricao": "Outros"
  },
  {
    "codigo": "30049051",
    "descricao": "Quercetina"
  },
  {
    "codigo": "30049052",
    "descricao": "Tiaprida"
  },
  {
    "codigo": "30049053",
    "descricao": "Etidronato dissódico"
  },
  {
    "codigo": "30049054",
    "descricao": "Cloridrato de amiodarona"
  },
  {
    "codigo": "30049055",
    "descricao": "Nitrovin; moxidectina"
  },
  {
    "codigo": "30049057",
    "descricao": "Carbocisteína; sulfiram"
  },
  {
    "codigo": "30049058",
    "descricao": "Ácido clodrônico ou seu sal dissódico; estreptozocina; fotemustina"
  },
  {
    "codigo": "30049059",
    "descricao": "Outros"
  },
  {
    "codigo": "30049061",
    "descricao": "Terfenadina; talniflumato; malato ácido de cleboprida; econazol ou seu nitrato; nitrato de isoconazol; flubendazol; cloridrato de mepivacaína; trimetoprima; cloridrato de bupivacaína"
  },
  {
    "codigo": "30049062",
    "descricao": "Cloridrato de loperamida; fembendazol; ketorolac trometamina; nifedipina nimodipina; nitrendipina"
  },
  {
    "codigo": "30049063",
    "descricao": "Albendazol ou seu sulfóxido; mebendazol; 6-mercaptopurina; metilsulfato de amezínio; oxifendazol; praziquantel"
  },
  {
    "codigo": "30049064",
    "descricao": "Alprazolam; bromazepam; clordiazepóxido; cloridrato de petidina; diazepam; droperidol; mazindol; triazolam"
  },
  {
    "codigo": "30049065",
    "descricao": "Benzetimida ou seu cloridrato; fenitoína ou seu sal sódico; isoniazida; pirazinamida"
  },
  {
    "codigo": "30049066",
    "descricao": "Ácido 2-(2-metil-3-cloroanilina)nicotínico ou seu sal de lisina; metronidazol ou seus sais; azatioprina; nitrato de miconazol"
  },
  {
    "codigo": "30049067",
    "descricao": "Enrofloxacina; maleato de enalapril; maleato de pirilamina; nicarbazina; norfloxacina; sais de piperazina"
  },
  {
    "codigo": "30049068",
    "descricao": "Altretamina; bortezomib; cloridrato de erlotinibe; dacarbazina; disoproxilfumarato de tenofovir; enfuvirtida; fluspirileno; letrozol; lopinavir; mesilato de imatinib; nelfinavir ou seu mesilato; nevirapine; pemetrexed; saquinavir; sulfato de abacavir; sulfato de atazanavir; sulfato de indinavir; temozolomida; tioguanina; tiopental sódico; tosilato de niraparibe; trietilenotiofosforamida; trimetrexato; uracil e tegafur; verteporfin"
  },
  {
    "codigo": "30049069",
    "descricao": "Outros"
  },
  {
    "codigo": "30049071",
    "descricao": "Levamisol ou seus sais; tetramisol"
  },
  {
    "codigo": "30049072",
    "descricao": "Sulfadiazina ou seu sal sódico; sulfametoxazol"
  },
  {
    "codigo": "30049073",
    "descricao": "Cloxazolam; ketazolam; piroxicam; tenoxicam"
  },
  {
    "codigo": "30049074",
    "descricao": "Ftalilsulfatiazol; inosina"
  },
  {
    "codigo": "30049075",
    "descricao": "Enantato de flufenazina; prometazina; gliburida; rutosídio; deslanosídio"
  },
  {
    "codigo": "30049076",
    "descricao": "Clortalidona; furosemida"
  },
  {
    "codigo": "30049077",
    "descricao": "Cloridrato de tizanidina; cetoconazol; furazolidona"
  },
  {
    "codigo": "30049078",
    "descricao": "Amprenavir; aprepitanto; delavirdina ou seu mesilato; efavirenz; emtricitabina; etopósido; everolimus; fosamprenavir cálcico; fosfato de fludarabina; gencitabina ou seu cloridrato; mesilato de dabrafenibe; raltitrexida; ritonavir; sirolimus; tacrolimus; temsirolimus; tenipósido; tipranavir"
  },
  {
    "codigo": "30049079",
    "descricao": "Outros"
  },
  {
    "codigo": "30049091",
    "descricao": "Extrato de pólen"
  },
  {
    "codigo": "30049092",
    "descricao": "Crisarobina; disofenol"
  },
  {
    "codigo": "30049093",
    "descricao": "Diclofenaco resinato"
  },
  {
    "codigo": "30049094",
    "descricao": "Silimarina"
  },
  {
    "codigo": "30049095",
    "descricao": "Bussulfano; dexormaplatina; dietilestilbestrol ou seu dipropionato; enloplatina; iproplatina; lobaplatina; miboplatina; miltefosina; mitotano; ormaplatina; procarbazina ou seu cloridrato; propofol; sebriplatina; zeniplatina"
  },
  {
    "codigo": "30049096",
    "descricao": "Complexo de ferro dextrana"
  },
  {
    "codigo": "30049097",
    "descricao": "Sevoflurano"
  },
  {
    "codigo": "30049098",
    "descricao": "Regenerador de cartilagem, constituído por colágeno moldado, absorvível"
  },
  {
    "codigo": "30049099",
    "descricao": "Outros"
  },
  {
    "codigo": "30051010",
    "descricao": "Impregnados ou recobertos de substâncias farmacêuticas"
  },
  {
    "codigo": "30051020",
    "descricao": "Curativos (pensos) cirúrgicos que permitem a observação direta de feridas"
  },
  {
    "codigo": "30051030",
    "descricao": "Curativos (pensos) impermeáveis aplicáveis sobre mucosas"
  },
  {
    "codigo": "30051040",
    "descricao": "Curativos (pensos) com obturador próprios para colostomia (cones obturadores)"
  },
  {
    "codigo": "30051050",
    "descricao": "Curativos (pensos) com fecho de correr próprios para fechar ferimentos"
  },
  {
    "codigo": "30051090",
    "descricao": "Outros"
  },
  {
    "codigo": "30059011",
    "descricao": "De ácido poliglicólico"
  },
  {
    "codigo": "30059012",
    "descricao": "De copolímeros de ácido glicólico e ácido láctico"
  },
  {
    "codigo": "30059019",
    "descricao": "Outros"
  },
  {
    "codigo": "30059020",
    "descricao": "Campos cirúrgicos, de falso tecido (tecido não tecido)"
  },
  {
    "codigo": "30059090",
    "descricao": "Outros"
  },
  {
    "codigo": "30061010",
    "descricao": "Materiais para suturas cirúrgicas, de polidioxanona"
  },
  {
    "codigo": "30061020",
    "descricao": "Materiais para suturas cirúrgicas, de aço inoxidável"
  },
  {
    "codigo": "30061090",
    "descricao": "Outros"
  },
  {
    "codigo": "30063011",
    "descricao": "À base de ioexol"
  },
  {
    "codigo": "30063012",
    "descricao": "À base de iocarmato de dimeglumina ou de iodixanol"
  },
  {
    "codigo": "30063013",
    "descricao": "À base de iopamidol"
  },
  {
    "codigo": "30063015",
    "descricao": "À base de dióxido de zircônio e sulfato de gentamicina"
  },
  {
    "codigo": "30063016",
    "descricao": "À base de diatrizoato de sódio ou de meglumina"
  },
  {
    "codigo": "30063017",
    "descricao": "À base de iomeprol, iopromida ou de ioversol"
  },
  {
    "codigo": "30063018",
    "descricao": "À base de iotalamato de sódio, de iotalamato de meglumina ou de suas misturas"
  },
  {
    "codigo": "30063019",
    "descricao": "Outras"
  },
  {
    "codigo": "30063021",
    "descricao": "À base de somatoliberina"
  },
  {
    "codigo": "30063029",
    "descricao": "Outros"
  },
  {
    "codigo": "30064011",
    "descricao": "Cimentos"
  },
  {
    "codigo": "30064012",
    "descricao": "Outros produtos para obturação dentária"
  },
  {
    "codigo": "30064020",
    "descricao": "Cimentos para reconstituição óssea"
  },
  {
    "codigo": "30065000",
    "descricao": "- Estojos e caixas de primeiros socorros, guarnecidos"
  },
  {
    "codigo": "30066000",
    "descricao": "- Preparações químicas contraceptivas à base de hormônios, de outros produtos da posição 29.37 ou de espermicidas"
  },
  {
    "codigo": "30067000",
    "descricao": "- Preparações apresentadas sob a forma de gel concebidas para uso em medicina humana ou veterinária como lubrificante para determinadas partes do corpo em intervenções cirúrgicas ou exames médicos ou como meio de ligação entre o corpo e os instrumentos médicos"
  },
  {
    "codigo": "30069110",
    "descricao": "Bolsas para colostomia, ileostomia e urostomia"
  },
  {
    "codigo": "30069190",
    "descricao": "Outros"
  },
  {
    "codigo": "30069200",
    "descricao": "-- Resíduos farmacêuticos"
  },
  {
    "codigo": "30069300",
    "descricao": "-- Placebos e estojos para ensaios clínicos cegos (ou duplo-cegos) destinados a um ensaio clínico reconhecido, apresentados em doses"
  },
  {
    "codigo": "31010000",
    "descricao": "Adubos (fertilizantes) de origem animal ou vegetal, mesmo misturados entre si ou tratados quimicamente; adubos (fertilizantes) resultantes da mistura ou do tratamento químico de produtos de origem animal ou vegetal."
  },
  {
    "codigo": "31021010",
    "descricao": "Que contenha, em peso, mais de 45 % de nitrogênio (azoto), calculado sobre o produto anidro no estado seco"
  },
  {
    "codigo": "31021090",
    "descricao": "Outra"
  },
  {
    "codigo": "31022100",
    "descricao": "-- Sulfato de amônio"
  },
  {
    "codigo": "31022910",
    "descricao": "Sulfonitrato de amônio"
  },
  {
    "codigo": "31022990",
    "descricao": "Outros"
  },
  {
    "codigo": "31023000",
    "descricao": "- Nitrato de amônio, mesmo em solução aquosa"
  },
  {
    "codigo": "31024000",
    "descricao": "- Misturas de nitrato de amônio com carbonato de cálcio ou com outras matérias inorgânicas desprovidas de poder fertilizante"
  },
  {
    "codigo": "31025011",
    "descricao": "Que contenha, em peso, 16,3 % ou menos de nitrogênio (azoto)"
  },
  {
    "codigo": "31025019",
    "descricao": "Outro"
  },
  {
    "codigo": "31025090",
    "descricao": "Outro"
  },
  {
    "codigo": "31026000",
    "descricao": "- Sais duplos e misturas de nitrato de cálcio e de nitrato de amônio"
  },
  {
    "codigo": "31028000",
    "descricao": "- Misturas de ureia com nitrato de amônio em soluções aquosas ou amoniacais"
  },
  {
    "codigo": "31029000",
    "descricao": "- Outros, incluindo as misturas não mencionadas nas subposições precedentes"
  },
  {
    "codigo": "31031100",
    "descricao": "-- Que contenham, em peso, 35 % ou mais de pentóxido de difósforo (P<sub>2</sub>O<sub>5</sub>)"
  },
  {
    "codigo": "31031900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "31039011",
    "descricao": "Que contenha, em peso, 46 % ou menos de pentóxido de difósforo (P<sub>2</sub>O<sub>5</sub>)"
  },
  {
    "codigo": "31039019",
    "descricao": "Outros"
  },
  {
    "codigo": "31039090",
    "descricao": "Outros"
  },
  {
    "codigo": "31042010",
    "descricao": "Que contenha, em peso, 60 % ou menos de óxido de potássio (K<sub>2</sub>O)"
  },
  {
    "codigo": "31042090",
    "descricao": "Outros"
  },
  {
    "codigo": "31043010",
    "descricao": "Que contenha, em peso, 52 % ou menos de óxido de potássio (K<sub>2</sub>O)"
  },
  {
    "codigo": "31043090",
    "descricao": "Outros"
  },
  {
    "codigo": "31049010",
    "descricao": "Sulfato duplo de potássio e magnésio, que contenha, em peso, 30 % ou mais de óxido de potássio (K<sub>2</sub>O)"
  },
  {
    "codigo": "31049090",
    "descricao": "Outros"
  },
  {
    "codigo": "31051000",
    "descricao": "- Produtos do presente Capítulo apresentados em tabletes ou formas semelhantes, ou ainda em embalagens de peso bruto não superior a 10 kg"
  },
  {
    "codigo": "31052000",
    "descricao": "- Adubos (fertilizantes) minerais ou químicos, que contenham os três elementos fertilizantes: nitrogênio (azoto), fósforo e potássio"
  },
  {
    "codigo": "31053000",
    "descricao": "- Hidrogeno-ortofosfato de diamônio (fosfato de diamônio ou diamoniacal)"
  },
  {
    "codigo": "31054000",
    "descricao": "- Di-hidrogeno-ortofosfato de amônio (fosfato de monoamônio ou monoamoniacal), mesmo misturado com hidrogeno-ortofosfato de diamônio (fosfato de diamônio ou diamoniacal)"
  },
  {
    "codigo": "31055100",
    "descricao": "-- Que contenham nitratos e fosfatos"
  },
  {
    "codigo": "31055900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "31056000",
    "descricao": "- Adubos (fertilizantes) minerais ou químicos, que contenham os dois elementos fertilizantes: fósforo e potássio"
  },
  {
    "codigo": "31059011",
    "descricao": "Que contenha, em peso, 15 % ou menos de nitrogênio (azoto) e 15 % ou menos de óxido de potássio (K<sub>2</sub>O)"
  },
  {
    "codigo": "31059019",
    "descricao": "Outros"
  },
  {
    "codigo": "31059090",
    "descricao": "Outros"
  },
  {
    "codigo": "32011000",
    "descricao": "- Extrato de quebracho"
  },
  {
    "codigo": "32012000",
    "descricao": "- Extrato de mimosa"
  },
  {
    "codigo": "32019011",
    "descricao": "De gambir"
  },
  {
    "codigo": "32019012",
    "descricao": "De carvalho ou de castanheiro"
  },
  {
    "codigo": "32019019",
    "descricao": "Outros"
  },
  {
    "codigo": "32019020",
    "descricao": "Taninos"
  },
  {
    "codigo": "32019090",
    "descricao": "Outros"
  },
  {
    "codigo": "32021000",
    "descricao": "- Produtos tanantes orgânicos sintéticos"
  },
  {
    "codigo": "32029011",
    "descricao": "À base de sais de cromo"
  },
  {
    "codigo": "32029012",
    "descricao": "À base de sais de titânio"
  },
  {
    "codigo": "32029013",
    "descricao": "À base de sais de zircônio"
  },
  {
    "codigo": "32029019",
    "descricao": "Outros"
  },
  {
    "codigo": "32029021",
    "descricao": "À base de compostos de cromo"
  },
  {
    "codigo": "32029029",
    "descricao": "Outros"
  },
  {
    "codigo": "32029030",
    "descricao": "Preparações enzimáticas para a pré-curtimenta"
  },
  {
    "codigo": "32030011",
    "descricao": "Hemateína"
  },
  {
    "codigo": "32030012",
    "descricao": "Fisetina"
  },
  {
    "codigo": "32030013",
    "descricao": "Morina"
  },
  {
    "codigo": "32030019",
    "descricao": "Outras"
  },
  {
    "codigo": "32030021",
    "descricao": "Carmim de cochonilha"
  },
  {
    "codigo": "32030029",
    "descricao": "Outras"
  },
  {
    "codigo": "32030030",
    "descricao": "Preparações indicadas na Nota 3 do presente Capítulo, à base de matérias corantes de origem vegetal ou animal"
  },
  {
    "codigo": "32041100",
    "descricao": "-- Corantes dispersos e preparações à base desses corantes"
  },
  {
    "codigo": "32041210",
    "descricao": "Corantes ácidos, mesmo metalizados, e preparações à base desses corantes"
  },
  {
    "codigo": "32041220",
    "descricao": "Corantes mordentes e preparações à base desses corantes"
  },
  {
    "codigo": "32041300",
    "descricao": "-- Corantes básicos e preparações à base desses corantes"
  },
  {
    "codigo": "32041400",
    "descricao": "-- Corantes diretos e preparações à base desses corantes"
  },
  {
    "codigo": "32041510",
    "descricao": "<i>Indigo blue</i> segundo Colour Index 73000"
  },
  {
    "codigo": "32041520",
    "descricao": "Dibenzantrona"
  },
  {
    "codigo": "32041530",
    "descricao": "12,12-Dimetoxidibenzantrona"
  },
  {
    "codigo": "32041590",
    "descricao": "Outros"
  },
  {
    "codigo": "32041600",
    "descricao": "-- Corantes reagentes e preparações à base desses corantes"
  },
  {
    "codigo": "32041700",
    "descricao": "-- Pigmentos e preparações à base desses pigmentos"
  },
  {
    "codigo": "32041810",
    "descricao": "Carotenoides"
  },
  {
    "codigo": "32041820",
    "descricao": "Preparações que contenham beta-caroteno, ésteres metílico ou etílico do ácido 8'-apo-beta-carotenoico ou cantaxantina, com óleos vegetais, amido, gelatina, sacarose ou dextrina, próprias para colorir alimentos"
  },
  {
    "codigo": "32041830",
    "descricao": "Outras preparações próprias para colorir alimentos"
  },
  {
    "codigo": "32041890",
    "descricao": "Outras"
  },
  {
    "codigo": "32041920",
    "descricao": "Corantes solúveis em solventes (corantes solventes)"
  },
  {
    "codigo": "32041930",
    "descricao": "Corantes azoicos"
  },
  {
    "codigo": "32041990",
    "descricao": "Outras"
  },
  {
    "codigo": "32042011",
    "descricao": "Derivados do ácido 4,4-bis-(1,3,5)triazinil-6-aminoestilbeno-2,2-dissulfônico"
  },
  {
    "codigo": "32042019",
    "descricao": "Outros"
  },
  {
    "codigo": "32042090",
    "descricao": "Outros"
  },
  {
    "codigo": "32049000",
    "descricao": "- Outros"
  },
  {
    "codigo": "32050000",
    "descricao": "Lacas corantes; preparações indicadas na Nota 3 do presente Capítulo, à base de lacas corantes."
  },
  {
    "codigo": "32061110",
    "descricao": "Pigmentos tipo rutilo"
  },
  {
    "codigo": "32061120",
    "descricao": "Outros pigmentos"
  },
  {
    "codigo": "32061130",
    "descricao": "Preparações"
  },
  {
    "codigo": "32061910",
    "descricao": "Pigmento constituído por mica revestida com película de dióxido de titânio"
  },
  {
    "codigo": "32061990",
    "descricao": "Outros"
  },
  {
    "codigo": "32062000",
    "descricao": "- Pigmentos e preparações à base de compostos de cromo"
  },
  {
    "codigo": "32064100",
    "descricao": "-- Ultramar e suas preparações"
  },
  {
    "codigo": "32064210",
    "descricao": "Litopônio"
  },
  {
    "codigo": "32064290",
    "descricao": "Outros"
  },
  {
    "codigo": "32064910",
    "descricao": "Pigmentos e preparações à base de compostos de cádmio"
  },
  {
    "codigo": "32064920",
    "descricao": "Pigmentos e preparações à base de hexacianoferratos (ferrocianetos e ferricianetos)"
  },
  {
    "codigo": "32064990",
    "descricao": "Outras"
  },
  {
    "codigo": "32065011",
    "descricao": "Halofosfatos de cálcio ou de estrôncio"
  },
  {
    "codigo": "32065019",
    "descricao": "Outros"
  },
  {
    "codigo": "32065021",
    "descricao": "Halofosfatos de cálcio ou de estrôncio"
  },
  {
    "codigo": "32065029",
    "descricao": "Outros"
  },
  {
    "codigo": "32071020",
    "descricao": "Suspensão de pigmentos em solventes orgânicos, do tipo utilizado em impressoras de jato de tinta para decoração de superfícies cerâmicas por cozimento"
  },
  {
    "codigo": "32071030",
    "descricao": "Outros, à base de zircônio ou de seus sais"
  },
  {
    "codigo": "32071090",
    "descricao": "Outros"
  },
  {
    "codigo": "32072010",
    "descricao": "Engobos"
  },
  {
    "codigo": "32072091",
    "descricao": "Com um teor, em peso, de prata igual ou superior a 25 % ou de bismuto igual ou superior a 40 %, do tipo utilizado na fabricação de circuitos impressos"
  },
  {
    "codigo": "32072099",
    "descricao": "Outras"
  },
  {
    "codigo": "32073000",
    "descricao": "- Polimentos (Esmaltes metálicos*) líquidos e preparações semelhantes"
  },
  {
    "codigo": "32074010",
    "descricao": "Fritas de vidro"
  },
  {
    "codigo": "32074090",
    "descricao": "Outros"
  },
  {
    "codigo": "32081010",
    "descricao": "Tintas"
  },
  {
    "codigo": "32081020",
    "descricao": "Vernizes"
  },
  {
    "codigo": "32081030",
    "descricao": "Soluções definidas na Nota 4 do presente Capítulo"
  },
  {
    "codigo": "32082011",
    "descricao": "À base de polímeros acrílicos, apresentadas em sortidos definidos na Nota 3 da Seção VI, do tipo utilizado para a fabricação de circuitos impressos"
  },
  {
    "codigo": "32082019",
    "descricao": "Outras"
  },
  {
    "codigo": "32082020",
    "descricao": "Vernizes"
  },
  {
    "codigo": "32082030",
    "descricao": "Soluções definidas na Nota 4 do presente Capítulo"
  },
  {
    "codigo": "32089010",
    "descricao": "Tintas"
  },
  {
    "codigo": "32089021",
    "descricao": "À base de derivados de celulose"
  },
  {
    "codigo": "32089029",
    "descricao": "Outros"
  },
  {
    "codigo": "32089031",
    "descricao": "De silicones"
  },
  {
    "codigo": "32089039",
    "descricao": "Outras"
  },
  {
    "codigo": "32091010",
    "descricao": "Tintas"
  },
  {
    "codigo": "32091020",
    "descricao": "Vernizes"
  },
  {
    "codigo": "32099011",
    "descricao": "À base de politetrafluoretileno"
  },
  {
    "codigo": "32099019",
    "descricao": "Outras"
  },
  {
    "codigo": "32099020",
    "descricao": "Vernizes"
  },
  {
    "codigo": "32100010",
    "descricao": "Tintas"
  },
  {
    "codigo": "32100020",
    "descricao": "Vernizes"
  },
  {
    "codigo": "32100030",
    "descricao": "Pigmentos a água preparados, do tipo utilizado para acabamento de couros"
  },
  {
    "codigo": "32110000",
    "descricao": "Secantes preparados."
  },
  {
    "codigo": "32121000",
    "descricao": "- Folhas para marcar a ferro"
  },
  {
    "codigo": "32129010",
    "descricao": "Alumínio em pó ou em lamelas, empastado com solvente do tipo hidrocarbonetos, com um teor de alumínio igual ou superior a 60 %, em peso"
  },
  {
    "codigo": "32129090",
    "descricao": "Outros"
  },
  {
    "codigo": "32131000",
    "descricao": "- Cores em sortidos"
  },
  {
    "codigo": "32139000",
    "descricao": "- Outras"
  },
  {
    "codigo": "32141010",
    "descricao": "Mástique de vidraceiro, cimentos de resina e outras mástiques"
  },
  {
    "codigo": "32141020",
    "descricao": "Indutos utilizados em pintura"
  },
  {
    "codigo": "32149000",
    "descricao": "- Outros"
  },
  {
    "codigo": "32151100",
    "descricao": "-- Pretas"
  },
  {
    "codigo": "32151900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "32159000",
    "descricao": "- Outras"
  },
  {
    "codigo": "33011210",
    "descricao": "De <i>petit grain</i>"
  },
  {
    "codigo": "33011290",
    "descricao": "Outros"
  },
  {
    "codigo": "33011300",
    "descricao": "-- De limão"
  },
  {
    "codigo": "33011910",
    "descricao": "De lima"
  },
  {
    "codigo": "33011990",
    "descricao": "Outros"
  },
  {
    "codigo": "33012400",
    "descricao": "-- De hortelã-pimenta (<i>Mentha piperita</i>)"
  },
  {
    "codigo": "33012510",
    "descricao": "De menta japonesa (<i>Mentha arvensis</i>)"
  },
  {
    "codigo": "33012520",
    "descricao": "De <i>mentha spearmint</i> (<i>Mentha viridis</i><i> L.</i>)"
  },
  {
    "codigo": "33012590",
    "descricao": "Outros"
  },
  {
    "codigo": "33012911",
    "descricao": "De citronela"
  },
  {
    "codigo": "33012912",
    "descricao": "De cedro"
  },
  {
    "codigo": "33012913",
    "descricao": "De pau-santo (<i>Bulnesia sarmientoi</i>)"
  },
  {
    "codigo": "33012914",
    "descricao": "De <i>lemongrass</i>"
  },
  {
    "codigo": "33012915",
    "descricao": "De pau-rosa"
  },
  {
    "codigo": "33012916",
    "descricao": "De palma rosa"
  },
  {
    "codigo": "33012917",
    "descricao": "De coriandro"
  },
  {
    "codigo": "33012918",
    "descricao": "De cabreúva"
  },
  {
    "codigo": "33012919",
    "descricao": "De eucalipto"
  },
  {
    "codigo": "33012921",
    "descricao": "De alfazema ou lavanda"
  },
  {
    "codigo": "33012922",
    "descricao": "De vetiver"
  },
  {
    "codigo": "33012990",
    "descricao": "Outros"
  },
  {
    "codigo": "33013000",
    "descricao": "- Resinoides"
  },
  {
    "codigo": "33019010",
    "descricao": "Soluções concentradas de óleos essenciais em gorduras, em óleos fixos, em ceras ou em matérias análogas, obtidas por tratamento de flores através de substâncias gordas ou por maceração"
  },
  {
    "codigo": "33019020",
    "descricao": "Subprodutos terpênicos residuais da desterpenação dos óleos essenciais"
  },
  {
    "codigo": "33019030",
    "descricao": "Águas destiladas aromáticas e soluções aquosas de óleos essenciais"
  },
  {
    "codigo": "33019040",
    "descricao": "Oleorresinas de extração"
  },
  {
    "codigo": "33021000",
    "descricao": "- Do tipo utilizado para as indústrias alimentares ou de bebidas"
  },
  {
    "codigo": "33029011",
    "descricao": "Vetiverol"
  },
  {
    "codigo": "33029019",
    "descricao": "Outras"
  },
  {
    "codigo": "33029091",
    "descricao": "Misturas à base de substâncias odoríferas apresentadas sob a forma de microcápsulas"
  },
  {
    "codigo": "33029099",
    "descricao": "Outras"
  },
  {
    "codigo": "33030010",
    "descricao": "Perfumes (extratos)"
  },
  {
    "codigo": "33030020",
    "descricao": "Águas-de-colônia"
  },
  {
    "codigo": "33041000",
    "descricao": "- Produtos de maquiagem para os lábios"
  },
  {
    "codigo": "33042010",
    "descricao": "Sombra, delineador, lápis para sobrancelhas e rímel"
  },
  {
    "codigo": "33042090",
    "descricao": "Outros"
  },
  {
    "codigo": "33043000",
    "descricao": "- Preparações para manicuros e pedicuros"
  },
  {
    "codigo": "33049100",
    "descricao": "-- Pós, incluindo os compactos"
  },
  {
    "codigo": "33049910",
    "descricao": "Cremes de beleza e cremes nutritivos; loções tônicas"
  },
  {
    "codigo": "33049990",
    "descricao": "Outros"
  },
  {
    "codigo": "33051000",
    "descricao": "- Xampus"
  },
  {
    "codigo": "33052000",
    "descricao": "- Preparações para ondulação ou alisamento, permanentes"
  },
  {
    "codigo": "33053000",
    "descricao": "- Laquês (Lacas*) para o cabelo"
  },
  {
    "codigo": "33059000",
    "descricao": "- Outras"
  },
  {
    "codigo": "33061000",
    "descricao": "- Dentifrícios (dentífricos)"
  },
  {
    "codigo": "33062000",
    "descricao": "- Fios utilizados para limpar os espaços interdentais (fios dentais)"
  },
  {
    "codigo": "33069000",
    "descricao": "- Outras"
  },
  {
    "codigo": "33071000",
    "descricao": "- Preparações para barbear (antes, durante ou após)"
  },
  {
    "codigo": "33072010",
    "descricao": "Líquidos"
  },
  {
    "codigo": "33072090",
    "descricao": "Outros"
  },
  {
    "codigo": "33073000",
    "descricao": "- Sais perfumados e outras preparações para banhos"
  },
  {
    "codigo": "33074100",
    "descricao": "-- Agarbate e outras preparações odoríferas que atuem por combustão"
  },
  {
    "codigo": "33074900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "33079000",
    "descricao": "- Outros"
  },
  {
    "codigo": "34011110",
    "descricao": "Sabões medicinais"
  },
  {
    "codigo": "34011190",
    "descricao": "Outros"
  },
  {
    "codigo": "34011900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "34012010",
    "descricao": "De toucador"
  },
  {
    "codigo": "34012090",
    "descricao": "Outros"
  },
  {
    "codigo": "34013000",
    "descricao": "- Produtos e preparações orgânicos tensoativos para lavagem da pele, sob a forma de líquido ou de creme, acondicionados para venda a retalho, mesmo que contenham sabão"
  },
  {
    "codigo": "34023100",
    "descricao": "-- Ácidos sulfônicos de alquilbenzenos lineares e seus sais"
  },
  {
    "codigo": "34023910",
    "descricao": "Dibutilnaftalenossulfato de sódio"
  },
  {
    "codigo": "34023920",
    "descricao": "N-Metil-N-oleiltaurato de sódio"
  },
  {
    "codigo": "34023930",
    "descricao": "Alquilsulfonato de sódio, secundário"
  },
  {
    "codigo": "34023990",
    "descricao": "Outros"
  },
  {
    "codigo": "34024110",
    "descricao": "Acetato de oleilamina"
  },
  {
    "codigo": "34024190",
    "descricao": "Outros"
  },
  {
    "codigo": "34024200",
    "descricao": "-- Não iônicos"
  },
  {
    "codigo": "34024900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "34025000",
    "descricao": "- Preparações acondicionadas para venda a retalho"
  },
  {
    "codigo": "34029011",
    "descricao": "Que contenham exclusivamente produtos não iônicos"
  },
  {
    "codigo": "34029019",
    "descricao": "Outras"
  },
  {
    "codigo": "34029021",
    "descricao": "Soluções ou emulsões hidroalcoólicas de (1-perfluoralquil-2-acetoxi)propil-betaína"
  },
  {
    "codigo": "34029022",
    "descricao": "À base de nonanoiloxibenzenossulfonato de sódio"
  },
  {
    "codigo": "34029023",
    "descricao": "Soluções ou emulsões hidroalcoólicas de sulfonatos de perfluoralquiltrimetilamônio e de perfluoralquilacrilamida"
  },
  {
    "codigo": "34029029",
    "descricao": "Outras"
  },
  {
    "codigo": "34029031",
    "descricao": "À base de nonilfenol etoxilado"
  },
  {
    "codigo": "34029039",
    "descricao": "Outras"
  },
  {
    "codigo": "34029090",
    "descricao": "Outras"
  },
  {
    "codigo": "34031110",
    "descricao": "Para o tratamento de matérias têxteis"
  },
  {
    "codigo": "34031120",
    "descricao": "Para o tratamento de couros e peles"
  },
  {
    "codigo": "34031190",
    "descricao": "Outras"
  },
  {
    "codigo": "34031900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "34039110",
    "descricao": "Para o tratamento de matérias têxteis"
  },
  {
    "codigo": "34039120",
    "descricao": "Para o tratamento de couros e peles"
  },
  {
    "codigo": "34039190",
    "descricao": "Outras"
  },
  {
    "codigo": "34039900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "34042010",
    "descricao": "Ceras artificiais"
  },
  {
    "codigo": "34042020",
    "descricao": "Ceras preparadas"
  },
  {
    "codigo": "34049011",
    "descricao": "De polietileno, emulsionáveis"
  },
  {
    "codigo": "34049012",
    "descricao": "Outras, de polietileno"
  },
  {
    "codigo": "34049013",
    "descricao": "De polipropilenoglicóis"
  },
  {
    "codigo": "34049014",
    "descricao": "De dímero de alquilceteno com dois grupos alternados <i>n</i>-alquila de C<sub>12</sub>, C<sub>14</sub> e C<sub>16</sub>, em grânulos"
  },
  {
    "codigo": "34049019",
    "descricao": "Outras"
  },
  {
    "codigo": "34049021",
    "descricao": "À base de vaselina e álcoois de lanolina (eucerina anidra)"
  },
  {
    "codigo": "34049022",
    "descricao": "À base de hidroxiestearil cetil éter"
  },
  {
    "codigo": "34049029",
    "descricao": "Outras"
  },
  {
    "codigo": "34051000",
    "descricao": "- Pomadas, cremes e preparações semelhantes, para calçado ou para couros"
  },
  {
    "codigo": "34052000",
    "descricao": "- Encáusticas e preparações semelhantes, para conservação e limpeza de móveis de madeira, soalhos e de outros artigos de madeira"
  },
  {
    "codigo": "34053000",
    "descricao": "- Preparações para dar brilho a pinturas de carroçarias e produtos semelhantes, exceto preparações para dar brilho a metais"
  },
  {
    "codigo": "34054000",
    "descricao": "- Pastas, pós e outras preparações para arear"
  },
  {
    "codigo": "34059000",
    "descricao": "- Outros"
  },
  {
    "codigo": "34060000",
    "descricao": "Velas, pavios, círios e artigos semelhantes."
  },
  {
    "codigo": "34070010",
    "descricao": "Massas ou pastas para modelar"
  },
  {
    "codigo": "34070020",
    "descricao": "\"Ceras para odontologia\""
  },
  {
    "codigo": "34070090",
    "descricao": "Outras"
  },
  {
    "codigo": "35011000",
    "descricao": "- Caseínas"
  },
  {
    "codigo": "35019011",
    "descricao": "Caseinato de sódio"
  },
  {
    "codigo": "35019019",
    "descricao": "Outros"
  },
  {
    "codigo": "35019020",
    "descricao": "Colas de caseína"
  },
  {
    "codigo": "35021100",
    "descricao": "-- Seca"
  },
  {
    "codigo": "35021900",
    "descricao": "-- Outra"
  },
  {
    "codigo": "35022000",
    "descricao": "- Lactalbumina, incluindo os concentrados de duas ou mais proteínas de soro de leite"
  },
  {
    "codigo": "35029010",
    "descricao": "Soroalbumina"
  },
  {
    "codigo": "35029090",
    "descricao": "Outros"
  },
  {
    "codigo": "35030011",
    "descricao": "De osseína, com grau de pureza igual ou superior a 99,98 %, em peso"
  },
  {
    "codigo": "35030012",
    "descricao": "De osseína, com grau de pureza inferior a 99,98 %, em peso"
  },
  {
    "codigo": "35030019",
    "descricao": "Outros"
  },
  {
    "codigo": "35030090",
    "descricao": "Outras"
  },
  {
    "codigo": "35040011",
    "descricao": "Peptonas e peptonatos"
  },
  {
    "codigo": "35040019",
    "descricao": "Outros"
  },
  {
    "codigo": "35040020",
    "descricao": "Proteínas de soja em pó, com um teor de proteínas igual ou superior a 90 %, em peso, em base seca"
  },
  {
    "codigo": "35040030",
    "descricao": "Proteínas de batata em pó, com um teor de proteínas igual ou superior a 80 %, em peso, em base seca"
  },
  {
    "codigo": "35040090",
    "descricao": "Outros"
  },
  {
    "codigo": "35051000",
    "descricao": "- Dextrina e outros amidos e féculas modificados"
  },
  {
    "codigo": "35052000",
    "descricao": "- Colas"
  },
  {
    "codigo": "35061010",
    "descricao": "À base de cianoacrilatos"
  },
  {
    "codigo": "35061090",
    "descricao": "Outros"
  },
  {
    "codigo": "35069110",
    "descricao": "À base de borracha"
  },
  {
    "codigo": "35069120",
    "descricao": "À base de polímeros das posições 39.01 a 39.13, dispersos ou para dispersar em meio aquoso"
  },
  {
    "codigo": "35069190",
    "descricao": "Outros"
  },
  {
    "codigo": "35069900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "35071000",
    "descricao": "- Coalho e seus concentrados"
  },
  {
    "codigo": "35079011",
    "descricao": "Alfa-amilase (<i>Aspergillus oryzae</i>)"
  },
  {
    "codigo": "35079019",
    "descricao": "Outros"
  },
  {
    "codigo": "35079021",
    "descricao": "Fibrinucleases"
  },
  {
    "codigo": "35079022",
    "descricao": "Bromelina"
  },
  {
    "codigo": "35079023",
    "descricao": "Estreptoquinase"
  },
  {
    "codigo": "35079024",
    "descricao": "Estreptodornase"
  },
  {
    "codigo": "35079025",
    "descricao": "Mistura de estreptoquinase e estreptodornase"
  },
  {
    "codigo": "35079026",
    "descricao": "Papaína"
  },
  {
    "codigo": "35079029",
    "descricao": "Outros"
  },
  {
    "codigo": "35079031",
    "descricao": "Lisozima e seu cloridrato"
  },
  {
    "codigo": "35079032",
    "descricao": "L-Asparaginase"
  },
  {
    "codigo": "35079039",
    "descricao": "Outros"
  },
  {
    "codigo": "35079041",
    "descricao": "À base de celulases"
  },
  {
    "codigo": "35079042",
    "descricao": "À base de transglutaminase"
  },
  {
    "codigo": "35079049",
    "descricao": "Outras"
  },
  {
    "codigo": "36010000",
    "descricao": "Pólvoras propulsivas."
  },
  {
    "codigo": "36020000",
    "descricao": "Explosivos preparados, exceto pólvoras propulsivas."
  },
  {
    "codigo": "36031000",
    "descricao": "- Estopins e rastilhos, de segurança"
  },
  {
    "codigo": "36032000",
    "descricao": "- Cordéis (cordões) detonantes"
  },
  {
    "codigo": "36033000",
    "descricao": "- Escorvas fulminantes"
  },
  {
    "codigo": "36034000",
    "descricao": "- Cápsulas fulminantes"
  },
  {
    "codigo": "36035000",
    "descricao": "- Inflamadores"
  },
  {
    "codigo": "36036000",
    "descricao": "- Detonadores elétricos"
  },
  {
    "codigo": "36041000",
    "descricao": "- Fogos de artifício"
  },
  {
    "codigo": "36049010",
    "descricao": "Foguetes e cartuchos contra o granizo e semelhantes"
  },
  {
    "codigo": "36049090",
    "descricao": "Outros"
  },
  {
    "codigo": "36050000",
    "descricao": "Fósforos, exceto os artigos de pirotecnia da posição 36.04."
  },
  {
    "codigo": "36061000",
    "descricao": "- Combustíveis líquidos e combustíveis gasosos liquefeitos, em recipientes do tipo utilizado para carregar ou recarregar isqueiros ou acendedores, com capacidade não superior a 300 cm<sup>3</sup>"
  },
  {
    "codigo": "36069000",
    "descricao": "- Outros"
  },
  {
    "codigo": "37011010",
    "descricao": "Sensibilizados em uma face"
  },
  {
    "codigo": "37011021",
    "descricao": "Próprios para uso odontológico"
  },
  {
    "codigo": "37011029",
    "descricao": "Outros"
  },
  {
    "codigo": "37012010",
    "descricao": "Para fotografia a cores (policromo)"
  },
  {
    "codigo": "37012020",
    "descricao": "Para fotografia monocromática"
  },
  {
    "codigo": "37013010",
    "descricao": "Para fotografia a cores (policromo)"
  },
  {
    "codigo": "37013021",
    "descricao": "De alumínio"
  },
  {
    "codigo": "37013022",
    "descricao": "De poliéster"
  },
  {
    "codigo": "37013029",
    "descricao": "Outras"
  },
  {
    "codigo": "37013031",
    "descricao": "De alumínio"
  },
  {
    "codigo": "37013039",
    "descricao": "Outras"
  },
  {
    "codigo": "37013040",
    "descricao": "Filmes para as artes gráficas"
  },
  {
    "codigo": "37013050",
    "descricao": "Filmes heliográficos, de poliéster"
  },
  {
    "codigo": "37013090",
    "descricao": "Outros"
  },
  {
    "codigo": "37019100",
    "descricao": "-- Para fotografia a cores (policromo)"
  },
  {
    "codigo": "37019900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "37021010",
    "descricao": "Sensibilizados em uma face"
  },
  {
    "codigo": "37021020",
    "descricao": "Sensibilizados em ambas as faces"
  },
  {
    "codigo": "37023100",
    "descricao": "-- Para fotografia a cores (policromo)"
  },
  {
    "codigo": "37023200",
    "descricao": "-- Outros, que contenham uma emulsão de halogenetos de prata"
  },
  {
    "codigo": "37023900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "37024100",
    "descricao": "-- De largura superior a 610 mm e comprimento superior a 200 m, para fotografia a cores (policromo)"
  },
  {
    "codigo": "37024210",
    "descricao": "Para as artes gráficas"
  },
  {
    "codigo": "37024290",
    "descricao": "Outros"
  },
  {
    "codigo": "37024310",
    "descricao": "Para as artes gráficas"
  },
  {
    "codigo": "37024320",
    "descricao": "Heliográficos, de poliéster"
  },
  {
    "codigo": "37024390",
    "descricao": "Outros"
  },
  {
    "codigo": "37024410",
    "descricao": "Para fotografia a cores (policromo)"
  },
  {
    "codigo": "37024421",
    "descricao": "Para as artes gráficas"
  },
  {
    "codigo": "37024422",
    "descricao": "Fotopolimerizáveis, sensibilizadas à base de compostos acrílicos, do tipo utilizado para a fabricação de circuitos impressos"
  },
  {
    "codigo": "37024429",
    "descricao": "Outros"
  },
  {
    "codigo": "37025200",
    "descricao": "-- De largura não superior a 16 mm"
  },
  {
    "codigo": "37025300",
    "descricao": "-- De largura superior a 16 mm, mas não superior a 35 mm, e comprimento não superior a 30 m, para diapositivos"
  },
  {
    "codigo": "37025411",
    "descricao": "Em bobinas (<i>filmpacks</i>)"
  },
  {
    "codigo": "37025412",
    "descricao": "De 12 exposições (0,5 m de comprimento), de 24 exposições (1,0 m de comprimento) ou de 36 exposições (1,5 m de comprimento)"
  },
  {
    "codigo": "37025419",
    "descricao": "Outros"
  },
  {
    "codigo": "37025491",
    "descricao": "Em bobinas (<i>filmpacks</i>)"
  },
  {
    "codigo": "37025499",
    "descricao": "Outros"
  },
  {
    "codigo": "37025510",
    "descricao": "De largura igual a 35 mm"
  },
  {
    "codigo": "37025590",
    "descricao": "Outros"
  },
  {
    "codigo": "37025600",
    "descricao": "-- De largura superior a 35 mm"
  },
  {
    "codigo": "37029600",
    "descricao": "-- De largura não superior a 35 mm e comprimento não superior a 30 m"
  },
  {
    "codigo": "37029700",
    "descricao": "-- De largura não superior a 35 mm e comprimento superior a 30 m"
  },
  {
    "codigo": "37029800",
    "descricao": "-- De largura superior a 35 mm"
  },
  {
    "codigo": "37031010",
    "descricao": "Para fotografia a cores (policromo)"
  },
  {
    "codigo": "37031021",
    "descricao": "Papel heliográfico"
  },
  {
    "codigo": "37031029",
    "descricao": "Outros"
  },
  {
    "codigo": "37032000",
    "descricao": "- Outros, para fotografia a cores (policromo)"
  },
  {
    "codigo": "37039010",
    "descricao": "Papel para fotocomposição"
  },
  {
    "codigo": "37039090",
    "descricao": "Outros"
  },
  {
    "codigo": "37040000",
    "descricao": "Chapas, filmes, papéis, cartões e têxteis, fotográficos, impressionados, mas não revelados."
  },
  {
    "codigo": "37050010",
    "descricao": "Fotomáscaras sobre vidro plano, positivas, próprias para gravação em pastilhas de silício (<i>chips</i>) para fabricação de microestruturas eletrônicas"
  },
  {
    "codigo": "37050090",
    "descricao": "Outros"
  },
  {
    "codigo": "37061000",
    "descricao": "- De largura igual ou superior a 35 mm"
  },
  {
    "codigo": "37069000",
    "descricao": "- Outros"
  },
  {
    "codigo": "37071000",
    "descricao": "- Emulsões para sensibilização"
  },
  {
    "codigo": "37079010",
    "descricao": "Fixadores"
  },
  {
    "codigo": "37079021",
    "descricao": "À base de negro de fumo ou de um corante e resinas termoplásticas, para a reprodução de documentos por processo eletrostático"
  },
  {
    "codigo": "37079029",
    "descricao": "Outros"
  },
  {
    "codigo": "37079030",
    "descricao": "Compostos diazoicos fotossensíveis para preparação de emulsões"
  },
  {
    "codigo": "37079090",
    "descricao": "Outros"
  },
  {
    "codigo": "38011000",
    "descricao": "- Grafita artificial"
  },
  {
    "codigo": "38012010",
    "descricao": "Suspensão semicoloidal em óleos minerais"
  },
  {
    "codigo": "38012090",
    "descricao": "Outros"
  },
  {
    "codigo": "38013010",
    "descricao": "Pasta carbonada para eletrodos"
  },
  {
    "codigo": "38013090",
    "descricao": "Outras"
  },
  {
    "codigo": "38019000",
    "descricao": "- Outras"
  },
  {
    "codigo": "38021000",
    "descricao": "- Carvões ativados"
  },
  {
    "codigo": "38029010",
    "descricao": "Farinhas siliciosas fósseis"
  },
  {
    "codigo": "38029020",
    "descricao": "Bentonita"
  },
  {
    "codigo": "38029030",
    "descricao": "Atapulgita"
  },
  {
    "codigo": "38029040",
    "descricao": "Outras argilas e terras"
  },
  {
    "codigo": "38029050",
    "descricao": "Bauxita"
  },
  {
    "codigo": "38029090",
    "descricao": "Outros"
  },
  {
    "codigo": "38030010",
    "descricao": "Em bruto"
  },
  {
    "codigo": "38030090",
    "descricao": "Outros"
  },
  {
    "codigo": "38040011",
    "descricao": "Ao sulfito"
  },
  {
    "codigo": "38040012",
    "descricao": "À soda ou ao sulfato"
  },
  {
    "codigo": "38040020",
    "descricao": "Lignossulfonatos"
  },
  {
    "codigo": "38051000",
    "descricao": "- Essências de terebintina, de pinheiro ou provenientes da fabricação da pasta de papel ao sulfato"
  },
  {
    "codigo": "38059010",
    "descricao": "Óleo de pinho"
  },
  {
    "codigo": "38059090",
    "descricao": "Outros"
  },
  {
    "codigo": "38061000",
    "descricao": "- Colofônias e ácidos resínicos"
  },
  {
    "codigo": "38062000",
    "descricao": "- Sais de colofônias, de ácidos resínicos ou de derivados de colofônias ou de ácidos resínicos, exceto os sais de aductos de colofônias"
  },
  {
    "codigo": "38063000",
    "descricao": "- Gomas ésteres"
  },
  {
    "codigo": "38069011",
    "descricao": "Colofônias oxidadas, hidrogenadas, desidrogenadas, polimerizadas ou modificadas com ácidos fumárico ou maleico ou com anidrido maleico"
  },
  {
    "codigo": "38069012",
    "descricao": "Abietatos de metila ou de benzila; hidroabietato de metila"
  },
  {
    "codigo": "38069019",
    "descricao": "Outros"
  },
  {
    "codigo": "38069090",
    "descricao": "Outros"
  },
  {
    "codigo": "38070000",
    "descricao": "Alcatrões de madeira; óleos de alcatrão de madeira; creosoto de madeira; metileno; breu (pez) vegetal; breu (pez) para a indústria da cerveja e preparações semelhantes à base de colofônias, de ácidos resínicos ou de breu (pez) vegetal."
  },
  {
    "codigo": "38085200",
    "descricao": "-- DDT (ISO) (clofenotano (DCI)), acondicionado em embalagens com um conteúdo de peso líquido não superior a 300 g"
  },
  {
    "codigo": "38085910",
    "descricao": "Apresentadas em formas ou embalagens exclusivamente para uso direto em aplicações domissanitárias"
  },
  {
    "codigo": "38085921",
    "descricao": "À base de metamidofós (ISO) ou de monocrotofós (ISO)"
  },
  {
    "codigo": "38085922",
    "descricao": "À base de endossulfan (ISO)"
  },
  {
    "codigo": "38085923",
    "descricao": "À base de alaclor (ISO)"
  },
  {
    "codigo": "38085924",
    "descricao": "À base de 1,2,3,4,5,6-hexaclorocicloexano (HCH (ISO)), incluindo o lindano (ISO, DCI)"
  },
  {
    "codigo": "38085925",
    "descricao": "À base de triclorfom (ISO)"
  },
  {
    "codigo": "38085926",
    "descricao": "À base de N-etilperfluoroctano sulfonamida"
  },
  {
    "codigo": "38085929",
    "descricao": "Outras"
  },
  {
    "codigo": "38086100",
    "descricao": "-- Acondicionadas em embalagens com um conteúdo de peso líquido não superior a 300 g"
  },
  {
    "codigo": "38086210",
    "descricao": "À base de alfa-cipermetrina (ISO)"
  },
  {
    "codigo": "38086290",
    "descricao": "Outras"
  },
  {
    "codigo": "38086910",
    "descricao": "À base de alfa-cipermetrina (ISO)"
  },
  {
    "codigo": "38086990",
    "descricao": "Outras"
  },
  {
    "codigo": "38089111",
    "descricao": "Que contenham bromometano (brometo de metila) ou bromoclorometano"
  },
  {
    "codigo": "38089119",
    "descricao": "Outros"
  },
  {
    "codigo": "38089120",
    "descricao": "Apresentados de outro modo, que contenham bromometano (brometo de metila) ou bromoclorometano"
  },
  {
    "codigo": "38089191",
    "descricao": "À base de acefato ou de <i>Bacillus thuringiensis</i>"
  },
  {
    "codigo": "38089192",
    "descricao": "À base de cipermetrinas ou de permetrina"
  },
  {
    "codigo": "38089193",
    "descricao": "À base de dicrotofós"
  },
  {
    "codigo": "38089194",
    "descricao": "À base de dissulfoton"
  },
  {
    "codigo": "38089195",
    "descricao": "À base de fosfeto de alumínio"
  },
  {
    "codigo": "38089196",
    "descricao": "À base de diclorvós"
  },
  {
    "codigo": "38089197",
    "descricao": "À base de óleo mineral ou de tiometon"
  },
  {
    "codigo": "38089199",
    "descricao": "Outros"
  },
  {
    "codigo": "38089211",
    "descricao": "Que contenham bromometano (brometo de metila) ou bromoclorometano"
  },
  {
    "codigo": "38089219",
    "descricao": "Outros"
  },
  {
    "codigo": "38089220",
    "descricao": "Apresentados de outro modo, que contenham bromometano (brometo de metila) ou bromoclorometano"
  },
  {
    "codigo": "38089291",
    "descricao": "À base de hidróxido de cobre, de oxicloreto de cobre ou de óxido cuproso"
  },
  {
    "codigo": "38089292",
    "descricao": "À base de enxofre ou de ziram"
  },
  {
    "codigo": "38089293",
    "descricao": "À base de mancozeb ou de maneb"
  },
  {
    "codigo": "38089294",
    "descricao": "À base de sulfiram"
  },
  {
    "codigo": "38089295",
    "descricao": "À base de compostos de arsênio, cobre ou cromo, exceto os produtos do subitem 3808.92.91"
  },
  {
    "codigo": "38089296",
    "descricao": "À base de thiram"
  },
  {
    "codigo": "38089297",
    "descricao": "À base de propiconazol"
  },
  {
    "codigo": "38089299",
    "descricao": "Outros"
  },
  {
    "codigo": "38089311",
    "descricao": "Que contenham bromometano (brometo de metila) ou bromoclorometano"
  },
  {
    "codigo": "38089319",
    "descricao": "Outros"
  },
  {
    "codigo": "38089321",
    "descricao": "Que contenham bromometano (brometo de metila) ou bromoclorometano"
  },
  {
    "codigo": "38089322",
    "descricao": "Outros, à base de ácido 2,4-diclorofenoxiacético (2,4-D), de ácido 4-(2,4-diclorofenoxi)butírico (2,4-DB), de ácido (4-cloro-2-metil)fenoxiacético (MCPA) ou de derivados de 2,4-D ou 2,4-DB"
  },
  {
    "codigo": "38089323",
    "descricao": "Outros, à base de atrazina ou de diuron"
  },
  {
    "codigo": "38089324",
    "descricao": "Outros, à base de glifosato ou seus sais, de imazaquim ou de lactofen"
  },
  {
    "codigo": "38089325",
    "descricao": "Outros, à base de dicloreto de paraquate, de propanil ou de simazina"
  },
  {
    "codigo": "38089326",
    "descricao": "Outros, à base de trifluralina"
  },
  {
    "codigo": "38089327",
    "descricao": "Outros, à base de imazetapir"
  },
  {
    "codigo": "38089328",
    "descricao": "Outros, à base de ametrina ou de hexazinona"
  },
  {
    "codigo": "38089329",
    "descricao": "Outros"
  },
  {
    "codigo": "38089331",
    "descricao": "Que contenham bromometano (brometo de metila) ou bromoclorometano"
  },
  {
    "codigo": "38089332",
    "descricao": "Outros, apresentados em formas ou embalagens exclusivamente para uso direto em aplicações domissanitárias"
  },
  {
    "codigo": "38089333",
    "descricao": "Outros"
  },
  {
    "codigo": "38089341",
    "descricao": "Que contenham bromometano (brometo de metila) ou bromoclorometano"
  },
  {
    "codigo": "38089349",
    "descricao": "Outros"
  },
  {
    "codigo": "38089351",
    "descricao": "Que contenham bromometano (brometo de metila) ou bromoclorometano"
  },
  {
    "codigo": "38089352",
    "descricao": "Outros, à base de hidrazida maleica"
  },
  {
    "codigo": "38089359",
    "descricao": "Outros"
  },
  {
    "codigo": "38089411",
    "descricao": "Que contenham bromometano (brometo de metila) ou bromoclorometano"
  },
  {
    "codigo": "38089419",
    "descricao": "Outros"
  },
  {
    "codigo": "38089421",
    "descricao": "Que contenham bromometano (brometo de metila) ou bromoclorometano"
  },
  {
    "codigo": "38089422",
    "descricao": "Outros, à base de 2-(tiocianometiltio) benzotiazol"
  },
  {
    "codigo": "38089429",
    "descricao": "Outros"
  },
  {
    "codigo": "38089911",
    "descricao": "Que contenham bromometano (brometo de metila) ou bromoclorometano"
  },
  {
    "codigo": "38089919",
    "descricao": "Outros"
  },
  {
    "codigo": "38089920",
    "descricao": "Apresentados de outro modo, que contenham bromometano (brometo de metila) ou bromoclorometano"
  },
  {
    "codigo": "38089991",
    "descricao": "Acaricidas à base de amitraz, de clorfenvinfós ou de propargite"
  },
  {
    "codigo": "38089992",
    "descricao": "Acaricidas à base de ciexatin ou de óxido de fembutatina"
  },
  {
    "codigo": "38089993",
    "descricao": "Outros acaricidas"
  },
  {
    "codigo": "38089994",
    "descricao": "Nematicidas à base de metam sódio"
  },
  {
    "codigo": "38089995",
    "descricao": "Outros nematicidas"
  },
  {
    "codigo": "38089996",
    "descricao": "Raticidas"
  },
  {
    "codigo": "38089999",
    "descricao": "Outros"
  },
  {
    "codigo": "38091010",
    "descricao": "Do tipo utilizado na indústria têxtil"
  },
  {
    "codigo": "38091090",
    "descricao": "Outros"
  },
  {
    "codigo": "38099110",
    "descricao": "Aprestos preparados"
  },
  {
    "codigo": "38099120",
    "descricao": "Preparações mordentes"
  },
  {
    "codigo": "38099130",
    "descricao": "Produtos ignífugos"
  },
  {
    "codigo": "38099141",
    "descricao": "À base de parafina ou de derivados de ácidos graxos (gordos)"
  },
  {
    "codigo": "38099149",
    "descricao": "Outros"
  },
  {
    "codigo": "38099190",
    "descricao": "Outros"
  },
  {
    "codigo": "38099211",
    "descricao": "À base de parafina ou de derivados de ácidos graxos (gordos)"
  },
  {
    "codigo": "38099219",
    "descricao": "Outros"
  },
  {
    "codigo": "38099290",
    "descricao": "Outros"
  },
  {
    "codigo": "38099311",
    "descricao": "À base de parafina ou de derivados de ácidos graxos (gordos)"
  },
  {
    "codigo": "38099319",
    "descricao": "Outros"
  },
  {
    "codigo": "38099390",
    "descricao": "Outros"
  },
  {
    "codigo": "38101010",
    "descricao": "Preparações para decapagem de metais"
  },
  {
    "codigo": "38101020",
    "descricao": "Pastas e pós para soldar"
  },
  {
    "codigo": "38109000",
    "descricao": "- Outros"
  },
  {
    "codigo": "38111100",
    "descricao": "-- À base de compostos de chumbo"
  },
  {
    "codigo": "38111900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "38112110",
    "descricao": "Melhoradores do índice de viscosidade"
  },
  {
    "codigo": "38112120",
    "descricao": "Antidesgastes, anticorrosivos ou antioxidantes, que contenham dialquilditiofosfato de zinco ou diarilditiofosfato de zinco"
  },
  {
    "codigo": "38112130",
    "descricao": "Dispersantes sem cinzas"
  },
  {
    "codigo": "38112140",
    "descricao": "Detergentes metálicos"
  },
  {
    "codigo": "38112150",
    "descricao": "Outras preparações que contenham, pelo menos, um de quaisquer dos produtos compreendidos nos itens 3811.21.10, 3811.21.20, 3811.21.30 e 3811.21.40"
  },
  {
    "codigo": "38112190",
    "descricao": "Outros"
  },
  {
    "codigo": "38112910",
    "descricao": "Dispersantes sem cinzas"
  },
  {
    "codigo": "38112920",
    "descricao": "Detergentes metálicos"
  },
  {
    "codigo": "38112990",
    "descricao": "Outros"
  },
  {
    "codigo": "38119010",
    "descricao": "Dispersantes sem cinzas, para óleos de petróleo combustíveis"
  },
  {
    "codigo": "38119090",
    "descricao": "Outros"
  },
  {
    "codigo": "38121000",
    "descricao": "- Preparações denominadas \"aceleradores de vulcanização\""
  },
  {
    "codigo": "38122000",
    "descricao": "- Plastificantes compostos para borracha ou plástico"
  },
  {
    "codigo": "38123100",
    "descricao": "-- Misturas de oligômeros de 2,2,4-trimetil-1,2-di-hidroquinolina (TMQ)"
  },
  {
    "codigo": "38123911",
    "descricao": "Que contenham derivados N-substituídos de <i>p</i>-fenilenodiamina"
  },
  {
    "codigo": "38123912",
    "descricao": "Que contenham fosfitos de alquila, de arila ou de alquil-arila"
  },
  {
    "codigo": "38123919",
    "descricao": "Outros"
  },
  {
    "codigo": "38123921",
    "descricao": "Que contenham derivados N-substituídos de <i>p</i>-fenilenodiamina"
  },
  {
    "codigo": "38123929",
    "descricao": "Outros"
  },
  {
    "codigo": "38130010",
    "descricao": "Que contenham bromoclorodifluorometano, bromotrifluorometano ou dibromotetrafluoroetanos"
  },
  {
    "codigo": "38130020",
    "descricao": "Que contenham hidrobromofluorcarbonetos (HBFC) do metano, do etano ou do propano"
  },
  {
    "codigo": "38130030",
    "descricao": "Que contenham hidroclorofluorcarbonetos (HCFC) do metano, do etano ou do propano"
  },
  {
    "codigo": "38130040",
    "descricao": "Que contenham bromoclorometano"
  },
  {
    "codigo": "38130090",
    "descricao": "Outros"
  },
  {
    "codigo": "38140010",
    "descricao": "Que contenham clorofluorcarbonetos (CFC) do metano, do etano ou do propano, mesmo que contenham hidroclorofluorcarbonetos (HCFC)"
  },
  {
    "codigo": "38140020",
    "descricao": "Que contenham hidroclorofluorcarbonetos (HCFC) do metano, do etano ou do propano, mas que não contenham clorofluorcarbonetos (CFC)"
  },
  {
    "codigo": "38140030",
    "descricao": "Que contenham tetracloreto de carbono, bromoclorometano ou 1,1,1-tricloroetano (metilclorofórmio)"
  },
  {
    "codigo": "38140090",
    "descricao": "Outros"
  },
  {
    "codigo": "38151100",
    "descricao": "-- Tendo como substância ativa o níquel ou um composto de níquel"
  },
  {
    "codigo": "38151210",
    "descricao": "Em colmeia cerâmica ou metálica para conversão catalítica de gases de escape de veículos"
  },
  {
    "codigo": "38151220",
    "descricao": "Com tamanho de partícula inferior a 500 micrômetros (mícrons)"
  },
  {
    "codigo": "38151290",
    "descricao": "Outros"
  },
  {
    "codigo": "38151900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "38159010",
    "descricao": "Para craqueamento de petróleo"
  },
  {
    "codigo": "38159091",
    "descricao": "Tendo como substância ativa o isoprenilalumínio (IPRA)"
  },
  {
    "codigo": "38159092",
    "descricao": "Tendo como substância ativa o óxido de zinco"
  },
  {
    "codigo": "38159093",
    "descricao": "Tendo como substância ativa óxidos de terras raras"
  },
  {
    "codigo": "38159099",
    "descricao": "Outros"
  },
  {
    "codigo": "38160011",
    "descricao": "À base de magnesita calcinada"
  },
  {
    "codigo": "38160012",
    "descricao": "À base de silimanita"
  },
  {
    "codigo": "38160019",
    "descricao": "Outros"
  },
  {
    "codigo": "38160021",
    "descricao": "Que contenham grafita e 50 % ou mais, em peso, de coríndon"
  },
  {
    "codigo": "38160029",
    "descricao": "Outras"
  },
  {
    "codigo": "38160090",
    "descricao": "Outros"
  },
  {
    "codigo": "38170010",
    "descricao": "Misturas de alquilbenzenos"
  },
  {
    "codigo": "38170020",
    "descricao": "Misturas de alquilnaftalenos"
  },
  {
    "codigo": "38180010",
    "descricao": "De silício"
  },
  {
    "codigo": "38180090",
    "descricao": "Outros"
  },
  {
    "codigo": "38190000",
    "descricao": "Fluidos para freios (travões) hidráulicos e outros líquidos preparados para transmissões hidráulicas, que não contenham óleos de petróleo nem de minerais betuminosos, ou que os contenham em proporção inferior a 70 %, em peso."
  },
  {
    "codigo": "38200000",
    "descricao": "Preparações anticongelantes e líquidos preparados para descongelamento."
  },
  {
    "codigo": "38210000",
    "descricao": "Meios de cultura preparados para o desenvolvimento e a manutenção de microrganismos (incluindo os vírus e os organismos similares) ou de células vegetais, humanas ou animais."
  },
  {
    "codigo": "38221100",
    "descricao": "-- Para a malária (paludismo)"
  },
  {
    "codigo": "38221200",
    "descricao": "-- Para a zika e outras doenças transmitidas por mosquitos do gênero <i>Aedes</i>"
  },
  {
    "codigo": "38221300",
    "descricao": "-- Para a determinação dos grupos ou dos fatores sanguíneos"
  },
  {
    "codigo": "38221910",
    "descricao": "Reagentes para determinação de componentes do sangue ou da urina, sobre suporte de papel, em rolos, sem suporte adicional hidrófobo, impróprios para uso direto"
  },
  {
    "codigo": "38221920",
    "descricao": "Reagentes para determinação de glicose no sangue, sobre suporte em tiras, para uso direto"
  },
  {
    "codigo": "38221930",
    "descricao": "Reagentes de origem microbiana para diagnóstico"
  },
  {
    "codigo": "38221940",
    "descricao": "Anticorpos monoclonais em solução tampão, que contenham albumina bovina"
  },
  {
    "codigo": "38221990",
    "descricao": "Outros"
  },
  {
    "codigo": "38229000",
    "descricao": "- Outros"
  },
  {
    "codigo": "38231100",
    "descricao": "-- Ácido esteárico"
  },
  {
    "codigo": "38231200",
    "descricao": "-- Ácido oleico"
  },
  {
    "codigo": "38231300",
    "descricao": "-- Ácidos graxos (gordos) do <i>tall oil</i>"
  },
  {
    "codigo": "38231910",
    "descricao": "Ácido caprílico"
  },
  {
    "codigo": "38231990",
    "descricao": "Outros"
  },
  {
    "codigo": "38237010",
    "descricao": "Esteárico"
  },
  {
    "codigo": "38237020",
    "descricao": "Láurico"
  },
  {
    "codigo": "38237040",
    "descricao": "Cetílico"
  },
  {
    "codigo": "38237090",
    "descricao": "Outros"
  },
  {
    "codigo": "38241000",
    "descricao": "- Aglutinantes preparados para moldes ou para núcleos de fundição"
  },
  {
    "codigo": "38243000",
    "descricao": "- Carbonetos metálicos não aglomerados, misturados entre si ou com aglutinantes metálicos"
  },
  {
    "codigo": "38244000",
    "descricao": "- Aditivos preparados para cimentos, argamassas ou concretos (betões)"
  },
  {
    "codigo": "38245000",
    "descricao": "- Argamassas e concretos (betões), não refratários"
  },
  {
    "codigo": "38246000",
    "descricao": "- Sorbitol, exceto o da subposição 2905.44"
  },
  {
    "codigo": "38248110",
    "descricao": "Mistura de óxido de propileno com um conteúdo de óxido de etileno inferior ou igual a 30 %, em peso"
  },
  {
    "codigo": "38248190",
    "descricao": "Outras"
  },
  {
    "codigo": "38248210",
    "descricao": "Que contenham policlorobifenilas (PCB)"
  },
  {
    "codigo": "38248290",
    "descricao": "Outras"
  },
  {
    "codigo": "38248300",
    "descricao": "-- Que contenham fosfato de tris(2,3-dibromopropila)"
  },
  {
    "codigo": "38248400",
    "descricao": "-- Que contenham aldrin (ISO), canfecloro (ISO) (toxafeno), clordano (ISO), clordecona (ISO), DDT (ISO) (clofenotano (DCI), 1,1,1-tricloro-2,2-bis(<i>p</i>-clorofenil)etano), dieldrin (ISO, DCI), endossulfan (ISO), endrin (ISO), heptacloro (ISO) ou mirex (ISO)"
  },
  {
    "codigo": "38248500",
    "descricao": "-- Que contenham 1,2,3,4,5,6-hexaclorocicloexano (HCH (ISO)), incluindo o lindano (ISO, DCI)"
  },
  {
    "codigo": "38248600",
    "descricao": "-- Que contenham pentaclorobenzeno (ISO) ou hexaclorobenzeno (ISO)"
  },
  {
    "codigo": "38248700",
    "descricao": "-- Que contenham ácido perfluoroctano sulfônico, seus sais, perfluoroctanossulfonamidas, ou fluoreto de perfluoroctanossulfonila"
  },
  {
    "codigo": "38248810",
    "descricao": "Que contenham éteres tetra- ou pentabromodifenílicos"
  },
  {
    "codigo": "38248820",
    "descricao": "Que contenham éteres hexa-, hepta- ou octabromodifenílicos"
  },
  {
    "codigo": "38248900",
    "descricao": "-- Que contenham parafinas cloradas de cadeia curta"
  },
  {
    "codigo": "38249100",
    "descricao": "-- Misturas e preparações constituídas principalmente por metilfosfonato de (5-etil-2-metil-2-óxido-1,3,2-dioxafosfinan-5-il)metil metila e metilfosfonato de bis[(5-etil-2-metil-2-óxido-1,3,2-dioxafosfinan-5-il)metila]"
  },
  {
    "codigo": "38249200",
    "descricao": "-- Ésteres de poliglicol do ácido metilfosfônico"
  },
  {
    "codigo": "38249911",
    "descricao": "Salinomicina micelial"
  },
  {
    "codigo": "38249912",
    "descricao": "Com um teor de cianocobalamina inferior ou igual a 55 %, em peso"
  },
  {
    "codigo": "38249913",
    "descricao": "Da fabricação da primicina amônica"
  },
  {
    "codigo": "38249914",
    "descricao": "Senduramicina sódica, da fabricação da senduramicina"
  },
  {
    "codigo": "38249915",
    "descricao": "Maduramicina amônica, em solução alcoólica, da fabricação da maduramicina"
  },
  {
    "codigo": "38249919",
    "descricao": "Outros"
  },
  {
    "codigo": "38249921",
    "descricao": "Ácidos graxos (gordos) dimerizados; preparações que contenham ácidos graxos (gordos) dimerizados"
  },
  {
    "codigo": "38249922",
    "descricao": "Preparações que contenham estearoilbenzoilmetano e palmitoilbenzoilmetano; preparações que contenham caprilato e caprato de propilenoglicol"
  },
  {
    "codigo": "38249923",
    "descricao": "Preparações que contenham triglicerídios dos ácidos caprílico e cáprico"
  },
  {
    "codigo": "38249924",
    "descricao": "Ésteres de álcoois graxos (gordos) de C<sub>12</sub> a C<sub>20 </sub>do ácido metacrílico e suas misturas; ésteres de ácidos monocarboxílicos de C<sub>10</sub> ramificados com glicerol"
  },
  {
    "codigo": "38249925",
    "descricao": "Misturas de ésteres dimetílicos dos ácidos adípico, glutárico e succínico; misturas de ácidos dibásicos de C<sub>11</sub> e C<sub>12</sub>; ácidos naftênicos, seus sais insolúveis em água e seus ésteres"
  },
  {
    "codigo": "38249929",
    "descricao": "Outros"
  },
  {
    "codigo": "38249931",
    "descricao": "Que contenham isocianatos de hexametileno ou outros isocianatos"
  },
  {
    "codigo": "38249932",
    "descricao": "Que contenham aminas graxas de C<sub>8</sub> a C<sub>22</sub>"
  },
  {
    "codigo": "38249933",
    "descricao": "Que contenham polietilenoaminas e dietilenotriaminas, próprias para a coagulação do látex"
  },
  {
    "codigo": "38249934",
    "descricao": "Outras, que contenham polietilenoaminas"
  },
  {
    "codigo": "38249935",
    "descricao": "Misturas de mono-, di- e triisopropanolaminas"
  },
  {
    "codigo": "38249936",
    "descricao": "Reticulantes para silicones"
  },
  {
    "codigo": "38249939",
    "descricao": "Outras"
  },
  {
    "codigo": "38249941",
    "descricao": "Preparações desincrustantes, anticorrosivas ou antioxidantes"
  },
  {
    "codigo": "38249942",
    "descricao": "Mistura eutética de difenila e óxido de difenila"
  },
  {
    "codigo": "38249943",
    "descricao": "À base de trimetil-3,9-dietildecano"
  },
  {
    "codigo": "38249949",
    "descricao": "Outros"
  },
  {
    "codigo": "38249951",
    "descricao": "Antiespumantes que contenham fosfato de tributila em solução de álcool isopropílico"
  },
  {
    "codigo": "38249952",
    "descricao": "Misturas de polietilenoglicóis"
  },
  {
    "codigo": "38249953",
    "descricao": "Polipropilenoglicol líquido"
  },
  {
    "codigo": "38249954",
    "descricao": "Retardante de chama que contenha misturas de trifenilfosfatos isopropilados"
  },
  {
    "codigo": "38249959",
    "descricao": "Outros"
  },
  {
    "codigo": "38249961",
    "descricao": "À base de gadobenato de dimeglumina, de gadobutrol, de gadopentetato de dimeglumina, de gadoterato de meglumina, de gadoteridol ou de gadoxetato dissódico"
  },
  {
    "codigo": "38249962",
    "descricao": "À base de hexafluoreto de enxofre"
  },
  {
    "codigo": "38249969",
    "descricao": "Outros"
  },
  {
    "codigo": "38249971",
    "descricao": "Cal sodada; carbonato de cálcio hidrófugo"
  },
  {
    "codigo": "38249972",
    "descricao": "Preparações à base de sílica em suspensão coloidal; nitreto de boro de estrutura cristalina cúbica, compactado com substrato de carboneto de tungstênio (volfrâmio)"
  },
  {
    "codigo": "38249973",
    "descricao": "Preparações à base de carboneto de tungstênio (volfrâmio) com níquel como aglomerante; brometo de hidrogênio em solução"
  },
  {
    "codigo": "38249974",
    "descricao": "Preparações à base de hidróxido de níquel ou de cádmio, de óxido de cádmio ou de óxido ferroso férrico, próprios para a fabricação de acumuladores alcalinos"
  },
  {
    "codigo": "38249975",
    "descricao": "Preparações utilizadas na elaboração de meios de cultura; trocadores de íons para o tratamento de águas; preparações à base de zeólitas artificiais"
  },
  {
    "codigo": "38249976",
    "descricao": "Compostos absorventes à base de metais para aperfeiçoar o vácuo nos tubos ou válvulas elétricas"
  },
  {
    "codigo": "38249977",
    "descricao": "Adubos (fertilizantes) foliares que contenham zinco ou manganês"
  },
  {
    "codigo": "38249978",
    "descricao": "Preparações à base de óxido de alumínio e óxido de zircônio, com um conteúdo de óxido de zircônio igual ou superior a 20 %, em peso; preparações de óxido de alumínio com óxido de lantânio"
  },
  {
    "codigo": "38249979",
    "descricao": "Outros"
  },
  {
    "codigo": "38249981",
    "descricao": "Preparações à base de anidrido poliisobutenilsuccínico, em óleo mineral"
  },
  {
    "codigo": "38249982",
    "descricao": "Halquinol; tetraclorohidroxiglicina de alumínio e zircônio"
  },
  {
    "codigo": "38249983",
    "descricao": "Triisocianato de tiofosfato de fenila ou de trifenilmetano, em solução de cloreto de metileno ou de acetato de etila; preparações à base de tetraacetiletilenodiamina (TAED), em grânulos"
  },
  {
    "codigo": "38249984",
    "descricao": "Que contenham éteres decabromodifenílicos"
  },
  {
    "codigo": "38249985",
    "descricao": "Metilato de sódio em metanol"
  },
  {
    "codigo": "38249986",
    "descricao": "Maneb; mancozeb; cloreto de benzalcônio"
  },
  {
    "codigo": "38249987",
    "descricao": "Dispersão aquosa de microcápsulas de poliuretano ou de melamina-formaldeído que contenha um precursor de corante em solventes orgânicos"
  },
  {
    "codigo": "38249988",
    "descricao": "Misturas constituídas principalmente pelos compostos seguintes (grupos alquila de C<sub>1</sub> a C<sub>3</sub>, exceto nos casos expressamente indicados): alquilfosfonofluoridatos de O-alquila (de até C<sub>10</sub>, incluindo cicloalquila); N,N-dialquilfosforoamidocianidatos de O-alquila (de até C<sub>10</sub>, incluindo cicloalquila); hidrogênio alquilfosfonotioatos de [S-2-(dialquilamino)etila], seus ésteres de O-alquila (de até C<sub>10</sub>, incluindo cicloalquila) ou seus sais alquilados ou protonados; difluoretos de alquilfosfonila; hidrogênio alquilfosfonitos de [O-2-(dialquilamino)etila], seus ésteres de O-alquila (de até C<sub>10</sub>, incluindo cicloalquila) ou seus sais alquilados ou protonados; dialogenetos de N,N-dialquilfosforoamídicos; N,N-dialquilfosforoamidatos de dialquila; N,N-dialquil-2-cloroetilaminas ou seus sais protonados; N,N-dialquil-2-aminoetanóis ou seus sais protonados; N,N-dialquilaminoetano-2-tióis ou seus sais protonados; outras misturas constituídas principalmente por compostos que contenham um átomo de fósforo ligado a um grupo alquila (de C<sub>1</sub> a C<sub>3</sub>) mas sem outros átomos de carbono"
  },
  {
    "codigo": "38249989",
    "descricao": "Outros"
  },
  {
    "codigo": "38251000",
    "descricao": "- Resíduos municipais"
  },
  {
    "codigo": "38252000",
    "descricao": "- Lamas de tratamento de esgotos (Lamas de depuração*)"
  },
  {
    "codigo": "38253000",
    "descricao": "- Resíduos clínicos"
  },
  {
    "codigo": "38254100",
    "descricao": "-- Halogenados"
  },
  {
    "codigo": "38254900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "38255000",
    "descricao": "- Resíduos de soluções decapantes para metais, de fluidos hidráulicos, de fluidos para freios (travões) e de fluidos anticongelantes"
  },
  {
    "codigo": "38256100",
    "descricao": "-- Que contenham principalmente constituintes orgânicos"
  },
  {
    "codigo": "38256900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "38259000",
    "descricao": "- Outros"
  },
  {
    "codigo": "38260000",
    "descricao": "Biodiesel e suas misturas, que não contenham ou que contenham menos de 70 %, em peso, de óleos de petróleo ou de óleos minerais betuminosos."
  },
  {
    "codigo": "38271110",
    "descricao": "Que contenham triclorotrifluoroetanos"
  },
  {
    "codigo": "38271190",
    "descricao": "Outras"
  },
  {
    "codigo": "38271200",
    "descricao": "-- Que contenham hidrobromofluorcarbonetos (HBFC)"
  },
  {
    "codigo": "38271300",
    "descricao": "-- Que contenham tetracloreto de carbono"
  },
  {
    "codigo": "38271400",
    "descricao": "-- Que contenham 1,1,1-tricloroetano (metilclorofórmio)"
  },
  {
    "codigo": "38272000",
    "descricao": "- Que contenham bromoclorodifluorometano (halon-1211), bromotrifluorometano (halon-1301) ou dibromotetrafluoroetanos (halon-2402)"
  },
  {
    "codigo": "38273110",
    "descricao": "Que contenham clorodifluorometano e pentafluoroetano"
  },
  {
    "codigo": "38273190",
    "descricao": "Outras"
  },
  {
    "codigo": "38273210",
    "descricao": "Que contenham clorodifluorometano e clorotetrafluoroetano"
  },
  {
    "codigo": "38273290",
    "descricao": "Outras"
  },
  {
    "codigo": "38273900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "38274000",
    "descricao": "- Que contenham brometo de metila (bromometano) ou bromoclorometano"
  },
  {
    "codigo": "38275100",
    "descricao": "-- Que contenham trifluorometano (HFC-23)"
  },
  {
    "codigo": "38275900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "38276100",
    "descricao": "-- Que contenham, em massa, 15 % ou mais de 1,1,1-trifluoroetano (HFC-143a)"
  },
  {
    "codigo": "38276200",
    "descricao": "-- Outras, não mencionadas na subposição acima, que contenham, em massa, 55 % ou mais de pentafluoroetano (HFC-125), mas que não contenham derivados fluorados não saturados dos hidrocarbonetos acíclicos (HFO)"
  },
  {
    "codigo": "38276300",
    "descricao": "-- Outras, não mencionadas nas subposições acima, que contenham, em massa, 40 % ou mais de pentafluoroetano (HFC-125)"
  },
  {
    "codigo": "38276400",
    "descricao": "-- Outras, não mencionadas nas subposições acima, que contenham, em massa, 30 % ou mais de 1,1,1,2-tetrafluoroetano (HFC-134a), mas que não contenham derivados fluorados não saturados dos hidrocarbonetos acíclicos (HFO)"
  },
  {
    "codigo": "38276500",
    "descricao": "-- Outras, não mencionadas nas subposições acima, que contenham, em massa, 20 % ou mais de difluorometano (HFC-32) e 20 % ou mais de pentafluoroetano (HFC-125)"
  },
  {
    "codigo": "38276800",
    "descricao": "-- Outras, não mencionadas nas subposições acima, que contenham substâncias das subposições 2903.41 a 2903.48"
  },
  {
    "codigo": "38276900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "38279000",
    "descricao": "- Outras"
  },
  {
    "codigo": "39011020",
    "descricao": "Com carga"
  },
  {
    "codigo": "39011030",
    "descricao": "Sem carga"
  },
  {
    "codigo": "39012011",
    "descricao": "Vulcanizado, de densidade superior a 1,3"
  },
  {
    "codigo": "39012019",
    "descricao": "Outros"
  },
  {
    "codigo": "39012021",
    "descricao": "Vulcanizado, de densidade superior a 1,3"
  },
  {
    "codigo": "39012029",
    "descricao": "Outros"
  },
  {
    "codigo": "39013010",
    "descricao": "Nas formas previstas na Nota 6 a) deste Capítulo"
  },
  {
    "codigo": "39013090",
    "descricao": "Outros"
  },
  {
    "codigo": "39014000",
    "descricao": "- Copolímeros de etileno e alfa-olefina, de densidade inferior a 0,94"
  },
  {
    "codigo": "39019010",
    "descricao": "Copolímeros de etileno e ácido acrílico"
  },
  {
    "codigo": "39019020",
    "descricao": "Copolímeros de etileno e monômeros com radicais carboxílicos, inclusive com metacrilato de metila ou acrilato de metila como terceiro monômero"
  },
  {
    "codigo": "39019030",
    "descricao": "Polietileno clorossulfonado"
  },
  {
    "codigo": "39019040",
    "descricao": "Polietileno clorado"
  },
  {
    "codigo": "39019050",
    "descricao": "Copolímeros de etileno - ácido metacrílico, com um conteúdo de etileno igual ou superior a 60 %, em peso"
  },
  {
    "codigo": "39019090",
    "descricao": "Outros"
  },
  {
    "codigo": "39021010",
    "descricao": "Com carga"
  },
  {
    "codigo": "39021020",
    "descricao": "Sem carga"
  },
  {
    "codigo": "39022000",
    "descricao": "- Poli-isobutileno"
  },
  {
    "codigo": "39023000",
    "descricao": "- Copolímeros de propileno"
  },
  {
    "codigo": "39029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "39031110",
    "descricao": "Com carga"
  },
  {
    "codigo": "39031120",
    "descricao": "Sem carga"
  },
  {
    "codigo": "39031900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "39032000",
    "descricao": "- Copolímeros de estireno-acrilonitrila (SAN)"
  },
  {
    "codigo": "39033010",
    "descricao": "Com carga"
  },
  {
    "codigo": "39033020",
    "descricao": "Sem carga"
  },
  {
    "codigo": "39039010",
    "descricao": "Copolímeros de metacrilato de metilbutadieno-estireno (MBS)"
  },
  {
    "codigo": "39039020",
    "descricao": "Copolímeros de acrilonitrilo-estireno-acrilato de butilo (ASA)"
  },
  {
    "codigo": "39039090",
    "descricao": "Outros"
  },
  {
    "codigo": "39041010",
    "descricao": "Obtido por processo de suspensão"
  },
  {
    "codigo": "39041020",
    "descricao": "Obtido por processo de emulsão"
  },
  {
    "codigo": "39041090",
    "descricao": "Outros"
  },
  {
    "codigo": "39042100",
    "descricao": "-- Não plastificado"
  },
  {
    "codigo": "39042200",
    "descricao": "-- Plastificado"
  },
  {
    "codigo": "39043000",
    "descricao": "- Copolímeros de cloreto de vinila e acetato de vinila"
  },
  {
    "codigo": "39044010",
    "descricao": "Com acetato de vinila, com um ácido dibásico ou com álcool vinílico, nas formas previstas na Nota 6 b) deste Capítulo"
  },
  {
    "codigo": "39044090",
    "descricao": "Outros"
  },
  {
    "codigo": "39045010",
    "descricao": "Copolímeros de cloreto de vinilideno, sem emulsionante nem plastificante"
  },
  {
    "codigo": "39045090",
    "descricao": "Outros"
  },
  {
    "codigo": "39046110",
    "descricao": "Nas formas previstas na Nota 6 a) deste Capítulo"
  },
  {
    "codigo": "39046190",
    "descricao": "Outros"
  },
  {
    "codigo": "39046910",
    "descricao": "Copolímero de fluoreto de vinilideno e hexafluorpropileno"
  },
  {
    "codigo": "39046990",
    "descricao": "Outros"
  },
  {
    "codigo": "39049010",
    "descricao": "Poli(cloreto de vinila) clorado"
  },
  {
    "codigo": "39049090",
    "descricao": "Outros"
  },
  {
    "codigo": "39051200",
    "descricao": "-- Em dispersão aquosa"
  },
  {
    "codigo": "39051910",
    "descricao": "Com grupos álcool vinílico, nas formas previstas na Nota 6 b) deste Capítulo"
  },
  {
    "codigo": "39051990",
    "descricao": "Outro"
  },
  {
    "codigo": "39052100",
    "descricao": "-- Em dispersão aquosa"
  },
  {
    "codigo": "39052900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "39053000",
    "descricao": "- Poli(álcool vinílico), mesmo que contenha grupos acetato não hidrolisados"
  },
  {
    "codigo": "39059130",
    "descricao": "De vinilpirrolidona e acetato de vinila, em solução alcoólica"
  },
  {
    "codigo": "39059190",
    "descricao": "Outros"
  },
  {
    "codigo": "39059910",
    "descricao": "Poli(vinilformal)"
  },
  {
    "codigo": "39059920",
    "descricao": "Poli(butiral de vinila)"
  },
  {
    "codigo": "39059930",
    "descricao": "Poli(vinilpirrolidona) iodada"
  },
  {
    "codigo": "39059990",
    "descricao": "Outros"
  },
  {
    "codigo": "39061000",
    "descricao": "- Poli(metacrilato de metila)"
  },
  {
    "codigo": "39069011",
    "descricao": "Poli(ácido acrílico) e seus sais"
  },
  {
    "codigo": "39069012",
    "descricao": "Sal sódico do poli(ácido acrilamídico), solúvel em água"
  },
  {
    "codigo": "39069019",
    "descricao": "Outros"
  },
  {
    "codigo": "39069021",
    "descricao": "Poli(ácido acrílico) e seus sais"
  },
  {
    "codigo": "39069022",
    "descricao": "Copolímero de metacrilato de 2-di-isopropilaminoetila e metacrilato de <i>n</i>-decila, em suspensão de dimetilacetamida"
  },
  {
    "codigo": "39069029",
    "descricao": "Outros"
  },
  {
    "codigo": "39069031",
    "descricao": "Poli(ácido acrílico) e seus sais"
  },
  {
    "codigo": "39069032",
    "descricao": "Sal sódico do poli(ácido acrilamídico), solúvel em água"
  },
  {
    "codigo": "39069039",
    "descricao": "Outros"
  },
  {
    "codigo": "39069051",
    "descricao": "Poli(ácido acrílico) e seus sais"
  },
  {
    "codigo": "39069052",
    "descricao": "Sal sódico do poli(ácido acrilamídico), solúvel em água"
  },
  {
    "codigo": "39069053",
    "descricao": "Carboxipolimetileno, em pó"
  },
  {
    "codigo": "39069054",
    "descricao": "Poli(acrilato de sódio), com capacidade de absorção de uma solução aquosa de cloreto de sódio 0,9 %, em peso, igual ou superior a vinte vezes seu próprio peso"
  },
  {
    "codigo": "39069059",
    "descricao": "Outros"
  },
  {
    "codigo": "39069061",
    "descricao": "Copolímero de acrilato de potássio e acrilamida, com capacidade de absorção de água destilada de até quatrocentas vezes seu próprio peso"
  },
  {
    "codigo": "39069062",
    "descricao": "Copolímeros de acrilato de metila-etileno com um conteúdo de acrilato de metila igual ou superior a 50 %, em peso"
  },
  {
    "codigo": "39069063",
    "descricao": "Copolímero de acrilato de etila, acrilato de n-butila e acrilato de 2-metoxietila"
  },
  {
    "codigo": "39069064",
    "descricao": "Copolímero de acrilato de potássio e ácido acrílico, com capacidade de absorção de água destilada de até quatrocentas vezes seu próprio peso"
  },
  {
    "codigo": "39069065",
    "descricao": "Copolímero de acrilamida e acrilato de sódio"
  },
  {
    "codigo": "39069069",
    "descricao": "Outros"
  },
  {
    "codigo": "39071010",
    "descricao": "Com carga, nas formas previstas na Nota 6 a) deste Capítulo"
  },
  {
    "codigo": "39071020",
    "descricao": "Com carga, nas formas previstas na Nota 6 b) deste Capítulo"
  },
  {
    "codigo": "39071031",
    "descricao": "Polidextrose"
  },
  {
    "codigo": "39071039",
    "descricao": "Outros"
  },
  {
    "codigo": "39071041",
    "descricao": "Polidextrose"
  },
  {
    "codigo": "39071042",
    "descricao": "Outros, em pó que passe através de uma peneira com abertura de malha de 0,85 mm em proporção superior a 80 %, em peso"
  },
  {
    "codigo": "39071049",
    "descricao": "Outros"
  },
  {
    "codigo": "39071091",
    "descricao": "Em grânulos, de diâmetro de partícula superior a 2 mm, segundo a Norma ASTM E 11-70"
  },
  {
    "codigo": "39071099",
    "descricao": "Outros"
  },
  {
    "codigo": "39072100",
    "descricao": "-- Metilfosfonato de bis(polioxietileno)"
  },
  {
    "codigo": "39072911",
    "descricao": "Com carga"
  },
  {
    "codigo": "39072912",
    "descricao": "Sem carga"
  },
  {
    "codigo": "39072920",
    "descricao": "Politetrametilenoeterglicol"
  },
  {
    "codigo": "39072931",
    "descricao": "Polietilenoglicol 400"
  },
  {
    "codigo": "39072939",
    "descricao": "Outros"
  },
  {
    "codigo": "39072941",
    "descricao": "Poli(epicloridrina)"
  },
  {
    "codigo": "39072942",
    "descricao": "Copolímeros de óxido de etileno"
  },
  {
    "codigo": "39072949",
    "descricao": "Outros"
  },
  {
    "codigo": "39072991",
    "descricao": "Poliacetal poliéter (PAPE)"
  },
  {
    "codigo": "39072992",
    "descricao": "Éter metalílico de poli(oxietileno) (HPEG)"
  },
  {
    "codigo": "39072999",
    "descricao": "Outros"
  },
  {
    "codigo": "39073011",
    "descricao": "Nas formas previstas na Nota 6 a) deste Capítulo"
  },
  {
    "codigo": "39073019",
    "descricao": "Outras"
  },
  {
    "codigo": "39073021",
    "descricao": "Copolímero de tetrabromobisfenol A e epicloridrina (resina epóxida bromada)"
  },
  {
    "codigo": "39073022",
    "descricao": "Outras, nas formas previstas na Nota 6 a) deste Capítulo"
  },
  {
    "codigo": "39073029",
    "descricao": "Outras"
  },
  {
    "codigo": "39074010",
    "descricao": "Nas formas previstas na Nota 6 b) deste Capítulo, com transmissão de luz de comprimento de onda de 550 nm ou 800 nm, superior a 89 %, segundo Norma ASTM D 1003-00 e índice de fluidez de massa igual ou superior a 60 g/10 min e inferior ou igual a 80 g/10 min segundo Norma ASTM D 1238"
  },
  {
    "codigo": "39074020",
    "descricao": "Em pó ou flocos, com índice de fluidez de massa inferior a 60 g/10 min ou superior a 80 g/10 min segundo Norma ASTM D 1238"
  },
  {
    "codigo": "39074090",
    "descricao": "Outros"
  },
  {
    "codigo": "39075010",
    "descricao": "Nas formas previstas na Nota 6 a) deste Capítulo"
  },
  {
    "codigo": "39075090",
    "descricao": "Outras"
  },
  {
    "codigo": "39076100",
    "descricao": "-- De um índice de viscosidade de 78 ml/g ou mais"
  },
  {
    "codigo": "39076900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "39077000",
    "descricao": "- Poli(ácido láctico)"
  },
  {
    "codigo": "39079100",
    "descricao": "-- Não saturados"
  },
  {
    "codigo": "39079911",
    "descricao": "Com carga de fibra de vidro"
  },
  {
    "codigo": "39079912",
    "descricao": "Outros, nas formas previstas na Nota 6 a) deste Capítulo"
  },
  {
    "codigo": "39079919",
    "descricao": "Outros"
  },
  {
    "codigo": "39079991",
    "descricao": "Nas formas previstas na Nota 6 a) deste Capítulo"
  },
  {
    "codigo": "39079992",
    "descricao": "Poli(épsilon-caprolactona)"
  },
  {
    "codigo": "39079993",
    "descricao": "Copolímero de tereftalato de dimetila, cicloexanodimetanol e ácido isoftálico"
  },
  {
    "codigo": "39079994",
    "descricao": "Copolímero de tereftalato de dimetila, cicloexanodimetanol e tetrametil ciclobutanodiol"
  },
  {
    "codigo": "39079995",
    "descricao": "Copolímero de tereftalato de dimetila, cicloexanodimetanol e etilenoglicol"
  },
  {
    "codigo": "39079999",
    "descricao": "Outros"
  },
  {
    "codigo": "39081011",
    "descricao": "Poliamida-11"
  },
  {
    "codigo": "39081012",
    "descricao": "Poliamida-12"
  },
  {
    "codigo": "39081013",
    "descricao": "Poliamida-6 ou poliamida-6,6, com carga"
  },
  {
    "codigo": "39081014",
    "descricao": "Poliamida-6 ou poliamida-6,6, sem carga"
  },
  {
    "codigo": "39081019",
    "descricao": "Outras"
  },
  {
    "codigo": "39081021",
    "descricao": "Poliamida-11"
  },
  {
    "codigo": "39081022",
    "descricao": "Poliamida-12"
  },
  {
    "codigo": "39081023",
    "descricao": "Poliamida-6 ou poliamida-6,6, com carga"
  },
  {
    "codigo": "39081025",
    "descricao": "Poliamida-6, sem carga"
  },
  {
    "codigo": "39081026",
    "descricao": "Poliamida-6,6, sem carga"
  },
  {
    "codigo": "39081029",
    "descricao": "Outras"
  },
  {
    "codigo": "39089010",
    "descricao": "Copolímero de lauril-lactama"
  },
  {
    "codigo": "39089020",
    "descricao": "Obtidas por condensação de ácidos graxos (gordos) dimerizados ou trimerizados com etilenaminas"
  },
  {
    "codigo": "39089090",
    "descricao": "Outras"
  },
  {
    "codigo": "39091000",
    "descricao": "- Resinas ureicas; resinas de tioureia"
  },
  {
    "codigo": "39092011",
    "descricao": "Melamina-formaldeído, em pó"
  },
  {
    "codigo": "39092019",
    "descricao": "Outras"
  },
  {
    "codigo": "39092021",
    "descricao": "Melamina-formaldeído, em pó"
  },
  {
    "codigo": "39092029",
    "descricao": "Outras"
  },
  {
    "codigo": "39093100",
    "descricao": "-- Poli(isocianato de fenil metileno) (MDI bruto, MDI polimérico)"
  },
  {
    "codigo": "39093900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "39094011",
    "descricao": "Fenol-formaldeído"
  },
  {
    "codigo": "39094019",
    "descricao": "Outras"
  },
  {
    "codigo": "39094091",
    "descricao": "Fenol-formaldeído"
  },
  {
    "codigo": "39094099",
    "descricao": "Outras"
  },
  {
    "codigo": "39095011",
    "descricao": "Soluções em solventes orgânicos"
  },
  {
    "codigo": "39095012",
    "descricao": "Em dispersão aquosa"
  },
  {
    "codigo": "39095019",
    "descricao": "Outros"
  },
  {
    "codigo": "39095021",
    "descricao": "Hidroxilados, com propriedades adesivas"
  },
  {
    "codigo": "39095029",
    "descricao": "Outros"
  },
  {
    "codigo": "39100011",
    "descricao": "Misturas de pré-polímeros lineares e cíclicos, obtidos por hidrólise de dimetildiclorosilano, de peso molecular médio inferior ou igual a 8.800"
  },
  {
    "codigo": "39100012",
    "descricao": "Polidimetilsiloxano, polimetilidrogenosiloxano ou misturas destes produtos, em dispersão"
  },
  {
    "codigo": "39100013",
    "descricao": "Copolímeros de dimetilsiloxano com compostos vinílicos, de viscosidade igual ou superior a 1.000.000 cSt"
  },
  {
    "codigo": "39100019",
    "descricao": "Outros"
  },
  {
    "codigo": "39100021",
    "descricao": "De vulcanização a quente"
  },
  {
    "codigo": "39100029",
    "descricao": "Outros"
  },
  {
    "codigo": "39100030",
    "descricao": "Resinas"
  },
  {
    "codigo": "39100090",
    "descricao": "Outros"
  },
  {
    "codigo": "39111010",
    "descricao": "Com carga"
  },
  {
    "codigo": "39111021",
    "descricao": "Resinas de petróleo, total ou parcialmente hidrogenadas, de Cor Gardner inferior a 3, segundo Norma ASTM D 1544"
  },
  {
    "codigo": "39111029",
    "descricao": "Outros"
  },
  {
    "codigo": "39112000",
    "descricao": "- Poli(1,3-fenileno metilfosfonato)"
  },
  {
    "codigo": "39119011",
    "descricao": "Politerpenos modificados quimicamente, exceto com fenóis"
  },
  {
    "codigo": "39119012",
    "descricao": "Polieterimidas (PEI) e seus copolímeros"
  },
  {
    "codigo": "39119013",
    "descricao": "Polietersulfonas (PES) e seus copolímeros"
  },
  {
    "codigo": "39119014",
    "descricao": "Poli(sulfeto de fenileno)"
  },
  {
    "codigo": "39119019",
    "descricao": "Outros"
  },
  {
    "codigo": "39119021",
    "descricao": "Politerpenos modificados quimicamente, exceto com fenóis"
  },
  {
    "codigo": "39119022",
    "descricao": "Poli(sulfeto de fenileno)"
  },
  {
    "codigo": "39119023",
    "descricao": "Polietilenaminas"
  },
  {
    "codigo": "39119024",
    "descricao": "Polieterimidas (PEI) e seus copolímeros"
  },
  {
    "codigo": "39119025",
    "descricao": "Polietersulfonas (PES) e seus copolímeros"
  },
  {
    "codigo": "39119026",
    "descricao": "Polissulfonas"
  },
  {
    "codigo": "39119027",
    "descricao": "Cloreto de hexadimetrina"
  },
  {
    "codigo": "39119029",
    "descricao": "Outros"
  },
  {
    "codigo": "39121110",
    "descricao": "Com carga"
  },
  {
    "codigo": "39121120",
    "descricao": "Sem carga"
  },
  {
    "codigo": "39121200",
    "descricao": "-- Plastificados"
  },
  {
    "codigo": "39122010",
    "descricao": "Com carga"
  },
  {
    "codigo": "39122021",
    "descricao": "Em álcool, com um teor de não voláteis igual ou superior a 65 %, em peso"
  },
  {
    "codigo": "39122029",
    "descricao": "Outros"
  },
  {
    "codigo": "39123111",
    "descricao": "Com um teor de carboximetilcelulose igual ou superior a 75 %, em peso"
  },
  {
    "codigo": "39123119",
    "descricao": "Outros"
  },
  {
    "codigo": "39123121",
    "descricao": "Com um teor de sais igual ou superior a 75 %, em peso"
  },
  {
    "codigo": "39123129",
    "descricao": "Outros"
  },
  {
    "codigo": "39123910",
    "descricao": "Metil-, etil- e propilcelulose, hidroxiladas"
  },
  {
    "codigo": "39123920",
    "descricao": "Outras metilceluloses"
  },
  {
    "codigo": "39123930",
    "descricao": "Outras etilceluloses"
  },
  {
    "codigo": "39123990",
    "descricao": "Outros"
  },
  {
    "codigo": "39129010",
    "descricao": "Propionato de celulose"
  },
  {
    "codigo": "39129020",
    "descricao": "Acetobutanoato de celulose"
  },
  {
    "codigo": "39129031",
    "descricao": "Em pó"
  },
  {
    "codigo": "39129039",
    "descricao": "Outras"
  },
  {
    "codigo": "39129040",
    "descricao": "Outras celuloses, em pó"
  },
  {
    "codigo": "39129090",
    "descricao": "Outros"
  },
  {
    "codigo": "39131000",
    "descricao": "- Ácido algínico, seus sais e seus ésteres"
  },
  {
    "codigo": "39139011",
    "descricao": "Borracha clorada ou cloridratada, nas formas previstas na Nota 6 b) deste Capítulo"
  },
  {
    "codigo": "39139012",
    "descricao": "Borracha clorada, noutras formas"
  },
  {
    "codigo": "39139019",
    "descricao": "Outros"
  },
  {
    "codigo": "39139020",
    "descricao": "Goma xantana"
  },
  {
    "codigo": "39139030",
    "descricao": "Dextrana"
  },
  {
    "codigo": "39139040",
    "descricao": "Proteínas endurecidas"
  },
  {
    "codigo": "39139050",
    "descricao": "Quitosan (<i>Chitosan</i>), seus sais ou seus derivados"
  },
  {
    "codigo": "39139060",
    "descricao": "Sulfato de condroitina"
  },
  {
    "codigo": "39139090",
    "descricao": "Outros"
  },
  {
    "codigo": "39140011",
    "descricao": "De copolímeros de estireno-divinilbenzeno, sulfonados"
  },
  {
    "codigo": "39140019",
    "descricao": "Outros"
  },
  {
    "codigo": "39140090",
    "descricao": "Outros"
  },
  {
    "codigo": "39151000",
    "descricao": "- De polímeros de etileno"
  },
  {
    "codigo": "39152000",
    "descricao": "- De polímeros de estireno"
  },
  {
    "codigo": "39153000",
    "descricao": "- De polímeros de cloreto de vinila"
  },
  {
    "codigo": "39159000",
    "descricao": "- De outro plástico"
  },
  {
    "codigo": "39161000",
    "descricao": "- De polímeros de etileno"
  },
  {
    "codigo": "39162000",
    "descricao": "- De polímeros de cloreto de vinila"
  },
  {
    "codigo": "39169010",
    "descricao": "Monofilamentos"
  },
  {
    "codigo": "39169090",
    "descricao": "Outros"
  },
  {
    "codigo": "39171010",
    "descricao": "De proteínas endurecidas"
  },
  {
    "codigo": "39171021",
    "descricao": "Fibrosas, de celulose regenerada, de diâmetro igual ou superior a 150 mm"
  },
  {
    "codigo": "39171029",
    "descricao": "Outras"
  },
  {
    "codigo": "39172100",
    "descricao": "-- De polímeros de etileno"
  },
  {
    "codigo": "39172210",
    "descricao": "De seção transversal interna redonda de diâmetro inferior a 6 mm e externa hexagonal"
  },
  {
    "codigo": "39172290",
    "descricao": "Outros"
  },
  {
    "codigo": "39172300",
    "descricao": "-- De polímeros de cloreto de vinila"
  },
  {
    "codigo": "39172900",
    "descricao": "-- De outro plástico"
  },
  {
    "codigo": "39173100",
    "descricao": "-- Tubos flexíveis podendo suportar uma pressão de, pelo menos, 27,6 MPa"
  },
  {
    "codigo": "39173210",
    "descricao": "De copolímeros de etileno"
  },
  {
    "codigo": "39173221",
    "descricao": "Tubos capilares, semipermeáveis, próprios para hemodiálise ou para oxigenação sanguínea"
  },
  {
    "codigo": "39173229",
    "descricao": "Outros"
  },
  {
    "codigo": "39173230",
    "descricao": "De poli(tereftalato de etileno)"
  },
  {
    "codigo": "39173240",
    "descricao": "De silicones"
  },
  {
    "codigo": "39173251",
    "descricao": "Tubos capilares, semipermeáveis, próprios para hemodiálise"
  },
  {
    "codigo": "39173259",
    "descricao": "Outros"
  },
  {
    "codigo": "39173290",
    "descricao": "Outros"
  },
  {
    "codigo": "39173300",
    "descricao": "-- Outros, não reforçados com outras matérias, nem associados de outra forma com outras matérias, com acessórios"
  },
  {
    "codigo": "39173900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "39174010",
    "descricao": "Do tipo utilizado em linhas de sangue para hemodiálise"
  },
  {
    "codigo": "39174090",
    "descricao": "Outros"
  },
  {
    "codigo": "39181000",
    "descricao": "- De polímeros de cloreto de vinila"
  },
  {
    "codigo": "39189000",
    "descricao": "- De outro plástico"
  },
  {
    "codigo": "39191010",
    "descricao": "De polipropileno"
  },
  {
    "codigo": "39191020",
    "descricao": "De poli(cloreto de vinila)"
  },
  {
    "codigo": "39191090",
    "descricao": "Outras"
  },
  {
    "codigo": "39199010",
    "descricao": "De polipropileno"
  },
  {
    "codigo": "39199020",
    "descricao": "De poli(cloreto de vinila)"
  },
  {
    "codigo": "39199090",
    "descricao": "Outras"
  },
  {
    "codigo": "39201010",
    "descricao": "De densidade igual ou superior a 0,94, espessura inferior ou igual a 19 micrômetros (mícrons), em rolos de largura inferior ou igual a 66 cm"
  },
  {
    "codigo": "39201091",
    "descricao": "De densidade inferior a 0,94, com óleo de parafina e carga (sílica e negro de fumo), apresentando nervuras paralelas entre si, com uma resistência elétrica igual ou superior a 0,030 ohms.cm<sup>2</sup>, mas inferior ou igual a 0,120 ohms.cm<sup>2</sup>, em rolos, do tipo utilizado para a fabricação de separadores de acumuladores elétricos"
  },
  {
    "codigo": "39201099",
    "descricao": "Outras"
  },
  {
    "codigo": "39202011",
    "descricao": "De largura inferior ou igual a 12,5 cm e espessura inferior ou igual a 10 micrômetros (mícrons), metalizadas"
  },
  {
    "codigo": "39202012",
    "descricao": "De largura inferior ou igual a 1 m e espessura inferior ou igual a 13 micrômetros (mícrons), com uma ou ambas as faces rugosas de rugosidade relativa (relação entre a espessura média e a máxima) igual ou superior a 6 %, de rigidez dielétrica igual ou superior a 500 V/micrômetro (Norma ASTM D 3755-97), em rolos"
  },
  {
    "codigo": "39202019",
    "descricao": "Outras"
  },
  {
    "codigo": "39202090",
    "descricao": "Outras"
  },
  {
    "codigo": "39203000",
    "descricao": "- De polímeros de estireno"
  },
  {
    "codigo": "39204310",
    "descricao": "De poli(cloreto de vinila), transparentes, termocontráteis, de espessura inferior ou igual a 250 micrômetros (mícrons)"
  },
  {
    "codigo": "39204390",
    "descricao": "Outras"
  },
  {
    "codigo": "39204900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "39205100",
    "descricao": "-- De poli(metacrilato de metila)"
  },
  {
    "codigo": "39205900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "39206100",
    "descricao": "-- De policarbonatos"
  },
  {
    "codigo": "39206211",
    "descricao": "De espessura inferior a 5 micrômetros (mícrons)"
  },
  {
    "codigo": "39206219",
    "descricao": "Outras"
  },
  {
    "codigo": "39206291",
    "descricao": "Com largura superior a 12 cm, sem qualquer trabalho à superfície"
  },
  {
    "codigo": "39206299",
    "descricao": "Outras"
  },
  {
    "codigo": "39206300",
    "descricao": "-- De poliésteres não saturados"
  },
  {
    "codigo": "39206900",
    "descricao": "-- De outros poliésteres"
  },
  {
    "codigo": "39207100",
    "descricao": "-- De celulose regenerada"
  },
  {
    "codigo": "39207310",
    "descricao": "De espessura inferior ou igual a 0,75 mm"
  },
  {
    "codigo": "39207390",
    "descricao": "Outras"
  },
  {
    "codigo": "39207910",
    "descricao": "De fibra vulcanizada, de espessura inferior ou igual a 1 mm"
  },
  {
    "codigo": "39207990",
    "descricao": "Outros"
  },
  {
    "codigo": "39209100",
    "descricao": "-- De poli(butiral de vinila)"
  },
  {
    "codigo": "39209200",
    "descricao": "-- De poliamidas"
  },
  {
    "codigo": "39209300",
    "descricao": "-- De resinas amínicas"
  },
  {
    "codigo": "39209400",
    "descricao": "-- De resinas fenólicas"
  },
  {
    "codigo": "39209910",
    "descricao": "De silicone"
  },
  {
    "codigo": "39209920",
    "descricao": "De poli(álcool vinílico)"
  },
  {
    "codigo": "39209930",
    "descricao": "De polímeros de fluoreto de vinila"
  },
  {
    "codigo": "39209940",
    "descricao": "De poliimida"
  },
  {
    "codigo": "39209950",
    "descricao": "De poli(clorotrifluoretileno)"
  },
  {
    "codigo": "39209990",
    "descricao": "Outras"
  },
  {
    "codigo": "39211100",
    "descricao": "-- De polímeros de estireno"
  },
  {
    "codigo": "39211200",
    "descricao": "-- De polímeros de cloreto de vinila"
  },
  {
    "codigo": "39211310",
    "descricao": "Com base poliéster, de células abertas, com um número de poros por decímetro linear igual ou superior a 24 e inferior ou igual a 157 (6 a 40 poros por polegada linear), com resistência à compressão 50 % (RC<sub>50</sub>) igual ou superior a 3,0 kPa e inferior ou igual a 6,0 kPa"
  },
  {
    "codigo": "39211390",
    "descricao": "Outras"
  },
  {
    "codigo": "39211400",
    "descricao": "-- De celulose regenerada"
  },
  {
    "codigo": "39211900",
    "descricao": "-- De outro plástico"
  },
  {
    "codigo": "39219011",
    "descricao": "De resina melamina-formaldeído"
  },
  {
    "codigo": "39219012",
    "descricao": "De polietileno, com reforço de napas de fibras de polietileno paralelizadas, superpostas entre si em ângulo de 90º e impregnadas com resinas"
  },
  {
    "codigo": "39219013",
    "descricao": "De copolímeros de tetrafluoretileno reforçadas com tecido de fibras de politetrafluoretileno, do tipo utilizado como membranas semipermeáveis em células de eletrólise"
  },
  {
    "codigo": "39219019",
    "descricao": "Outras"
  },
  {
    "codigo": "39219020",
    "descricao": "De poli(tereftalato de etileno), com camada antiestática à base de gelatina ou de látex em ambas as faces, mesmo com halogenetos de potássio"
  },
  {
    "codigo": "39219090",
    "descricao": "Outras"
  },
  {
    "codigo": "39221000",
    "descricao": "- Banheiras, boxes para chuveiros (polibãs*), pias e lavatórios"
  },
  {
    "codigo": "39222000",
    "descricao": "- Assentos e tampas, de sanitários"
  },
  {
    "codigo": "39229000",
    "descricao": "- Outros"
  },
  {
    "codigo": "39231010",
    "descricao": "Estojos de plástico, do tipo utilizado para acondicionar discos para sistemas de leitura por raio laser"
  },
  {
    "codigo": "39231090",
    "descricao": "Outros"
  },
  {
    "codigo": "39232110",
    "descricao": "De capacidade inferior ou igual a 1.000 cm<sup>3</sup>"
  },
  {
    "codigo": "39232190",
    "descricao": "Outros"
  },
  {
    "codigo": "39232910",
    "descricao": "De capacidade inferior ou igual a 1.000 cm<sup>3</sup>"
  },
  {
    "codigo": "39232990",
    "descricao": "Outros"
  },
  {
    "codigo": "39233010",
    "descricao": "Recipientes para gás liquefeito de petróleo (GLP)"
  },
  {
    "codigo": "39233090",
    "descricao": "Outros"
  },
  {
    "codigo": "39234000",
    "descricao": "- Bobinas, carretéis, canelas e suportes semelhantes"
  },
  {
    "codigo": "39235000",
    "descricao": "- Rolhas, tampas, cápsulas e outros dispositivos para fechar recipientes"
  },
  {
    "codigo": "39239010",
    "descricao": "Paletes simples, paletes-caixas e outros estrados para carga; taipais de paletes"
  },
  {
    "codigo": "39239090",
    "descricao": "Outros"
  },
  {
    "codigo": "39241000",
    "descricao": "- Serviços de mesa e outros utensílios de mesa ou de cozinha"
  },
  {
    "codigo": "39249000",
    "descricao": "- Outros"
  },
  {
    "codigo": "39251000",
    "descricao": "- Reservatórios, cisternas, cubas e recipientes análogos, de capacidade superior a 300 l"
  },
  {
    "codigo": "39252000",
    "descricao": "- Portas, janelas e seus caixilhos, alizares e soleiras"
  },
  {
    "codigo": "39253000",
    "descricao": "- Postigos, estores (incluindo as venezianas) e artigos semelhantes, e suas partes"
  },
  {
    "codigo": "39259010",
    "descricao": "De poliestireno expandido (EPS)"
  },
  {
    "codigo": "39259090",
    "descricao": "Outros"
  },
  {
    "codigo": "39261000",
    "descricao": "- Artigos de escritório e artigos escolares"
  },
  {
    "codigo": "39262000",
    "descricao": "- Vestuário e seus acessórios (incluindo as luvas, mitenes e semelhantes)"
  },
  {
    "codigo": "39263000",
    "descricao": "- Guarnições para móveis, carroçarias ou semelhantes"
  },
  {
    "codigo": "39264000",
    "descricao": "- Estatuetas e outros objetos de ornamentação"
  },
  {
    "codigo": "39269010",
    "descricao": "Arruelas (anilhas)"
  },
  {
    "codigo": "39269021",
    "descricao": "De transmissão"
  },
  {
    "codigo": "39269022",
    "descricao": "Transportadoras"
  },
  {
    "codigo": "39269030",
    "descricao": "Bolsas para uso em medicina (hemodiálise e usos semelhantes)"
  },
  {
    "codigo": "39269040",
    "descricao": "Artigos de laboratório ou de farmácia"
  },
  {
    "codigo": "39269050",
    "descricao": "Acessórios do tipo utilizado em linhas de sangue para hemodiálise, tais como: obturadores, incluindo os reguláveis (clamps), clipes e semelhantes"
  },
  {
    "codigo": "39269061",
    "descricao": "De tetrafluoretileno e éter perfluorometilvinil"
  },
  {
    "codigo": "39269069",
    "descricao": "Outros"
  },
  {
    "codigo": "39269090",
    "descricao": "Outras"
  },
  {
    "codigo": "40011000",
    "descricao": "- Látex de borracha natural, mesmo pré-vulcanizado"
  },
  {
    "codigo": "40012100",
    "descricao": "-- Folhas fumadas"
  },
  {
    "codigo": "40012200",
    "descricao": "-- Borracha natural tecnicamente especificada (TSNR)"
  },
  {
    "codigo": "40012910",
    "descricao": "Crepadas"
  },
  {
    "codigo": "40012920",
    "descricao": "Granuladas ou prensadas"
  },
  {
    "codigo": "40012990",
    "descricao": "Outras"
  },
  {
    "codigo": "40013000",
    "descricao": "- Balata, guta-percha, guaiúle, chicle e gomas naturais análogas"
  },
  {
    "codigo": "40021110",
    "descricao": "De estireno-butadieno (SBR)"
  },
  {
    "codigo": "40021120",
    "descricao": "De estireno-butadieno carboxilada (XSBR)"
  },
  {
    "codigo": "40021911",
    "descricao": "Em chapas, folhas ou tiras"
  },
  {
    "codigo": "40021912",
    "descricao": "Grau alimentício de acordo com o estabelecido pelo <i>Food Chemical Codex</i>, em formas primárias"
  },
  {
    "codigo": "40021919",
    "descricao": "Outras"
  },
  {
    "codigo": "40021920",
    "descricao": "De estireno-butadieno carboxilada (XSBR)"
  },
  {
    "codigo": "40022010",
    "descricao": "Óleo"
  },
  {
    "codigo": "40022091",
    "descricao": "1,2-polibutadieno sindiotáctico"
  },
  {
    "codigo": "40022099",
    "descricao": "Outras"
  },
  {
    "codigo": "40023100",
    "descricao": "-- Borracha de isobuteno-isopreno (butila) (IIR)"
  },
  {
    "codigo": "40023900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "40024100",
    "descricao": "-- Látex"
  },
  {
    "codigo": "40024900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "40025100",
    "descricao": "-- Látex"
  },
  {
    "codigo": "40025900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "40026000",
    "descricao": "- Borracha de isopreno (IR)"
  },
  {
    "codigo": "40027000",
    "descricao": "- Borracha de etileno-propileno-dieno não conjugado (EPDM)"
  },
  {
    "codigo": "40028000",
    "descricao": "- Misturas dos produtos da posição 40.01 com produtos da presente posição"
  },
  {
    "codigo": "40029100",
    "descricao": "-- Látex"
  },
  {
    "codigo": "40029910",
    "descricao": "Borracha estireno-isopreno-estireno"
  },
  {
    "codigo": "40029920",
    "descricao": "Borracha etileno-propileno-dieno não conjugado-propileno (EPDM-propileno)"
  },
  {
    "codigo": "40029930",
    "descricao": "Borracha acrilonitrila-butadieno hidrogenada"
  },
  {
    "codigo": "40029990",
    "descricao": "Outras"
  },
  {
    "codigo": "40030000",
    "descricao": "Borracha regenerada, em formas primárias ou em chapas, folhas ou tiras."
  },
  {
    "codigo": "40040000",
    "descricao": "Desperdícios, resíduos e aparas, de borracha não endurecida, mesmo reduzidos a pó ou a grânulos."
  },
  {
    "codigo": "40051010",
    "descricao": "Borracha etileno-propileno-dieno não conjugado-propileno (EPDM-propileno), com sílica e plastificante, em grânulos"
  },
  {
    "codigo": "40051090",
    "descricao": "Outras"
  },
  {
    "codigo": "40052000",
    "descricao": "- Soluções; dispersões, exceto as da subposição 4005.10"
  },
  {
    "codigo": "40059110",
    "descricao": "Preparações base para a fabricação de gomas de mascar"
  },
  {
    "codigo": "40059190",
    "descricao": "Outras"
  },
  {
    "codigo": "40059910",
    "descricao": "Preparações base para a fabricação de gomas de mascar"
  },
  {
    "codigo": "40059990",
    "descricao": "Outras"
  },
  {
    "codigo": "40061000",
    "descricao": "- Perfis para recauchutagem"
  },
  {
    "codigo": "40069000",
    "descricao": "- Outros"
  },
  {
    "codigo": "40070011",
    "descricao": "Recobertos com silicone, mesmo paralelizados"
  },
  {
    "codigo": "40070019",
    "descricao": "Outros"
  },
  {
    "codigo": "40070020",
    "descricao": "Cordas"
  },
  {
    "codigo": "40081100",
    "descricao": "-- Chapas, folhas e tiras"
  },
  {
    "codigo": "40081900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "40082100",
    "descricao": "-- Chapas, folhas e tiras"
  },
  {
    "codigo": "40082900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "40091100",
    "descricao": "-- Sem acessórios"
  },
  {
    "codigo": "40091210",
    "descricao": "Com uma pressão de ruptura igual ou superior a 17,3 MPa"
  },
  {
    "codigo": "40091290",
    "descricao": "Outros"
  },
  {
    "codigo": "40092110",
    "descricao": "Com uma pressão de ruptura igual ou superior a 17,3 MPa"
  },
  {
    "codigo": "40092190",
    "descricao": "Outros"
  },
  {
    "codigo": "40092210",
    "descricao": "Com uma pressão de ruptura igual ou superior a 17,3 MPa"
  },
  {
    "codigo": "40092290",
    "descricao": "Outros"
  },
  {
    "codigo": "40093100",
    "descricao": "-- Sem acessórios"
  },
  {
    "codigo": "40093210",
    "descricao": "Com uma pressão de ruptura igual ou superior a 17,3 MPa"
  },
  {
    "codigo": "40093290",
    "descricao": "Outros"
  },
  {
    "codigo": "40094100",
    "descricao": "-- Sem acessórios"
  },
  {
    "codigo": "40094210",
    "descricao": "Com uma pressão de ruptura igual ou superior a 17,3 MPa"
  },
  {
    "codigo": "40094290",
    "descricao": "Outros"
  },
  {
    "codigo": "40101100",
    "descricao": "-- Reforçadas apenas com metal"
  },
  {
    "codigo": "40101200",
    "descricao": "-- Reforçadas apenas com matérias têxteis"
  },
  {
    "codigo": "40101900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "40103100",
    "descricao": "-- Correias de transmissão sem fim, de seção trapezoidal, estriadas, com uma circunferência externa superior a 60 cm, mas não superior a 180 cm"
  },
  {
    "codigo": "40103200",
    "descricao": "-- Correias de transmissão sem fim, de seção trapezoidal, não estriadas, com uma circunferência externa superior a 60 cm, mas não superior a 180 cm"
  },
  {
    "codigo": "40103300",
    "descricao": "-- Correias de transmissão sem fim, de seção trapezoidal, estriadas, com uma circunferência externa superior a 180 cm, mas não superior a 240 cm"
  },
  {
    "codigo": "40103400",
    "descricao": "-- Correias de transmissão sem fim, de seção trapezoidal, não estriadas, com uma circunferência externa superior a 180 cm, mas não superior a 240 cm"
  },
  {
    "codigo": "40103500",
    "descricao": "-- Correias de transmissão sem fim, síncronas, com uma circunferência externa superior a 60 cm, mas não superior a 150 cm"
  },
  {
    "codigo": "40103600",
    "descricao": "-- Correias de transmissão sem fim, síncronas, com uma circunferência externa superior a 150 cm, mas não superior a 198 cm"
  },
  {
    "codigo": "40103900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "40111000",
    "descricao": "- Do tipo utilizado em automóveis de passageiros (incluindo os veículos de uso misto (<i>station wagons</i>) e os automóveis de corrida)"
  },
  {
    "codigo": "40112010",
    "descricao": "De medida 11,00-24"
  },
  {
    "codigo": "40112090",
    "descricao": "Outros"
  },
  {
    "codigo": "40113000",
    "descricao": "- Do tipo utilizado em veículos aéreos"
  },
  {
    "codigo": "40114000",
    "descricao": "- Do tipo utilizado em motocicletas"
  },
  {
    "codigo": "40115000",
    "descricao": "- Do tipo utilizado em bicicletas"
  },
  {
    "codigo": "40117010",
    "descricao": "Nas seguintes medidas: 4,00-15; 4,00-18; 4,00-19; 5,00-15; 5,00-16; 5,50-16; 6,00-16; 6,00-19; 6,00-20; 6,50-16; 6,50-20; 7,50-16; 7,50-18; 7,50-20"
  },
  {
    "codigo": "40117090",
    "descricao": "Outros"
  },
  {
    "codigo": "40118010",
    "descricao": "Radiais, para <i>dumpers</i> concebidos para serem utilizados fora de rodovias, com seção de largura igual ou superior a 940 mm (37\"), para aros de diâmetro igual ou superior a 1.448 mm (57\")"
  },
  {
    "codigo": "40118020",
    "descricao": "Outros, com seção de largura igual ou superior a 1.143 mm (45\"), para aros de diâmetro igual ou superior a 1.143 mm (45\")"
  },
  {
    "codigo": "40118090",
    "descricao": "Outros"
  },
  {
    "codigo": "40119010",
    "descricao": "Com seção de largura igual ou superior a 1.143 mm (45\"), para aros de diâmetro igual ou superior a 1.143 mm (45\")"
  },
  {
    "codigo": "40119090",
    "descricao": "Outros"
  },
  {
    "codigo": "40121100",
    "descricao": "-- Do tipo utilizado em automóveis de passageiros (incluindo os veículos de uso misto (<i>station wagons</i>) e os automóveis de corrida)"
  },
  {
    "codigo": "40121200",
    "descricao": "-- Do tipo utilizado em ônibus (autocarros) ou caminhões"
  },
  {
    "codigo": "40121300",
    "descricao": "-- Do tipo utilizado em veículos aéreos"
  },
  {
    "codigo": "40121900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "40122000",
    "descricao": "- Pneumáticos usados"
  },
  {
    "codigo": "40129010",
    "descricao": "<i>Flaps</i>"
  },
  {
    "codigo": "40129090",
    "descricao": "Outros"
  },
  {
    "codigo": "40131010",
    "descricao": "Para pneumáticos do tipo utilizado em ônibus ou caminhões, de medida 11,00-24"
  },
  {
    "codigo": "40131090",
    "descricao": "Outras"
  },
  {
    "codigo": "40132000",
    "descricao": "- Do tipo utilizado em bicicletas"
  },
  {
    "codigo": "40139000",
    "descricao": "- Outras"
  },
  {
    "codigo": "40141000",
    "descricao": "- Preservativos"
  },
  {
    "codigo": "40149010",
    "descricao": "Bolsas para gelo ou para água quente"
  },
  {
    "codigo": "40149090",
    "descricao": "Outros"
  },
  {
    "codigo": "40151200",
    "descricao": "-- Do tipo utilizado em medicina, cirurgia, odontologia ou veterinária"
  },
  {
    "codigo": "40151900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "40159000",
    "descricao": "- Outros"
  },
  {
    "codigo": "40161010",
    "descricao": "Partes de veículos automóveis ou tratores e de máquinas ou aparelhos, não domésticos, dos Capítulos 84, 85 ou 90"
  },
  {
    "codigo": "40161090",
    "descricao": "Outras"
  },
  {
    "codigo": "40169100",
    "descricao": "-- Revestimentos para pisos (pavimentos) e tapetes"
  },
  {
    "codigo": "40169200",
    "descricao": "-- Borrachas de apagar"
  },
  {
    "codigo": "40169300",
    "descricao": "-- Juntas, gaxetas e semelhantes"
  },
  {
    "codigo": "40169400",
    "descricao": "-- Defensas, mesmo infláveis, para atracação de embarcações"
  },
  {
    "codigo": "40169510",
    "descricao": "De salvamento"
  },
  {
    "codigo": "40169590",
    "descricao": "Outros"
  },
  {
    "codigo": "40169910",
    "descricao": "Tampões vedadores para condensadores, de EPDM, com perfurações para terminais"
  },
  {
    "codigo": "40169990",
    "descricao": "Outras"
  },
  {
    "codigo": "40170000",
    "descricao": "Borracha endurecida (ebonite, por exemplo) sob qualquer forma, incluindo os desperdícios e resíduos; obras de borracha endurecida."
  },
  {
    "codigo": "41012000",
    "descricao": "- Couros e peles em bruto, inteiros, não divididos, de peso unitário não superior a 8 kg quando secos, a 10 kg quando salgados a seco e a 16 kg quando frescos, salgados a úmido ou conservados de outro modo"
  },
  {
    "codigo": "41015010",
    "descricao": "Sem dividir"
  },
  {
    "codigo": "41015020",
    "descricao": "Divididos, com o lado flor"
  },
  {
    "codigo": "41015030",
    "descricao": "Divididos, sem o lado flor"
  },
  {
    "codigo": "41019010",
    "descricao": "Sem dividir"
  },
  {
    "codigo": "41019020",
    "descricao": "Divididos, com o lado flor"
  },
  {
    "codigo": "41019030",
    "descricao": "Divididos, sem o lado flor"
  },
  {
    "codigo": "41021000",
    "descricao": "- Com lã (não depiladas)"
  },
  {
    "codigo": "41022100",
    "descricao": "-- Piqueladas"
  },
  {
    "codigo": "41022900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "41032000",
    "descricao": "- De répteis"
  },
  {
    "codigo": "41033000",
    "descricao": "- De suínos"
  },
  {
    "codigo": "41039000",
    "descricao": "- Outros"
  },
  {
    "codigo": "41041111",
    "descricao": "Couros e peles inteiros, de bovinos (incluindo os búfalos), de superfície unitária não superior a 2,6 m<sup>2</sup>, simplesmente curtidos ao cromo (<i>wet-blue</i>)"
  },
  {
    "codigo": "41041112",
    "descricao": "Outros couros e peles inteiros, de bovinos (incluindo os búfalos), de superfície unitária não superior a 2,6 m<sup>2</sup>"
  },
  {
    "codigo": "41041113",
    "descricao": "Outros couros e peles de bovinos (incluindo os búfalos), com pré-curtimenta vegetal"
  },
  {
    "codigo": "41041114",
    "descricao": "Outros couros e peles de bovinos (incluindo os búfalos)"
  },
  {
    "codigo": "41041119",
    "descricao": "Outros"
  },
  {
    "codigo": "41041121",
    "descricao": "Couros e peles inteiros, de bovinos (incluindo os búfalos), de superfície unitária não superior a 2,6 m<sup>2</sup>, simplesmente curtidos ao cromo (<i>wet-blue</i>)"
  },
  {
    "codigo": "41041122",
    "descricao": "Outros couros e peles inteiros, de bovinos (incluindo os búfalos), de superfície unitária não superior a 2,6 m<sup>2</sup>"
  },
  {
    "codigo": "41041123",
    "descricao": "Outros couros e peles de bovinos (incluindo os búfalos), com pré-curtimenta vegetal"
  },
  {
    "codigo": "41041124",
    "descricao": "Outros couros e peles de bovinos (incluindo os búfalos)"
  },
  {
    "codigo": "41041129",
    "descricao": "Outros"
  },
  {
    "codigo": "41041910",
    "descricao": "Couros e peles inteiros, de bovinos (incluindo os búfalos), de superfície unitária não superior a 2,6 m<sup>2</sup>, simplesmente curtidos ao cromo (<i>wet-blue</i>)"
  },
  {
    "codigo": "41041920",
    "descricao": "Outros couros e peles inteiros, de bovinos (incluindo os búfalos), de superfície unitária não superior a 2,6 m<sup>2</sup>"
  },
  {
    "codigo": "41041930",
    "descricao": "Outros couros e peles de bovinos (incluindo os búfalos), com pré-curtimenta vegetal"
  },
  {
    "codigo": "41041940",
    "descricao": "Outros couros e peles de bovinos (incluindo os búfalos)"
  },
  {
    "codigo": "41041990",
    "descricao": "Outros"
  },
  {
    "codigo": "41044110",
    "descricao": "Couros e peles inteiros, de bovinos (incluindo os búfalos), de superfície unitária não superior a 2,6 m<sup>2</sup>"
  },
  {
    "codigo": "41044120",
    "descricao": "Outros couros e peles de bovinos (incluindo os búfalos), curtidos ao vegetal, para solas"
  },
  {
    "codigo": "41044130",
    "descricao": "Outros couros e peles de bovinos (incluindo os búfalos)"
  },
  {
    "codigo": "41044190",
    "descricao": "Outros"
  },
  {
    "codigo": "41044910",
    "descricao": "Couros e peles inteiros, de bovinos (incluindo os búfalos), de superfície unitária não superior a 2,6 m<sup>2 </sup>"
  },
  {
    "codigo": "41044920",
    "descricao": "Outros couros e peles de bovinos (incluindo os búfalos)"
  },
  {
    "codigo": "41044990",
    "descricao": "Outros"
  },
  {
    "codigo": "41051010",
    "descricao": "Com pré-curtimenta vegetal"
  },
  {
    "codigo": "41051021",
    "descricao": "Ao cromo (<i>wet-blue</i>)"
  },
  {
    "codigo": "41051029",
    "descricao": "Outras"
  },
  {
    "codigo": "41051090",
    "descricao": "Outras"
  },
  {
    "codigo": "41053000",
    "descricao": "- No estado seco (<i>crust</i>)"
  },
  {
    "codigo": "41062110",
    "descricao": "Com pré-curtimenta vegetal"
  },
  {
    "codigo": "41062121",
    "descricao": "Ao cromo (<i>wet-blue</i>)"
  },
  {
    "codigo": "41062129",
    "descricao": "Outros"
  },
  {
    "codigo": "41062190",
    "descricao": "Outros"
  },
  {
    "codigo": "41062200",
    "descricao": "-- No estado seco (<i>crust</i>)"
  },
  {
    "codigo": "41063110",
    "descricao": "Simplesmente curtidos ao cromo (<i>wet-blue</i>)"
  },
  {
    "codigo": "41063190",
    "descricao": "Outros"
  },
  {
    "codigo": "41063200",
    "descricao": "-- No estado seco (<i>crust</i>)"
  },
  {
    "codigo": "41064000",
    "descricao": "- De répteis"
  },
  {
    "codigo": "41069100",
    "descricao": "-- No estado úmido (incluindo <i>wet-blue</i>)"
  },
  {
    "codigo": "41069200",
    "descricao": "-- No estado seco (<i>crust</i>)"
  },
  {
    "codigo": "41071110",
    "descricao": "Couros e peles de bovinos (incluindo os búfalos), de superfície unitária não superior a 2,6 m<sup>2</sup>"
  },
  {
    "codigo": "41071120",
    "descricao": "Outros couros e peles de bovinos (incluindo os búfalos)"
  },
  {
    "codigo": "41071190",
    "descricao": "Outros"
  },
  {
    "codigo": "41071210",
    "descricao": "Couros e peles de bovinos (incluindo os búfalos), de superfície unitária não superior a 2,6 m<sup>2</sup>"
  },
  {
    "codigo": "41071220",
    "descricao": "Outros couros e peles de bovinos (incluindo os búfalos)"
  },
  {
    "codigo": "41071290",
    "descricao": "Outros"
  },
  {
    "codigo": "41071910",
    "descricao": "Couros e peles de bovinos (incluindo os búfalos), de superfície unitária não superior a 2,6 m<sup>2</sup>"
  },
  {
    "codigo": "41071920",
    "descricao": "Outros couros e peles de bovinos (incluindo os búfalos)"
  },
  {
    "codigo": "41071990",
    "descricao": "Outros"
  },
  {
    "codigo": "41079110",
    "descricao": "De bovinos (incluindo os búfalos)"
  },
  {
    "codigo": "41079190",
    "descricao": "Outros"
  },
  {
    "codigo": "41079210",
    "descricao": "De bovinos (incluindo os búfalos)"
  },
  {
    "codigo": "41079290",
    "descricao": "Outros"
  },
  {
    "codigo": "41079910",
    "descricao": "De bovinos (incluindo os búfalos)"
  },
  {
    "codigo": "41079990",
    "descricao": "Outros"
  },
  {
    "codigo": "41120000",
    "descricao": "Couros preparados após curtimenta ou após secagem (<i>crusting</i>) e couros e peles apergaminhados, de ovinos, depilados, mesmo divididos, exceto os da posição 41.14."
  },
  {
    "codigo": "41131010",
    "descricao": "Curtidos ao cromo, com acabamento"
  },
  {
    "codigo": "41131090",
    "descricao": "Outros"
  },
  {
    "codigo": "41132000",
    "descricao": "- De suínos"
  },
  {
    "codigo": "41133000",
    "descricao": "- De répteis"
  },
  {
    "codigo": "41139000",
    "descricao": "- Outros"
  },
  {
    "codigo": "41141000",
    "descricao": "- Couros e peles acamurçados (incluindo a camurça combinada)"
  },
  {
    "codigo": "41142010",
    "descricao": "Envernizados ou revestidos"
  },
  {
    "codigo": "41142020",
    "descricao": "Metalizados"
  },
  {
    "codigo": "41151000",
    "descricao": "- Couro reconstituído à base de couro ou de fibras de couro, em chapas, folhas ou tiras, mesmo enroladas"
  },
  {
    "codigo": "41152000",
    "descricao": "- Aparas e outros desperdícios de couros ou de peles preparados ou de couro reconstituído, não utilizáveis para fabricação de obras de couro; serragem, pó e farinha, de couro"
  },
  {
    "codigo": "42010010",
    "descricao": "De couro natural ou reconstituído"
  },
  {
    "codigo": "42010090",
    "descricao": "Outros"
  },
  {
    "codigo": "42021100",
    "descricao": "-- Com a superfície exterior de couro natural ou reconstituído"
  },
  {
    "codigo": "42021210",
    "descricao": "De plástico"
  },
  {
    "codigo": "42021220",
    "descricao": "De matérias têxteis"
  },
  {
    "codigo": "42021900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "42022100",
    "descricao": "-- Com a superfície exterior de couro natural ou reconstituído"
  },
  {
    "codigo": "42022210",
    "descricao": "De folhas de plástico"
  },
  {
    "codigo": "42022220",
    "descricao": "De matérias têxteis"
  },
  {
    "codigo": "42022900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "42023100",
    "descricao": "-- Com a superfície exterior de couro natural ou reconstituído"
  },
  {
    "codigo": "42023200",
    "descricao": "-- Com a superfície exterior de folhas de plástico ou de matérias têxteis"
  },
  {
    "codigo": "42023900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "42029100",
    "descricao": "-- Com a superfície exterior de couro natural ou reconstituído"
  },
  {
    "codigo": "42029200",
    "descricao": "-- Com a superfície exterior de folhas de plástico ou de matérias têxteis"
  },
  {
    "codigo": "42029900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "42031000",
    "descricao": "- Vestuário"
  },
  {
    "codigo": "42032100",
    "descricao": "-- Especialmente concebidas para a prática de esportes"
  },
  {
    "codigo": "42032900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "42033000",
    "descricao": "- Cintos, cinturões e bandoleiras ou talabartes"
  },
  {
    "codigo": "42034000",
    "descricao": "- Outros acessórios de vestuário"
  },
  {
    "codigo": "42050000",
    "descricao": "Outras obras de couro natural ou reconstituído."
  },
  {
    "codigo": "42060000",
    "descricao": "Obras de tripa, de <i>baudruches</i>, de bexiga ou de tendões."
  },
  {
    "codigo": "43011000",
    "descricao": "- De visons, inteiras, mesmo com cabeça, cauda ou patas"
  },
  {
    "codigo": "43013000",
    "descricao": "- De cordeiros denominados astracã, <i>breitschwanz</i>, caracul, <i>persianer</i> ou semelhantes, de cordeiros da Índia, da China, da Mongólia ou do Tibete, inteiras, mesmo com cabeça, cauda ou patas"
  },
  {
    "codigo": "43016000",
    "descricao": "- De raposas, inteiras, mesmo com cabeça, cauda ou patas"
  },
  {
    "codigo": "43018000",
    "descricao": "- De outros animais, inteiras, mesmo com cabeça, cauda ou patas"
  },
  {
    "codigo": "43019000",
    "descricao": "- Cabeças, caudas, patas e outras partes utilizáveis na indústria de peles"
  },
  {
    "codigo": "43021100",
    "descricao": "-- De visons"
  },
  {
    "codigo": "43021910",
    "descricao": "De ovinos"
  },
  {
    "codigo": "43021990",
    "descricao": "Outras"
  },
  {
    "codigo": "43022000",
    "descricao": "- Cabeças, caudas, patas e outras partes, desperdícios e aparas, não reunidos (não montados)"
  },
  {
    "codigo": "43023000",
    "descricao": "- Peles com pelo inteiras e respectivos pedaços e aparas, reunidos (montados)"
  },
  {
    "codigo": "43031000",
    "descricao": "- Vestuário e seus acessórios"
  },
  {
    "codigo": "43039000",
    "descricao": "- Outros"
  },
  {
    "codigo": "43040000",
    "descricao": "Peles com pelo artificiais, e suas obras."
  },
  {
    "codigo": "44011100",
    "descricao": "-- De coníferas"
  },
  {
    "codigo": "44011200",
    "descricao": "-- De não coníferas"
  },
  {
    "codigo": "44012100",
    "descricao": "-- De coníferas"
  },
  {
    "codigo": "44012200",
    "descricao": "-- De não coníferas"
  },
  {
    "codigo": "44013100",
    "descricao": "-- <i>Pellets</i> de madeira"
  },
  {
    "codigo": "44013200",
    "descricao": "-- Briquetes de madeira"
  },
  {
    "codigo": "44013900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "44014100",
    "descricao": "-- Serragem (serradura)"
  },
  {
    "codigo": "44014900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "44021000",
    "descricao": "- De bambu"
  },
  {
    "codigo": "44022000",
    "descricao": "- De cascas ou de caroços"
  },
  {
    "codigo": "44029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "44031100",
    "descricao": "-- De coníferas"
  },
  {
    "codigo": "44031200",
    "descricao": "-- De não coníferas"
  },
  {
    "codigo": "44032100",
    "descricao": "-- De pinheiro (<i>Pinus</i> spp.), cuja menor dimensão da seção transversal é igual ou superior a 15 cm"
  },
  {
    "codigo": "44032200",
    "descricao": "-- De pinheiro (<i>Pinus</i> spp.), outras"
  },
  {
    "codigo": "44032300",
    "descricao": "-- De abeto (<i>Abies</i> spp.) e de espruce (pícea) (<i>Picea</i> spp.), cuja menor dimensão da seção transversal é igual ou superior a 15 cm"
  },
  {
    "codigo": "44032400",
    "descricao": "-- De abeto (<i>Abies</i> spp.) e de espruce (pícea) (<i>Picea</i> spp.), outras"
  },
  {
    "codigo": "44032500",
    "descricao": "-- Outras, cuja menor dimensão da seção transversal é igual ou superior a 15 cm"
  },
  {
    "codigo": "44032600",
    "descricao": "-- Outras"
  },
  {
    "codigo": "44034100",
    "descricao": "-- Dark Red Meranti, Light Red Meranti e Meranti Bakau"
  },
  {
    "codigo": "44034200",
    "descricao": "-- Teca"
  },
  {
    "codigo": "44034900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "44039100",
    "descricao": "-- De carvalho (<i>Quercus</i> spp.)"
  },
  {
    "codigo": "44039300",
    "descricao": "-- De faia (<i>Fagus</i> spp.), cuja menor dimensão da seção transversal é igual ou superior a 15 cm"
  },
  {
    "codigo": "44039400",
    "descricao": "-- De faia (<i>Fagus</i> spp.), outras"
  },
  {
    "codigo": "44039500",
    "descricao": "-- De bétula (vidoeiro) (<i>Betula</i> spp.), cuja menor dimensão da seção transversal é igual ou superior a 15 cm"
  },
  {
    "codigo": "44039600",
    "descricao": "-- De bétula (vidoeiro) (<i>Betula</i> spp.), outras"
  },
  {
    "codigo": "44039700",
    "descricao": "-- De choupo (álamo) (<i>Populus</i> spp.)"
  },
  {
    "codigo": "44039800",
    "descricao": "-- De eucalipto (<i>Eucalyptus</i> spp.)"
  },
  {
    "codigo": "44039900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "44041000",
    "descricao": "- De coníferas"
  },
  {
    "codigo": "44042000",
    "descricao": "- De não coníferas"
  },
  {
    "codigo": "44050000",
    "descricao": "Lã de madeira; farinha de madeira."
  },
  {
    "codigo": "44061100",
    "descricao": "-- De coníferas"
  },
  {
    "codigo": "44061200",
    "descricao": "-- De não coníferas"
  },
  {
    "codigo": "44069100",
    "descricao": "-- De coníferas"
  },
  {
    "codigo": "44069200",
    "descricao": "-- De não coníferas"
  },
  {
    "codigo": "44071100",
    "descricao": "-- De pinheiro (<i>Pinus</i> spp.)"
  },
  {
    "codigo": "44071200",
    "descricao": "-- De abeto (<i>Abies</i> spp.) e de espruce (pícea) (<i>Picea</i> spp.)"
  },
  {
    "codigo": "44071300",
    "descricao": "-- De S-P-F (espruce (pícea) (<i>Picea</i> spp.), pinheiro (<i>Pinus</i> spp.) e abeto (<i>Abies</i> spp.))"
  },
  {
    "codigo": "44071400",
    "descricao": "-- De Hem-fir (tsuga (<i>western hemlock</i>) (<i>Tsuga heterophylla</i>) e abeto (<i>Abies</i> spp.))"
  },
  {
    "codigo": "44071900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "44072100",
    "descricao": "-- Mahogany (Mogno) (<i>Swietenia</i> spp.)"
  },
  {
    "codigo": "44072200",
    "descricao": "-- Virola, Imbuia e Balsa"
  },
  {
    "codigo": "44072300",
    "descricao": "-- Teca"
  },
  {
    "codigo": "44072500",
    "descricao": "-- Dark Red Meranti, Light Red Meranti e Meranti Bakau"
  },
  {
    "codigo": "44072600",
    "descricao": "-- White Lauan, White Meranti, White Seraya, Yellow Meranti e Alan"
  },
  {
    "codigo": "44072700",
    "descricao": "-- Sapelli"
  },
  {
    "codigo": "44072800",
    "descricao": "-- Iroko"
  },
  {
    "codigo": "44072910",
    "descricao": "De cedro"
  },
  {
    "codigo": "44072920",
    "descricao": "De ipê"
  },
  {
    "codigo": "44072930",
    "descricao": "De pau-marfim"
  },
  {
    "codigo": "44072940",
    "descricao": "De louro"
  },
  {
    "codigo": "44072950",
    "descricao": "De canafístula (<i>Peltophorum vogelianum</i>)"
  },
  {
    "codigo": "44072960",
    "descricao": "De cabreúva Parda (<i>Myrocarpus</i> spp.)"
  },
  {
    "codigo": "44072970",
    "descricao": "De urundei (<i>Astronium balansae</i>)"
  },
  {
    "codigo": "44072990",
    "descricao": "Outras"
  },
  {
    "codigo": "44079100",
    "descricao": "-- De carvalho (<i>Quercus</i> spp.)"
  },
  {
    "codigo": "44079200",
    "descricao": "-- De faia (<i>Fagus</i> spp.)"
  },
  {
    "codigo": "44079300",
    "descricao": "-- De bordo (ácer) (<i>Acer</i> spp.)"
  },
  {
    "codigo": "44079400",
    "descricao": "-- De prunóidea (<i>Prunus</i> spp.)"
  },
  {
    "codigo": "44079500",
    "descricao": "-- De freixo (<i>Fraxinus</i> spp.)"
  },
  {
    "codigo": "44079600",
    "descricao": "-- De bétula (vidoeiro) (<i>Betula</i> spp.)"
  },
  {
    "codigo": "44079700",
    "descricao": "-- De choupo (álamo) (<i>Populus</i> spp.)"
  },
  {
    "codigo": "44079920",
    "descricao": "De peroba (<i>Paratecoma peroba</i>)"
  },
  {
    "codigo": "44079930",
    "descricao": "De guaiuvira (<i>Patagonula americana</i>)"
  },
  {
    "codigo": "44079960",
    "descricao": "De amendoim (<i>Pterogyne nitens</i>)"
  },
  {
    "codigo": "44079970",
    "descricao": "De angico preto (<i>Piptadenia macrocarpa</i>)"
  },
  {
    "codigo": "44079990",
    "descricao": "Outras"
  },
  {
    "codigo": "44081010",
    "descricao": "Obtidas por corte de madeira estratificada"
  },
  {
    "codigo": "44081091",
    "descricao": "De pinho brasil (<i>Araucaria angustifolia</i>)"
  },
  {
    "codigo": "44081099",
    "descricao": "Outras"
  },
  {
    "codigo": "44083110",
    "descricao": "Obtidas por corte de madeira estratificada"
  },
  {
    "codigo": "44083190",
    "descricao": "Outras"
  },
  {
    "codigo": "44083910",
    "descricao": "Obtidas por corte de madeira estratificada"
  },
  {
    "codigo": "44083991",
    "descricao": "De cedro"
  },
  {
    "codigo": "44083992",
    "descricao": "De pau-marfim"
  },
  {
    "codigo": "44083999",
    "descricao": "Outras"
  },
  {
    "codigo": "44089010",
    "descricao": "Obtidas por corte de madeira estratificada"
  },
  {
    "codigo": "44089090",
    "descricao": "Outras"
  },
  {
    "codigo": "44091000",
    "descricao": "- De coníferas"
  },
  {
    "codigo": "44092100",
    "descricao": "-- De bambu"
  },
  {
    "codigo": "44092200",
    "descricao": "-- De madeiras tropicais"
  },
  {
    "codigo": "44092900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "44101110",
    "descricao": "Em bruto ou simplesmente polidos"
  },
  {
    "codigo": "44101121",
    "descricao": "Em ambas as faces, com película protetora na face superior e trabalho de encaixe nas quatro laterais, do tipo utilizado para pisos (pavimentos)"
  },
  {
    "codigo": "44101129",
    "descricao": "Outros"
  },
  {
    "codigo": "44101190",
    "descricao": "Outros"
  },
  {
    "codigo": "44101210",
    "descricao": "Em bruto ou simplesmente polidos"
  },
  {
    "codigo": "44101290",
    "descricao": "Outros"
  },
  {
    "codigo": "44101911",
    "descricao": "Em bruto ou simplesmente polidos"
  },
  {
    "codigo": "44101919",
    "descricao": "Outros"
  },
  {
    "codigo": "44101991",
    "descricao": "Em bruto ou simplesmente polidos"
  },
  {
    "codigo": "44101992",
    "descricao": "Recobertos na superfície com papel impregnado de melamina"
  },
  {
    "codigo": "44101999",
    "descricao": "Outros"
  },
  {
    "codigo": "44109000",
    "descricao": "- Outros"
  },
  {
    "codigo": "44111210",
    "descricao": "Não trabalhados mecanicamente nem recobertos à superfície"
  },
  {
    "codigo": "44111290",
    "descricao": "Outros"
  },
  {
    "codigo": "44111310",
    "descricao": "Não trabalhados mecanicamente nem recobertos à superfície"
  },
  {
    "codigo": "44111391",
    "descricao": "Recobertos em ambas as faces com papel impregnado de melamina, película protetora na face superior e trabalho de encaixe nas quatro laterais, do tipo utilizado para pisos (pavimentos)"
  },
  {
    "codigo": "44111399",
    "descricao": "Outros"
  },
  {
    "codigo": "44111410",
    "descricao": "Não trabalhados mecanicamente nem recobertos à superfície"
  },
  {
    "codigo": "44111490",
    "descricao": "Outros"
  },
  {
    "codigo": "44119210",
    "descricao": "Não trabalhados mecanicamente nem recobertos à superfície"
  },
  {
    "codigo": "44119290",
    "descricao": "Outros"
  },
  {
    "codigo": "44119310",
    "descricao": "Não trabalhados mecanicamente nem recobertos à superfície"
  },
  {
    "codigo": "44119390",
    "descricao": "Outros"
  },
  {
    "codigo": "44119410",
    "descricao": "Não trabalhados mecanicamente nem recobertos à superfície"
  },
  {
    "codigo": "44119490",
    "descricao": "Outros"
  },
  {
    "codigo": "44121000",
    "descricao": "- De bambu"
  },
  {
    "codigo": "44123100",
    "descricao": "-- Com, pelo menos, uma camada exterior de madeira tropical"
  },
  {
    "codigo": "44123300",
    "descricao": "-- Outras, com, pelo menos, uma camada exterior de madeira não conífera, das espécies amieiro (<i>Alnus</i> spp.), freixo (<i>Fraxinus</i> spp.), faia (<i>Fagus</i> spp.), bétula (vidoeiro) (<i>Betula</i> spp.), prunóidea (<i>Prunus</i> spp.), castanheiro (<i>Castanea</i> spp.), olmo (<i>Ulmus</i> spp.), eucalipto (<i>Eucalyptus</i> spp.), nogueira (<i>Carya</i> spp.), castanheiro-da-índia (<i>Aesculus</i> spp.), tília (<i>Tilia</i> spp.), bordo (ácer) (<i>Acer</i> spp.), carvalho (<i>Quercus</i> spp.), plátano (<i>Platanus</i> spp.), choupo (álamo) (<i>Populus</i> spp.), robínia (falsa-acácia) (<i>Robinia</i> spp.), tulipeiro (<i>Liriodendron</i> spp.) ou nogueira (<i>Juglans</i> spp.)"
  },
  {
    "codigo": "44123400",
    "descricao": "-- Outras, com, pelo menos, uma camada exterior de madeira não conífera, não especificadas na subposição 4412.33"
  },
  {
    "codigo": "44123900",
    "descricao": "-- Outras, com ambas as camadas exteriores de madeira de coníferas"
  },
  {
    "codigo": "44124100",
    "descricao": "-- Com, pelo menos, uma camada exterior de madeira tropical"
  },
  {
    "codigo": "44124200",
    "descricao": "-- Outras, com, pelo menos, uma camada exterior de madeira não conífera"
  },
  {
    "codigo": "44124900",
    "descricao": "-- Outras, com ambas as camadas exteriores de madeira de coníferas"
  },
  {
    "codigo": "44125100",
    "descricao": "-- Com, pelo menos, uma camada exterior de madeira tropical"
  },
  {
    "codigo": "44125200",
    "descricao": "-- Outras, com, pelo menos, uma camada exterior de madeira não conífera"
  },
  {
    "codigo": "44125900",
    "descricao": "-- Outras, com ambas as camadas exteriores de madeira de coníferas"
  },
  {
    "codigo": "44129100",
    "descricao": "-- Com, pelo menos, uma camada exterior de madeira tropical"
  },
  {
    "codigo": "44129200",
    "descricao": "-- Outras, com, pelo menos, uma camada exterior de madeira não conífera"
  },
  {
    "codigo": "44129900",
    "descricao": "-- Outras, com ambas as camadas exteriores de madeira de coníferas"
  },
  {
    "codigo": "44130000",
    "descricao": "Madeira densificada, em blocos, pranchas, lâminas ou perfis."
  },
  {
    "codigo": "44141000",
    "descricao": "- De madeira tropical"
  },
  {
    "codigo": "44149000",
    "descricao": "- Outras"
  },
  {
    "codigo": "44151000",
    "descricao": "- Caixotes, caixas, engradados, barricas e embalagens semelhantes; carretéis para cabos"
  },
  {
    "codigo": "44152000",
    "descricao": "- Paletes simples, paletes-caixas e outros estrados para carga; taipais de paletes"
  },
  {
    "codigo": "44160010",
    "descricao": "De carvalho (<i>Quercus</i> spp.)"
  },
  {
    "codigo": "44160090",
    "descricao": "Outros"
  },
  {
    "codigo": "44170010",
    "descricao": "Ferramentas"
  },
  {
    "codigo": "44170020",
    "descricao": "Formas, alargadeiras e esticadores, para calçado"
  },
  {
    "codigo": "44170090",
    "descricao": "Outros"
  },
  {
    "codigo": "44181100",
    "descricao": "-- De madeira tropical"
  },
  {
    "codigo": "44181900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "44182100",
    "descricao": "-- De madeira tropical"
  },
  {
    "codigo": "44182900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "44183000",
    "descricao": "- Postes e vigas, exceto os produtos das subposições 4418.81 a 4418.89"
  },
  {
    "codigo": "44184000",
    "descricao": "- Cofragens para concreto (betão)"
  },
  {
    "codigo": "44185000",
    "descricao": "- Fasquias para telhados (<i>shingles</i> e <i>shakes</i>)"
  },
  {
    "codigo": "44187300",
    "descricao": "-- De bambu ou com, pelo menos, a camada superior de bambu"
  },
  {
    "codigo": "44187400",
    "descricao": "-- Outros, para pisos (pavimentos) em mosaico"
  },
  {
    "codigo": "44187500",
    "descricao": "-- Outros, de camadas múltiplas"
  },
  {
    "codigo": "44187900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "44188100",
    "descricao": "-- Madeira laminada (lamelada) colada (glulam ou MLC)"
  },
  {
    "codigo": "44188200",
    "descricao": "-- Madeira laminada (lamelada) cruzada (CLT ou X-lam)"
  },
  {
    "codigo": "44188300",
    "descricao": "-- Vigas em I"
  },
  {
    "codigo": "44188900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "44189100",
    "descricao": "-- De bambu"
  },
  {
    "codigo": "44189200",
    "descricao": "-- Painéis celulares de madeira"
  },
  {
    "codigo": "44189900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "44191100",
    "descricao": "-- Tábuas para cortar pão, outras tábuas para cortar e artigos semelhantes"
  },
  {
    "codigo": "44191200",
    "descricao": "-- Pauzinhos (hashi ou fachi)"
  },
  {
    "codigo": "44191900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "44192000",
    "descricao": "- De madeira tropical"
  },
  {
    "codigo": "44199000",
    "descricao": "- Outros"
  },
  {
    "codigo": "44201100",
    "descricao": "-- De madeira tropical"
  },
  {
    "codigo": "44201900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "44209000",
    "descricao": "- Outros"
  },
  {
    "codigo": "44211000",
    "descricao": "- Cabides para vestuário"
  },
  {
    "codigo": "44212000",
    "descricao": "- Urnas funerárias (caixões)"
  },
  {
    "codigo": "44219100",
    "descricao": "-- De bambu"
  },
  {
    "codigo": "44219900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "45011000",
    "descricao": "- Cortiça natural, em bruto ou simplesmente preparada"
  },
  {
    "codigo": "45019000",
    "descricao": "- Outros"
  },
  {
    "codigo": "45020000",
    "descricao": "Cortiça natural, sem a crosta ou simplesmente esquadriada, ou em cubos, chapas, folhas ou tiras, de forma quadrada ou retangular (incluindo os esboços com arestas vivas, para rolhas)."
  },
  {
    "codigo": "45031000",
    "descricao": "- Rolhas"
  },
  {
    "codigo": "45039000",
    "descricao": "- Outras"
  },
  {
    "codigo": "45041000",
    "descricao": "- Cubos, blocos, chapas, folhas e tiras; ladrilhos de qualquer formato; cilindros maciços, incluindo os discos"
  },
  {
    "codigo": "45049000",
    "descricao": "- Outras"
  },
  {
    "codigo": "46012100",
    "descricao": "-- De bambu"
  },
  {
    "codigo": "46012200",
    "descricao": "-- De rotim"
  },
  {
    "codigo": "46012900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "46019200",
    "descricao": "-- De bambu"
  },
  {
    "codigo": "46019300",
    "descricao": "-- De rotim"
  },
  {
    "codigo": "46019400",
    "descricao": "-- De outras matérias vegetais"
  },
  {
    "codigo": "46019900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "46021100",
    "descricao": "-- De bambu"
  },
  {
    "codigo": "46021200",
    "descricao": "-- De rotim"
  },
  {
    "codigo": "46021900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "46029000",
    "descricao": "- Outras"
  },
  {
    "codigo": "47010000",
    "descricao": "Pastas mecânicas de madeira."
  },
  {
    "codigo": "47020000",
    "descricao": "Pastas químicas de madeira, para dissolução."
  },
  {
    "codigo": "47031100",
    "descricao": "-- De coníferas"
  },
  {
    "codigo": "47031900",
    "descricao": "-- De não coníferas"
  },
  {
    "codigo": "47032110",
    "descricao": "Em rolos"
  },
  {
    "codigo": "47032190",
    "descricao": "Outras"
  },
  {
    "codigo": "47032900",
    "descricao": "-- De não coníferas"
  },
  {
    "codigo": "47041100",
    "descricao": "-- De coníferas"
  },
  {
    "codigo": "47041900",
    "descricao": "-- De não coníferas"
  },
  {
    "codigo": "47042100",
    "descricao": "-- De coníferas"
  },
  {
    "codigo": "47042900",
    "descricao": "-- De não coníferas"
  },
  {
    "codigo": "47050000",
    "descricao": "Pastas de madeira obtidas por combinação de um tratamento mecânico com um tratamento químico."
  },
  {
    "codigo": "47061000",
    "descricao": "- Pastas de línteres de algodão"
  },
  {
    "codigo": "47062000",
    "descricao": "- Pastas de fibras obtidas a partir de papel ou cartão reciclados (desperdícios e resíduos)"
  },
  {
    "codigo": "47063000",
    "descricao": "- Outras, de bambu"
  },
  {
    "codigo": "47069100",
    "descricao": "-- Mecânicas"
  },
  {
    "codigo": "47069200",
    "descricao": "-- Químicas"
  },
  {
    "codigo": "47069300",
    "descricao": "-- Obtidas por combinação de um tratamento mecânico com um tratamento químico"
  },
  {
    "codigo": "47071000",
    "descricao": "- Papel ou cartão, <i>Kraft</i>, crus, ou papel ou cartão, ondulados (canelados*)"
  },
  {
    "codigo": "47072000",
    "descricao": "- Outro papel ou cartão, obtidos principalmente a partir de pasta química branqueada, não corada na massa"
  },
  {
    "codigo": "47073000",
    "descricao": "- Papel ou cartão, obtidos principalmente a partir de pasta mecânica (por exemplo, jornais, periódicos e impressos semelhantes)"
  },
  {
    "codigo": "47079000",
    "descricao": "- Outros, incluindo os desperdícios e resíduos não selecionados"
  },
  {
    "codigo": "48010020",
    "descricao": "Em folhas, nas que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48010030",
    "descricao": "Outros, de peso inferior ou igual a 57 g/m<sup>2</sup>, em que 65 % ou mais, em peso, do conteúdo total de fibras seja constituído por fibras de madeiras obtidas por processo mecânico"
  },
  {
    "codigo": "48010090",
    "descricao": "Outros"
  },
  {
    "codigo": "48021000",
    "descricao": "- Papel e cartão feitos à mão (folha a folha)"
  },
  {
    "codigo": "48022010",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48022090",
    "descricao": "Outros"
  },
  {
    "codigo": "48024010",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm"
  },
  {
    "codigo": "48024090",
    "descricao": "Outros"
  },
  {
    "codigo": "48025410",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48025491",
    "descricao": "Fabricado principalmente a partir de pasta branqueada ou pasta obtida por um processo mecânico, de peso inferior a 19 g/m<sup>2</sup>"
  },
  {
    "codigo": "48025499",
    "descricao": "Outros"
  },
  {
    "codigo": "48025510",
    "descricao": "De largura não superior a 15 cm"
  },
  {
    "codigo": "48025591",
    "descricao": "De desenho"
  },
  {
    "codigo": "48025592",
    "descricao": "<i>Kraft</i>"
  },
  {
    "codigo": "48025599",
    "descricao": "Outros"
  },
  {
    "codigo": "48025610",
    "descricao": "Em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48025691",
    "descricao": "Para impressão de notas (papéis-moeda)"
  },
  {
    "codigo": "48025692",
    "descricao": "De desenho"
  },
  {
    "codigo": "48025693",
    "descricao": "<i>Kraft</i>"
  },
  {
    "codigo": "48025699",
    "descricao": "Outros"
  },
  {
    "codigo": "48025710",
    "descricao": "Em tiras de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48025791",
    "descricao": "Para impressão de notas (papéis-moeda)"
  },
  {
    "codigo": "48025792",
    "descricao": "De desenho"
  },
  {
    "codigo": "48025793",
    "descricao": "<i>Kraft</i>"
  },
  {
    "codigo": "48025799",
    "descricao": "Outros"
  },
  {
    "codigo": "48025810",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48025891",
    "descricao": "De desenho"
  },
  {
    "codigo": "48025892",
    "descricao": "<i>Kraft</i>"
  },
  {
    "codigo": "48025899",
    "descricao": "Outros"
  },
  {
    "codigo": "48026110",
    "descricao": "De largura não superior a 15 cm"
  },
  {
    "codigo": "48026191",
    "descricao": "De peso inferior ou igual a 57 g/m<sup>2</sup>, em que 65 % ou mais, em peso, do conteúdo total de fibras seja constituído por fibras de madeira obtidas por processo mecânico"
  },
  {
    "codigo": "48026192",
    "descricao": "<i>Kraft</i>"
  },
  {
    "codigo": "48026199",
    "descricao": "Outros"
  },
  {
    "codigo": "48026210",
    "descricao": "Em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48026291",
    "descricao": "De peso inferior ou igual a 57 g/m<sup>2</sup>, em que 65 % ou mais, em peso, do conteúdo total de fibras seja constituído por fibras de madeira obtidas por processo mecânico"
  },
  {
    "codigo": "48026292",
    "descricao": "<i>Kraft</i>"
  },
  {
    "codigo": "48026299",
    "descricao": "Outros"
  },
  {
    "codigo": "48026910",
    "descricao": "Em tiras de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48026991",
    "descricao": "De peso inferior ou igual a 57 g/m<sup>2</sup>, em que 65 % ou mais, em peso, do conteúdo total de fibras seja constituído por fibras de madeira obtidas por processo mecânico"
  },
  {
    "codigo": "48026992",
    "descricao": "<i>Kraft</i>"
  },
  {
    "codigo": "48026999",
    "descricao": "Outros"
  },
  {
    "codigo": "48030010",
    "descricao": "Pasta (<i>ouate</i>) de celulose e mantas de fibras de celulose"
  },
  {
    "codigo": "48030090",
    "descricao": "Outros"
  },
  {
    "codigo": "48041100",
    "descricao": "-- Crus"
  },
  {
    "codigo": "48041900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "48042100",
    "descricao": "-- Crus"
  },
  {
    "codigo": "48042900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "48043110",
    "descricao": "De rigidez dielétrica igual ou superior a 600 V (método ASTM D 202 ou equivalente)"
  },
  {
    "codigo": "48043190",
    "descricao": "Outros"
  },
  {
    "codigo": "48043910",
    "descricao": "De rigidez dielétrica igual ou superior a 600 V (método ASTM D 202 ou equivalente)"
  },
  {
    "codigo": "48043990",
    "descricao": "Outros"
  },
  {
    "codigo": "48044100",
    "descricao": "-- Crus"
  },
  {
    "codigo": "48044200",
    "descricao": "-- Branqueados uniformemente na massa e em que mais de 95 %, em peso, do conteúdo total de fibras seja constituído por fibras de madeira obtidas por processo químico"
  },
  {
    "codigo": "48044900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "48045100",
    "descricao": "-- Crus"
  },
  {
    "codigo": "48045200",
    "descricao": "-- Branqueados uniformemente na massa e em que mais de 95 %, em peso, do conteúdo total de fibras seja constituído por fibras de madeira obtidas por processo químico"
  },
  {
    "codigo": "48045910",
    "descricao": "Semibranqueados, com um conteúdo de 100 %, em peso, de fibras de madeira obtidas por processo químico"
  },
  {
    "codigo": "48045990",
    "descricao": "Outros"
  },
  {
    "codigo": "48051100",
    "descricao": "-- Papel semiquímico para ondular (canelar*)"
  },
  {
    "codigo": "48051200",
    "descricao": "-- Papel palha para ondular (canelar*)"
  },
  {
    "codigo": "48051900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "48052400",
    "descricao": "-- De peso não superior a 150 g/m<sup>2</sup>"
  },
  {
    "codigo": "48052500",
    "descricao": "-- De peso superior a 150 g/m<sup>2</sup>"
  },
  {
    "codigo": "48053000",
    "descricao": "- Papel sulfite de embalagem"
  },
  {
    "codigo": "48054010",
    "descricao": "De peso superior a 15 g/m<sup>2</sup>, mas não superior a 25 g/m<sup>2</sup>, com um conteúdo de fibras sintéticas termossoldáveis igual ou superior a 20 %, mas não superior a 30 %, em peso, do conteúdo total de fibras"
  },
  {
    "codigo": "48054090",
    "descricao": "Outros"
  },
  {
    "codigo": "48055000",
    "descricao": "- Papel-feltro e cartão-feltro, papel e cartão lanosos"
  },
  {
    "codigo": "48059100",
    "descricao": "-- De peso não superior a 150 g/m<sup>2</sup>"
  },
  {
    "codigo": "48059210",
    "descricao": "Com fibras de vidro"
  },
  {
    "codigo": "48059290",
    "descricao": "Outros"
  },
  {
    "codigo": "48059300",
    "descricao": "-- De peso igual ou superior a 225 g/m<sup>2</sup>"
  },
  {
    "codigo": "48061000",
    "descricao": "- Papel-pergaminho e cartão-pergaminho (sulfurizados)"
  },
  {
    "codigo": "48062000",
    "descricao": "- Papel impermeável a gorduras"
  },
  {
    "codigo": "48063000",
    "descricao": "- Papel vegetal"
  },
  {
    "codigo": "48064000",
    "descricao": "- Papel cristal e outro papel calandrado transparente ou translúcido"
  },
  {
    "codigo": "48070000",
    "descricao": "Papel e cartão obtidos por colagem de folhas sobrepostas, não revestidos na superfície nem impregnados, mesmo reforçados interiormente, em rolos ou em folhas."
  },
  {
    "codigo": "48081000",
    "descricao": "- Papel e cartão ondulados (canelados*), mesmo perfurados"
  },
  {
    "codigo": "48084000",
    "descricao": "- Papel <i>Kraft</i>, encrespado ou plissado, mesmo gofrado, estampado ou perfurado"
  },
  {
    "codigo": "48089000",
    "descricao": "- Outros"
  },
  {
    "codigo": "48092000",
    "descricao": "- Papel autocopiativo"
  },
  {
    "codigo": "48099000",
    "descricao": "- Outros"
  },
  {
    "codigo": "48101310",
    "descricao": "De largura não superior a 15 cm"
  },
  {
    "codigo": "48101381",
    "descricao": "Metalizados"
  },
  {
    "codigo": "48101382",
    "descricao": "Baritados (revestidos de óxido ou sulfato de bário)"
  },
  {
    "codigo": "48101389",
    "descricao": "Outros"
  },
  {
    "codigo": "48101391",
    "descricao": "Papel revestido ou recoberto em uma face, do tipo <i>wet strength</i>, resistente à umidade e ao meio alcalino"
  },
  {
    "codigo": "48101399",
    "descricao": "Outros"
  },
  {
    "codigo": "48101410",
    "descricao": "Em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48101481",
    "descricao": "Metalizados"
  },
  {
    "codigo": "48101482",
    "descricao": "Baritados (revestidos de óxido ou sulfato de bário)"
  },
  {
    "codigo": "48101489",
    "descricao": "Outros"
  },
  {
    "codigo": "48101490",
    "descricao": "Outros"
  },
  {
    "codigo": "48101910",
    "descricao": "Em tiras de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48101981",
    "descricao": "Metalizados"
  },
  {
    "codigo": "48101982",
    "descricao": "Baritados (revestidos de óxido ou sulfato de bário)"
  },
  {
    "codigo": "48101989",
    "descricao": "Outros"
  },
  {
    "codigo": "48101991",
    "descricao": "Papel revestido ou recoberto em uma face, do tipo <i>wet strength</i>, resistente à umidade e ao meio alcalino"
  },
  {
    "codigo": "48101999",
    "descricao": "Outros"
  },
  {
    "codigo": "48102210",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48102290",
    "descricao": "Outros"
  },
  {
    "codigo": "48102910",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48102990",
    "descricao": "Outros"
  },
  {
    "codigo": "48103110",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48103190",
    "descricao": "Outros"
  },
  {
    "codigo": "48103210",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48103290",
    "descricao": "Outros"
  },
  {
    "codigo": "48103910",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48103990",
    "descricao": "Outros"
  },
  {
    "codigo": "48109210",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48109290",
    "descricao": "Outros"
  },
  {
    "codigo": "48109910",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48109990",
    "descricao": "Outros"
  },
  {
    "codigo": "48111010",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48111090",
    "descricao": "Outros"
  },
  {
    "codigo": "48114110",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48114190",
    "descricao": "Outros"
  },
  {
    "codigo": "48114910",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48114990",
    "descricao": "Outros"
  },
  {
    "codigo": "48115110",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48115121",
    "descricao": "De silicone, exceto gofrados na face recoberta ou revestida"
  },
  {
    "codigo": "48115122",
    "descricao": "De polietileno, estratificado com alumínio, impresso"
  },
  {
    "codigo": "48115123",
    "descricao": "De polietileno ou polipropileno, em ambas as faces, base para papel fotográfico"
  },
  {
    "codigo": "48115128",
    "descricao": "Outros, gofrados na face recoberta ou revestida"
  },
  {
    "codigo": "48115129",
    "descricao": "Outros"
  },
  {
    "codigo": "48115130",
    "descricao": "Outros, impregnados"
  },
  {
    "codigo": "48115910",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48115921",
    "descricao": "De polietileno ou polipropileno, em ambas as faces, base para papel fotográfico"
  },
  {
    "codigo": "48115922",
    "descricao": "De silicone"
  },
  {
    "codigo": "48115923",
    "descricao": "De polietileno, estratificado com alumínio, impresso"
  },
  {
    "codigo": "48115929",
    "descricao": "Outros"
  },
  {
    "codigo": "48115930",
    "descricao": "Outros, impregnados"
  },
  {
    "codigo": "48116010",
    "descricao": "Em tiras ou rolos de largura não superior a 15 cm ou em folhas em que nenhum lado exceda 360 mm, quando não dobradas"
  },
  {
    "codigo": "48116090",
    "descricao": "Outros"
  },
  {
    "codigo": "48119011",
    "descricao": "Recobertos de pasta eletrolítica à base de amido modificado, de peso igual ou superior a 75 g/m<sup>2</sup>, mas não superior a 120 g/m<sup>2</sup>"
  },
  {
    "codigo": "48119019",
    "descricao": "Outros"
  },
  {
    "codigo": "48119020",
    "descricao": "Outros, impregnados e revestidos em ambas as faces com látex numa proporção total, em peso, igual ou superior a 15 %, de peso igual ou superior a 105 g/m<sup>2</sup>, mas não superior a 135 g/m<sup>2</sup>, do tipo utilizado como suporte para fabricação de abrasivos (lixas), em rolos"
  },
  {
    "codigo": "48119090",
    "descricao": "Outros"
  },
  {
    "codigo": "48120000",
    "descricao": "Blocos e chapas, filtrantes, de pasta de papel."
  },
  {
    "codigo": "48131000",
    "descricao": "- Em cadernos ou em tubos"
  },
  {
    "codigo": "48132000",
    "descricao": "- Em rolos de largura não superior a 5 cm"
  },
  {
    "codigo": "48139000",
    "descricao": "- Outros"
  },
  {
    "codigo": "48142000",
    "descricao": "- Papel de parede e revestimentos para parede semelhantes, constituídos por papel revestido ou recoberto, no lado da face, por uma camada de plástico granida, gofrada, colorida, impressa com desenhos ou decorada de qualquer outra forma"
  },
  {
    "codigo": "48149000",
    "descricao": "- Outros"
  },
  {
    "codigo": "48162000",
    "descricao": "- Papel autocopiativo"
  },
  {
    "codigo": "48169010",
    "descricao": "Papel-carbono e semelhantes"
  },
  {
    "codigo": "48169090",
    "descricao": "Outros"
  },
  {
    "codigo": "48171000",
    "descricao": "- Envelopes"
  },
  {
    "codigo": "48172000",
    "descricao": "- Aerogramas, cartões-postais não ilustrados e cartões para correspondência"
  },
  {
    "codigo": "48173000",
    "descricao": "- Caixas, sacos e semelhantes, de papel ou cartão, que contenham um sortido de artigos para correspondência"
  },
  {
    "codigo": "48181000",
    "descricao": "- Papel higiênico"
  },
  {
    "codigo": "48182000",
    "descricao": "- Lenços, lenços (toalhitas) demaquilantes e toalhas de mão"
  },
  {
    "codigo": "48183000",
    "descricao": "- Toalhas de mesa e guardanapos"
  },
  {
    "codigo": "48185000",
    "descricao": "- Vestuário e seus acessórios"
  },
  {
    "codigo": "48189010",
    "descricao": "Almofadas absorventes do tipo utilizado em embalagens de produtos alimentícios"
  },
  {
    "codigo": "48189090",
    "descricao": "Outros"
  },
  {
    "codigo": "48191000",
    "descricao": "- Caixas de papel ou cartão, ondulados (canelados*)"
  },
  {
    "codigo": "48192000",
    "descricao": "- Caixas e cartonagens, dobráveis, de papel ou cartão, não ondulados (canelados*)"
  },
  {
    "codigo": "48193000",
    "descricao": "- Sacos cuja base tenha largura igual ou superior a 40 cm"
  },
  {
    "codigo": "48194000",
    "descricao": "- Outros sacos; bolsas e cartuchos"
  },
  {
    "codigo": "48195000",
    "descricao": "- Outras embalagens, incluindo as capas para discos"
  },
  {
    "codigo": "48196000",
    "descricao": "- Cartonagens para escritórios, lojas e estabelecimentos semelhantes"
  },
  {
    "codigo": "48201000",
    "descricao": "- Livros de registro e de contabilidade, blocos de notas, de encomendas, de recibos, de apontamentos, de papel para cartas, agendas e artigos semelhantes"
  },
  {
    "codigo": "48202000",
    "descricao": "- Cadernos"
  },
  {
    "codigo": "48203000",
    "descricao": "- Classificadores, encadernações (exceto as capas para livros) e capas de processos"
  },
  {
    "codigo": "48204000",
    "descricao": "- Formulários em blocos de papel múltiplas vias, mesmo com folhas intercaladas de papel-carbono (papel químico)"
  },
  {
    "codigo": "48205000",
    "descricao": "- Álbuns para amostras ou para coleções"
  },
  {
    "codigo": "48209000",
    "descricao": "- Outros"
  },
  {
    "codigo": "48211000",
    "descricao": "- Impressas"
  },
  {
    "codigo": "48219000",
    "descricao": "- Outras"
  },
  {
    "codigo": "48221000",
    "descricao": "- Do tipo utilizado para enrolamento de fios têxteis"
  },
  {
    "codigo": "48229000",
    "descricao": "- Outros"
  },
  {
    "codigo": "48232010",
    "descricao": "De peso superior a 15 g/m<sup>2</sup>, mas não superior a 25 g/m<sup>2</sup>, com um conteúdo de fibras sintéticas termossoldáveis igual ou superior a 20 %, mas não superior a 30 %, em peso, do conteúdo total de fibras"
  },
  {
    "codigo": "48232091",
    "descricao": "Em tiras ou rolos de largura superior a 15 cm, mas não superior a 36 cm"
  },
  {
    "codigo": "48232099",
    "descricao": "Outros"
  },
  {
    "codigo": "48234000",
    "descricao": "- Papel-diagrama para aparelhos registradores, em bobinas, em folhas ou em discos"
  },
  {
    "codigo": "48236100",
    "descricao": "-- De bambu"
  },
  {
    "codigo": "48236900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "48237000",
    "descricao": "- Artigos moldados ou prensados, de pasta de papel"
  },
  {
    "codigo": "48239010",
    "descricao": "Cartões perfurados para mecanismos Jacquard"
  },
  {
    "codigo": "48239020",
    "descricao": "De rigidez dielétrica igual ou superior a 600 V (método ASTM D 202 ou equivalente) e de peso inferior ou igual a 60 g/m<sup>2</sup>"
  },
  {
    "codigo": "48239091",
    "descricao": "Em tiras ou rolos de largura superior a 15 cm, mas não superior a 36 cm"
  },
  {
    "codigo": "48239099",
    "descricao": "Outros"
  },
  {
    "codigo": "49011000",
    "descricao": "- Em folhas soltas, mesmo dobradas"
  },
  {
    "codigo": "49019100",
    "descricao": "-- Dicionários e enciclopédias, mesmo em fascículos"
  },
  {
    "codigo": "49019900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "49021000",
    "descricao": "- Que se publiquem pelo menos quatro vezes por semana"
  },
  {
    "codigo": "49029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "49030000",
    "descricao": "Álbuns ou livros de ilustrações e álbuns para desenhar ou colorir, para crianças."
  },
  {
    "codigo": "49040000",
    "descricao": "Música manuscrita ou impressa, ilustrada ou não, mesmo encadernada."
  },
  {
    "codigo": "49052000",
    "descricao": "- Sob a forma de livros ou brochuras"
  },
  {
    "codigo": "49059000",
    "descricao": "- Outras"
  },
  {
    "codigo": "49060000",
    "descricao": "Planos, plantas e desenhos, de arquitetura, de engenharia e outros planos e desenhos industriais, comerciais, topográficos ou semelhantes, originais, feitos à mão; textos manuscritos; reproduções fotográficas em papel sensibilizado e cópias a papel-carbono (papel químico) dos planos, plantas, desenhos ou textos acima referidos."
  },
  {
    "codigo": "49070010",
    "descricao": "Notas (papéis-moeda)"
  },
  {
    "codigo": "49070020",
    "descricao": "Cheques de viagem"
  },
  {
    "codigo": "49070030",
    "descricao": "Títulos de ações ou de obrigações e títulos semelhantes, convalidados e firmados"
  },
  {
    "codigo": "49070090",
    "descricao": "Outros"
  },
  {
    "codigo": "49081000",
    "descricao": "- Decalcomanias vitrificáveis"
  },
  {
    "codigo": "49089000",
    "descricao": "- Outras"
  },
  {
    "codigo": "49090000",
    "descricao": "Cartões-postais impressos ou ilustrados; cartões impressos com votos ou mensagens pessoais, mesmo ilustrados, mesmo com envelopes, guarnições ou aplicações."
  },
  {
    "codigo": "49100000",
    "descricao": "Calendários de qualquer espécie, impressos, incluindo os blocos-calendários para desfolhar."
  },
  {
    "codigo": "49111010",
    "descricao": "Que contenham informações relativas ao funcionamento, manutenção, reparo ou utilização de máquinas, aparelhos, veículos e outras mercadorias de origem extrazona"
  },
  {
    "codigo": "49111090",
    "descricao": "Outros"
  },
  {
    "codigo": "49119100",
    "descricao": "-- Estampas, gravuras e fotografias"
  },
  {
    "codigo": "49119900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "50010000",
    "descricao": "Casulos de bicho-da-seda próprios para dobar."
  },
  {
    "codigo": "50020000",
    "descricao": "Seda crua (não fiada)."
  },
  {
    "codigo": "50030010",
    "descricao": "Não cardados nem penteados"
  },
  {
    "codigo": "50030090",
    "descricao": "Outros"
  },
  {
    "codigo": "50040000",
    "descricao": "Fios de seda (exceto fios de desperdícios de seda) não acondicionados para venda a retalho."
  },
  {
    "codigo": "50050000",
    "descricao": "Fios de desperdícios de seda, não acondicionados para venda a retalho."
  },
  {
    "codigo": "50060000",
    "descricao": "Fios de seda ou de desperdícios de seda, acondicionados para venda a retalho; pelo de Messina (crina de Florença)."
  },
  {
    "codigo": "50071010",
    "descricao": "Estampados, tintos ou de fios de diversas cores"
  },
  {
    "codigo": "50071090",
    "descricao": "Outros"
  },
  {
    "codigo": "50072010",
    "descricao": "Estampados, tintos ou de fios de diversas cores"
  },
  {
    "codigo": "50072090",
    "descricao": "Outros"
  },
  {
    "codigo": "50079000",
    "descricao": "- Outros tecidos"
  },
  {
    "codigo": "51011110",
    "descricao": "De finura igual ou superior 22,05 micrômetros (mícrons), mas inferior ou igual a 32,6 micrômetros (mícrons)"
  },
  {
    "codigo": "51011190",
    "descricao": "Outra"
  },
  {
    "codigo": "51011900",
    "descricao": "-- Outra"
  },
  {
    "codigo": "51012100",
    "descricao": "-- Lã de tosquia"
  },
  {
    "codigo": "51012900",
    "descricao": "-- Outra"
  },
  {
    "codigo": "51013000",
    "descricao": "- Carbonizada"
  },
  {
    "codigo": "51021100",
    "descricao": "-- De cabra de Caxemira"
  },
  {
    "codigo": "51021900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "51022000",
    "descricao": "- Pelos grosseiros"
  },
  {
    "codigo": "51031000",
    "descricao": "- Desperdícios da penteação de lã ou de pelos finos"
  },
  {
    "codigo": "51032000",
    "descricao": "- Outros desperdícios de lã ou de pelos finos"
  },
  {
    "codigo": "51033000",
    "descricao": "- Desperdícios de pelos grosseiros"
  },
  {
    "codigo": "51040000",
    "descricao": "Fiapos de lã ou de pelos finos ou grosseiros."
  },
  {
    "codigo": "51051000",
    "descricao": "- Lã cardada"
  },
  {
    "codigo": "51052100",
    "descricao": "-- \"Lã penteada a granel\""
  },
  {
    "codigo": "51052910",
    "descricao": "<i>Tops</i>"
  },
  {
    "codigo": "51052991",
    "descricao": "De finura inferior a 22,5 micrômetros (mícrons)"
  },
  {
    "codigo": "51052999",
    "descricao": "Outras"
  },
  {
    "codigo": "51053100",
    "descricao": "-- De cabra de Caxemira"
  },
  {
    "codigo": "51053900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "51054000",
    "descricao": "- Pelos grosseiros, cardados ou penteados"
  },
  {
    "codigo": "51061000",
    "descricao": "- Que contenham pelo menos 85 %, em peso, de lã"
  },
  {
    "codigo": "51062000",
    "descricao": "- Que contenham menos de 85 %, em peso, de lã"
  },
  {
    "codigo": "51071011",
    "descricao": "De dois cabos, de título inferior ou igual a 184,58 decitex por cabo"
  },
  {
    "codigo": "51071019",
    "descricao": "Outros"
  },
  {
    "codigo": "51071090",
    "descricao": "Outros"
  },
  {
    "codigo": "51072000",
    "descricao": "- Que contenham menos de 85 %, em peso, de lã"
  },
  {
    "codigo": "51081000",
    "descricao": "- Cardados"
  },
  {
    "codigo": "51082000",
    "descricao": "- Penteados"
  },
  {
    "codigo": "51091000",
    "descricao": "- Que contenham pelo menos 85 %, em peso, de lã ou de pelos finos"
  },
  {
    "codigo": "51099000",
    "descricao": "- Outros"
  },
  {
    "codigo": "51100000",
    "descricao": "Fios de pelos grosseiros ou de crina (incluindo os fios de crina revestidos por enrolamento), mesmo acondicionados para venda a retalho."
  },
  {
    "codigo": "51111110",
    "descricao": "De lã"
  },
  {
    "codigo": "51111120",
    "descricao": "De pelos finos"
  },
  {
    "codigo": "51111900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "51112000",
    "descricao": "- Outros, combinados, principal ou unicamente, com filamentos sintéticos ou artificiais"
  },
  {
    "codigo": "51113010",
    "descricao": "De lã, feltrados, com trama combinada exclusivamente com fibras sintéticas e urdidura exclusivamente de algodão, de peso igual ou superior a 600 g/m<sup>2</sup>, próprios para fabricação de bolas de tênis"
  },
  {
    "codigo": "51113090",
    "descricao": "Outros"
  },
  {
    "codigo": "51119000",
    "descricao": "- Outros"
  },
  {
    "codigo": "51121100",
    "descricao": "-- De peso não superior a 200 g/m<sup>2</sup>"
  },
  {
    "codigo": "51121910",
    "descricao": "De lã"
  },
  {
    "codigo": "51121920",
    "descricao": "De pelos finos"
  },
  {
    "codigo": "51122010",
    "descricao": "De lã"
  },
  {
    "codigo": "51122020",
    "descricao": "De pelos finos"
  },
  {
    "codigo": "51123010",
    "descricao": "De lã"
  },
  {
    "codigo": "51123020",
    "descricao": "De pelos finos"
  },
  {
    "codigo": "51129000",
    "descricao": "- Outros"
  },
  {
    "codigo": "51130011",
    "descricao": "Que contenham pelo menos 85 %, em peso, de pelos grosseiros"
  },
  {
    "codigo": "51130012",
    "descricao": "Que contenham menos de 85 %, em peso, de pelos grosseiros e que contenham algodão"
  },
  {
    "codigo": "51130013",
    "descricao": "Que contenham menos de 85 %, em peso, de pelos grosseiros e que não contenham algodão"
  },
  {
    "codigo": "51130020",
    "descricao": "De crina"
  },
  {
    "codigo": "52010010",
    "descricao": "Não debulhado"
  },
  {
    "codigo": "52010020",
    "descricao": "Simplesmente debulhado"
  },
  {
    "codigo": "52010090",
    "descricao": "Outros"
  },
  {
    "codigo": "52021000",
    "descricao": "- Desperdícios de fios"
  },
  {
    "codigo": "52029100",
    "descricao": "-- Fiapos"
  },
  {
    "codigo": "52029900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "52030000",
    "descricao": "Algodão cardado ou penteado."
  },
  {
    "codigo": "52041111",
    "descricao": "De dois cabos"
  },
  {
    "codigo": "52041112",
    "descricao": "De três ou mais cabos"
  },
  {
    "codigo": "52041120",
    "descricao": "De algodão cru, de título superior a 5.000 decitex por fio simples"
  },
  {
    "codigo": "52041131",
    "descricao": "De dois cabos"
  },
  {
    "codigo": "52041132",
    "descricao": "De três ou mais cabos"
  },
  {
    "codigo": "52041140",
    "descricao": "De algodão branqueado ou colorido, de título superior a 5.000 decitex por fio simples"
  },
  {
    "codigo": "52041911",
    "descricao": "De dois cabos"
  },
  {
    "codigo": "52041912",
    "descricao": "De três ou mais cabos"
  },
  {
    "codigo": "52041920",
    "descricao": "De algodão cru, de título superior a 5.000 decitex por fio simples"
  },
  {
    "codigo": "52041931",
    "descricao": "De dois cabos"
  },
  {
    "codigo": "52041932",
    "descricao": "De três ou mais cabos"
  },
  {
    "codigo": "52041940",
    "descricao": "De algodão branqueado ou colorido, de título superior a 5.000 decitex por fio simples"
  },
  {
    "codigo": "52042000",
    "descricao": "- Acondicionadas para venda a retalho"
  },
  {
    "codigo": "52051100",
    "descricao": "-- De título igual ou superior a 714,29 decitex (número métrico não superior a 14)"
  },
  {
    "codigo": "52051200",
    "descricao": "-- De título inferior a 714,29 decitex, mas não inferior a 232,56 decitex (número métrico superior a 14, mas não superior a 43)"
  },
  {
    "codigo": "52051310",
    "descricao": "Crus"
  },
  {
    "codigo": "52051390",
    "descricao": "Outros"
  },
  {
    "codigo": "52051400",
    "descricao": "-- De título inferior a 192,31 decitex, mas não inferior a 125 decitex (número métrico superior a 52, mas não superior a 80)"
  },
  {
    "codigo": "52051500",
    "descricao": "-- De título inferior a 125 decitex (número métrico superior a 80)"
  },
  {
    "codigo": "52052100",
    "descricao": "-- De título igual ou superior a 714,29 decitex (número métrico não superior a 14)"
  },
  {
    "codigo": "52052200",
    "descricao": "-- De título inferior a 714,29 decitex, mas não inferior a 232,56 decitex (número métrico superior a 14, mas não superior a 43)"
  },
  {
    "codigo": "52052310",
    "descricao": "Crus"
  },
  {
    "codigo": "52052390",
    "descricao": "Outros"
  },
  {
    "codigo": "52052400",
    "descricao": "-- De título inferior a 192,31 decitex, mas não inferior a 125 decitex (número métrico superior a 52, mas não superior a 80)"
  },
  {
    "codigo": "52052600",
    "descricao": "-- De título inferior a 125 decitex, mas não inferior a 106,38 decitex (número métrico superior a 80, mas não superior a 94)"
  },
  {
    "codigo": "52052700",
    "descricao": "-- De título inferior a 106,38 decitex, mas não inferior a 83,33 decitex (número métrico superior a 94, mas não superior a 120)"
  },
  {
    "codigo": "52052800",
    "descricao": "-- De título inferior a 83,33 decitex (número métrico superior a 120)"
  },
  {
    "codigo": "52053100",
    "descricao": "-- De título igual ou superior a 714,29 decitex por fio simples (número métrico não superior a 14, por fio simples)"
  },
  {
    "codigo": "52053200",
    "descricao": "-- De título inferior a 714,29 decitex, mas não inferior a 232,56 decitex por fio simples (número métrico superior a 14, mas não superior a 43, por fio simples)"
  },
  {
    "codigo": "52053300",
    "descricao": "-- De título inferior a 232,56 decitex, mas não inferior a 192,31 decitex por fio simples (número métrico superior a 43, mas não superior a 52, por fio simples)"
  },
  {
    "codigo": "52053400",
    "descricao": "-- De título inferior a 192,31 decitex, mas não inferior a 125 decitex por fio simples (número métrico superior a 52, mas não superior a 80, por fio simples)"
  },
  {
    "codigo": "52053500",
    "descricao": "-- De título inferior a 125 decitex por fio simples (número métrico superior a 80, por fio simples)"
  },
  {
    "codigo": "52054100",
    "descricao": "-- De título igual ou superior a 714,29 decitex por fio simples (número métrico não superior a 14, por fio simples)"
  },
  {
    "codigo": "52054200",
    "descricao": "-- De título inferior a 714,29 decitex, mas não inferior a 232,56 decitex por fio simples (número métrico superior a 14, mas não superior a 43, por fio simples)"
  },
  {
    "codigo": "52054300",
    "descricao": "-- De título inferior a 232,56 decitex, mas não inferior a 192,31 decitex por fio simples (número métrico superior a 43, mas não superior a 52, por fio simples)"
  },
  {
    "codigo": "52054400",
    "descricao": "-- De título inferior a 192,31 decitex, mas não inferior a 125 decitex por fio simples (número métrico superior a 52, mas não superior a 80, por fio simples)"
  },
  {
    "codigo": "52054600",
    "descricao": "-- De título inferior a 125 decitex, mas não inferior a 106,38 decitex por fio simples (número métrico superior a 80, mas não superior a 94, por fio simples)"
  },
  {
    "codigo": "52054700",
    "descricao": "-- De título inferior a 106,38 decitex, mas não inferior a 83,33 decitex por fio simples (número métrico superior a 94, mas não superior a 120, por fio simples)"
  },
  {
    "codigo": "52054800",
    "descricao": "-- De título inferior a 83,33 decitex por fio simples (número métrico superior a 120, por fio simples)"
  },
  {
    "codigo": "52061100",
    "descricao": "-- De título igual ou superior a 714,29 decitex (número métrico não superior a 14)"
  },
  {
    "codigo": "52061200",
    "descricao": "-- De título inferior a 714,29 decitex, mas não inferior a 232,56 decitex (número métrico superior a 14, mas não superior a 43)"
  },
  {
    "codigo": "52061300",
    "descricao": "-- De título inferior a 232,56 decitex, mas não inferior a 192,31 decitex (número métrico superior a 43, mas não superior a 52)"
  },
  {
    "codigo": "52061400",
    "descricao": "-- De título inferior a 192,31 decitex, mas não inferior a 125 decitex (número métrico superior a 52, mas não superior a 80)"
  },
  {
    "codigo": "52061500",
    "descricao": "-- De título inferior a 125 decitex (número métrico superior a 80)"
  },
  {
    "codigo": "52062100",
    "descricao": "-- De título igual ou superior a 714,29 decitex (número métrico não superior a 14)"
  },
  {
    "codigo": "52062200",
    "descricao": "-- De título inferior a 714,29 decitex, mas não inferior a 232,56 decitex (número métrico superior a 14, mas não superior a 43)"
  },
  {
    "codigo": "52062300",
    "descricao": "-- De título inferior a 232,56 decitex, mas não inferior a 192,31 decitex (número métrico superior a 43, mas não superior a 52)"
  },
  {
    "codigo": "52062400",
    "descricao": "-- De título inferior a 192,31 decitex, mas não inferior a 125 decitex (número métrico superior a 52, mas não superior a 80)"
  },
  {
    "codigo": "52062500",
    "descricao": "-- De título inferior a 125 decitex (número métrico superior a 80)"
  },
  {
    "codigo": "52063100",
    "descricao": "-- De título igual ou superior a 714,29 decitex por fio simples (número métrico não superior a 14, por fio simples)"
  },
  {
    "codigo": "52063200",
    "descricao": "-- De título inferior a 714,29 decitex, mas não inferior a 232,56 decitex por fio simples (número métrico superior a 14, mas não superior a 43, por fio simples)"
  },
  {
    "codigo": "52063300",
    "descricao": "-- De título inferior a 232,56 decitex, mas não inferior a 192,31 decitex por fio simples (número métrico superior a 43, mas não superior a 52, por fio simples)"
  },
  {
    "codigo": "52063400",
    "descricao": "-- De título inferior a 192,31 decitex, mas não inferior a 125 decitex por fio simples (número métrico superior a 52, mas não superior a 80, por fio simples)"
  },
  {
    "codigo": "52063500",
    "descricao": "-- De título inferior a 125 decitex por fio simples (número métrico superior a 80, por fio simples)"
  },
  {
    "codigo": "52064100",
    "descricao": "-- De título igual ou superior a 714,29 decitex por fio simples (número métrico não superior a 14, por fio simples)"
  },
  {
    "codigo": "52064200",
    "descricao": "-- De título inferior a 714,29 decitex, mas não inferior a 232,56 decitex por fio simples (número métrico superior a 14, mas não superior a 43, por fio simples)"
  },
  {
    "codigo": "52064300",
    "descricao": "-- De título inferior a 232,56 decitex, mas não inferior a 192,31 decitex por fio simples (número métrico superior a 43, mas não superior a 52, por fio simples)"
  },
  {
    "codigo": "52064400",
    "descricao": "-- De título inferior a 192,31 decitex, mas não inferior a 125 decitex por fio simples (número métrico superior a 52, mas não superior a 80, por fio simples)"
  },
  {
    "codigo": "52064500",
    "descricao": "-- De título inferior a 125 decitex por fio simples (número métrico superior a 80, por fio simples)"
  },
  {
    "codigo": "52071000",
    "descricao": "- Que contenham pelo menos 85 %, em peso, de algodão"
  },
  {
    "codigo": "52079000",
    "descricao": "- Outros"
  },
  {
    "codigo": "52081100",
    "descricao": "-- Em ponto de tafetá, de peso não superior a 100 g/m<sup>2</sup>"
  },
  {
    "codigo": "52081200",
    "descricao": "-- Em ponto de tafetá, de peso superior a 100 g/m<sup>2</sup>"
  },
  {
    "codigo": "52081300",
    "descricao": "-- Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52081900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52082100",
    "descricao": "-- Em ponto de tafetá, de peso não superior a 100 g/m<sup>2</sup>"
  },
  {
    "codigo": "52082200",
    "descricao": "-- Em ponto de tafetá, de peso superior a 100 g/m<sup>2</sup>"
  },
  {
    "codigo": "52082300",
    "descricao": "-- Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52082900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52083100",
    "descricao": "-- Em ponto de tafetá, de peso não superior a 100 g/m<sup>2</sup>"
  },
  {
    "codigo": "52083200",
    "descricao": "-- Em ponto de tafetá, de peso superior a 100 g/m<sup>2</sup>"
  },
  {
    "codigo": "52083300",
    "descricao": "-- Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52083900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52084100",
    "descricao": "-- Em ponto de tafetá, de peso não superior a 100 g/m<sup>2</sup>"
  },
  {
    "codigo": "52084200",
    "descricao": "-- Em ponto de tafetá, de peso superior a 100 g/m<sup>2</sup>"
  },
  {
    "codigo": "52084300",
    "descricao": "-- Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52084900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52085100",
    "descricao": "-- Em ponto de tafetá, de peso não superior a 100 g/m<sup>2</sup>"
  },
  {
    "codigo": "52085200",
    "descricao": "-- Em ponto de tafetá, de peso superior a 100 g/m<sup>2</sup>"
  },
  {
    "codigo": "52085910",
    "descricao": "Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52085990",
    "descricao": "Outros"
  },
  {
    "codigo": "52091100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52091200",
    "descricao": "-- Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52091900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52092100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52092200",
    "descricao": "-- Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52092900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52093100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52093200",
    "descricao": "-- Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52093900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52094100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52094210",
    "descricao": "Com fios tintos em <i>indigo blue</i> segundo Color Index 73000"
  },
  {
    "codigo": "52094290",
    "descricao": "Outros"
  },
  {
    "codigo": "52094300",
    "descricao": "-- Outros tecidos em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52094900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52095100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52095200",
    "descricao": "-- Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52095900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52101100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52101910",
    "descricao": "Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52101990",
    "descricao": "Outros"
  },
  {
    "codigo": "52102100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52102910",
    "descricao": "Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52102990",
    "descricao": "Outros"
  },
  {
    "codigo": "52103100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52103200",
    "descricao": "-- Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52103900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52104100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52104910",
    "descricao": "Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52104990",
    "descricao": "Outros"
  },
  {
    "codigo": "52105100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52105910",
    "descricao": "Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52105990",
    "descricao": "Outros"
  },
  {
    "codigo": "52111100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52111200",
    "descricao": "-- Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52111900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52112010",
    "descricao": "Em ponto de tafetá"
  },
  {
    "codigo": "52112020",
    "descricao": "Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52112090",
    "descricao": "Outros"
  },
  {
    "codigo": "52113100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52113200",
    "descricao": "-- Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52113900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52114100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52114210",
    "descricao": "Com fios tintos em <i>indigo blue</i> segundo Color Index 73000"
  },
  {
    "codigo": "52114290",
    "descricao": "Outros"
  },
  {
    "codigo": "52114300",
    "descricao": "-- Outros tecidos em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52114900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52115100",
    "descricao": "-- Em ponto de tafetá"
  },
  {
    "codigo": "52115200",
    "descricao": "-- Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "52115900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "52121100",
    "descricao": "-- Crus"
  },
  {
    "codigo": "52121200",
    "descricao": "-- Branqueados"
  },
  {
    "codigo": "52121300",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "52121400",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "52121500",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "52122100",
    "descricao": "-- Crus"
  },
  {
    "codigo": "52122200",
    "descricao": "-- Branqueados"
  },
  {
    "codigo": "52122300",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "52122400",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "52122500",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "53011000",
    "descricao": "- Linho em bruto ou macerado"
  },
  {
    "codigo": "53012110",
    "descricao": "Quebrado"
  },
  {
    "codigo": "53012120",
    "descricao": "Espadelado"
  },
  {
    "codigo": "53012910",
    "descricao": "Penteado"
  },
  {
    "codigo": "53012990",
    "descricao": "Outro"
  },
  {
    "codigo": "53013000",
    "descricao": "- Estopas e desperdícios de linho"
  },
  {
    "codigo": "53021000",
    "descricao": "- Cânhamo em bruto ou macerado"
  },
  {
    "codigo": "53029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "53031010",
    "descricao": "Juta"
  },
  {
    "codigo": "53031090",
    "descricao": "Outras"
  },
  {
    "codigo": "53039010",
    "descricao": "Juta"
  },
  {
    "codigo": "53039090",
    "descricao": "Outros"
  },
  {
    "codigo": "53050010",
    "descricao": "De abacá, em bruto"
  },
  {
    "codigo": "53050090",
    "descricao": "Outros"
  },
  {
    "codigo": "53061000",
    "descricao": "- Simples"
  },
  {
    "codigo": "53062000",
    "descricao": "- Retorcidos ou retorcidos múltiplos"
  },
  {
    "codigo": "53071010",
    "descricao": "De juta"
  },
  {
    "codigo": "53071090",
    "descricao": "Outros"
  },
  {
    "codigo": "53072010",
    "descricao": "De juta"
  },
  {
    "codigo": "53072090",
    "descricao": "Outros"
  },
  {
    "codigo": "53081000",
    "descricao": "- Fios de cairo (fibra de coco)"
  },
  {
    "codigo": "53082000",
    "descricao": "- Fios de cânhamo"
  },
  {
    "codigo": "53089000",
    "descricao": "- Outros"
  },
  {
    "codigo": "53091100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "53091900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "53092100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "53092900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "53101010",
    "descricao": "Aniagem de juta"
  },
  {
    "codigo": "53101090",
    "descricao": "Outros"
  },
  {
    "codigo": "53109000",
    "descricao": "- Outros"
  },
  {
    "codigo": "53110000",
    "descricao": "Tecidos de outras fibras têxteis vegetais; tecidos de fios de papel."
  },
  {
    "codigo": "54011011",
    "descricao": "Não acondicionadas para venda a retalho"
  },
  {
    "codigo": "54011012",
    "descricao": "Acondicionadas para venda a retalho"
  },
  {
    "codigo": "54011090",
    "descricao": "Outras"
  },
  {
    "codigo": "54012011",
    "descricao": "Não acondicionadas para venda a retalho"
  },
  {
    "codigo": "54012012",
    "descricao": "Acondicionadas para venda a retalho"
  },
  {
    "codigo": "54012090",
    "descricao": "Outras"
  },
  {
    "codigo": "54021100",
    "descricao": "-- De aramidas"
  },
  {
    "codigo": "54021910",
    "descricao": "De náilon"
  },
  {
    "codigo": "54021990",
    "descricao": "Outros"
  },
  {
    "codigo": "54022010",
    "descricao": "De copolímero de ácido <i>p</i>-hidroxibenzoico e ácido hidroxinaftoico"
  },
  {
    "codigo": "54022090",
    "descricao": "Outros"
  },
  {
    "codigo": "54023111",
    "descricao": "Tintos"
  },
  {
    "codigo": "54023119",
    "descricao": "Outros"
  },
  {
    "codigo": "54023190",
    "descricao": "Outros"
  },
  {
    "codigo": "54023211",
    "descricao": "Multifilamento com efeito antiestático permanente, de título superior a 110 tex"
  },
  {
    "codigo": "54023219",
    "descricao": "Outros"
  },
  {
    "codigo": "54023290",
    "descricao": "Outros"
  },
  {
    "codigo": "54023310",
    "descricao": "Crus"
  },
  {
    "codigo": "54023320",
    "descricao": "Tintos"
  },
  {
    "codigo": "54023390",
    "descricao": "Outros"
  },
  {
    "codigo": "54023400",
    "descricao": "-- De polipropileno"
  },
  {
    "codigo": "54023900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "54024400",
    "descricao": "-- De elastômeros"
  },
  {
    "codigo": "54024510",
    "descricao": "De aramidas"
  },
  {
    "codigo": "54024520",
    "descricao": "De náilon"
  },
  {
    "codigo": "54024590",
    "descricao": "Outros"
  },
  {
    "codigo": "54024600",
    "descricao": "-- Outros, de poliésteres, parcialmente orientados"
  },
  {
    "codigo": "54024710",
    "descricao": "Crus"
  },
  {
    "codigo": "54024720",
    "descricao": "Tintos"
  },
  {
    "codigo": "54024790",
    "descricao": "Outros"
  },
  {
    "codigo": "54024800",
    "descricao": "-- Outros, de polipropileno"
  },
  {
    "codigo": "54024910",
    "descricao": "De polietileno, com tenacidade igual ou superior a 26 cN/tex"
  },
  {
    "codigo": "54024990",
    "descricao": "Outros"
  },
  {
    "codigo": "54025110",
    "descricao": "De aramidas"
  },
  {
    "codigo": "54025190",
    "descricao": "Outros"
  },
  {
    "codigo": "54025200",
    "descricao": "-- De poliésteres"
  },
  {
    "codigo": "54025300",
    "descricao": "-- De polipropileno"
  },
  {
    "codigo": "54025900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "54026110",
    "descricao": "De aramidas"
  },
  {
    "codigo": "54026190",
    "descricao": "Outros"
  },
  {
    "codigo": "54026200",
    "descricao": "-- De poliésteres"
  },
  {
    "codigo": "54026300",
    "descricao": "-- De polipropileno"
  },
  {
    "codigo": "54026900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "54031000",
    "descricao": "- Fios de alta tenacidade, de raiom viscose"
  },
  {
    "codigo": "54033110",
    "descricao": "Crus ou branqueados"
  },
  {
    "codigo": "54033190",
    "descricao": "Outros"
  },
  {
    "codigo": "54033200",
    "descricao": "-- De raiom viscose, com torção superior a 120 voltas por metro"
  },
  {
    "codigo": "54033300",
    "descricao": "-- De acetato de celulose"
  },
  {
    "codigo": "54033900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "54034100",
    "descricao": "-- De raiom viscose"
  },
  {
    "codigo": "54034200",
    "descricao": "-- De acetato de celulose"
  },
  {
    "codigo": "54034900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "54041100",
    "descricao": "-- De elastômeros"
  },
  {
    "codigo": "54041200",
    "descricao": "-- Outros, de polipropileno"
  },
  {
    "codigo": "54041911",
    "descricao": "Reabsorvíveis"
  },
  {
    "codigo": "54041919",
    "descricao": "Outros"
  },
  {
    "codigo": "54041990",
    "descricao": "Outros"
  },
  {
    "codigo": "54049000",
    "descricao": "- Outras"
  },
  {
    "codigo": "54050000",
    "descricao": "Monofilamentos artificiais, de título igual ou superior a 67 decitex e cuja maior dimensão da seção transversal não seja superior a 1 mm; lâminas e formas semelhantes (palha artificial, por exemplo) de matérias têxteis artificiais, cuja largura aparente não seja superior a 5 mm."
  },
  {
    "codigo": "54060010",
    "descricao": "Fios de filamentos sintéticos"
  },
  {
    "codigo": "54060020",
    "descricao": "Fios de filamentos artificiais"
  },
  {
    "codigo": "54071011",
    "descricao": "De aramidas"
  },
  {
    "codigo": "54071019",
    "descricao": "Outros"
  },
  {
    "codigo": "54071021",
    "descricao": "De aramidas"
  },
  {
    "codigo": "54071029",
    "descricao": "Outros"
  },
  {
    "codigo": "54072000",
    "descricao": "- Tecidos obtidos a partir de lâminas ou de formas semelhantes"
  },
  {
    "codigo": "54073000",
    "descricao": "- \"Tecidos\" mencionados na Nota 9 da Seção XI"
  },
  {
    "codigo": "54074100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "54074200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "54074300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "54074400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "54075100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "54075210",
    "descricao": "Sem fios de borracha"
  },
  {
    "codigo": "54075220",
    "descricao": "Com fios de borracha"
  },
  {
    "codigo": "54075300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "54075400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "54076100",
    "descricao": "-- Que contenham pelo menos 85 %, em peso, de filamentos de poliéster não texturizados"
  },
  {
    "codigo": "54076900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "54077100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "54077200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "54077300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "54077400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "54078100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "54078200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "54078300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "54078400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "54079100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "54079200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "54079300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "54079400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "54081000",
    "descricao": "- Tecidos obtidos a partir de fios de alta tenacidade, de raiom viscose"
  },
  {
    "codigo": "54082100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "54082200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "54082300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "54082400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "54083100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "54083200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "54083300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "54083400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "55011100",
    "descricao": "-- De aramidas"
  },
  {
    "codigo": "55011900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "55012000",
    "descricao": "- De poliésteres"
  },
  {
    "codigo": "55013000",
    "descricao": "- Acrílicos ou modacrílicos"
  },
  {
    "codigo": "55014000",
    "descricao": "- De polipropileno"
  },
  {
    "codigo": "55019000",
    "descricao": "- Outros"
  },
  {
    "codigo": "55021000",
    "descricao": "- De acetato de celulose"
  },
  {
    "codigo": "55029010",
    "descricao": "De raiom viscose"
  },
  {
    "codigo": "55029090",
    "descricao": "Outros"
  },
  {
    "codigo": "55031100",
    "descricao": "-- De aramidas"
  },
  {
    "codigo": "55031910",
    "descricao": "Bicomponentes, de diferentes pontos de fusão"
  },
  {
    "codigo": "55031990",
    "descricao": "Outras"
  },
  {
    "codigo": "55032010",
    "descricao": "Bicomponentes, de diferentes pontos de fusão"
  },
  {
    "codigo": "55032090",
    "descricao": "Outras"
  },
  {
    "codigo": "55033000",
    "descricao": "- Acrílicas ou modacrílicas"
  },
  {
    "codigo": "55034000",
    "descricao": "- De polipropileno"
  },
  {
    "codigo": "55039010",
    "descricao": "Bicomponentes, de diferentes pontos de fusão"
  },
  {
    "codigo": "55039020",
    "descricao": "De poli(álcool vinílico)"
  },
  {
    "codigo": "55039090",
    "descricao": "Outras"
  },
  {
    "codigo": "55041000",
    "descricao": "- De raiom viscose"
  },
  {
    "codigo": "55049010",
    "descricao": "De liocel"
  },
  {
    "codigo": "55049090",
    "descricao": "Outras"
  },
  {
    "codigo": "55051000",
    "descricao": "- De fibras sintéticas"
  },
  {
    "codigo": "55052000",
    "descricao": "- De fibras artificiais"
  },
  {
    "codigo": "55061000",
    "descricao": "- De náilon ou de outras poliamidas"
  },
  {
    "codigo": "55062000",
    "descricao": "- De poliésteres"
  },
  {
    "codigo": "55063000",
    "descricao": "- Acrílicas ou modacrílicas"
  },
  {
    "codigo": "55064000",
    "descricao": "- De polipropileno"
  },
  {
    "codigo": "55069000",
    "descricao": "- Outras"
  },
  {
    "codigo": "55070000",
    "descricao": "Fibras artificiais descontínuas, cardadas, penteadas ou transformadas de outro modo para fiação."
  },
  {
    "codigo": "55081000",
    "descricao": "- De fibras sintéticas descontínuas"
  },
  {
    "codigo": "55082000",
    "descricao": "- De fibras artificiais descontínuas"
  },
  {
    "codigo": "55091100",
    "descricao": "-- Simples"
  },
  {
    "codigo": "55091210",
    "descricao": "De aramidas"
  },
  {
    "codigo": "55091290",
    "descricao": "Outros"
  },
  {
    "codigo": "55092100",
    "descricao": "-- Simples"
  },
  {
    "codigo": "55092200",
    "descricao": "-- Retorcidos ou retorcidos múltiplos"
  },
  {
    "codigo": "55093100",
    "descricao": "-- Simples"
  },
  {
    "codigo": "55093200",
    "descricao": "-- Retorcidos ou retorcidos múltiplos"
  },
  {
    "codigo": "55094100",
    "descricao": "-- Simples"
  },
  {
    "codigo": "55094200",
    "descricao": "-- Retorcidos ou retorcidos múltiplos"
  },
  {
    "codigo": "55095100",
    "descricao": "-- Combinadas, principal ou unicamente, com fibras artificiais descontínuas"
  },
  {
    "codigo": "55095200",
    "descricao": "-- Combinadas, principal ou unicamente, com lã ou pelos finos"
  },
  {
    "codigo": "55095300",
    "descricao": "-- Combinadas, principal ou unicamente, com algodão"
  },
  {
    "codigo": "55095900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "55096100",
    "descricao": "-- Combinadas, principal ou unicamente, com lã ou pelos finos"
  },
  {
    "codigo": "55096200",
    "descricao": "-- Combinadas, principal ou unicamente, com algodão"
  },
  {
    "codigo": "55096900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "55099100",
    "descricao": "-- Combinados, principal ou unicamente, com lã ou pelos finos"
  },
  {
    "codigo": "55099200",
    "descricao": "-- Combinados, principal ou unicamente, com algodão"
  },
  {
    "codigo": "55099900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "55101111",
    "descricao": "De raiom viscose, exceto modal"
  },
  {
    "codigo": "55101112",
    "descricao": "De modal"
  },
  {
    "codigo": "55101113",
    "descricao": "De liocel"
  },
  {
    "codigo": "55101119",
    "descricao": "Outros"
  },
  {
    "codigo": "55101190",
    "descricao": "Outros"
  },
  {
    "codigo": "55101211",
    "descricao": "De raiom viscose, exceto modal"
  },
  {
    "codigo": "55101212",
    "descricao": "De modal"
  },
  {
    "codigo": "55101213",
    "descricao": "De liocel"
  },
  {
    "codigo": "55101219",
    "descricao": "Outros"
  },
  {
    "codigo": "55101290",
    "descricao": "Outros"
  },
  {
    "codigo": "55102011",
    "descricao": "De raiom viscose, exceto modal"
  },
  {
    "codigo": "55102012",
    "descricao": "De modal"
  },
  {
    "codigo": "55102013",
    "descricao": "De liocel"
  },
  {
    "codigo": "55102019",
    "descricao": "Outros"
  },
  {
    "codigo": "55102090",
    "descricao": "Outros"
  },
  {
    "codigo": "55103011",
    "descricao": "De raiom viscose, exceto modal"
  },
  {
    "codigo": "55103012",
    "descricao": "De modal"
  },
  {
    "codigo": "55103013",
    "descricao": "De liocel"
  },
  {
    "codigo": "55103019",
    "descricao": "Outros"
  },
  {
    "codigo": "55103090",
    "descricao": "Outros"
  },
  {
    "codigo": "55109011",
    "descricao": "De raiom viscose, exceto modal"
  },
  {
    "codigo": "55109012",
    "descricao": "De modal"
  },
  {
    "codigo": "55109013",
    "descricao": "De liocel"
  },
  {
    "codigo": "55109019",
    "descricao": "Outros"
  },
  {
    "codigo": "55109090",
    "descricao": "Outros"
  },
  {
    "codigo": "55111000",
    "descricao": "- De fibras sintéticas descontínuas, que contenham pelo menos 85 %, em peso, destas fibras"
  },
  {
    "codigo": "55112000",
    "descricao": "- De fibras sintéticas descontínuas, que contenham menos de 85 %, em peso, destas fibras"
  },
  {
    "codigo": "55113000",
    "descricao": "- De fibras artificiais descontínuas"
  },
  {
    "codigo": "55121100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "55121900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "55122100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "55122900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "55129110",
    "descricao": "De aramidas"
  },
  {
    "codigo": "55129190",
    "descricao": "Outros"
  },
  {
    "codigo": "55129910",
    "descricao": "De aramidas"
  },
  {
    "codigo": "55129990",
    "descricao": "Outros"
  },
  {
    "codigo": "55131100",
    "descricao": "-- De fibras descontínuas de poliéster, em ponto de tafetá"
  },
  {
    "codigo": "55131200",
    "descricao": "-- De fibras descontínuas de poliéster, em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "55131300",
    "descricao": "-- Outros tecidos de fibras descontínuas de poliéster"
  },
  {
    "codigo": "55131900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "55132100",
    "descricao": "-- De fibras descontínuas de poliéster, em ponto de tafetá"
  },
  {
    "codigo": "55132310",
    "descricao": "Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "55132390",
    "descricao": "Outros"
  },
  {
    "codigo": "55132900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "55133100",
    "descricao": "-- De fibras descontínuas de poliéster, em ponto de tafetá"
  },
  {
    "codigo": "55133911",
    "descricao": "Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "55133919",
    "descricao": "Outros"
  },
  {
    "codigo": "55133990",
    "descricao": "Outros"
  },
  {
    "codigo": "55134100",
    "descricao": "-- De fibras descontínuas de poliéster, em ponto de tafetá"
  },
  {
    "codigo": "55134911",
    "descricao": "Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "55134919",
    "descricao": "Outros"
  },
  {
    "codigo": "55134990",
    "descricao": "Outros"
  },
  {
    "codigo": "55141100",
    "descricao": "-- De fibras descontínuas de poliéster, em ponto de tafetá"
  },
  {
    "codigo": "55141200",
    "descricao": "-- De fibras descontínuas de poliéster, em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "55141910",
    "descricao": "De fibras descontínuas de poliéster"
  },
  {
    "codigo": "55141990",
    "descricao": "Outros"
  },
  {
    "codigo": "55142100",
    "descricao": "-- De fibras descontínuas de poliéster, em ponto de tafetá"
  },
  {
    "codigo": "55142200",
    "descricao": "-- De fibras descontínuas de poliéster, em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "55142300",
    "descricao": "-- Outros tecidos de fibras descontínuas de poliéster"
  },
  {
    "codigo": "55142900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "55143011",
    "descricao": "Em ponto de tafetá"
  },
  {
    "codigo": "55143012",
    "descricao": "Em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "55143019",
    "descricao": "Outros"
  },
  {
    "codigo": "55143090",
    "descricao": "Outros"
  },
  {
    "codigo": "55144100",
    "descricao": "-- De fibras descontínuas de poliéster, em ponto de tafetá"
  },
  {
    "codigo": "55144200",
    "descricao": "-- De fibras descontínuas de poliéster, em ponto sarjado, incluindo o diagonal, cuja relação de textura não seja superior a 4"
  },
  {
    "codigo": "55144300",
    "descricao": "-- Outros tecidos de fibras descontínuas de poliéster"
  },
  {
    "codigo": "55144900",
    "descricao": "-- Outros tecidos"
  },
  {
    "codigo": "55151100",
    "descricao": "-- Combinadas, principal ou unicamente, com fibras descontínuas de raiom viscose"
  },
  {
    "codigo": "55151200",
    "descricao": "-- Combinadas, principal ou unicamente, com filamentos sintéticos ou artificiais"
  },
  {
    "codigo": "55151300",
    "descricao": "-- Combinadas, principal ou unicamente, com lã ou pelos finos"
  },
  {
    "codigo": "55151900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "55152100",
    "descricao": "-- Combinadas, principal ou unicamente, com filamentos sintéticos ou artificiais"
  },
  {
    "codigo": "55152200",
    "descricao": "-- Combinadas, principal ou unicamente, com lã ou pelos finos"
  },
  {
    "codigo": "55152900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "55159100",
    "descricao": "-- Combinados, principal ou unicamente, com filamentos sintéticos ou artificiais"
  },
  {
    "codigo": "55159910",
    "descricao": "Combinados, principal ou unicamente, com lã ou pelos finos"
  },
  {
    "codigo": "55159990",
    "descricao": "Outros"
  },
  {
    "codigo": "55161100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "55161200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "55161300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "55161400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "55162100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "55162200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "55162300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "55162400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "55163100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "55163200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "55163300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "55163400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "55164100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "55164200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "55164300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "55164400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "55169100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "55169200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "55169300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "55169400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "56012110",
    "descricao": "Pastas (<i>ouates</i>)"
  },
  {
    "codigo": "56012190",
    "descricao": "Outros artigos de pastas (<i>ouates</i>)"
  },
  {
    "codigo": "56012211",
    "descricao": "De aramidas"
  },
  {
    "codigo": "56012219",
    "descricao": "Outras"
  },
  {
    "codigo": "56012291",
    "descricao": "Cilindros para filtros de cigarros"
  },
  {
    "codigo": "56012299",
    "descricao": "Outros"
  },
  {
    "codigo": "56012900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "56013010",
    "descricao": "De aramidas"
  },
  {
    "codigo": "56013090",
    "descricao": "Outros"
  },
  {
    "codigo": "56021000",
    "descricao": "- Feltros agulhados e artigos obtidos por costura por entrelaçamento (<i>cousus-tricotés</i>)"
  },
  {
    "codigo": "56022100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "56022900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "56029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "56031110",
    "descricao": "De aramidas"
  },
  {
    "codigo": "56031120",
    "descricao": "De poliéster"
  },
  {
    "codigo": "56031130",
    "descricao": "De polipropileno"
  },
  {
    "codigo": "56031140",
    "descricao": "De raiom viscose"
  },
  {
    "codigo": "56031190",
    "descricao": "Outros"
  },
  {
    "codigo": "56031210",
    "descricao": "De polietileno de alta densidade"
  },
  {
    "codigo": "56031220",
    "descricao": "De aramidas"
  },
  {
    "codigo": "56031230",
    "descricao": "De poliéster"
  },
  {
    "codigo": "56031240",
    "descricao": "De polipropileno"
  },
  {
    "codigo": "56031250",
    "descricao": "De raiom viscose"
  },
  {
    "codigo": "56031290",
    "descricao": "Outros"
  },
  {
    "codigo": "56031310",
    "descricao": "De polietileno de alta densidade"
  },
  {
    "codigo": "56031320",
    "descricao": "De aramidas"
  },
  {
    "codigo": "56031330",
    "descricao": "De poliéster"
  },
  {
    "codigo": "56031340",
    "descricao": "De polipropileno"
  },
  {
    "codigo": "56031350",
    "descricao": "De raiom viscose"
  },
  {
    "codigo": "56031390",
    "descricao": "Outros"
  },
  {
    "codigo": "56031410",
    "descricao": "De aramidas"
  },
  {
    "codigo": "56031420",
    "descricao": "De poliéster"
  },
  {
    "codigo": "56031430",
    "descricao": "De polipropileno"
  },
  {
    "codigo": "56031440",
    "descricao": "De raiom viscose"
  },
  {
    "codigo": "56031490",
    "descricao": "Outros"
  },
  {
    "codigo": "56039110",
    "descricao": "De poliéster"
  },
  {
    "codigo": "56039120",
    "descricao": "De polipropileno"
  },
  {
    "codigo": "56039130",
    "descricao": "De raiom viscose"
  },
  {
    "codigo": "56039190",
    "descricao": "Outros"
  },
  {
    "codigo": "56039210",
    "descricao": "De polietileno de alta densidade"
  },
  {
    "codigo": "56039220",
    "descricao": "De poliéster"
  },
  {
    "codigo": "56039230",
    "descricao": "De polipropileno"
  },
  {
    "codigo": "56039240",
    "descricao": "De raiom viscose"
  },
  {
    "codigo": "56039290",
    "descricao": "Outros"
  },
  {
    "codigo": "56039310",
    "descricao": "De polietileno de alta densidade"
  },
  {
    "codigo": "56039320",
    "descricao": "De poliéster"
  },
  {
    "codigo": "56039330",
    "descricao": "De polipropileno"
  },
  {
    "codigo": "56039340",
    "descricao": "De raiom viscose"
  },
  {
    "codigo": "56039390",
    "descricao": "Outros"
  },
  {
    "codigo": "56039410",
    "descricao": "De poliéster"
  },
  {
    "codigo": "56039420",
    "descricao": "De polipropileno"
  },
  {
    "codigo": "56039430",
    "descricao": "De raiom viscose"
  },
  {
    "codigo": "56039490",
    "descricao": "Outros"
  },
  {
    "codigo": "56041000",
    "descricao": "- Fios e cordas, de borracha, recobertos de têxteis"
  },
  {
    "codigo": "56049010",
    "descricao": "Imitações de categute constituídas por fios de seda"
  },
  {
    "codigo": "56049021",
    "descricao": "Com borracha"
  },
  {
    "codigo": "56049022",
    "descricao": "Com plástico"
  },
  {
    "codigo": "56049090",
    "descricao": "Outros"
  },
  {
    "codigo": "56050010",
    "descricao": "Com metais preciosos"
  },
  {
    "codigo": "56050020",
    "descricao": "Revestidos por enrolamento, exceto com metais preciosos"
  },
  {
    "codigo": "56050090",
    "descricao": "Outros"
  },
  {
    "codigo": "56060000",
    "descricao": "Fios revestidos por enrolamento, lâminas e formas semelhantes das posições 54.04 ou 54.05, revestidas por enrolamento, exceto os da posição 56.05 e os fios de crina revestidos por enrolamento; fios de froco (<i>chenille</i>); fios denominados \"de cadeia\" (<i>chaînette</i>)."
  },
  {
    "codigo": "56072100",
    "descricao": "-- Cordéis para atadeiras ou enfardadeiras"
  },
  {
    "codigo": "56072900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "56074100",
    "descricao": "-- Cordéis para atadeiras ou enfardadeiras"
  },
  {
    "codigo": "56074900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "56075011",
    "descricao": "De náilon"
  },
  {
    "codigo": "56075019",
    "descricao": "Outros"
  },
  {
    "codigo": "56075090",
    "descricao": "Outros"
  },
  {
    "codigo": "56079010",
    "descricao": "De algodão"
  },
  {
    "codigo": "56079020",
    "descricao": "De juta, inferior ao número métrico 0,75 por fio simples"
  },
  {
    "codigo": "56079090",
    "descricao": "Outros"
  },
  {
    "codigo": "56081100",
    "descricao": "-- Redes confeccionadas para a pesca"
  },
  {
    "codigo": "56081900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "56089000",
    "descricao": "- Outras"
  },
  {
    "codigo": "56090010",
    "descricao": "De algodão"
  },
  {
    "codigo": "56090090",
    "descricao": "Outros"
  },
  {
    "codigo": "57011011",
    "descricao": "Feitos à mão"
  },
  {
    "codigo": "57011012",
    "descricao": "Feitos a máquina"
  },
  {
    "codigo": "57011020",
    "descricao": "De pelos finos"
  },
  {
    "codigo": "57019000",
    "descricao": "- De outras matérias têxteis"
  },
  {
    "codigo": "57021000",
    "descricao": "- Tapetes denominados <i>Kelim</i> ou <i>Kilim</i>, <i>Schumacks</i> ou <i>Soumak</i>, <i>Karamanie</i> e tapetes semelhantes tecidos à mão"
  },
  {
    "codigo": "57022000",
    "descricao": "- Revestimentos para pisos (pavimentos), de cairo (fibra de coco)"
  },
  {
    "codigo": "57023100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "57023200",
    "descricao": "-- De matérias têxteis sintéticas ou artificiais"
  },
  {
    "codigo": "57023900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "57024100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "57024200",
    "descricao": "-- De matérias têxteis sintéticas ou artificiais"
  },
  {
    "codigo": "57024900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "57025010",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "57025020",
    "descricao": "De matérias têxteis sintéticas ou artificiais"
  },
  {
    "codigo": "57025090",
    "descricao": "Outros"
  },
  {
    "codigo": "57029100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "57029200",
    "descricao": "-- De matérias têxteis sintéticas ou artificiais"
  },
  {
    "codigo": "57029900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "57031000",
    "descricao": "- De lã ou de pelos finos"
  },
  {
    "codigo": "57032100",
    "descricao": "-- Grama (relva)"
  },
  {
    "codigo": "57032900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "57033100",
    "descricao": "-- Grama (relva)"
  },
  {
    "codigo": "57033900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "57039000",
    "descricao": "- De outras matérias têxteis"
  },
  {
    "codigo": "57041000",
    "descricao": "- \"Ladrilhos\" de área da superfície não superior a 0,3 m<sup>2</sup>"
  },
  {
    "codigo": "57042000",
    "descricao": "- \"Ladrilhos\" de área da superfície superior a 0,3 m<sup>2</sup>, mas não superior a 1 m<sup>2</sup>"
  },
  {
    "codigo": "57049000",
    "descricao": "- Outros"
  },
  {
    "codigo": "57050000",
    "descricao": "Outros tapetes e revestimentos para pisos (pavimentos), de matérias têxteis, mesmo confeccionados."
  },
  {
    "codigo": "58011000",
    "descricao": "- De lã ou de pelos finos"
  },
  {
    "codigo": "58012100",
    "descricao": "-- Veludos e pelúcias obtidos por trama, não cortados"
  },
  {
    "codigo": "58012200",
    "descricao": "-- Veludos e pelúcias obtidos por trama, cortados, canelados (<i>côtelés</i>)"
  },
  {
    "codigo": "58012300",
    "descricao": "-- Outros veludos e pelúcias obtidos por trama"
  },
  {
    "codigo": "58012600",
    "descricao": "-- Tecidos de froco (<i>chenille</i>)"
  },
  {
    "codigo": "58012700",
    "descricao": "-- Veludos e pelúcias obtidos por urdidura"
  },
  {
    "codigo": "58013100",
    "descricao": "-- Veludos e pelúcias obtidos por trama, não cortados"
  },
  {
    "codigo": "58013200",
    "descricao": "-- Veludos e pelúcias obtidos por trama, cortados, canelados (<i>côtelés</i>)"
  },
  {
    "codigo": "58013300",
    "descricao": "-- Outros veludos e pelúcias obtidos por trama"
  },
  {
    "codigo": "58013600",
    "descricao": "-- Tecidos de froco (<i>chenille</i>)"
  },
  {
    "codigo": "58013700",
    "descricao": "-- Veludos e pelúcias obtidos por urdidura"
  },
  {
    "codigo": "58019000",
    "descricao": "- De outras matérias têxteis"
  },
  {
    "codigo": "58021000",
    "descricao": "- Tecidos atoalhados (turcos), de algodão"
  },
  {
    "codigo": "58022000",
    "descricao": "- Tecidos atoalhados (turcos), de outras matérias têxteis"
  },
  {
    "codigo": "58023000",
    "descricao": "- Tecidos tufados"
  },
  {
    "codigo": "58030010",
    "descricao": "De algodão"
  },
  {
    "codigo": "58030090",
    "descricao": "Outros"
  },
  {
    "codigo": "58041010",
    "descricao": "De algodão"
  },
  {
    "codigo": "58041090",
    "descricao": "Outros"
  },
  {
    "codigo": "58042100",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "58042910",
    "descricao": "De algodão"
  },
  {
    "codigo": "58042990",
    "descricao": "Outras"
  },
  {
    "codigo": "58043010",
    "descricao": "De algodão"
  },
  {
    "codigo": "58043090",
    "descricao": "Outras"
  },
  {
    "codigo": "58050010",
    "descricao": "De algodão"
  },
  {
    "codigo": "58050020",
    "descricao": "De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "58050090",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "58061000",
    "descricao": "- Fitas de veludo, de pelúcias, de tecidos de froco (<i>chenille</i>) ou de tecidos atoalhados (turcos)"
  },
  {
    "codigo": "58062000",
    "descricao": "- Outras fitas que contenham, em peso, 5 % ou mais de fios de elastômeros ou de fios de borracha"
  },
  {
    "codigo": "58063100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "58063200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "58063900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "58064000",
    "descricao": "- Fitas sem trama, de fios ou fibras paralelizados e colados (<i>bolducs</i>)"
  },
  {
    "codigo": "58071000",
    "descricao": "- Tecidos"
  },
  {
    "codigo": "58079000",
    "descricao": "- Outros"
  },
  {
    "codigo": "58081000",
    "descricao": "- Tranças em peça"
  },
  {
    "codigo": "58089000",
    "descricao": "- Outros"
  },
  {
    "codigo": "58090000",
    "descricao": "Tecidos de fios de metal e tecidos de fios metálicos ou de fios têxteis metalizados da posição 56.05, do tipo utilizado em vestuário, para guarnição de interiores ou usos semelhantes, não especificados nem compreendidos noutras posições."
  },
  {
    "codigo": "58101000",
    "descricao": "- Bordados químicos ou aéreos e bordados com fundo recortado"
  },
  {
    "codigo": "58109100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "58109200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "58109900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "58110000",
    "descricao": "Artigos têxteis acolchoados em peça, constituídos por uma ou mais camadas de matérias têxteis associadas a uma matéria de enchimento ou estofamento, acolchoados por qualquer processo, exceto os bordados da posição 58.10."
  },
  {
    "codigo": "59011000",
    "descricao": "- Tecidos revestidos de cola ou de matérias amiláceas, do tipo utilizado na encadernação, cartonagem ou usos semelhantes"
  },
  {
    "codigo": "59019000",
    "descricao": "- Outros"
  },
  {
    "codigo": "59021010",
    "descricao": "Impregnadas, recobertas ou revestidas com borracha"
  },
  {
    "codigo": "59021090",
    "descricao": "Outras"
  },
  {
    "codigo": "59022000",
    "descricao": "- De poliésteres"
  },
  {
    "codigo": "59029000",
    "descricao": "- Outras"
  },
  {
    "codigo": "59031000",
    "descricao": "- Com poli(cloreto de vinila)"
  },
  {
    "codigo": "59032000",
    "descricao": "- Com poliuretano"
  },
  {
    "codigo": "59039010",
    "descricao": "De fios de poliéster, impregnados com uma ou mais resinas sintéticas, perceptíveis ou não à vista desarmada, e recobertos com uma ou mais resinas sintéticas perceptíveis à vista desarmada numa de suas faces, do tipo utilizado como suporte para fabricação de abrasivos (lixas), em rolos"
  },
  {
    "codigo": "59039090",
    "descricao": "Outros"
  },
  {
    "codigo": "59041000",
    "descricao": "- Linóleos"
  },
  {
    "codigo": "59049000",
    "descricao": "- Outros"
  },
  {
    "codigo": "59050000",
    "descricao": "Revestimentos para paredes, de matérias têxteis."
  },
  {
    "codigo": "59061000",
    "descricao": "- Fitas adesivas de largura não superior a 20 cm"
  },
  {
    "codigo": "59069100",
    "descricao": "-- De malha"
  },
  {
    "codigo": "59069900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "59070000",
    "descricao": "Outros tecidos impregnados, revestidos ou recobertos; telas pintadas para cenários teatrais, para fundos de estúdio ou para usos semelhantes."
  },
  {
    "codigo": "59080000",
    "descricao": "Mechas de matérias têxteis, tecidas, entrançadas ou tricotadas, para candeeiros, fogareiros, isqueiros, velas e semelhantes; camisas de incandescência e tecidos tubulares tricotados para a sua fabricação, mesmo impregnados."
  },
  {
    "codigo": "59090000",
    "descricao": "Mangueiras e tubos semelhantes, de matérias têxteis, mesmo com reforço ou acessórios de outras matérias."
  },
  {
    "codigo": "59100000",
    "descricao": "Correias transportadoras ou de transmissão, de matérias têxteis, mesmo impregnadas, revestidas ou recobertas, de plástico, ou estratificadas com plástico ou reforçadas com metal ou com outras matérias."
  },
  {
    "codigo": "59111000",
    "descricao": "- Tecidos, feltros e tecidos forrados de feltro, combinados com uma ou mais camadas de borracha, couro ou de outras matérias, do tipo utilizado na fabricação de guarnições de cardas, e produtos análogos para outros usos técnicos, incluindo as fitas de veludo, impregnadas de borracha, para recobrimento de cilindros de teares"
  },
  {
    "codigo": "59112010",
    "descricao": "De matéria têxtil sintética ou artificial, em peça"
  },
  {
    "codigo": "59112090",
    "descricao": "Outras"
  },
  {
    "codigo": "59113100",
    "descricao": "-- De peso inferior a 650 g/m<sup>2</sup>"
  },
  {
    "codigo": "59113200",
    "descricao": "-- De peso igual ou superior a 650 g/m<sup>2</sup>"
  },
  {
    "codigo": "59114000",
    "descricao": "- Tecidos filtrantes e tecidos espessos, do tipo utilizado em prensas de óleo ou outros usos técnicos análogos, incluindo os de cabelo"
  },
  {
    "codigo": "59119000",
    "descricao": "- Outros"
  },
  {
    "codigo": "60011010",
    "descricao": "De algodão"
  },
  {
    "codigo": "60011020",
    "descricao": "De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "60011090",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "60012100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "60012200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "60012900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "60019100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "60019200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "60019900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "60024010",
    "descricao": "De algodão"
  },
  {
    "codigo": "60024020",
    "descricao": "De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "60024090",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "60029010",
    "descricao": "De algodão"
  },
  {
    "codigo": "60029020",
    "descricao": "De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "60029090",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "60031000",
    "descricao": "- De lã ou de pelos finos"
  },
  {
    "codigo": "60032000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "60033000",
    "descricao": "- De fibras sintéticas"
  },
  {
    "codigo": "60034000",
    "descricao": "- De fibras artificiais"
  },
  {
    "codigo": "60039000",
    "descricao": "- Outros"
  },
  {
    "codigo": "60041011",
    "descricao": "Crus ou branqueados"
  },
  {
    "codigo": "60041012",
    "descricao": "Tintos"
  },
  {
    "codigo": "60041013",
    "descricao": "De fios de diversas cores"
  },
  {
    "codigo": "60041014",
    "descricao": "Estampados"
  },
  {
    "codigo": "60041031",
    "descricao": "Crus ou branqueados"
  },
  {
    "codigo": "60041032",
    "descricao": "Tintos"
  },
  {
    "codigo": "60041033",
    "descricao": "De fios de diversas cores"
  },
  {
    "codigo": "60041034",
    "descricao": "Estampados"
  },
  {
    "codigo": "60041041",
    "descricao": "Crus ou branqueados"
  },
  {
    "codigo": "60041042",
    "descricao": "Tintos"
  },
  {
    "codigo": "60041043",
    "descricao": "De fios de diversas cores"
  },
  {
    "codigo": "60041044",
    "descricao": "Estampados"
  },
  {
    "codigo": "60041091",
    "descricao": "Crus ou branqueados"
  },
  {
    "codigo": "60041092",
    "descricao": "Tintos"
  },
  {
    "codigo": "60041093",
    "descricao": "De fios de diversas cores"
  },
  {
    "codigo": "60041094",
    "descricao": "Estampados"
  },
  {
    "codigo": "60049010",
    "descricao": "De algodão"
  },
  {
    "codigo": "60049030",
    "descricao": "De fibras sintéticas"
  },
  {
    "codigo": "60049040",
    "descricao": "De fibras artificiais"
  },
  {
    "codigo": "60049090",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "60052100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "60052200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "60052300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "60052400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "60053500",
    "descricao": "-- Tecidos mencionados na Nota de subposição 1 do presente Capítulo"
  },
  {
    "codigo": "60053600",
    "descricao": "-- Outros, crus ou branqueados"
  },
  {
    "codigo": "60053700",
    "descricao": "-- Outros, tintos"
  },
  {
    "codigo": "60053800",
    "descricao": "-- Outros, de fios de diversas cores"
  },
  {
    "codigo": "60053900",
    "descricao": "-- Outros, estampados"
  },
  {
    "codigo": "60054100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "60054200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "60054300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "60054400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "60059010",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "60059090",
    "descricao": "Outros"
  },
  {
    "codigo": "60061000",
    "descricao": "- De lã ou de pelos finos"
  },
  {
    "codigo": "60062100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "60062200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "60062300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "60062400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "60063110",
    "descricao": "De náilon ou de outras poliamidas"
  },
  {
    "codigo": "60063120",
    "descricao": "De poliésteres"
  },
  {
    "codigo": "60063130",
    "descricao": "Acrílicos ou modacrílicos"
  },
  {
    "codigo": "60063190",
    "descricao": "Outros"
  },
  {
    "codigo": "60063210",
    "descricao": "De náilon ou de outras poliamidas"
  },
  {
    "codigo": "60063220",
    "descricao": "De poliésteres"
  },
  {
    "codigo": "60063230",
    "descricao": "Acrílicos ou modacrílicos"
  },
  {
    "codigo": "60063290",
    "descricao": "Outros"
  },
  {
    "codigo": "60063310",
    "descricao": "De náilon ou de outras poliamidas"
  },
  {
    "codigo": "60063320",
    "descricao": "De poliésteres"
  },
  {
    "codigo": "60063330",
    "descricao": "Acrílicos ou modacrílicos"
  },
  {
    "codigo": "60063390",
    "descricao": "Outros"
  },
  {
    "codigo": "60063410",
    "descricao": "De náilon ou de outras poliamidas"
  },
  {
    "codigo": "60063420",
    "descricao": "De poliésteres"
  },
  {
    "codigo": "60063430",
    "descricao": "Acrílicos ou modacrílicos"
  },
  {
    "codigo": "60063490",
    "descricao": "Outros"
  },
  {
    "codigo": "60064100",
    "descricao": "-- Crus ou branqueados"
  },
  {
    "codigo": "60064200",
    "descricao": "-- Tintos"
  },
  {
    "codigo": "60064300",
    "descricao": "-- De fios de diversas cores"
  },
  {
    "codigo": "60064400",
    "descricao": "-- Estampados"
  },
  {
    "codigo": "60069000",
    "descricao": "- Outros"
  },
  {
    "codigo": "61012000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "61013000",
    "descricao": "- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61019010",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "61019090",
    "descricao": "Outros"
  },
  {
    "codigo": "61021000",
    "descricao": "- De lã ou de pelos finos"
  },
  {
    "codigo": "61022000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "61023000",
    "descricao": "- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61029000",
    "descricao": "- De outras matérias têxteis"
  },
  {
    "codigo": "61031010",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "61031020",
    "descricao": "De fibras sintéticas"
  },
  {
    "codigo": "61031090",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "61032200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61032300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61032910",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "61032990",
    "descricao": "Outros"
  },
  {
    "codigo": "61033100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "61033200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61033300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61033900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61034100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "61034200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61034300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61034900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61041300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61041910",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "61041920",
    "descricao": "De algodão"
  },
  {
    "codigo": "61041990",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "61042200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61042300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61042910",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "61042990",
    "descricao": "Outros"
  },
  {
    "codigo": "61043100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "61043200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61043300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61043900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61044100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "61044200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61044300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61044400",
    "descricao": "-- De fibras artificiais"
  },
  {
    "codigo": "61044900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61045100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "61045200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61045300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61045900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61046100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "61046200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61046300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61046900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61051000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "61052000",
    "descricao": "- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61059000",
    "descricao": "- De outras matérias têxteis"
  },
  {
    "codigo": "61061000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "61062000",
    "descricao": "- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61069000",
    "descricao": "- De outras matérias têxteis"
  },
  {
    "codigo": "61071100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61071200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61071900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61072100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61072200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61072900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61079100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61079910",
    "descricao": "De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61079990",
    "descricao": "Outros"
  },
  {
    "codigo": "61081100",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61081900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61082100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61082200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61082900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61083100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61083200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61083900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61089100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61089200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61089900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61091000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "61099000",
    "descricao": "- De outras matérias têxteis"
  },
  {
    "codigo": "61101100",
    "descricao": "-- De lã"
  },
  {
    "codigo": "61101200",
    "descricao": "-- De cabra de Caxemira"
  },
  {
    "codigo": "61101900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "61102000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "61103000",
    "descricao": "- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61109000",
    "descricao": "- De outras matérias têxteis"
  },
  {
    "codigo": "61112000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "61113000",
    "descricao": "- De fibras sintéticas"
  },
  {
    "codigo": "61119010",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "61119090",
    "descricao": "Outros"
  },
  {
    "codigo": "61121100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61121200",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61121900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61122000",
    "descricao": "- Macacões (Fatos-macacos*) e conjuntos, de esqui"
  },
  {
    "codigo": "61123100",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61123900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61124100",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61124900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61130000",
    "descricao": "Vestuário confeccionado com tecidos de malha das posições 59.03, 59.06 ou 59.07."
  },
  {
    "codigo": "61142000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "61143000",
    "descricao": "- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61149010",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "61149090",
    "descricao": "Outros"
  },
  {
    "codigo": "61151011",
    "descricao": "De fibras sintéticas, de título inferior a 67 decitex por fio simples"
  },
  {
    "codigo": "61151012",
    "descricao": "De fibras sintéticas, de título igual ou superior a 67 decitex por fio simples"
  },
  {
    "codigo": "61151013",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "61151014",
    "descricao": "De algodão"
  },
  {
    "codigo": "61151019",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "61151021",
    "descricao": "De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61151022",
    "descricao": "De algodão"
  },
  {
    "codigo": "61151029",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "61151091",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "61151092",
    "descricao": "De algodão"
  },
  {
    "codigo": "61151093",
    "descricao": "De fibras sintéticas"
  },
  {
    "codigo": "61151099",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "61152100",
    "descricao": "-- De fibras sintéticas, de título inferior a 67 decitex por fio simples"
  },
  {
    "codigo": "61152200",
    "descricao": "-- De fibras sintéticas, de título igual ou superior a 67 decitex por fio simples"
  },
  {
    "codigo": "61152910",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "61152920",
    "descricao": "De algodão"
  },
  {
    "codigo": "61152990",
    "descricao": "Outras"
  },
  {
    "codigo": "61153010",
    "descricao": "De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "61153020",
    "descricao": "De algodão"
  },
  {
    "codigo": "61153090",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "61159400",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "61159500",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61159600",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61159900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61161000",
    "descricao": "- Impregnadas, revestidas, recobertas ou estratificadas, de plástico ou de borracha"
  },
  {
    "codigo": "61169100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "61169200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "61169300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "61169900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "61171000",
    "descricao": "- Xales, echarpes, lenços de pescoço, cachenês, cachecóis, mantilhas, véus e semelhantes"
  },
  {
    "codigo": "61178010",
    "descricao": "Gravatas, gravatas-borboletas e <i>plastrons</i>"
  },
  {
    "codigo": "61178090",
    "descricao": "Outros"
  },
  {
    "codigo": "61179000",
    "descricao": "- Partes"
  },
  {
    "codigo": "62012000",
    "descricao": "- De lã ou de pelos finos"
  },
  {
    "codigo": "62013000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "62014000",
    "descricao": "- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "62019000",
    "descricao": "- De outras matérias têxteis"
  },
  {
    "codigo": "62022000",
    "descricao": "- De lã ou de pelos finos"
  },
  {
    "codigo": "62023000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "62024000",
    "descricao": "- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "62029000",
    "descricao": "- De outras matérias têxteis"
  },
  {
    "codigo": "62031100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "62031200",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "62031900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62032200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62032300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "62032910",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "62032990",
    "descricao": "Outros"
  },
  {
    "codigo": "62033100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "62033200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62033300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "62033900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62034100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "62034200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62034300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "62034900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62041100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "62041200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62041300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "62041900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62042100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "62042200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62042300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "62042900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62043100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "62043200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62043300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "62043900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62044100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "62044200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62044300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "62044400",
    "descricao": "-- De fibras artificiais"
  },
  {
    "codigo": "62044900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62045100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "62045200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62045300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "62045900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62046100",
    "descricao": "-- De lã ou de pelos finos"
  },
  {
    "codigo": "62046200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62046300",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "62046900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62052000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "62053000",
    "descricao": "- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "62059010",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "62059090",
    "descricao": "Outras"
  },
  {
    "codigo": "62061000",
    "descricao": "- De seda ou de desperdícios de seda"
  },
  {
    "codigo": "62062000",
    "descricao": "- De lã ou de pelos finos"
  },
  {
    "codigo": "62063000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "62064000",
    "descricao": "- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "62069000",
    "descricao": "- De outras matérias têxteis"
  },
  {
    "codigo": "62071100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62071900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62072100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62072200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "62072900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62079100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62079910",
    "descricao": "De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "62079990",
    "descricao": "Outros"
  },
  {
    "codigo": "62081100",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "62081900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62082100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62082200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "62082900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62089100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62089200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "62089900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62092000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "62093000",
    "descricao": "- De fibras sintéticas"
  },
  {
    "codigo": "62099010",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "62099090",
    "descricao": "Outras"
  },
  {
    "codigo": "62101000",
    "descricao": "- Com as matérias das posições 56.02 ou 56.03"
  },
  {
    "codigo": "62102000",
    "descricao": "- Outro vestuário, do tipo abrangido pela posição 62.01"
  },
  {
    "codigo": "62103000",
    "descricao": "- Outro vestuário, do tipo abrangido pela posição 62.02"
  },
  {
    "codigo": "62104000",
    "descricao": "- Outro vestuário de uso masculino"
  },
  {
    "codigo": "62105000",
    "descricao": "- Outro vestuário de uso feminino"
  },
  {
    "codigo": "62111100",
    "descricao": "-- De uso masculino"
  },
  {
    "codigo": "62111200",
    "descricao": "-- De uso feminino"
  },
  {
    "codigo": "62112000",
    "descricao": "- Macacões (Fatos-macacos*) e conjuntos, de esqui"
  },
  {
    "codigo": "62113200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62113300",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "62113910",
    "descricao": "De lã ou de pelos finos"
  },
  {
    "codigo": "62113990",
    "descricao": "Outras"
  },
  {
    "codigo": "62114200",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "62114300",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "62114900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "62121000",
    "descricao": "- Sutiãs e bustiês (sutiãs de cós alto*)"
  },
  {
    "codigo": "62122000",
    "descricao": "- Cintas e cintas-calças"
  },
  {
    "codigo": "62123000",
    "descricao": "- Modeladores de torso inteiro (Cintas-sutiãs*)"
  },
  {
    "codigo": "62129000",
    "descricao": "- Outros"
  },
  {
    "codigo": "62132000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "62139010",
    "descricao": "De seda ou de desperdícios de seda"
  },
  {
    "codigo": "62139090",
    "descricao": "Outros"
  },
  {
    "codigo": "62141000",
    "descricao": "- De seda ou de desperdícios de seda"
  },
  {
    "codigo": "62142000",
    "descricao": "- De lã ou de pelos finos"
  },
  {
    "codigo": "62143000",
    "descricao": "- De fibras sintéticas"
  },
  {
    "codigo": "62144000",
    "descricao": "- De fibras artificiais"
  },
  {
    "codigo": "62149010",
    "descricao": "De algodão"
  },
  {
    "codigo": "62149090",
    "descricao": "Outros"
  },
  {
    "codigo": "62151000",
    "descricao": "- De seda ou de desperdícios de seda"
  },
  {
    "codigo": "62152000",
    "descricao": "- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "62159000",
    "descricao": "- De outras matérias têxteis"
  },
  {
    "codigo": "62160000",
    "descricao": "Luvas, mitenes e semelhantes."
  },
  {
    "codigo": "62171000",
    "descricao": "- Acessórios"
  },
  {
    "codigo": "62179000",
    "descricao": "- Partes"
  },
  {
    "codigo": "63011000",
    "descricao": "- Cobertores e mantas, elétricos"
  },
  {
    "codigo": "63012000",
    "descricao": "- Cobertores e mantas (exceto os elétricos), de lã ou de pelos finos"
  },
  {
    "codigo": "63013000",
    "descricao": "- Cobertores e mantas (exceto os elétricos), de algodão"
  },
  {
    "codigo": "63014000",
    "descricao": "- Cobertores e mantas (exceto os elétricos), de fibras sintéticas"
  },
  {
    "codigo": "63019000",
    "descricao": "- Outros cobertores e mantas"
  },
  {
    "codigo": "63021000",
    "descricao": "- Roupa de cama, de malha"
  },
  {
    "codigo": "63022100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "63022200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "63022900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "63023100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "63023200",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "63023900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "63024000",
    "descricao": "- Roupa de mesa, de malha"
  },
  {
    "codigo": "63025100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "63025300",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "63025910",
    "descricao": "De linho"
  },
  {
    "codigo": "63025990",
    "descricao": "Outras"
  },
  {
    "codigo": "63026000",
    "descricao": "- Roupa de toucador ou de cozinha, de tecidos atoalhados (turcos) de algodão"
  },
  {
    "codigo": "63029100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "63029300",
    "descricao": "-- De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "63029910",
    "descricao": "De linho"
  },
  {
    "codigo": "63029990",
    "descricao": "Outras"
  },
  {
    "codigo": "63031200",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "63031910",
    "descricao": "De algodão"
  },
  {
    "codigo": "63031990",
    "descricao": "Outros"
  },
  {
    "codigo": "63039100",
    "descricao": "-- De algodão"
  },
  {
    "codigo": "63039200",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "63039900",
    "descricao": "-- De outras matérias têxteis"
  },
  {
    "codigo": "63041100",
    "descricao": "-- De malha"
  },
  {
    "codigo": "63041910",
    "descricao": "De algodão"
  },
  {
    "codigo": "63041990",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "63042000",
    "descricao": "- Mosquiteiros para camas mencionados na Nota de subposição 1 do presente Capítulo"
  },
  {
    "codigo": "63049100",
    "descricao": "-- De malha"
  },
  {
    "codigo": "63049200",
    "descricao": "-- De algodão, exceto de malha"
  },
  {
    "codigo": "63049300",
    "descricao": "-- De fibras sintéticas, exceto de malha"
  },
  {
    "codigo": "63049900",
    "descricao": "-- De outras matérias têxteis, exceto de malha"
  },
  {
    "codigo": "63051000",
    "descricao": "- De juta ou de outras fibras têxteis liberianas da posição 53.03"
  },
  {
    "codigo": "63052000",
    "descricao": "- De algodão"
  },
  {
    "codigo": "63053200",
    "descricao": "-- Recipientes flexíveis para produtos a granel"
  },
  {
    "codigo": "63053310",
    "descricao": "De malha"
  },
  {
    "codigo": "63053390",
    "descricao": "Outros"
  },
  {
    "codigo": "63053900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "63059000",
    "descricao": "- De outras matérias têxteis"
  },
  {
    "codigo": "63061200",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "63061910",
    "descricao": "De algodão"
  },
  {
    "codigo": "63061990",
    "descricao": "Outros"
  },
  {
    "codigo": "63062200",
    "descricao": "-- De fibras sintéticas"
  },
  {
    "codigo": "63062910",
    "descricao": "De algodão"
  },
  {
    "codigo": "63062990",
    "descricao": "Outros"
  },
  {
    "codigo": "63063010",
    "descricao": "De fibras sintéticas"
  },
  {
    "codigo": "63063090",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "63064010",
    "descricao": "De algodão"
  },
  {
    "codigo": "63064090",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "63069000",
    "descricao": "- Outros"
  },
  {
    "codigo": "63071000",
    "descricao": "- Rodilhas, esfregões, panos de prato ou de cozinha, flanelas e artigos de limpeza semelhantes"
  },
  {
    "codigo": "63072000",
    "descricao": "- Cintos e coletes salva-vidas"
  },
  {
    "codigo": "63079010",
    "descricao": "De falso tecido (tecido não tecido)"
  },
  {
    "codigo": "63079020",
    "descricao": "Artigo tubular com tratamento ignífugo, próprio para saída de emergência de pessoas, mesmo com seus elementos de montagem"
  },
  {
    "codigo": "63079090",
    "descricao": "Outros"
  },
  {
    "codigo": "63080000",
    "descricao": "Sortidos constituídos por cortes de tecido e fios, mesmo com acessórios, para confecção de tapetes, tapeçarias, toalhas de mesa ou guardanapos, bordados, ou artigos têxteis semelhantes, em embalagens para venda a retalho."
  },
  {
    "codigo": "63090010",
    "descricao": "Vestuário, seus acessórios, e suas partes"
  },
  {
    "codigo": "63090090",
    "descricao": "Outros"
  },
  {
    "codigo": "63101000",
    "descricao": "- Selecionados"
  },
  {
    "codigo": "63109000",
    "descricao": "- Outros"
  },
  {
    "codigo": "64011000",
    "descricao": "- Calçado com biqueira protetora de metal"
  },
  {
    "codigo": "64019200",
    "descricao": "-- Cobrindo o tornozelo, mas não o joelho"
  },
  {
    "codigo": "64019910",
    "descricao": "Cobrindo o joelho"
  },
  {
    "codigo": "64019990",
    "descricao": "Outro"
  },
  {
    "codigo": "64021200",
    "descricao": "-- Calçado para esqui e para surfe de neve"
  },
  {
    "codigo": "64021900",
    "descricao": "-- Outro"
  },
  {
    "codigo": "64022000",
    "descricao": "- Calçado com parte superior em tiras ou correias, fixados à sola por pregos, tachas, pinos e semelhantes"
  },
  {
    "codigo": "64029110",
    "descricao": "Com biqueira protetora de metal"
  },
  {
    "codigo": "64029190",
    "descricao": "Outro"
  },
  {
    "codigo": "64029910",
    "descricao": "Com biqueira protetora de metal"
  },
  {
    "codigo": "64029990",
    "descricao": "Outro"
  },
  {
    "codigo": "64031200",
    "descricao": "-- Calçado para esqui e para surfe de neve"
  },
  {
    "codigo": "64031900",
    "descricao": "-- Outro"
  },
  {
    "codigo": "64032000",
    "descricao": "- Calçado com sola exterior de couro natural e parte superior constituída por tiras de couro natural passando pelo peito do pé e envolvendo o dedo grande"
  },
  {
    "codigo": "64034000",
    "descricao": "- Outro calçado, com biqueira protetora de metal"
  },
  {
    "codigo": "64035110",
    "descricao": "Com sola de madeira e desprovido de palmilha"
  },
  {
    "codigo": "64035190",
    "descricao": "Outro"
  },
  {
    "codigo": "64035910",
    "descricao": "Com sola de madeira e desprovido de palmilha"
  },
  {
    "codigo": "64035990",
    "descricao": "Outro"
  },
  {
    "codigo": "64039110",
    "descricao": "Com sola de madeira e desprovido de palmilha"
  },
  {
    "codigo": "64039190",
    "descricao": "Outro"
  },
  {
    "codigo": "64039910",
    "descricao": "Com sola de madeira e desprovido de palmilha"
  },
  {
    "codigo": "64039990",
    "descricao": "Outro"
  },
  {
    "codigo": "64041100",
    "descricao": "-- Calçado para esporte; calçado para tênis, basquetebol, ginástica, treino e semelhantes"
  },
  {
    "codigo": "64041900",
    "descricao": "-- Outro"
  },
  {
    "codigo": "64042000",
    "descricao": "- Calçado com sola exterior de couro natural ou reconstituído"
  },
  {
    "codigo": "64051010",
    "descricao": "Com sola exterior de borracha ou plástico e parte superior de couro reconstituído"
  },
  {
    "codigo": "64051020",
    "descricao": "Com sola exterior de couro natural ou reconstituído e parte superior de couro reconstituído"
  },
  {
    "codigo": "64051090",
    "descricao": "Outro"
  },
  {
    "codigo": "64052000",
    "descricao": "- Com parte superior de matérias têxteis"
  },
  {
    "codigo": "64059000",
    "descricao": "- Outro"
  },
  {
    "codigo": "64061000",
    "descricao": "- Partes superiores de calçado e seus componentes, exceto contrafortes e biqueiras rígidas"
  },
  {
    "codigo": "64062000",
    "descricao": "- Solas exteriores e saltos, de borracha ou plástico"
  },
  {
    "codigo": "64069010",
    "descricao": "Solas exteriores e saltos, de couro natural ou reconstituído"
  },
  {
    "codigo": "64069020",
    "descricao": "Palmilhas"
  },
  {
    "codigo": "64069090",
    "descricao": "Outros"
  },
  {
    "codigo": "65010000",
    "descricao": "Esboços não enformados nem na copa nem na aba, discos e cilindros, mesmo cortados no sentido da altura, de feltro, para chapéus."
  },
  {
    "codigo": "65020010",
    "descricao": "De palha fina (manila, panamá e semelhantes)"
  },
  {
    "codigo": "65020090",
    "descricao": "Outros"
  },
  {
    "codigo": "65040010",
    "descricao": "De palha fina (manila, panamá e semelhantes)"
  },
  {
    "codigo": "65040090",
    "descricao": "Outros"
  },
  {
    "codigo": "65050011",
    "descricao": "De algodão"
  },
  {
    "codigo": "65050012",
    "descricao": "De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "65050019",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "65050021",
    "descricao": "De algodão"
  },
  {
    "codigo": "65050022",
    "descricao": "De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "65050029",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "65050031",
    "descricao": "De algodão"
  },
  {
    "codigo": "65050032",
    "descricao": "De fibras sintéticas ou artificiais"
  },
  {
    "codigo": "65050039",
    "descricao": "De outras matérias têxteis"
  },
  {
    "codigo": "65050090",
    "descricao": "Outros"
  },
  {
    "codigo": "65061010",
    "descricao": "Do tipo utilizado por bombeiros, com viseira e protetor facial incorporados"
  },
  {
    "codigo": "65061090",
    "descricao": "Outros"
  },
  {
    "codigo": "65069100",
    "descricao": "-- De borracha ou de plástico"
  },
  {
    "codigo": "65069900",
    "descricao": "-- De outras matérias"
  },
  {
    "codigo": "65070000",
    "descricao": "Carneiras, forros, capas, armações, palas e barbicachos (francaletes*), para chapéus e artigos de uso semelhante."
  },
  {
    "codigo": "66011000",
    "descricao": "- Guarda-sóis de jardim e artigos semelhantes"
  },
  {
    "codigo": "66019110",
    "descricao": "Cobertos de tecido de seda ou de matérias têxteis sintéticas ou artificiais"
  },
  {
    "codigo": "66019190",
    "descricao": "Outros"
  },
  {
    "codigo": "66019900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "66020000",
    "descricao": "Bengalas, bengalas-assentos, chicotes, pingalins e artigos semelhantes."
  },
  {
    "codigo": "66032000",
    "descricao": "- Armações montadas, mesmo com hastes ou cabos, para guarda-chuvas, sombrinhas ou guarda-sóis"
  },
  {
    "codigo": "66039000",
    "descricao": "- Outros"
  },
  {
    "codigo": "67010000",
    "descricao": "Peles e outras partes de aves, com as suas penas ou penugem, penas, partes de penas, penugem e artigos destas matérias, exceto os produtos da posição 05.05, bem como os cálamos e outros canos de penas, trabalhados."
  },
  {
    "codigo": "67021000",
    "descricao": "- De plástico"
  },
  {
    "codigo": "67029000",
    "descricao": "- De outras matérias"
  },
  {
    "codigo": "67030000",
    "descricao": "Cabelo disposto no mesmo sentido, adelgaçado, branqueado ou preparado de outro modo; lã, pelos e outras matérias têxteis, preparados para fabricação de perucas ou de artigos semelhantes."
  },
  {
    "codigo": "67041100",
    "descricao": "-- Perucas completas"
  },
  {
    "codigo": "67041900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "67042000",
    "descricao": "- De cabelo"
  },
  {
    "codigo": "67049000",
    "descricao": "- De outras matérias"
  },
  {
    "codigo": "68010000",
    "descricao": "Pedras para calcetar, meios-fios (lancis) e placas (lajes) para pavimentação, de pedra natural (exceto a ardósia)."
  },
  {
    "codigo": "68021000",
    "descricao": "- Ladrilhos, cubos, pastilhas e artigos semelhantes, mesmo de forma diferente da quadrada ou retangular, cuja maior superfície possa ser inscrita num quadrado de lado inferior a 7 cm; grânulos, fragmentos e pós, corados artificialmente"
  },
  {
    "codigo": "68022100",
    "descricao": "-- Mármore, travertino e alabastro"
  },
  {
    "codigo": "68022300",
    "descricao": "-- Granito"
  },
  {
    "codigo": "68022900",
    "descricao": "-- Outras pedras"
  },
  {
    "codigo": "68029100",
    "descricao": "-- Mármore, travertino e alabastro"
  },
  {
    "codigo": "68029200",
    "descricao": "-- Outras pedras calcárias"
  },
  {
    "codigo": "68029310",
    "descricao": "Esferas para moinho"
  },
  {
    "codigo": "68029390",
    "descricao": "Outros"
  },
  {
    "codigo": "68029910",
    "descricao": "Esferas para moinho"
  },
  {
    "codigo": "68029990",
    "descricao": "Outras"
  },
  {
    "codigo": "68030000",
    "descricao": "Ardósia natural trabalhada e obras de ardósia natural ou aglomerada."
  },
  {
    "codigo": "68041000",
    "descricao": "- Mós para moer ou desfibrar"
  },
  {
    "codigo": "68042111",
    "descricao": "Aglomerados com resina"
  },
  {
    "codigo": "68042119",
    "descricao": "Outros"
  },
  {
    "codigo": "68042190",
    "descricao": "Outros"
  },
  {
    "codigo": "68042211",
    "descricao": "Aglomerados com resina"
  },
  {
    "codigo": "68042219",
    "descricao": "Outros"
  },
  {
    "codigo": "68042290",
    "descricao": "Outros"
  },
  {
    "codigo": "68042300",
    "descricao": "-- De pedras naturais"
  },
  {
    "codigo": "68043000",
    "descricao": "- Pedras para amolar ou para polir, manualmente"
  },
  {
    "codigo": "68051000",
    "descricao": "- Aplicados apenas sobre tecidos de matérias têxteis"
  },
  {
    "codigo": "68052000",
    "descricao": "- Aplicados apenas sobre papel ou cartão"
  },
  {
    "codigo": "68053010",
    "descricao": "Com suporte de papel ou cartão combinados com matérias têxteis"
  },
  {
    "codigo": "68053020",
    "descricao": "Discos de fibra vulcanizada recobertos com óxido de alumínio ou carboneto de silício"
  },
  {
    "codigo": "68053090",
    "descricao": "Outros"
  },
  {
    "codigo": "68061000",
    "descricao": "- Lãs de escórias de altos-fornos, lãs de outras escórias, lã de rocha e lãs minerais semelhantes, mesmo misturadas entre si, a granel, em folhas ou em rolos"
  },
  {
    "codigo": "68062000",
    "descricao": "- Vermiculita e argilas, expandidas, espuma de escórias e produtos minerais semelhantes, expandidos, mesmo misturados entre si"
  },
  {
    "codigo": "68069010",
    "descricao": "Aluminosos ou silicoaluminosos"
  },
  {
    "codigo": "68069090",
    "descricao": "Outros"
  },
  {
    "codigo": "68071000",
    "descricao": "- Em rolos"
  },
  {
    "codigo": "68079000",
    "descricao": "- Outras"
  },
  {
    "codigo": "68080000",
    "descricao": "Painéis, chapas, ladrilhos, blocos e semelhantes, de fibras vegetais, palha ou aparas, partículas, serragem (serradura) ou outros desperdícios de madeira, aglomerados com cimento, gesso ou outros aglutinantes minerais."
  },
  {
    "codigo": "68091100",
    "descricao": "-- Revestidos ou reforçados exclusivamente com papel ou cartão"
  },
  {
    "codigo": "68091900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "68099000",
    "descricao": "- Outras obras"
  },
  {
    "codigo": "68101100",
    "descricao": "-- Blocos e tijolos para a construção"
  },
  {
    "codigo": "68101900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "68109100",
    "descricao": "-- Elementos pré-fabricados para a construção ou engenharia civil"
  },
  {
    "codigo": "68109900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "68114000",
    "descricao": "- Que contenham amianto"
  },
  {
    "codigo": "68118100",
    "descricao": "-- Placas onduladas"
  },
  {
    "codigo": "68118200",
    "descricao": "-- Outras placas, painéis, ladrilhos, telhas e artigos semelhantes"
  },
  {
    "codigo": "68118900",
    "descricao": "-- Outras obras"
  },
  {
    "codigo": "68128000",
    "descricao": "- De crocidolita"
  },
  {
    "codigo": "68129100",
    "descricao": "-- Vestuário, acessórios de vestuário, calçado e chapéus"
  },
  {
    "codigo": "68129910",
    "descricao": "Juntas e outros elementos com função semelhante de vedação"
  },
  {
    "codigo": "68129920",
    "descricao": "Amianto trabalhado, em fibras"
  },
  {
    "codigo": "68129930",
    "descricao": "Misturas à base de amianto ou à base de amianto e carbonato de magnésio"
  },
  {
    "codigo": "68129990",
    "descricao": "Outras"
  },
  {
    "codigo": "68132000",
    "descricao": "- Que contenham amianto"
  },
  {
    "codigo": "68138110",
    "descricao": "Pastilhas"
  },
  {
    "codigo": "68138190",
    "descricao": "Outras"
  },
  {
    "codigo": "68138910",
    "descricao": "Disco de fricção para embreagens"
  },
  {
    "codigo": "68138990",
    "descricao": "Outras"
  },
  {
    "codigo": "68141000",
    "descricao": "- Placas, folhas ou tiras, de mica aglomerada ou reconstituída, mesmo com suporte"
  },
  {
    "codigo": "68149000",
    "descricao": "- Outras"
  },
  {
    "codigo": "68151100",
    "descricao": "-- Fibras de carbono"
  },
  {
    "codigo": "68151200",
    "descricao": "-- Têxteis de fibras de carbono"
  },
  {
    "codigo": "68151300",
    "descricao": "-- Outras obras de fibras de carbono"
  },
  {
    "codigo": "68151900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "68152000",
    "descricao": "- Obras de turfa"
  },
  {
    "codigo": "68159110",
    "descricao": "Crus, aglomerados com aglutinante químico"
  },
  {
    "codigo": "68159190",
    "descricao": "Outras"
  },
  {
    "codigo": "68159911",
    "descricao": "Com um teor de alumina (Al<sub>2</sub>O<sub>3</sub>), igual ou superior a 90 %, em peso"
  },
  {
    "codigo": "68159912",
    "descricao": "Com um teor de silica (SiO<sub>2</sub>) igual ou superior a 90 %, em peso"
  },
  {
    "codigo": "68159913",
    "descricao": "Com um teor, em peso, de óxido de zircônio (ZrO<sub>2</sub>) igual ou superior a 50 % mesmo com um conteúdo de alumina inferior a 45 %"
  },
  {
    "codigo": "68159914",
    "descricao": "Constituídas por uma mistura ou combinação de alumina (Al<sub>2</sub>O<sub>3</sub>), silica (SiO<sub>2</sub>) e óxido de zircônio (ZrO<sub>2</sub>), com um teor, em peso, de alumina igual ou superior a 45 %, mas inferior a 90 % ou com um conteúdo, em peso, de óxido de zircônio (ZrO<sub>2</sub>) igual ou superior a 20 %, mas inferior a 50 %"
  },
  {
    "codigo": "68159919",
    "descricao": "Outras"
  },
  {
    "codigo": "68159990",
    "descricao": "Outras"
  },
  {
    "codigo": "69010000",
    "descricao": "Tijolos, placas (lajes), ladrilhos e outras peças cerâmicas de farinhas siliciosas fósseis (por exemplo, <i>kieselguhr</i>, tripolita, diatomita) ou de terras siliciosas semelhantes."
  },
  {
    "codigo": "69021011",
    "descricao": "Tijolos ou placas, que contenham, em peso, mais de 90 % de trióxido de dicromo"
  },
  {
    "codigo": "69021018",
    "descricao": "Outros tijolos"
  },
  {
    "codigo": "69021019",
    "descricao": "Outros"
  },
  {
    "codigo": "69021090",
    "descricao": "Outros"
  },
  {
    "codigo": "69022010",
    "descricao": "Tijolos sílico-aluminosos"
  },
  {
    "codigo": "69022091",
    "descricao": "Sílico-aluminosos"
  },
  {
    "codigo": "69022092",
    "descricao": "Silicoso, semi-silicoso ou de sílica"
  },
  {
    "codigo": "69022093",
    "descricao": "De silimanita"
  },
  {
    "codigo": "69022099",
    "descricao": "Outros"
  },
  {
    "codigo": "69029010",
    "descricao": "De grafita"
  },
  {
    "codigo": "69029020",
    "descricao": "Não fundidos, com um teor de óxido de zircônio (ZrO<sub>2</sub>) superior a 25 %, em peso"
  },
  {
    "codigo": "69029030",
    "descricao": "Com um teor de carbono superior a 85 %, em peso, e diâmetro médio de poro inferior ou igual a 5 micrômetros (mícrons), do tipo utilizado em altos-fornos"
  },
  {
    "codigo": "69029040",
    "descricao": "De carboneto de silício"
  },
  {
    "codigo": "69029090",
    "descricao": "Outros"
  },
  {
    "codigo": "69031011",
    "descricao": "De grafita, exceto os do subitem 6903.10.12"
  },
  {
    "codigo": "69031012",
    "descricao": "Elaborados com uma mistura de grafita e carboneto de silício"
  },
  {
    "codigo": "69031019",
    "descricao": "Outros"
  },
  {
    "codigo": "69031020",
    "descricao": "Retortas elaboradas com uma mistura de grafita e carboneto de silício"
  },
  {
    "codigo": "69031030",
    "descricao": "Tampas e tampões"
  },
  {
    "codigo": "69031040",
    "descricao": "Tubos"
  },
  {
    "codigo": "69031090",
    "descricao": "Outros"
  },
  {
    "codigo": "69032010",
    "descricao": "Cadinhos"
  },
  {
    "codigo": "69032020",
    "descricao": "Tampas e tampões"
  },
  {
    "codigo": "69032030",
    "descricao": "Tubos"
  },
  {
    "codigo": "69032090",
    "descricao": "Outros"
  },
  {
    "codigo": "69039011",
    "descricao": "De carboneto de silício"
  },
  {
    "codigo": "69039012",
    "descricao": "De compostos de zircônio"
  },
  {
    "codigo": "69039019",
    "descricao": "Outros"
  },
  {
    "codigo": "69039091",
    "descricao": "De carboneto de silício"
  },
  {
    "codigo": "69039092",
    "descricao": "De compostos de zircônio"
  },
  {
    "codigo": "69039099",
    "descricao": "Outros"
  },
  {
    "codigo": "69041000",
    "descricao": "- Tijolos para construção"
  },
  {
    "codigo": "69049000",
    "descricao": "- Outros"
  },
  {
    "codigo": "69051000",
    "descricao": "- Telhas"
  },
  {
    "codigo": "69059000",
    "descricao": "- Outros"
  },
  {
    "codigo": "69060000",
    "descricao": "Tubos, calhas ou algerozes e acessórios para canalizações, de cerâmica."
  },
  {
    "codigo": "69072100",
    "descricao": "-- Com um coeficiente de absorção de água, em peso, não superior a 0,5 %"
  },
  {
    "codigo": "69072200",
    "descricao": "-- Com um coeficiente de absorção de água, em peso, superior a 0,5 %, mas não superior a 10 %"
  },
  {
    "codigo": "69072300",
    "descricao": "-- Com um coeficiente de absorção de água, em peso, superior a 10 %"
  },
  {
    "codigo": "69073000",
    "descricao": "- Cubos, pastilhas e artigos semelhantes, para mosaicos, exceto os da subposição 6907.40"
  },
  {
    "codigo": "69074000",
    "descricao": "- Peças de acabamento"
  },
  {
    "codigo": "69091100",
    "descricao": "-- De porcelana"
  },
  {
    "codigo": "69091210",
    "descricao": "Guia-fios para máquina têxtil"
  },
  {
    "codigo": "69091220",
    "descricao": "Guias de agulhas para cabeças de impressão"
  },
  {
    "codigo": "69091230",
    "descricao": "Anéis de carboneto de silício para juntas de vedação mecânicas"
  },
  {
    "codigo": "69091290",
    "descricao": "Outros"
  },
  {
    "codigo": "69091910",
    "descricao": "Guia-fios para máquina têxtil"
  },
  {
    "codigo": "69091920",
    "descricao": "Guias de agulhas para cabeças de impressão"
  },
  {
    "codigo": "69091930",
    "descricao": "Colmeia de cerâmica à base de alumina (Al<sub>2</sub>O<sub>3</sub>), sílica (SiO<sub>2</sub>) e óxido de magnésio (MgO), de depuradores por conversão catalítica de gases de escape de veículos"
  },
  {
    "codigo": "69091990",
    "descricao": "Outros"
  },
  {
    "codigo": "69099000",
    "descricao": "- Outros"
  },
  {
    "codigo": "69101000",
    "descricao": "- De porcelana"
  },
  {
    "codigo": "69109000",
    "descricao": "- Outros"
  },
  {
    "codigo": "69111010",
    "descricao": "Conjunto (jogo ou aparelho) para jantar, café ou chá, apresentado em embalagem comum"
  },
  {
    "codigo": "69111090",
    "descricao": "Outros"
  },
  {
    "codigo": "69119000",
    "descricao": "- Outros"
  },
  {
    "codigo": "69120000",
    "descricao": "Serviços de mesa, artigos de cozinha, outros artigos de uso doméstico e artigos de higiene ou de toucador, de cerâmica, exceto de porcelana."
  },
  {
    "codigo": "69131000",
    "descricao": "- De porcelana"
  },
  {
    "codigo": "69139000",
    "descricao": "- Outros"
  },
  {
    "codigo": "69141000",
    "descricao": "- De porcelana"
  },
  {
    "codigo": "69149000",
    "descricao": "- Outras"
  },
  {
    "codigo": "70010000",
    "descricao": "Cacos, fragmentos e outros desperdícios e resíduos de vidro, exceto o vidro de tubos catódicos e outros vidros ativados da posição 85.49; vidro em blocos ou massas."
  },
  {
    "codigo": "70021000",
    "descricao": "- Esferas"
  },
  {
    "codigo": "70022000",
    "descricao": "- Barras ou varetas"
  },
  {
    "codigo": "70023100",
    "descricao": "-- De quartzo ou de outras sílicas fundidos"
  },
  {
    "codigo": "70023200",
    "descricao": "-- De outro vidro com um coeficiente de dilatação linear não superior a 5 x 10<sup>-</sup><sup>6</sup> por Kelvin, entre 0 °C e 300 °C"
  },
  {
    "codigo": "70023900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "70031200",
    "descricao": "-- Coradas na massa, opacificadas, folheadas (chapeadas), ou com camada absorvente, refletora ou não"
  },
  {
    "codigo": "70031900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "70032000",
    "descricao": "- Chapas e folhas, armadas"
  },
  {
    "codigo": "70033000",
    "descricao": "- Perfis"
  },
  {
    "codigo": "70042000",
    "descricao": "- Vidro corado na massa, opacificado, folheado (chapeado), ou com camada absorvente, refletora ou não"
  },
  {
    "codigo": "70049000",
    "descricao": "- Outro vidro"
  },
  {
    "codigo": "70051000",
    "descricao": "- Vidro não armado, com camada absorvente, refletora ou não"
  },
  {
    "codigo": "70052100",
    "descricao": "-- Corado na massa, opacificado, folheado (chapeado) ou simplesmente desbastado"
  },
  {
    "codigo": "70052900",
    "descricao": "-- Outro"
  },
  {
    "codigo": "70053000",
    "descricao": "- Vidro armado"
  },
  {
    "codigo": "70060000",
    "descricao": "Vidro das posições 70.03, 70.04 ou 70.05, recurvado, biselado, gravado, brocado, esmaltado ou trabalhado de outro modo, mas não emoldurado nem associado a outras matérias."
  },
  {
    "codigo": "70071100",
    "descricao": "-- De dimensões e formatos que permitam a sua aplicação em automóveis, veículos aéreos, barcos ou outros veículos"
  },
  {
    "codigo": "70071900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "70072100",
    "descricao": "-- De dimensões e formatos que permitam a sua aplicação em automóveis, veículos aéreos, barcos ou outros veículos"
  },
  {
    "codigo": "70072900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "70080000",
    "descricao": "Vidros isolantes de paredes múltiplas."
  },
  {
    "codigo": "70091000",
    "descricao": "- Espelhos retrovisores para veículos"
  },
  {
    "codigo": "70099100",
    "descricao": "-- Não emoldurados"
  },
  {
    "codigo": "70099200",
    "descricao": "-- Emoldurados"
  },
  {
    "codigo": "70101000",
    "descricao": "- Ampolas"
  },
  {
    "codigo": "70102000",
    "descricao": "- Rolhas, tampas e outros dispositivos para fechar recipientes"
  },
  {
    "codigo": "70109011",
    "descricao": "Garrafões e garrafas"
  },
  {
    "codigo": "70109012",
    "descricao": "Frascos, boiões, vasos, embalagens tubulares e outros recipientes próprios para transporte ou embalagem; boiões para conservas"
  },
  {
    "codigo": "70109021",
    "descricao": "Garrafões e garrafas"
  },
  {
    "codigo": "70109022",
    "descricao": "Frascos, boiões, vasos, embalagens tubulares e outros recipientes próprios para transporte ou embalagem; boiões para conservas"
  },
  {
    "codigo": "70109090",
    "descricao": "Outros"
  },
  {
    "codigo": "70111010",
    "descricao": "Para lâmpadas ou tubos de descarga, incluindo os de luz relâmpago (<i>flash</i>)"
  },
  {
    "codigo": "70111021",
    "descricao": "Bulbos de diâmetro inferior ou igual a 90 mm"
  },
  {
    "codigo": "70111029",
    "descricao": "Outros"
  },
  {
    "codigo": "70111090",
    "descricao": "Outros"
  },
  {
    "codigo": "70112000",
    "descricao": "- Para tubos catódicos"
  },
  {
    "codigo": "70119000",
    "descricao": "- Outros"
  },
  {
    "codigo": "70131000",
    "descricao": "- Objetos de vitrocerâmica"
  },
  {
    "codigo": "70132200",
    "descricao": "-- De cristal de chumbo"
  },
  {
    "codigo": "70132800",
    "descricao": "-- Outros"
  },
  {
    "codigo": "70133300",
    "descricao": "-- De cristal de chumbo"
  },
  {
    "codigo": "70133700",
    "descricao": "-- Outros"
  },
  {
    "codigo": "70134100",
    "descricao": "-- De cristal de chumbo"
  },
  {
    "codigo": "70134210",
    "descricao": "Cafeteiras e chaleiras"
  },
  {
    "codigo": "70134290",
    "descricao": "Outros"
  },
  {
    "codigo": "70134900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "70139110",
    "descricao": "Para ornamentação de interiores"
  },
  {
    "codigo": "70139190",
    "descricao": "Outros"
  },
  {
    "codigo": "70139900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "70140000",
    "descricao": "Artigos de vidro para sinalização e elementos de óptica de vidro (exceto os da posição 70.15), não trabalhados opticamente."
  },
  {
    "codigo": "70151010",
    "descricao": "Fotocromáticos"
  },
  {
    "codigo": "70151091",
    "descricao": "Brancos"
  },
  {
    "codigo": "70151092",
    "descricao": "Coloridos"
  },
  {
    "codigo": "70159010",
    "descricao": "Vidros de relojoaria"
  },
  {
    "codigo": "70159020",
    "descricao": "Vidros para máscaras, óculos ou anteparos, protetores"
  },
  {
    "codigo": "70159030",
    "descricao": "Vidros para os demais óculos"
  },
  {
    "codigo": "70159090",
    "descricao": "Outros"
  },
  {
    "codigo": "70161000",
    "descricao": "- Cubos, pastilhas e outros artigos semelhantes, de vidro, mesmo com suporte, para mosaicos ou decorações semelhantes"
  },
  {
    "codigo": "70169000",
    "descricao": "- Outros"
  },
  {
    "codigo": "70171000",
    "descricao": "- De quartzo ou de outras sílicas, fundidos"
  },
  {
    "codigo": "70172000",
    "descricao": "- De outro vidro com um coeficiente de dilatação linear não superior a 5 x 10<sup>-</sup><sup>6</sup> por Kelvin, entre 0 °C e 300 °C"
  },
  {
    "codigo": "70179000",
    "descricao": "- Outros"
  },
  {
    "codigo": "70181010",
    "descricao": "Contas de vidro"
  },
  {
    "codigo": "70181020",
    "descricao": "Imitações de pérolas naturais ou cultivadas, pedras preciosas ou semipreciosas"
  },
  {
    "codigo": "70181090",
    "descricao": "Outros"
  },
  {
    "codigo": "70182000",
    "descricao": "- Microsferas de vidro, de diâmetro não superior a 1 mm"
  },
  {
    "codigo": "70189000",
    "descricao": "- Outros"
  },
  {
    "codigo": "70191100",
    "descricao": "-- Fios cortados (<i>chopped strands</i>), de comprimento não superior a 50 mm"
  },
  {
    "codigo": "70191210",
    "descricao": "Impregnadas ou recobertas com resina de poliuretano ou borracha de estireno-butadieno"
  },
  {
    "codigo": "70191290",
    "descricao": "Outras"
  },
  {
    "codigo": "70191300",
    "descricao": "-- Outros fios, mechas"
  },
  {
    "codigo": "70191400",
    "descricao": "-- Mantas (<i>mats</i>) consolidadas mecanicamente"
  },
  {
    "codigo": "70191500",
    "descricao": "-- Mantas (<i>mats</i>) consolidadas quimicamente"
  },
  {
    "codigo": "70191900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "70196100",
    "descricao": "-- Tecidos de mechas ligeiramente torcidas (<i>rovings</i>) de malha fechada (<i>closed woven fabrics</i>)"
  },
  {
    "codigo": "70196200",
    "descricao": "-- Outros, obtidos de mechas ligeiramente torcidas (<i>rovings</i>) de malha fechada (<i>other closed fabrics</i>)"
  },
  {
    "codigo": "70196300",
    "descricao": "-- Tecidos de fios de malha fechada, em ponto de tafetá, não revestidos nem estratificados"
  },
  {
    "codigo": "70196400",
    "descricao": "-- Tecidos de fios de malha fechada, em ponto de tafetá, revestidos ou estratificados"
  },
  {
    "codigo": "70196500",
    "descricao": "-- Tecidos de malha aberta de largura não superior a 30 cm"
  },
  {
    "codigo": "70196600",
    "descricao": "-- Tecidos de malha aberta de largura superior a 30 cm"
  },
  {
    "codigo": "70196900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "70197100",
    "descricao": "-- Véus (camadas finas)"
  },
  {
    "codigo": "70197200",
    "descricao": "-- Outros tecidos de malha fechada"
  },
  {
    "codigo": "70197310",
    "descricao": "Constituídos por fios paralelizados e superpostos entre si em ângulo de 90°, impregnados e soldados nos pontos de interseção com resina termoplástica, com densidade igual ou superior a 3 e inferior ou igual a 7 fios por centímetro"
  },
  {
    "codigo": "70197390",
    "descricao": "Outros"
  },
  {
    "codigo": "70198000",
    "descricao": "- Lã de vidro e suas obras"
  },
  {
    "codigo": "70199000",
    "descricao": "- Outras"
  },
  {
    "codigo": "70200010",
    "descricao": "Ampolas de vidro para garrafas térmicas ou para outros recipientes isotérmicos, cujo isolamento seja assegurado pelo vácuo"
  },
  {
    "codigo": "70200090",
    "descricao": "Outras"
  },
  {
    "codigo": "71011000",
    "descricao": "- Pérolas naturais"
  },
  {
    "codigo": "71012100",
    "descricao": "-- Em bruto"
  },
  {
    "codigo": "71012200",
    "descricao": "-- Trabalhadas"
  },
  {
    "codigo": "71021000",
    "descricao": "- Não selecionados"
  },
  {
    "codigo": "71022100",
    "descricao": "-- Em bruto ou simplesmente serrados, clivados ou desbastados"
  },
  {
    "codigo": "71022900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "71023100",
    "descricao": "-- Em bruto ou simplesmente serrados, clivados ou desbastados"
  },
  {
    "codigo": "71023900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "71031000",
    "descricao": "- Em bruto ou simplesmente serradas ou desbastadas"
  },
  {
    "codigo": "71039100",
    "descricao": "-- Rubis, safiras e esmeraldas"
  },
  {
    "codigo": "71039900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "71041000",
    "descricao": "- Quartzo piezelétrico"
  },
  {
    "codigo": "71042100",
    "descricao": "-- Diamantes"
  },
  {
    "codigo": "71042900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "71049100",
    "descricao": "-- Diamantes"
  },
  {
    "codigo": "71049900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "71051000",
    "descricao": "- De diamantes"
  },
  {
    "codigo": "71059000",
    "descricao": "- Outros"
  },
  {
    "codigo": "71061000",
    "descricao": "- Pós"
  },
  {
    "codigo": "71069100",
    "descricao": "-- Em formas brutas"
  },
  {
    "codigo": "71069210",
    "descricao": "Barras, fios e perfis de seção maciça"
  },
  {
    "codigo": "71069220",
    "descricao": "Chapas, lâminas, folhas e tiras"
  },
  {
    "codigo": "71069290",
    "descricao": "Outras"
  },
  {
    "codigo": "71070000",
    "descricao": "Metais comuns folheados ou chapeados (plaquê) de prata, em formas brutas ou semimanufaturadas."
  },
  {
    "codigo": "71081100",
    "descricao": "-- Pós"
  },
  {
    "codigo": "71081210",
    "descricao": "Bulhão dourado (<i>bullion doré</i>)"
  },
  {
    "codigo": "71081290",
    "descricao": "Outras"
  },
  {
    "codigo": "71081310",
    "descricao": "Barras, fios e perfis de seção maciça"
  },
  {
    "codigo": "71081390",
    "descricao": "Outros"
  },
  {
    "codigo": "71082000",
    "descricao": "- Para uso monetário"
  },
  {
    "codigo": "71090000",
    "descricao": "Metais comuns ou prata, folheados ou chapeados (plaquê) de ouro, em formas brutas ou semimanufaturadas."
  },
  {
    "codigo": "71101100",
    "descricao": "-- Em formas brutas ou em pó"
  },
  {
    "codigo": "71101910",
    "descricao": "Barras, fios e perfis de seção maciça"
  },
  {
    "codigo": "71101990",
    "descricao": "Outras"
  },
  {
    "codigo": "71102100",
    "descricao": "-- Em formas brutas ou em pó"
  },
  {
    "codigo": "71102900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "71103100",
    "descricao": "-- Em formas brutas ou em pó"
  },
  {
    "codigo": "71103900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "71104100",
    "descricao": "-- Em formas brutas ou em pó"
  },
  {
    "codigo": "71104900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "71110000",
    "descricao": "Metais comuns, prata ou ouro, folheados ou chapeados (plaquê) de platina, em formas brutas ou semimanufaturadas."
  },
  {
    "codigo": "71123010",
    "descricao": "Que contenham ouro, mas que não contenham outros metais preciosos"
  },
  {
    "codigo": "71123020",
    "descricao": "Que contenham platina, mas que não contenham outros metais preciosos"
  },
  {
    "codigo": "71123090",
    "descricao": "Outros"
  },
  {
    "codigo": "71129100",
    "descricao": "-- De ouro, de metais folheados ou chapeados (plaquê) de ouro, exceto varreduras de ourivesaria que contenham outros metais preciosos"
  },
  {
    "codigo": "71129200",
    "descricao": "-- De platina, de metais folheados ou chapeados (plaquê) de platina, exceto varreduras de ourivesaria que contenham outros metais preciosos"
  },
  {
    "codigo": "71129900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "71131100",
    "descricao": "-- De prata, mesmo revestida, folheada ou chapeada de outros metais preciosos (plaquê)"
  },
  {
    "codigo": "71131900",
    "descricao": "-- De outros metais preciosos, mesmo revestidos, folheados ou chapeados de metais preciosos (plaquê)"
  },
  {
    "codigo": "71132000",
    "descricao": "- De metais comuns folheados ou chapeados de metais preciosos (plaquê)"
  },
  {
    "codigo": "71141100",
    "descricao": "-- De prata, mesmo revestida, folheada ou chapeada de outros metais preciosos (plaquê)"
  },
  {
    "codigo": "71141900",
    "descricao": "-- De outros metais preciosos, mesmo revestidos, folheados ou chapeados de metais preciosos (plaquê)"
  },
  {
    "codigo": "71142000",
    "descricao": "- De metais comuns folheados ou chapeados de metais preciosos (plaquê)"
  },
  {
    "codigo": "71151000",
    "descricao": "- Telas ou grades catalisadoras, de platina"
  },
  {
    "codigo": "71159000",
    "descricao": "- Outras"
  },
  {
    "codigo": "71161000",
    "descricao": "- De pérolas naturais ou cultivadas"
  },
  {
    "codigo": "71162010",
    "descricao": "De diamantes sintéticos"
  },
  {
    "codigo": "71162020",
    "descricao": "Guias de agulhas, de rubi, para cabeças de impressão"
  },
  {
    "codigo": "71162090",
    "descricao": "Outras"
  },
  {
    "codigo": "71171100",
    "descricao": "-- Abotoaduras (botões de punho) e artigos semelhantes"
  },
  {
    "codigo": "71171900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "71179000",
    "descricao": "- Outras"
  },
  {
    "codigo": "71181010",
    "descricao": "Destinadas a ter curso legal no país importador"
  },
  {
    "codigo": "71181090",
    "descricao": "Outras"
  },
  {
    "codigo": "71189000",
    "descricao": "- Outras"
  },
  {
    "codigo": "72011000",
    "descricao": "- Ferro fundido bruto não ligado, que contenha, em peso, 0,5 % ou menos de fósforo"
  },
  {
    "codigo": "72012000",
    "descricao": "- Ferro fundido bruto não ligado, que contenha, em peso, mais de 0,5 % de fósforo"
  },
  {
    "codigo": "72015000",
    "descricao": "- Ligas de ferro fundido bruto; ferro <i>spiegel</i> (especular)"
  },
  {
    "codigo": "72021100",
    "descricao": "-- Que contenha, em peso, mais de 2 % de carbono"
  },
  {
    "codigo": "72021900",
    "descricao": "-- Outra"
  },
  {
    "codigo": "72022100",
    "descricao": "-- Que contenha, em peso, mais de 55 % de silício"
  },
  {
    "codigo": "72022900",
    "descricao": "-- Outra"
  },
  {
    "codigo": "72023000",
    "descricao": "- Ferrossiliciomanganês"
  },
  {
    "codigo": "72024100",
    "descricao": "-- Que contenha, em peso, mais de 4 % de carbono"
  },
  {
    "codigo": "72024900",
    "descricao": "-- Outra"
  },
  {
    "codigo": "72025000",
    "descricao": "- Ferrossiliciocromo"
  },
  {
    "codigo": "72026000",
    "descricao": "- Ferroníquel"
  },
  {
    "codigo": "72027000",
    "descricao": "- Ferromolibdênio"
  },
  {
    "codigo": "72028000",
    "descricao": "- Ferrotungstênio (ferrovolfrâmio) e ferrossiliciotungstênio (ferrossiliciovolfrâmio)"
  },
  {
    "codigo": "72029100",
    "descricao": "-- Ferrotitânio e ferrossiliciotitânio"
  },
  {
    "codigo": "72029200",
    "descricao": "-- Ferrovanádio"
  },
  {
    "codigo": "72029300",
    "descricao": "-- Ferronióbio (ferrocolômbio)"
  },
  {
    "codigo": "72029910",
    "descricao": "Ferrofósforo"
  },
  {
    "codigo": "72029990",
    "descricao": "Outras"
  },
  {
    "codigo": "72031000",
    "descricao": "- Produtos ferrosos obtidos por redução direta dos minérios de ferro"
  },
  {
    "codigo": "72039000",
    "descricao": "- Outros"
  },
  {
    "codigo": "72041000",
    "descricao": "- Desperdícios e resíduos, e sucata, de ferro fundido"
  },
  {
    "codigo": "72042100",
    "descricao": "-- De aço inoxidável"
  },
  {
    "codigo": "72042900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "72043000",
    "descricao": "- Desperdícios e resíduos, e sucata, de ferro ou aço, estanhados"
  },
  {
    "codigo": "72044100",
    "descricao": "-- Resíduos do torno e da fresa, aparas, lascas (<i>meulures</i>), pó de serra, limalhas e desperdícios da estampagem ou do corte, mesmo em fardos"
  },
  {
    "codigo": "72044900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "72045000",
    "descricao": "- Desperdícios e resíduos, em lingotes"
  },
  {
    "codigo": "72051000",
    "descricao": "- Granalhas"
  },
  {
    "codigo": "72052100",
    "descricao": "-- De ligas de aço"
  },
  {
    "codigo": "72052910",
    "descricao": "De ferro esponjoso, com um teor de ferro igual ou superior a 98 %, em peso"
  },
  {
    "codigo": "72052920",
    "descricao": "De ferro revestido com resina termoplástica, com um teor de ferro igual ou superior a 98 %, em peso"
  },
  {
    "codigo": "72052990",
    "descricao": "Outros"
  },
  {
    "codigo": "72061000",
    "descricao": "- Lingotes"
  },
  {
    "codigo": "72069000",
    "descricao": "- Outros"
  },
  {
    "codigo": "72071110",
    "descricao": "<i>Billets</i>"
  },
  {
    "codigo": "72071190",
    "descricao": "Outros"
  },
  {
    "codigo": "72071200",
    "descricao": "-- Outros, de seção transversal retangular"
  },
  {
    "codigo": "72071900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "72072000",
    "descricao": "- Que contenham, em peso, 0,25 % ou mais de carbono"
  },
  {
    "codigo": "72081000",
    "descricao": "- Em rolos, simplesmente laminados a quente, apresentando motivos em relevo"
  },
  {
    "codigo": "72082500",
    "descricao": "-- De espessura igual ou superior a 4,75 mm"
  },
  {
    "codigo": "72082610",
    "descricao": "Com um limite mínimo de elasticidade de 355 MPa"
  },
  {
    "codigo": "72082690",
    "descricao": "Outros"
  },
  {
    "codigo": "72082710",
    "descricao": "Com um limite mínimo de elasticidade de 275 MPa"
  },
  {
    "codigo": "72082790",
    "descricao": "Outros"
  },
  {
    "codigo": "72083610",
    "descricao": "Com um limite mínimo de elasticidade de 355 MPa"
  },
  {
    "codigo": "72083690",
    "descricao": "Outros"
  },
  {
    "codigo": "72083700",
    "descricao": "-- De espessura igual ou superior a 4,75 mm, mas não superior a 10 mm"
  },
  {
    "codigo": "72083810",
    "descricao": "Com um limite mínimo de elasticidade de 355 MPa"
  },
  {
    "codigo": "72083890",
    "descricao": "Outros"
  },
  {
    "codigo": "72083910",
    "descricao": "Com um limite mínimo de elasticidade de 275 MPa"
  },
  {
    "codigo": "72083990",
    "descricao": "Outros"
  },
  {
    "codigo": "72084000",
    "descricao": "- Não enrolados, simplesmente laminados a quente, apresentando motivos em relevo"
  },
  {
    "codigo": "72085100",
    "descricao": "-- De espessura superior a 10 mm"
  },
  {
    "codigo": "72085200",
    "descricao": "-- De espessura igual ou superior a 4,75 mm, mas não superior a 10 mm"
  },
  {
    "codigo": "72085300",
    "descricao": "-- De espessura igual ou superior a 3 mm, mas inferior a 4,75 mm"
  },
  {
    "codigo": "72085400",
    "descricao": "-- De espessura inferior a 3 mm"
  },
  {
    "codigo": "72089000",
    "descricao": "- Outros"
  },
  {
    "codigo": "72091500",
    "descricao": "-- De espessura igual ou superior a 3 mm"
  },
  {
    "codigo": "72091600",
    "descricao": "-- De espessura superior a 1 mm, mas inferior a 3 mm"
  },
  {
    "codigo": "72091700",
    "descricao": "-- De espessura igual ou superior a 0,5 mm, mas não superior a 1 mm"
  },
  {
    "codigo": "72091800",
    "descricao": "-- De espessura inferior a 0,5 mm"
  },
  {
    "codigo": "72092500",
    "descricao": "-- De espessura igual ou superior a 3 mm"
  },
  {
    "codigo": "72092600",
    "descricao": "-- De espessura superior a 1 mm, mas inferior a 3 mm"
  },
  {
    "codigo": "72092700",
    "descricao": "-- De espessura igual ou superior a 0,5 mm, mas não superior a 1 mm"
  },
  {
    "codigo": "72092800",
    "descricao": "-- De espessura inferior a 0,5 mm"
  },
  {
    "codigo": "72099000",
    "descricao": "- Outros"
  },
  {
    "codigo": "72101100",
    "descricao": "-- De espessura igual ou superior a 0,5 mm"
  },
  {
    "codigo": "72101200",
    "descricao": "-- De espessura inferior a 0,5 mm"
  },
  {
    "codigo": "72102000",
    "descricao": "- Revestidos de chumbo, incluindo os revestidos de uma liga de chumboestanho"
  },
  {
    "codigo": "72103010",
    "descricao": "De espessura inferior a 4,75 mm"
  },
  {
    "codigo": "72103090",
    "descricao": "Outros"
  },
  {
    "codigo": "72104110",
    "descricao": "De espessura inferior a 4,75 mm"
  },
  {
    "codigo": "72104190",
    "descricao": "Outros"
  },
  {
    "codigo": "72104910",
    "descricao": "De espessura inferior a 4,75 mm"
  },
  {
    "codigo": "72104990",
    "descricao": "Outros"
  },
  {
    "codigo": "72105000",
    "descricao": "- Revestidos de óxidos de cromo ou de cromo e óxidos de cromo"
  },
  {
    "codigo": "72106100",
    "descricao": "-- Revestidos de ligas de aluminiozinco"
  },
  {
    "codigo": "72106911",
    "descricao": "De peso igual ou superior a 120 g/m<sup>2</sup> e com conteúdo de silício igual ou superior a 5 %, mas inferior ou igual a 11 %, em peso"
  },
  {
    "codigo": "72106919",
    "descricao": "Outros"
  },
  {
    "codigo": "72106990",
    "descricao": "Outros"
  },
  {
    "codigo": "72107010",
    "descricao": "Pintados ou envernizados"
  },
  {
    "codigo": "72107020",
    "descricao": "Revestidos de plástico"
  },
  {
    "codigo": "72109000",
    "descricao": "- Outros"
  },
  {
    "codigo": "72111300",
    "descricao": "-- Laminados nas quatro faces ou em caixa fechada, de largura superior a 150 mm e de espessura igual ou superior a 4 mm, não enrolados e não apresentando motivos em relevo"
  },
  {
    "codigo": "72111400",
    "descricao": "-- Outros, de espessura igual ou superior a 4,75 mm"
  },
  {
    "codigo": "72111900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "72112300",
    "descricao": "-- Que contenham, em peso, menos de 0,25 % de carbono"
  },
  {
    "codigo": "72112910",
    "descricao": "Com um teor de carbono igual ou superior a 0,25 %, mas inferior a 0,6 %, em peso"
  },
  {
    "codigo": "72112920",
    "descricao": "Com um teor de carbono igual ou superior a 0,6 %, em peso"
  },
  {
    "codigo": "72119010",
    "descricao": "Com um teor de carbono igual ou superior a 0,6 %, em peso"
  },
  {
    "codigo": "72119090",
    "descricao": "Outros"
  },
  {
    "codigo": "72121000",
    "descricao": "- Estanhados"
  },
  {
    "codigo": "72122010",
    "descricao": "De espessura inferior a 4,75 mm"
  },
  {
    "codigo": "72122090",
    "descricao": "Outros"
  },
  {
    "codigo": "72123000",
    "descricao": "- Galvanizados por outro processo"
  },
  {
    "codigo": "72124010",
    "descricao": "Pintados ou envernizados"
  },
  {
    "codigo": "72124021",
    "descricao": "Com uma camada intermediária de liga cobre-estanho ou cobre-estanho-chumbo, aplicada por sinterização"
  },
  {
    "codigo": "72124029",
    "descricao": "Outros"
  },
  {
    "codigo": "72125010",
    "descricao": "Com uma camada de liga cobre-estanho ou cobre-estanho-chumbo, aplicada por sinterização, inclusive com revestimento misto metal-plástico ou metal-plástico-fibra de carbono"
  },
  {
    "codigo": "72125090",
    "descricao": "Outros"
  },
  {
    "codigo": "72126000",
    "descricao": "- Folheados ou chapeados"
  },
  {
    "codigo": "72131000",
    "descricao": "- Dentados, com nervuras, sulcos (entalhes) ou relevos, obtidos durante a laminagem"
  },
  {
    "codigo": "72132000",
    "descricao": "- Outros, de aço para tornear"
  },
  {
    "codigo": "72139110",
    "descricao": "Com um teor de carbono igual ou superior a 0,6 %, em peso"
  },
  {
    "codigo": "72139190",
    "descricao": "Outros"
  },
  {
    "codigo": "72139910",
    "descricao": "Com um teor de carbono igual ou superior a 0,6 %, em peso"
  },
  {
    "codigo": "72139990",
    "descricao": "Outros"
  },
  {
    "codigo": "72141010",
    "descricao": "Com um teor de carbono inferior ou igual a 0,6 %, em peso"
  },
  {
    "codigo": "72141090",
    "descricao": "Outras"
  },
  {
    "codigo": "72142000",
    "descricao": "- Dentadas, com nervuras, sulcos (entalhes) ou relevos, obtidos durante a laminagem, ou torcidas após laminagem"
  },
  {
    "codigo": "72143000",
    "descricao": "- Outras, de aço para tornear"
  },
  {
    "codigo": "72149100",
    "descricao": "-- De seção transversal retangular"
  },
  {
    "codigo": "72149910",
    "descricao": "De seção circular"
  },
  {
    "codigo": "72149990",
    "descricao": "Outras"
  },
  {
    "codigo": "72151000",
    "descricao": "- De aço para tornear, simplesmente obtidas ou completamente acabadas a frio"
  },
  {
    "codigo": "72155000",
    "descricao": "- Outras, simplesmente obtidas ou completamente acabadas a frio"
  },
  {
    "codigo": "72159010",
    "descricao": "Com um teor de carbono inferior ou igual a 0,6 %, em peso"
  },
  {
    "codigo": "72159090",
    "descricao": "Outras"
  },
  {
    "codigo": "72161000",
    "descricao": "- Perfis em U, I ou H, simplesmente laminados, estirados ou extrudados, a quente, de altura inferior a 80 mm"
  },
  {
    "codigo": "72162100",
    "descricao": "-- Perfis em L"
  },
  {
    "codigo": "72162200",
    "descricao": "-- Perfis em T"
  },
  {
    "codigo": "72163100",
    "descricao": "-- Perfis em U"
  },
  {
    "codigo": "72163200",
    "descricao": "-- Perfis em I"
  },
  {
    "codigo": "72163300",
    "descricao": "-- Perfis em H"
  },
  {
    "codigo": "72164010",
    "descricao": "De altura inferior ou igual a 200 mm"
  },
  {
    "codigo": "72164090",
    "descricao": "Outros"
  },
  {
    "codigo": "72165000",
    "descricao": "- Outros perfis, simplesmente laminados, estirados ou extrudados, a quente"
  },
  {
    "codigo": "72166110",
    "descricao": "De altura inferior a 80 mm"
  },
  {
    "codigo": "72166190",
    "descricao": "Outros"
  },
  {
    "codigo": "72166910",
    "descricao": "De altura inferior a 80 mm"
  },
  {
    "codigo": "72166990",
    "descricao": "Outros"
  },
  {
    "codigo": "72169100",
    "descricao": "-- Obtidos ou acabados a frio a partir de produtos laminados planos"
  },
  {
    "codigo": "72169900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "72171011",
    "descricao": "Com um teor, em peso, de fósforo inferior a 0,035 % e de enxofre inferior a 0,035 %, temperado e revenido, flecha máxima sem carga de 1 cm em 1 m, resistência à tração igual ou superior a 1.960 MPa e cuja maior dimensão da seção transversal seja inferior ou igual a 2,25 mm"
  },
  {
    "codigo": "72171019",
    "descricao": "Outros"
  },
  {
    "codigo": "72171090",
    "descricao": "Outros"
  },
  {
    "codigo": "72172010",
    "descricao": "Com um teor de carbono igual ou superior a 0,6 %, em peso"
  },
  {
    "codigo": "72172090",
    "descricao": "Outros"
  },
  {
    "codigo": "72173010",
    "descricao": "Com um teor de carbono igual ou superior a 0,6 %, em peso"
  },
  {
    "codigo": "72173090",
    "descricao": "Outros"
  },
  {
    "codigo": "72179000",
    "descricao": "- Outros"
  },
  {
    "codigo": "72181000",
    "descricao": "- Lingotes e outras formas primárias"
  },
  {
    "codigo": "72189100",
    "descricao": "-- De seção transversal retangular"
  },
  {
    "codigo": "72189900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "72191100",
    "descricao": "-- De espessura superior a 10 mm"
  },
  {
    "codigo": "72191200",
    "descricao": "-- De espessura igual ou superior a 4,75 mm, mas não superior a 10 mm"
  },
  {
    "codigo": "72191300",
    "descricao": "-- De espessura igual ou superior a 3 mm, mas inferior a 4,75 mm"
  },
  {
    "codigo": "72191400",
    "descricao": "-- De espessura inferior a 3 mm"
  },
  {
    "codigo": "72192100",
    "descricao": "-- De espessura superior a 10 mm"
  },
  {
    "codigo": "72192200",
    "descricao": "-- De espessura igual ou superior a 4,75 mm, mas não superior a 10 mm"
  },
  {
    "codigo": "72192300",
    "descricao": "-- De espessura igual ou superior a 3 mm, mas inferior a 4,75 mm"
  },
  {
    "codigo": "72192400",
    "descricao": "-- De espessura inferior a 3 mm"
  },
  {
    "codigo": "72193100",
    "descricao": "-- De espessura igual ou superior a 4,75 mm"
  },
  {
    "codigo": "72193200",
    "descricao": "-- De espessura igual ou superior a 3 mm, mas inferior a 4,75 mm"
  },
  {
    "codigo": "72193300",
    "descricao": "-- De espessura superior a 1 mm, mas inferior a 3 mm"
  },
  {
    "codigo": "72193400",
    "descricao": "-- De espessura igual ou superior a 0,5 mm, mas não superior a 1 mm"
  },
  {
    "codigo": "72193500",
    "descricao": "-- De espessura inferior a 0,5 mm"
  },
  {
    "codigo": "72199010",
    "descricao": "De espessura inferior a 4,75 mm e dureza igual ou superior a 42 HRC"
  },
  {
    "codigo": "72199090",
    "descricao": "Outros"
  },
  {
    "codigo": "72201100",
    "descricao": "-- De espessura igual ou superior a 4,75 mm"
  },
  {
    "codigo": "72201210",
    "descricao": "De espessura inferior ou igual a 1,5 mm"
  },
  {
    "codigo": "72201220",
    "descricao": "De espessura superior a 1,5 mm, mas não superior a 3 mm"
  },
  {
    "codigo": "72201290",
    "descricao": "Outros"
  },
  {
    "codigo": "72202010",
    "descricao": "De largura inferior ou igual a 23 mm e espessura inferior ou igual a 0,1 mm"
  },
  {
    "codigo": "72202090",
    "descricao": "Outros"
  },
  {
    "codigo": "72209000",
    "descricao": "- Outros"
  },
  {
    "codigo": "72210000",
    "descricao": "Fio-máquina de aço inoxidável."
  },
  {
    "codigo": "72221100",
    "descricao": "-- De seção circular"
  },
  {
    "codigo": "72221910",
    "descricao": "De seção transversal retangular"
  },
  {
    "codigo": "72221990",
    "descricao": "Outras"
  },
  {
    "codigo": "72222000",
    "descricao": "- Barras simplesmente obtidas ou completamente acabadas a frio"
  },
  {
    "codigo": "72223000",
    "descricao": "- Outras barras"
  },
  {
    "codigo": "72224010",
    "descricao": "De altura igual ou superior a 80 mm"
  },
  {
    "codigo": "72224090",
    "descricao": "Outros"
  },
  {
    "codigo": "72230000",
    "descricao": "Fios de aço inoxidável."
  },
  {
    "codigo": "72241000",
    "descricao": "- Lingotes e outras formas primárias"
  },
  {
    "codigo": "72249000",
    "descricao": "- Outros"
  },
  {
    "codigo": "72251100",
    "descricao": "-- De grãos orientados"
  },
  {
    "codigo": "72251900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "72253000",
    "descricao": "- Outros, simplesmente laminados a quente, em rolos"
  },
  {
    "codigo": "72254010",
    "descricao": "De aço, segundo normas AISI D2, D3 ou D6, de espessura inferior ou igual a 7 mm"
  },
  {
    "codigo": "72254020",
    "descricao": "De aços de corte rápido"
  },
  {
    "codigo": "72254090",
    "descricao": "Outros"
  },
  {
    "codigo": "72255010",
    "descricao": "De aços de corte rápido"
  },
  {
    "codigo": "72255090",
    "descricao": "Outros"
  },
  {
    "codigo": "72259100",
    "descricao": "-- Galvanizados eletroliticamente"
  },
  {
    "codigo": "72259200",
    "descricao": "-- Galvanizados por outro processo"
  },
  {
    "codigo": "72259910",
    "descricao": "De aços de corte rápido"
  },
  {
    "codigo": "72259990",
    "descricao": "Outros"
  },
  {
    "codigo": "72261100",
    "descricao": "-- De grãos orientados"
  },
  {
    "codigo": "72261900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "72262010",
    "descricao": "De espessura igual ou superior a 1 mm, mas não superior a 4 mm"
  },
  {
    "codigo": "72262090",
    "descricao": "Outros"
  },
  {
    "codigo": "72269100",
    "descricao": "-- Simplesmente laminados a quente"
  },
  {
    "codigo": "72269200",
    "descricao": "-- Simplesmente laminados a frio"
  },
  {
    "codigo": "72269900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "72271000",
    "descricao": "- De aço de corte rápido"
  },
  {
    "codigo": "72272000",
    "descricao": "- De aço siliciomanganês"
  },
  {
    "codigo": "72279000",
    "descricao": "- Outros"
  },
  {
    "codigo": "72281010",
    "descricao": "Simplesmente laminadas, estiradas ou extrudadas, a quente"
  },
  {
    "codigo": "72281090",
    "descricao": "Outras"
  },
  {
    "codigo": "72282000",
    "descricao": "- Barras de aço siliciomanganês"
  },
  {
    "codigo": "72283000",
    "descricao": "- Outras barras, simplesmente laminadas, estiradas ou extrudadas, a quente"
  },
  {
    "codigo": "72284000",
    "descricao": "- Outras barras, simplesmente forjadas"
  },
  {
    "codigo": "72285000",
    "descricao": "- Outras barras, simplesmente obtidas ou completamente acabadas a frio"
  },
  {
    "codigo": "72286000",
    "descricao": "- Outras barras"
  },
  {
    "codigo": "72287000",
    "descricao": "- Perfis"
  },
  {
    "codigo": "72288000",
    "descricao": "- Barras ocas para perfuração"
  },
  {
    "codigo": "72292000",
    "descricao": "- De aço siliciomanganês"
  },
  {
    "codigo": "72299000",
    "descricao": "- Outros"
  },
  {
    "codigo": "73011000",
    "descricao": "- Estacas-pranchas"
  },
  {
    "codigo": "73012000",
    "descricao": "- Perfis"
  },
  {
    "codigo": "73021010",
    "descricao": "De aço, de peso linear igual ou superior a 44,5 kg/m"
  },
  {
    "codigo": "73021090",
    "descricao": "Outros"
  },
  {
    "codigo": "73023000",
    "descricao": "- Agulhas, cróssimas, alavancas para comando de agulhas e outros elementos de cruzamentos e desvios"
  },
  {
    "codigo": "73024000",
    "descricao": "- Talas de junção (Eclissas*) e placas de apoio ou assentamento"
  },
  {
    "codigo": "73029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "73030000",
    "descricao": "Tubos e perfis ocos, de ferro fundido."
  },
  {
    "codigo": "73041100",
    "descricao": "-- De aço inoxidável"
  },
  {
    "codigo": "73041900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "73042200",
    "descricao": "-- Hastes de perfuração de aço inoxidável"
  },
  {
    "codigo": "73042310",
    "descricao": "De aço não ligado"
  },
  {
    "codigo": "73042390",
    "descricao": "Outras"
  },
  {
    "codigo": "73042400",
    "descricao": "-- Outros, de aço inoxidável"
  },
  {
    "codigo": "73042910",
    "descricao": "De aço não ligado"
  },
  {
    "codigo": "73042931",
    "descricao": "De diâmetro exterior inferior ou igual a 229 mm"
  },
  {
    "codigo": "73042939",
    "descricao": "Outros"
  },
  {
    "codigo": "73042990",
    "descricao": "Outros"
  },
  {
    "codigo": "73043110",
    "descricao": "Tubos não revestidos"
  },
  {
    "codigo": "73043190",
    "descricao": "Outros"
  },
  {
    "codigo": "73043910",
    "descricao": "Tubos não revestidos, de diâmetro exterior inferior ou igual a 229 mm"
  },
  {
    "codigo": "73043920",
    "descricao": "Tubos revestidos, de diâmetro exterior inferior ou igual a 229 mm"
  },
  {
    "codigo": "73043990",
    "descricao": "Outros"
  },
  {
    "codigo": "73044110",
    "descricao": "Tubos capilares de diâmetro exterior inferior ou igual a 3 mm e diâmetro interior inferior ou igual a 0,2 mm"
  },
  {
    "codigo": "73044190",
    "descricao": "Outros"
  },
  {
    "codigo": "73044900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "73045111",
    "descricao": "Tubos capilares de diâmetro exterior inferior ou igual a 3 mm e diâmetro interior inferior ou igual a 0,2 mm"
  },
  {
    "codigo": "73045119",
    "descricao": "Outros"
  },
  {
    "codigo": "73045190",
    "descricao": "Outros"
  },
  {
    "codigo": "73045910",
    "descricao": "Tubos de diâmetro exterior inferior ou igual a 229 mm"
  },
  {
    "codigo": "73045990",
    "descricao": "Outros"
  },
  {
    "codigo": "73049011",
    "descricao": "De aço inoxidável"
  },
  {
    "codigo": "73049019",
    "descricao": "Outros"
  },
  {
    "codigo": "73049090",
    "descricao": "Outros"
  },
  {
    "codigo": "73051100",
    "descricao": "-- Soldados longitudinalmente por arco imerso"
  },
  {
    "codigo": "73051200",
    "descricao": "-- Outros, soldados longitudinalmente"
  },
  {
    "codigo": "73051900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "73052000",
    "descricao": "- Tubos para revestimento de poços, do tipo utilizado na extração de petróleo ou de gás"
  },
  {
    "codigo": "73053100",
    "descricao": "-- Soldados longitudinalmente"
  },
  {
    "codigo": "73053900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "73059000",
    "descricao": "- Outros"
  },
  {
    "codigo": "73061100",
    "descricao": "-- Soldados, de aço inoxidável"
  },
  {
    "codigo": "73061900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "73062100",
    "descricao": "-- Soldados, de aço inoxidável"
  },
  {
    "codigo": "73062900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "73063010",
    "descricao": "De diâmetro exterior igual a 22,25 mm, espessura igual a 2,64 mm e comprimento igual a 448,2 mm"
  },
  {
    "codigo": "73063090",
    "descricao": "Outros"
  },
  {
    "codigo": "73064000",
    "descricao": "- Outros, soldados, de seção circular, de aço inoxidável"
  },
  {
    "codigo": "73065000",
    "descricao": "- Outros, soldados, de seção circular, de outras ligas de aço"
  },
  {
    "codigo": "73066100",
    "descricao": "-- De seção quadrada ou retangular"
  },
  {
    "codigo": "73066900",
    "descricao": "-- De outras seções"
  },
  {
    "codigo": "73069010",
    "descricao": "De ferro ou aço não ligado"
  },
  {
    "codigo": "73069020",
    "descricao": "De aço inoxidável"
  },
  {
    "codigo": "73069090",
    "descricao": "Outros"
  },
  {
    "codigo": "73071100",
    "descricao": "-- De ferro fundido não maleável"
  },
  {
    "codigo": "73071910",
    "descricao": "De ferro fundido maleável, de diâmetro interior superior a 50,8 mm"
  },
  {
    "codigo": "73071920",
    "descricao": "De aço"
  },
  {
    "codigo": "73071990",
    "descricao": "Outros"
  },
  {
    "codigo": "73072100",
    "descricao": "-- Flanges"
  },
  {
    "codigo": "73072200",
    "descricao": "-- Cotovelos, curvas e luvas (mangas*), roscados"
  },
  {
    "codigo": "73072300",
    "descricao": "-- Acessórios para soldar topo a topo"
  },
  {
    "codigo": "73072900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "73079100",
    "descricao": "-- Flanges"
  },
  {
    "codigo": "73079200",
    "descricao": "-- Cotovelos, curvas e luvas (mangas*), roscados"
  },
  {
    "codigo": "73079300",
    "descricao": "-- Acessórios para soldar topo a topo"
  },
  {
    "codigo": "73079900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "73081000",
    "descricao": "- Pontes e elementos de pontes"
  },
  {
    "codigo": "73082000",
    "descricao": "- Torres e pórticos"
  },
  {
    "codigo": "73083000",
    "descricao": "- Portas e janelas, e seus caixilhos, alizares e soleiras"
  },
  {
    "codigo": "73084000",
    "descricao": "- Material para andaimes, para cofragens ou para escoramentos"
  },
  {
    "codigo": "73089010",
    "descricao": "Chapas, barras, perfis, tubos e semelhantes, próprios para construções"
  },
  {
    "codigo": "73089090",
    "descricao": "Outros"
  },
  {
    "codigo": "73090010",
    "descricao": "Para armazenamento de grãos e outras matérias sólidas"
  },
  {
    "codigo": "73090020",
    "descricao": "Recipientes isotérmicos refrigerados a nitrogênio (azoto) líquido, do tipo utilizado para sêmen, sangue, tecidos biológicos e outros produtos semelhantes"
  },
  {
    "codigo": "73090090",
    "descricao": "Outros"
  },
  {
    "codigo": "73101010",
    "descricao": "Recipientes isotérmicos refrigerados a nitrogênio (azoto) líquido, do tipo utilizado para sêmen, sangue, tecidos biológicos e outros produtos semelhantes"
  },
  {
    "codigo": "73101090",
    "descricao": "Outros"
  },
  {
    "codigo": "73102110",
    "descricao": "Próprias para acondicionar produtos alimentícios"
  },
  {
    "codigo": "73102190",
    "descricao": "Outros"
  },
  {
    "codigo": "73102910",
    "descricao": "Próprios para acondicionar produtos alimentícios"
  },
  {
    "codigo": "73102920",
    "descricao": "Recipientes isotérmicos refrigerados a nitrogênio (azoto) líquido, do tipo utilizado para sêmen, sangue, tecidos biológicos e outros produtos semelhantes"
  },
  {
    "codigo": "73102990",
    "descricao": "Outros"
  },
  {
    "codigo": "73110000",
    "descricao": "Recipientes para gases comprimidos ou liquefeitos, de ferro fundido, ferro ou aço."
  },
  {
    "codigo": "73121010",
    "descricao": "De fios de aço revestidos de bronze ou latão"
  },
  {
    "codigo": "73121090",
    "descricao": "Outros"
  },
  {
    "codigo": "73129000",
    "descricao": "- Outros"
  },
  {
    "codigo": "73130000",
    "descricao": "Arame farpado, de ferro ou aço; arames ou tiras, retorcidos, mesmo farpados, de ferro ou aço, do tipo utilizado em cercas."
  },
  {
    "codigo": "73141200",
    "descricao": "-- Telas metálicas, contínuas ou sem fim, para máquinas, de aço inoxidável"
  },
  {
    "codigo": "73141400",
    "descricao": "-- Outras telas metálicas tecidas, de aço inoxidável"
  },
  {
    "codigo": "73141900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "73142000",
    "descricao": "- Grades e redes, soldadas nos pontos de interseção, de fios com, pelo menos, 3 mm na maior dimensão da seção transversal e com malhas de 100 cm<sup>2</sup> ou mais, de superfície"
  },
  {
    "codigo": "73143100",
    "descricao": "-- Galvanizadas"
  },
  {
    "codigo": "73143900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "73144100",
    "descricao": "-- Galvanizadas"
  },
  {
    "codigo": "73144200",
    "descricao": "-- Revestidas de plástico"
  },
  {
    "codigo": "73144900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "73145000",
    "descricao": "- Chapas e tiras, distendidas"
  },
  {
    "codigo": "73151110",
    "descricao": "Do tipo utilizado em bicicletas, com passo de 12,7 mm (1/2\") e largura interna igual ou superior a 1,98 mm (5/64\"), mas inferior ou igual a 3,17 mm (1/8\")"
  },
  {
    "codigo": "73151190",
    "descricao": "Outras"
  },
  {
    "codigo": "73151210",
    "descricao": "De transmissão"
  },
  {
    "codigo": "73151290",
    "descricao": "Outras"
  },
  {
    "codigo": "73151900",
    "descricao": "-- Partes"
  },
  {
    "codigo": "73152000",
    "descricao": "- Correntes antiderrapantes"
  },
  {
    "codigo": "73158100",
    "descricao": "-- Correntes de elos com suporte"
  },
  {
    "codigo": "73158200",
    "descricao": "-- Outras correntes, de elos soldados"
  },
  {
    "codigo": "73158900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "73159000",
    "descricao": "- Outras partes"
  },
  {
    "codigo": "73160000",
    "descricao": "Âncoras, fateixas, e suas partes, de ferro fundido, ferro ou aço."
  },
  {
    "codigo": "73170010",
    "descricao": "Tachas"
  },
  {
    "codigo": "73170020",
    "descricao": "Grampos de fio curvado"
  },
  {
    "codigo": "73170030",
    "descricao": "Pontas ou dentes para máquinas têxteis"
  },
  {
    "codigo": "73170090",
    "descricao": "Outros"
  },
  {
    "codigo": "73181100",
    "descricao": "-- Tira-fundos"
  },
  {
    "codigo": "73181200",
    "descricao": "-- Outros parafusos para madeira"
  },
  {
    "codigo": "73181300",
    "descricao": "-- Ganchos, escápulas e pitões"
  },
  {
    "codigo": "73181400",
    "descricao": "-- Parafusos autoperfurantes"
  },
  {
    "codigo": "73181500",
    "descricao": "-- Outros parafusos e pinos ou pernos, mesmo com as porcas e arruelas (anilhas)"
  },
  {
    "codigo": "73181600",
    "descricao": "-- Porcas"
  },
  {
    "codigo": "73181900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "73182100",
    "descricao": "-- Arruelas (anilhas) de pressão e outras arruelas (anilhas) de segurança"
  },
  {
    "codigo": "73182200",
    "descricao": "-- Outras arruelas (anilhas)"
  },
  {
    "codigo": "73182300",
    "descricao": "-- Rebites"
  },
  {
    "codigo": "73182400",
    "descricao": "-- Chavetas e contrapinos ou troços"
  },
  {
    "codigo": "73182900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "73194000",
    "descricao": "- Alfinetes de segurança e outros alfinetes"
  },
  {
    "codigo": "73199000",
    "descricao": "- Outros"
  },
  {
    "codigo": "73201000",
    "descricao": "- Molas de folhas e suas folhas"
  },
  {
    "codigo": "73202010",
    "descricao": "Cilíndricas"
  },
  {
    "codigo": "73202090",
    "descricao": "Outras"
  },
  {
    "codigo": "73209000",
    "descricao": "- Outras"
  },
  {
    "codigo": "73211100",
    "descricao": "-- A combustíveis gasosos, ou a gás e outros combustíveis"
  },
  {
    "codigo": "73211200",
    "descricao": "-- A combustíveis líquidos"
  },
  {
    "codigo": "73211900",
    "descricao": "-- Outros, incluindo os aparelhos a combustíveis sólidos"
  },
  {
    "codigo": "73218100",
    "descricao": "-- A combustíveis gasosos, ou a gás e outros combustíveis"
  },
  {
    "codigo": "73218200",
    "descricao": "-- A combustíveis líquidos"
  },
  {
    "codigo": "73218900",
    "descricao": "-- Outros, incluindo os aparelhos a combustíveis sólidos"
  },
  {
    "codigo": "73219000",
    "descricao": "- Partes"
  },
  {
    "codigo": "73221100",
    "descricao": "-- De ferro fundido"
  },
  {
    "codigo": "73221900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "73229010",
    "descricao": "Geradores de ar quente a combustível líquido, com capacidade igual ou superior a 1.500 kcal/h, mas não superior a 10.400 kcal/h, do tipo utilizado em veículos automóveis"
  },
  {
    "codigo": "73229090",
    "descricao": "Outros"
  },
  {
    "codigo": "73231000",
    "descricao": "- Palha de ferro ou aço; esponjas, esfregões, luvas e artigos semelhantes para limpeza, polimento ou usos semelhantes"
  },
  {
    "codigo": "73239100",
    "descricao": "-- De ferro fundido, não esmaltados"
  },
  {
    "codigo": "73239200",
    "descricao": "-- De ferro fundido, esmaltados"
  },
  {
    "codigo": "73239300",
    "descricao": "-- De aço inoxidável"
  },
  {
    "codigo": "73239400",
    "descricao": "-- De ferro ou aço, esmaltados"
  },
  {
    "codigo": "73239900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "73241000",
    "descricao": "- Pias e lavatórios, de aço inoxidável"
  },
  {
    "codigo": "73242100",
    "descricao": "-- De ferro fundido, mesmo esmaltadas"
  },
  {
    "codigo": "73242900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "73249000",
    "descricao": "- Outros, incluindo as partes"
  },
  {
    "codigo": "73251000",
    "descricao": "- De ferro fundido, não maleável"
  },
  {
    "codigo": "73259100",
    "descricao": "-- Esferas e artigos semelhantes, para moinhos"
  },
  {
    "codigo": "73259910",
    "descricao": "De aço"
  },
  {
    "codigo": "73259990",
    "descricao": "Outras"
  },
  {
    "codigo": "73261100",
    "descricao": "-- Esferas e artigos semelhantes, para moinhos"
  },
  {
    "codigo": "73261900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "73262000",
    "descricao": "- Obras de fio de ferro ou aço"
  },
  {
    "codigo": "73269010",
    "descricao": "Calotas elípticas de aço ao níquel, segundo Norma ASME SA 353, do tipo utilizado na fabricação de recipientes para gases comprimidos ou liquefeitos"
  },
  {
    "codigo": "73269020",
    "descricao": "Discos próprios para cunhagem de moedas"
  },
  {
    "codigo": "73269090",
    "descricao": "Outras"
  },
  {
    "codigo": "74010000",
    "descricao": "Mates de cobre; cobre de cementação (precipitado de cobre)."
  },
  {
    "codigo": "74020000",
    "descricao": "Cobre não refinado (afinado); ânodos de cobre para refinação (afinação) eletrolítica."
  },
  {
    "codigo": "74031100",
    "descricao": "-- Cátodos e seus elementos"
  },
  {
    "codigo": "74031200",
    "descricao": "-- Barras para obtenção de fios (<i>wire-bars</i>)"
  },
  {
    "codigo": "74031300",
    "descricao": "-- Palanquilhas (Lingotes*) (<i>billets</i>)"
  },
  {
    "codigo": "74031900",
    "descricao": "-- Outro"
  },
  {
    "codigo": "74032100",
    "descricao": "-- À base de cobrezinco (latão)"
  },
  {
    "codigo": "74032200",
    "descricao": "-- À base de cobre-estanho (bronze)"
  },
  {
    "codigo": "74032900",
    "descricao": "-- Outras ligas de cobre (exceto ligas-mãe da posição 74.05)"
  },
  {
    "codigo": "74040000",
    "descricao": "Desperdícios e resíduos, e sucata, de cobre."
  },
  {
    "codigo": "74050000",
    "descricao": "Ligas-mãe de cobre."
  },
  {
    "codigo": "74061010",
    "descricao": "Com um teor, em peso, de chumbo igual ou superior a 9,5 %, mas inferior ou igual a 25,0 % e de estanho igual ou superior a 1,75 %, mas inferior ou igual a 11,0 %, sem outros elementos"
  },
  {
    "codigo": "74061020",
    "descricao": "Com um teor, em peso, de estanho igual ou superior a 7,0 %, mas inferior ou igual a 9,0 % e de níquel igual ou superior a 0,7 %, mas inferior ou igual a 1,3 %, sem outros elementos"
  },
  {
    "codigo": "74061090",
    "descricao": "Outros"
  },
  {
    "codigo": "74062000",
    "descricao": "- Pós de estrutura lamelar; escamas"
  },
  {
    "codigo": "74071010",
    "descricao": "Barras"
  },
  {
    "codigo": "74071021",
    "descricao": "Ocos"
  },
  {
    "codigo": "74071029",
    "descricao": "Outros"
  },
  {
    "codigo": "74072110",
    "descricao": "Barras"
  },
  {
    "codigo": "74072120",
    "descricao": "Perfis"
  },
  {
    "codigo": "74072910",
    "descricao": "Barras"
  },
  {
    "codigo": "74072921",
    "descricao": "Ocos"
  },
  {
    "codigo": "74072929",
    "descricao": "Outros"
  },
  {
    "codigo": "74081100",
    "descricao": "-- Com a maior dimensão da seção transversal superior a 6 mm"
  },
  {
    "codigo": "74081900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "74082100",
    "descricao": "-- À base de cobrezinco (latão)"
  },
  {
    "codigo": "74082200",
    "descricao": "-- À base de cobreníquel (cuproníquel) ou de cobreniquelzinco (<i>maillechort</i>)"
  },
  {
    "codigo": "74082912",
    "descricao": "Fosforoso, de seção transversal circular, de diâmetro inferior ou igual a 0,8 mm"
  },
  {
    "codigo": "74082913",
    "descricao": "Outros, fosforosos"
  },
  {
    "codigo": "74082919",
    "descricao": "Outros"
  },
  {
    "codigo": "74082990",
    "descricao": "Outros"
  },
  {
    "codigo": "74091100",
    "descricao": "-- Em rolos"
  },
  {
    "codigo": "74091900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "74092100",
    "descricao": "-- Em rolos"
  },
  {
    "codigo": "74092900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "74093111",
    "descricao": "Com uma camada intermediária de liga de cobre-estanho ou cobre-estanho-chumbo, aplicada por sinterização"
  },
  {
    "codigo": "74093119",
    "descricao": "Outras"
  },
  {
    "codigo": "74093190",
    "descricao": "Outras"
  },
  {
    "codigo": "74093900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "74094011",
    "descricao": "De liga de cobreniquelsilício, galvanizadas"
  },
  {
    "codigo": "74094019",
    "descricao": "Outras"
  },
  {
    "codigo": "74094090",
    "descricao": "Outras"
  },
  {
    "codigo": "74099000",
    "descricao": "- De outras ligas de cobre"
  },
  {
    "codigo": "74101112",
    "descricao": "De espessura inferior ou igual a 0,04 mm e uma resistividade elétrica inferior ou igual a 0,017241 ohm.mm<sup>2</sup>/m"
  },
  {
    "codigo": "74101113",
    "descricao": "Outras, de espessura inferior ou igual a 0,04 mm"
  },
  {
    "codigo": "74101119",
    "descricao": "Outras"
  },
  {
    "codigo": "74101190",
    "descricao": "Outras"
  },
  {
    "codigo": "74101200",
    "descricao": "-- De ligas de cobre"
  },
  {
    "codigo": "74102110",
    "descricao": "Com suporte isolante de resina epóxida e fibra de vidro, do tipo utilizado para circuitos impressos"
  },
  {
    "codigo": "74102120",
    "descricao": "Com espessura superior a 0,012 mm, sobre suporte de poliéster ou poliimida e com espessura total, incluindo o suporte, inferior ou igual a 0,195 mm"
  },
  {
    "codigo": "74102130",
    "descricao": "Com suporte isolante de resina fenólica e papel, do tipo utilizado para circuitos impressos"
  },
  {
    "codigo": "74102190",
    "descricao": "Outras"
  },
  {
    "codigo": "74102200",
    "descricao": "-- De ligas de cobre"
  },
  {
    "codigo": "74111010",
    "descricao": "Não aletados nem ranhurados"
  },
  {
    "codigo": "74111090",
    "descricao": "Outros"
  },
  {
    "codigo": "74112110",
    "descricao": "Não aletados nem ranhurados"
  },
  {
    "codigo": "74112190",
    "descricao": "Outros"
  },
  {
    "codigo": "74112210",
    "descricao": "Não aletados nem ranhurados"
  },
  {
    "codigo": "74112290",
    "descricao": "Outros"
  },
  {
    "codigo": "74112910",
    "descricao": "Não aletados nem ranhurados"
  },
  {
    "codigo": "74112990",
    "descricao": "Outros"
  },
  {
    "codigo": "74121000",
    "descricao": "- De cobre refinado (afinado)"
  },
  {
    "codigo": "74122000",
    "descricao": "- De ligas de cobre"
  },
  {
    "codigo": "74130000",
    "descricao": "Cordas, cabos, tranças (entrançados*) e artigos semelhantes, de cobre, não isolados para usos elétricos."
  },
  {
    "codigo": "74151000",
    "descricao": "- Tachas, pregos, percevejos, escápulas (pregos para tacos) e artigos semelhantes"
  },
  {
    "codigo": "74152100",
    "descricao": "-- Arruelas (anilhas) (incluindo as de pressão)"
  },
  {
    "codigo": "74152900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "74153300",
    "descricao": "-- Parafusos; pinos ou pernos e porcas"
  },
  {
    "codigo": "74153900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "74181000",
    "descricao": "- Serviços de mesa, artigos de cozinha e outros artigos de uso doméstico, e suas partes; esponjas, esfregões, luvas e artigos semelhantes, para limpeza, polimento ou usos semelhantes"
  },
  {
    "codigo": "74182000",
    "descricao": "- Artigos de higiene ou de toucador, e suas partes"
  },
  {
    "codigo": "74192000",
    "descricao": "- Vazadas, moldadas, estampadas ou forjadas, mas não trabalhadas de outro modo"
  },
  {
    "codigo": "74198010",
    "descricao": "Telas metálicas de fio de cobre"
  },
  {
    "codigo": "74198020",
    "descricao": "Grades e redes, de fio de cobre; chapas e tiras, distendidas"
  },
  {
    "codigo": "74198030",
    "descricao": "Molas"
  },
  {
    "codigo": "74198040",
    "descricao": "Discos próprios para cunhagem de moedas"
  },
  {
    "codigo": "74198090",
    "descricao": "Outras"
  },
  {
    "codigo": "75011000",
    "descricao": "- Mates de níquel"
  },
  {
    "codigo": "75012000",
    "descricao": "- <i>Sinters</i> de óxidos de níquel e outros produtos intermediários da metalurgia do níquel"
  },
  {
    "codigo": "75021010",
    "descricao": "Catodos"
  },
  {
    "codigo": "75021090",
    "descricao": "Outro"
  },
  {
    "codigo": "75022000",
    "descricao": "- Ligas de níquel"
  },
  {
    "codigo": "75030000",
    "descricao": "Desperdícios e resíduos, e sucata, de níquel."
  },
  {
    "codigo": "75040010",
    "descricao": "Não ligado"
  },
  {
    "codigo": "75040090",
    "descricao": "Outros"
  },
  {
    "codigo": "75051110",
    "descricao": "Barras"
  },
  {
    "codigo": "75051121",
    "descricao": "Ocos"
  },
  {
    "codigo": "75051129",
    "descricao": "Outros"
  },
  {
    "codigo": "75051210",
    "descricao": "Barras"
  },
  {
    "codigo": "75051221",
    "descricao": "Ocos"
  },
  {
    "codigo": "75051229",
    "descricao": "Outros"
  },
  {
    "codigo": "75052100",
    "descricao": "-- De níquel não ligado"
  },
  {
    "codigo": "75052210",
    "descricao": "À base de niqueltitânio (nitinol)"
  },
  {
    "codigo": "75052290",
    "descricao": "Outros"
  },
  {
    "codigo": "75061000",
    "descricao": "- De níquel não ligado"
  },
  {
    "codigo": "75062000",
    "descricao": "- De ligas de níquel"
  },
  {
    "codigo": "75071100",
    "descricao": "-- De níquel não ligado"
  },
  {
    "codigo": "75071200",
    "descricao": "-- De ligas de níquel"
  },
  {
    "codigo": "75072000",
    "descricao": "- Acessórios para tubos"
  },
  {
    "codigo": "75081000",
    "descricao": "- Telas metálicas e grades, de fios de níquel"
  },
  {
    "codigo": "75089010",
    "descricao": "Cilindros ocos de seção variável, obtidos por centrifugação, do tipo utilizado em reformadores estequiométricos de gás natural"
  },
  {
    "codigo": "75089090",
    "descricao": "Outras"
  },
  {
    "codigo": "76011000",
    "descricao": "- Alumínio não ligado"
  },
  {
    "codigo": "76012000",
    "descricao": "- Ligas de alumínio"
  },
  {
    "codigo": "76020000",
    "descricao": "Desperdícios e resíduos, e sucata, de alumínio."
  },
  {
    "codigo": "76031000",
    "descricao": "- Pós de estrutura não lamelar"
  },
  {
    "codigo": "76032000",
    "descricao": "- Pós de estrutura lamelar; escamas"
  },
  {
    "codigo": "76041010",
    "descricao": "Barras"
  },
  {
    "codigo": "76041021",
    "descricao": "Ocos"
  },
  {
    "codigo": "76041029",
    "descricao": "Outros"
  },
  {
    "codigo": "76042100",
    "descricao": "-- Perfis ocos"
  },
  {
    "codigo": "76042911",
    "descricao": "Forjadas, de seção transversal circular, de diâmetro igual ou superior a 400 mm, mas não superior a 760 mm"
  },
  {
    "codigo": "76042919",
    "descricao": "Outras"
  },
  {
    "codigo": "76042920",
    "descricao": "Perfis"
  },
  {
    "codigo": "76051110",
    "descricao": "Com um teor de alumínio igual ou superior a 99,45 %, em peso, e uma resistividade elétrica inferior ou igual a 0,0283 ohm.mm<sup>2</sup>/m"
  },
  {
    "codigo": "76051190",
    "descricao": "Outros"
  },
  {
    "codigo": "76051910",
    "descricao": "Com um teor de alumínio igual ou superior a 99,45 %, em peso, e uma resistividade elétrica inferior ou igual a 0,0283 ohm.mm<sup>2</sup>/m"
  },
  {
    "codigo": "76051990",
    "descricao": "Outros"
  },
  {
    "codigo": "76052110",
    "descricao": "Com um teor, em peso, de alumínio igual ou superior a 98,45 %, e de magnésio e silício, considerados individualmente, igual ou superior a 0,45 % e inferior ou igual a 0,55 % e uma resistividade elétrica inferior ou igual a 0,0328 ohm.mm<sup>2</sup>/m"
  },
  {
    "codigo": "76052190",
    "descricao": "Outros"
  },
  {
    "codigo": "76052910",
    "descricao": "Com um teor, em peso, de alumínio igual ou superior a 98,45 %, e de magnésio e silício, considerados individualmente, igual ou superior a 0,45 % e inferior ou igual a 0,55 % e uma resistividade elétrica inferior ou igual a 0,0328 ohm.mm<sup>2</sup>/m"
  },
  {
    "codigo": "76052990",
    "descricao": "Outros"
  },
  {
    "codigo": "76061110",
    "descricao": "Com um teor, em peso, de silício igual ou superior a 0,05 % e inferior ou igual a 0,20 %, de ferro igual ou superior a 0,20 % e inferior ou igual a 0,40 %, de cobre inferior ou igual a 0,05 %, de zinco inferior ou igual a 0,05 %, de manganês inferior ou igual a 0,1 % e de outros elementos, cada um, inferior ou igual a 0,1 %, de espessura inferior ou igual a 0,4 mm, em bobinas de largura superior a 900 mm, com uma relação entre as rugosidades máxima e aritmética média igual ou superior a 1,25 e inferior ou igual a 1,30 em cada uma das faces e com um limite de resistência à tração igual ou superior a 115 MPa"
  },
  {
    "codigo": "76061190",
    "descricao": "Outras"
  },
  {
    "codigo": "76061210",
    "descricao": "Com teores, em peso, de magnésio igual ou superior a 4 % e inferior ou igual a 5 %, de manganês igual ou superior a 0,20 % e inferior ou igual a 0,50 %, de ferro inferior ou igual a 0,35 %, de silício inferior ou igual a 0,20 % e de outros metais, em conjunto, inferior ou igual a 0,75 %, e de espessura inferior ou igual a 0,3 mm e largura igual ou superior a 1.450 mm, envernizadas em ambas as faces"
  },
  {
    "codigo": "76061220",
    "descricao": "Com um teor, em peso, de alumínio igual ou superior a 99 % e de magnésio superior a 0,10 %, de espessura inferior ou igual a 0,40 mm, com um limite de resistência a tração igual ou superior a 140 MPa, mas inferior ou igual a 240 MPa, e alongamento igual ou superior a 0,90 %, mas inferior ou igual a 7 %"
  },
  {
    "codigo": "76061230",
    "descricao": "Simplesmente laminadas, constituídas de, pelo menos, duas camadas de diferentes ligas de alumínio, sendo uma o núcleo e as outras de revestimento, exceto: núcleo de liga da <i>Aluminium Association</i> AA 3003 modificada (liga de alumínio com um teor, em peso, de silício inferior ou igual a 0,60 %, de ferro inferior ou igual a 0,70 %, de cobre igual ou superior a 0,05 % e inferior ou igual a 0,20 %, de manganês igual ou superior a 1,0 % e inferior ou igual a 1,5 %, de zinco inferior ou igual a 0,15 % e de outros elementos total inferior ou igual a 0,15 %) com revestimento de liga AA 4343 (liga de alumínio com um teor, em peso, de silício igual ou superior a 6,8 % e inferior ou igual a 8,2 %, de ferro inferior ou igual a 0,80 %, de cobre inferior ou igual a 0,25 %, de manganês inferior ou igual a 0,10 %, de zinco inferior ou igual a 0,20 % e de outros elementos total inferior ou igual a 0,15 %)"
  },
  {
    "codigo": "76061290",
    "descricao": "Outras"
  },
  {
    "codigo": "76069100",
    "descricao": "-- De alumínio não ligado"
  },
  {
    "codigo": "76069200",
    "descricao": "-- De ligas de alumínio"
  },
  {
    "codigo": "76071110",
    "descricao": "Com um teor, em peso, de alumínio igual ou superior a 99 % e de magnésio superior a 0,06 %, de espessura igual ou superior a 0,12 mm, com um limite de resistência a tração igual ou superior a 140 MPa, mas inferior ou igual a 240 MPa, e alongamento igual ou superior a 0,90 %, mas inferior ou igual a 7 %"
  },
  {
    "codigo": "76071120",
    "descricao": "Constituídas de, pelo menos, duas camadas de diferentes ligas de alumínio, sendo uma o núcleo e as outras de revestimento, exceto: núcleo de liga da <i>Aluminium Association</i> AA 3003 modificada (liga de alumínio com um teor, em peso, de silício inferior ou igual a 0,60 %, de ferro inferior ou igual a 0,70 %, de cobre igual ou superior a 0,05 % e inferior ou igual a 0,20 %, de manganês igual ou superior a 1,0 % e inferior ou igual a 1,5 %, de zinco inferior ou igual a 0,15 % e de outros elementos total inferior ou igual a 0,15 %) com revestimento de liga AA 4343 (liga de alumínio com um teor, em peso, de silício igual ou superior a 6,8 % e inferior ou igual a 8,2 %, de ferro inferior ou igual a 0,80 %, de cobre inferior ou igual a 0,25 %, de manganês inferior ou igual a 0,10 %, de zinco inferior ou igual a 0,20 % e de outros elementos total inferior ou igual a 0,15 %)"
  },
  {
    "codigo": "76071190",
    "descricao": "Outras"
  },
  {
    "codigo": "76071910",
    "descricao": "Gravadas por processo eletroquímico de corrosão, mesmo com camada de óxido de alumínio, de espessura inferior ou igual a 110 micrômetros (mícrons) e com um conteúdo de alumínio igual ou superior a 98 %, em peso"
  },
  {
    "codigo": "76071990",
    "descricao": "Outras"
  },
  {
    "codigo": "76072000",
    "descricao": "- Com suporte"
  },
  {
    "codigo": "76081000",
    "descricao": "- De alumínio não ligado"
  },
  {
    "codigo": "76082010",
    "descricao": "Sem costura, extrudados e trefilados, segundo Norma ASTM B210, de seção circular, de liga AA 6061 (<i>Aluminium Association</i>), com limite elástico aparente de Johnson (JAEL) superior a 3.000 Nm, segundo Norma SAE AE7, diâmetro externo igual ou superior a 85 mm, mas inferior ou igual a 105 mm e espessura igual ou superior a 1,9 mm, mas inferior ou igual a 2,3 mm"
  },
  {
    "codigo": "76082090",
    "descricao": "Outros"
  },
  {
    "codigo": "76090000",
    "descricao": "Acessórios para tubos (por exemplo, uniões, cotovelos, luvas (mangas*)), de alumínio."
  },
  {
    "codigo": "76101000",
    "descricao": "- Portas e janelas, e seus caixilhos, alizares e soleiras"
  },
  {
    "codigo": "76109000",
    "descricao": "- Outros"
  },
  {
    "codigo": "76110000",
    "descricao": "Reservatórios, tonéis, cubas e recipientes semelhantes para quaisquer matérias (exceto gases comprimidos ou liquefeitos), de alumínio, de capacidade superior a 300 l, sem dispositivos mecânicos ou térmicos, mesmo com revestimento interior ou calorífugo."
  },
  {
    "codigo": "76121000",
    "descricao": "- Recipientes tubulares, flexíveis"
  },
  {
    "codigo": "76129011",
    "descricao": "Para aerossóis, com capacidade inferior ou igual a 700 cm<sup>3</sup>"
  },
  {
    "codigo": "76129012",
    "descricao": "Isotérmicos, refrigerados a nitrogênio (azoto) líquido, do tipo utilizado para sêmen, sangue, tecidos biológicos e outros produtos semelhantes"
  },
  {
    "codigo": "76129019",
    "descricao": "Outros"
  },
  {
    "codigo": "76129020",
    "descricao": "Recipientes (cápsulas) para embalagem de café e produtos semelhantes, do tipo utilizado em máquinas para preparação de bebidas"
  },
  {
    "codigo": "76129090",
    "descricao": "Outros"
  },
  {
    "codigo": "76130000",
    "descricao": "Recipientes para gases comprimidos ou liquefeitos, de alumínio."
  },
  {
    "codigo": "76141010",
    "descricao": "Cordas e cabos"
  },
  {
    "codigo": "76141090",
    "descricao": "Outros"
  },
  {
    "codigo": "76149010",
    "descricao": "Cabos"
  },
  {
    "codigo": "76149090",
    "descricao": "Outros"
  },
  {
    "codigo": "76151000",
    "descricao": "- Serviços de mesa, artigos de cozinha e outros artigos de uso doméstico, e suas partes; esponjas, esfregões, luvas e artigos semelhantes, para limpeza, polimento ou usos semelhantes"
  },
  {
    "codigo": "76152000",
    "descricao": "- Artigos de higiene ou de toucador, e suas partes"
  },
  {
    "codigo": "76161000",
    "descricao": "- Tachas, pregos, escápulas (pregos para tacos), parafusos, pinos ou pernos roscados, porcas, ganchos roscados, rebites, chavetas, cavilhas, contrapinos ou troços, arruelas (anilhas) e artigos semelhantes"
  },
  {
    "codigo": "76169100",
    "descricao": "-- Telas metálicas, grades e redes, de fios de alumínio"
  },
  {
    "codigo": "76169900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "78011011",
    "descricao": "Em lingotes"
  },
  {
    "codigo": "78011019",
    "descricao": "Outro"
  },
  {
    "codigo": "78011090",
    "descricao": "Outro"
  },
  {
    "codigo": "78019100",
    "descricao": "-- Que contenha antimônio como segundo elemento predominante em peso"
  },
  {
    "codigo": "78019900",
    "descricao": "-- Outro"
  },
  {
    "codigo": "78020000",
    "descricao": "Desperdícios e resíduos, e sucata, de chumbo."
  },
  {
    "codigo": "78041100",
    "descricao": "-- Folhas e tiras, de espessura não superior a 0,2 mm (excluindo o suporte)"
  },
  {
    "codigo": "78041900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "78042000",
    "descricao": "- Pós e escamas"
  },
  {
    "codigo": "78060010",
    "descricao": "Barras, perfis e fios"
  },
  {
    "codigo": "78060020",
    "descricao": "Tubos e seus acessórios"
  },
  {
    "codigo": "78060090",
    "descricao": "Outras"
  },
  {
    "codigo": "79011111",
    "descricao": "Em lingotes"
  },
  {
    "codigo": "79011119",
    "descricao": "Outro"
  },
  {
    "codigo": "79011191",
    "descricao": "Em lingotes"
  },
  {
    "codigo": "79011199",
    "descricao": "Outro"
  },
  {
    "codigo": "79011210",
    "descricao": "Em lingotes"
  },
  {
    "codigo": "79011290",
    "descricao": "Outro"
  },
  {
    "codigo": "79012010",
    "descricao": "Em lingotes"
  },
  {
    "codigo": "79012090",
    "descricao": "Outro"
  },
  {
    "codigo": "79020000",
    "descricao": "Desperdícios e resíduos, e sucata, de zinco."
  },
  {
    "codigo": "79031000",
    "descricao": "- Poeiras de zinco"
  },
  {
    "codigo": "79039000",
    "descricao": "- Outros"
  },
  {
    "codigo": "79040000",
    "descricao": "Barras, perfis e fios, de zinco."
  },
  {
    "codigo": "79050000",
    "descricao": "Chapas, folhas e tiras, de zinco."
  },
  {
    "codigo": "79070010",
    "descricao": "Tubos e seus acessórios"
  },
  {
    "codigo": "79070090",
    "descricao": "Outras"
  },
  {
    "codigo": "80011000",
    "descricao": "- Estanho não ligado"
  },
  {
    "codigo": "80012000",
    "descricao": "- Ligas de estanho"
  },
  {
    "codigo": "80020000",
    "descricao": "Desperdícios e resíduos, e sucata, de estanho."
  },
  {
    "codigo": "80030000",
    "descricao": "Barras, perfis e fios, de estanho."
  },
  {
    "codigo": "80070010",
    "descricao": "Chapas, folhas e tiras"
  },
  {
    "codigo": "80070020",
    "descricao": "Pós e escamas"
  },
  {
    "codigo": "80070030",
    "descricao": "Tubos e seus acessórios"
  },
  {
    "codigo": "80070090",
    "descricao": "Outras"
  },
  {
    "codigo": "81011000",
    "descricao": "- Pós"
  },
  {
    "codigo": "81019400",
    "descricao": "-- Tungstênio (volfrâmio) em formas brutas, incluindo as barras simplesmente obtidas por sinterização"
  },
  {
    "codigo": "81019600",
    "descricao": "-- Fios"
  },
  {
    "codigo": "81019700",
    "descricao": "-- Desperdícios e resíduos, e sucata"
  },
  {
    "codigo": "81019910",
    "descricao": "Do tipo utilizado na fabricação de contatos elétricos"
  },
  {
    "codigo": "81019990",
    "descricao": "Outros"
  },
  {
    "codigo": "81021000",
    "descricao": "- Pós"
  },
  {
    "codigo": "81029400",
    "descricao": "-- Molibdênio em formas brutas, incluindo as barras simplesmente obtidas por sinterização"
  },
  {
    "codigo": "81029500",
    "descricao": "-- Barras, exceto as simplesmente obtidas por sinterização, perfis, chapas, tiras e folhas"
  },
  {
    "codigo": "81029600",
    "descricao": "-- Fios"
  },
  {
    "codigo": "81029700",
    "descricao": "-- Desperdícios e resíduos, e sucata"
  },
  {
    "codigo": "81029900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "81032000",
    "descricao": "- Tântalo em formas brutas, incluindo as barras simplesmente obtidas por sinterização; pós"
  },
  {
    "codigo": "81033000",
    "descricao": "- Desperdícios e resíduos, e sucata"
  },
  {
    "codigo": "81039100",
    "descricao": "-- Cadinhos"
  },
  {
    "codigo": "81039900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "81041100",
    "descricao": "-- Que contenha pelo menos 99,8 %, em peso, de magnésio"
  },
  {
    "codigo": "81041900",
    "descricao": "-- Outro"
  },
  {
    "codigo": "81042000",
    "descricao": "- Desperdícios e resíduos, e sucata"
  },
  {
    "codigo": "81043000",
    "descricao": "- Aparas, resíduos de torno e grânulos, calibrados; pós"
  },
  {
    "codigo": "81049000",
    "descricao": "- Outros"
  },
  {
    "codigo": "81052010",
    "descricao": "Em formas brutas"
  },
  {
    "codigo": "81052021",
    "descricao": "De ligas à base de cobalto-cromo-tungstênio (volfrâmio) (estelites)"
  },
  {
    "codigo": "81052029",
    "descricao": "Outros"
  },
  {
    "codigo": "81052090",
    "descricao": "Outros"
  },
  {
    "codigo": "81053000",
    "descricao": "- Desperdícios e resíduos, e sucata"
  },
  {
    "codigo": "81059010",
    "descricao": "Chapas, folhas, tiras, fios, hastes, pastilhas e plaquetas"
  },
  {
    "codigo": "81059090",
    "descricao": "Outros"
  },
  {
    "codigo": "81061000",
    "descricao": "- Que contenham mais de 99,99 %, em peso, de bismuto"
  },
  {
    "codigo": "81069000",
    "descricao": "- Outros"
  },
  {
    "codigo": "81082000",
    "descricao": "- Titânio em formas brutas; pós"
  },
  {
    "codigo": "81083000",
    "descricao": "- Desperdícios e resíduos, e sucata"
  },
  {
    "codigo": "81089000",
    "descricao": "- Outros"
  },
  {
    "codigo": "81092100",
    "descricao": "-- Que contenham menos de uma parte de háfnio para 500 partes, em peso, de zircônio"
  },
  {
    "codigo": "81092900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "81093100",
    "descricao": "-- Que contenham menos de uma parte de háfnio para 500 partes, em peso, de zircônio"
  },
  {
    "codigo": "81093900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "81099100",
    "descricao": "-- Que contenham menos de uma parte de háfnio para 500 partes, em peso, de zircônio"
  },
  {
    "codigo": "81099900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "81101010",
    "descricao": "Em formas brutas"
  },
  {
    "codigo": "81101020",
    "descricao": "Pós"
  },
  {
    "codigo": "81102000",
    "descricao": "- Desperdícios e resíduos, e sucata"
  },
  {
    "codigo": "81109000",
    "descricao": "- Outros"
  },
  {
    "codigo": "81110010",
    "descricao": "Em formas brutas"
  },
  {
    "codigo": "81110020",
    "descricao": "Chapas, folhas, tiras, fios, hastes, pastilhas e plaquetas"
  },
  {
    "codigo": "81110090",
    "descricao": "Outros"
  },
  {
    "codigo": "81121200",
    "descricao": "-- Em formas brutas; pós"
  },
  {
    "codigo": "81121300",
    "descricao": "-- Desperdícios e resíduos, e sucata"
  },
  {
    "codigo": "81121900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "81122110",
    "descricao": "Em formas brutas"
  },
  {
    "codigo": "81122120",
    "descricao": "Pós"
  },
  {
    "codigo": "81122200",
    "descricao": "-- Desperdícios e resíduos, e sucata"
  },
  {
    "codigo": "81122900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "81123100",
    "descricao": "-- Em formas brutas; desperdícios e resíduos, e sucata; pós"
  },
  {
    "codigo": "81123900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "81124100",
    "descricao": "-- Em formas brutas; desperdícios e resíduos, e sucata; pós"
  },
  {
    "codigo": "81124900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "81125100",
    "descricao": "-- Em formas brutas; pós"
  },
  {
    "codigo": "81125200",
    "descricao": "-- Desperdícios e resíduos, e sucata"
  },
  {
    "codigo": "81125900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "81126100",
    "descricao": "-- Desperdícios e resíduos, e sucata"
  },
  {
    "codigo": "81126900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "81129200",
    "descricao": "-- Em formas brutas; desperdícios e resíduos, e sucata; pós"
  },
  {
    "codigo": "81129900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "81130010",
    "descricao": "Chapas, folhas, tiras, fios, hastes, pastilhas e plaquetas"
  },
  {
    "codigo": "81130090",
    "descricao": "Outros"
  },
  {
    "codigo": "82011000",
    "descricao": "- Pás"
  },
  {
    "codigo": "82013000",
    "descricao": "- Alviões, picaretas, enxadas, sachos, ancinhos e raspadeiras"
  },
  {
    "codigo": "82014000",
    "descricao": "- Machados, podões e ferramentas semelhantes com gume"
  },
  {
    "codigo": "82015000",
    "descricao": "- Tesouras de podar (incluindo as tesouras para aves) manipuladas com uma das mãos"
  },
  {
    "codigo": "82016000",
    "descricao": "- Tesouras para sebes, tesouras de podar e ferramentas semelhantes, manipuladas com as duas mãos"
  },
  {
    "codigo": "82019000",
    "descricao": "- Outras ferramentas manuais para agricultura, horticultura e silvicultura"
  },
  {
    "codigo": "82021000",
    "descricao": "- Serras manuais"
  },
  {
    "codigo": "82022000",
    "descricao": "- Folhas de serras de fita"
  },
  {
    "codigo": "82023100",
    "descricao": "-- Com parte operante de aço"
  },
  {
    "codigo": "82023900",
    "descricao": "-- Outras, incluindo as partes"
  },
  {
    "codigo": "82024000",
    "descricao": "- Correntes cortantes de serras"
  },
  {
    "codigo": "82029100",
    "descricao": "-- Folhas de serras retilíneas, para trabalhar metais"
  },
  {
    "codigo": "82029910",
    "descricao": "Retas, não dentadas, para serrar pedras"
  },
  {
    "codigo": "82029990",
    "descricao": "Outras"
  },
  {
    "codigo": "82031010",
    "descricao": "Limas e grosas"
  },
  {
    "codigo": "82031090",
    "descricao": "Outras"
  },
  {
    "codigo": "82032010",
    "descricao": "Alicates (mesmo cortantes)"
  },
  {
    "codigo": "82032090",
    "descricao": "Outras"
  },
  {
    "codigo": "82033000",
    "descricao": "- Cisalhas para metais e ferramentas semelhantes"
  },
  {
    "codigo": "82034000",
    "descricao": "- Corta-tubos, corta-pinos, saca-bocados e ferramentas semelhantes"
  },
  {
    "codigo": "82041100",
    "descricao": "-- De abertura fixa"
  },
  {
    "codigo": "82041200",
    "descricao": "-- De abertura variável"
  },
  {
    "codigo": "82042000",
    "descricao": "- Chaves de caixa intercambiáveis, mesmo com cabos"
  },
  {
    "codigo": "82051000",
    "descricao": "- Ferramentas de furar ou de roscar"
  },
  {
    "codigo": "82052000",
    "descricao": "- Martelos e marretas"
  },
  {
    "codigo": "82053000",
    "descricao": "- Plainas, formões, goivas e ferramentas cortantes semelhantes, para trabalhar madeira"
  },
  {
    "codigo": "82054000",
    "descricao": "- Chaves de fenda"
  },
  {
    "codigo": "82055100",
    "descricao": "-- De uso doméstico"
  },
  {
    "codigo": "82055900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "82056000",
    "descricao": "- Lâmpadas ou lamparinas de soldar (maçaricos) e semelhantes"
  },
  {
    "codigo": "82057000",
    "descricao": "- Tornos de apertar, sargentos e semelhantes"
  },
  {
    "codigo": "82059000",
    "descricao": "- Outros, incluindo os sortidos constituídos por artigos incluídos em pelo menos duas das subposições da presente posição"
  },
  {
    "codigo": "82060000",
    "descricao": "Ferramentas de pelo menos duas das posições 82.02 a 82.05, acondicionadas em sortidos para venda a retalho."
  },
  {
    "codigo": "82071300",
    "descricao": "-- Com parte operante de <i>cermets</i>"
  },
  {
    "codigo": "82071910",
    "descricao": "Brocas (<i>drill bits</i>)"
  },
  {
    "codigo": "82071990",
    "descricao": "Outras"
  },
  {
    "codigo": "82072000",
    "descricao": "- Fieiras de estiramento ou de extrusão, para metais"
  },
  {
    "codigo": "82073000",
    "descricao": "- Ferramentas de embutir, de estampar ou de puncionar"
  },
  {
    "codigo": "82074010",
    "descricao": "De roscar interiormente"
  },
  {
    "codigo": "82074020",
    "descricao": "De roscar exteriormente"
  },
  {
    "codigo": "82075011",
    "descricao": "Helicoidais, de diâmetro inferior ou igual a 52 mm"
  },
  {
    "codigo": "82075019",
    "descricao": "Outras"
  },
  {
    "codigo": "82075090",
    "descricao": "Outras"
  },
  {
    "codigo": "82076000",
    "descricao": "- Ferramentas de escarear, mandrilar ou de brochar"
  },
  {
    "codigo": "82077010",
    "descricao": "De topo"
  },
  {
    "codigo": "82077020",
    "descricao": "Para cortar engrenagens"
  },
  {
    "codigo": "82077090",
    "descricao": "Outras"
  },
  {
    "codigo": "82078000",
    "descricao": "- Ferramentas de tornear"
  },
  {
    "codigo": "82079000",
    "descricao": "- Outras ferramentas intercambiáveis"
  },
  {
    "codigo": "82081000",
    "descricao": "- Para trabalhar metais"
  },
  {
    "codigo": "82082000",
    "descricao": "- Para trabalhar madeira"
  },
  {
    "codigo": "82083000",
    "descricao": "- Para aparelhos de cozinha ou para máquinas das indústrias alimentares"
  },
  {
    "codigo": "82084000",
    "descricao": "- Para máquinas de agricultura, horticultura ou silvicultura"
  },
  {
    "codigo": "82089000",
    "descricao": "- Outras"
  },
  {
    "codigo": "82090011",
    "descricao": "Intercambiáveis"
  },
  {
    "codigo": "82090019",
    "descricao": "Outras"
  },
  {
    "codigo": "82090090",
    "descricao": "Outros"
  },
  {
    "codigo": "82100010",
    "descricao": "Moinhos"
  },
  {
    "codigo": "82100090",
    "descricao": "Outros"
  },
  {
    "codigo": "82111000",
    "descricao": "- Sortidos"
  },
  {
    "codigo": "82119100",
    "descricao": "-- Facas de mesa, de lâmina fixa"
  },
  {
    "codigo": "82119210",
    "descricao": "Para cozinha e açougue"
  },
  {
    "codigo": "82119220",
    "descricao": "Para caça"
  },
  {
    "codigo": "82119290",
    "descricao": "Outras"
  },
  {
    "codigo": "82119310",
    "descricao": "Podadeiras e suas partes"
  },
  {
    "codigo": "82119320",
    "descricao": "Canivetes com uma ou várias lâminas ou outras peças"
  },
  {
    "codigo": "82119390",
    "descricao": "Outras"
  },
  {
    "codigo": "82119400",
    "descricao": "-- Lâminas"
  },
  {
    "codigo": "82119500",
    "descricao": "-- Cabos de metais comuns"
  },
  {
    "codigo": "82121010",
    "descricao": "Navalhas"
  },
  {
    "codigo": "82121020",
    "descricao": "Aparelhos"
  },
  {
    "codigo": "82122010",
    "descricao": "Lâminas"
  },
  {
    "codigo": "82122020",
    "descricao": "Esboços em tiras"
  },
  {
    "codigo": "82129000",
    "descricao": "- Outras partes"
  },
  {
    "codigo": "82130000",
    "descricao": "Tesouras e suas lâminas."
  },
  {
    "codigo": "82141000",
    "descricao": "- Espátulas (corta-papéis), abre-cartas, raspadeiras, apontadores de lápis (apara-lápis) e suas lâminas"
  },
  {
    "codigo": "82142000",
    "descricao": "- Utensílios e sortidos de utensílios de manicuros ou de pedicuros (incluindo as limas para unhas)"
  },
  {
    "codigo": "82149010",
    "descricao": "Máquinas de tosquiar e suas partes"
  },
  {
    "codigo": "82149090",
    "descricao": "Outros"
  },
  {
    "codigo": "82151000",
    "descricao": "- Sortidos que contenham pelo menos um objeto prateado, dourado ou platinado"
  },
  {
    "codigo": "82152000",
    "descricao": "- Outros sortidos"
  },
  {
    "codigo": "82159100",
    "descricao": "-- Prateados, dourados ou platinados"
  },
  {
    "codigo": "82159910",
    "descricao": "De aço inoxidável"
  },
  {
    "codigo": "82159990",
    "descricao": "Outros"
  },
  {
    "codigo": "83011000",
    "descricao": "- Cadeados"
  },
  {
    "codigo": "83012000",
    "descricao": "- Fechaduras do tipo utilizado em veículos automóveis"
  },
  {
    "codigo": "83013000",
    "descricao": "- Fechaduras do tipo utilizado em móveis"
  },
  {
    "codigo": "83014000",
    "descricao": "- Outras fechaduras; ferrolhos"
  },
  {
    "codigo": "83015000",
    "descricao": "- Fechos e armações com fecho, com fechadura"
  },
  {
    "codigo": "83016000",
    "descricao": "- Partes"
  },
  {
    "codigo": "83017000",
    "descricao": "- Chaves apresentadas isoladamente"
  },
  {
    "codigo": "83021000",
    "descricao": "- Dobradiças de qualquer espécie (incluindo os gonzos e as charneiras)"
  },
  {
    "codigo": "83022000",
    "descricao": "- Rodízios"
  },
  {
    "codigo": "83023000",
    "descricao": "- Outras guarnições, ferragens e artigos semelhantes, para veículos automóveis"
  },
  {
    "codigo": "83024100",
    "descricao": "-- Para construções"
  },
  {
    "codigo": "83024200",
    "descricao": "-- Outros, para móveis"
  },
  {
    "codigo": "83024900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "83025000",
    "descricao": "- Pateras, porta-chapéus, cabides e artigos semelhantes"
  },
  {
    "codigo": "83026000",
    "descricao": "- Fechos automáticos para portas"
  },
  {
    "codigo": "83030000",
    "descricao": "Cofres-fortes, portas blindadas e compartimentos para casas-fortes, cofres e caixas de segurança e artigos semelhantes, de metais comuns."
  },
  {
    "codigo": "83040000",
    "descricao": "Classificadores, fichários (ficheiros), caixas de classificação, porta-cópias, porta-canetas, porta-carimbos e artigos semelhantes, de escritório, de metais comuns, excluindo os móveis de escritório da posição 94.03."
  },
  {
    "codigo": "83051000",
    "descricao": "- Ferragens para encadernação de folhas soltas ou para classificadores"
  },
  {
    "codigo": "83052000",
    "descricao": "- Grampos (Agrafos*) apresentados em barretas"
  },
  {
    "codigo": "83059000",
    "descricao": "- Outros, incluindo as partes"
  },
  {
    "codigo": "83061000",
    "descricao": "- Sinos, campainhas, gongos e artigos semelhantes"
  },
  {
    "codigo": "83062100",
    "descricao": "-- Prateados, dourados ou platinados"
  },
  {
    "codigo": "83062900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "83063000",
    "descricao": "- Molduras para fotografias, gravuras ou semelhantes; espelhos"
  },
  {
    "codigo": "83071010",
    "descricao": "Do tipo utilizado na exploração submarina de petróleo ou gás, constituídos por camadas flexíveis de aço e camadas de plástico, de diâmetro interior superior a 254 mm"
  },
  {
    "codigo": "83071090",
    "descricao": "Outros"
  },
  {
    "codigo": "83079000",
    "descricao": "- De outros metais comuns"
  },
  {
    "codigo": "83081000",
    "descricao": "- Grampos, colchetes e ilhoses"
  },
  {
    "codigo": "83082000",
    "descricao": "- Rebites tubulares ou de haste fendida"
  },
  {
    "codigo": "83089010",
    "descricao": "Fivelas"
  },
  {
    "codigo": "83089020",
    "descricao": "Contas e lantejoulas"
  },
  {
    "codigo": "83089090",
    "descricao": "Outros"
  },
  {
    "codigo": "83091000",
    "descricao": "- Cápsulas de coroa"
  },
  {
    "codigo": "83099000",
    "descricao": "- Outros"
  },
  {
    "codigo": "83100000",
    "descricao": "Placas indicadoras, placas sinalizadoras, placas-endereços e placas semelhantes, números, letras e sinais diversos, de metais comuns, exceto os da posição 94.05."
  },
  {
    "codigo": "83111000",
    "descricao": "- Eletrodos revestidos exteriormente para soldar a arco, de metais comuns"
  },
  {
    "codigo": "83112000",
    "descricao": "- Fios revestidos interiormente para soldar a arco, de metais comuns"
  },
  {
    "codigo": "83113000",
    "descricao": "- Varetas revestidas exteriormente e fios revestidos interiormente, para soldar à chama, de metais comuns"
  },
  {
    "codigo": "83119000",
    "descricao": "- Outros"
  },
  {
    "codigo": "84011000",
    "descricao": "- Reatores nucleares"
  },
  {
    "codigo": "84012000",
    "descricao": "- Máquinas e aparelhos para a separação de isótopos, e suas partes"
  },
  {
    "codigo": "84013000",
    "descricao": "- Elementos combustíveis (cartuchos) não irradiados"
  },
  {
    "codigo": "84014000",
    "descricao": "- Partes de reatores nucleares"
  },
  {
    "codigo": "84021100",
    "descricao": "-- Caldeiras aquatubulares com produção de vapor superior a 45 t por hora"
  },
  {
    "codigo": "84021200",
    "descricao": "-- Caldeiras aquatubulares com produção de vapor não superior a 45 t por hora"
  },
  {
    "codigo": "84021900",
    "descricao": "-- Outras caldeiras para produção de vapor, incluindo as caldeiras mistas"
  },
  {
    "codigo": "84022000",
    "descricao": "- Caldeiras denominadas \"de água superaquecida\""
  },
  {
    "codigo": "84029000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84031010",
    "descricao": "Com capacidade inferior ou igual a 200.000 kcal/hora"
  },
  {
    "codigo": "84031090",
    "descricao": "Outras"
  },
  {
    "codigo": "84039000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84041010",
    "descricao": "Da posição 84.02"
  },
  {
    "codigo": "84041020",
    "descricao": "Da posição 84.03"
  },
  {
    "codigo": "84042000",
    "descricao": "- Condensadores para máquinas a vapor"
  },
  {
    "codigo": "84049010",
    "descricao": "De aparelhos auxiliares para caldeiras da posição 84.02"
  },
  {
    "codigo": "84049090",
    "descricao": "Outras"
  },
  {
    "codigo": "84051000",
    "descricao": "- Geradores de gás de ar (gás pobre) ou de gás de água, mesmo com depuradores; geradores de acetileno e geradores semelhantes de gás, operados a água, mesmo com depuradores"
  },
  {
    "codigo": "84059000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84061000",
    "descricao": "- Turbinas para propulsão de embarcações"
  },
  {
    "codigo": "84068100",
    "descricao": "-- De potência superior a 40 MW"
  },
  {
    "codigo": "84068200",
    "descricao": "-- De potência não superior a 40 MW"
  },
  {
    "codigo": "84069011",
    "descricao": "De turbinas a reação, de múltiplos estágios"
  },
  {
    "codigo": "84069019",
    "descricao": "Outras"
  },
  {
    "codigo": "84069021",
    "descricao": "Fixas (de estator)"
  },
  {
    "codigo": "84069029",
    "descricao": "Outras"
  },
  {
    "codigo": "84069090",
    "descricao": "Outras"
  },
  {
    "codigo": "84071000",
    "descricao": "- Motores para aviação"
  },
  {
    "codigo": "84072110",
    "descricao": "Monocilíndricos"
  },
  {
    "codigo": "84072190",
    "descricao": "Outros"
  },
  {
    "codigo": "84072910",
    "descricao": "Monocilíndricos"
  },
  {
    "codigo": "84072990",
    "descricao": "Outros"
  },
  {
    "codigo": "84073110",
    "descricao": "Monocilíndricos"
  },
  {
    "codigo": "84073190",
    "descricao": "Outros"
  },
  {
    "codigo": "84073200",
    "descricao": "-- De cilindrada superior a 50 cm<sup>3</sup>, mas não superior a 250 cm<sup>3</sup>"
  },
  {
    "codigo": "84073310",
    "descricao": "Monocilíndricos"
  },
  {
    "codigo": "84073390",
    "descricao": "Outros"
  },
  {
    "codigo": "84073410",
    "descricao": "Monocilíndricos"
  },
  {
    "codigo": "84073490",
    "descricao": "Outros"
  },
  {
    "codigo": "84079000",
    "descricao": "- Outros motores"
  },
  {
    "codigo": "84081010",
    "descricao": "Do tipo fora de borda"
  },
  {
    "codigo": "84081090",
    "descricao": "Outros"
  },
  {
    "codigo": "84082010",
    "descricao": "De cilindrada inferior ou igual a 1.500 cm<sup>3</sup>"
  },
  {
    "codigo": "84082020",
    "descricao": "De cilindrada superior a 1.500 cm<sup>3</sup>, mas não superior a 2.500 cm<sup>3</sup>"
  },
  {
    "codigo": "84082030",
    "descricao": "De cilindrada superior a 2.500 cm<sup>3</sup>, mas não superior a 3.500 cm<sup>3</sup>"
  },
  {
    "codigo": "84082090",
    "descricao": "Outros"
  },
  {
    "codigo": "84089010",
    "descricao": "Estacionários, de potência normal ISO superior a 497,5 kW (663 HP), segundo Norma ISO 3046/1"
  },
  {
    "codigo": "84089090",
    "descricao": "Outros"
  },
  {
    "codigo": "84091000",
    "descricao": "- De motores para aviação"
  },
  {
    "codigo": "84099111",
    "descricao": "Bielas"
  },
  {
    "codigo": "84099112",
    "descricao": "Blocos de cilindros, cabeçotes e cárteres"
  },
  {
    "codigo": "84099113",
    "descricao": "Carburadores, com bomba e dispositivo de compensação de nível de combustível incorporados, ambos a membrana, de diâmetro de venturi inferior ou igual a 22,8 mm e peso inferior ou igual a 280 g"
  },
  {
    "codigo": "84099114",
    "descricao": "Válvulas de admissão ou de escape"
  },
  {
    "codigo": "84099115",
    "descricao": "Coletores de admissão ou de escape"
  },
  {
    "codigo": "84099116",
    "descricao": "Anéis de segmento"
  },
  {
    "codigo": "84099117",
    "descricao": "Guias de válvulas"
  },
  {
    "codigo": "84099118",
    "descricao": "Outros carburadores"
  },
  {
    "codigo": "84099120",
    "descricao": "Pistões ou êmbolos"
  },
  {
    "codigo": "84099130",
    "descricao": "Camisas de cilindro"
  },
  {
    "codigo": "84099140",
    "descricao": "Sistema de injeção eletrônica"
  },
  {
    "codigo": "84099190",
    "descricao": "Outras"
  },
  {
    "codigo": "84099912",
    "descricao": "Blocos de cilindros e cárteres"
  },
  {
    "codigo": "84099914",
    "descricao": "Válvulas de admissão ou de escape"
  },
  {
    "codigo": "84099915",
    "descricao": "Coletores de admissão ou de escape"
  },
  {
    "codigo": "84099917",
    "descricao": "Guias de válvulas"
  },
  {
    "codigo": "84099921",
    "descricao": "De diâmetro igual ou superior a 200 mm"
  },
  {
    "codigo": "84099929",
    "descricao": "Outros"
  },
  {
    "codigo": "84099930",
    "descricao": "Camisas de cilindro"
  },
  {
    "codigo": "84099941",
    "descricao": "De peso igual ou superior a 30 kg"
  },
  {
    "codigo": "84099949",
    "descricao": "Outras"
  },
  {
    "codigo": "84099951",
    "descricao": "De diâmetro igual ou superior a 200 mm"
  },
  {
    "codigo": "84099959",
    "descricao": "Outros"
  },
  {
    "codigo": "84099961",
    "descricao": "De diâmetro igual ou superior a 20 mm"
  },
  {
    "codigo": "84099969",
    "descricao": "Outros"
  },
  {
    "codigo": "84099971",
    "descricao": "De diâmetro igual ou superior a 200 mm"
  },
  {
    "codigo": "84099979",
    "descricao": "Outros"
  },
  {
    "codigo": "84099991",
    "descricao": "Camisas de cilindro soldadas a cabeçotes, de diâmetro igual ou superior a 200 mm"
  },
  {
    "codigo": "84099999",
    "descricao": "Outras"
  },
  {
    "codigo": "84101100",
    "descricao": "-- De potência não superior a 1.000 kW"
  },
  {
    "codigo": "84101200",
    "descricao": "-- De potência superior a 1.000 kW, mas não superior a 10.000 kW"
  },
  {
    "codigo": "84101300",
    "descricao": "-- De potência superior a 10.000 kW"
  },
  {
    "codigo": "84109000",
    "descricao": "- Partes, incluindo os reguladores"
  },
  {
    "codigo": "84111100",
    "descricao": "-- De empuxo (impulso*) não superior a 25 kN"
  },
  {
    "codigo": "84111200",
    "descricao": "-- De empuxo (impulso*) superior a 25 kN"
  },
  {
    "codigo": "84112100",
    "descricao": "-- De potência não superior a 1.100 kW"
  },
  {
    "codigo": "84112200",
    "descricao": "-- De potência superior a 1.100 kW"
  },
  {
    "codigo": "84118100",
    "descricao": "-- De potência não superior a 5.000 kW"
  },
  {
    "codigo": "84118200",
    "descricao": "-- De potência superior a 5.000 kW"
  },
  {
    "codigo": "84119100",
    "descricao": "-- De turborreatores ou de turbopropulsores"
  },
  {
    "codigo": "84119900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84121000",
    "descricao": "- Propulsores a reação, excluindo os turborreatores"
  },
  {
    "codigo": "84122110",
    "descricao": "Cilindros hidráulicos"
  },
  {
    "codigo": "84122190",
    "descricao": "Outros"
  },
  {
    "codigo": "84122900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84123110",
    "descricao": "Cilindros pneumáticos"
  },
  {
    "codigo": "84123190",
    "descricao": "Outros"
  },
  {
    "codigo": "84123900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84128000",
    "descricao": "- Outros"
  },
  {
    "codigo": "84129010",
    "descricao": "De propulsores a reação"
  },
  {
    "codigo": "84129080",
    "descricao": "De máquinas das subposições 8412.21 ou 8412.31"
  },
  {
    "codigo": "84129090",
    "descricao": "Outras"
  },
  {
    "codigo": "84131100",
    "descricao": "-- Bombas para distribuição de combustíveis ou lubrificantes, do tipo utilizado em postos (estações) de serviço ou garagens"
  },
  {
    "codigo": "84131900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84132000",
    "descricao": "- Bombas manuais, exceto das subposições 8413.11 ou 8413.19"
  },
  {
    "codigo": "84133010",
    "descricao": "Para gasolina ou álcool"
  },
  {
    "codigo": "84133020",
    "descricao": "Injetoras de combustível para motor de ignição por compressão"
  },
  {
    "codigo": "84133030",
    "descricao": "Para óleo lubrificante"
  },
  {
    "codigo": "84133090",
    "descricao": "Outras"
  },
  {
    "codigo": "84134000",
    "descricao": "- Bombas para concreto (betão)"
  },
  {
    "codigo": "84135010",
    "descricao": "De potência superior a 3,73 kW (5 HP), mas não superior a 447,42 kW (600 HP), excluídas as para oxigênio líquido"
  },
  {
    "codigo": "84135090",
    "descricao": "Outras"
  },
  {
    "codigo": "84136011",
    "descricao": "De engrenagem"
  },
  {
    "codigo": "84136019",
    "descricao": "Outras"
  },
  {
    "codigo": "84136090",
    "descricao": "Outras"
  },
  {
    "codigo": "84137010",
    "descricao": "Eletrobombas submersíveis"
  },
  {
    "codigo": "84137080",
    "descricao": "Outras, de vazão inferior ou igual a 300 l/min"
  },
  {
    "codigo": "84137090",
    "descricao": "Outras"
  },
  {
    "codigo": "84138100",
    "descricao": "-- Bombas"
  },
  {
    "codigo": "84138200",
    "descricao": "-- Elevadores de líquidos"
  },
  {
    "codigo": "84139110",
    "descricao": "Hastes de bombeamento, do tipo utilizado para extração de petróleo"
  },
  {
    "codigo": "84139190",
    "descricao": "Outras"
  },
  {
    "codigo": "84139200",
    "descricao": "-- De elevadores de líquidos"
  },
  {
    "codigo": "84141000",
    "descricao": "- Bombas de vácuo"
  },
  {
    "codigo": "84142000",
    "descricao": "- Bombas de ar, de mão ou de pé"
  },
  {
    "codigo": "84143011",
    "descricao": "Com capacidade inferior a 4.700 frigorias/hora"
  },
  {
    "codigo": "84143019",
    "descricao": "Outros"
  },
  {
    "codigo": "84143091",
    "descricao": "Com capacidade inferior ou igual a 16.000 frigorias/hora"
  },
  {
    "codigo": "84143099",
    "descricao": "Outros"
  },
  {
    "codigo": "84144010",
    "descricao": "De deslocamento alternativo"
  },
  {
    "codigo": "84144020",
    "descricao": "De parafuso"
  },
  {
    "codigo": "84144090",
    "descricao": "Outros"
  },
  {
    "codigo": "84145110",
    "descricao": "De mesa"
  },
  {
    "codigo": "84145120",
    "descricao": "De teto"
  },
  {
    "codigo": "84145190",
    "descricao": "Outros"
  },
  {
    "codigo": "84145910",
    "descricao": "Microventiladores com área de carcaça inferior a 90 cm<sup>2</sup>"
  },
  {
    "codigo": "84145990",
    "descricao": "Outros"
  },
  {
    "codigo": "84146000",
    "descricao": "- Coifas aspirantes (exaustores) com dimensão horizontal máxima não superior a 120 cm"
  },
  {
    "codigo": "84147000",
    "descricao": "- Cabinas (câmaras) de segurança biológica estanques aos gases"
  },
  {
    "codigo": "84148011",
    "descricao": "Estacionários, de pistão"
  },
  {
    "codigo": "84148012",
    "descricao": "De parafuso"
  },
  {
    "codigo": "84148013",
    "descricao": "De lóbulos paralelos (tipo <i>Roots</i>)"
  },
  {
    "codigo": "84148019",
    "descricao": "Outros"
  },
  {
    "codigo": "84148021",
    "descricao": "Turboalimentadores de ar, de peso inferior ou igual a 50 kg para motores das posições 84.07 ou 84.08, acionado pelos gases de escapamento dos mesmos"
  },
  {
    "codigo": "84148022",
    "descricao": "Turboalimentadores de ar, de peso superior a 50 kg para motores das posições 84.07 ou 84.08, acionados pelos gases de escapamento dos mesmos"
  },
  {
    "codigo": "84148029",
    "descricao": "Outros"
  },
  {
    "codigo": "84148031",
    "descricao": "De pistão"
  },
  {
    "codigo": "84148032",
    "descricao": "De parafuso"
  },
  {
    "codigo": "84148033",
    "descricao": "Centrífugos, de vazão máxima inferior a 22.000 m<sup>3</sup>/h"
  },
  {
    "codigo": "84148038",
    "descricao": "Outros compressores centrífugos"
  },
  {
    "codigo": "84148039",
    "descricao": "Outros"
  },
  {
    "codigo": "84148090",
    "descricao": "Outros"
  },
  {
    "codigo": "84149010",
    "descricao": "De bombas"
  },
  {
    "codigo": "84149020",
    "descricao": "De ventiladores ou coifas aspirantes"
  },
  {
    "codigo": "84149031",
    "descricao": "Pistões ou êmbolos"
  },
  {
    "codigo": "84149032",
    "descricao": "Anéis de segmento"
  },
  {
    "codigo": "84149033",
    "descricao": "Blocos de cilindros, cabeçotes e cárteres"
  },
  {
    "codigo": "84149034",
    "descricao": "Válvulas"
  },
  {
    "codigo": "84149039",
    "descricao": "Outras"
  },
  {
    "codigo": "84149040",
    "descricao": "De cabinas (câmaras) de segurança"
  },
  {
    "codigo": "84151011",
    "descricao": "Do tipo <i>split-system</i> (sistema com elementos separados)"
  },
  {
    "codigo": "84151019",
    "descricao": "Outros"
  },
  {
    "codigo": "84151090",
    "descricao": "Outros"
  },
  {
    "codigo": "84152010",
    "descricao": "Com capacidade inferior ou igual a 30.000 frigorias/hora"
  },
  {
    "codigo": "84152090",
    "descricao": "Outros"
  },
  {
    "codigo": "84158110",
    "descricao": "Com capacidade inferior ou igual a 30.000 frigorias/hora"
  },
  {
    "codigo": "84158190",
    "descricao": "Outros"
  },
  {
    "codigo": "84158210",
    "descricao": "Com capacidade inferior ou igual a 30.000 frigorias/hora"
  },
  {
    "codigo": "84158290",
    "descricao": "Outros"
  },
  {
    "codigo": "84158300",
    "descricao": "-- Sem dispositivo de refrigeração"
  },
  {
    "codigo": "84159010",
    "descricao": "Unidades evaporadoras (internas) de aparelho de ar-condicionado do tipo <i>split-system</i> (sistema com elementos separados), com capacidade inferior ou igual a 30.000 frigorias/hora"
  },
  {
    "codigo": "84159020",
    "descricao": "Unidades condensadoras (externas) de aparelho de ar-condicionado do tipo <i>split-system</i> (sistema com elementos separados), com capacidade inferior ou igual a 30.000 frigorias/hora"
  },
  {
    "codigo": "84159090",
    "descricao": "Outras"
  },
  {
    "codigo": "84161000",
    "descricao": "- Queimadores de combustíveis líquidos"
  },
  {
    "codigo": "84162010",
    "descricao": "De gases"
  },
  {
    "codigo": "84162090",
    "descricao": "Outros"
  },
  {
    "codigo": "84163000",
    "descricao": "- Fornalhas automáticas, incluindo as antefornalhas, grelhas mecânicas, descarregadores mecânicos de cinzas e dispositivos semelhantes"
  },
  {
    "codigo": "84169000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84171010",
    "descricao": "Fornos industriais para fusão de metais"
  },
  {
    "codigo": "84171020",
    "descricao": "Fornos industriais para tratamento térmico de metais"
  },
  {
    "codigo": "84171090",
    "descricao": "Outros"
  },
  {
    "codigo": "84172000",
    "descricao": "- Fornos de padaria, pastelaria ou para a indústria de bolachas e biscoitos"
  },
  {
    "codigo": "84178010",
    "descricao": "Fornos industriais para cerâmica"
  },
  {
    "codigo": "84178020",
    "descricao": "Fornos industriais para fusão de vidro"
  },
  {
    "codigo": "84178090",
    "descricao": "Outros"
  },
  {
    "codigo": "84179000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84181000",
    "descricao": "- Combinações de refrigeradores e congeladores (<i>freezers</i>), munidos de portas ou gavetas exteriores separadas, ou de uma combinação desses elementos"
  },
  {
    "codigo": "84182100",
    "descricao": "-- De compressão"
  },
  {
    "codigo": "84182900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84183000",
    "descricao": "- Congeladores (<i>freezers</i>) horizontais (arcas), de capacidade não superior a 800 l"
  },
  {
    "codigo": "84184000",
    "descricao": "- Congeladores (<i>freezers</i>) verticais, de capacidade não superior a 900 l"
  },
  {
    "codigo": "84185010",
    "descricao": "Congeladores (<i>freezers</i>)"
  },
  {
    "codigo": "84185090",
    "descricao": "Outros"
  },
  {
    "codigo": "84186100",
    "descricao": "-- Bombas de calor, exceto as máquinas e aparelhos de ar-condicionado da posição 84.15"
  },
  {
    "codigo": "84186910",
    "descricao": "Máquinas não domésticas para preparação de sorvetes"
  },
  {
    "codigo": "84186920",
    "descricao": "Resfriadores de leite"
  },
  {
    "codigo": "84186931",
    "descricao": "De água ou sucos"
  },
  {
    "codigo": "84186932",
    "descricao": "De bebidas carbonatadas"
  },
  {
    "codigo": "84186940",
    "descricao": "Grupos frigoríficos de compressão com capacidade inferior ou igual a 30.000 frigorias/hora"
  },
  {
    "codigo": "84186991",
    "descricao": "Resfriadores de água, de absorção por brometo de lítio"
  },
  {
    "codigo": "84186999",
    "descricao": "Outros"
  },
  {
    "codigo": "84189100",
    "descricao": "-- Móveis concebidos para receber um equipamento para a produção de frio"
  },
  {
    "codigo": "84189900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84191100",
    "descricao": "-- De aquecimento instantâneo, a gás"
  },
  {
    "codigo": "84191200",
    "descricao": "-- Aquecedores de água solares"
  },
  {
    "codigo": "84191900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84192000",
    "descricao": "- Esterilizadores médico-cirúrgicos ou de laboratório"
  },
  {
    "codigo": "84193300",
    "descricao": "-- Aparelhos de liofilização, aparelhos de criodessecação e secadores por pulverização"
  },
  {
    "codigo": "84193400",
    "descricao": "-- Outros, para produtos agrícolas"
  },
  {
    "codigo": "84193500",
    "descricao": "-- Outros, para madeiras, pastas de papel, papel ou cartão"
  },
  {
    "codigo": "84193900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84194010",
    "descricao": "De destilação de água"
  },
  {
    "codigo": "84194020",
    "descricao": "De destilação ou retificação de álcoois e outros fluidos voláteis ou de hidrocarbonetos"
  },
  {
    "codigo": "84194090",
    "descricao": "Outros"
  },
  {
    "codigo": "84195010",
    "descricao": "De placas"
  },
  {
    "codigo": "84195021",
    "descricao": "Metálicos"
  },
  {
    "codigo": "84195022",
    "descricao": "De grafita"
  },
  {
    "codigo": "84195029",
    "descricao": "Outros"
  },
  {
    "codigo": "84195090",
    "descricao": "Outros"
  },
  {
    "codigo": "84196000",
    "descricao": "- Aparelhos e dispositivos para liquefação do ar ou de outros gases"
  },
  {
    "codigo": "84198110",
    "descricao": "Autoclaves"
  },
  {
    "codigo": "84198190",
    "descricao": "Outros"
  },
  {
    "codigo": "84198911",
    "descricao": "De alimentos, mediante Ultra Alta Temperatura (UHT - <i>Ultra High Temperature</i>) por injeção direta de vapor, com capacidade igual ou superior a 6.500 l/h"
  },
  {
    "codigo": "84198919",
    "descricao": "Outros"
  },
  {
    "codigo": "84198920",
    "descricao": "Estufas"
  },
  {
    "codigo": "84198930",
    "descricao": "Torrefadores"
  },
  {
    "codigo": "84198940",
    "descricao": "Evaporadores"
  },
  {
    "codigo": "84198991",
    "descricao": "Recipiente refrigerador, com dispositivo de circulação de fluido refrigerante"
  },
  {
    "codigo": "84198999",
    "descricao": "Outros"
  },
  {
    "codigo": "84199010",
    "descricao": "De aquecedores de água das subposições 8419.11 ou 8419.19"
  },
  {
    "codigo": "84199020",
    "descricao": "De colunas de destilação ou de retificação"
  },
  {
    "codigo": "84199031",
    "descricao": "Placa corrugada, de aço inoxidável ou de alumínio, com superfície de troca térmica de área superior a 0,4 m<sup>2</sup>"
  },
  {
    "codigo": "84199039",
    "descricao": "Outras"
  },
  {
    "codigo": "84199040",
    "descricao": "De aparelhos ou dispositivos das subposições 8419.81 ou 8419.89"
  },
  {
    "codigo": "84199090",
    "descricao": "Outras"
  },
  {
    "codigo": "84201010",
    "descricao": "Para papel ou cartão"
  },
  {
    "codigo": "84201090",
    "descricao": "Outros"
  },
  {
    "codigo": "84209100",
    "descricao": "-- Cilindros"
  },
  {
    "codigo": "84209900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84211110",
    "descricao": "Com capacidade de processamento de leite igual ou superior a 30.000 l/h"
  },
  {
    "codigo": "84211190",
    "descricao": "Outras"
  },
  {
    "codigo": "84211210",
    "descricao": "Com tambor de capacidade inferior ou igual a 23 l"
  },
  {
    "codigo": "84211290",
    "descricao": "Outros"
  },
  {
    "codigo": "84211910",
    "descricao": "Centrifugadores para laboratórios de análises, ensaios ou pesquisas científicas"
  },
  {
    "codigo": "84211990",
    "descricao": "Outros"
  },
  {
    "codigo": "84212100",
    "descricao": "-- Para filtrar ou depurar água"
  },
  {
    "codigo": "84212200",
    "descricao": "-- Para filtrar ou depurar bebidas, exceto água"
  },
  {
    "codigo": "84212300",
    "descricao": "-- Para filtrar carburantes ou óleos lubrificantes nos motores de ignição por centelha (faísca) ou por compressão"
  },
  {
    "codigo": "84212911",
    "descricao": "Capilares"
  },
  {
    "codigo": "84212919",
    "descricao": "Outros"
  },
  {
    "codigo": "84212920",
    "descricao": "Aparelho de osmose inversa"
  },
  {
    "codigo": "84212930",
    "descricao": "Filtros-prensa"
  },
  {
    "codigo": "84212990",
    "descricao": "Outros"
  },
  {
    "codigo": "84213100",
    "descricao": "-- Filtros de entrada de ar para motores de ignição por centelha (faísca) ou por compressão"
  },
  {
    "codigo": "84213200",
    "descricao": "-- Conversores catalíticos e filtros de partículas, mesmo combinados, para depurar ou filtrar os gases de escape dos motores de ignição por centelha (faísca) ou por compressão"
  },
  {
    "codigo": "84213910",
    "descricao": "Filtros eletrostáticos"
  },
  {
    "codigo": "84213930",
    "descricao": "Concentradores de oxigênio por depuração do ar, com capacidade de saída inferior ou igual a 6 l/min"
  },
  {
    "codigo": "84213990",
    "descricao": "Outros"
  },
  {
    "codigo": "84219110",
    "descricao": "De secadores de roupa do item 8421.12.10"
  },
  {
    "codigo": "84219191",
    "descricao": "Tambores rotativos com pratos ou discos separadores, de peso superior a 300 kg"
  },
  {
    "codigo": "84219199",
    "descricao": "Outras"
  },
  {
    "codigo": "84219910",
    "descricao": "De aparelhos para filtrar ou depurar gases, da subposição 8421.39"
  },
  {
    "codigo": "84219920",
    "descricao": "Do tipo utilizado em linhas de sangue para hemodiálise"
  },
  {
    "codigo": "84219991",
    "descricao": "Cartuchos de membrana de aparelhos de osmose inversa"
  },
  {
    "codigo": "84219999",
    "descricao": "Outras"
  },
  {
    "codigo": "84221100",
    "descricao": "-- Do tipo doméstico"
  },
  {
    "codigo": "84221900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84222000",
    "descricao": "- Máquinas e aparelhos para limpar ou secar garrafas ou outros recipientes"
  },
  {
    "codigo": "84223010",
    "descricao": "Máquinas e aparelhos para encher, fechar, arrolhar, capsular ou rotular garrafas"
  },
  {
    "codigo": "84223021",
    "descricao": "Para encher caixas ou sacos com pó ou grãos"
  },
  {
    "codigo": "84223022",
    "descricao": "Para encher e fechar embalagens confeccionadas com papel ou cartão dos subitens 4811.51.22 ou 4811.59.23, mesmo com dispositivo de rotulagem"
  },
  {
    "codigo": "84223023",
    "descricao": "Para encher e fechar recipientes tubulares flexíveis (bisnagas), com capacidade igual ou superior a 100 unidades por minuto"
  },
  {
    "codigo": "84223029",
    "descricao": "Outros"
  },
  {
    "codigo": "84223030",
    "descricao": "Para gaseificar bebidas"
  },
  {
    "codigo": "84224010",
    "descricao": "Horizontais, próprias para empacotamento de massas alimentícias longas (comprimento superior a 200 mm) em pacotes tipo almofadas (<i>pillow pack</i>), com capacidade de produção superior a 100 pacotes por minuto e controlador lógico programável (CLP)"
  },
  {
    "codigo": "84224020",
    "descricao": "Automática, para embalar tubos ou barras de metal, em atados de peso inferior ou igual a 2.000 kg e comprimento inferior ou igual a 12 m"
  },
  {
    "codigo": "84224030",
    "descricao": "De empacotar embalagens confeccionadas com papel ou cartão dos subitens 4811.51.22 ou 4811.59.23 em caixas ou bandejas de papel ou cartão dobráveis, com capacidade igual ou superior a 5.000 embalagens por hora"
  },
  {
    "codigo": "84224090",
    "descricao": "Outros"
  },
  {
    "codigo": "84229010",
    "descricao": "De máquinas de lavar louça, de uso doméstico"
  },
  {
    "codigo": "84229090",
    "descricao": "Outras"
  },
  {
    "codigo": "84231000",
    "descricao": "- Balanças para pessoas, incluindo as balanças para bebês; balanças de uso doméstico"
  },
  {
    "codigo": "84232000",
    "descricao": "- Básculas de pesagem contínua em transportadores"
  },
  {
    "codigo": "84233011",
    "descricao": "Com aparelhos periféricos, que constituam unidade funcional"
  },
  {
    "codigo": "84233019",
    "descricao": "Outras"
  },
  {
    "codigo": "84233090",
    "descricao": "Outras"
  },
  {
    "codigo": "84238110",
    "descricao": "De mesa, com dispositivo registrador ou impressor de etiquetas"
  },
  {
    "codigo": "84238190",
    "descricao": "Outros"
  },
  {
    "codigo": "84238200",
    "descricao": "-- De capacidade superior a 30 kg, mas não superior a 5.000 kg"
  },
  {
    "codigo": "84238900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84239010",
    "descricao": "Pesos"
  },
  {
    "codigo": "84239021",
    "descricao": "De aparelhos ou instrumentos da subposição 8423.10"
  },
  {
    "codigo": "84239029",
    "descricao": "Outras"
  },
  {
    "codigo": "84241000",
    "descricao": "- Extintores, mesmo carregados"
  },
  {
    "codigo": "84242000",
    "descricao": "- Pistolas aerográficas e aparelhos semelhantes"
  },
  {
    "codigo": "84243010",
    "descricao": "Máquinas e aparelhos de desobstrução de tubulação ou de limpeza, por jato de água"
  },
  {
    "codigo": "84243020",
    "descricao": "De jato de areia própria para desgaste localizado de peças de vestuário"
  },
  {
    "codigo": "84243030",
    "descricao": "Perfuradoras por jato de água com pressão de trabalho máxima igual ou superior a 10 MPa"
  },
  {
    "codigo": "84243090",
    "descricao": "Outros"
  },
  {
    "codigo": "84244100",
    "descricao": "-- Pulverizadores portáteis"
  },
  {
    "codigo": "84244900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84248221",
    "descricao": "Por aspersão"
  },
  {
    "codigo": "84248229",
    "descricao": "Outros"
  },
  {
    "codigo": "84248290",
    "descricao": "Outros"
  },
  {
    "codigo": "84248910",
    "descricao": "Aparelhos de pulverização constituídos por botão de pressão com bocal (tampa <i>spray</i>), válvula do tipo aerossol, junta de estanqueidade (junta de canopla) e tubo de imersão, montados sobre um corpo metálico (canopla), do tipo utilizado para serem montados no gargalo de recipientes, para projetar líquidos, pós ou espumas"
  },
  {
    "codigo": "84248920",
    "descricao": "Aparelhos automáticos para projetar lubrificantes sobre pneumáticos, que contenham uma estação de secagem por ar preaquecido e dispositivos para agarrar e movimentar pneumáticos"
  },
  {
    "codigo": "84248990",
    "descricao": "Outros"
  },
  {
    "codigo": "84249010",
    "descricao": "De aparelhos da subposição 8424.10 ou do item 8424.89.10"
  },
  {
    "codigo": "84249090",
    "descricao": "Outras"
  },
  {
    "codigo": "84251100",
    "descricao": "-- De motor elétrico"
  },
  {
    "codigo": "84251910",
    "descricao": "Talhas, cadernais e moitões, manuais"
  },
  {
    "codigo": "84251990",
    "descricao": "Outros"
  },
  {
    "codigo": "84253110",
    "descricao": "Com capacidade inferior ou igual a 100 t"
  },
  {
    "codigo": "84253190",
    "descricao": "Outros"
  },
  {
    "codigo": "84253910",
    "descricao": "Com capacidade inferior ou igual a 100 t"
  },
  {
    "codigo": "84253990",
    "descricao": "Outros"
  },
  {
    "codigo": "84254100",
    "descricao": "-- Elevadores fixos de veículos, para garagens (oficinas)"
  },
  {
    "codigo": "84254200",
    "descricao": "-- Outros macacos, hidráulicos"
  },
  {
    "codigo": "84254910",
    "descricao": "Manuais"
  },
  {
    "codigo": "84254990",
    "descricao": "Outros"
  },
  {
    "codigo": "84261100",
    "descricao": "-- Pontes e vigas, rolantes, de suportes fixos"
  },
  {
    "codigo": "84261200",
    "descricao": "-- Pórticos móveis de pneumáticos e carros-pórticos"
  },
  {
    "codigo": "84261900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84262000",
    "descricao": "- Guindastes de torre"
  },
  {
    "codigo": "84263000",
    "descricao": "- Guindastes de pórtico"
  },
  {
    "codigo": "84264110",
    "descricao": "Com deslocamento em sentido longitudinal, transversal e diagonal (tipo caranguejo) com capacidade de carga igual ou superior a 60 t"
  },
  {
    "codigo": "84264190",
    "descricao": "Outros"
  },
  {
    "codigo": "84264910",
    "descricao": "De lagartas (esteiras), com capacidade de elevação igual ou superior a 70 t"
  },
  {
    "codigo": "84264990",
    "descricao": "Outros"
  },
  {
    "codigo": "84269100",
    "descricao": "-- Próprios para serem montados em veículos rodoviários"
  },
  {
    "codigo": "84269900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84271011",
    "descricao": "De capacidade de carga superior a 6,5 t"
  },
  {
    "codigo": "84271019",
    "descricao": "Outras"
  },
  {
    "codigo": "84271090",
    "descricao": "Outros"
  },
  {
    "codigo": "84272010",
    "descricao": "Empilhadeiras com capacidade de carga superior a 6,5 t"
  },
  {
    "codigo": "84272090",
    "descricao": "Outros"
  },
  {
    "codigo": "84279000",
    "descricao": "- Outros"
  },
  {
    "codigo": "84281000",
    "descricao": "- Elevadores e monta-cargas"
  },
  {
    "codigo": "84282010",
    "descricao": "Transportadores tubulares (transvasadores) móveis, acionados com motor de potência superior a 90 kW (120 HP)"
  },
  {
    "codigo": "84282090",
    "descricao": "Outros"
  },
  {
    "codigo": "84283100",
    "descricao": "-- Especialmente concebidos para uso subterrâneo"
  },
  {
    "codigo": "84283200",
    "descricao": "-- Outros, de caçamba (balde*)"
  },
  {
    "codigo": "84283300",
    "descricao": "-- Outros, de correia"
  },
  {
    "codigo": "84283910",
    "descricao": "De correntes"
  },
  {
    "codigo": "84283920",
    "descricao": "De rolos motores"
  },
  {
    "codigo": "84283930",
    "descricao": "De pinças laterais, do tipo utilizado para o transporte de jornais"
  },
  {
    "codigo": "84283990",
    "descricao": "Outros"
  },
  {
    "codigo": "84284000",
    "descricao": "- Escadas e tapetes, rolantes"
  },
  {
    "codigo": "84286000",
    "descricao": "- Teleféricos (incluindo as telecadeiras e os telesquis); mecanismos de tração para funiculares"
  },
  {
    "codigo": "84287000",
    "descricao": "- Robôs industriais"
  },
  {
    "codigo": "84289010",
    "descricao": "Do tipo utilizado para desembarque de botes salva-vidas, motorizados ou providos de dispositivo de compensação de inclinação"
  },
  {
    "codigo": "84289020",
    "descricao": "Transportadores-elevadores (transelevadores) automáticos, de deslocamento horizontal sobre guias"
  },
  {
    "codigo": "84289030",
    "descricao": "Máquina para formação de pilhas de jornais, dispostos em sentido alternado, de capacidade igual ou superior a 80.000 exemplares/h"
  },
  {
    "codigo": "84289090",
    "descricao": "Outros"
  },
  {
    "codigo": "84291110",
    "descricao": "De potência no volante igual ou superior a 387,76 kW (520 HP)"
  },
  {
    "codigo": "84291190",
    "descricao": "Outros"
  },
  {
    "codigo": "84291910",
    "descricao": "<i>Bulldozers</i> de potência no volante igual ou superior a 234,90 kW (315 HP)"
  },
  {
    "codigo": "84291990",
    "descricao": "Outros"
  },
  {
    "codigo": "84292010",
    "descricao": "Motoniveladores articulados, de potência no volante igual ou superior a 205,07 kW (275 HP)"
  },
  {
    "codigo": "84292090",
    "descricao": "Outros"
  },
  {
    "codigo": "84293000",
    "descricao": "- Raspo-transportadores (<i>scrapers</i>)"
  },
  {
    "codigo": "84294000",
    "descricao": "- Compactadores e rolos ou cilindros compressores"
  },
  {
    "codigo": "84295111",
    "descricao": "Do tipo utilizado em minas subterrâneas"
  },
  {
    "codigo": "84295119",
    "descricao": "Outras"
  },
  {
    "codigo": "84295121",
    "descricao": "De potência no volante igual ou superior a 454,13 kW (609 HP)"
  },
  {
    "codigo": "84295129",
    "descricao": "Outras"
  },
  {
    "codigo": "84295191",
    "descricao": "De potência no volante igual ou superior a 297,5 kW (399 HP)"
  },
  {
    "codigo": "84295192",
    "descricao": "De potência no volante inferior ou igual a 43,99 kW (59 HP)"
  },
  {
    "codigo": "84295199",
    "descricao": "Outras"
  },
  {
    "codigo": "84295211",
    "descricao": "De potência no volante igual ou superior a 484,7 kW (650 HP)"
  },
  {
    "codigo": "84295212",
    "descricao": "De potência no volante inferior ou igual a 40,3 kW (54 HP)"
  },
  {
    "codigo": "84295219",
    "descricao": "Outras"
  },
  {
    "codigo": "84295220",
    "descricao": "Infraestruturas motoras, próprias para receber equipamentos das subposições 8430.49, 8430.61 ou 8430.69, mesmo com dispositivo de deslocamento sobre trilhos"
  },
  {
    "codigo": "84295290",
    "descricao": "Outras"
  },
  {
    "codigo": "84295900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84301000",
    "descricao": "- Bate-estacas e arranca-estacas"
  },
  {
    "codigo": "84302000",
    "descricao": "- Limpa-neves"
  },
  {
    "codigo": "84303110",
    "descricao": "Cortadores de carvão ou de rocha"
  },
  {
    "codigo": "84303190",
    "descricao": "Outros"
  },
  {
    "codigo": "84303910",
    "descricao": "Cortadores de carvão ou de rocha"
  },
  {
    "codigo": "84303990",
    "descricao": "Outras"
  },
  {
    "codigo": "84304110",
    "descricao": "Perfuratriz de percussão"
  },
  {
    "codigo": "84304120",
    "descricao": "Perfuratriz rotativa"
  },
  {
    "codigo": "84304130",
    "descricao": "Máquinas de sondagem, rotativas"
  },
  {
    "codigo": "84304190",
    "descricao": "Outras"
  },
  {
    "codigo": "84304910",
    "descricao": "Perfuratriz de percussão"
  },
  {
    "codigo": "84304920",
    "descricao": "Máquinas de sondagem, rotativas"
  },
  {
    "codigo": "84304990",
    "descricao": "Outras"
  },
  {
    "codigo": "84305000",
    "descricao": "- Outras máquinas e aparelhos, autopropulsados"
  },
  {
    "codigo": "84306100",
    "descricao": "-- Máquinas de comprimir ou de compactar"
  },
  {
    "codigo": "84306911",
    "descricao": "Com capacidade de carga superior a 4 m<sup>3</sup>"
  },
  {
    "codigo": "84306919",
    "descricao": "Outros"
  },
  {
    "codigo": "84306990",
    "descricao": "Outros"
  },
  {
    "codigo": "84311010",
    "descricao": "Do item 8425.19.10 ou das subposições 8425.39, 8425.42 ou 8425.49"
  },
  {
    "codigo": "84311090",
    "descricao": "Outras"
  },
  {
    "codigo": "84312011",
    "descricao": "Autopropulsadas"
  },
  {
    "codigo": "84312019",
    "descricao": "De outras empilhadeiras"
  },
  {
    "codigo": "84312090",
    "descricao": "Outras"
  },
  {
    "codigo": "84313110",
    "descricao": "De elevadores"
  },
  {
    "codigo": "84313190",
    "descricao": "Outras"
  },
  {
    "codigo": "84313900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84314100",
    "descricao": "-- Caçambas (Baldes*), mesmo de mandíbulas, pás, ganchos e tenazes"
  },
  {
    "codigo": "84314200",
    "descricao": "-- Lâminas para <i>bulldozers</i> ou <i>angledozers</i>"
  },
  {
    "codigo": "84314310",
    "descricao": "De máquinas de sondagem rotativas"
  },
  {
    "codigo": "84314390",
    "descricao": "Outras"
  },
  {
    "codigo": "84314910",
    "descricao": "De máquinas ou aparelhos da posição 84.26"
  },
  {
    "codigo": "84314921",
    "descricao": "Cabinas"
  },
  {
    "codigo": "84314922",
    "descricao": "Lagartas (esteiras)"
  },
  {
    "codigo": "84314923",
    "descricao": "Tanques de combustível e demais reservatórios"
  },
  {
    "codigo": "84314929",
    "descricao": "Outras"
  },
  {
    "codigo": "84321000",
    "descricao": "- Arados e charruas"
  },
  {
    "codigo": "84322100",
    "descricao": "-- Grades de discos"
  },
  {
    "codigo": "84322900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84323110",
    "descricao": "Semeadores-adubadores"
  },
  {
    "codigo": "84323190",
    "descricao": "Outros"
  },
  {
    "codigo": "84323910",
    "descricao": "Semeadores-adubadores"
  },
  {
    "codigo": "84323990",
    "descricao": "Outros"
  },
  {
    "codigo": "84324100",
    "descricao": "-- Espalhadores de estrume"
  },
  {
    "codigo": "84324200",
    "descricao": "-- Distribuidores de adubos (fertilizantes)"
  },
  {
    "codigo": "84328000",
    "descricao": "- Outras máquinas e aparelhos"
  },
  {
    "codigo": "84329000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84331100",
    "descricao": "-- Motorizados, cujo dispositivo de corte gira num plano horizontal"
  },
  {
    "codigo": "84331900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84332010",
    "descricao": "Com dispositivo de acondicionamento em fileiras constituído por rotor de dedos e pente"
  },
  {
    "codigo": "84332090",
    "descricao": "Outras"
  },
  {
    "codigo": "84333000",
    "descricao": "- Outras máquinas e aparelhos para colher e dispor o feno"
  },
  {
    "codigo": "84334000",
    "descricao": "- Enfardadeiras de palha ou de forragem, incluindo as enfardadeiras-apanhadeiras"
  },
  {
    "codigo": "84335100",
    "descricao": "-- Colheitadeiras combinadas com debulhadoras (ceifeiras-debulhadoras)"
  },
  {
    "codigo": "84335200",
    "descricao": "-- Outras máquinas e aparelhos para debulha"
  },
  {
    "codigo": "84335300",
    "descricao": "-- Máquinas para colheita de raízes ou tubérculos"
  },
  {
    "codigo": "84335911",
    "descricao": "Com capacidade para trabalhar até dois sulcos de colheita e potência no volante inferior ou igual a 59,7 kW (80 HP)"
  },
  {
    "codigo": "84335919",
    "descricao": "Outras"
  },
  {
    "codigo": "84335990",
    "descricao": "Outros"
  },
  {
    "codigo": "84336010",
    "descricao": "Selecionadores de fruta"
  },
  {
    "codigo": "84336021",
    "descricao": "Com capacidade superior a 250.000 ovos por hora"
  },
  {
    "codigo": "84336029",
    "descricao": "Outras"
  },
  {
    "codigo": "84336090",
    "descricao": "Outras"
  },
  {
    "codigo": "84339010",
    "descricao": "De cortadores de grama (relva)"
  },
  {
    "codigo": "84339090",
    "descricao": "Outras"
  },
  {
    "codigo": "84341000",
    "descricao": "- Máquinas de ordenhar"
  },
  {
    "codigo": "84342010",
    "descricao": "Para tratamento do leite"
  },
  {
    "codigo": "84342090",
    "descricao": "Outros"
  },
  {
    "codigo": "84349000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84351000",
    "descricao": "- Máquinas e aparelhos"
  },
  {
    "codigo": "84359000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84361000",
    "descricao": "- Máquinas e aparelhos para preparação de alimentos ou rações para animais"
  },
  {
    "codigo": "84362100",
    "descricao": "-- Chocadeiras e criadeiras"
  },
  {
    "codigo": "84362900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84368000",
    "descricao": "- Outras máquinas e aparelhos"
  },
  {
    "codigo": "84369100",
    "descricao": "-- De máquinas ou aparelhos para avicultura"
  },
  {
    "codigo": "84369900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84371000",
    "descricao": "- Máquinas para limpeza, seleção ou peneiração de grãos ou de produtos hortícolas secos"
  },
  {
    "codigo": "84378010",
    "descricao": "Para trituração ou moagem de grãos"
  },
  {
    "codigo": "84378090",
    "descricao": "Outros"
  },
  {
    "codigo": "84379000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84381000",
    "descricao": "- Máquinas e aparelhos para as indústrias de panificação, pastelaria, bolachas e biscoitos e de massas alimentícias"
  },
  {
    "codigo": "84382011",
    "descricao": "Para fabricar bombons de chocolate por moldagem, de capacidade de produção igual ou superior a 150 kg/h"
  },
  {
    "codigo": "84382019",
    "descricao": "Outros"
  },
  {
    "codigo": "84382090",
    "descricao": "Outros"
  },
  {
    "codigo": "84383000",
    "descricao": "- Máquinas e aparelhos para a indústria de açúcar"
  },
  {
    "codigo": "84384000",
    "descricao": "- Máquinas e aparelhos para a indústria cervejeira"
  },
  {
    "codigo": "84385000",
    "descricao": "- Máquinas e aparelhos para preparação de carnes"
  },
  {
    "codigo": "84386000",
    "descricao": "- Máquinas e aparelhos para preparação de fruta ou de produtos hortícolas"
  },
  {
    "codigo": "84388010",
    "descricao": "Máquinas para extração de óleo essencial de citros"
  },
  {
    "codigo": "84388020",
    "descricao": "Automática, para descabeçar, cortar a cauda e eviscerar peixes, com capacidade superior a 350 unidades por minuto"
  },
  {
    "codigo": "84388090",
    "descricao": "Outros"
  },
  {
    "codigo": "84389000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84391010",
    "descricao": "Para tratamento preliminar das matérias-primas"
  },
  {
    "codigo": "84391020",
    "descricao": "Classificadoras e classificadoras-depuradoras de pasta"
  },
  {
    "codigo": "84391030",
    "descricao": "Refinadoras"
  },
  {
    "codigo": "84391090",
    "descricao": "Outros"
  },
  {
    "codigo": "84392000",
    "descricao": "- Máquinas e aparelhos para fabricação de papel ou cartão"
  },
  {
    "codigo": "84393010",
    "descricao": "Bobinadoras-esticadoras"
  },
  {
    "codigo": "84393020",
    "descricao": "Para impregnar"
  },
  {
    "codigo": "84393030",
    "descricao": "Para ondular"
  },
  {
    "codigo": "84393090",
    "descricao": "Outros"
  },
  {
    "codigo": "84399100",
    "descricao": "-- De máquinas ou aparelhos para fabricação de pasta de matérias fibrosas celulósicas"
  },
  {
    "codigo": "84399910",
    "descricao": "Rolos, corrugadores ou de pressão, de máquinas para ondular, com largura útil igual ou superior a 2.500 mm"
  },
  {
    "codigo": "84399990",
    "descricao": "Outras"
  },
  {
    "codigo": "84401011",
    "descricao": "Com alimentação automática"
  },
  {
    "codigo": "84401019",
    "descricao": "Outros"
  },
  {
    "codigo": "84401020",
    "descricao": "Máquinas para fabricar capas de papelão, com dispositivo de colagem e capacidade de produção superior a 60 unidades por minuto"
  },
  {
    "codigo": "84401090",
    "descricao": "Outros"
  },
  {
    "codigo": "84409000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84411010",
    "descricao": "Cortadeiras bobinadoras com velocidade de bobinado superior a 2.000 m/min"
  },
  {
    "codigo": "84411090",
    "descricao": "Outras"
  },
  {
    "codigo": "84412000",
    "descricao": "- Máquinas para fabricação de sacos de quaisquer dimensões ou de envelopes"
  },
  {
    "codigo": "84413010",
    "descricao": "De dobrar e colar, para fabricação de caixas"
  },
  {
    "codigo": "84413090",
    "descricao": "Outras"
  },
  {
    "codigo": "84414000",
    "descricao": "- Máquinas de moldar artigos de pasta de papel, papel ou cartão"
  },
  {
    "codigo": "84418000",
    "descricao": "- Outras máquinas e aparelhos"
  },
  {
    "codigo": "84419000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84423010",
    "descricao": "De compor por processo fotográfico"
  },
  {
    "codigo": "84423020",
    "descricao": "De compor caracteres tipográficos por outros processos, mesmo com dispositivo de fundir"
  },
  {
    "codigo": "84423090",
    "descricao": "Outros"
  },
  {
    "codigo": "84424010",
    "descricao": "De máquinas do item 8442.30.10"
  },
  {
    "codigo": "84424020",
    "descricao": "De máquinas do item 8442.30.20"
  },
  {
    "codigo": "84424090",
    "descricao": "Outras"
  },
  {
    "codigo": "84425000",
    "descricao": "- Clichês, placas, cilindros e outros elementos de impressão; pedras litográficas, placas e cilindros, preparados para impressão (por exemplo, aplainados, granulados ou polidos)"
  },
  {
    "codigo": "84431110",
    "descricao": "Para impressão multicolor de jornais, de largura igual ou superior a 900 mm, com unidades de impressão em configuração torre e dispositivos automáticos de emendar bobinas"
  },
  {
    "codigo": "84431190",
    "descricao": "Outros"
  },
  {
    "codigo": "84431200",
    "descricao": "-- Máquinas e aparelhos de impressão, por ofsete, do tipo utilizado em escritórios, alimentados por folhas em que um lado não seja superior a 22 cm e que o outro não seja superior a 36 cm, quando não dobradas"
  },
  {
    "codigo": "84431310",
    "descricao": "Para impressão multicolor de recipientes de matérias plásticas, cilíndricos, cônicos ou de faces planas"
  },
  {
    "codigo": "84431321",
    "descricao": "Com velocidade de impressão igual ou superior a 12.000 folhas por hora"
  },
  {
    "codigo": "84431329",
    "descricao": "Outros"
  },
  {
    "codigo": "84431390",
    "descricao": "Outros"
  },
  {
    "codigo": "84431400",
    "descricao": "-- Máquinas e aparelhos de impressão, tipográficos, alimentados por bobinas, excluindo as máquinas e aparelhos flexográficos"
  },
  {
    "codigo": "84431500",
    "descricao": "-- Máquinas e aparelhos de impressão, tipográficos, não alimentados por bobinas, excluindo as máquinas e aparelhos flexográficos"
  },
  {
    "codigo": "84431600",
    "descricao": "-- Máquinas e aparelhos de impressão, flexográficos"
  },
  {
    "codigo": "84431710",
    "descricao": "Rotativas para heliogravura"
  },
  {
    "codigo": "84431790",
    "descricao": "Outros"
  },
  {
    "codigo": "84431910",
    "descricao": "Para serigrafia"
  },
  {
    "codigo": "84431990",
    "descricao": "Outros"
  },
  {
    "codigo": "84433111",
    "descricao": "De jato de tinta líquida, com largura de impressão inferior ou igual a 420 mm"
  },
  {
    "codigo": "84433112",
    "descricao": "De transferência térmica de cera sólida (por exemplo, <i>solid ink</i> e <i>dye sublimation</i>)"
  },
  {
    "codigo": "84433113",
    "descricao": "A laser, LED (Diodos Emissores de Luz) ou LCS (Sistema de Cristal Líquido), monocromáticas, com largura de impressão inferior ou igual a 280 mm"
  },
  {
    "codigo": "84433114",
    "descricao": "A laser, LED (Diodos Emissores de Luz) ou LCS (Sistema de Cristal Líquido), monocromáticas, com largura de impressão superior a 280 mm, mas não superior a 420 mm"
  },
  {
    "codigo": "84433115",
    "descricao": "A laser, LED (Diodos Emissores de Luz) ou LCS (Sistema de Cristal Líquido), policromáticas"
  },
  {
    "codigo": "84433116",
    "descricao": "Outras, com largura de impressão superior a 420 mm"
  },
  {
    "codigo": "84433119",
    "descricao": "Outras"
  },
  {
    "codigo": "84433191",
    "descricao": "Com impressão por sistema térmico"
  },
  {
    "codigo": "84433199",
    "descricao": "Outras"
  },
  {
    "codigo": "84433221",
    "descricao": "De linha"
  },
  {
    "codigo": "84433222",
    "descricao": "De caracteres Braille"
  },
  {
    "codigo": "84433223",
    "descricao": "Outras matriciais (por pontos)"
  },
  {
    "codigo": "84433229",
    "descricao": "Outras"
  },
  {
    "codigo": "84433231",
    "descricao": "De jato de tinta líquida, com largura de impressão inferior ou igual a 420 mm"
  },
  {
    "codigo": "84433232",
    "descricao": "De transferência térmica de cera sólida (por exemplo, <i>solid ink</i> e <i>dye sublimation</i>)"
  },
  {
    "codigo": "84433233",
    "descricao": "A laser, LED (Diodos Emissores de Luz) ou LCS (Sistema de Cristal Líquido), monocromáticas, com largura de impressão inferior ou igual a 280 mm"
  },
  {
    "codigo": "84433234",
    "descricao": "A laser, LED (Diodos Emissores de Luz) ou LCS (Sistema de Cristal Líquido), monocromáticas, com largura de impressão superior a 280 mm, mas não superior a 420 mm"
  },
  {
    "codigo": "84433235",
    "descricao": "A laser, LED (Diodos Emissores de Luz) ou LCS (Sistema de Cristal Líquido), policromáticas, com velocidade de impressão inferior ou igual a 20 páginas por minuto (ppm)"
  },
  {
    "codigo": "84433236",
    "descricao": "A laser, LED (Diodos Emissores de Luz) ou LCS (Sistema de Cristal Líquido), policromáticas, com velocidade de impressão superior a 20 páginas por minuto (ppm)"
  },
  {
    "codigo": "84433237",
    "descricao": "Térmicas, do tipo utilizado em impressão de imagens para diagnóstico médico em folhas revestidas com camada termossensível"
  },
  {
    "codigo": "84433238",
    "descricao": "Outras, com largura de impressão superior a 420 mm"
  },
  {
    "codigo": "84433239",
    "descricao": "Outras"
  },
  {
    "codigo": "84433240",
    "descricao": "Outras impressoras alimentadas por folhas"
  },
  {
    "codigo": "84433251",
    "descricao": "Por meio de penas"
  },
  {
    "codigo": "84433252",
    "descricao": "Outros, com largura de impressão superior a 580 mm"
  },
  {
    "codigo": "84433259",
    "descricao": "Outros"
  },
  {
    "codigo": "84433291",
    "descricao": "Impressoras de código de barras postais, tipo 3 em 5, a jato de tinta fluorescente, com velocidade de até 4,5 m/s e passo de 1,4 mm"
  },
  {
    "codigo": "84433299",
    "descricao": "Outros"
  },
  {
    "codigo": "84433910",
    "descricao": "Máquinas de impressão por jato de tinta"
  },
  {
    "codigo": "84433921",
    "descricao": "De reprodução da imagem do original sobre a cópia por meio de um suporte intermediário (processo indireto), monocromáticas, para cópias de superfície inferior ou igual a 1 m<sup>2</sup>, com velocidade inferior a 100 cópias por minuto"
  },
  {
    "codigo": "84433928",
    "descricao": "Outras, por processo indireto"
  },
  {
    "codigo": "84433929",
    "descricao": "Outras"
  },
  {
    "codigo": "84433930",
    "descricao": "Outras máquinas copiadoras"
  },
  {
    "codigo": "84433990",
    "descricao": "Outros"
  },
  {
    "codigo": "84439110",
    "descricao": "De máquinas e aparelhos da subposição 8443.12"
  },
  {
    "codigo": "84439191",
    "descricao": "Dobradoras"
  },
  {
    "codigo": "84439192",
    "descricao": "Numeradores automáticos"
  },
  {
    "codigo": "84439199",
    "descricao": "Outros"
  },
  {
    "codigo": "84439911",
    "descricao": "Mecanismos de impressão, mesmo sem cabeça de impressão incorporada"
  },
  {
    "codigo": "84439912",
    "descricao": "Cabeças de impressão"
  },
  {
    "codigo": "84439919",
    "descricao": "Outros"
  },
  {
    "codigo": "84439921",
    "descricao": "Mecanismos de impressão, mesmo sem cabeça de impressão incorporada"
  },
  {
    "codigo": "84439922",
    "descricao": "Cabeças de impressão"
  },
  {
    "codigo": "84439923",
    "descricao": "Cartuchos de tinta"
  },
  {
    "codigo": "84439929",
    "descricao": "Outros"
  },
  {
    "codigo": "84439931",
    "descricao": "Mecanismos de impressão, mesmo sem cilindro fotossensível incorporado"
  },
  {
    "codigo": "84439932",
    "descricao": "Cilindros recobertos de matéria semicondutora fotoelétrica"
  },
  {
    "codigo": "84439933",
    "descricao": "Cartuchos de revelador (<i>toners</i>)"
  },
  {
    "codigo": "84439939",
    "descricao": "Outros"
  },
  {
    "codigo": "84439941",
    "descricao": "Mecanismos de impressão, mesmo sem cabeça de impressão incorporada"
  },
  {
    "codigo": "84439942",
    "descricao": "Cabeças de impressão"
  },
  {
    "codigo": "84439949",
    "descricao": "Outros"
  },
  {
    "codigo": "84439950",
    "descricao": "Outros mecanismos de impressão, suas partes e acessórios"
  },
  {
    "codigo": "84439960",
    "descricao": "Circuitos impressos com componentes elétricos ou eletrônicos, montados"
  },
  {
    "codigo": "84439970",
    "descricao": "Bandejas e gavetas, suas partes e acessórios"
  },
  {
    "codigo": "84439980",
    "descricao": "Mecanismos de alimentação ou de triagem de papéis ou documentos, suas partes e acessórios"
  },
  {
    "codigo": "84439990",
    "descricao": "Outros"
  },
  {
    "codigo": "84440010",
    "descricao": "Para extrudar"
  },
  {
    "codigo": "84440020",
    "descricao": "Para corte ou ruptura de fibras"
  },
  {
    "codigo": "84440090",
    "descricao": "Outras"
  },
  {
    "codigo": "84451110",
    "descricao": "Para lã"
  },
  {
    "codigo": "84451120",
    "descricao": "Para fibras do Capítulo 53"
  },
  {
    "codigo": "84451190",
    "descricao": "Outras"
  },
  {
    "codigo": "84451200",
    "descricao": "-- Penteadoras"
  },
  {
    "codigo": "84451300",
    "descricao": "-- Bancos de estiramento (fusos)"
  },
  {
    "codigo": "84451910",
    "descricao": "Máquinas para a preparação da seda"
  },
  {
    "codigo": "84451921",
    "descricao": "Para recuperação de cordas, fios, trapos ou qualquer outro desperdício, transformando-os em fibras adequadas para cardagem"
  },
  {
    "codigo": "84451922",
    "descricao": "Descaroçadeiras e deslintadeiras de algodão"
  },
  {
    "codigo": "84451923",
    "descricao": "Para desengordurar, lavar, alvejar ou tingir fibras têxteis em massa ou rama"
  },
  {
    "codigo": "84451924",
    "descricao": "Abridoras de fibras de lã"
  },
  {
    "codigo": "84451925",
    "descricao": "Abridoras de fibras do Capítulo 53"
  },
  {
    "codigo": "84451926",
    "descricao": "Máquinas de carbonizar a lã"
  },
  {
    "codigo": "84451927",
    "descricao": "Para estirar a lã"
  },
  {
    "codigo": "84451929",
    "descricao": "Outras"
  },
  {
    "codigo": "84452000",
    "descricao": "- Máquinas para fiação de matérias têxteis"
  },
  {
    "codigo": "84453010",
    "descricao": "Retorcedeiras"
  },
  {
    "codigo": "84453090",
    "descricao": "Outras"
  },
  {
    "codigo": "84454011",
    "descricao": "Bobinadoras de trama (espuladeiras)"
  },
  {
    "codigo": "84454012",
    "descricao": "Para fios elastanos"
  },
  {
    "codigo": "84454018",
    "descricao": "Outras, com atador automático"
  },
  {
    "codigo": "84454019",
    "descricao": "Outras"
  },
  {
    "codigo": "84454021",
    "descricao": "Com velocidade de bobinado igual ou superior a 4.000 m/min"
  },
  {
    "codigo": "84454029",
    "descricao": "Outras"
  },
  {
    "codigo": "84454031",
    "descricao": "Com controle de comprimento ou peso e atador automático"
  },
  {
    "codigo": "84454039",
    "descricao": "Outras"
  },
  {
    "codigo": "84454040",
    "descricao": "Noveleiras automáticas"
  },
  {
    "codigo": "84454090",
    "descricao": "Outras"
  },
  {
    "codigo": "84459010",
    "descricao": "Urdideiras"
  },
  {
    "codigo": "84459020",
    "descricao": "Passadeiras para liço e pente"
  },
  {
    "codigo": "84459030",
    "descricao": "Para amarrar urdideiras"
  },
  {
    "codigo": "84459040",
    "descricao": "Automáticas, para colocar lamelas"
  },
  {
    "codigo": "84459090",
    "descricao": "Outras"
  },
  {
    "codigo": "84461010",
    "descricao": "Com mecanismo Jacquard"
  },
  {
    "codigo": "84461090",
    "descricao": "Outros"
  },
  {
    "codigo": "84462100",
    "descricao": "-- A motor"
  },
  {
    "codigo": "84462900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84463010",
    "descricao": "A jato de ar"
  },
  {
    "codigo": "84463020",
    "descricao": "A jato de água"
  },
  {
    "codigo": "84463030",
    "descricao": "De projétil"
  },
  {
    "codigo": "84463040",
    "descricao": "De pinças"
  },
  {
    "codigo": "84463090",
    "descricao": "Outros"
  },
  {
    "codigo": "84471100",
    "descricao": "-- Com cilindro de diâmetro não superior a 165 mm"
  },
  {
    "codigo": "84471200",
    "descricao": "-- Com cilindro de diâmetro superior a 165 mm"
  },
  {
    "codigo": "84472010",
    "descricao": "Teares manuais"
  },
  {
    "codigo": "84472021",
    "descricao": "Para fabricação de malhas de urdidura"
  },
  {
    "codigo": "84472029",
    "descricao": "Outros"
  },
  {
    "codigo": "84472030",
    "descricao": "Máquinas de costura por entrelaçamento (<i>couture-tricotage</i>)"
  },
  {
    "codigo": "84479010",
    "descricao": "Máquinas para fabricação de redes, tules ou filós"
  },
  {
    "codigo": "84479020",
    "descricao": "Máquinas automáticas para bordar"
  },
  {
    "codigo": "84479090",
    "descricao": "Outras"
  },
  {
    "codigo": "84481110",
    "descricao": "Ratieras"
  },
  {
    "codigo": "84481120",
    "descricao": "Mecanismos Jacquard"
  },
  {
    "codigo": "84481190",
    "descricao": "Outros"
  },
  {
    "codigo": "84481900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84482010",
    "descricao": "Fieiras para a extrusão"
  },
  {
    "codigo": "84482020",
    "descricao": "Outras partes e acessórios de máquinas para a extrusão"
  },
  {
    "codigo": "84482030",
    "descricao": "De máquinas para corte ou ruptura de fibras"
  },
  {
    "codigo": "84482090",
    "descricao": "Outras"
  },
  {
    "codigo": "84483100",
    "descricao": "-- Guarnições de cardas"
  },
  {
    "codigo": "84483211",
    "descricao": "Chapéus (<i>flats</i>)"
  },
  {
    "codigo": "84483219",
    "descricao": "Outras"
  },
  {
    "codigo": "84483220",
    "descricao": "De penteadoras"
  },
  {
    "codigo": "84483230",
    "descricao": "De bancas de estiramento (bancas de fusos)"
  },
  {
    "codigo": "84483240",
    "descricao": "De máquinas para a preparação da seda"
  },
  {
    "codigo": "84483250",
    "descricao": "De máquinas para carbonizar lã"
  },
  {
    "codigo": "84483290",
    "descricao": "Outros"
  },
  {
    "codigo": "84483310",
    "descricao": "Cursores"
  },
  {
    "codigo": "84483390",
    "descricao": "Outros"
  },
  {
    "codigo": "84483911",
    "descricao": "De filatórios intermitentes (selfatinas)"
  },
  {
    "codigo": "84483912",
    "descricao": "De máquinas do tipo <i>tow-to-yarn</i>"
  },
  {
    "codigo": "84483917",
    "descricao": "De outros filatórios"
  },
  {
    "codigo": "84483919",
    "descricao": "Outras"
  },
  {
    "codigo": "84483921",
    "descricao": "De bobinadoras de trama (espuladeiras)"
  },
  {
    "codigo": "84483922",
    "descricao": "De bobinadoras automáticas para fios elastanos, ou com atador automático"
  },
  {
    "codigo": "84483923",
    "descricao": "Outras, de bobinadoras automáticas"
  },
  {
    "codigo": "84483929",
    "descricao": "Outras"
  },
  {
    "codigo": "84483991",
    "descricao": "De urdideiras"
  },
  {
    "codigo": "84483992",
    "descricao": "De passadeiras para liço e pente"
  },
  {
    "codigo": "84483999",
    "descricao": "Outras"
  },
  {
    "codigo": "84484200",
    "descricao": "-- Pentes, liços e quadros de liços"
  },
  {
    "codigo": "84484910",
    "descricao": "De máquinas ou aparelhos auxiliares de teares"
  },
  {
    "codigo": "84484920",
    "descricao": "De teares para tecidos de largura superior a 30 cm, sem lançadeiras, a jato de água ou de projétil"
  },
  {
    "codigo": "84484990",
    "descricao": "Outras"
  },
  {
    "codigo": "84485110",
    "descricao": "Platinas"
  },
  {
    "codigo": "84485190",
    "descricao": "Outros"
  },
  {
    "codigo": "84485910",
    "descricao": "De teares circulares para malhas"
  },
  {
    "codigo": "84485921",
    "descricao": "Manuais"
  },
  {
    "codigo": "84485922",
    "descricao": "Para fabricação de malhas de urdidura"
  },
  {
    "codigo": "84485929",
    "descricao": "Outras"
  },
  {
    "codigo": "84485930",
    "descricao": "De máquinas para fabricação de redes, tules ou filós, ou automáticas para bordar"
  },
  {
    "codigo": "84485940",
    "descricao": "De máquinas do item 8447.90.90"
  },
  {
    "codigo": "84485990",
    "descricao": "Outras"
  },
  {
    "codigo": "84490010",
    "descricao": "Máquinas e aparelhos para fabricação ou acabamento de feltros"
  },
  {
    "codigo": "84490020",
    "descricao": "Máquinas e aparelhos para fabricação de falsos tecidos (tecidos não tecidos)"
  },
  {
    "codigo": "84490080",
    "descricao": "Outros"
  },
  {
    "codigo": "84490091",
    "descricao": "De máquinas ou aparelhos para fabricação de falsos tecidos (tecidos não tecidos)"
  },
  {
    "codigo": "84490099",
    "descricao": "Outras"
  },
  {
    "codigo": "84501100",
    "descricao": "-- Máquinas inteiramente automáticas"
  },
  {
    "codigo": "84501200",
    "descricao": "-- Outras máquinas, com secador centrífugo incorporado"
  },
  {
    "codigo": "84501900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84502010",
    "descricao": "Túneis contínuos"
  },
  {
    "codigo": "84502020",
    "descricao": "Outras máquinas, de capacidade não superior a 18 kg"
  },
  {
    "codigo": "84502090",
    "descricao": "Outras"
  },
  {
    "codigo": "84509010",
    "descricao": "De máquinas dos itens 8450.20.10 ou 8450.20.90"
  },
  {
    "codigo": "84509090",
    "descricao": "Outras"
  },
  {
    "codigo": "84511000",
    "descricao": "- Máquinas para lavar a seco"
  },
  {
    "codigo": "84512100",
    "descricao": "-- De capacidade, expressa em peso de roupa seca, não superior a 10 kg"
  },
  {
    "codigo": "84512910",
    "descricao": "Que funcionem por meio de ondas eletromagnéticas (micro-ondas), cuja produção seja igual ou superior a 120 kg/h de produto seco"
  },
  {
    "codigo": "84512990",
    "descricao": "Outras"
  },
  {
    "codigo": "84513010",
    "descricao": "Automáticas"
  },
  {
    "codigo": "84513091",
    "descricao": "Prensas para passar de peso inferior ou igual a 14 kg"
  },
  {
    "codigo": "84513099",
    "descricao": "Outras"
  },
  {
    "codigo": "84514010",
    "descricao": "Para lavar"
  },
  {
    "codigo": "84514021",
    "descricao": "Para tingir tecidos em rolos; para tingir por pressão estática, com molinete (rotor de pás), jato de água (<i>jet</i>) ou combinada"
  },
  {
    "codigo": "84514029",
    "descricao": "Outras"
  },
  {
    "codigo": "84514090",
    "descricao": "Outras"
  },
  {
    "codigo": "84515010",
    "descricao": "Para inspeção visual de tecidos"
  },
  {
    "codigo": "84515020",
    "descricao": "Automáticas, para enfestar ou cortar"
  },
  {
    "codigo": "84515090",
    "descricao": "Outras"
  },
  {
    "codigo": "84518000",
    "descricao": "- Outras máquinas e aparelhos"
  },
  {
    "codigo": "84519010",
    "descricao": "Para as máquinas da subposição 8451.21"
  },
  {
    "codigo": "84519090",
    "descricao": "Outras"
  },
  {
    "codigo": "84521000",
    "descricao": "- Máquinas de costura de uso doméstico"
  },
  {
    "codigo": "84522110",
    "descricao": "Para costurar couros ou peles"
  },
  {
    "codigo": "84522120",
    "descricao": "Para costurar tecidos"
  },
  {
    "codigo": "84522190",
    "descricao": "Outras"
  },
  {
    "codigo": "84522910",
    "descricao": "Para costurar couros ou peles"
  },
  {
    "codigo": "84522921",
    "descricao": "Remalhadeiras"
  },
  {
    "codigo": "84522922",
    "descricao": "Para casear"
  },
  {
    "codigo": "84522923",
    "descricao": "Tipo zigue-zague para inserir elástico"
  },
  {
    "codigo": "84522924",
    "descricao": "De costura reta"
  },
  {
    "codigo": "84522925",
    "descricao": "Galoneiras"
  },
  {
    "codigo": "84522929",
    "descricao": "Outras"
  },
  {
    "codigo": "84522990",
    "descricao": "Outras"
  },
  {
    "codigo": "84523000",
    "descricao": "- Agulhas para máquinas de costura"
  },
  {
    "codigo": "84529020",
    "descricao": "Móveis, bases e tampas, para máquinas de costura, e suas partes"
  },
  {
    "codigo": "84529081",
    "descricao": "Guia-fios, lançadeiras e porta-bobinas"
  },
  {
    "codigo": "84529089",
    "descricao": "Outras"
  },
  {
    "codigo": "84529091",
    "descricao": "Guia-fios, lançadeiras não rotativas e porta-bobinas"
  },
  {
    "codigo": "84529092",
    "descricao": "Para remalhadeiras"
  },
  {
    "codigo": "84529093",
    "descricao": "Lançadeiras rotativas"
  },
  {
    "codigo": "84529094",
    "descricao": "Corpos moldados por fundição"
  },
  {
    "codigo": "84529099",
    "descricao": "Outras"
  },
  {
    "codigo": "84531010",
    "descricao": "Máquinas para dividir couros com largura útil inferior ou igual a 3.000 mm, com lâmina sem fim, com controle eletrônico programável"
  },
  {
    "codigo": "84531090",
    "descricao": "Outros"
  },
  {
    "codigo": "84532000",
    "descricao": "- Máquinas e aparelhos para fabricar ou consertar calçado"
  },
  {
    "codigo": "84538000",
    "descricao": "- Outras máquinas e aparelhos"
  },
  {
    "codigo": "84539000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84541000",
    "descricao": "- Conversores"
  },
  {
    "codigo": "84542010",
    "descricao": "Lingoteiras"
  },
  {
    "codigo": "84542090",
    "descricao": "Outras"
  },
  {
    "codigo": "84543010",
    "descricao": "Sob pressão"
  },
  {
    "codigo": "84543020",
    "descricao": "Por centrifugação"
  },
  {
    "codigo": "84543090",
    "descricao": "Outras"
  },
  {
    "codigo": "84549010",
    "descricao": "De máquinas de vazar (moldar) por centrifugação"
  },
  {
    "codigo": "84549090",
    "descricao": "Outras"
  },
  {
    "codigo": "84551000",
    "descricao": "- Laminadores de tubos"
  },
  {
    "codigo": "84552110",
    "descricao": "De cilindros lisos"
  },
  {
    "codigo": "84552190",
    "descricao": "Outros"
  },
  {
    "codigo": "84552210",
    "descricao": "De cilindros lisos"
  },
  {
    "codigo": "84552290",
    "descricao": "Outros"
  },
  {
    "codigo": "84553010",
    "descricao": "Fundidos, de aço ou ferro fundido nodular"
  },
  {
    "codigo": "84553020",
    "descricao": "Forjados, de aço de corte rápido, com um teor, em peso, de carbono igual ou superior a 0,80 % e inferior ou igual a 0,90 %, de cromo igual ou superior a 3,50 % e inferior ou igual a 4 %, de vanádio igual ou superior a 1,60 % e inferior ou igual a 2,30 %, de molibdênio inferior ou igual a 8,50 % e de tungstênio (volfrâmio) inferior ou igual a 7 %"
  },
  {
    "codigo": "84553090",
    "descricao": "Outros"
  },
  {
    "codigo": "84559000",
    "descricao": "- Outras partes"
  },
  {
    "codigo": "84561111",
    "descricao": "Para corte de chapas metálicas de espessura superior a 8 mm"
  },
  {
    "codigo": "84561119",
    "descricao": "Outras"
  },
  {
    "codigo": "84561190",
    "descricao": "Outras"
  },
  {
    "codigo": "84561211",
    "descricao": "Para corte de chapas metálicas de espessura superior a 8 mm"
  },
  {
    "codigo": "84561219",
    "descricao": "Outras"
  },
  {
    "codigo": "84561290",
    "descricao": "Outras"
  },
  {
    "codigo": "84562010",
    "descricao": "De comando numérico"
  },
  {
    "codigo": "84562090",
    "descricao": "Outras"
  },
  {
    "codigo": "84563011",
    "descricao": "Para texturizar superfícies cilíndricas"
  },
  {
    "codigo": "84563019",
    "descricao": "Outras"
  },
  {
    "codigo": "84563090",
    "descricao": "Outras"
  },
  {
    "codigo": "84564000",
    "descricao": "- Que operem por jato de plasma"
  },
  {
    "codigo": "84565000",
    "descricao": "- Máquinas de corte a jato de água"
  },
  {
    "codigo": "84569000",
    "descricao": "- Outras"
  },
  {
    "codigo": "84571000",
    "descricao": "- Centros de usinagem (fabricação*)"
  },
  {
    "codigo": "84572010",
    "descricao": "De comando numérico"
  },
  {
    "codigo": "84572090",
    "descricao": "Outras"
  },
  {
    "codigo": "84573010",
    "descricao": "De comando numérico"
  },
  {
    "codigo": "84573090",
    "descricao": "Outras"
  },
  {
    "codigo": "84581110",
    "descricao": "Revólver"
  },
  {
    "codigo": "84581191",
    "descricao": "De 6 ou mais fusos porta-peças"
  },
  {
    "codigo": "84581199",
    "descricao": "Outros"
  },
  {
    "codigo": "84581910",
    "descricao": "Revólver"
  },
  {
    "codigo": "84581990",
    "descricao": "Outros"
  },
  {
    "codigo": "84589100",
    "descricao": "-- De comando numérico"
  },
  {
    "codigo": "84589900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84591000",
    "descricao": "- Unidades com cabeça deslizante"
  },
  {
    "codigo": "84592110",
    "descricao": "Radiais"
  },
  {
    "codigo": "84592191",
    "descricao": "De mais de um cabeçote mono ou multifuso"
  },
  {
    "codigo": "84592199",
    "descricao": "Outras"
  },
  {
    "codigo": "84592900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84593100",
    "descricao": "-- De comando numérico"
  },
  {
    "codigo": "84593900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84594100",
    "descricao": "-- De comando numérico"
  },
  {
    "codigo": "84594900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84595100",
    "descricao": "-- De comando numérico"
  },
  {
    "codigo": "84595900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84596100",
    "descricao": "-- De comando numérico"
  },
  {
    "codigo": "84596900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84597000",
    "descricao": "- Outras máquinas para roscar interior ou exteriormente"
  },
  {
    "codigo": "84601200",
    "descricao": "-- De comando numérico"
  },
  {
    "codigo": "84601900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84602200",
    "descricao": "-- Máquinas para retificar sem centro, de comando numérico"
  },
  {
    "codigo": "84602300",
    "descricao": "-- Outras máquinas para retificar superfícies cilíndricas, de comando numérico"
  },
  {
    "codigo": "84602400",
    "descricao": "-- Outras, de comando numérico"
  },
  {
    "codigo": "84602900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84603100",
    "descricao": "-- De comando numérico"
  },
  {
    "codigo": "84603900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84604011",
    "descricao": "Brunidoras para cilindros de diâmetro inferior ou igual a 312 mm"
  },
  {
    "codigo": "84604019",
    "descricao": "Outras"
  },
  {
    "codigo": "84604091",
    "descricao": "Brunidoras para cilindros de diâmetro inferior ou igual a 312 mm"
  },
  {
    "codigo": "84604099",
    "descricao": "Outras"
  },
  {
    "codigo": "84609011",
    "descricao": "De polir, com cinco ou mais cabeças e porta -peças rotativo"
  },
  {
    "codigo": "84609012",
    "descricao": "De esmerilhar, com duas ou mais cabeças e porta-peças rotativo"
  },
  {
    "codigo": "84609019",
    "descricao": "Outras"
  },
  {
    "codigo": "84609090",
    "descricao": "Outras"
  },
  {
    "codigo": "84612010",
    "descricao": "Para escatelar"
  },
  {
    "codigo": "84612090",
    "descricao": "Outras"
  },
  {
    "codigo": "84613010",
    "descricao": "De comando numérico"
  },
  {
    "codigo": "84613090",
    "descricao": "Outras"
  },
  {
    "codigo": "84614010",
    "descricao": "De comando numérico"
  },
  {
    "codigo": "84614091",
    "descricao": "Redondeadoras de dentes"
  },
  {
    "codigo": "84614099",
    "descricao": "Outras"
  },
  {
    "codigo": "84615010",
    "descricao": "De fitas sem fim"
  },
  {
    "codigo": "84615020",
    "descricao": "Circulares"
  },
  {
    "codigo": "84615090",
    "descricao": "Outras"
  },
  {
    "codigo": "84619010",
    "descricao": "De comando numérico"
  },
  {
    "codigo": "84619090",
    "descricao": "Outras"
  },
  {
    "codigo": "84621100",
    "descricao": "-- Máquinas para forjamento em matriz fechada"
  },
  {
    "codigo": "84621900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84622200",
    "descricao": "-- Máquinas para formação de perfis"
  },
  {
    "codigo": "84622300",
    "descricao": "-- Prensas dobradeiras, de comando numérico"
  },
  {
    "codigo": "84622400",
    "descricao": "-- Prensas para painéis, de comando numérico"
  },
  {
    "codigo": "84622500",
    "descricao": "-- Máquinas de conformação por rolos, de comando numérico"
  },
  {
    "codigo": "84622600",
    "descricao": "-- Outras máquinas para enrolar, arquear, dobrar, endireitar ou aplanar, de comando numérico"
  },
  {
    "codigo": "84622900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84623200",
    "descricao": "-- Linhas de corte longitudinal e linhas de corte transversal"
  },
  {
    "codigo": "84623300",
    "descricao": "-- Máquinas para cisalhar, de comando numérico"
  },
  {
    "codigo": "84623900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84624200",
    "descricao": "-- De comando numérico"
  },
  {
    "codigo": "84624900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84625100",
    "descricao": "-- De comando numérico"
  },
  {
    "codigo": "84625900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84626100",
    "descricao": "-- Prensas hidráulicas"
  },
  {
    "codigo": "84626200",
    "descricao": "-- Prensas mecânicas"
  },
  {
    "codigo": "84626300",
    "descricao": "-- Servoprensas"
  },
  {
    "codigo": "84626900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84629000",
    "descricao": "- Outras"
  },
  {
    "codigo": "84631010",
    "descricao": "Para estirar tubos"
  },
  {
    "codigo": "84631090",
    "descricao": "Outros"
  },
  {
    "codigo": "84632010",
    "descricao": "De comando numérico"
  },
  {
    "codigo": "84632091",
    "descricao": "De pente plano, com capacidade de produção igual ou superior a 160 unidades por minuto, de diâmetro de rosca compreendido entre 3 mm e 10 mm"
  },
  {
    "codigo": "84632099",
    "descricao": "Outras"
  },
  {
    "codigo": "84633000",
    "descricao": "- Máquinas para trabalhar arames e fios de metal"
  },
  {
    "codigo": "84639010",
    "descricao": "De comando numérico"
  },
  {
    "codigo": "84639090",
    "descricao": "Outras"
  },
  {
    "codigo": "84641000",
    "descricao": "- Máquinas para serrar"
  },
  {
    "codigo": "84642010",
    "descricao": "Para vidro"
  },
  {
    "codigo": "84642021",
    "descricao": "De polir placas, para pavimentação ou revestimento, com oito ou mais cabeças"
  },
  {
    "codigo": "84642029",
    "descricao": "Outras"
  },
  {
    "codigo": "84642090",
    "descricao": "Outras"
  },
  {
    "codigo": "84649011",
    "descricao": "De comando numérico, para retificar, fresar e perfurar"
  },
  {
    "codigo": "84649019",
    "descricao": "Outras"
  },
  {
    "codigo": "84649090",
    "descricao": "Outras"
  },
  {
    "codigo": "84651000",
    "descricao": "- Máquinas-ferramentas capazes de efetuar diferentes tipos de operações sem troca de ferramentas"
  },
  {
    "codigo": "84652000",
    "descricao": "- Centros de usinagem (fabricação*)"
  },
  {
    "codigo": "84659110",
    "descricao": "De fita sem fim"
  },
  {
    "codigo": "84659120",
    "descricao": "Circulares"
  },
  {
    "codigo": "84659190",
    "descricao": "Outras"
  },
  {
    "codigo": "84659211",
    "descricao": "Fresadoras"
  },
  {
    "codigo": "84659219",
    "descricao": "Outras"
  },
  {
    "codigo": "84659290",
    "descricao": "Outras"
  },
  {
    "codigo": "84659310",
    "descricao": "Lixadeiras"
  },
  {
    "codigo": "84659390",
    "descricao": "Outras"
  },
  {
    "codigo": "84659400",
    "descricao": "-- Máquinas para arquear ou reunir"
  },
  {
    "codigo": "84659511",
    "descricao": "Para furar"
  },
  {
    "codigo": "84659512",
    "descricao": "Para escatelar"
  },
  {
    "codigo": "84659591",
    "descricao": "Para furar"
  },
  {
    "codigo": "84659592",
    "descricao": "Para escatelar"
  },
  {
    "codigo": "84659600",
    "descricao": "-- Máquinas para fender, seccionar ou desenrolar"
  },
  {
    "codigo": "84659900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84661000",
    "descricao": "- Porta-ferramentas e fieiras de abertura automática"
  },
  {
    "codigo": "84662010",
    "descricao": "Para tornos"
  },
  {
    "codigo": "84662090",
    "descricao": "Outros"
  },
  {
    "codigo": "84663000",
    "descricao": "- Dispositivos divisores e outros dispositivos especiais, para máquinas"
  },
  {
    "codigo": "84669100",
    "descricao": "-- Para máquinas da posição 84.64"
  },
  {
    "codigo": "84669200",
    "descricao": "-- Para máquinas da posição 84.65"
  },
  {
    "codigo": "84669311",
    "descricao": "Para máquinas da subposição 8456.20"
  },
  {
    "codigo": "84669319",
    "descricao": "Outras"
  },
  {
    "codigo": "84669320",
    "descricao": "Para máquinas da posição 84.57"
  },
  {
    "codigo": "84669330",
    "descricao": "Para máquinas da posição 84.58"
  },
  {
    "codigo": "84669340",
    "descricao": "Para máquinas da posição 84.59"
  },
  {
    "codigo": "84669350",
    "descricao": "Para máquinas da posição 84.60"
  },
  {
    "codigo": "84669360",
    "descricao": "Para máquinas da posição 84.61"
  },
  {
    "codigo": "84669410",
    "descricao": "Para máquinas das subposições 8462.11 ou 8462.19"
  },
  {
    "codigo": "84669420",
    "descricao": "Para máquinas das subposições 8462.22 a 8462.29"
  },
  {
    "codigo": "84669490",
    "descricao": "Outras"
  },
  {
    "codigo": "84671110",
    "descricao": "Furadeiras"
  },
  {
    "codigo": "84671190",
    "descricao": "Outras"
  },
  {
    "codigo": "84671900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84672100",
    "descricao": "-- Furadeiras (perfuradoras) de qualquer espécie, incluindo as rotativas"
  },
  {
    "codigo": "84672200",
    "descricao": "-- Serras"
  },
  {
    "codigo": "84672910",
    "descricao": "Tesouras"
  },
  {
    "codigo": "84672991",
    "descricao": "Cortadoras de tecidos"
  },
  {
    "codigo": "84672992",
    "descricao": "Parafusadeiras e rosqueadeiras"
  },
  {
    "codigo": "84672993",
    "descricao": "Martelos"
  },
  {
    "codigo": "84672999",
    "descricao": "Outras"
  },
  {
    "codigo": "84678100",
    "descricao": "-- Serras de corrente"
  },
  {
    "codigo": "84678900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84679100",
    "descricao": "-- De serras de corrente"
  },
  {
    "codigo": "84679200",
    "descricao": "-- De ferramentas pneumáticas"
  },
  {
    "codigo": "84679900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84681000",
    "descricao": "- Maçaricos de uso manual"
  },
  {
    "codigo": "84682000",
    "descricao": "- Outras máquinas e aparelhos a gás"
  },
  {
    "codigo": "84688010",
    "descricao": "Para soldar por fricção"
  },
  {
    "codigo": "84688090",
    "descricao": "Outras"
  },
  {
    "codigo": "84689010",
    "descricao": "De maçaricos de uso manual"
  },
  {
    "codigo": "84689020",
    "descricao": "De máquinas ou aparelhos para soldar por fricção"
  },
  {
    "codigo": "84689090",
    "descricao": "Outras"
  },
  {
    "codigo": "84701000",
    "descricao": "- Calculadoras eletrônicas capazes de funcionar sem fonte externa de energia elétrica e máquinas de bolso com função de cálculo incorporada que permitam gravar, reproduzir e visualizar informações"
  },
  {
    "codigo": "84702100",
    "descricao": "-- Com dispositivo impressor incorporado"
  },
  {
    "codigo": "84702900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84703000",
    "descricao": "- Outras máquinas de calcular"
  },
  {
    "codigo": "84705010",
    "descricao": "Eletrônicas"
  },
  {
    "codigo": "84705090",
    "descricao": "Outras"
  },
  {
    "codigo": "84709010",
    "descricao": "Máquinas de franquear correspondência"
  },
  {
    "codigo": "84709090",
    "descricao": "Outras"
  },
  {
    "codigo": "84713011",
    "descricao": "De peso inferior a 350 g, com tela de área não superior a 140 cm<sup>2</sup>"
  },
  {
    "codigo": "84713012",
    "descricao": "De peso inferior a 3,5 kg, com tela de área superior a 140 cm<sup>2</sup>, mas inferior a 560 cm<sup>2</sup>"
  },
  {
    "codigo": "84713019",
    "descricao": "Outras"
  },
  {
    "codigo": "84713090",
    "descricao": "Outras"
  },
  {
    "codigo": "84714100",
    "descricao": "-- Que contenham, no mesmo corpo, pelo menos uma unidade central de processamento e, mesmo combinadas, uma unidade de entrada e uma unidade de saída"
  },
  {
    "codigo": "84714900",
    "descricao": "-- Outras, apresentadas sob a forma de sistemas"
  },
  {
    "codigo": "84715010",
    "descricao": "De pequena capacidade, baseadas em microprocessadores, com capacidade de instalação, dentro do mesmo gabinete, de unidades de memória da subposição 8471.70, podendo conter múltiplos conectores de expansão (<i>slots</i>), e valor FOB inferior ou igual a US$ 12.500,00, por unidade"
  },
  {
    "codigo": "84715020",
    "descricao": "De média capacidade, podendo conter no máximo uma unidade de entrada e outra de saída da subposição 8471.60, com capacidade de instalação, dentro do mesmo gabinete, de unidades de memória da subposição 8471.70, podendo conter múltiplos conectores de expansão (<i>slots</i>), e valor FOB superior a US$ 12.500,00, mas não superior a US$ 46.000,00, por unidade"
  },
  {
    "codigo": "84715030",
    "descricao": "De grande capacidade, podendo conter no máximo uma unidade de entrada e outra de saída da subposição 8471.60, com capacidade de instalação interna, ou em módulos separados do gabinete do processador central, de unidades de memória da subposição 8471.70, e valor FOB superior a US$ 46.000,00, mas não superior a US$ 100.000,00, por unidade"
  },
  {
    "codigo": "84715040",
    "descricao": "De muito grande capacidade, podendo conter no máximo uma unidade de entrada e outra de saída da subposição 8471.60, com capacidade de instalação interna, ou em módulos separados do gabinete do processador central, de unidades de memória da subposição 8471.70, e valor FOB superior a US$ 100.000,00, por unidade"
  },
  {
    "codigo": "84715090",
    "descricao": "Outras"
  },
  {
    "codigo": "84716052",
    "descricao": "Teclados"
  },
  {
    "codigo": "84716053",
    "descricao": "Indicadores ou apontadores (<i>mouse</i> e <i>track-ball</i>, por exemplo)"
  },
  {
    "codigo": "84716054",
    "descricao": "Mesas digitalizadoras"
  },
  {
    "codigo": "84716059",
    "descricao": "Outras"
  },
  {
    "codigo": "84716061",
    "descricao": "Com unidade de saída por vídeo monocromático"
  },
  {
    "codigo": "84716062",
    "descricao": "Com unidade de saída por vídeo policromático"
  },
  {
    "codigo": "84716080",
    "descricao": "Terminais de auto-atendimento bancário"
  },
  {
    "codigo": "84716090",
    "descricao": "Outras"
  },
  {
    "codigo": "84717010",
    "descricao": "De discos magnéticos"
  },
  {
    "codigo": "84717020",
    "descricao": "De discos para leitura ou gravação de dados por meios ópticos (unidade de disco óptico)"
  },
  {
    "codigo": "84717030",
    "descricao": "De fitas magnéticas"
  },
  {
    "codigo": "84717040",
    "descricao": "De estado sólido (SSD - <i>Solid-State Drive</i>)"
  },
  {
    "codigo": "84717090",
    "descricao": "Outras, incluídas as combinações de unidades de, pelo menos, dois dos itens precedentes"
  },
  {
    "codigo": "84718000",
    "descricao": "- Outras unidades de máquinas automáticas para processamento de dados"
  },
  {
    "codigo": "84719011",
    "descricao": "De cartões magnéticos"
  },
  {
    "codigo": "84719012",
    "descricao": "Leitores de códigos de barras"
  },
  {
    "codigo": "84719013",
    "descricao": "Leitores de caracteres magnetizáveis"
  },
  {
    "codigo": "84719014",
    "descricao": "Digitalizadores de imagens (<i>scanners</i>)"
  },
  {
    "codigo": "84719019",
    "descricao": "Outros"
  },
  {
    "codigo": "84719090",
    "descricao": "Outros"
  },
  {
    "codigo": "84721000",
    "descricao": "- Duplicadores"
  },
  {
    "codigo": "84723010",
    "descricao": "Máquinas automáticas para obliterar selos postais"
  },
  {
    "codigo": "84723020",
    "descricao": "Máquinas automáticas para seleção de correspondência por formato e classificação e distribuição da mesma por leitura óptica do código postal"
  },
  {
    "codigo": "84723030",
    "descricao": "Máquinas automáticas para seleção e distribuição de encomendas, por leitura óptica do código postal"
  },
  {
    "codigo": "84723090",
    "descricao": "Outras"
  },
  {
    "codigo": "84729010",
    "descricao": "Distribuidores (dispensadores) automáticos de notas (papéis-moeda), incluindo os que efetuam outras operações bancárias"
  },
  {
    "codigo": "84729020",
    "descricao": "Máquinas do tipo utilizado em caixas de banco, com dispositivo para autenticar"
  },
  {
    "codigo": "84729030",
    "descricao": "Máquinas para selecionar e contar moedas ou notas (papéis-moeda)"
  },
  {
    "codigo": "84729040",
    "descricao": "Máquinas apontadoras de lápis (apara-lápis), perfuradores, grampeadores e desgrampeadores"
  },
  {
    "codigo": "84729051",
    "descricao": "Com capacidade de classificação superior a 400 documentos por minuto"
  },
  {
    "codigo": "84729059",
    "descricao": "Outras"
  },
  {
    "codigo": "84729091",
    "descricao": "Máquinas para imprimir endereços ou para estampar placas de endereços"
  },
  {
    "codigo": "84729099",
    "descricao": "Outros"
  },
  {
    "codigo": "84732100",
    "descricao": "-- Das calculadoras eletrônicas das subposições 8470.10, 8470.21 ou 8470.29"
  },
  {
    "codigo": "84732910",
    "descricao": "Circuitos impressos com componentes elétricos ou eletrônicos, montados, para caixas registradoras"
  },
  {
    "codigo": "84732920",
    "descricao": "De máquinas da subposição 8470.30"
  },
  {
    "codigo": "84732990",
    "descricao": "Outros"
  },
  {
    "codigo": "84733011",
    "descricao": "Com fonte de alimentação, mesmo com módulo <i>display</i> numérico"
  },
  {
    "codigo": "84733019",
    "descricao": "Outros"
  },
  {
    "codigo": "84733031",
    "descricao": "Conjuntos cabeça-disco (HDA - <i>Head Disk Assembly</i>) de unidades de discos rígidos, montados"
  },
  {
    "codigo": "84733032",
    "descricao": "Braços posicionadores de cabeças magnéticas"
  },
  {
    "codigo": "84733033",
    "descricao": "Cabeças magnéticas"
  },
  {
    "codigo": "84733034",
    "descricao": "Mecanismos bobinadores para unidades de fitas magnéticas (<i>magnetic tape transporter</i>)"
  },
  {
    "codigo": "84733039",
    "descricao": "Outras"
  },
  {
    "codigo": "84733041",
    "descricao": "Placas-mãe (<i>mother boards</i>)"
  },
  {
    "codigo": "84733042",
    "descricao": "Placas (módulos) de memória com uma superfície inferior ou igual a 50 cm<sup>2</sup>"
  },
  {
    "codigo": "84733049",
    "descricao": "Outros"
  },
  {
    "codigo": "84733090",
    "descricao": "Outros"
  },
  {
    "codigo": "84734010",
    "descricao": "Circuitos impressos com componentes elétricos ou eletrônicos, montados"
  },
  {
    "codigo": "84734070",
    "descricao": "Outras partes e acessórios das máquinas dos itens 8472.90.10 ou 8472.90.20"
  },
  {
    "codigo": "84734090",
    "descricao": "Outros"
  },
  {
    "codigo": "84735010",
    "descricao": "Circuitos impressos com componentes elétricos ou eletrônicos, montados"
  },
  {
    "codigo": "84735040",
    "descricao": "Cabeças magnéticas"
  },
  {
    "codigo": "84735050",
    "descricao": "Placas (módulos) de memória com uma superfície inferior ou igual a 50 cm<sup>2</sup>"
  },
  {
    "codigo": "84735090",
    "descricao": "Outros"
  },
  {
    "codigo": "84741000",
    "descricao": "- Máquinas e aparelhos para selecionar, peneirar, separar ou lavar"
  },
  {
    "codigo": "84742010",
    "descricao": "De bolas"
  },
  {
    "codigo": "84742090",
    "descricao": "Outros"
  },
  {
    "codigo": "84743100",
    "descricao": "-- Betoneiras e aparelhos para amassar cimento"
  },
  {
    "codigo": "84743200",
    "descricao": "-- Máquinas para misturar matérias minerais com betume"
  },
  {
    "codigo": "84743900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "84748010",
    "descricao": "Para fazer moldes de areia para fundição"
  },
  {
    "codigo": "84748090",
    "descricao": "Outras"
  },
  {
    "codigo": "84749000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84751000",
    "descricao": "- Máquinas para montagem de lâmpadas, tubos ou válvulas, elétricos ou eletrônicos, ou de lâmpadas de luz relâmpago (<i>flash</i>), que tenham invólucro de vidro"
  },
  {
    "codigo": "84752100",
    "descricao": "-- Máquinas para fabricação de fibras ópticas e de seus esboços"
  },
  {
    "codigo": "84752910",
    "descricao": "Para fabricação de recipientes da posição 70.10, exceto ampolas"
  },
  {
    "codigo": "84752990",
    "descricao": "Outras"
  },
  {
    "codigo": "84759000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84762100",
    "descricao": "-- Com dispositivo de aquecimento ou de refrigeração incorporado"
  },
  {
    "codigo": "84762900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84768100",
    "descricao": "-- Com dispositivo de aquecimento ou de refrigeração incorporado"
  },
  {
    "codigo": "84768910",
    "descricao": "Máquinas automáticas de venda de selos postais"
  },
  {
    "codigo": "84768990",
    "descricao": "Outras"
  },
  {
    "codigo": "84769000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84771011",
    "descricao": "Monocolor, para materiais termoplásticos, com capacidade de injeção inferior ou igual a 5.000 g e força de fechamento inferior ou igual a 12.000 kN"
  },
  {
    "codigo": "84771019",
    "descricao": "Outras"
  },
  {
    "codigo": "84771021",
    "descricao": "Monocolor, para materiais termoplásticos, com capacidade de injeção inferior ou igual a 5.000 g e força de fechamento inferior ou igual a 12.000 kN"
  },
  {
    "codigo": "84771029",
    "descricao": "Outras"
  },
  {
    "codigo": "84771091",
    "descricao": "De comando numérico"
  },
  {
    "codigo": "84771099",
    "descricao": "Outras"
  },
  {
    "codigo": "84772010",
    "descricao": "Para materiais termoplásticos, de diâmetro da rosca inferior ou igual a 300 mm"
  },
  {
    "codigo": "84772090",
    "descricao": "Outras"
  },
  {
    "codigo": "84773010",
    "descricao": "Para fabricação de recipientes termoplásticos de capacidade inferior ou igual a 5 l, com uma produção inferior ou igual a 1.000 unidades por hora, referente a recipiente de 1 l"
  },
  {
    "codigo": "84773090",
    "descricao": "Outras"
  },
  {
    "codigo": "84774010",
    "descricao": "De moldar a vácuo poliestireno expandido (EPS) ou polipropileno expandido (EPP)"
  },
  {
    "codigo": "84774090",
    "descricao": "Outras"
  },
  {
    "codigo": "84775100",
    "descricao": "-- Para moldar ou recauchutar pneumáticos ou para moldar ou dar forma a câmaras de ar"
  },
  {
    "codigo": "84775911",
    "descricao": "Com capacidade inferior ou igual a 30.000 kN"
  },
  {
    "codigo": "84775919",
    "descricao": "Outras"
  },
  {
    "codigo": "84775990",
    "descricao": "Outras"
  },
  {
    "codigo": "84778010",
    "descricao": "Máquina de unir lâminas de borracha entre si ou com tecidos com borracha, para fabricação de pneumáticos"
  },
  {
    "codigo": "84778090",
    "descricao": "Outras"
  },
  {
    "codigo": "84779000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84781010",
    "descricao": "Batedoras-separadoras automáticas de talos e folhas"
  },
  {
    "codigo": "84781090",
    "descricao": "Outros"
  },
  {
    "codigo": "84789000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84791010",
    "descricao": "Automotrizes para espalhar e calcar pisos (pavimentos) betuminosos"
  },
  {
    "codigo": "84791090",
    "descricao": "Outros"
  },
  {
    "codigo": "84792000",
    "descricao": "- Máquinas e aparelhos para extração ou preparação de óleos ou gorduras vegetais ou de origem microbiana, fixos, ou de animais"
  },
  {
    "codigo": "84793000",
    "descricao": "- Prensas para fabricação de painéis de partículas, de fibras de madeira ou de outras matérias lenhosas, e outras máquinas e aparelhos para tratamento de madeira ou de cortiça"
  },
  {
    "codigo": "84794000",
    "descricao": "- Máquinas para fabricação de cordas ou cabos"
  },
  {
    "codigo": "84795000",
    "descricao": "- Robôs industriais, não especificados nem compreendidos noutras posições"
  },
  {
    "codigo": "84796000",
    "descricao": "- Aparelhos de evaporação para arrefecimento do ar"
  },
  {
    "codigo": "84797100",
    "descricao": "-- Do tipo utilizado em aeroportos"
  },
  {
    "codigo": "84797900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "84798110",
    "descricao": "Diferenciadores das tensões de tração de entrada e saída da chapa, em instalações de galvanoplastia"
  },
  {
    "codigo": "84798190",
    "descricao": "Outros"
  },
  {
    "codigo": "84798210",
    "descricao": "Misturadores"
  },
  {
    "codigo": "84798290",
    "descricao": "Outros"
  },
  {
    "codigo": "84798300",
    "descricao": "-- Prensas isostáticas a frio"
  },
  {
    "codigo": "84798911",
    "descricao": "Prensas"
  },
  {
    "codigo": "84798912",
    "descricao": "Distribuidores e doseadores de sólidos ou de líquidos"
  },
  {
    "codigo": "84798921",
    "descricao": "Máquinas e aparelhos para cestaria ou espartaria"
  },
  {
    "codigo": "84798922",
    "descricao": "Máquinas e aparelhos para fabricação de pincéis, brochas ou escovas"
  },
  {
    "codigo": "84798931",
    "descricao": "Limpadores de para-brisas"
  },
  {
    "codigo": "84798932",
    "descricao": "Acumuladores"
  },
  {
    "codigo": "84798940",
    "descricao": "Silos metálicos para cereais, fixos (não transportáveis), incluindo as baterias, com mecanismos elevadores ou extratores incorporados"
  },
  {
    "codigo": "84798991",
    "descricao": "Aparelhos para limpar peças por ultrassom"
  },
  {
    "codigo": "84798992",
    "descricao": "Máquinas de leme para embarcações"
  },
  {
    "codigo": "84798999",
    "descricao": "Outros"
  },
  {
    "codigo": "84799010",
    "descricao": "De limpadores de para-brisas elétricos ou de acumuladores hidráulicos para aeronaves"
  },
  {
    "codigo": "84799090",
    "descricao": "Outras"
  },
  {
    "codigo": "84801000",
    "descricao": "- Caixas de fundição"
  },
  {
    "codigo": "84802000",
    "descricao": "- Placas de fundo para moldes"
  },
  {
    "codigo": "84803000",
    "descricao": "- Modelos para moldes"
  },
  {
    "codigo": "84804100",
    "descricao": "-- Para moldagem por injeção ou por compressão"
  },
  {
    "codigo": "84804910",
    "descricao": "Coquilhas"
  },
  {
    "codigo": "84804990",
    "descricao": "Outros"
  },
  {
    "codigo": "84805000",
    "descricao": "- Moldes para vidro"
  },
  {
    "codigo": "84806000",
    "descricao": "- Moldes para matérias minerais"
  },
  {
    "codigo": "84807100",
    "descricao": "-- Para moldagem por injeção ou por compressão"
  },
  {
    "codigo": "84807910",
    "descricao": "Para vulcanização de pneumáticos"
  },
  {
    "codigo": "84807990",
    "descricao": "Outros"
  },
  {
    "codigo": "84811000",
    "descricao": "- Válvulas redutoras de pressão"
  },
  {
    "codigo": "84812011",
    "descricao": "Com pinhão"
  },
  {
    "codigo": "84812019",
    "descricao": "Outras"
  },
  {
    "codigo": "84812090",
    "descricao": "Outras"
  },
  {
    "codigo": "84813000",
    "descricao": "- Válvulas de retenção"
  },
  {
    "codigo": "84814000",
    "descricao": "- Válvulas de segurança ou de alívio"
  },
  {
    "codigo": "84818011",
    "descricao": "Válvulas para escoamento"
  },
  {
    "codigo": "84818019",
    "descricao": "Outros"
  },
  {
    "codigo": "84818021",
    "descricao": "Válvulas de expansão termostáticas ou pressostáticas"
  },
  {
    "codigo": "84818029",
    "descricao": "Outros"
  },
  {
    "codigo": "84818031",
    "descricao": "Com uma pressão de trabalho inferior ou igual a 50 mbar e dispositivo de segurança termoelétrico incorporado, do tipo utilizado em aparelhos domésticos"
  },
  {
    "codigo": "84818039",
    "descricao": "Outros"
  },
  {
    "codigo": "84818091",
    "descricao": "Válvulas tipo aerossol"
  },
  {
    "codigo": "84818092",
    "descricao": "Válvulas solenoides"
  },
  {
    "codigo": "84818093",
    "descricao": "Válvulas tipo gaveta"
  },
  {
    "codigo": "84818094",
    "descricao": "Válvulas tipo globo"
  },
  {
    "codigo": "84818095",
    "descricao": "Válvulas tipo esfera"
  },
  {
    "codigo": "84818096",
    "descricao": "Válvulas tipo macho"
  },
  {
    "codigo": "84818097",
    "descricao": "Válvulas tipo borboleta"
  },
  {
    "codigo": "84818099",
    "descricao": "Outros"
  },
  {
    "codigo": "84819010",
    "descricao": "De válvulas tipo aerossol ou dos dispositivos do item 8481.80.1"
  },
  {
    "codigo": "84819090",
    "descricao": "Outras"
  },
  {
    "codigo": "84821010",
    "descricao": "De carga radial"
  },
  {
    "codigo": "84821090",
    "descricao": "Outros"
  },
  {
    "codigo": "84822010",
    "descricao": "De carga radial"
  },
  {
    "codigo": "84822090",
    "descricao": "Outros"
  },
  {
    "codigo": "84823000",
    "descricao": "- Rolamentos de roletes em forma de tonel"
  },
  {
    "codigo": "84824000",
    "descricao": "- Rolamentos de agulhas, incluindo as montagens de gaiolas e agulhas"
  },
  {
    "codigo": "84825010",
    "descricao": "De carga radial"
  },
  {
    "codigo": "84825090",
    "descricao": "Outros"
  },
  {
    "codigo": "84828000",
    "descricao": "- Outros, incluindo os rolamentos combinados"
  },
  {
    "codigo": "84829111",
    "descricao": "Para carga de canetas esferográficas"
  },
  {
    "codigo": "84829119",
    "descricao": "Outras"
  },
  {
    "codigo": "84829120",
    "descricao": "Roletes cilíndricos"
  },
  {
    "codigo": "84829130",
    "descricao": "Roletes cônicos"
  },
  {
    "codigo": "84829190",
    "descricao": "Outros"
  },
  {
    "codigo": "84829910",
    "descricao": "Selos, capas e porta-esferas de aço"
  },
  {
    "codigo": "84829990",
    "descricao": "Outras"
  },
  {
    "codigo": "84831011",
    "descricao": "Forjados, de peso igual ou superior a 900 kg e comprimento igual ou superior a 2.000 mm"
  },
  {
    "codigo": "84831019",
    "descricao": "Outros"
  },
  {
    "codigo": "84831020",
    "descricao": "Árvores de cames para comando de válvulas"
  },
  {
    "codigo": "84831030",
    "descricao": "Veios flexíveis"
  },
  {
    "codigo": "84831040",
    "descricao": "Manivelas"
  },
  {
    "codigo": "84831050",
    "descricao": "Árvores de transmissão providas de acoplamentos dentados com entalhes de proteção contra sobrecarga, de comprimento igual ou superior a 1500 mm e diâmetro do eixo igual ou superior a 400 mm"
  },
  {
    "codigo": "84831090",
    "descricao": "Outras"
  },
  {
    "codigo": "84832000",
    "descricao": "- Mancais (chumaceiras) com rolamentos incorporados"
  },
  {
    "codigo": "84833010",
    "descricao": "Montados com \"bronzes\" de metal antifricção"
  },
  {
    "codigo": "84833021",
    "descricao": "De diâmetro interno igual ou superior a 200 mm"
  },
  {
    "codigo": "84833029",
    "descricao": "Outros"
  },
  {
    "codigo": "84833090",
    "descricao": "Outros"
  },
  {
    "codigo": "84834010",
    "descricao": "Redutores, multiplicadores, caixas de transmissão e variadores de velocidade, incluindo os conversores de torque"
  },
  {
    "codigo": "84834090",
    "descricao": "Outros"
  },
  {
    "codigo": "84835010",
    "descricao": "Polias, exceto as de rolamentos reguladoras de tensão"
  },
  {
    "codigo": "84835090",
    "descricao": "Outros"
  },
  {
    "codigo": "84836011",
    "descricao": "De fricção"
  },
  {
    "codigo": "84836019",
    "descricao": "Outras"
  },
  {
    "codigo": "84836090",
    "descricao": "Outros"
  },
  {
    "codigo": "84839000",
    "descricao": "- Rodas dentadas e outros elementos de transmissão apresentados separadamente; partes"
  },
  {
    "codigo": "84841000",
    "descricao": "- Juntas metaloplásticas"
  },
  {
    "codigo": "84842000",
    "descricao": "- Juntas de vedação mecânicas"
  },
  {
    "codigo": "84849000",
    "descricao": "- Outros"
  },
  {
    "codigo": "84851000",
    "descricao": "- Por depósito de metal"
  },
  {
    "codigo": "84852000",
    "descricao": "- Por depósito de plástico ou de borracha"
  },
  {
    "codigo": "84853000",
    "descricao": "- Por depósito de gesso, cimento, cerâmica ou de vidro"
  },
  {
    "codigo": "84858000",
    "descricao": "- Outras"
  },
  {
    "codigo": "84859000",
    "descricao": "- Partes"
  },
  {
    "codigo": "84861000",
    "descricao": "- Máquinas e aparelhos para fabricação de <i>boules</i> ou <i>wa</i><i>fers</i>"
  },
  {
    "codigo": "84862000",
    "descricao": "- Máquinas e aparelhos para fabricação de dispositivos semicondutores ou de circuitos integrados eletrônicos"
  },
  {
    "codigo": "84863000",
    "descricao": "- Máquinas e aparelhos para fabricação de dispositivos de visualização de tela (ecrã*) plana"
  },
  {
    "codigo": "84864000",
    "descricao": "- Máquinas e aparelhos especificados na Nota 11 C) do presente Capítulo"
  },
  {
    "codigo": "84869000",
    "descricao": "- Partes e acessórios"
  },
  {
    "codigo": "84871000",
    "descricao": "- Hélices para embarcações e suas pás"
  },
  {
    "codigo": "84879000",
    "descricao": "- Outras"
  },
  {
    "codigo": "85011011",
    "descricao": "De passo não superior a 1,8°"
  },
  {
    "codigo": "85011019",
    "descricao": "Outros"
  },
  {
    "codigo": "85011021",
    "descricao": "Síncronos"
  },
  {
    "codigo": "85011029",
    "descricao": "Outros"
  },
  {
    "codigo": "85011030",
    "descricao": "Universais"
  },
  {
    "codigo": "85012000",
    "descricao": "- Motores universais de potência superior a 37,5 W"
  },
  {
    "codigo": "85013110",
    "descricao": "Motores"
  },
  {
    "codigo": "85013120",
    "descricao": "Geradores"
  },
  {
    "codigo": "85013210",
    "descricao": "Motores"
  },
  {
    "codigo": "85013220",
    "descricao": "Geradores"
  },
  {
    "codigo": "85013310",
    "descricao": "Motores"
  },
  {
    "codigo": "85013320",
    "descricao": "Geradores"
  },
  {
    "codigo": "85013411",
    "descricao": "De potência não superior a 3.000 kW"
  },
  {
    "codigo": "85013419",
    "descricao": "Outros"
  },
  {
    "codigo": "85013420",
    "descricao": "Geradores"
  },
  {
    "codigo": "85014011",
    "descricao": "Síncronos"
  },
  {
    "codigo": "85014019",
    "descricao": "Outros"
  },
  {
    "codigo": "85014021",
    "descricao": "Síncronos"
  },
  {
    "codigo": "85014029",
    "descricao": "Outros"
  },
  {
    "codigo": "85015110",
    "descricao": "Trifásicos, com rotor de gaiola"
  },
  {
    "codigo": "85015120",
    "descricao": "Trifásicos, com rotor de anéis"
  },
  {
    "codigo": "85015190",
    "descricao": "Outros"
  },
  {
    "codigo": "85015210",
    "descricao": "Trifásicos, com rotor de gaiola"
  },
  {
    "codigo": "85015220",
    "descricao": "Trifásicos, com rotor de anéis"
  },
  {
    "codigo": "85015290",
    "descricao": "Outros"
  },
  {
    "codigo": "85015310",
    "descricao": "Trifásicos, de potência não superior a 7.500 kW"
  },
  {
    "codigo": "85015320",
    "descricao": "Trifásicos, de potência superior a 7.500 kW, mas não superior a 30.000 kW"
  },
  {
    "codigo": "85015330",
    "descricao": "Trifásicos, de potência superior a 30.000 kW, mas não superior a 50.000 kW"
  },
  {
    "codigo": "85015390",
    "descricao": "Outros"
  },
  {
    "codigo": "85016100",
    "descricao": "-- De potência não superior a 75 kVA"
  },
  {
    "codigo": "85016200",
    "descricao": "-- De potência superior a 75 kVA, mas não superior a 375 kVA"
  },
  {
    "codigo": "85016300",
    "descricao": "-- De potência superior a 375 kVA, mas não superior a 750 kVA"
  },
  {
    "codigo": "85016400",
    "descricao": "-- De potência superior a 750 kVA"
  },
  {
    "codigo": "85017100",
    "descricao": "-- De potência não superior a 50 W"
  },
  {
    "codigo": "85017210",
    "descricao": "De potência não superior a 75 kW"
  },
  {
    "codigo": "85017290",
    "descricao": "Outros"
  },
  {
    "codigo": "85018000",
    "descricao": "- Geradores fotovoltaicos de corrente alternada"
  },
  {
    "codigo": "85021110",
    "descricao": "De corrente alternada"
  },
  {
    "codigo": "85021190",
    "descricao": "Outros"
  },
  {
    "codigo": "85021210",
    "descricao": "De corrente alternada"
  },
  {
    "codigo": "85021290",
    "descricao": "Outros"
  },
  {
    "codigo": "85021311",
    "descricao": "De potência não superior a 430 kVA"
  },
  {
    "codigo": "85021319",
    "descricao": "Outros"
  },
  {
    "codigo": "85021390",
    "descricao": "Outros"
  },
  {
    "codigo": "85022011",
    "descricao": "De potência não superior a 210 kVA"
  },
  {
    "codigo": "85022019",
    "descricao": "Outros"
  },
  {
    "codigo": "85022090",
    "descricao": "Outros"
  },
  {
    "codigo": "85023100",
    "descricao": "-- De energia eólica"
  },
  {
    "codigo": "85023900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85024010",
    "descricao": "De frequência"
  },
  {
    "codigo": "85024090",
    "descricao": "Outros"
  },
  {
    "codigo": "85030010",
    "descricao": "De motores ou geradores das subposições 8501.10, 8501.20, 8501.31, 8501.32 ou do item 8501.40.1"
  },
  {
    "codigo": "85030090",
    "descricao": "Outras"
  },
  {
    "codigo": "85041000",
    "descricao": "- Reatores (Balastros*) para lâmpadas ou tubos de descarga"
  },
  {
    "codigo": "85042100",
    "descricao": "-- De potência não superior a 650 kVA"
  },
  {
    "codigo": "85042200",
    "descricao": "-- De potência superior a 650 kVA, mas não superior a 10.000 kVA"
  },
  {
    "codigo": "85042300",
    "descricao": "-- De potência superior a 10.000 kVA"
  },
  {
    "codigo": "85043111",
    "descricao": "Transformadores de corrente"
  },
  {
    "codigo": "85043119",
    "descricao": "Outros"
  },
  {
    "codigo": "85043191",
    "descricao": "Transformador de saída horizontal (<i>fly back</i>), com tensão de saída superior a 18 kV e frequência de varredura horizontal igual ou superior a 32 kHz"
  },
  {
    "codigo": "85043192",
    "descricao": "Transformadores de FI, de detecção, de relação, de linearidade ou de foco"
  },
  {
    "codigo": "85043193",
    "descricao": "Outros, de largura e comprimento não superior a 50 mm e altura não superior a 25 mm, próprios para montagem por inserção (PTH - <i>Pin Through Hole</i>) ou montagem em superfície (SMD - <i>Surface Mounted Device</i>)"
  },
  {
    "codigo": "85043199",
    "descricao": "Outros"
  },
  {
    "codigo": "85043211",
    "descricao": "Para frequências inferiores ou iguais a 60 Hz"
  },
  {
    "codigo": "85043219",
    "descricao": "Outros"
  },
  {
    "codigo": "85043221",
    "descricao": "Para frequências inferiores ou iguais a 60 Hz"
  },
  {
    "codigo": "85043229",
    "descricao": "Outros"
  },
  {
    "codigo": "85043300",
    "descricao": "-- De potência superior a 16 kVA, mas não superior a 500 kVA"
  },
  {
    "codigo": "85043400",
    "descricao": "-- De potência superior a 500 kVA"
  },
  {
    "codigo": "85044010",
    "descricao": "Carregadores de acumuladores"
  },
  {
    "codigo": "85044021",
    "descricao": "De cristal (semicondutores)"
  },
  {
    "codigo": "85044022",
    "descricao": "Eletrolíticos"
  },
  {
    "codigo": "85044029",
    "descricao": "Outros"
  },
  {
    "codigo": "85044030",
    "descricao": "Conversores de corrente contínua"
  },
  {
    "codigo": "85044040",
    "descricao": "Equipamento de alimentação ininterrupta de energia (UPS ou <i>no break</i>)"
  },
  {
    "codigo": "85044050",
    "descricao": "Conversores eletrônicos de frequência, para variação de velocidade de motores elétricos"
  },
  {
    "codigo": "85044060",
    "descricao": "Aparelhos eletrônicos de alimentação de energia do tipo utilizado para iluminação de emergência"
  },
  {
    "codigo": "85044090",
    "descricao": "Outros"
  },
  {
    "codigo": "85045010",
    "descricao": "De largura e comprimento não superior a 45 mm e altura não superior a 30 mm, próprias para montagem por inserção (PTH - <i>Pin Through Hole</i>) ou montagem em superfície (SMD - <i>Surface Mounted Device</i>)"
  },
  {
    "codigo": "85045090",
    "descricao": "Outras"
  },
  {
    "codigo": "85049010",
    "descricao": "Núcleos de pó ferromagnético"
  },
  {
    "codigo": "85049020",
    "descricao": "De reatores para lâmpadas ou tubos de descarga"
  },
  {
    "codigo": "85049030",
    "descricao": "De transformadores das subposições 8504.21, 8504.22, 8504.23, 8504.33 ou 8504.34"
  },
  {
    "codigo": "85049040",
    "descricao": "De conversores estáticos, exceto de carregadores de acumuladores e de retificadores"
  },
  {
    "codigo": "85049090",
    "descricao": "Outras"
  },
  {
    "codigo": "85051100",
    "descricao": "-- De metal"
  },
  {
    "codigo": "85051910",
    "descricao": "De ferrita (cerâmicos)"
  },
  {
    "codigo": "85051990",
    "descricao": "Outros"
  },
  {
    "codigo": "85052010",
    "descricao": "Freios (travões) que atuam por corrente de Foucault, do tipo utilizado nos veículos das posições 87.01 a 87.05"
  },
  {
    "codigo": "85052090",
    "descricao": "Outros"
  },
  {
    "codigo": "85059011",
    "descricao": "Do tipo utilizado em aparelhos de diagnóstico de imagem por ressonância magnética"
  },
  {
    "codigo": "85059019",
    "descricao": "Outros"
  },
  {
    "codigo": "85059080",
    "descricao": "Outros"
  },
  {
    "codigo": "85059090",
    "descricao": "Partes"
  },
  {
    "codigo": "85061011",
    "descricao": "De tensão igual a 1,5 V, cilíndricas, do tipo LR14 (C)"
  },
  {
    "codigo": "85061012",
    "descricao": "De tensão igual a 1,5 V, cilíndricas, do tipo LR20 (D)"
  },
  {
    "codigo": "85061019",
    "descricao": "Outras"
  },
  {
    "codigo": "85061020",
    "descricao": "Outras pilhas"
  },
  {
    "codigo": "85061031",
    "descricao": "Alcalinas, de tensão igual a 9 V"
  },
  {
    "codigo": "85061032",
    "descricao": "Alcalinas, de tensão igual a 12 V"
  },
  {
    "codigo": "85061039",
    "descricao": "Outras"
  },
  {
    "codigo": "85063010",
    "descricao": "Com volume exterior não superior a 300 cm<sup>3</sup>"
  },
  {
    "codigo": "85063090",
    "descricao": "Outras"
  },
  {
    "codigo": "85064010",
    "descricao": "Com volume exterior não superior a 300 cm<sup>3</sup>"
  },
  {
    "codigo": "85064090",
    "descricao": "Outras"
  },
  {
    "codigo": "85065010",
    "descricao": "Com volume exterior não superior a 300 cm<sup>3</sup>"
  },
  {
    "codigo": "85065090",
    "descricao": "Outras"
  },
  {
    "codigo": "85066010",
    "descricao": "Com volume exterior não superior a 300 cm<sup>3</sup>"
  },
  {
    "codigo": "85066090",
    "descricao": "Outras"
  },
  {
    "codigo": "85068010",
    "descricao": "Com volume exterior não superior a 300 cm<sup>3</sup>"
  },
  {
    "codigo": "85068090",
    "descricao": "Outras"
  },
  {
    "codigo": "85069000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85071010",
    "descricao": "De capacidade inferior ou igual a 20 Ah e tensão inferior ou igual a 12 V"
  },
  {
    "codigo": "85071090",
    "descricao": "Outros"
  },
  {
    "codigo": "85072010",
    "descricao": "De peso inferior ou igual a 1.000 kg"
  },
  {
    "codigo": "85072090",
    "descricao": "Outros"
  },
  {
    "codigo": "85073011",
    "descricao": "De capacidade inferior ou igual a 15 Ah"
  },
  {
    "codigo": "85073019",
    "descricao": "Outros"
  },
  {
    "codigo": "85073090",
    "descricao": "Outros"
  },
  {
    "codigo": "85075010",
    "descricao": "De tensão igual a 1,2 V, cilíndricos do tipo HR6 (AA)"
  },
  {
    "codigo": "85075020",
    "descricao": "De tensão igual a 1,2 V, cilíndricos do tipo HR03 (AAA)"
  },
  {
    "codigo": "85075090",
    "descricao": "Outros"
  },
  {
    "codigo": "85076000",
    "descricao": "- De íon de lítio"
  },
  {
    "codigo": "85078000",
    "descricao": "- Outros acumuladores"
  },
  {
    "codigo": "85079010",
    "descricao": "Separadores"
  },
  {
    "codigo": "85079020",
    "descricao": "Recipientes de plástico, suas tampas e tampões"
  },
  {
    "codigo": "85079090",
    "descricao": "Outras"
  },
  {
    "codigo": "85081100",
    "descricao": "-- De potência não superior a 1.500 W e cujo volume do reservatório não exceda 20 l"
  },
  {
    "codigo": "85081900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85086000",
    "descricao": "- Outros aspiradores"
  },
  {
    "codigo": "85087000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85094010",
    "descricao": "Liquidificadores"
  },
  {
    "codigo": "85094020",
    "descricao": "Batedeiras"
  },
  {
    "codigo": "85094030",
    "descricao": "Moedores de carne"
  },
  {
    "codigo": "85094040",
    "descricao": "Extratores centrífugos de sucos"
  },
  {
    "codigo": "85094050",
    "descricao": "Aparelhos de funções múltiplas, providos de acessórios intercambiáveis, para processar alimentos"
  },
  {
    "codigo": "85094090",
    "descricao": "Outros"
  },
  {
    "codigo": "85098010",
    "descricao": "Enceradeiras de pisos"
  },
  {
    "codigo": "85098090",
    "descricao": "Outros"
  },
  {
    "codigo": "85099000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85101000",
    "descricao": "- Aparelhos ou máquinas de barbear"
  },
  {
    "codigo": "85102000",
    "descricao": "- Máquinas de cortar o cabelo ou de tosquiar"
  },
  {
    "codigo": "85103000",
    "descricao": "- Aparelhos de depilar"
  },
  {
    "codigo": "85109011",
    "descricao": "Lâminas"
  },
  {
    "codigo": "85109019",
    "descricao": "Outras"
  },
  {
    "codigo": "85109020",
    "descricao": "Pentes e contrapentes para máquinas de tosquiar"
  },
  {
    "codigo": "85109090",
    "descricao": "Outras"
  },
  {
    "codigo": "85111000",
    "descricao": "- Velas de ignição"
  },
  {
    "codigo": "85112010",
    "descricao": "Magnetos"
  },
  {
    "codigo": "85112090",
    "descricao": "Outros"
  },
  {
    "codigo": "85113010",
    "descricao": "Distribuidores"
  },
  {
    "codigo": "85113020",
    "descricao": "Bobinas de ignição"
  },
  {
    "codigo": "85114000",
    "descricao": "- Motores de arranque, mesmo funcionando como geradores"
  },
  {
    "codigo": "85115010",
    "descricao": "Dínamos e alternadores"
  },
  {
    "codigo": "85115090",
    "descricao": "Outros"
  },
  {
    "codigo": "85118010",
    "descricao": "Velas de aquecimento"
  },
  {
    "codigo": "85118020",
    "descricao": "Reguladores de voltagem (conjuntores-disjuntores)"
  },
  {
    "codigo": "85118030",
    "descricao": "Ignição eletrônica digital"
  },
  {
    "codigo": "85118090",
    "descricao": "Outros"
  },
  {
    "codigo": "85119000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85121000",
    "descricao": "- Aparelhos de iluminação ou de sinalização visual do tipo utilizado em bicicletas"
  },
  {
    "codigo": "85122011",
    "descricao": "Faróis"
  },
  {
    "codigo": "85122019",
    "descricao": "Outros"
  },
  {
    "codigo": "85122021",
    "descricao": "Luzes fixas"
  },
  {
    "codigo": "85122022",
    "descricao": "Luzes indicadoras de manobras"
  },
  {
    "codigo": "85122023",
    "descricao": "Caixas de luzes combinadas"
  },
  {
    "codigo": "85122029",
    "descricao": "Outros"
  },
  {
    "codigo": "85123000",
    "descricao": "- Aparelhos de sinalização acústica"
  },
  {
    "codigo": "85124010",
    "descricao": "Limpadores de para-brisas"
  },
  {
    "codigo": "85124020",
    "descricao": "Degeladores e desembaçadores"
  },
  {
    "codigo": "85129000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85131010",
    "descricao": "Manuais"
  },
  {
    "codigo": "85131090",
    "descricao": "Outras"
  },
  {
    "codigo": "85139000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85141100",
    "descricao": "-- Prensas isostáticas a quente"
  },
  {
    "codigo": "85141900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85142011",
    "descricao": "Industriais"
  },
  {
    "codigo": "85142019",
    "descricao": "Outros"
  },
  {
    "codigo": "85142020",
    "descricao": "Por perdas dielétricas"
  },
  {
    "codigo": "85143100",
    "descricao": "-- Fornos de feixe de elétrons"
  },
  {
    "codigo": "85143200",
    "descricao": "-- Fornos de plasma e fornos de arco a vácuo"
  },
  {
    "codigo": "85143900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85144000",
    "descricao": "- Outros aparelhos para tratamento térmico de matérias por indução ou por perdas dielétricas"
  },
  {
    "codigo": "85149000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85151100",
    "descricao": "-- Ferros e pistolas"
  },
  {
    "codigo": "85151900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85152100",
    "descricao": "-- Inteira ou parcialmente automáticos"
  },
  {
    "codigo": "85152900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85153110",
    "descricao": "Robôs para soldar, por arco, em atmosfera inerte (MIG - <i>Metal Inert Gas</i>) ou atmosfera ativa (MAG - <i>Metal Active Gas</i>), de comando numérico"
  },
  {
    "codigo": "85153190",
    "descricao": "Outros"
  },
  {
    "codigo": "85153900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85158010",
    "descricao": "Para soldar a laser"
  },
  {
    "codigo": "85158090",
    "descricao": "Outros"
  },
  {
    "codigo": "85159000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85161000",
    "descricao": "- Aquecedores elétricos de água, incluindo os de imersão"
  },
  {
    "codigo": "85162100",
    "descricao": "-- Radiadores de acumulação"
  },
  {
    "codigo": "85162900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85163100",
    "descricao": "-- Secadores de cabelo"
  },
  {
    "codigo": "85163200",
    "descricao": "-- Outros aparelhos para arranjos do cabelo"
  },
  {
    "codigo": "85163300",
    "descricao": "-- Aparelhos para secar as mãos"
  },
  {
    "codigo": "85164000",
    "descricao": "- Ferros elétricos de passar"
  },
  {
    "codigo": "85165000",
    "descricao": "- Fornos de micro-ondas"
  },
  {
    "codigo": "85166000",
    "descricao": "- Outros fornos; fogões de cozinha, fogareiros (incluindo as chapas de cocção), grelhas e assadeiras"
  },
  {
    "codigo": "85167100",
    "descricao": "-- Aparelhos para preparação de café ou de chá"
  },
  {
    "codigo": "85167200",
    "descricao": "-- Torradeiras de pão"
  },
  {
    "codigo": "85167910",
    "descricao": "Panelas"
  },
  {
    "codigo": "85167920",
    "descricao": "Fritadoras"
  },
  {
    "codigo": "85167990",
    "descricao": "Outros"
  },
  {
    "codigo": "85168010",
    "descricao": "Para aparelhos da presente posição"
  },
  {
    "codigo": "85168090",
    "descricao": "Outras"
  },
  {
    "codigo": "85169000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85171100",
    "descricao": "-- Aparelhos telefônicos por fio com unidade auscultador-microfone sem fio"
  },
  {
    "codigo": "85171300",
    "descricao": "-- Telefones inteligentes (<i>smartphones</i>)"
  },
  {
    "codigo": "85171410",
    "descricao": "De radiotelefonia, analógicos"
  },
  {
    "codigo": "85171431",
    "descricao": "Portáteis"
  },
  {
    "codigo": "85171432",
    "descricao": "Fixos, sem fonte própria de energia"
  },
  {
    "codigo": "85171439",
    "descricao": "Outros"
  },
  {
    "codigo": "85171441",
    "descricao": "Digitais, operando em banda C, Ku, L ou S"
  },
  {
    "codigo": "85171449",
    "descricao": "Outros"
  },
  {
    "codigo": "85171490",
    "descricao": "Outros"
  },
  {
    "codigo": "85171830",
    "descricao": "Não combinados com outros aparelhos"
  },
  {
    "codigo": "85171890",
    "descricao": "Outros"
  },
  {
    "codigo": "85176130",
    "descricao": "De telefonia celular"
  },
  {
    "codigo": "85176141",
    "descricao": "Principal terrena fixa, sem conjunto antena-refletor"
  },
  {
    "codigo": "85176142",
    "descricao": "VSAT (<i>Very Small Aperture Terminal</i>), sem conjunto antena-refletor"
  },
  {
    "codigo": "85176143",
    "descricao": "Digitais, operando em banda C, Ku, L ou S"
  },
  {
    "codigo": "85176149",
    "descricao": "Outras"
  },
  {
    "codigo": "85176191",
    "descricao": "Digitais, de frequência igual ou superior a 15 GHz e inferior ou igual a 23 GHz e taxa de transmissão inferior ou igual a 8 Mbit/s"
  },
  {
    "codigo": "85176192",
    "descricao": "Digitais, de frequência superior a 23 GHz"
  },
  {
    "codigo": "85176199",
    "descricao": "Outras"
  },
  {
    "codigo": "85176214",
    "descricao": "Concentradores de linhas de assinantes (terminais de central ou terminal remoto)"
  },
  {
    "codigo": "85176215",
    "descricao": "Multiplexadores"
  },
  {
    "codigo": "85176221",
    "descricao": "Centrais automáticas públicas, incluindo as de trânsito"
  },
  {
    "codigo": "85176229",
    "descricao": "Outros"
  },
  {
    "codigo": "85176234",
    "descricao": "Aparelhos para comutação de pacotes de dados (<i>switches</i>)"
  },
  {
    "codigo": "85176239",
    "descricao": "Outros"
  },
  {
    "codigo": "85176241",
    "descricao": "Com capacidade de conexão sem fio"
  },
  {
    "codigo": "85176249",
    "descricao": "Outros"
  },
  {
    "codigo": "85176251",
    "descricao": "Terminais ou repetidores sobre linhas metálicas"
  },
  {
    "codigo": "85176252",
    "descricao": "Terminais ou repetidores sobre linhas de fibras ópticas, com velocidade de transmissão superior a 2,5 Gbit/s"
  },
  {
    "codigo": "85176253",
    "descricao": "Terminais de texto que operem com código de transmissão Baudot, providos de teclado alfanumérico e visor, mesmo com telefone incorporado"
  },
  {
    "codigo": "85176254",
    "descricao": "Distribuidores de conexões para redes (<i>hubs</i>)"
  },
  {
    "codigo": "85176255",
    "descricao": "Moduladores-demoduladores (<i>modems</i>)"
  },
  {
    "codigo": "85176256",
    "descricao": "Interfones"
  },
  {
    "codigo": "85176259",
    "descricao": "Outros"
  },
  {
    "codigo": "85176262",
    "descricao": "De tecnologia celular"
  },
  {
    "codigo": "85176264",
    "descricao": "Por satélite, digitais, operando em banda C, Ku, L ou S"
  },
  {
    "codigo": "85176265",
    "descricao": "Outros, por satélite"
  },
  {
    "codigo": "85176272",
    "descricao": "De frequência inferior a 15 GHz e de taxa de transmissão inferior ou igual a 34 Mbit/s, exceto os interfones"
  },
  {
    "codigo": "85176273",
    "descricao": "Interfones"
  },
  {
    "codigo": "85176277",
    "descricao": "Outros, de frequência inferior a 15 GHz"
  },
  {
    "codigo": "85176278",
    "descricao": "De frequência igual ou superior a 15 GHz, mas inferior ou igual a 23 GHz e taxa de transmissão inferior ou igual a 8 Mbit/s"
  },
  {
    "codigo": "85176279",
    "descricao": "Outros"
  },
  {
    "codigo": "85176291",
    "descricao": "Aparelhos transmissores (emissores)"
  },
  {
    "codigo": "85176294",
    "descricao": "Tradutores (conversores) de protocolos para interconexão de redes (<i>gateways</i>)"
  },
  {
    "codigo": "85176296",
    "descricao": "Outros, analógicos"
  },
  {
    "codigo": "85176299",
    "descricao": "Outros"
  },
  {
    "codigo": "85176900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85177110",
    "descricao": "Antenas próprias para telefones celulares portáteis"
  },
  {
    "codigo": "85177120",
    "descricao": "Antenas próprias para estações-base de telefonia celular"
  },
  {
    "codigo": "85177190",
    "descricao": "Outras"
  },
  {
    "codigo": "85177900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "85181010",
    "descricao": "Piezelétricos próprios para aparelhos telefônicos"
  },
  {
    "codigo": "85181090",
    "descricao": "Outros"
  },
  {
    "codigo": "85182100",
    "descricao": "-- Alto-falante (altifalante) único montado na sua caixa (coluna)"
  },
  {
    "codigo": "85182200",
    "descricao": "-- Alto-falantes (altifalantes) múltiplos montados na mesma caixa (coluna)"
  },
  {
    "codigo": "85182910",
    "descricao": "Piezelétricos próprios para aparelhos telefônicos"
  },
  {
    "codigo": "85182990",
    "descricao": "Outros"
  },
  {
    "codigo": "85183000",
    "descricao": "- Fones de ouvido (Auscultadores e auriculares*), mesmo combinados com um microfone, e conjuntos ou sortidos constituídos por um microfone e um ou mais alto-falantes (altifalantes)"
  },
  {
    "codigo": "85184000",
    "descricao": "- Amplificadores elétricos de audiofrequência"
  },
  {
    "codigo": "85185000",
    "descricao": "- Aparelhos elétricos de amplificação de som"
  },
  {
    "codigo": "85189010",
    "descricao": "De alto-falantes (altifalantes)"
  },
  {
    "codigo": "85189090",
    "descricao": "Outras"
  },
  {
    "codigo": "85192000",
    "descricao": "- Aparelhos que funcionem por introdução de moedas, notas (papéis-moeda), cartões de banco, fichas ou por outros meios de pagamento"
  },
  {
    "codigo": "85193000",
    "descricao": "- Pratos de toca-discos (gira-discos*)"
  },
  {
    "codigo": "85198110",
    "descricao": "Com sistema de leitura óptica por laser (leitores de discos compactos)"
  },
  {
    "codigo": "85198120",
    "descricao": "Gravadores de som de cabinas de aeronaves"
  },
  {
    "codigo": "85198190",
    "descricao": "Outros"
  },
  {
    "codigo": "85198900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85211010",
    "descricao": "Gravador-reprodutor, sem sintonizador"
  },
  {
    "codigo": "85211081",
    "descricao": "Em cassete, de largura de fita igual a 12,65 mm (1/2'')"
  },
  {
    "codigo": "85211089",
    "descricao": "Outros"
  },
  {
    "codigo": "85211090",
    "descricao": "Outros, para fitas de largura igual ou superior a 19,05 mm (3/4'')"
  },
  {
    "codigo": "85219000",
    "descricao": "- Outros"
  },
  {
    "codigo": "85221000",
    "descricao": "- Fonocaptores"
  },
  {
    "codigo": "85229000",
    "descricao": "- Outros"
  },
  {
    "codigo": "85232110",
    "descricao": "Não gravados"
  },
  {
    "codigo": "85232120",
    "descricao": "Gravados"
  },
  {
    "codigo": "85232911",
    "descricao": "Do tipo utilizado em unidades de discos rígidos"
  },
  {
    "codigo": "85232919",
    "descricao": "Outros"
  },
  {
    "codigo": "85232990",
    "descricao": "Outros"
  },
  {
    "codigo": "85234110",
    "descricao": "Discos para sistema de leitura por raios laser com possibilidade de serem gravados uma única vez"
  },
  {
    "codigo": "85234190",
    "descricao": "Outros"
  },
  {
    "codigo": "85234910",
    "descricao": "Para reprodução apenas do som"
  },
  {
    "codigo": "85234920",
    "descricao": "Para reprodução de fenômenos diferentes do som ou da imagem"
  },
  {
    "codigo": "85234990",
    "descricao": "Outros"
  },
  {
    "codigo": "85235110",
    "descricao": "Cartões de memória (<i>memory cards</i>)"
  },
  {
    "codigo": "85235190",
    "descricao": "Outros"
  },
  {
    "codigo": "85235210",
    "descricao": "Cartões e etiquetas de acionamento por aproximação"
  },
  {
    "codigo": "85235290",
    "descricao": "Outros"
  },
  {
    "codigo": "85235900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85238000",
    "descricao": "- Outros"
  },
  {
    "codigo": "85241100",
    "descricao": "-- De cristais líquidos"
  },
  {
    "codigo": "85241200",
    "descricao": "-- De diodos emissores de luz orgânicos (OLED)"
  },
  {
    "codigo": "85241900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85249100",
    "descricao": "-- De cristais líquidos"
  },
  {
    "codigo": "85249200",
    "descricao": "-- De diodos emissores de luz orgânicos (OLED)"
  },
  {
    "codigo": "85249900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85255011",
    "descricao": "Em AM, com modulação por código ou largura de pulso, totalmente a semicondutor e com potência de saída superior a 10 kW"
  },
  {
    "codigo": "85255019",
    "descricao": "Outros"
  },
  {
    "codigo": "85255021",
    "descricao": "De frequência superior a 7 GHz"
  },
  {
    "codigo": "85255022",
    "descricao": "Em banda UHF, de frequência igual ou superior a 2,0 GHz, mas não superior a 2,7 GHz, com potência de saída igual ou superior a 10 W, mas não superior a 100 W"
  },
  {
    "codigo": "85255023",
    "descricao": "Em banda UHF, com potência de saída superior a 10 kW"
  },
  {
    "codigo": "85255024",
    "descricao": "Em banda VHF, com potência de saída igual ou superior a 20 kW"
  },
  {
    "codigo": "85255029",
    "descricao": "Outros"
  },
  {
    "codigo": "85256010",
    "descricao": "De radiodifusão"
  },
  {
    "codigo": "85256020",
    "descricao": "De televisão, de frequência superior a 7 GHz"
  },
  {
    "codigo": "85256090",
    "descricao": "Outros"
  },
  {
    "codigo": "85258100",
    "descricao": "-- Ultrarrápidas, mencionadas na Nota de subposições 1 do presente Capítulo"
  },
  {
    "codigo": "85258200",
    "descricao": "-- Outras, resistentes à radiação, mencionadas na Nota de subposições 2 do presente Capítulo"
  },
  {
    "codigo": "85258300",
    "descricao": "-- Outras, de visão noturna, mencionadas na Nota de subposições 3 do presente Capítulo"
  },
  {
    "codigo": "85258911",
    "descricao": "Com três ou mais captadores de imagem"
  },
  {
    "codigo": "85258912",
    "descricao": "Com sensor de imagem a semicondutor tipo CCD, de mais de 490 x 580 elementos de imagem (<i>pixels</i>) ativos, sensíveis a intensidades de iluminação inferiores a 0,20 lux"
  },
  {
    "codigo": "85258913",
    "descricao": "Com sensor de imagem a semicondutor tipo CMOS, de mais de 490 x 580 elementos de imagem (<i>pixels</i>) ativos, sensíveis a intensidades de iluminação inferiores a 0,20 lux"
  },
  {
    "codigo": "85258914",
    "descricao": "Outras, próprias para captar imagens exclusivamente no espectro infravermelho de comprimento de onda igual ou superior a 2 micrômetros (mícrons), mas não superior a 14 micrômetros (mícrons)"
  },
  {
    "codigo": "85258919",
    "descricao": "Outras"
  },
  {
    "codigo": "85258921",
    "descricao": "Com três ou mais captadores de imagem"
  },
  {
    "codigo": "85258922",
    "descricao": "Outras, próprias para captar imagens exclusivamente no espectro infravermelho de comprimento de onda igual ou superior a 2 micrômetros (mícrons), mas não superior a 14 micrômetros (mícrons)"
  },
  {
    "codigo": "85258929",
    "descricao": "Outras"
  },
  {
    "codigo": "85261000",
    "descricao": "- Aparelhos de radiodetecção e de radiossondagem (radar)"
  },
  {
    "codigo": "85269100",
    "descricao": "-- Aparelhos de radionavegação"
  },
  {
    "codigo": "85269200",
    "descricao": "-- Aparelhos de radiotelecomando"
  },
  {
    "codigo": "85271200",
    "descricao": "-- Rádios toca-fitas (Rádios-leitores de cassetes*) de bolso"
  },
  {
    "codigo": "85271300",
    "descricao": "-- Outros aparelhos combinados com um aparelho de gravação ou de reprodução de som"
  },
  {
    "codigo": "85271900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85272100",
    "descricao": "-- Combinados com um aparelho de gravação ou de reprodução de som"
  },
  {
    "codigo": "85272900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85279100",
    "descricao": "-- Combinados com um aparelho de gravação ou de reprodução de som"
  },
  {
    "codigo": "85279200",
    "descricao": "-- Não combinados com um aparelho de gravação ou de reprodução de som, mas combinados com um relógio"
  },
  {
    "codigo": "85279910",
    "descricao": "Amplificador com sintonizador (<i>receiver</i>)"
  },
  {
    "codigo": "85279990",
    "descricao": "Outros"
  },
  {
    "codigo": "85284200",
    "descricao": "-- Capazes de serem conectados diretamente a uma máquina automática para processamento de dados da posição 84.71 e concebidos para serem utilizados com esta máquina"
  },
  {
    "codigo": "85284930",
    "descricao": "Policromáticos, com dispositivos de seleção de varredura (<i>underscanning</i>) e de retardo de sincronismo horizontal e vertical (<i>H/V delay</i> ou <i>pulse cross</i>)"
  },
  {
    "codigo": "85284990",
    "descricao": "Outros"
  },
  {
    "codigo": "85285200",
    "descricao": "-- Capazes de serem conectados diretamente a uma máquina automática para processamento de dados da posição 84.71 e concebidos para serem utilizados com esta máquina"
  },
  {
    "codigo": "85285900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85286200",
    "descricao": "-- Capazes de serem conectados diretamente a uma máquina automática para processamento de dados da posição 84.71 e concebidos para serem utilizados com esta máquina"
  },
  {
    "codigo": "85286910",
    "descricao": "Com tecnologia de dispositivo digital de microespelhos (DMD - <i>Digital Micromirror Device</i>)"
  },
  {
    "codigo": "85286990",
    "descricao": "Outros"
  },
  {
    "codigo": "85287111",
    "descricao": "Sem saída de radiofrequência (RF) modulada nos canais 3 ou 4, com saídas de áudio balanceadas com impedância de 600 Ohms, próprio para montagem em <i>racks</i> e com saída de vídeo com conector BNC"
  },
  {
    "codigo": "85287119",
    "descricao": "Outros"
  },
  {
    "codigo": "85287190",
    "descricao": "Outros"
  },
  {
    "codigo": "85287200",
    "descricao": "-- Outros, a cores"
  },
  {
    "codigo": "85287300",
    "descricao": "-- Outros, a preto e branco ou outros monocromos"
  },
  {
    "codigo": "85291020",
    "descricao": "Antenas com refletor parabólico"
  },
  {
    "codigo": "85291090",
    "descricao": "Outros"
  },
  {
    "codigo": "85299011",
    "descricao": "Gabinetes e bastidores"
  },
  {
    "codigo": "85299012",
    "descricao": "Circuitos impressos com componentes elétricos ou eletrônicos, montados"
  },
  {
    "codigo": "85299019",
    "descricao": "Outras"
  },
  {
    "codigo": "85299020",
    "descricao": "De aparelhos das posições 85.27 ou 85.28"
  },
  {
    "codigo": "85299030",
    "descricao": "De aparelhos da subposição 8526.10"
  },
  {
    "codigo": "85299040",
    "descricao": "De aparelhos da subposição 8526.91"
  },
  {
    "codigo": "85299050",
    "descricao": "De módulos de visualização da posição 85.24"
  },
  {
    "codigo": "85299090",
    "descricao": "Outras"
  },
  {
    "codigo": "85301010",
    "descricao": "Digitais, para controle de tráfego"
  },
  {
    "codigo": "85301090",
    "descricao": "Outros"
  },
  {
    "codigo": "85308010",
    "descricao": "Digitais, para controle de tráfego de automotores"
  },
  {
    "codigo": "85308090",
    "descricao": "Outros"
  },
  {
    "codigo": "85309000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85311010",
    "descricao": "Alarmes contra incêndio ou sobreaquecimento"
  },
  {
    "codigo": "85311090",
    "descricao": "Outros"
  },
  {
    "codigo": "85312000",
    "descricao": "- Painéis indicadores com dispositivos de cristais líquidos (LCD) ou de diodos emissores de luz (LED)"
  },
  {
    "codigo": "85318000",
    "descricao": "- Outros aparelhos"
  },
  {
    "codigo": "85319000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85321000",
    "descricao": "- Condensadores fixos concebidos para linhas elétricas de 50/60 Hz e capazes de absorver uma potência reativa igual ou superior a 0,5 kvar (condensadores de potência)"
  },
  {
    "codigo": "85322111",
    "descricao": "Com tensão de isolação inferior ou igual a 125 V"
  },
  {
    "codigo": "85322119",
    "descricao": "Outros"
  },
  {
    "codigo": "85322120",
    "descricao": "Próprios para montagem por inserção (PTH - <i>Pin Through Hole</i>)"
  },
  {
    "codigo": "85322190",
    "descricao": "Outros"
  },
  {
    "codigo": "85322200",
    "descricao": "-- Eletrolíticos de alumínio"
  },
  {
    "codigo": "85322310",
    "descricao": "Próprios para montagem em superfície (SMD - <i>Surface Mounted Device</i>)"
  },
  {
    "codigo": "85322390",
    "descricao": "Outros"
  },
  {
    "codigo": "85322410",
    "descricao": "Próprios para montagem em superfície (SMD - <i>Surface Mounted Device</i>)"
  },
  {
    "codigo": "85322420",
    "descricao": "Próprios para montagem por inserção (PTH - <i>Pin Through Hole</i>)"
  },
  {
    "codigo": "85322490",
    "descricao": "Outros"
  },
  {
    "codigo": "85322510",
    "descricao": "Próprios para montagem em superfície (SMD - <i>Surface Mounted Device</i>)"
  },
  {
    "codigo": "85322590",
    "descricao": "Outros"
  },
  {
    "codigo": "85322910",
    "descricao": "Próprios para montagem em superfície (SMD - <i>Surface Mounted Device</i>)"
  },
  {
    "codigo": "85322990",
    "descricao": "Outros"
  },
  {
    "codigo": "85323010",
    "descricao": "Próprios para montagem em superfície (SMD - <i>Surface Mounted Device</i>)"
  },
  {
    "codigo": "85323090",
    "descricao": "Outros"
  },
  {
    "codigo": "85329000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85331000",
    "descricao": "- Resistências fixas de carbono, aglomeradas ou de camada"
  },
  {
    "codigo": "85332110",
    "descricao": "De fio"
  },
  {
    "codigo": "85332120",
    "descricao": "Próprias para montagem em superfície (SMD - <i>Surface Mounted Device</i>)"
  },
  {
    "codigo": "85332190",
    "descricao": "Outras"
  },
  {
    "codigo": "85332900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "85333110",
    "descricao": "Potenciômetros"
  },
  {
    "codigo": "85333190",
    "descricao": "Outras"
  },
  {
    "codigo": "85333910",
    "descricao": "Potenciômetros"
  },
  {
    "codigo": "85333990",
    "descricao": "Outras"
  },
  {
    "codigo": "85334011",
    "descricao": "Termistores"
  },
  {
    "codigo": "85334012",
    "descricao": "Varistores para uma tensão inferior ou igual a 1.000 V"
  },
  {
    "codigo": "85334013",
    "descricao": "Outros varistores"
  },
  {
    "codigo": "85334019",
    "descricao": "Outras"
  },
  {
    "codigo": "85334091",
    "descricao": "Potenciômetro de carvão, do tipo utilizado para determinar o ângulo de abertura da borboleta, em sistemas de injeção de combustível controlados eletronicamente"
  },
  {
    "codigo": "85334092",
    "descricao": "Outros potenciômetros de carvão"
  },
  {
    "codigo": "85334099",
    "descricao": "Outras"
  },
  {
    "codigo": "85339000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85340011",
    "descricao": "Com isolante de resina fenólica e papel celulósico"
  },
  {
    "codigo": "85340012",
    "descricao": "Com isolante de resina epóxida e papel celulósico"
  },
  {
    "codigo": "85340013",
    "descricao": "Com isolante de resina epóxida e tecido de fibra de vidro"
  },
  {
    "codigo": "85340019",
    "descricao": "Outros"
  },
  {
    "codigo": "85340020",
    "descricao": "Simples face, flexíveis"
  },
  {
    "codigo": "85340031",
    "descricao": "Com isolante de resina fenólica e papel celulósico"
  },
  {
    "codigo": "85340032",
    "descricao": "Com isolante de resina epóxida e papel celulósico"
  },
  {
    "codigo": "85340033",
    "descricao": "Com isolante de resina epóxida e tecido de fibra de vidro"
  },
  {
    "codigo": "85340039",
    "descricao": "Outros"
  },
  {
    "codigo": "85340040",
    "descricao": "Dupla face, flexíveis"
  },
  {
    "codigo": "85340051",
    "descricao": "Com isolante de resina epóxida e tecido de fibra de vidro"
  },
  {
    "codigo": "85340059",
    "descricao": "Outros"
  },
  {
    "codigo": "85351000",
    "descricao": "- Fusíveis e corta-circuitos de fusíveis"
  },
  {
    "codigo": "85352100",
    "descricao": "-- Para uma tensão inferior a 72,5 kV"
  },
  {
    "codigo": "85352900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85353013",
    "descricao": "Interruptores a vácuo, sem dispositivo de acionamento (ampolas a vácuo)"
  },
  {
    "codigo": "85353017",
    "descricao": "Outros, com dispositivo de acionamento não automático"
  },
  {
    "codigo": "85353018",
    "descricao": "Outros, com dispositivo de acionamento automático, exceto os de contatos imersos em meio líquido"
  },
  {
    "codigo": "85353019",
    "descricao": "Outros"
  },
  {
    "codigo": "85353023",
    "descricao": "Interruptores a vácuo, sem dispositivo de acionamento (ampolas a vácuo)"
  },
  {
    "codigo": "85353027",
    "descricao": "Outros, com dispositivo de acionamento não automático"
  },
  {
    "codigo": "85353028",
    "descricao": "Outros, com dispositivo de acionamento automático, exceto os de contatos imersos em meio líquido"
  },
  {
    "codigo": "85353029",
    "descricao": "Outros"
  },
  {
    "codigo": "85354010",
    "descricao": "Para-raios para proteção de linhas de transmissão de eletricidade"
  },
  {
    "codigo": "85354090",
    "descricao": "Outros"
  },
  {
    "codigo": "85359010",
    "descricao": "Comutadores com ampolas a vácuo, sem interrupção de circulação de corrente durante a comutação, para uma corrente nominal igual ou superior a 100 A"
  },
  {
    "codigo": "85359090",
    "descricao": "Outros"
  },
  {
    "codigo": "85361000",
    "descricao": "- Fusíveis e corta-circuitos de fusíveis"
  },
  {
    "codigo": "85362000",
    "descricao": "- Disjuntores"
  },
  {
    "codigo": "85363010",
    "descricao": "Centelhador a gás"
  },
  {
    "codigo": "85363090",
    "descricao": "Outros"
  },
  {
    "codigo": "85364100",
    "descricao": "-- Para uma tensão não superior a 60 V"
  },
  {
    "codigo": "85364900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85365010",
    "descricao": "Unidade chaveadora de conversor de subida e descida para sistema de telecomunicações via satélite"
  },
  {
    "codigo": "85365020",
    "descricao": "Unidade chaveadora de amplificador de alta potência (HPA) para sistema de telecomunicações via satélite"
  },
  {
    "codigo": "85365030",
    "descricao": "Comutadores codificadores digitais, próprios para montagem em circuitos impressos"
  },
  {
    "codigo": "85365090",
    "descricao": "Outros"
  },
  {
    "codigo": "85366100",
    "descricao": "-- Suportes para lâmpadas"
  },
  {
    "codigo": "85366910",
    "descricao": "Tomada polarizada e tomada blindada"
  },
  {
    "codigo": "85366990",
    "descricao": "Outros"
  },
  {
    "codigo": "85367000",
    "descricao": "- Conectores para fibras ópticas, feixes ou cabos de fibras ópticas"
  },
  {
    "codigo": "85369010",
    "descricao": "Conectores para cabos planos constituídos por condutores paralelos isolados individualmente"
  },
  {
    "codigo": "85369020",
    "descricao": "Tomadas de contato deslizante em condutores aéreos"
  },
  {
    "codigo": "85369030",
    "descricao": "Soquetes para microestruturas eletrônicas"
  },
  {
    "codigo": "85369040",
    "descricao": "Conectores para circuito impresso"
  },
  {
    "codigo": "85369050",
    "descricao": "Terminais de conexão para condensadores, mesmo montados em suporte isolante"
  },
  {
    "codigo": "85369060",
    "descricao": "Conector de corrente elétrica para acoplamento através da carcaça, do tipo utilizado em motocompressores herméticos de refrigeração"
  },
  {
    "codigo": "85369090",
    "descricao": "Outros"
  },
  {
    "codigo": "85371011",
    "descricao": "Com processador e barramento de 32 bits ou superior, incorporando recursos gráficos e execução de macros, resolução inferior ou igual a 1 micrômetro (mícron) e capacidade de conexão digital para servo-acionamento, com monitor policromático"
  },
  {
    "codigo": "85371019",
    "descricao": "Outros"
  },
  {
    "codigo": "85371020",
    "descricao": "Controladores programáveis"
  },
  {
    "codigo": "85371030",
    "descricao": "Controladores de demanda de energia elétrica"
  },
  {
    "codigo": "85371090",
    "descricao": "Outros"
  },
  {
    "codigo": "85372010",
    "descricao": "Subestações isoladas a gás (GIS - <i>Gas-Insulated Switchgear</i> ou HIS - <i>Highly Integrated Switchgear</i>), para uma tensão superior a 52 kV"
  },
  {
    "codigo": "85372090",
    "descricao": "Outros"
  },
  {
    "codigo": "85381000",
    "descricao": "- Quadros, painéis, consoles, cabinas, armários e outros suportes, da posição 85.37, desprovidos dos seus aparelhos"
  },
  {
    "codigo": "85389010",
    "descricao": "Circuitos impressos com componentes elétricos ou eletrônicos, montados"
  },
  {
    "codigo": "85389020",
    "descricao": "De disjuntores, para uma tensão igual ou superior a 72,5 kV"
  },
  {
    "codigo": "85389090",
    "descricao": "Outras"
  },
  {
    "codigo": "85391010",
    "descricao": "Para uma tensão inferior ou igual a 15 V"
  },
  {
    "codigo": "85391090",
    "descricao": "Outros"
  },
  {
    "codigo": "85392110",
    "descricao": "Para uma tensão inferior ou igual a 15 V"
  },
  {
    "codigo": "85392190",
    "descricao": "Outros"
  },
  {
    "codigo": "85392200",
    "descricao": "-- Outros, de potência não superior a 200 W e uma tensão superior a 100 V"
  },
  {
    "codigo": "85392910",
    "descricao": "Para uma tensão inferior ou igual a 15 V"
  },
  {
    "codigo": "85392990",
    "descricao": "Outros"
  },
  {
    "codigo": "85393111",
    "descricao": "Que contenham mais de 5 mg de mercúrio por cada invólucro (tubo)"
  },
  {
    "codigo": "85393119",
    "descricao": "Outras"
  },
  {
    "codigo": "85393120",
    "descricao": "Outras lâmpadas"
  },
  {
    "codigo": "85393131",
    "descricao": "Com fósforo tribanda e que contenham mais de 5 mg de mercúrio"
  },
  {
    "codigo": "85393132",
    "descricao": "Com fósforo em halofosfato e que contenham mais de 10 mg de mercúrio"
  },
  {
    "codigo": "85393139",
    "descricao": "Outros"
  },
  {
    "codigo": "85393210",
    "descricao": "De vapor de mercúrio"
  },
  {
    "codigo": "85393220",
    "descricao": "De vapor de sódio"
  },
  {
    "codigo": "85393230",
    "descricao": "De halogeneto metálico"
  },
  {
    "codigo": "85393911",
    "descricao": "De comprimento não superior a 500 mm e que contenham mais de 3,5 mg de mercúrio"
  },
  {
    "codigo": "85393912",
    "descricao": "De comprimento superior a 500 mm, mas não superior a 1.500 mm e que contenham mais de 5 mg de mercúrio"
  },
  {
    "codigo": "85393913",
    "descricao": "De comprimento superior a 1.500 mm e que contenham mais de 13 mg de mercúrio"
  },
  {
    "codigo": "85393919",
    "descricao": "Outros"
  },
  {
    "codigo": "85393990",
    "descricao": "Outros"
  },
  {
    "codigo": "85394110",
    "descricao": "De potência igual ou superior a 1.000 W"
  },
  {
    "codigo": "85394190",
    "descricao": "Outras"
  },
  {
    "codigo": "85394900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85395100",
    "descricao": "-- Módulos de diodos emissores de luz (LED)"
  },
  {
    "codigo": "85395200",
    "descricao": "-- Lâmpadas e tubos de diodos emissores de luz (LED)"
  },
  {
    "codigo": "85399010",
    "descricao": "Eletrodos"
  },
  {
    "codigo": "85399020",
    "descricao": "Bases"
  },
  {
    "codigo": "85399090",
    "descricao": "Outras"
  },
  {
    "codigo": "85401100",
    "descricao": "-- A cores"
  },
  {
    "codigo": "85401200",
    "descricao": "-- A preto e branco ou outros monocromos"
  },
  {
    "codigo": "85402011",
    "descricao": "A preto e branco ou outros monocromos"
  },
  {
    "codigo": "85402019",
    "descricao": "Outros"
  },
  {
    "codigo": "85402020",
    "descricao": "Tubos conversores ou intensificadores de imagens, de raios X"
  },
  {
    "codigo": "85402090",
    "descricao": "Outros"
  },
  {
    "codigo": "85404000",
    "descricao": "- Tubos de visualização de dados gráficos, em monocromos; tubos de visualização de dados gráficos, a cores, com uma tela (ecrã*) fosfórica de espaçamento entre os pontos inferior a 0,4 mm"
  },
  {
    "codigo": "85406010",
    "descricao": "Tubos de visualização de dados gráficos, em cores, com uma tela de espaçamento entre os pontos igual ou superior a 0,4 mm"
  },
  {
    "codigo": "85406090",
    "descricao": "Outros"
  },
  {
    "codigo": "85407100",
    "descricao": "-- Magnétrons"
  },
  {
    "codigo": "85407900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85408100",
    "descricao": "-- Tubos de recepção ou de amplificação"
  },
  {
    "codigo": "85408910",
    "descricao": "Válvulas de potência para transmissores"
  },
  {
    "codigo": "85408990",
    "descricao": "Outros"
  },
  {
    "codigo": "85409110",
    "descricao": "Bobinas de deflexão (<i>yokes</i>)"
  },
  {
    "codigo": "85409120",
    "descricao": "Núcleos de pó ferromagnético para bobinas de deflexão (<i>yokes</i>)"
  },
  {
    "codigo": "85409130",
    "descricao": "Canhões eletrônicos"
  },
  {
    "codigo": "85409140",
    "descricao": "Painel de vidro, máscara de sombra e blindagem interna, reunidos, para tubos tricromáticos"
  },
  {
    "codigo": "85409190",
    "descricao": "Outras"
  },
  {
    "codigo": "85409900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "85411011",
    "descricao": "Zener"
  },
  {
    "codigo": "85411012",
    "descricao": "Outros, de intensidade de corrente inferior ou igual a 3 A"
  },
  {
    "codigo": "85411019",
    "descricao": "Outros"
  },
  {
    "codigo": "85411021",
    "descricao": "Zener"
  },
  {
    "codigo": "85411022",
    "descricao": "Outros, de intensidade de corrente inferior ou igual a 3 A"
  },
  {
    "codigo": "85411029",
    "descricao": "Outros"
  },
  {
    "codigo": "85411031",
    "descricao": "Zener"
  },
  {
    "codigo": "85411032",
    "descricao": "Outros, de intensidade de corrente inferior ou igual a 3 A"
  },
  {
    "codigo": "85411039",
    "descricao": "Outros"
  },
  {
    "codigo": "85411091",
    "descricao": "Zener"
  },
  {
    "codigo": "85411092",
    "descricao": "Outros, de intensidade de corrente inferior ou igual a 3 A"
  },
  {
    "codigo": "85411099",
    "descricao": "Outros"
  },
  {
    "codigo": "85412110",
    "descricao": "Não montados"
  },
  {
    "codigo": "85412120",
    "descricao": "Montados, próprios para montagem em superfície (SMD - <i>Surface Mounted Device</i>)"
  },
  {
    "codigo": "85412191",
    "descricao": "De efeito de campo, com junção heterogênea (HJFET ou HEMT)"
  },
  {
    "codigo": "85412199",
    "descricao": "Outros"
  },
  {
    "codigo": "85412910",
    "descricao": "Não montados"
  },
  {
    "codigo": "85412920",
    "descricao": "Montados"
  },
  {
    "codigo": "85413011",
    "descricao": "De intensidade de corrente inferior ou igual a 3 A"
  },
  {
    "codigo": "85413019",
    "descricao": "Outros"
  },
  {
    "codigo": "85413021",
    "descricao": "De intensidade de corrente inferior ou igual a 3 A"
  },
  {
    "codigo": "85413029",
    "descricao": "Outros"
  },
  {
    "codigo": "85414111",
    "descricao": "Diodos emissores de luz (LED), exceto diodos laser"
  },
  {
    "codigo": "85414112",
    "descricao": "Diodos laser"
  },
  {
    "codigo": "85414121",
    "descricao": "Diodos emissores de luz (LED), exceto diodos laser, próprios para montagem em superfície (SMD - <i>Surface Mounted Device</i>)"
  },
  {
    "codigo": "85414122",
    "descricao": "Outros diodos emissores de luz (LED), exceto diodos laser"
  },
  {
    "codigo": "85414123",
    "descricao": "Diodos laser com comprimento de onda de 1.300 nm ou 1.500 nm"
  },
  {
    "codigo": "85414124",
    "descricao": "Outros diodos laser"
  },
  {
    "codigo": "85414210",
    "descricao": "Células solares orgânicas"
  },
  {
    "codigo": "85414220",
    "descricao": "Outras células solares"
  },
  {
    "codigo": "85414290",
    "descricao": "Outras"
  },
  {
    "codigo": "85414300",
    "descricao": "-- Células fotovoltaicas montadas em módulos ou em painéis"
  },
  {
    "codigo": "85414900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85415100",
    "descricao": "-- Transdutores à base de semicondutores"
  },
  {
    "codigo": "85415900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85416010",
    "descricao": "De quartzo, de frequência igual ou superior a 1 MHz, mas não superior a 100 MHz"
  },
  {
    "codigo": "85416090",
    "descricao": "Outros"
  },
  {
    "codigo": "85419010",
    "descricao": "Suportes-conectores apresentados em tiras (<i>lead frames</i>)"
  },
  {
    "codigo": "85419020",
    "descricao": "Coberturas para encapsulamento (cápsulas)"
  },
  {
    "codigo": "85419090",
    "descricao": "Outras"
  },
  {
    "codigo": "85423110",
    "descricao": "Não montados"
  },
  {
    "codigo": "85423120",
    "descricao": "Montados, próprios para montagem em superfície (SMD - <i>Surface Mounted Device</i>)"
  },
  {
    "codigo": "85423190",
    "descricao": "Outros"
  },
  {
    "codigo": "85423210",
    "descricao": "Não montadas"
  },
  {
    "codigo": "85423221",
    "descricao": "Dos tipos RAM estáticas (SRAM) com tempo de acesso inferior ou igual a 25 ns, EPROM, EEPROM, PROM, ROM e FLASH"
  },
  {
    "codigo": "85423229",
    "descricao": "Outras"
  },
  {
    "codigo": "85423291",
    "descricao": "Dos tipos RAM estáticas (SRAM) com tempo de acesso inferior ou igual a 25 ns, EPROM, EEPROM, PROM, ROM e FLASH"
  },
  {
    "codigo": "85423299",
    "descricao": "Outras"
  },
  {
    "codigo": "85423311",
    "descricao": "De espessura de camada inferior ou igual a 1 micrômetro (mícron) com frequência de operação igual ou superior a 800 MHz"
  },
  {
    "codigo": "85423319",
    "descricao": "Outros"
  },
  {
    "codigo": "85423320",
    "descricao": "Outros, não montados"
  },
  {
    "codigo": "85423390",
    "descricao": "Outros"
  },
  {
    "codigo": "85423911",
    "descricao": "De espessura de camada inferior ou igual a 1 micrômetro (mícron) com frequência de operação igual ou superior a 800 MHz"
  },
  {
    "codigo": "85423919",
    "descricao": "Outros"
  },
  {
    "codigo": "85423920",
    "descricao": "Outros, não montados"
  },
  {
    "codigo": "85423931",
    "descricao": "Circuitos do tipo <i>chipset</i>"
  },
  {
    "codigo": "85423939",
    "descricao": "Outros"
  },
  {
    "codigo": "85423991",
    "descricao": "Circuitos do tipo <i>chipset</i>"
  },
  {
    "codigo": "85423999",
    "descricao": "Outros"
  },
  {
    "codigo": "85429000",
    "descricao": "- Partes"
  },
  {
    "codigo": "85431000",
    "descricao": "- Aceleradores de partículas"
  },
  {
    "codigo": "85432000",
    "descricao": "- Geradores de sinais"
  },
  {
    "codigo": "85433010",
    "descricao": "De eletrólise, com células de membrana"
  },
  {
    "codigo": "85433090",
    "descricao": "Outros"
  },
  {
    "codigo": "85434000",
    "descricao": "- Cigarros eletrônicos e dispositivos de vaporização elétricos de uso pessoal semelhantes"
  },
  {
    "codigo": "85437011",
    "descricao": "Para transmissão de sinais de micro-ondas de alta potência (HPA), a válvula TWT do tipo <i>Phase Combiner</i>, com potência de saída superior a 2,7 kW"
  },
  {
    "codigo": "85437012",
    "descricao": "Para recepção de sinais de micro-ondas de baixo ruído (LNA) na banda de 3.600 a 4.200 MHz, com temperatura menor ou igual a 55 Kelvin, para telecomunicações via satélite"
  },
  {
    "codigo": "85437013",
    "descricao": "Para distribuição de sinais de televisão"
  },
  {
    "codigo": "85437014",
    "descricao": "Outros para recepção de sinais de micro-ondas"
  },
  {
    "codigo": "85437015",
    "descricao": "Outros para transmissão de sinais de micro-ondas"
  },
  {
    "codigo": "85437019",
    "descricao": "Outros"
  },
  {
    "codigo": "85437020",
    "descricao": "Aparelhos para eletrocutar insetos"
  },
  {
    "codigo": "85437031",
    "descricao": "Geradores de efeitos especiais com manipulação em 2 ou 3 dimensões, mesmo combinados com dispositivo de comutação, de mais de 10 entradas de áudio ou de vídeo"
  },
  {
    "codigo": "85437032",
    "descricao": "Geradores de caracteres, digitais"
  },
  {
    "codigo": "85437033",
    "descricao": "Sincronizadores de quadro armazenadores ou corretores de base de tempo"
  },
  {
    "codigo": "85437034",
    "descricao": "Controladores de edição"
  },
  {
    "codigo": "85437035",
    "descricao": "Misturador digital, em tempo real, com oito ou mais entradas"
  },
  {
    "codigo": "85437036",
    "descricao": "Roteador-comutador (<i>routing switcher</i>) de mais de 20 entradas e mais de 16 saídas, de áudio ou de vídeo"
  },
  {
    "codigo": "85437039",
    "descricao": "Outros"
  },
  {
    "codigo": "85437040",
    "descricao": "Transcodificadores ou conversores de padrões de televisão"
  },
  {
    "codigo": "85437050",
    "descricao": "Simulador de antenas para transmissores com potência igual ou superior a 25 kW (carga fantasma)"
  },
  {
    "codigo": "85437091",
    "descricao": "Terminais de texto que operem com código de transmissão Baudot, providos de teclado alfanumérico e visor, para acoplamento exclusivamente acústico a telefone"
  },
  {
    "codigo": "85437092",
    "descricao": "Eletrificadores de cercas"
  },
  {
    "codigo": "85437099",
    "descricao": "Outros"
  },
  {
    "codigo": "85439010",
    "descricao": "Das máquinas ou aparelhos da subposição 8543.70"
  },
  {
    "codigo": "85439090",
    "descricao": "Outras"
  },
  {
    "codigo": "85441100",
    "descricao": "-- De cobre"
  },
  {
    "codigo": "85441911",
    "descricao": "Revestido de cobre (CCA - <i>Copper Clad Aluminum</i>)"
  },
  {
    "codigo": "85441919",
    "descricao": "Outros"
  },
  {
    "codigo": "85441990",
    "descricao": "Outros"
  },
  {
    "codigo": "85442000",
    "descricao": "- Cabos coaxiais e outros condutores elétricos coaxiais"
  },
  {
    "codigo": "85443000",
    "descricao": "- Jogos de fios para velas de ignição e outros jogos de fios do tipo utilizado em quaisquer veículos"
  },
  {
    "codigo": "85444200",
    "descricao": "-- Munidos de peças de conexão"
  },
  {
    "codigo": "85444900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85446000",
    "descricao": "- Outros condutores elétricos, para uma tensão superior a 1.000 V"
  },
  {
    "codigo": "85447010",
    "descricao": "Com revestimento externo de material dielétrico"
  },
  {
    "codigo": "85447020",
    "descricao": "Com revestimento externo de aço, próprios para instalação submarina (cabo submarino)"
  },
  {
    "codigo": "85447030",
    "descricao": "Com revestimento externo de alumínio"
  },
  {
    "codigo": "85447090",
    "descricao": "Outros"
  },
  {
    "codigo": "85451100",
    "descricao": "-- Do tipo utilizado em fornos"
  },
  {
    "codigo": "85451910",
    "descricao": "De grafita, com um teor de carbono igual ou superior a 99,9 %, em peso"
  },
  {
    "codigo": "85451920",
    "descricao": "Blocos de grafite, do tipo utilizado como cátodos em cubas eletrolíticas"
  },
  {
    "codigo": "85451990",
    "descricao": "Outros"
  },
  {
    "codigo": "85452000",
    "descricao": "- Escovas"
  },
  {
    "codigo": "85459010",
    "descricao": "Carvões para pilhas elétricas"
  },
  {
    "codigo": "85459020",
    "descricao": "Resistências aquecedoras desprovidas de revestimento e de terminais"
  },
  {
    "codigo": "85459030",
    "descricao": "Suportes de conexão (<i>nipples</i>), para eletrodos"
  },
  {
    "codigo": "85459090",
    "descricao": "Outros"
  },
  {
    "codigo": "85461000",
    "descricao": "- De vidro"
  },
  {
    "codigo": "85462000",
    "descricao": "- De cerâmica"
  },
  {
    "codigo": "85469000",
    "descricao": "- Outros"
  },
  {
    "codigo": "85471000",
    "descricao": "- Peças isolantes de cerâmica"
  },
  {
    "codigo": "85472010",
    "descricao": "Tampões vedadores para condensadores, com perfurações para terminais"
  },
  {
    "codigo": "85472090",
    "descricao": "Outras"
  },
  {
    "codigo": "85479000",
    "descricao": "- Outros"
  },
  {
    "codigo": "85480010",
    "descricao": "Termopares do tipo utilizado em dispositivos termoelétricos de segurança de aparelhos alimentados a gás"
  },
  {
    "codigo": "85480090",
    "descricao": "Outras"
  },
  {
    "codigo": "85491100",
    "descricao": "-- Desperdícios e resíduos, e sucata, de acumuladores de chumbo-ácido; acumuladores de chumbo-ácido inservíveis"
  },
  {
    "codigo": "85491200",
    "descricao": "-- Outros, que contenham chumbo, cádmio ou mercúrio"
  },
  {
    "codigo": "85491300",
    "descricao": "-- Selecionados por tipo de componente químico e que não contenham chumbo, cádmio ou mercúrio"
  },
  {
    "codigo": "85491400",
    "descricao": "-- Não selecionados e que não contenham chumbo, cádmio ou mercúrio"
  },
  {
    "codigo": "85491900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85492100",
    "descricao": "-- Que contenham pilhas, baterias de pilhas ou acumuladores, elétricos, interruptores de mercúrio, vidro de tubos catódicos ou outros vidros ativados, ou componentes elétricos ou eletrônicos que contenham cádmio, mercúrio, chumbo ou policlorobifenilas (PCB)"
  },
  {
    "codigo": "85492900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "85493100",
    "descricao": "-- Que contenham pilhas, baterias de pilhas ou acumuladores, elétricos, interruptores de mercúrio, vidro de tubos catódicos ou outros vidros ativados, ou componentes elétricos ou eletrônicos que contenham cádmio, mercúrio, chumbo ou policlorobifenilas (PCB)"
  },
  {
    "codigo": "85493900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "85499100",
    "descricao": "-- Que contenham pilhas, baterias de pilhas ou acumuladores, elétricos, interruptores de mercúrio, vidro de tubos catódicos ou outros vidros ativados, ou componentes elétricos ou eletrônicos que contenham cádmio, mercúrio, chumbo ou policlorobifenilas (PCB)"
  },
  {
    "codigo": "85499900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "86011000",
    "descricao": "- De fonte externa de eletricidade"
  },
  {
    "codigo": "86012000",
    "descricao": "- De acumuladores elétricos"
  },
  {
    "codigo": "86021000",
    "descricao": "- Locomotivas diesel-elétricas"
  },
  {
    "codigo": "86029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "86031000",
    "descricao": "- De fonte externa de eletricidade"
  },
  {
    "codigo": "86039000",
    "descricao": "- Outras"
  },
  {
    "codigo": "86040010",
    "descricao": "Autopropulsados, equipados com batedores de balastro e alinhadores de vias férreas"
  },
  {
    "codigo": "86040090",
    "descricao": "Outros"
  },
  {
    "codigo": "86050010",
    "descricao": "Vagões de passageiros"
  },
  {
    "codigo": "86050090",
    "descricao": "Outros"
  },
  {
    "codigo": "86061000",
    "descricao": "- Vagões-tanque (vagões-cisterna) e semelhantes"
  },
  {
    "codigo": "86063000",
    "descricao": "- Vagões de descarga automática, exceto os da subposição 8606.10"
  },
  {
    "codigo": "86069100",
    "descricao": "-- Cobertos e fechados"
  },
  {
    "codigo": "86069200",
    "descricao": "-- Abertos, com paredes fixas de altura superior a 60 cm"
  },
  {
    "codigo": "86069900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "86071110",
    "descricao": "<i>Bogies</i>"
  },
  {
    "codigo": "86071120",
    "descricao": "<i>Bissels</i>"
  },
  {
    "codigo": "86071200",
    "descricao": "-- Outros <i>bogies</i> e <i>bissels</i>"
  },
  {
    "codigo": "86071911",
    "descricao": "Com rolamentos incorporados, de diâmetro exterior superior a 190 mm, do tipo utilizado em eixos de rodas de vagões ferroviários"
  },
  {
    "codigo": "86071919",
    "descricao": "Outros"
  },
  {
    "codigo": "86071990",
    "descricao": "Outros"
  },
  {
    "codigo": "86072100",
    "descricao": "-- Freios (travões) a ar comprimido e suas partes"
  },
  {
    "codigo": "86072900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "86073000",
    "descricao": "- Ganchos e outros sistemas de engate, para-choques, e suas partes"
  },
  {
    "codigo": "86079100",
    "descricao": "-- De locomotivas ou de locotratores"
  },
  {
    "codigo": "86079900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "86080011",
    "descricao": "Mecânicos"
  },
  {
    "codigo": "86080012",
    "descricao": "Eletromecânicos"
  },
  {
    "codigo": "86080090",
    "descricao": "Outros"
  },
  {
    "codigo": "86090000",
    "descricao": "Contêineres (Contentores*), incluindo os de transporte de fluidos, especialmente concebidos e equipados para um ou mais meios de transporte."
  },
  {
    "codigo": "87011000",
    "descricao": "- Tratores de eixo único"
  },
  {
    "codigo": "87012100",
    "descricao": "-- Unicamente com motor de pistão de ignição por compressão (diesel ou semidiesel)"
  },
  {
    "codigo": "87012200",
    "descricao": "-- Equipados para propulsão, simultaneamente, com motor de pistão de ignição por compressão (diesel ou semidiesel) e motor elétrico"
  },
  {
    "codigo": "87012300",
    "descricao": "-- Equipados para propulsão, simultaneamente, com motor de pistão de ignição por centelha (faísca) e motor elétrico"
  },
  {
    "codigo": "87012400",
    "descricao": "-- Unicamente com motor elétrico para propulsão"
  },
  {
    "codigo": "87012900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "87013000",
    "descricao": "- Tratores de lagartas (esteiras)"
  },
  {
    "codigo": "87019100",
    "descricao": "-- Não superior a 18 kW"
  },
  {
    "codigo": "87019200",
    "descricao": "-- Superior a 18 kW, mas não superior a 37 kW"
  },
  {
    "codigo": "87019300",
    "descricao": "-- Superior a 37 kW, mas não superior a 75 kW"
  },
  {
    "codigo": "87019410",
    "descricao": "Tratores especialmente concebidos para arrastar troncos (<i>log skidders</i>)"
  },
  {
    "codigo": "87019490",
    "descricao": "Outros"
  },
  {
    "codigo": "87019510",
    "descricao": "Tratores especialmente concebidos para arrastar troncos (<i>log skidders</i>)"
  },
  {
    "codigo": "87019590",
    "descricao": "Outros"
  },
  {
    "codigo": "87021000",
    "descricao": "- Unicamente com motor de pistão de ignição por compressão (diesel ou semidiesel)"
  },
  {
    "codigo": "87022000",
    "descricao": "- Equipados para propulsão, simultaneamente, com motor de pistão de ignição por compressão (diesel ou semidiesel) e motor elétrico"
  },
  {
    "codigo": "87023000",
    "descricao": "- Equipados para propulsão, simultaneamente, com motor de pistão de ignição por centelha (faísca) e motor elétrico"
  },
  {
    "codigo": "87024010",
    "descricao": "Trólebus"
  },
  {
    "codigo": "87024090",
    "descricao": "Outros"
  },
  {
    "codigo": "87029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "87031000",
    "descricao": "- Veículos especialmente concebidos para se deslocar sobre a neve; veículos especiais para transporte de pessoas nos campos de golfe e veículos semelhantes"
  },
  {
    "codigo": "87032100",
    "descricao": "-- De cilindrada não superior a 1.000 cm<sup>3</sup>"
  },
  {
    "codigo": "87032210",
    "descricao": "Com capacidade de transporte de pessoas sentadas inferior ou igual a seis, incluindo o motorista"
  },
  {
    "codigo": "87032290",
    "descricao": "Outros"
  },
  {
    "codigo": "87032310",
    "descricao": "Com capacidade de transporte de pessoas sentadas inferior ou igual a seis, incluindo o motorista"
  },
  {
    "codigo": "87032390",
    "descricao": "Outros"
  },
  {
    "codigo": "87032410",
    "descricao": "Com capacidade de transporte de pessoas sentadas inferior ou igual a seis, incluindo o motorista"
  },
  {
    "codigo": "87032490",
    "descricao": "Outros"
  },
  {
    "codigo": "87033110",
    "descricao": "Com capacidade de transporte de pessoas sentadas inferior ou igual a seis, incluindo o motorista"
  },
  {
    "codigo": "87033190",
    "descricao": "Outros"
  },
  {
    "codigo": "87033210",
    "descricao": "Com capacidade de transporte de pessoas sentadas inferior ou igual a seis, incluindo o motorista"
  },
  {
    "codigo": "87033290",
    "descricao": "Outros"
  },
  {
    "codigo": "87033310",
    "descricao": "Com capacidade de transporte de pessoas sentadas inferior ou igual a seis, incluindo o motorista"
  },
  {
    "codigo": "87033390",
    "descricao": "Outros"
  },
  {
    "codigo": "87034000",
    "descricao": "- Outros veículos, equipados para propulsão, simultaneamente, com motor de pistão de ignição por centelha (faísca) e motor elétrico, exceto os suscetíveis de serem carregados por conexão a uma fonte externa de energia elétrica"
  },
  {
    "codigo": "87035000",
    "descricao": "- Outros veículos, equipados para propulsão, simultaneamente, com motor de pistão de ignição por compressão (diesel ou semidiesel) e motor elétrico, exceto os suscetíveis de serem carregados por conexão a uma fonte externa de energia elétrica"
  },
  {
    "codigo": "87036000",
    "descricao": "- Outros veículos, equipados para propulsão, simultaneamente, com motor de pistão de ignição por centelha (faísca) e motor elétrico, suscetíveis de serem carregados por conexão a uma fonte externa de energia elétrica"
  },
  {
    "codigo": "87037000",
    "descricao": "- Outros veículos, equipados para propulsão, simultaneamente, com motor de pistão de ignição por compressão (diesel ou semidiesel) e motor elétrico, suscetíveis de serem carregados por conexão a uma fonte externa de energia elétrica"
  },
  {
    "codigo": "87038000",
    "descricao": "- Outros veículos, equipados unicamente com motor elétrico para propulsão"
  },
  {
    "codigo": "87039000",
    "descricao": "- Outros"
  },
  {
    "codigo": "87041010",
    "descricao": "Com capacidade de carga igual ou superior a 85 toneladas"
  },
  {
    "codigo": "87041090",
    "descricao": "Outros"
  },
  {
    "codigo": "87042110",
    "descricao": "Chassis com motor e cabina"
  },
  {
    "codigo": "87042120",
    "descricao": "Com caixa basculante"
  },
  {
    "codigo": "87042130",
    "descricao": "Frigoríficos ou isotérmicos"
  },
  {
    "codigo": "87042190",
    "descricao": "Outros"
  },
  {
    "codigo": "87042210",
    "descricao": "Chassis com motor e cabina"
  },
  {
    "codigo": "87042220",
    "descricao": "Com caixa basculante"
  },
  {
    "codigo": "87042230",
    "descricao": "Frigoríficos ou isotérmicos"
  },
  {
    "codigo": "87042290",
    "descricao": "Outros"
  },
  {
    "codigo": "87042310",
    "descricao": "Chassis com motor e cabina"
  },
  {
    "codigo": "87042320",
    "descricao": "Com caixa basculante"
  },
  {
    "codigo": "87042330",
    "descricao": "Frigoríficos ou isotérmicos"
  },
  {
    "codigo": "87042340",
    "descricao": "De chassis articulado, para o transporte de troncos (<i>forwarder</i>), com grua incorporada, de potência máxima igual ou superior a 126 kW (170 HP)"
  },
  {
    "codigo": "87042390",
    "descricao": "Outros"
  },
  {
    "codigo": "87043110",
    "descricao": "Chassis com motor e cabina"
  },
  {
    "codigo": "87043120",
    "descricao": "Com caixa basculante"
  },
  {
    "codigo": "87043130",
    "descricao": "Frigoríficos ou isotérmicos"
  },
  {
    "codigo": "87043190",
    "descricao": "Outros"
  },
  {
    "codigo": "87043210",
    "descricao": "Chassis com motor e cabina"
  },
  {
    "codigo": "87043220",
    "descricao": "Com caixa basculante"
  },
  {
    "codigo": "87043230",
    "descricao": "Frigoríficos ou isotérmicos"
  },
  {
    "codigo": "87043290",
    "descricao": "Outros"
  },
  {
    "codigo": "87044100",
    "descricao": "-- De peso em carga máxima (bruto) não superior a 5 toneladas"
  },
  {
    "codigo": "87044200",
    "descricao": "-- De peso em carga máxima (bruto) superior a 5 toneladas, mas não superior a 20 toneladas"
  },
  {
    "codigo": "87044300",
    "descricao": "-- De peso em carga máxima (bruto) superior a 20 toneladas"
  },
  {
    "codigo": "87045100",
    "descricao": "-- De peso em carga máxima (bruto) não superior a 5 toneladas"
  },
  {
    "codigo": "87045200",
    "descricao": "-- De peso em carga máxima (bruto) superior a 5 toneladas"
  },
  {
    "codigo": "87046000",
    "descricao": "- Outros, unicamente com motor elétrico para propulsão"
  },
  {
    "codigo": "87049000",
    "descricao": "- Outros"
  },
  {
    "codigo": "87051020",
    "descricao": "Com todos os eixos de rodas direcionáveis e capacidade máxima de elevação inferior a 100 t"
  },
  {
    "codigo": "87051030",
    "descricao": "Com capacidade máxima de elevação igual ou superior a 100 t"
  },
  {
    "codigo": "87051090",
    "descricao": "Outros"
  },
  {
    "codigo": "87052000",
    "descricao": "- Torres (<i>derricks</i>) automóveis, para sondagem ou perfuração"
  },
  {
    "codigo": "87053000",
    "descricao": "- Veículos de combate a incêndio"
  },
  {
    "codigo": "87054000",
    "descricao": "- Caminhões-betoneiras"
  },
  {
    "codigo": "87059010",
    "descricao": "Caminhões para a determinação de parâmetros físicos característicos (perfilagem) de poços petrolíferos"
  },
  {
    "codigo": "87059090",
    "descricao": "Outros"
  },
  {
    "codigo": "87060010",
    "descricao": "Dos veículos da posição 87.02"
  },
  {
    "codigo": "87060020",
    "descricao": "Dos veículos das subposições 8701.10, 8701.30, 8701.91 a 8701.95 ou 8704.10"
  },
  {
    "codigo": "87060090",
    "descricao": "Outros"
  },
  {
    "codigo": "87071000",
    "descricao": "- Para os veículos da posição 87.03"
  },
  {
    "codigo": "87079010",
    "descricao": "Dos veículos das subposições 8701.10, 8701.30, 8701.91 a 8701.95 ou 8704.10"
  },
  {
    "codigo": "87079090",
    "descricao": "Outras"
  },
  {
    "codigo": "87081000",
    "descricao": "- Para-choques e suas partes"
  },
  {
    "codigo": "87082100",
    "descricao": "-- Cintos de segurança"
  },
  {
    "codigo": "87082200",
    "descricao": "-- Para-brisas, vidros traseiros e outros vidros especificados na Nota de subposição 1 do presente Capítulo"
  },
  {
    "codigo": "87082911",
    "descricao": "Para-lamas"
  },
  {
    "codigo": "87082912",
    "descricao": "Grades de radiadores"
  },
  {
    "codigo": "87082913",
    "descricao": "Portas"
  },
  {
    "codigo": "87082914",
    "descricao": "Painéis de instrumentos"
  },
  {
    "codigo": "87082919",
    "descricao": "Outros"
  },
  {
    "codigo": "87082991",
    "descricao": "Para-lamas"
  },
  {
    "codigo": "87082992",
    "descricao": "Grades de radiadores"
  },
  {
    "codigo": "87082993",
    "descricao": "Portas"
  },
  {
    "codigo": "87082994",
    "descricao": "Painéis de instrumentos"
  },
  {
    "codigo": "87082995",
    "descricao": "Geradores de gás para acionar retratores de cintos de segurança"
  },
  {
    "codigo": "87082999",
    "descricao": "Outros"
  },
  {
    "codigo": "87083011",
    "descricao": "Dos veículos das subposições 8701.10, 8701.30, 8701.91 a 8701.95 ou 8704.10"
  },
  {
    "codigo": "87083019",
    "descricao": "Outras"
  },
  {
    "codigo": "87083090",
    "descricao": "Outros"
  },
  {
    "codigo": "87084011",
    "descricao": "Servo-assistidas, próprias para torques de entrada superiores ou iguais a 750 Nm"
  },
  {
    "codigo": "87084019",
    "descricao": "Outras"
  },
  {
    "codigo": "87084080",
    "descricao": "Outras caixas de marchas"
  },
  {
    "codigo": "87084090",
    "descricao": "Partes"
  },
  {
    "codigo": "87085011",
    "descricao": "Eixos com diferencial com capacidade de suportar cargas superiores ou iguais a 14.000 kg, redutores planetários nos extremos e dispositivo de freio (travão) incorporado, do tipo utilizado em veículos da subposição 8704.10"
  },
  {
    "codigo": "87085012",
    "descricao": "Eixos não motores"
  },
  {
    "codigo": "87085019",
    "descricao": "Outros"
  },
  {
    "codigo": "87085080",
    "descricao": "Outros"
  },
  {
    "codigo": "87085091",
    "descricao": "De eixos não motores, dos veículos das subposições 8701.10, 8701.30, 8701.91 a 8701.95 ou 8704.10"
  },
  {
    "codigo": "87085099",
    "descricao": "Outras"
  },
  {
    "codigo": "87087010",
    "descricao": "De eixos propulsores dos veículos das subposições 8701.10, 8701.30, 8701.91 a 8701.95 ou 8704.10"
  },
  {
    "codigo": "87087090",
    "descricao": "Outros"
  },
  {
    "codigo": "87088000",
    "descricao": "- Sistemas de suspensão e suas partes (incluindo os amortecedores de suspensão)"
  },
  {
    "codigo": "87089100",
    "descricao": "-- Radiadores e suas partes"
  },
  {
    "codigo": "87089200",
    "descricao": "-- Silenciosos e tubos de escape; suas partes"
  },
  {
    "codigo": "87089300",
    "descricao": "-- Embreagens e suas partes"
  },
  {
    "codigo": "87089411",
    "descricao": "Volantes"
  },
  {
    "codigo": "87089412",
    "descricao": "Colunas"
  },
  {
    "codigo": "87089413",
    "descricao": "Caixas"
  },
  {
    "codigo": "87089481",
    "descricao": "Volantes"
  },
  {
    "codigo": "87089482",
    "descricao": "Colunas"
  },
  {
    "codigo": "87089483",
    "descricao": "Caixas"
  },
  {
    "codigo": "87089490",
    "descricao": "Partes"
  },
  {
    "codigo": "87089510",
    "descricao": "Bolsas infláveis de segurança com sistema de insuflação (<i>airbags</i>)"
  },
  {
    "codigo": "87089521",
    "descricao": "Bolsas infláveis para <i>airbags</i>"
  },
  {
    "codigo": "87089522",
    "descricao": "Sistema de insuflação"
  },
  {
    "codigo": "87089529",
    "descricao": "Outras"
  },
  {
    "codigo": "87089910",
    "descricao": "Dispositivos para comando de acelerador, freio (travão), embreagem, direção ou caixa de marchas mesmo os de adaptação dos preexistentes, do tipo utilizado por pessoas incapacitadas"
  },
  {
    "codigo": "87089990",
    "descricao": "Outros"
  },
  {
    "codigo": "87091100",
    "descricao": "-- Elétricos"
  },
  {
    "codigo": "87091900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "87099000",
    "descricao": "- Partes"
  },
  {
    "codigo": "87100000",
    "descricao": "Tanques e outros veículos blindados de combate, armados ou não, e suas partes."
  },
  {
    "codigo": "87111000",
    "descricao": "- Com motor de pistão de cilindrada não superior a 50 cm<sup>3</sup>"
  },
  {
    "codigo": "87112010",
    "descricao": "Motocicletas de cilindrada inferior ou igual a 125 cm<sup>3</sup>"
  },
  {
    "codigo": "87112020",
    "descricao": "Motocicletas de cilindrada superior a 125 cm<sup>3</sup>"
  },
  {
    "codigo": "87112090",
    "descricao": "Outros"
  },
  {
    "codigo": "87113000",
    "descricao": "- Com motor de pistão de cilindrada superior a 250 cm<sup>3</sup>, mas não superior a 500 cm<sup>3</sup>"
  },
  {
    "codigo": "87114000",
    "descricao": "- Com motor de pistão de cilindrada superior a 500 cm<sup>3</sup>, mas não superior a 800 cm<sup>3</sup>"
  },
  {
    "codigo": "87115000",
    "descricao": "- Com motor de pistão de cilindrada superior a 800 cm<sup>3</sup>"
  },
  {
    "codigo": "87116000",
    "descricao": "- Com motor elétrico para propulsão"
  },
  {
    "codigo": "87119000",
    "descricao": "- Outros"
  },
  {
    "codigo": "87120010",
    "descricao": "Bicicletas"
  },
  {
    "codigo": "87120090",
    "descricao": "Outros"
  },
  {
    "codigo": "87131000",
    "descricao": "- Sem mecanismo de propulsão"
  },
  {
    "codigo": "87139000",
    "descricao": "- Outros"
  },
  {
    "codigo": "87141000",
    "descricao": "- De motocicletas (incluindo os ciclomotores)"
  },
  {
    "codigo": "87142000",
    "descricao": "- De cadeiras de rodas ou de outros veículos para pessoas com incapacidade"
  },
  {
    "codigo": "87149100",
    "descricao": "-- Quadros e garfos, e suas partes"
  },
  {
    "codigo": "87149200",
    "descricao": "-- Aros e raios"
  },
  {
    "codigo": "87149311",
    "descricao": "Sem rosca, para pinhões do tipo cassete"
  },
  {
    "codigo": "87149319",
    "descricao": "Outros"
  },
  {
    "codigo": "87149320",
    "descricao": "Pinhões de rodas livres"
  },
  {
    "codigo": "87149410",
    "descricao": "Cubos de freios (travões)"
  },
  {
    "codigo": "87149490",
    "descricao": "Outros"
  },
  {
    "codigo": "87149500",
    "descricao": "-- Selins"
  },
  {
    "codigo": "87149611",
    "descricao": "Pedaleiros com pedivelas de peça única (monobloco)"
  },
  {
    "codigo": "87149612",
    "descricao": "Pedivelas de peça única (monobloco)"
  },
  {
    "codigo": "87149619",
    "descricao": "Outros"
  },
  {
    "codigo": "87149690",
    "descricao": "Outros"
  },
  {
    "codigo": "87149910",
    "descricao": "Câmbio de velocidades"
  },
  {
    "codigo": "87149920",
    "descricao": "Caixas de direção sem rosca"
  },
  {
    "codigo": "87149990",
    "descricao": "Outros"
  },
  {
    "codigo": "87150000",
    "descricao": "Carrinhos e veículos semelhantes para transporte de crianças, e suas partes."
  },
  {
    "codigo": "87161000",
    "descricao": "- Reboques e semirreboques, para habitação ou para acampar, do tipo <i>trailer</i> (caravana*)"
  },
  {
    "codigo": "87162000",
    "descricao": "- Reboques e semirreboques, autocarregáveis ou autodescarregáveis, para usos agrícolas"
  },
  {
    "codigo": "87163100",
    "descricao": "-- Tanques (cisternas)"
  },
  {
    "codigo": "87163900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "87164000",
    "descricao": "- Outros reboques e semirreboques"
  },
  {
    "codigo": "87168000",
    "descricao": "- Outros veículos"
  },
  {
    "codigo": "87169010",
    "descricao": "Chassis de reboques e semirreboques"
  },
  {
    "codigo": "87169090",
    "descricao": "Outras"
  },
  {
    "codigo": "88010000",
    "descricao": "Balões e dirigíveis; planadores, asas voadoras e outros veículos aéreos, não concebidos para propulsão a motor."
  },
  {
    "codigo": "88021100",
    "descricao": "-- De peso não superior a 2.000 kg, vazios (sem carga)"
  },
  {
    "codigo": "88021210",
    "descricao": "De peso não superior a 3.500 kg"
  },
  {
    "codigo": "88021290",
    "descricao": "Outros"
  },
  {
    "codigo": "88022010",
    "descricao": "A hélice"
  },
  {
    "codigo": "88022021",
    "descricao": "Monomotores"
  },
  {
    "codigo": "88022022",
    "descricao": "Multimotores"
  },
  {
    "codigo": "88022090",
    "descricao": "Outros"
  },
  {
    "codigo": "88023010",
    "descricao": "A hélice"
  },
  {
    "codigo": "88023021",
    "descricao": "Multimotores, de peso não superior a 7.000 kg, vazios (sem carga)"
  },
  {
    "codigo": "88023029",
    "descricao": "Outros"
  },
  {
    "codigo": "88023031",
    "descricao": "De peso não superior a 7.000 kg, vazios (sem carga)"
  },
  {
    "codigo": "88023039",
    "descricao": "Outros"
  },
  {
    "codigo": "88023090",
    "descricao": "Outros"
  },
  {
    "codigo": "88024010",
    "descricao": "A turboélice"
  },
  {
    "codigo": "88024090",
    "descricao": "Outros"
  },
  {
    "codigo": "88026000",
    "descricao": "- Veículos espaciais (incluindo os satélites) e seus veículos de lançamento, e veículos suborbitais"
  },
  {
    "codigo": "88040000",
    "descricao": "Paraquedas (incluindo os paraquedas dirigíveis e os parapentes) e os paraquedas giratórios; suas partes e acessórios."
  },
  {
    "codigo": "88051000",
    "descricao": "- Aparelhos e dispositivos para lançamento de veículos aéreos, e suas partes; aparelhos e dispositivos para aterrissagem (aterragem) de veículos aéreos em porta-aviões e aparelhos e dispositivos semelhantes, e suas partes"
  },
  {
    "codigo": "88052100",
    "descricao": "-- Simuladores de combate aéreo e suas partes"
  },
  {
    "codigo": "88052900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "88061000",
    "descricao": "- Concebidos para o transporte de passageiros"
  },
  {
    "codigo": "88062100",
    "descricao": "-- De peso máximo de decolagem não superior a 250 g"
  },
  {
    "codigo": "88062200",
    "descricao": "-- De peso máximo de decolagem superior a 250 g, mas não superior a 7 kg"
  },
  {
    "codigo": "88062300",
    "descricao": "-- De peso máximo de decolagem superior a 7 kg, mas não superior a 25 kg"
  },
  {
    "codigo": "88062400",
    "descricao": "-- De peso máximo de decolagem superior a 25 kg, mas não superior a 150 kg"
  },
  {
    "codigo": "88062900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "88069100",
    "descricao": "-- De peso máximo de decolagem não superior a 250 g"
  },
  {
    "codigo": "88069200",
    "descricao": "-- De peso máximo de decolagem superior a 250 g, mas não superior a 7 kg"
  },
  {
    "codigo": "88069300",
    "descricao": "-- De peso máximo de decolagem superior a 7 kg, mas não superior a 25 kg"
  },
  {
    "codigo": "88069400",
    "descricao": "-- De peso máximo de decolagem superior a 25 kg, mas não superior a 150 kg"
  },
  {
    "codigo": "88069900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "88071000",
    "descricao": "- Hélices e rotores, e suas partes"
  },
  {
    "codigo": "88072000",
    "descricao": "- Trens de aterrissagem (aterragem) e suas partes"
  },
  {
    "codigo": "88073000",
    "descricao": "- Outras partes de aviões, de helicópteros ou de veículos aéreos (aeronaves) não tripulados"
  },
  {
    "codigo": "88079000",
    "descricao": "- Outras"
  },
  {
    "codigo": "89011000",
    "descricao": "- Transatlânticos, barcos de excursão e embarcações semelhantes principalmente concebidas para o transporte de pessoas; <i>ferryboats</i>"
  },
  {
    "codigo": "89012000",
    "descricao": "- Navios-tanque"
  },
  {
    "codigo": "89013000",
    "descricao": "- Barcos frigoríficos, exceto os da subposição 8901.20"
  },
  {
    "codigo": "89019000",
    "descricao": "- Outras embarcações para o transporte de mercadorias ou para o transporte de pessoas e de mercadorias"
  },
  {
    "codigo": "89020010",
    "descricao": "De comprimento, de proa a popa, igual ou superior a 35 m"
  },
  {
    "codigo": "89020090",
    "descricao": "Outros"
  },
  {
    "codigo": "89031100",
    "descricao": "-- Equipados com um motor ou concebidos para comportá-lo, de peso vazio (sem carga) sem motor não superior a 100 kg"
  },
  {
    "codigo": "89031200",
    "descricao": "-- Não concebidos para serem utilizados com um motor e de peso vazio (sem carga) não superior a 100 kg"
  },
  {
    "codigo": "89031900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "89032100",
    "descricao": "-- De comprimento não superior a 7,5 m"
  },
  {
    "codigo": "89032200",
    "descricao": "-- De comprimento superior a 7,5 m, mas não superior a 24 m"
  },
  {
    "codigo": "89032300",
    "descricao": "-- De comprimento superior a 24 m"
  },
  {
    "codigo": "89033100",
    "descricao": "-- De comprimento não superior a 7,5 m"
  },
  {
    "codigo": "89033200",
    "descricao": "-- De comprimento superior a 7,5 m, mas não superior a 24 m"
  },
  {
    "codigo": "89033300",
    "descricao": "-- De comprimento superior a 24 m"
  },
  {
    "codigo": "89039300",
    "descricao": "-- De comprimento não superior a 7,5 m"
  },
  {
    "codigo": "89039900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "89040000",
    "descricao": "Rebocadores e barcos concebidos para empurrar outras embarcações."
  },
  {
    "codigo": "89051000",
    "descricao": "- Dragas"
  },
  {
    "codigo": "89052000",
    "descricao": "- Plataformas de perfuração ou de exploração, flutuantes ou submersíveis"
  },
  {
    "codigo": "89059000",
    "descricao": "- Outros"
  },
  {
    "codigo": "89061000",
    "descricao": "- Navios de guerra"
  },
  {
    "codigo": "89069000",
    "descricao": "- Outras"
  },
  {
    "codigo": "89071000",
    "descricao": "- Balsas infláveis"
  },
  {
    "codigo": "89079000",
    "descricao": "- Outras"
  },
  {
    "codigo": "89080000",
    "descricao": "Embarcações e outras estruturas flutuantes, para desmantelar."
  },
  {
    "codigo": "90011011",
    "descricao": "De diâmetro de núcleo inferior a 11 micrômetros (mícrons)"
  },
  {
    "codigo": "90011019",
    "descricao": "Outras"
  },
  {
    "codigo": "90011020",
    "descricao": "Feixes e cabos de fibras ópticas"
  },
  {
    "codigo": "90012000",
    "descricao": "- Matérias polarizantes em folhas ou em placas"
  },
  {
    "codigo": "90013000",
    "descricao": "- Lentes de contato"
  },
  {
    "codigo": "90014000",
    "descricao": "- Lentes de vidro, para óculos"
  },
  {
    "codigo": "90015000",
    "descricao": "- Lentes de outras matérias, para óculos"
  },
  {
    "codigo": "90019010",
    "descricao": "Lentes"
  },
  {
    "codigo": "90019090",
    "descricao": "Outros"
  },
  {
    "codigo": "90021111",
    "descricao": "Para câmeras fotográficas"
  },
  {
    "codigo": "90021119",
    "descricao": "Outras"
  },
  {
    "codigo": "90021120",
    "descricao": "De aproximação (<i>zoom</i>) para câmeras de televisão, de 20 ou mais aumentos"
  },
  {
    "codigo": "90021190",
    "descricao": "Outras"
  },
  {
    "codigo": "90021900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "90022010",
    "descricao": "Polarizantes"
  },
  {
    "codigo": "90022090",
    "descricao": "Outros"
  },
  {
    "codigo": "90029010",
    "descricao": "Comutadores (<i>switches</i>) optomecânicos, do tipo utilizado em redes ópticas de transmissão de dados, próprios para montagem por inserção (PTH - <i>Pin Through Hole</i>)"
  },
  {
    "codigo": "90029090",
    "descricao": "Outros"
  },
  {
    "codigo": "90031100",
    "descricao": "-- De plástico"
  },
  {
    "codigo": "90031910",
    "descricao": "De metais comuns, mesmo folheados ou chapeados de metais preciosos (plaquê)"
  },
  {
    "codigo": "90031990",
    "descricao": "Outras"
  },
  {
    "codigo": "90039010",
    "descricao": "Charneiras"
  },
  {
    "codigo": "90039090",
    "descricao": "Outras"
  },
  {
    "codigo": "90041000",
    "descricao": "- Óculos de sol"
  },
  {
    "codigo": "90049010",
    "descricao": "Óculos para correção"
  },
  {
    "codigo": "90049020",
    "descricao": "Óculos de segurança"
  },
  {
    "codigo": "90049090",
    "descricao": "Outros"
  },
  {
    "codigo": "90051000",
    "descricao": "- Binóculos"
  },
  {
    "codigo": "90058000",
    "descricao": "- Outros instrumentos"
  },
  {
    "codigo": "90059010",
    "descricao": "De binóculos"
  },
  {
    "codigo": "90059090",
    "descricao": "Outros"
  },
  {
    "codigo": "90063000",
    "descricao": "- Câmeras fotográficas especialmente concebidas para fotografia submarina ou aérea, para exame médico de órgãos internos ou para laboratórios de medicina legal ou de investigação judicial"
  },
  {
    "codigo": "90064000",
    "descricao": "- Câmeras fotográficas para filmes de revelação e cópia instantâneas"
  },
  {
    "codigo": "90065310",
    "descricao": "De foco fixo"
  },
  {
    "codigo": "90065320",
    "descricao": "De foco ajustável"
  },
  {
    "codigo": "90065930",
    "descricao": "Fotocompositoras a laser para preparação de clichês"
  },
  {
    "codigo": "90065940",
    "descricao": "Outras, de foco fixo"
  },
  {
    "codigo": "90065951",
    "descricao": "Para obtenção de negativos de 45 mm x 60 mm ou de dimensões superiores"
  },
  {
    "codigo": "90065959",
    "descricao": "Outras"
  },
  {
    "codigo": "90066100",
    "descricao": "-- Aparelhos de tubo de descarga para produção de luz relâmpago (<i>flash</i>) (denominados \"<i>flashes</i> eletrônicos\")"
  },
  {
    "codigo": "90066900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "90069110",
    "descricao": "Corpos"
  },
  {
    "codigo": "90069190",
    "descricao": "Outros"
  },
  {
    "codigo": "90069900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "90071000",
    "descricao": "- Câmeras"
  },
  {
    "codigo": "90072020",
    "descricao": "Para filmes de largura igual ou superior a 35 mm, mas não superior a 70 mm"
  },
  {
    "codigo": "90072090",
    "descricao": "Outros"
  },
  {
    "codigo": "90079100",
    "descricao": "-- De câmeras"
  },
  {
    "codigo": "90079200",
    "descricao": "-- De projetores"
  },
  {
    "codigo": "90085000",
    "descricao": "- Projetores e aparelhos de ampliação ou de redução"
  },
  {
    "codigo": "90089000",
    "descricao": "- Partes e acessórios"
  },
  {
    "codigo": "90101010",
    "descricao": "Cubas e cubetas, de operação automática e programáveis"
  },
  {
    "codigo": "90101020",
    "descricao": "Ampliadoras-copiadoras automáticas para papel fotográfico, com capacidade superior a 1.000 cópias por hora"
  },
  {
    "codigo": "90101090",
    "descricao": "Outros"
  },
  {
    "codigo": "90105010",
    "descricao": "Processadores fotográficos para o tratamento eletrônico de imagens, mesmo com saída digital"
  },
  {
    "codigo": "90105020",
    "descricao": "Aparelhos para revelação automática de chapas de fotopolímeros com suporte metálico"
  },
  {
    "codigo": "90105090",
    "descricao": "Outros"
  },
  {
    "codigo": "90106000",
    "descricao": "- Telas para projeção"
  },
  {
    "codigo": "90109010",
    "descricao": "De aparelhos ou material da subposição 9010.10 ou do item 9010.50.10"
  },
  {
    "codigo": "90109090",
    "descricao": "Outros"
  },
  {
    "codigo": "90111000",
    "descricao": "- Microscópios estereoscópicos"
  },
  {
    "codigo": "90112010",
    "descricao": "Para fotomicrografia"
  },
  {
    "codigo": "90112020",
    "descricao": "Para cinefotomicrografia"
  },
  {
    "codigo": "90112030",
    "descricao": "Para microprojeção"
  },
  {
    "codigo": "90118010",
    "descricao": "Binoculares de platina móvel"
  },
  {
    "codigo": "90118090",
    "descricao": "Outros"
  },
  {
    "codigo": "90119010",
    "descricao": "Dos artigos da subposição 9011.20"
  },
  {
    "codigo": "90119090",
    "descricao": "Outros"
  },
  {
    "codigo": "90121010",
    "descricao": "Microscópios eletrônicos"
  },
  {
    "codigo": "90121090",
    "descricao": "Outros"
  },
  {
    "codigo": "90129010",
    "descricao": "De microscópios eletrônicos"
  },
  {
    "codigo": "90129090",
    "descricao": "Outros"
  },
  {
    "codigo": "90131010",
    "descricao": "Miras telescópicas para armas"
  },
  {
    "codigo": "90131090",
    "descricao": "Outros"
  },
  {
    "codigo": "90132000",
    "descricao": "- Lasers, exceto diodos laser"
  },
  {
    "codigo": "90138000",
    "descricao": "- Outros dispositivos, aparelhos e instrumentos"
  },
  {
    "codigo": "90139000",
    "descricao": "- Partes e acessórios"
  },
  {
    "codigo": "90141000",
    "descricao": "- Bússolas, incluindo as agulhas de marear"
  },
  {
    "codigo": "90142010",
    "descricao": "Altímetros"
  },
  {
    "codigo": "90142020",
    "descricao": "Pilotos automáticos"
  },
  {
    "codigo": "90142030",
    "descricao": "Inclinômetros"
  },
  {
    "codigo": "90142090",
    "descricao": "Outros"
  },
  {
    "codigo": "90148010",
    "descricao": "Sondas acústicas (ecobatímetros) ou de ultrassom (sonar e semelhantes)"
  },
  {
    "codigo": "90148090",
    "descricao": "Outros"
  },
  {
    "codigo": "90149000",
    "descricao": "- Partes e acessórios"
  },
  {
    "codigo": "90151000",
    "descricao": "- Telêmetros"
  },
  {
    "codigo": "90152010",
    "descricao": "Com sistema de leitura por meio de prisma ou micrômetro óptico e precisão de leitura de 1 segundo"
  },
  {
    "codigo": "90152090",
    "descricao": "Outros"
  },
  {
    "codigo": "90153000",
    "descricao": "- Níveis"
  },
  {
    "codigo": "90154000",
    "descricao": "- Instrumentos e aparelhos de fotogrametria"
  },
  {
    "codigo": "90158010",
    "descricao": "Molinetes hidrométricos"
  },
  {
    "codigo": "90158090",
    "descricao": "Outros"
  },
  {
    "codigo": "90159010",
    "descricao": "De instrumentos ou aparelhos da subposição 9015.40"
  },
  {
    "codigo": "90159090",
    "descricao": "Outros"
  },
  {
    "codigo": "90160010",
    "descricao": "Sensíveis a pesos não superiores a 0,2 mg"
  },
  {
    "codigo": "90160090",
    "descricao": "Outras"
  },
  {
    "codigo": "90171010",
    "descricao": "Automáticas"
  },
  {
    "codigo": "90171090",
    "descricao": "Outras"
  },
  {
    "codigo": "90172000",
    "descricao": "- Outros instrumentos de desenho, de traçado ou de cálculo"
  },
  {
    "codigo": "90173010",
    "descricao": "Micrômetros"
  },
  {
    "codigo": "90173020",
    "descricao": "Paquímetros"
  },
  {
    "codigo": "90173090",
    "descricao": "Outros"
  },
  {
    "codigo": "90178010",
    "descricao": "Metros"
  },
  {
    "codigo": "90178090",
    "descricao": "Outros"
  },
  {
    "codigo": "90179010",
    "descricao": "De mesas ou máquinas de desenhar, automáticas"
  },
  {
    "codigo": "90179090",
    "descricao": "Outros"
  },
  {
    "codigo": "90181100",
    "descricao": "-- Eletrocardiógrafos"
  },
  {
    "codigo": "90181210",
    "descricao": "Ecógrafos com análise espectral Doppler"
  },
  {
    "codigo": "90181290",
    "descricao": "Outros"
  },
  {
    "codigo": "90181300",
    "descricao": "-- Aparelhos de diagnóstico de imagem por ressonância magnética"
  },
  {
    "codigo": "90181410",
    "descricao": "<i>Scanner</i> de tomografia por emissão de posítrons (PET - <i>Positron Emission Tomography</i>)"
  },
  {
    "codigo": "90181420",
    "descricao": "Câmaras gama"
  },
  {
    "codigo": "90181490",
    "descricao": "Outros"
  },
  {
    "codigo": "90181910",
    "descricao": "Endoscópios"
  },
  {
    "codigo": "90181920",
    "descricao": "Audiômetros"
  },
  {
    "codigo": "90181980",
    "descricao": "Outros"
  },
  {
    "codigo": "90181990",
    "descricao": "Partes"
  },
  {
    "codigo": "90182010",
    "descricao": "Para cirurgia, que operem por laser"
  },
  {
    "codigo": "90182020",
    "descricao": "Outros, para tratamento bucal, que operem por laser"
  },
  {
    "codigo": "90182090",
    "descricao": "Outros"
  },
  {
    "codigo": "90183111",
    "descricao": "De capacidade inferior ou igual a 2 cm<sup>3</sup>"
  },
  {
    "codigo": "90183119",
    "descricao": "Outras"
  },
  {
    "codigo": "90183190",
    "descricao": "Outras"
  },
  {
    "codigo": "90183211",
    "descricao": "Gengivais"
  },
  {
    "codigo": "90183212",
    "descricao": "De aço cromo-níquel, bisel trifacetado e diâmetro exterior igual ou superior a 1,6 mm, do tipo utilizado com bolsas de sangue"
  },
  {
    "codigo": "90183213",
    "descricao": "Agulhas ponta de lápis, do tipo utilizado em anestesia epidural ou raquidiana"
  },
  {
    "codigo": "90183219",
    "descricao": "Outras"
  },
  {
    "codigo": "90183220",
    "descricao": "Para suturas"
  },
  {
    "codigo": "90183910",
    "descricao": "Agulhas"
  },
  {
    "codigo": "90183921",
    "descricao": "De borracha"
  },
  {
    "codigo": "90183922",
    "descricao": "Cateteres de poli(cloreto de vinila), para embolectomia arterial"
  },
  {
    "codigo": "90183923",
    "descricao": "Cateteres de poli(cloreto de vinila), para termodiluição"
  },
  {
    "codigo": "90183925",
    "descricao": "Sondas vesicais estéreis de poliuretano, com revestimento hidrofílico, de uso intermitente, apresentadas em embalagens com solução salina"
  },
  {
    "codigo": "90183926",
    "descricao": "Cateteres intravenosos periféricos, de plástico"
  },
  {
    "codigo": "90183929",
    "descricao": "Outros"
  },
  {
    "codigo": "90183930",
    "descricao": "Lancetas para vacinação e cautérios"
  },
  {
    "codigo": "90183991",
    "descricao": "Artigo para fístula arteriovenosa, composto de agulha, base de fixação tipo borboleta, tubo plástico com conector e obturador"
  },
  {
    "codigo": "90183999",
    "descricao": "Outros"
  },
  {
    "codigo": "90184100",
    "descricao": "-- Aparelhos dentários de brocar, mesmo combinados numa base comum com outros equipamentos dentários"
  },
  {
    "codigo": "90184911",
    "descricao": "De carboneto de tungstênio (volfrâmio)"
  },
  {
    "codigo": "90184912",
    "descricao": "De aço-vanádio"
  },
  {
    "codigo": "90184919",
    "descricao": "Outras"
  },
  {
    "codigo": "90184920",
    "descricao": "Limas"
  },
  {
    "codigo": "90184940",
    "descricao": "Para tratamento bucal, que operem por projeção cinética de partículas"
  },
  {
    "codigo": "90184991",
    "descricao": "Para desenho e construção de peças cerâmicas para restaurações dentárias, computadorizados"
  },
  {
    "codigo": "90184999",
    "descricao": "Outros"
  },
  {
    "codigo": "90185010",
    "descricao": "Microscópios binoculares, do tipo utilizado em cirurgia oftalmológica"
  },
  {
    "codigo": "90185090",
    "descricao": "Outros"
  },
  {
    "codigo": "90189010",
    "descricao": "Para transfusão de sangue ou infusão intravenosa"
  },
  {
    "codigo": "90189021",
    "descricao": "Elétricos"
  },
  {
    "codigo": "90189029",
    "descricao": "Outros"
  },
  {
    "codigo": "90189031",
    "descricao": "Litotritores por onda de choque"
  },
  {
    "codigo": "90189039",
    "descricao": "Outros"
  },
  {
    "codigo": "90189040",
    "descricao": "Rins artificiais"
  },
  {
    "codigo": "90189050",
    "descricao": "Aparelhos de diatermia"
  },
  {
    "codigo": "90189061",
    "descricao": "Que contenham mercúrio"
  },
  {
    "codigo": "90189069",
    "descricao": "Outros"
  },
  {
    "codigo": "90189091",
    "descricao": "Incubadoras para bebês"
  },
  {
    "codigo": "90189093",
    "descricao": "Aparelhos para terapia intra-uretral por micro-ondas (TUMT), próprios para o tratamento de afecções prostáticas, computadorizados"
  },
  {
    "codigo": "90189094",
    "descricao": "Endoscópios"
  },
  {
    "codigo": "90189095",
    "descricao": "Grampos e clipes, seus aplicadores e extratores"
  },
  {
    "codigo": "90189096",
    "descricao": "Desfibriladores externos que operem unicamente em modo automático (AED - <i>Automatic External Defibrillator</i>)"
  },
  {
    "codigo": "90189097",
    "descricao": "Aparelhos destinados a procedimentos cirúrgicos assistidos por robótica"
  },
  {
    "codigo": "90189099",
    "descricao": "Outros"
  },
  {
    "codigo": "90191000",
    "descricao": "- Aparelhos de mecanoterapia; aparelhos de massagem; aparelhos de psicotécnica"
  },
  {
    "codigo": "90192010",
    "descricao": "De oxigenoterapia"
  },
  {
    "codigo": "90192020",
    "descricao": "De aerossolterapia"
  },
  {
    "codigo": "90192030",
    "descricao": "Respiratórios de reanimação"
  },
  {
    "codigo": "90192040",
    "descricao": "Respiradores automáticos (pulmões de aço)"
  },
  {
    "codigo": "90192090",
    "descricao": "Outros"
  },
  {
    "codigo": "90200010",
    "descricao": "Máscaras contra gases"
  },
  {
    "codigo": "90200090",
    "descricao": "Outros"
  },
  {
    "codigo": "90211010",
    "descricao": "Artigos e aparelhos ortopédicos"
  },
  {
    "codigo": "90211020",
    "descricao": "Artigos e aparelhos para fraturas"
  },
  {
    "codigo": "90211091",
    "descricao": "De artigos e aparelhos de ortopedia, articulados"
  },
  {
    "codigo": "90211099",
    "descricao": "Outros"
  },
  {
    "codigo": "90212110",
    "descricao": "De acrílico"
  },
  {
    "codigo": "90212190",
    "descricao": "Outros"
  },
  {
    "codigo": "90212900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "90213110",
    "descricao": "Femurais"
  },
  {
    "codigo": "90213120",
    "descricao": "Mioelétricas"
  },
  {
    "codigo": "90213190",
    "descricao": "Outras"
  },
  {
    "codigo": "90213911",
    "descricao": "Mecânicas"
  },
  {
    "codigo": "90213919",
    "descricao": "Outras"
  },
  {
    "codigo": "90213920",
    "descricao": "Lentes intraoculares"
  },
  {
    "codigo": "90213930",
    "descricao": "Próteses de artérias vasculares revestidas"
  },
  {
    "codigo": "90213940",
    "descricao": "Próteses mamárias não implantáveis"
  },
  {
    "codigo": "90213980",
    "descricao": "Outros"
  },
  {
    "codigo": "90213991",
    "descricao": "Partes de próteses modulares que substituem membros superiores ou inferiores"
  },
  {
    "codigo": "90213999",
    "descricao": "Outros"
  },
  {
    "codigo": "90214000",
    "descricao": "- Aparelhos para facilitar a audição dos surdos, exceto as partes e acessórios"
  },
  {
    "codigo": "90215000",
    "descricao": "- Marca-passos cardíacos (Estimuladores cardíacos*), exceto as partes e acessórios"
  },
  {
    "codigo": "90219011",
    "descricao": "Cardiodesfibriladores automáticos"
  },
  {
    "codigo": "90219012",
    "descricao": "Implantes expansíveis (<i>stents</i>), mesmo montados sobre cateter do tipo balão"
  },
  {
    "codigo": "90219013",
    "descricao": "Oclusores interauriculares constituídos por uma malha de fios de níquel e titânio preenchida com tecido de poliéster, mesmo apresentados com seu respectivo cateter"
  },
  {
    "codigo": "90219019",
    "descricao": "Outros"
  },
  {
    "codigo": "90219080",
    "descricao": "Outros"
  },
  {
    "codigo": "90219091",
    "descricao": "De marca-passos cardíacos"
  },
  {
    "codigo": "90219092",
    "descricao": "De aparelhos para facilitar a audição dos surdos"
  },
  {
    "codigo": "90219099",
    "descricao": "Outros"
  },
  {
    "codigo": "90221200",
    "descricao": "-- Aparelhos de tomografia computadorizada"
  },
  {
    "codigo": "90221311",
    "descricao": "De tomadas maxilares panorâmicas"
  },
  {
    "codigo": "90221319",
    "descricao": "Outros"
  },
  {
    "codigo": "90221390",
    "descricao": "Outros"
  },
  {
    "codigo": "90221411",
    "descricao": "Para mamografia"
  },
  {
    "codigo": "90221412",
    "descricao": "Para angiografia"
  },
  {
    "codigo": "90221413",
    "descricao": "Para densitometria óssea, computadorizados"
  },
  {
    "codigo": "90221419",
    "descricao": "Outros"
  },
  {
    "codigo": "90221490",
    "descricao": "Outros"
  },
  {
    "codigo": "90221910",
    "descricao": "Espectrômetros ou espectrógrafos de raios X"
  },
  {
    "codigo": "90221991",
    "descricao": "Do tipo utilizado para inspeção de bagagens, com túnel de altura inferior ou igual a 0,4 m, largura inferior ou igual a 0,6 m e comprimento inferior ou igual a 1,2 m"
  },
  {
    "codigo": "90221999",
    "descricao": "Outros"
  },
  {
    "codigo": "90222110",
    "descricao": "Aparelhos de radiocobalto (bombas de cobalto)"
  },
  {
    "codigo": "90222120",
    "descricao": "Outros, para gamaterapia"
  },
  {
    "codigo": "90222190",
    "descricao": "Outros"
  },
  {
    "codigo": "90222910",
    "descricao": "Para detecção do nível de enchimento ou tampas faltantes, em latas de bebidas, por meio de raios gama"
  },
  {
    "codigo": "90222990",
    "descricao": "Outros"
  },
  {
    "codigo": "90223000",
    "descricao": "- Tubos de raios X"
  },
  {
    "codigo": "90229010",
    "descricao": "Geradores de tensão"
  },
  {
    "codigo": "90229020",
    "descricao": "Telas radiológicas"
  },
  {
    "codigo": "90229080",
    "descricao": "Outros, excluindo as partes e acessórios"
  },
  {
    "codigo": "90229091",
    "descricao": "De aparelhos de raios X"
  },
  {
    "codigo": "90229099",
    "descricao": "Outros"
  },
  {
    "codigo": "90230000",
    "descricao": "Instrumentos, aparelhos e modelos, concebidos para demonstração (por exemplo, no ensino e nas exposições), não suscetíveis de outros usos."
  },
  {
    "codigo": "90241010",
    "descricao": "Para ensaios de tração ou compressão"
  },
  {
    "codigo": "90241020",
    "descricao": "Para ensaios de dureza"
  },
  {
    "codigo": "90241090",
    "descricao": "Outros"
  },
  {
    "codigo": "90248011",
    "descricao": "Automáticos, para fios"
  },
  {
    "codigo": "90248019",
    "descricao": "Outros"
  },
  {
    "codigo": "90248021",
    "descricao": "Máquinas para ensaios de pneumáticos"
  },
  {
    "codigo": "90248029",
    "descricao": "Outros"
  },
  {
    "codigo": "90248090",
    "descricao": "Outros"
  },
  {
    "codigo": "90249000",
    "descricao": "- Partes e acessórios"
  },
  {
    "codigo": "90251111",
    "descricao": "Que contenham mercúrio"
  },
  {
    "codigo": "90251119",
    "descricao": "Outros"
  },
  {
    "codigo": "90251191",
    "descricao": "Que contenham mercúrio"
  },
  {
    "codigo": "90251199",
    "descricao": "Outros"
  },
  {
    "codigo": "90251910",
    "descricao": "Pirômetros ópticos"
  },
  {
    "codigo": "90251990",
    "descricao": "Outros"
  },
  {
    "codigo": "90258000",
    "descricao": "- Outros instrumentos"
  },
  {
    "codigo": "90259010",
    "descricao": "De termômetros"
  },
  {
    "codigo": "90259090",
    "descricao": "Outros"
  },
  {
    "codigo": "90261011",
    "descricao": "Medidores-transmissores eletrônicos, que funcionem pelo princípio de indução eletromagnética"
  },
  {
    "codigo": "90261019",
    "descricao": "Outros"
  },
  {
    "codigo": "90261021",
    "descricao": "De metais, mediante correntes parasitas"
  },
  {
    "codigo": "90261029",
    "descricao": "Outros"
  },
  {
    "codigo": "90262010",
    "descricao": "Manômetros"
  },
  {
    "codigo": "90262090",
    "descricao": "Outros"
  },
  {
    "codigo": "90268000",
    "descricao": "- Outros instrumentos e aparelhos"
  },
  {
    "codigo": "90269010",
    "descricao": "De instrumentos e aparelhos para medida ou controle do nível"
  },
  {
    "codigo": "90269020",
    "descricao": "De manômetros"
  },
  {
    "codigo": "90269090",
    "descricao": "Outros"
  },
  {
    "codigo": "90271000",
    "descricao": "- Analisadores de gás ou de fumaça (fumos)"
  },
  {
    "codigo": "90272011",
    "descricao": "De fase gasosa"
  },
  {
    "codigo": "90272012",
    "descricao": "De fase líquida"
  },
  {
    "codigo": "90272019",
    "descricao": "Outros"
  },
  {
    "codigo": "90272021",
    "descricao": "Sequenciadores automáticos de ADN mediante eletroforese capilar"
  },
  {
    "codigo": "90272029",
    "descricao": "Outros"
  },
  {
    "codigo": "90273011",
    "descricao": "De emissão atômica"
  },
  {
    "codigo": "90273019",
    "descricao": "Outros"
  },
  {
    "codigo": "90273020",
    "descricao": "Espectrofotômetros"
  },
  {
    "codigo": "90275010",
    "descricao": "Colorímetros"
  },
  {
    "codigo": "90275020",
    "descricao": "Fotômetros"
  },
  {
    "codigo": "90275030",
    "descricao": "Refratômetros"
  },
  {
    "codigo": "90275040",
    "descricao": "Sacarímetros"
  },
  {
    "codigo": "90275050",
    "descricao": "Citômetro de fluxo"
  },
  {
    "codigo": "90275090",
    "descricao": "Outros"
  },
  {
    "codigo": "90278100",
    "descricao": "-- Espectrômetros de massa"
  },
  {
    "codigo": "90278911",
    "descricao": "Calorímetros"
  },
  {
    "codigo": "90278912",
    "descricao": "Viscosímetros"
  },
  {
    "codigo": "90278913",
    "descricao": "Densitômetros"
  },
  {
    "codigo": "90278914",
    "descricao": "Aparelhos medidores de pH"
  },
  {
    "codigo": "90278920",
    "descricao": "Polarógrafos"
  },
  {
    "codigo": "90278991",
    "descricao": "Exposímetros"
  },
  {
    "codigo": "90278999",
    "descricao": "Outros"
  },
  {
    "codigo": "90279010",
    "descricao": "Micrótomos"
  },
  {
    "codigo": "90279091",
    "descricao": "De espectrômetros e espectrógrafos, de emissão atômica"
  },
  {
    "codigo": "90279093",
    "descricao": "De polarógrafos"
  },
  {
    "codigo": "90279099",
    "descricao": "Outros"
  },
  {
    "codigo": "90281011",
    "descricao": "Do tipo utilizado em postos (estações) de serviço ou garagens"
  },
  {
    "codigo": "90281019",
    "descricao": "Outros"
  },
  {
    "codigo": "90281090",
    "descricao": "Outros"
  },
  {
    "codigo": "90282010",
    "descricao": "De peso inferior ou igual a 50 kg"
  },
  {
    "codigo": "90282020",
    "descricao": "De peso superior a 50 kg"
  },
  {
    "codigo": "90283011",
    "descricao": "Digitais"
  },
  {
    "codigo": "90283019",
    "descricao": "Outros"
  },
  {
    "codigo": "90283021",
    "descricao": "Digitais"
  },
  {
    "codigo": "90283029",
    "descricao": "Outros"
  },
  {
    "codigo": "90283031",
    "descricao": "Digitais"
  },
  {
    "codigo": "90283039",
    "descricao": "Outros"
  },
  {
    "codigo": "90283090",
    "descricao": "Outros"
  },
  {
    "codigo": "90289010",
    "descricao": "De contadores de eletricidade"
  },
  {
    "codigo": "90289090",
    "descricao": "Outros"
  },
  {
    "codigo": "90291010",
    "descricao": "Contadores de voltas, contadores de produção ou de horas de trabalho"
  },
  {
    "codigo": "90291090",
    "descricao": "Outros"
  },
  {
    "codigo": "90292010",
    "descricao": "Indicadores de velocidade e tacômetros"
  },
  {
    "codigo": "90292020",
    "descricao": "Estroboscópios"
  },
  {
    "codigo": "90299010",
    "descricao": "De indicadores de velocidade e tacômetros"
  },
  {
    "codigo": "90299090",
    "descricao": "Outros"
  },
  {
    "codigo": "90301010",
    "descricao": "Medidores de radioatividade"
  },
  {
    "codigo": "90301090",
    "descricao": "Outros"
  },
  {
    "codigo": "90302010",
    "descricao": "Osciloscópios digitais"
  },
  {
    "codigo": "90302021",
    "descricao": "De frequência igual ou superior a 60 MHz"
  },
  {
    "codigo": "90302022",
    "descricao": "Vetorscópios"
  },
  {
    "codigo": "90302029",
    "descricao": "Outros"
  },
  {
    "codigo": "90302030",
    "descricao": "Oscilógrafos"
  },
  {
    "codigo": "90303100",
    "descricao": "-- Multímetros, sem dispositivo registrador"
  },
  {
    "codigo": "90303200",
    "descricao": "-- Multímetros, com dispositivo registrador"
  },
  {
    "codigo": "90303311",
    "descricao": "Digitais"
  },
  {
    "codigo": "90303319",
    "descricao": "Outros"
  },
  {
    "codigo": "90303321",
    "descricao": "Do tipo utilizado em veículos automóveis"
  },
  {
    "codigo": "90303329",
    "descricao": "Outros"
  },
  {
    "codigo": "90303390",
    "descricao": "Outros"
  },
  {
    "codigo": "90303910",
    "descricao": "De teste de continuidade em circuitos impressos"
  },
  {
    "codigo": "90303990",
    "descricao": "Outros"
  },
  {
    "codigo": "90304010",
    "descricao": "Analisadores de protocolo"
  },
  {
    "codigo": "90304020",
    "descricao": "Analisadores de nível seletivo"
  },
  {
    "codigo": "90304030",
    "descricao": "Analisadores digitais de transmissão"
  },
  {
    "codigo": "90304090",
    "descricao": "Outros"
  },
  {
    "codigo": "90308210",
    "descricao": "De testes de circuitos integrados"
  },
  {
    "codigo": "90308290",
    "descricao": "Outros"
  },
  {
    "codigo": "90308410",
    "descricao": "De teste automático de circuito impresso montado (ATE)"
  },
  {
    "codigo": "90308420",
    "descricao": "De medidas de parâmetros característicos de sinais de televisão ou de vídeo"
  },
  {
    "codigo": "90308490",
    "descricao": "Outros"
  },
  {
    "codigo": "90308910",
    "descricao": "Analisadores lógicos de circuitos digitais"
  },
  {
    "codigo": "90308920",
    "descricao": "Analisadores de espectro de frequência"
  },
  {
    "codigo": "90308930",
    "descricao": "Frequencímetros"
  },
  {
    "codigo": "90308940",
    "descricao": "Fasímetros"
  },
  {
    "codigo": "90308990",
    "descricao": "Outros"
  },
  {
    "codigo": "90309010",
    "descricao": "De instrumentos e aparelhos da subposição 9030.10"
  },
  {
    "codigo": "90309090",
    "descricao": "Outros"
  },
  {
    "codigo": "90311000",
    "descricao": "- Máquinas de balancear (equilibrar) peças mecânicas"
  },
  {
    "codigo": "90312010",
    "descricao": "Para motores"
  },
  {
    "codigo": "90312090",
    "descricao": "Outros"
  },
  {
    "codigo": "90314100",
    "descricao": "-- Para controle de <i>wafers</i> ou de dispositivos, semicondutores (incluindo os circuitos integrados), ou para controle de fotomáscaras ou retículos utilizados na fabricação de dispositivos semicondutores (incluindo os circuitos integrados)"
  },
  {
    "codigo": "90314910",
    "descricao": "Para medida de parâmetros dimensionais de fibras de celulose, por meio de raios laser"
  },
  {
    "codigo": "90314920",
    "descricao": "Para medida da espessura de pneumáticos de veículos automóveis, por meio de raios laser"
  },
  {
    "codigo": "90314990",
    "descricao": "Outros"
  },
  {
    "codigo": "90318011",
    "descricao": "Dinamômetros"
  },
  {
    "codigo": "90318012",
    "descricao": "Rugosímetros"
  },
  {
    "codigo": "90318020",
    "descricao": "Máquinas para medição tridimensional"
  },
  {
    "codigo": "90318030",
    "descricao": "Metros padrões"
  },
  {
    "codigo": "90318040",
    "descricao": "Aparelhos digitais, de uso em veículos automóveis, para medida e indicação de múltiplas grandezas tais como: velocidade média, consumos instantâneo e médio e autonomia (computador de bordo)"
  },
  {
    "codigo": "90318050",
    "descricao": "Aparelhos para análise de têxteis, computadorizados"
  },
  {
    "codigo": "90318060",
    "descricao": "Células de carga"
  },
  {
    "codigo": "90318091",
    "descricao": "Para controle dimensional de pneumáticos, em condições de carga"
  },
  {
    "codigo": "90318099",
    "descricao": "Outros"
  },
  {
    "codigo": "90319010",
    "descricao": "De bancos de ensaio"
  },
  {
    "codigo": "90319090",
    "descricao": "Outros"
  },
  {
    "codigo": "90321010",
    "descricao": "De expansão de fluidos"
  },
  {
    "codigo": "90321090",
    "descricao": "Outros"
  },
  {
    "codigo": "90322000",
    "descricao": "- Manostatos (pressostatos)"
  },
  {
    "codigo": "90328100",
    "descricao": "-- Hidráulicos ou pneumáticos"
  },
  {
    "codigo": "90328911",
    "descricao": "Eletrônicos"
  },
  {
    "codigo": "90328919",
    "descricao": "Outros"
  },
  {
    "codigo": "90328921",
    "descricao": "De sistemas antibloqueantes de freio (travão) (ABS)"
  },
  {
    "codigo": "90328922",
    "descricao": "De sistemas de suspensão"
  },
  {
    "codigo": "90328923",
    "descricao": "De sistemas de transmissão"
  },
  {
    "codigo": "90328924",
    "descricao": "De sistemas de ignição"
  },
  {
    "codigo": "90328925",
    "descricao": "De sistemas de injeção"
  },
  {
    "codigo": "90328929",
    "descricao": "Outros"
  },
  {
    "codigo": "90328930",
    "descricao": "Equipamentos digitais para controle de veículos ferroviários"
  },
  {
    "codigo": "90328981",
    "descricao": "De pressão"
  },
  {
    "codigo": "90328982",
    "descricao": "De temperatura"
  },
  {
    "codigo": "90328983",
    "descricao": "De umidade"
  },
  {
    "codigo": "90328984",
    "descricao": "De velocidade de motores elétricos por variação de frequência"
  },
  {
    "codigo": "90328989",
    "descricao": "Outros"
  },
  {
    "codigo": "90328990",
    "descricao": "Outros"
  },
  {
    "codigo": "90329010",
    "descricao": "Circuitos impressos com componentes elétricos ou eletrônicos, montados"
  },
  {
    "codigo": "90329091",
    "descricao": "De termostatos"
  },
  {
    "codigo": "90329099",
    "descricao": "Outros"
  },
  {
    "codigo": "90330000",
    "descricao": "Partes e acessórios não especificados nem compreendidos noutras posições do presente Capítulo, para máquinas, aparelhos, instrumentos ou artigos do Capítulo 90."
  },
  {
    "codigo": "91011100",
    "descricao": "-- De mostrador exclusivamente mecânico"
  },
  {
    "codigo": "91011900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "91012100",
    "descricao": "-- De corda automática"
  },
  {
    "codigo": "91012900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "91019100",
    "descricao": "-- Funcionando eletricamente"
  },
  {
    "codigo": "91019900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "91021110",
    "descricao": "Com caixa de metal comum"
  },
  {
    "codigo": "91021190",
    "descricao": "Outros"
  },
  {
    "codigo": "91021210",
    "descricao": "Com caixa de metal comum"
  },
  {
    "codigo": "91021220",
    "descricao": "Com caixa de plástico, exceto as reforçadas com fibra de vidro"
  },
  {
    "codigo": "91021290",
    "descricao": "Outros"
  },
  {
    "codigo": "91021900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "91022100",
    "descricao": "-- De corda automática"
  },
  {
    "codigo": "91022900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "91029100",
    "descricao": "-- Funcionando eletricamente"
  },
  {
    "codigo": "91029900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "91031000",
    "descricao": "- Funcionando eletricamente"
  },
  {
    "codigo": "91039000",
    "descricao": "- Outros"
  },
  {
    "codigo": "91040000",
    "descricao": "Relógios para painéis de instrumentos e relógios semelhantes, para automóveis, veículos aéreos, embarcações ou para outros veículos."
  },
  {
    "codigo": "91051100",
    "descricao": "-- Funcionando eletricamente"
  },
  {
    "codigo": "91051900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "91052100",
    "descricao": "-- Funcionando eletricamente"
  },
  {
    "codigo": "91052900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "91059100",
    "descricao": "-- Funcionando eletricamente"
  },
  {
    "codigo": "91059900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "91061000",
    "descricao": "- Relógios de ponto; relógios datadores e contadores de horas"
  },
  {
    "codigo": "91069000",
    "descricao": "- Outros"
  },
  {
    "codigo": "91070010",
    "descricao": "Interruptores horários"
  },
  {
    "codigo": "91070090",
    "descricao": "Outros"
  },
  {
    "codigo": "91081110",
    "descricao": "Para relógios das posições 91.01 ou 91.02"
  },
  {
    "codigo": "91081190",
    "descricao": "Outros"
  },
  {
    "codigo": "91081200",
    "descricao": "-- De mostrador exclusivamente optoeletrônico"
  },
  {
    "codigo": "91081900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "91082000",
    "descricao": "- De corda automática"
  },
  {
    "codigo": "91089000",
    "descricao": "- Outros"
  },
  {
    "codigo": "91091000",
    "descricao": "- Funcionando eletricamente"
  },
  {
    "codigo": "91099000",
    "descricao": "- Outros"
  },
  {
    "codigo": "91101110",
    "descricao": "Para relógios das posições 91.01 ou 91.02"
  },
  {
    "codigo": "91101190",
    "descricao": "Outros"
  },
  {
    "codigo": "91101200",
    "descricao": "-- Mecanismos incompletos, montados"
  },
  {
    "codigo": "91101900",
    "descricao": "-- Esboços"
  },
  {
    "codigo": "91109000",
    "descricao": "- Outros"
  },
  {
    "codigo": "91111000",
    "descricao": "- Caixas de metais preciosos ou de metais folheados ou chapeados de metais preciosos (plaquê)"
  },
  {
    "codigo": "91112010",
    "descricao": "De latão, em esboço"
  },
  {
    "codigo": "91112090",
    "descricao": "Outras"
  },
  {
    "codigo": "91118000",
    "descricao": "- Outras caixas"
  },
  {
    "codigo": "91119010",
    "descricao": "Fundos de metais comuns"
  },
  {
    "codigo": "91119090",
    "descricao": "Outras"
  },
  {
    "codigo": "91122000",
    "descricao": "- Caixas e semelhantes"
  },
  {
    "codigo": "91129000",
    "descricao": "- Partes"
  },
  {
    "codigo": "91131000",
    "descricao": "- De metais preciosos ou de metais folheados ou chapeados de metais preciosos (plaquê)"
  },
  {
    "codigo": "91132000",
    "descricao": "- De metais comuns, mesmo dourados ou prateados"
  },
  {
    "codigo": "91139000",
    "descricao": "- Outras"
  },
  {
    "codigo": "91143000",
    "descricao": "- Quadrantes"
  },
  {
    "codigo": "91144000",
    "descricao": "- Platinas e pontes"
  },
  {
    "codigo": "91149000",
    "descricao": "- Outras"
  },
  {
    "codigo": "92011000",
    "descricao": "- Pianos verticais"
  },
  {
    "codigo": "92012000",
    "descricao": "- Pianos de cauda"
  },
  {
    "codigo": "92019000",
    "descricao": "- Outros"
  },
  {
    "codigo": "92021000",
    "descricao": "- De cordas, tocados com o auxílio de um arco"
  },
  {
    "codigo": "92029000",
    "descricao": "- Outros"
  },
  {
    "codigo": "92051000",
    "descricao": "- Instrumentos denominados \"metais\""
  },
  {
    "codigo": "92059000",
    "descricao": "- Outros"
  },
  {
    "codigo": "92060000",
    "descricao": "Instrumentos musicais de percussão (por exemplo, tambores, caixas, xilofones, pratos, castanholas, maracás)."
  },
  {
    "codigo": "92071010",
    "descricao": "Sintetizadores"
  },
  {
    "codigo": "92071090",
    "descricao": "Outros"
  },
  {
    "codigo": "92079010",
    "descricao": "Guitarras e contrabaixos"
  },
  {
    "codigo": "92079090",
    "descricao": "Outros"
  },
  {
    "codigo": "92081000",
    "descricao": "- Caixas de música"
  },
  {
    "codigo": "92089000",
    "descricao": "- Outros"
  },
  {
    "codigo": "92093000",
    "descricao": "- Cordas para instrumentos musicais"
  },
  {
    "codigo": "92099100",
    "descricao": "-- Partes e acessórios de pianos"
  },
  {
    "codigo": "92099200",
    "descricao": "-- Partes e acessórios de instrumentos musicais da posição 92.02"
  },
  {
    "codigo": "92099400",
    "descricao": "-- Partes e acessórios de instrumentos musicais da posição 92.07"
  },
  {
    "codigo": "92099900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "93011000",
    "descricao": "- Peças de artilharia (por exemplo, canhões, obuses e morteiros)"
  },
  {
    "codigo": "93012000",
    "descricao": "- Lança-mísseis; lança-chamas; lança-granadas; lança-torpedos e lançadores semelhantes"
  },
  {
    "codigo": "93019000",
    "descricao": "- Outras"
  },
  {
    "codigo": "93020000",
    "descricao": "Revólveres e pistolas, exceto os das posições 93.03 ou 93.04."
  },
  {
    "codigo": "93031000",
    "descricao": "- Armas de fogo carregáveis exclusivamente pela boca"
  },
  {
    "codigo": "93032000",
    "descricao": "- Outras espingardas e carabinas de caça ou de tiro ao alvo, com pelo menos um cano liso"
  },
  {
    "codigo": "93033000",
    "descricao": "- Outras espingardas e carabinas de caça ou de tiro ao alvo"
  },
  {
    "codigo": "93039010",
    "descricao": "Lançadores do tipo utilizado com cartuchos dos itens 9306.21.10, 9306.21.20 ou 9306.21.30"
  },
  {
    "codigo": "93039090",
    "descricao": "Outros"
  },
  {
    "codigo": "93040010",
    "descricao": "Recipientes do tipo aerossol que contenham produtos químicos ou oleorresina de <i>Capsicum</i>, com fins irritantes"
  },
  {
    "codigo": "93040090",
    "descricao": "Outras"
  },
  {
    "codigo": "93051000",
    "descricao": "- De revólveres ou pistolas"
  },
  {
    "codigo": "93052000",
    "descricao": "- De espingardas ou carabinas da posição 93.03"
  },
  {
    "codigo": "93059100",
    "descricao": "-- De armas de guerra da posição 93.01"
  },
  {
    "codigo": "93059900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "93062110",
    "descricao": "Que contenham produtos químicos ou oleorresina de <i>Capsicum</i>, com fins irritantes"
  },
  {
    "codigo": "93062120",
    "descricao": "Outros, que produzem efeitos fumígenos, de iluminação, de som ou de identificação mediante tintas ou corantes"
  },
  {
    "codigo": "93062130",
    "descricao": "Outros, com um ou mais projéteis de elastômeros"
  },
  {
    "codigo": "93062190",
    "descricao": "Outros"
  },
  {
    "codigo": "93062900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "93063000",
    "descricao": "- Outros cartuchos e suas partes"
  },
  {
    "codigo": "93069010",
    "descricao": "Granadas que contenham produtos químicos ou oleorresina de <i>Capsicum</i>, com fins irritantes"
  },
  {
    "codigo": "93069020",
    "descricao": "Outras granadas, que produzem efeitos fumígenos, de iluminação, de som ou de identificação mediante tintas ou corantes"
  },
  {
    "codigo": "93069090",
    "descricao": "Outros"
  },
  {
    "codigo": "93070000",
    "descricao": "Sabres, espadas, baionetas, lanças e outras armas brancas, suas partes e bainhas."
  },
  {
    "codigo": "94011010",
    "descricao": "Ejetáveis"
  },
  {
    "codigo": "94011090",
    "descricao": "Outros"
  },
  {
    "codigo": "94012000",
    "descricao": "- Assentos do tipo utilizado em veículos automóveis"
  },
  {
    "codigo": "94013100",
    "descricao": "-- De madeira"
  },
  {
    "codigo": "94013900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "94014100",
    "descricao": "-- De madeira"
  },
  {
    "codigo": "94014900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "94015200",
    "descricao": "-- De bambu"
  },
  {
    "codigo": "94015300",
    "descricao": "-- De rotim"
  },
  {
    "codigo": "94015900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "94016100",
    "descricao": "-- Estofados"
  },
  {
    "codigo": "94016900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "94017100",
    "descricao": "-- Estofados"
  },
  {
    "codigo": "94017900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "94018000",
    "descricao": "- Outros assentos"
  },
  {
    "codigo": "94019100",
    "descricao": "-- De madeira"
  },
  {
    "codigo": "94019900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "94021000",
    "descricao": "- Cadeiras odontológicas, cadeiras para salões de cabeleireiro e cadeiras semelhantes, e suas partes"
  },
  {
    "codigo": "94029010",
    "descricao": "Mesas de operação"
  },
  {
    "codigo": "94029020",
    "descricao": "Camas dotadas de mecanismos para usos clínicos"
  },
  {
    "codigo": "94029090",
    "descricao": "Outros"
  },
  {
    "codigo": "94031000",
    "descricao": "- Móveis de metal, do tipo utilizado em escritórios"
  },
  {
    "codigo": "94032010",
    "descricao": "Do tipo utilizado em cozinhas"
  },
  {
    "codigo": "94032090",
    "descricao": "Outros"
  },
  {
    "codigo": "94033000",
    "descricao": "- Móveis de madeira, do tipo utilizado em escritórios"
  },
  {
    "codigo": "94034000",
    "descricao": "- Móveis de madeira, do tipo utilizado em cozinhas"
  },
  {
    "codigo": "94035000",
    "descricao": "- Móveis de madeira, do tipo utilizado em quartos de dormir"
  },
  {
    "codigo": "94036000",
    "descricao": "- Outros móveis de madeira"
  },
  {
    "codigo": "94037000",
    "descricao": "- Móveis de plástico"
  },
  {
    "codigo": "94038200",
    "descricao": "-- De bambu"
  },
  {
    "codigo": "94038300",
    "descricao": "-- De rotim"
  },
  {
    "codigo": "94038900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "94039100",
    "descricao": "-- De madeira"
  },
  {
    "codigo": "94039900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "94041000",
    "descricao": "- Suportes para camas (somiês)"
  },
  {
    "codigo": "94042100",
    "descricao": "-- De borracha alveolar ou de plástico alveolar, mesmo recobertos"
  },
  {
    "codigo": "94042900",
    "descricao": "-- De outras matérias"
  },
  {
    "codigo": "94043000",
    "descricao": "- Sacos de dormir"
  },
  {
    "codigo": "94044000",
    "descricao": "- Colchas, edredões e artigos semelhantes"
  },
  {
    "codigo": "94049000",
    "descricao": "- Outros"
  },
  {
    "codigo": "94051110",
    "descricao": "Focos cirúrgicos (luzes sem sombra, do tipo utilizado em medicina, cirurgia ou odontologia)"
  },
  {
    "codigo": "94051190",
    "descricao": "Outros"
  },
  {
    "codigo": "94051910",
    "descricao": "Focos cirúrgicos (luzes sem sombra, do tipo utilizado em medicina, cirurgia ou odontologia)"
  },
  {
    "codigo": "94051990",
    "descricao": "Outros"
  },
  {
    "codigo": "94052100",
    "descricao": "-- Concebidos para serem utilizados unicamente com fontes de luz de diodos emissores de luz (LED)"
  },
  {
    "codigo": "94052900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "94053100",
    "descricao": "-- Concebidas para serem utilizadas unicamente com fontes de luz de diodos emissores de luz (LED)"
  },
  {
    "codigo": "94053900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "94054100",
    "descricao": "-- Fotovoltaicos, concebidos para serem utilizados unicamente com fontes de luz de diodos emissores de luz (LED)"
  },
  {
    "codigo": "94054200",
    "descricao": "-- Outros, concebidos para serem utilizados unicamente com fontes de luz de diodos emissores de luz (LED)"
  },
  {
    "codigo": "94054900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "94055000",
    "descricao": "- Luminárias e aparelhos de iluminação, não elétricos"
  },
  {
    "codigo": "94056100",
    "descricao": "-- Concebidos para serem utilizados unicamente com fontes de luz de diodos emissores de luz (LED)"
  },
  {
    "codigo": "94056900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "94059100",
    "descricao": "-- De vidro"
  },
  {
    "codigo": "94059200",
    "descricao": "-- De plástico"
  },
  {
    "codigo": "94059900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "94061010",
    "descricao": "Estufas"
  },
  {
    "codigo": "94061090",
    "descricao": "Outras"
  },
  {
    "codigo": "94062000",
    "descricao": "- Unidades de construção modulares, de aço"
  },
  {
    "codigo": "94069010",
    "descricao": "Estufas"
  },
  {
    "codigo": "94069020",
    "descricao": "Com estrutura de ferro ou aço e paredes exteriores constituídas principalmente dessas matérias"
  },
  {
    "codigo": "94069090",
    "descricao": "Outras"
  },
  {
    "codigo": "95030010",
    "descricao": "Triciclos, patinetes, carros de pedais e outros brinquedos semelhantes com rodas; carrinhos para bonecos"
  },
  {
    "codigo": "95030021",
    "descricao": "Bonecos, mesmo vestidos, com mecanismo a corda ou elétrico"
  },
  {
    "codigo": "95030022",
    "descricao": "Outros bonecos, mesmo vestidos"
  },
  {
    "codigo": "95030029",
    "descricao": "Partes e acessórios"
  },
  {
    "codigo": "95030031",
    "descricao": "Com enchimento"
  },
  {
    "codigo": "95030039",
    "descricao": "Outros"
  },
  {
    "codigo": "95030040",
    "descricao": "Trens elétricos, incluindo os trilhos, sinais e outros acessórios"
  },
  {
    "codigo": "95030050",
    "descricao": "Modelos reduzidos, mesmo animados, em conjuntos para montagem, exceto os do item 9503.00.40"
  },
  {
    "codigo": "95030060",
    "descricao": "Outros conjuntos e brinquedos, para construção"
  },
  {
    "codigo": "95030070",
    "descricao": "Quebra-cabeças (<i>puzzles</i>)"
  },
  {
    "codigo": "95030080",
    "descricao": "Outros brinquedos, apresentados em sortidos ou em panóplias"
  },
  {
    "codigo": "95030091",
    "descricao": "Instrumentos e aparelhos musicais, de brinquedo"
  },
  {
    "codigo": "95030097",
    "descricao": "Outros brinquedos, com motor elétrico"
  },
  {
    "codigo": "95030098",
    "descricao": "Outros brinquedos, com motor não elétrico"
  },
  {
    "codigo": "95030099",
    "descricao": "Outros"
  },
  {
    "codigo": "95042000",
    "descricao": "- Bilhares de qualquer espécie e seus acessórios"
  },
  {
    "codigo": "95043000",
    "descricao": "- Outros jogos que funcionem por introdução de moedas, notas (papéis-moeda), cartões de banco, fichas ou por outros meios de pagamento, exceto os jogos de balizas (pinos) automáticos (boliche)"
  },
  {
    "codigo": "95044000",
    "descricao": "- Cartas de jogar"
  },
  {
    "codigo": "95045000",
    "descricao": "- Consoles e máquinas de jogos de vídeo, exceto os classificados na subposição 9504.30"
  },
  {
    "codigo": "95049010",
    "descricao": "Jogos de balizas (pinos) automáticos (boliche)"
  },
  {
    "codigo": "95049090",
    "descricao": "Outros"
  },
  {
    "codigo": "95051000",
    "descricao": "- Artigos para festas de Natal"
  },
  {
    "codigo": "95059000",
    "descricao": "- Outros"
  },
  {
    "codigo": "95061100",
    "descricao": "-- Esquis"
  },
  {
    "codigo": "95061200",
    "descricao": "-- Fixadores para esquis"
  },
  {
    "codigo": "95061900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "95062100",
    "descricao": "-- Pranchas à vela"
  },
  {
    "codigo": "95062900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "95063100",
    "descricao": "-- Tacos completos"
  },
  {
    "codigo": "95063200",
    "descricao": "-- Bolas"
  },
  {
    "codigo": "95063900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "95064000",
    "descricao": "- Artigos e equipamentos para tênis de mesa"
  },
  {
    "codigo": "95065100",
    "descricao": "-- Raquetes de tênis, mesmo não encordoadas"
  },
  {
    "codigo": "95065900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "95066100",
    "descricao": "-- Bolas de tênis"
  },
  {
    "codigo": "95066200",
    "descricao": "-- Infláveis"
  },
  {
    "codigo": "95066900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "95067000",
    "descricao": "- Patins para gelo e patins de rodas, incluindo os fixados em calçado"
  },
  {
    "codigo": "95069100",
    "descricao": "-- Artigos e equipamentos para cultura física, ginástica ou atletismo"
  },
  {
    "codigo": "95069900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "95071000",
    "descricao": "- Varas (Canas*) de pesca"
  },
  {
    "codigo": "95072000",
    "descricao": "- Anzóis, mesmo montados em sedelas"
  },
  {
    "codigo": "95073000",
    "descricao": "- Carretilhas e molinetes (Carretes*), de pesca"
  },
  {
    "codigo": "95079000",
    "descricao": "- Outros"
  },
  {
    "codigo": "95081000",
    "descricao": "- Circos ambulantes e coleções de animais ambulantes"
  },
  {
    "codigo": "95082110",
    "descricao": "Com percurso igual ou superior a 300 m"
  },
  {
    "codigo": "95082120",
    "descricao": "Vagonetes com capacidade igual ou superior a 6 pessoas"
  },
  {
    "codigo": "95082190",
    "descricao": "Outras"
  },
  {
    "codigo": "95082210",
    "descricao": "Carrosséis, mesmo dotados de dispositivo de elevação, de diâmetro inferior a 16 m"
  },
  {
    "codigo": "95082290",
    "descricao": "Outros"
  },
  {
    "codigo": "95082300",
    "descricao": "-- Carrinhos de choque"
  },
  {
    "codigo": "95082400",
    "descricao": "-- Simuladores de movimentos e cinemas dinâmicos"
  },
  {
    "codigo": "95082500",
    "descricao": "-- Percursos aquáticos"
  },
  {
    "codigo": "95082600",
    "descricao": "-- Equipamentos para parques aquáticos"
  },
  {
    "codigo": "95082900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "95083000",
    "descricao": "- Atrações de parques e feiras"
  },
  {
    "codigo": "95084000",
    "descricao": "- Teatros ambulantes"
  },
  {
    "codigo": "96011000",
    "descricao": "- Marfim trabalhado e obras de marfim"
  },
  {
    "codigo": "96019000",
    "descricao": "- Outros"
  },
  {
    "codigo": "96020010",
    "descricao": "Cápsulas de gelatinas digeríveis"
  },
  {
    "codigo": "96020020",
    "descricao": "Colmeias artificiais"
  },
  {
    "codigo": "96020090",
    "descricao": "Outras"
  },
  {
    "codigo": "96031000",
    "descricao": "- Vassouras e escovas constituídas por pequenos ramos ou outras matérias vegetais reunidas em feixes, mesmo com cabo"
  },
  {
    "codigo": "96032100",
    "descricao": "-- Escovas de dentes, incluindo as escovas para dentaduras"
  },
  {
    "codigo": "96032900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "96033000",
    "descricao": "- Pincéis e escovas, para artistas, pincéis de escrever e pincéis semelhantes para aplicação de produtos cosméticos"
  },
  {
    "codigo": "96034010",
    "descricao": "Rolos"
  },
  {
    "codigo": "96034090",
    "descricao": "Outros"
  },
  {
    "codigo": "96035000",
    "descricao": "- Outras escovas que constituam partes de máquinas, de aparelhos ou de veículos"
  },
  {
    "codigo": "96039000",
    "descricao": "- Outros"
  },
  {
    "codigo": "96040000",
    "descricao": "Peneiras e crivos, manuais."
  },
  {
    "codigo": "96050000",
    "descricao": "Conjuntos de viagem para toucador de pessoas, para costura ou para limpeza de calçado ou de roupa."
  },
  {
    "codigo": "96061000",
    "descricao": "- Botões de pressão e suas partes"
  },
  {
    "codigo": "96062100",
    "descricao": "-- De plástico, não recobertos de matérias têxteis"
  },
  {
    "codigo": "96062200",
    "descricao": "-- De metais comuns, não recobertos de matérias têxteis"
  },
  {
    "codigo": "96062900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "96063000",
    "descricao": "- Formas e outras partes, de botões; esboços de botões"
  },
  {
    "codigo": "96071100",
    "descricao": "-- Com grampos de metal comum"
  },
  {
    "codigo": "96071900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "96072000",
    "descricao": "- Partes"
  },
  {
    "codigo": "96081000",
    "descricao": "- Canetas esferográficas"
  },
  {
    "codigo": "96082000",
    "descricao": "- Canetas e marcadores, com ponta de feltro ou com outras pontas porosas"
  },
  {
    "codigo": "96083000",
    "descricao": "- Canetas-tinteiro (Canetas de tinta permanente*) e outras canetas"
  },
  {
    "codigo": "96084000",
    "descricao": "- Lapiseiras"
  },
  {
    "codigo": "96085000",
    "descricao": "- Sortidos de artigos de, pelo menos, duas das subposições precedentes"
  },
  {
    "codigo": "96086000",
    "descricao": "- Cargas com ponta, para canetas esferográficas"
  },
  {
    "codigo": "96089100",
    "descricao": "-- Penas (aparos) e suas pontas"
  },
  {
    "codigo": "96089981",
    "descricao": "Pontas porosas para os artigos da subposição 9608.20"
  },
  {
    "codigo": "96089989",
    "descricao": "Outras"
  },
  {
    "codigo": "96089990",
    "descricao": "Outros"
  },
  {
    "codigo": "96091000",
    "descricao": "- Lápis"
  },
  {
    "codigo": "96092000",
    "descricao": "- Minas para lápis ou para lapiseiras"
  },
  {
    "codigo": "96099000",
    "descricao": "- Outros"
  },
  {
    "codigo": "96100000",
    "descricao": "Lousas e quadros para escrever ou desenhar, mesmo emoldurados."
  },
  {
    "codigo": "96110000",
    "descricao": "Carimbos, incluindo os datadores e numeradores, sinetes e artigos semelhantes (incluindo os aparelhos para impressão de etiquetas), manuais; dispositivos manuais de composição tipográfica e jogos de impressão manuais que contenham tais dispositivos."
  },
  {
    "codigo": "96121000",
    "descricao": "- Fitas impressoras"
  },
  {
    "codigo": "96122000",
    "descricao": "- Almofadas de carimbo"
  },
  {
    "codigo": "96131000",
    "descricao": "- Isqueiros de bolso, a gás, não recarregáveis"
  },
  {
    "codigo": "96132000",
    "descricao": "- Isqueiros de bolso, a gás, recarregáveis"
  },
  {
    "codigo": "96138000",
    "descricao": "- Outros isqueiros e acendedores"
  },
  {
    "codigo": "96139000",
    "descricao": "- Partes"
  },
  {
    "codigo": "96140000",
    "descricao": "Cachimbos (incluindo os seus fornilhos), piteiras (boquilhas) para charutos ou cigarros, e suas partes."
  },
  {
    "codigo": "96151100",
    "descricao": "-- De borracha endurecida ou de plástico"
  },
  {
    "codigo": "96151900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "96159000",
    "descricao": "- Outros"
  },
  {
    "codigo": "96161000",
    "descricao": "- Vaporizadores de toucador, suas armações e cabeças de armações"
  },
  {
    "codigo": "96162000",
    "descricao": "- Borlas ou esponjas para pós ou para aplicação de outros cosméticos ou de produtos de toucador"
  },
  {
    "codigo": "96170010",
    "descricao": "Garrafas térmicas e outros recipientes isotérmicos"
  },
  {
    "codigo": "96170020",
    "descricao": "Partes"
  },
  {
    "codigo": "96180000",
    "descricao": "Manequins e artigos semelhantes; autômatos e cenas animadas, para vitrines e mostruários."
  },
  {
    "codigo": "96190000",
    "descricao": "Absorventes (Pensos*) e tampões higiênicos, cueiros, fraldas e artigos higiênicos semelhantes, de qualquer matéria."
  },
  {
    "codigo": "96200000",
    "descricao": "Monopés, bipés, tripés e artigos semelhantes."
  },
  {
    "codigo": "97012100",
    "descricao": "-- Quadros, pinturas e desenhos"
  },
  {
    "codigo": "97012200",
    "descricao": "-- Mosaicos"
  },
  {
    "codigo": "97012900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "97019100",
    "descricao": "-- Quadros, pinturas e desenhos"
  },
  {
    "codigo": "97019200",
    "descricao": "-- Mosaicos"
  },
  {
    "codigo": "97019900",
    "descricao": "-- Outros"
  },
  {
    "codigo": "97021000",
    "descricao": "- Com mais de 100 anos"
  },
  {
    "codigo": "97029000",
    "descricao": "- Outras"
  },
  {
    "codigo": "97031000",
    "descricao": "- Com mais de 100 anos"
  },
  {
    "codigo": "97039000",
    "descricao": "- Outras"
  },
  {
    "codigo": "97040000",
    "descricao": "Selos postais, selos fiscais, marcas postais, envelopes de primeiro dia (<i>first-day covers</i>), inteiros postais e semelhantes, obliterados, ou não obliterados, exceto os artigos da posição 49.07."
  },
  {
    "codigo": "97051000",
    "descricao": "- Coleções e peças de coleção que apresentem um interesse arqueológico, etnográfico ou histórico"
  },
  {
    "codigo": "97052100",
    "descricao": "-- Espécimes humanos e suas partes"
  },
  {
    "codigo": "97052200",
    "descricao": "-- Espécies extintas ou ameaçadas de extinção, e suas partes"
  },
  {
    "codigo": "97052900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "97053100",
    "descricao": "-- Com mais de 100 anos"
  },
  {
    "codigo": "97053900",
    "descricao": "-- Outras"
  },
  {
    "codigo": "97061000",
    "descricao": "- Com mais de 250 anos"
  },
  {
    "codigo": "97069000",
    "descricao": "- Outras"
  }
]
